webpackJsonp([0],[
/* 0 */
/***/ (function(module, exports) {

/* globals __VUE_SSR_CONTEXT__ */

// this module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle

module.exports = function normalizeComponent (
  rawScriptExports,
  compiledTemplate,
  injectStyles,
  scopeId,
  moduleIdentifier /* server only */
) {
  var esModule
  var scriptExports = rawScriptExports = rawScriptExports || {}

  // ES6 modules interop
  var type = typeof rawScriptExports.default
  if (type === 'object' || type === 'function') {
    esModule = rawScriptExports
    scriptExports = rawScriptExports.default
  }

  // Vue.extend constructor export interop
  var options = typeof scriptExports === 'function'
    ? scriptExports.options
    : scriptExports

  // render functions
  if (compiledTemplate) {
    options.render = compiledTemplate.render
    options.staticRenderFns = compiledTemplate.staticRenderFns
  }

  // scopedId
  if (scopeId) {
    options._scopeId = scopeId
  }

  var hook
  if (moduleIdentifier) { // server build
    hook = function (context) {
      // 2.3 injection
      context =
        context || // cached call
        (this.$vnode && this.$vnode.ssrContext) || // stateful
        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
      // 2.2 with runInNewContext: true
      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__
      }
      // inject component styles
      if (injectStyles) {
        injectStyles.call(this, context)
      }
      // register component module identifier for async chunk inferrence
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier)
      }
    }
    // used by ssr in case component is cached and beforeCreate
    // never gets called
    options._ssrRegister = hook
  } else if (injectStyles) {
    hook = injectStyles
  }

  if (hook) {
    var functional = options.functional
    var existing = functional
      ? options.render
      : options.beforeCreate
    if (!functional) {
      // inject component registration as beforeCreate hook
      options.beforeCreate = existing
        ? [].concat(existing, hook)
        : [hook]
    } else {
      // register for functioal component in vue file
      options.render = function renderWithStyleInjection (h, context) {
        hook.call(context)
        return existing(h, context)
      }
    }
  }

  return {
    esModule: esModule,
    exports: scriptExports,
    options: options
  }
}


/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var bind = __webpack_require__(8);

/*global toString:true*/

// utils is a library of generic helper functions non-specific to axios

var toString = Object.prototype.toString;

/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Array, otherwise false
 */
function isArray(val) {
  return toString.call(val) === '[object Array]';
}

/**
 * Determine if a value is undefined
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if the value is undefined, otherwise false
 */
function isUndefined(val) {
  return typeof val === 'undefined';
}

/**
 * Determine if a value is a Buffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Buffer, otherwise false
 */
function isBuffer(val) {
  return val !== null && !isUndefined(val) && val.constructor !== null && !isUndefined(val.constructor)
    && typeof val.constructor.isBuffer === 'function' && val.constructor.isBuffer(val);
}

/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */
function isArrayBuffer(val) {
  return toString.call(val) === '[object ArrayBuffer]';
}

/**
 * Determine if a value is a FormData
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an FormData, otherwise false
 */
function isFormData(val) {
  return (typeof FormData !== 'undefined') && (val instanceof FormData);
}

/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */
function isArrayBufferView(val) {
  var result;
  if ((typeof ArrayBuffer !== 'undefined') && (ArrayBuffer.isView)) {
    result = ArrayBuffer.isView(val);
  } else {
    result = (val) && (val.buffer) && (val.buffer instanceof ArrayBuffer);
  }
  return result;
}

/**
 * Determine if a value is a String
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a String, otherwise false
 */
function isString(val) {
  return typeof val === 'string';
}

/**
 * Determine if a value is a Number
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Number, otherwise false
 */
function isNumber(val) {
  return typeof val === 'number';
}

/**
 * Determine if a value is an Object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Object, otherwise false
 */
function isObject(val) {
  return val !== null && typeof val === 'object';
}

/**
 * Determine if a value is a Date
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Date, otherwise false
 */
function isDate(val) {
  return toString.call(val) === '[object Date]';
}

/**
 * Determine if a value is a File
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a File, otherwise false
 */
function isFile(val) {
  return toString.call(val) === '[object File]';
}

/**
 * Determine if a value is a Blob
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Blob, otherwise false
 */
function isBlob(val) {
  return toString.call(val) === '[object Blob]';
}

/**
 * Determine if a value is a Function
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */
function isFunction(val) {
  return toString.call(val) === '[object Function]';
}

/**
 * Determine if a value is a Stream
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Stream, otherwise false
 */
function isStream(val) {
  return isObject(val) && isFunction(val.pipe);
}

/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */
function isURLSearchParams(val) {
  return typeof URLSearchParams !== 'undefined' && val instanceof URLSearchParams;
}

/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 * @returns {String} The String freed of excess whitespace
 */
function trim(str) {
  return str.replace(/^\s*/, '').replace(/\s*$/, '');
}

/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 */
function isStandardBrowserEnv() {
  if (typeof navigator !== 'undefined' && (navigator.product === 'ReactNative' ||
                                           navigator.product === 'NativeScript' ||
                                           navigator.product === 'NS')) {
    return false;
  }
  return (
    typeof window !== 'undefined' &&
    typeof document !== 'undefined'
  );
}

/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 */
function forEach(obj, fn) {
  // Don't bother if no value provided
  if (obj === null || typeof obj === 'undefined') {
    return;
  }

  // Force an array if not already something iterable
  if (typeof obj !== 'object') {
    /*eslint no-param-reassign:0*/
    obj = [obj];
  }

  if (isArray(obj)) {
    // Iterate over array values
    for (var i = 0, l = obj.length; i < l; i++) {
      fn.call(null, obj[i], i, obj);
    }
  } else {
    // Iterate over object keys
    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        fn.call(null, obj[key], key, obj);
      }
    }
  }
}

/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */
function merge(/* obj1, obj2, obj3, ... */) {
  var result = {};
  function assignValue(val, key) {
    if (typeof result[key] === 'object' && typeof val === 'object') {
      result[key] = merge(result[key], val);
    } else {
      result[key] = val;
    }
  }

  for (var i = 0, l = arguments.length; i < l; i++) {
    forEach(arguments[i], assignValue);
  }
  return result;
}

/**
 * Function equal to merge with the difference being that no reference
 * to original objects is kept.
 *
 * @see merge
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */
function deepMerge(/* obj1, obj2, obj3, ... */) {
  var result = {};
  function assignValue(val, key) {
    if (typeof result[key] === 'object' && typeof val === 'object') {
      result[key] = deepMerge(result[key], val);
    } else if (typeof val === 'object') {
      result[key] = deepMerge({}, val);
    } else {
      result[key] = val;
    }
  }

  for (var i = 0, l = arguments.length; i < l; i++) {
    forEach(arguments[i], assignValue);
  }
  return result;
}

/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 * @return {Object} The resulting value of object a
 */
function extend(a, b, thisArg) {
  forEach(b, function assignValue(val, key) {
    if (thisArg && typeof val === 'function') {
      a[key] = bind(val, thisArg);
    } else {
      a[key] = val;
    }
  });
  return a;
}

module.exports = {
  isArray: isArray,
  isArrayBuffer: isArrayBuffer,
  isBuffer: isBuffer,
  isFormData: isFormData,
  isArrayBufferView: isArrayBufferView,
  isString: isString,
  isNumber: isNumber,
  isObject: isObject,
  isUndefined: isUndefined,
  isDate: isDate,
  isFile: isFile,
  isBlob: isBlob,
  isFunction: isFunction,
  isStream: isStream,
  isURLSearchParams: isURLSearchParams,
  isStandardBrowserEnv: isStandardBrowserEnv,
  forEach: forEach,
  merge: merge,
  deepMerge: deepMerge,
  extend: extend,
  trim: trim
};


/***/ }),
/* 2 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),
/* 3 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global, setImmediate) {/*!
 * Vue.js v2.6.12
 * (c) 2014-2020 Evan You
 * Released under the MIT License.
 */
/*  */

var emptyObject = Object.freeze({});

// These helpers produce better VM code in JS engines due to their
// explicitness and function inlining.
function isUndef (v) {
  return v === undefined || v === null
}

function isDef (v) {
  return v !== undefined && v !== null
}

function isTrue (v) {
  return v === true
}

function isFalse (v) {
  return v === false
}

/**
 * Check if value is primitive.
 */
function isPrimitive (value) {
  return (
    typeof value === 'string' ||
    typeof value === 'number' ||
    // $flow-disable-line
    typeof value === 'symbol' ||
    typeof value === 'boolean'
  )
}

/**
 * Quick object check - this is primarily used to tell
 * Objects from primitive values when we know the value
 * is a JSON-compliant type.
 */
function isObject (obj) {
  return obj !== null && typeof obj === 'object'
}

/**
 * Get the raw type string of a value, e.g., [object Object].
 */
var _toString = Object.prototype.toString;

function toRawType (value) {
  return _toString.call(value).slice(8, -1)
}

/**
 * Strict object type check. Only returns true
 * for plain JavaScript objects.
 */
function isPlainObject (obj) {
  return _toString.call(obj) === '[object Object]'
}

function isRegExp (v) {
  return _toString.call(v) === '[object RegExp]'
}

/**
 * Check if val is a valid array index.
 */
function isValidArrayIndex (val) {
  var n = parseFloat(String(val));
  return n >= 0 && Math.floor(n) === n && isFinite(val)
}

function isPromise (val) {
  return (
    isDef(val) &&
    typeof val.then === 'function' &&
    typeof val.catch === 'function'
  )
}

/**
 * Convert a value to a string that is actually rendered.
 */
function toString (val) {
  return val == null
    ? ''
    : Array.isArray(val) || (isPlainObject(val) && val.toString === _toString)
      ? JSON.stringify(val, null, 2)
      : String(val)
}

/**
 * Convert an input value to a number for persistence.
 * If the conversion fails, return original string.
 */
function toNumber (val) {
  var n = parseFloat(val);
  return isNaN(n) ? val : n
}

/**
 * Make a map and return a function for checking if a key
 * is in that map.
 */
function makeMap (
  str,
  expectsLowerCase
) {
  var map = Object.create(null);
  var list = str.split(',');
  for (var i = 0; i < list.length; i++) {
    map[list[i]] = true;
  }
  return expectsLowerCase
    ? function (val) { return map[val.toLowerCase()]; }
    : function (val) { return map[val]; }
}

/**
 * Check if a tag is a built-in tag.
 */
var isBuiltInTag = makeMap('slot,component', true);

/**
 * Check if an attribute is a reserved attribute.
 */
var isReservedAttribute = makeMap('key,ref,slot,slot-scope,is');

/**
 * Remove an item from an array.
 */
function remove (arr, item) {
  if (arr.length) {
    var index = arr.indexOf(item);
    if (index > -1) {
      return arr.splice(index, 1)
    }
  }
}

/**
 * Check whether an object has the property.
 */
var hasOwnProperty = Object.prototype.hasOwnProperty;
function hasOwn (obj, key) {
  return hasOwnProperty.call(obj, key)
}

/**
 * Create a cached version of a pure function.
 */
function cached (fn) {
  var cache = Object.create(null);
  return (function cachedFn (str) {
    var hit = cache[str];
    return hit || (cache[str] = fn(str))
  })
}

/**
 * Camelize a hyphen-delimited string.
 */
var camelizeRE = /-(\w)/g;
var camelize = cached(function (str) {
  return str.replace(camelizeRE, function (_, c) { return c ? c.toUpperCase() : ''; })
});

/**
 * Capitalize a string.
 */
var capitalize = cached(function (str) {
  return str.charAt(0).toUpperCase() + str.slice(1)
});

/**
 * Hyphenate a camelCase string.
 */
var hyphenateRE = /\B([A-Z])/g;
var hyphenate = cached(function (str) {
  return str.replace(hyphenateRE, '-$1').toLowerCase()
});

/**
 * Simple bind polyfill for environments that do not support it,
 * e.g., PhantomJS 1.x. Technically, we don't need this anymore
 * since native bind is now performant enough in most browsers.
 * But removing it would mean breaking code that was able to run in
 * PhantomJS 1.x, so this must be kept for backward compatibility.
 */

/* istanbul ignore next */
function polyfillBind (fn, ctx) {
  function boundFn (a) {
    var l = arguments.length;
    return l
      ? l > 1
        ? fn.apply(ctx, arguments)
        : fn.call(ctx, a)
      : fn.call(ctx)
  }

  boundFn._length = fn.length;
  return boundFn
}

function nativeBind (fn, ctx) {
  return fn.bind(ctx)
}

var bind = Function.prototype.bind
  ? nativeBind
  : polyfillBind;

/**
 * Convert an Array-like object to a real Array.
 */
function toArray (list, start) {
  start = start || 0;
  var i = list.length - start;
  var ret = new Array(i);
  while (i--) {
    ret[i] = list[i + start];
  }
  return ret
}

/**
 * Mix properties into target object.
 */
function extend (to, _from) {
  for (var key in _from) {
    to[key] = _from[key];
  }
  return to
}

/**
 * Merge an Array of Objects into a single Object.
 */
function toObject (arr) {
  var res = {};
  for (var i = 0; i < arr.length; i++) {
    if (arr[i]) {
      extend(res, arr[i]);
    }
  }
  return res
}

/* eslint-disable no-unused-vars */

/**
 * Perform no operation.
 * Stubbing args to make Flow happy without leaving useless transpiled code
 * with ...rest (https://flow.org/blog/2017/05/07/Strict-Function-Call-Arity/).
 */
function noop (a, b, c) {}

/**
 * Always return false.
 */
var no = function (a, b, c) { return false; };

/* eslint-enable no-unused-vars */

/**
 * Return the same value.
 */
var identity = function (_) { return _; };

/**
 * Generate a string containing static keys from compiler modules.
 */
function genStaticKeys (modules) {
  return modules.reduce(function (keys, m) {
    return keys.concat(m.staticKeys || [])
  }, []).join(',')
}

/**
 * Check if two values are loosely equal - that is,
 * if they are plain objects, do they have the same shape?
 */
function looseEqual (a, b) {
  if (a === b) { return true }
  var isObjectA = isObject(a);
  var isObjectB = isObject(b);
  if (isObjectA && isObjectB) {
    try {
      var isArrayA = Array.isArray(a);
      var isArrayB = Array.isArray(b);
      if (isArrayA && isArrayB) {
        return a.length === b.length && a.every(function (e, i) {
          return looseEqual(e, b[i])
        })
      } else if (a instanceof Date && b instanceof Date) {
        return a.getTime() === b.getTime()
      } else if (!isArrayA && !isArrayB) {
        var keysA = Object.keys(a);
        var keysB = Object.keys(b);
        return keysA.length === keysB.length && keysA.every(function (key) {
          return looseEqual(a[key], b[key])
        })
      } else {
        /* istanbul ignore next */
        return false
      }
    } catch (e) {
      /* istanbul ignore next */
      return false
    }
  } else if (!isObjectA && !isObjectB) {
    return String(a) === String(b)
  } else {
    return false
  }
}

/**
 * Return the first index at which a loosely equal value can be
 * found in the array (if value is a plain object, the array must
 * contain an object of the same shape), or -1 if it is not present.
 */
function looseIndexOf (arr, val) {
  for (var i = 0; i < arr.length; i++) {
    if (looseEqual(arr[i], val)) { return i }
  }
  return -1
}

/**
 * Ensure a function is called only once.
 */
function once (fn) {
  var called = false;
  return function () {
    if (!called) {
      called = true;
      fn.apply(this, arguments);
    }
  }
}

var SSR_ATTR = 'data-server-rendered';

var ASSET_TYPES = [
  'component',
  'directive',
  'filter'
];

var LIFECYCLE_HOOKS = [
  'beforeCreate',
  'created',
  'beforeMount',
  'mounted',
  'beforeUpdate',
  'updated',
  'beforeDestroy',
  'destroyed',
  'activated',
  'deactivated',
  'errorCaptured',
  'serverPrefetch'
];

/*  */



var config = ({
  /**
   * Option merge strategies (used in core/util/options)
   */
  // $flow-disable-line
  optionMergeStrategies: Object.create(null),

  /**
   * Whether to suppress warnings.
   */
  silent: false,

  /**
   * Show production mode tip message on boot?
   */
  productionTip: "production" !== 'production',

  /**
   * Whether to enable devtools
   */
  devtools: "production" !== 'production',

  /**
   * Whether to record perf
   */
  performance: false,

  /**
   * Error handler for watcher errors
   */
  errorHandler: null,

  /**
   * Warn handler for watcher warns
   */
  warnHandler: null,

  /**
   * Ignore certain custom elements
   */
  ignoredElements: [],

  /**
   * Custom user key aliases for v-on
   */
  // $flow-disable-line
  keyCodes: Object.create(null),

  /**
   * Check if a tag is reserved so that it cannot be registered as a
   * component. This is platform-dependent and may be overwritten.
   */
  isReservedTag: no,

  /**
   * Check if an attribute is reserved so that it cannot be used as a component
   * prop. This is platform-dependent and may be overwritten.
   */
  isReservedAttr: no,

  /**
   * Check if a tag is an unknown element.
   * Platform-dependent.
   */
  isUnknownElement: no,

  /**
   * Get the namespace of an element
   */
  getTagNamespace: noop,

  /**
   * Parse the real tag name for the specific platform.
   */
  parsePlatformTagName: identity,

  /**
   * Check if an attribute must be bound using property, e.g. value
   * Platform-dependent.
   */
  mustUseProp: no,

  /**
   * Perform updates asynchronously. Intended to be used by Vue Test Utils
   * This will significantly reduce performance if set to false.
   */
  async: true,

  /**
   * Exposed for legacy reasons
   */
  _lifecycleHooks: LIFECYCLE_HOOKS
});

/*  */

/**
 * unicode letters used for parsing html tags, component names and property paths.
 * using https://www.w3.org/TR/html53/semantics-scripting.html#potentialcustomelementname
 * skipping \u10000-\uEFFFF due to it freezing up PhantomJS
 */
var unicodeRegExp = /a-zA-Z\u00B7\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u037D\u037F-\u1FFF\u200C-\u200D\u203F-\u2040\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD/;

/**
 * Check if a string starts with $ or _
 */
function isReserved (str) {
  var c = (str + '').charCodeAt(0);
  return c === 0x24 || c === 0x5F
}

/**
 * Define a property.
 */
function def (obj, key, val, enumerable) {
  Object.defineProperty(obj, key, {
    value: val,
    enumerable: !!enumerable,
    writable: true,
    configurable: true
  });
}

/**
 * Parse simple path.
 */
var bailRE = new RegExp(("[^" + (unicodeRegExp.source) + ".$_\\d]"));
function parsePath (path) {
  if (bailRE.test(path)) {
    return
  }
  var segments = path.split('.');
  return function (obj) {
    for (var i = 0; i < segments.length; i++) {
      if (!obj) { return }
      obj = obj[segments[i]];
    }
    return obj
  }
}

/*  */

// can we use __proto__?
var hasProto = '__proto__' in {};

// Browser environment sniffing
var inBrowser = typeof window !== 'undefined';
var inWeex = typeof WXEnvironment !== 'undefined' && !!WXEnvironment.platform;
var weexPlatform = inWeex && WXEnvironment.platform.toLowerCase();
var UA = inBrowser && window.navigator.userAgent.toLowerCase();
var isIE = UA && /msie|trident/.test(UA);
var isIE9 = UA && UA.indexOf('msie 9.0') > 0;
var isEdge = UA && UA.indexOf('edge/') > 0;
var isAndroid = (UA && UA.indexOf('android') > 0) || (weexPlatform === 'android');
var isIOS = (UA && /iphone|ipad|ipod|ios/.test(UA)) || (weexPlatform === 'ios');
var isChrome = UA && /chrome\/\d+/.test(UA) && !isEdge;
var isPhantomJS = UA && /phantomjs/.test(UA);
var isFF = UA && UA.match(/firefox\/(\d+)/);

// Firefox has a "watch" function on Object.prototype...
var nativeWatch = ({}).watch;

var supportsPassive = false;
if (inBrowser) {
  try {
    var opts = {};
    Object.defineProperty(opts, 'passive', ({
      get: function get () {
        /* istanbul ignore next */
        supportsPassive = true;
      }
    })); // https://github.com/facebook/flow/issues/285
    window.addEventListener('test-passive', null, opts);
  } catch (e) {}
}

// this needs to be lazy-evaled because vue may be required before
// vue-server-renderer can set VUE_ENV
var _isServer;
var isServerRendering = function () {
  if (_isServer === undefined) {
    /* istanbul ignore if */
    if (!inBrowser && !inWeex && typeof global !== 'undefined') {
      // detect presence of vue-server-renderer and avoid
      // Webpack shimming the process
      _isServer = global['process'] && global['process'].env.VUE_ENV === 'server';
    } else {
      _isServer = false;
    }
  }
  return _isServer
};

// detect devtools
var devtools = inBrowser && window.__VUE_DEVTOOLS_GLOBAL_HOOK__;

/* istanbul ignore next */
function isNative (Ctor) {
  return typeof Ctor === 'function' && /native code/.test(Ctor.toString())
}

var hasSymbol =
  typeof Symbol !== 'undefined' && isNative(Symbol) &&
  typeof Reflect !== 'undefined' && isNative(Reflect.ownKeys);

var _Set;
/* istanbul ignore if */ // $flow-disable-line
if (typeof Set !== 'undefined' && isNative(Set)) {
  // use native Set when available.
  _Set = Set;
} else {
  // a non-standard Set polyfill that only works with primitive keys.
  _Set = /*@__PURE__*/(function () {
    function Set () {
      this.set = Object.create(null);
    }
    Set.prototype.has = function has (key) {
      return this.set[key] === true
    };
    Set.prototype.add = function add (key) {
      this.set[key] = true;
    };
    Set.prototype.clear = function clear () {
      this.set = Object.create(null);
    };

    return Set;
  }());
}

/*  */

var warn = noop;
var tip = noop;
var generateComponentTrace = (noop); // work around flow check
var formatComponentName = (noop);

if (false) {
  var hasConsole = typeof console !== 'undefined';
  var classifyRE = /(?:^|[-_])(\w)/g;
  var classify = function (str) { return str
    .replace(classifyRE, function (c) { return c.toUpperCase(); })
    .replace(/[-_]/g, ''); };

  warn = function (msg, vm) {
    var trace = vm ? generateComponentTrace(vm) : '';

    if (config.warnHandler) {
      config.warnHandler.call(null, msg, vm, trace);
    } else if (hasConsole && (!config.silent)) {
      console.error(("[Vue warn]: " + msg + trace));
    }
  };

  tip = function (msg, vm) {
    if (hasConsole && (!config.silent)) {
      console.warn("[Vue tip]: " + msg + (
        vm ? generateComponentTrace(vm) : ''
      ));
    }
  };

  formatComponentName = function (vm, includeFile) {
    if (vm.$root === vm) {
      return '<Root>'
    }
    var options = typeof vm === 'function' && vm.cid != null
      ? vm.options
      : vm._isVue
        ? vm.$options || vm.constructor.options
        : vm;
    var name = options.name || options._componentTag;
    var file = options.__file;
    if (!name && file) {
      var match = file.match(/([^/\\]+)\.vue$/);
      name = match && match[1];
    }

    return (
      (name ? ("<" + (classify(name)) + ">") : "<Anonymous>") +
      (file && includeFile !== false ? (" at " + file) : '')
    )
  };

  var repeat = function (str, n) {
    var res = '';
    while (n) {
      if (n % 2 === 1) { res += str; }
      if (n > 1) { str += str; }
      n >>= 1;
    }
    return res
  };

  generateComponentTrace = function (vm) {
    if (vm._isVue && vm.$parent) {
      var tree = [];
      var currentRecursiveSequence = 0;
      while (vm) {
        if (tree.length > 0) {
          var last = tree[tree.length - 1];
          if (last.constructor === vm.constructor) {
            currentRecursiveSequence++;
            vm = vm.$parent;
            continue
          } else if (currentRecursiveSequence > 0) {
            tree[tree.length - 1] = [last, currentRecursiveSequence];
            currentRecursiveSequence = 0;
          }
        }
        tree.push(vm);
        vm = vm.$parent;
      }
      return '\n\nfound in\n\n' + tree
        .map(function (vm, i) { return ("" + (i === 0 ? '---> ' : repeat(' ', 5 + i * 2)) + (Array.isArray(vm)
            ? ((formatComponentName(vm[0])) + "... (" + (vm[1]) + " recursive calls)")
            : formatComponentName(vm))); })
        .join('\n')
    } else {
      return ("\n\n(found in " + (formatComponentName(vm)) + ")")
    }
  };
}

/*  */

var uid = 0;

/**
 * A dep is an observable that can have multiple
 * directives subscribing to it.
 */
var Dep = function Dep () {
  this.id = uid++;
  this.subs = [];
};

Dep.prototype.addSub = function addSub (sub) {
  this.subs.push(sub);
};

Dep.prototype.removeSub = function removeSub (sub) {
  remove(this.subs, sub);
};

Dep.prototype.depend = function depend () {
  if (Dep.target) {
    Dep.target.addDep(this);
  }
};

Dep.prototype.notify = function notify () {
  // stabilize the subscriber list first
  var subs = this.subs.slice();
  if (false) {
    // subs aren't sorted in scheduler if not running async
    // we need to sort them now to make sure they fire in correct
    // order
    subs.sort(function (a, b) { return a.id - b.id; });
  }
  for (var i = 0, l = subs.length; i < l; i++) {
    subs[i].update();
  }
};

// The current target watcher being evaluated.
// This is globally unique because only one watcher
// can be evaluated at a time.
Dep.target = null;
var targetStack = [];

function pushTarget (target) {
  targetStack.push(target);
  Dep.target = target;
}

function popTarget () {
  targetStack.pop();
  Dep.target = targetStack[targetStack.length - 1];
}

/*  */

var VNode = function VNode (
  tag,
  data,
  children,
  text,
  elm,
  context,
  componentOptions,
  asyncFactory
) {
  this.tag = tag;
  this.data = data;
  this.children = children;
  this.text = text;
  this.elm = elm;
  this.ns = undefined;
  this.context = context;
  this.fnContext = undefined;
  this.fnOptions = undefined;
  this.fnScopeId = undefined;
  this.key = data && data.key;
  this.componentOptions = componentOptions;
  this.componentInstance = undefined;
  this.parent = undefined;
  this.raw = false;
  this.isStatic = false;
  this.isRootInsert = true;
  this.isComment = false;
  this.isCloned = false;
  this.isOnce = false;
  this.asyncFactory = asyncFactory;
  this.asyncMeta = undefined;
  this.isAsyncPlaceholder = false;
};

var prototypeAccessors = { child: { configurable: true } };

// DEPRECATED: alias for componentInstance for backwards compat.
/* istanbul ignore next */
prototypeAccessors.child.get = function () {
  return this.componentInstance
};

Object.defineProperties( VNode.prototype, prototypeAccessors );

var createEmptyVNode = function (text) {
  if ( text === void 0 ) text = '';

  var node = new VNode();
  node.text = text;
  node.isComment = true;
  return node
};

function createTextVNode (val) {
  return new VNode(undefined, undefined, undefined, String(val))
}

// optimized shallow clone
// used for static nodes and slot nodes because they may be reused across
// multiple renders, cloning them avoids errors when DOM manipulations rely
// on their elm reference.
function cloneVNode (vnode) {
  var cloned = new VNode(
    vnode.tag,
    vnode.data,
    // #7975
    // clone children array to avoid mutating original in case of cloning
    // a child.
    vnode.children && vnode.children.slice(),
    vnode.text,
    vnode.elm,
    vnode.context,
    vnode.componentOptions,
    vnode.asyncFactory
  );
  cloned.ns = vnode.ns;
  cloned.isStatic = vnode.isStatic;
  cloned.key = vnode.key;
  cloned.isComment = vnode.isComment;
  cloned.fnContext = vnode.fnContext;
  cloned.fnOptions = vnode.fnOptions;
  cloned.fnScopeId = vnode.fnScopeId;
  cloned.asyncMeta = vnode.asyncMeta;
  cloned.isCloned = true;
  return cloned
}

/*
 * not type checking this file because flow doesn't play well with
 * dynamically accessing methods on Array prototype
 */

var arrayProto = Array.prototype;
var arrayMethods = Object.create(arrayProto);

var methodsToPatch = [
  'push',
  'pop',
  'shift',
  'unshift',
  'splice',
  'sort',
  'reverse'
];

/**
 * Intercept mutating methods and emit events
 */
methodsToPatch.forEach(function (method) {
  // cache original method
  var original = arrayProto[method];
  def(arrayMethods, method, function mutator () {
    var args = [], len = arguments.length;
    while ( len-- ) args[ len ] = arguments[ len ];

    var result = original.apply(this, args);
    var ob = this.__ob__;
    var inserted;
    switch (method) {
      case 'push':
      case 'unshift':
        inserted = args;
        break
      case 'splice':
        inserted = args.slice(2);
        break
    }
    if (inserted) { ob.observeArray(inserted); }
    // notify change
    ob.dep.notify();
    return result
  });
});

/*  */

var arrayKeys = Object.getOwnPropertyNames(arrayMethods);

/**
 * In some cases we may want to disable observation inside a component's
 * update computation.
 */
var shouldObserve = true;

function toggleObserving (value) {
  shouldObserve = value;
}

/**
 * Observer class that is attached to each observed
 * object. Once attached, the observer converts the target
 * object's property keys into getter/setters that
 * collect dependencies and dispatch updates.
 */
var Observer = function Observer (value) {
  this.value = value;
  this.dep = new Dep();
  this.vmCount = 0;
  def(value, '__ob__', this);
  if (Array.isArray(value)) {
    if (hasProto) {
      protoAugment(value, arrayMethods);
    } else {
      copyAugment(value, arrayMethods, arrayKeys);
    }
    this.observeArray(value);
  } else {
    this.walk(value);
  }
};

/**
 * Walk through all properties and convert them into
 * getter/setters. This method should only be called when
 * value type is Object.
 */
Observer.prototype.walk = function walk (obj) {
  var keys = Object.keys(obj);
  for (var i = 0; i < keys.length; i++) {
    defineReactive$$1(obj, keys[i]);
  }
};

/**
 * Observe a list of Array items.
 */
Observer.prototype.observeArray = function observeArray (items) {
  for (var i = 0, l = items.length; i < l; i++) {
    observe(items[i]);
  }
};

// helpers

/**
 * Augment a target Object or Array by intercepting
 * the prototype chain using __proto__
 */
function protoAugment (target, src) {
  /* eslint-disable no-proto */
  target.__proto__ = src;
  /* eslint-enable no-proto */
}

/**
 * Augment a target Object or Array by defining
 * hidden properties.
 */
/* istanbul ignore next */
function copyAugment (target, src, keys) {
  for (var i = 0, l = keys.length; i < l; i++) {
    var key = keys[i];
    def(target, key, src[key]);
  }
}

/**
 * Attempt to create an observer instance for a value,
 * returns the new observer if successfully observed,
 * or the existing observer if the value already has one.
 */
function observe (value, asRootData) {
  if (!isObject(value) || value instanceof VNode) {
    return
  }
  var ob;
  if (hasOwn(value, '__ob__') && value.__ob__ instanceof Observer) {
    ob = value.__ob__;
  } else if (
    shouldObserve &&
    !isServerRendering() &&
    (Array.isArray(value) || isPlainObject(value)) &&
    Object.isExtensible(value) &&
    !value._isVue
  ) {
    ob = new Observer(value);
  }
  if (asRootData && ob) {
    ob.vmCount++;
  }
  return ob
}

/**
 * Define a reactive property on an Object.
 */
function defineReactive$$1 (
  obj,
  key,
  val,
  customSetter,
  shallow
) {
  var dep = new Dep();

  var property = Object.getOwnPropertyDescriptor(obj, key);
  if (property && property.configurable === false) {
    return
  }

  // cater for pre-defined getter/setters
  var getter = property && property.get;
  var setter = property && property.set;
  if ((!getter || setter) && arguments.length === 2) {
    val = obj[key];
  }

  var childOb = !shallow && observe(val);
  Object.defineProperty(obj, key, {
    enumerable: true,
    configurable: true,
    get: function reactiveGetter () {
      var value = getter ? getter.call(obj) : val;
      if (Dep.target) {
        dep.depend();
        if (childOb) {
          childOb.dep.depend();
          if (Array.isArray(value)) {
            dependArray(value);
          }
        }
      }
      return value
    },
    set: function reactiveSetter (newVal) {
      var value = getter ? getter.call(obj) : val;
      /* eslint-disable no-self-compare */
      if (newVal === value || (newVal !== newVal && value !== value)) {
        return
      }
      /* eslint-enable no-self-compare */
      if (false) {
        customSetter();
      }
      // #7981: for accessor properties without setter
      if (getter && !setter) { return }
      if (setter) {
        setter.call(obj, newVal);
      } else {
        val = newVal;
      }
      childOb = !shallow && observe(newVal);
      dep.notify();
    }
  });
}

/**
 * Set a property on an object. Adds the new property and
 * triggers change notification if the property doesn't
 * already exist.
 */
function set (target, key, val) {
  if (false
  ) {
    warn(("Cannot set reactive property on undefined, null, or primitive value: " + ((target))));
  }
  if (Array.isArray(target) && isValidArrayIndex(key)) {
    target.length = Math.max(target.length, key);
    target.splice(key, 1, val);
    return val
  }
  if (key in target && !(key in Object.prototype)) {
    target[key] = val;
    return val
  }
  var ob = (target).__ob__;
  if (target._isVue || (ob && ob.vmCount)) {
    "production" !== 'production' && warn(
      'Avoid adding reactive properties to a Vue instance or its root $data ' +
      'at runtime - declare it upfront in the data option.'
    );
    return val
  }
  if (!ob) {
    target[key] = val;
    return val
  }
  defineReactive$$1(ob.value, key, val);
  ob.dep.notify();
  return val
}

/**
 * Delete a property and trigger change if necessary.
 */
function del (target, key) {
  if (false
  ) {
    warn(("Cannot delete reactive property on undefined, null, or primitive value: " + ((target))));
  }
  if (Array.isArray(target) && isValidArrayIndex(key)) {
    target.splice(key, 1);
    return
  }
  var ob = (target).__ob__;
  if (target._isVue || (ob && ob.vmCount)) {
    "production" !== 'production' && warn(
      'Avoid deleting properties on a Vue instance or its root $data ' +
      '- just set it to null.'
    );
    return
  }
  if (!hasOwn(target, key)) {
    return
  }
  delete target[key];
  if (!ob) {
    return
  }
  ob.dep.notify();
}

/**
 * Collect dependencies on array elements when the array is touched, since
 * we cannot intercept array element access like property getters.
 */
function dependArray (value) {
  for (var e = (void 0), i = 0, l = value.length; i < l; i++) {
    e = value[i];
    e && e.__ob__ && e.__ob__.dep.depend();
    if (Array.isArray(e)) {
      dependArray(e);
    }
  }
}

/*  */

/**
 * Option overwriting strategies are functions that handle
 * how to merge a parent option value and a child option
 * value into the final value.
 */
var strats = config.optionMergeStrategies;

/**
 * Options with restrictions
 */
if (false) {
  strats.el = strats.propsData = function (parent, child, vm, key) {
    if (!vm) {
      warn(
        "option \"" + key + "\" can only be used during instance " +
        'creation with the `new` keyword.'
      );
    }
    return defaultStrat(parent, child)
  };
}

/**
 * Helper that recursively merges two data objects together.
 */
function mergeData (to, from) {
  if (!from) { return to }
  var key, toVal, fromVal;

  var keys = hasSymbol
    ? Reflect.ownKeys(from)
    : Object.keys(from);

  for (var i = 0; i < keys.length; i++) {
    key = keys[i];
    // in case the object is already observed...
    if (key === '__ob__') { continue }
    toVal = to[key];
    fromVal = from[key];
    if (!hasOwn(to, key)) {
      set(to, key, fromVal);
    } else if (
      toVal !== fromVal &&
      isPlainObject(toVal) &&
      isPlainObject(fromVal)
    ) {
      mergeData(toVal, fromVal);
    }
  }
  return to
}

/**
 * Data
 */
function mergeDataOrFn (
  parentVal,
  childVal,
  vm
) {
  if (!vm) {
    // in a Vue.extend merge, both should be functions
    if (!childVal) {
      return parentVal
    }
    if (!parentVal) {
      return childVal
    }
    // when parentVal & childVal are both present,
    // we need to return a function that returns the
    // merged result of both functions... no need to
    // check if parentVal is a function here because
    // it has to be a function to pass previous merges.
    return function mergedDataFn () {
      return mergeData(
        typeof childVal === 'function' ? childVal.call(this, this) : childVal,
        typeof parentVal === 'function' ? parentVal.call(this, this) : parentVal
      )
    }
  } else {
    return function mergedInstanceDataFn () {
      // instance merge
      var instanceData = typeof childVal === 'function'
        ? childVal.call(vm, vm)
        : childVal;
      var defaultData = typeof parentVal === 'function'
        ? parentVal.call(vm, vm)
        : parentVal;
      if (instanceData) {
        return mergeData(instanceData, defaultData)
      } else {
        return defaultData
      }
    }
  }
}

strats.data = function (
  parentVal,
  childVal,
  vm
) {
  if (!vm) {
    if (childVal && typeof childVal !== 'function') {
      "production" !== 'production' && warn(
        'The "data" option should be a function ' +
        'that returns a per-instance value in component ' +
        'definitions.',
        vm
      );

      return parentVal
    }
    return mergeDataOrFn(parentVal, childVal)
  }

  return mergeDataOrFn(parentVal, childVal, vm)
};

/**
 * Hooks and props are merged as arrays.
 */
function mergeHook (
  parentVal,
  childVal
) {
  var res = childVal
    ? parentVal
      ? parentVal.concat(childVal)
      : Array.isArray(childVal)
        ? childVal
        : [childVal]
    : parentVal;
  return res
    ? dedupeHooks(res)
    : res
}

function dedupeHooks (hooks) {
  var res = [];
  for (var i = 0; i < hooks.length; i++) {
    if (res.indexOf(hooks[i]) === -1) {
      res.push(hooks[i]);
    }
  }
  return res
}

LIFECYCLE_HOOKS.forEach(function (hook) {
  strats[hook] = mergeHook;
});

/**
 * Assets
 *
 * When a vm is present (instance creation), we need to do
 * a three-way merge between constructor options, instance
 * options and parent options.
 */
function mergeAssets (
  parentVal,
  childVal,
  vm,
  key
) {
  var res = Object.create(parentVal || null);
  if (childVal) {
    "production" !== 'production' && assertObjectType(key, childVal, vm);
    return extend(res, childVal)
  } else {
    return res
  }
}

ASSET_TYPES.forEach(function (type) {
  strats[type + 's'] = mergeAssets;
});

/**
 * Watchers.
 *
 * Watchers hashes should not overwrite one
 * another, so we merge them as arrays.
 */
strats.watch = function (
  parentVal,
  childVal,
  vm,
  key
) {
  // work around Firefox's Object.prototype.watch...
  if (parentVal === nativeWatch) { parentVal = undefined; }
  if (childVal === nativeWatch) { childVal = undefined; }
  /* istanbul ignore if */
  if (!childVal) { return Object.create(parentVal || null) }
  if (false) {
    assertObjectType(key, childVal, vm);
  }
  if (!parentVal) { return childVal }
  var ret = {};
  extend(ret, parentVal);
  for (var key$1 in childVal) {
    var parent = ret[key$1];
    var child = childVal[key$1];
    if (parent && !Array.isArray(parent)) {
      parent = [parent];
    }
    ret[key$1] = parent
      ? parent.concat(child)
      : Array.isArray(child) ? child : [child];
  }
  return ret
};

/**
 * Other object hashes.
 */
strats.props =
strats.methods =
strats.inject =
strats.computed = function (
  parentVal,
  childVal,
  vm,
  key
) {
  if (childVal && "production" !== 'production') {
    assertObjectType(key, childVal, vm);
  }
  if (!parentVal) { return childVal }
  var ret = Object.create(null);
  extend(ret, parentVal);
  if (childVal) { extend(ret, childVal); }
  return ret
};
strats.provide = mergeDataOrFn;

/**
 * Default strategy.
 */
var defaultStrat = function (parentVal, childVal) {
  return childVal === undefined
    ? parentVal
    : childVal
};

/**
 * Validate component names
 */
function checkComponents (options) {
  for (var key in options.components) {
    validateComponentName(key);
  }
}

function validateComponentName (name) {
  if (!new RegExp(("^[a-zA-Z][\\-\\.0-9_" + (unicodeRegExp.source) + "]*$")).test(name)) {
    warn(
      'Invalid component name: "' + name + '". Component names ' +
      'should conform to valid custom element name in html5 specification.'
    );
  }
  if (isBuiltInTag(name) || config.isReservedTag(name)) {
    warn(
      'Do not use built-in or reserved HTML elements as component ' +
      'id: ' + name
    );
  }
}

/**
 * Ensure all props option syntax are normalized into the
 * Object-based format.
 */
function normalizeProps (options, vm) {
  var props = options.props;
  if (!props) { return }
  var res = {};
  var i, val, name;
  if (Array.isArray(props)) {
    i = props.length;
    while (i--) {
      val = props[i];
      if (typeof val === 'string') {
        name = camelize(val);
        res[name] = { type: null };
      } else if (false) {
        warn('props must be strings when using array syntax.');
      }
    }
  } else if (isPlainObject(props)) {
    for (var key in props) {
      val = props[key];
      name = camelize(key);
      res[name] = isPlainObject(val)
        ? val
        : { type: val };
    }
  } else if (false) {
    warn(
      "Invalid value for option \"props\": expected an Array or an Object, " +
      "but got " + (toRawType(props)) + ".",
      vm
    );
  }
  options.props = res;
}

/**
 * Normalize all injections into Object-based format
 */
function normalizeInject (options, vm) {
  var inject = options.inject;
  if (!inject) { return }
  var normalized = options.inject = {};
  if (Array.isArray(inject)) {
    for (var i = 0; i < inject.length; i++) {
      normalized[inject[i]] = { from: inject[i] };
    }
  } else if (isPlainObject(inject)) {
    for (var key in inject) {
      var val = inject[key];
      normalized[key] = isPlainObject(val)
        ? extend({ from: key }, val)
        : { from: val };
    }
  } else if (false) {
    warn(
      "Invalid value for option \"inject\": expected an Array or an Object, " +
      "but got " + (toRawType(inject)) + ".",
      vm
    );
  }
}

/**
 * Normalize raw function directives into object format.
 */
function normalizeDirectives (options) {
  var dirs = options.directives;
  if (dirs) {
    for (var key in dirs) {
      var def$$1 = dirs[key];
      if (typeof def$$1 === 'function') {
        dirs[key] = { bind: def$$1, update: def$$1 };
      }
    }
  }
}

function assertObjectType (name, value, vm) {
  if (!isPlainObject(value)) {
    warn(
      "Invalid value for option \"" + name + "\": expected an Object, " +
      "but got " + (toRawType(value)) + ".",
      vm
    );
  }
}

/**
 * Merge two option objects into a new one.
 * Core utility used in both instantiation and inheritance.
 */
function mergeOptions (
  parent,
  child,
  vm
) {
  if (false) {
    checkComponents(child);
  }

  if (typeof child === 'function') {
    child = child.options;
  }

  normalizeProps(child, vm);
  normalizeInject(child, vm);
  normalizeDirectives(child);

  // Apply extends and mixins on the child options,
  // but only if it is a raw options object that isn't
  // the result of another mergeOptions call.
  // Only merged options has the _base property.
  if (!child._base) {
    if (child.extends) {
      parent = mergeOptions(parent, child.extends, vm);
    }
    if (child.mixins) {
      for (var i = 0, l = child.mixins.length; i < l; i++) {
        parent = mergeOptions(parent, child.mixins[i], vm);
      }
    }
  }

  var options = {};
  var key;
  for (key in parent) {
    mergeField(key);
  }
  for (key in child) {
    if (!hasOwn(parent, key)) {
      mergeField(key);
    }
  }
  function mergeField (key) {
    var strat = strats[key] || defaultStrat;
    options[key] = strat(parent[key], child[key], vm, key);
  }
  return options
}

/**
 * Resolve an asset.
 * This function is used because child instances need access
 * to assets defined in its ancestor chain.
 */
function resolveAsset (
  options,
  type,
  id,
  warnMissing
) {
  /* istanbul ignore if */
  if (typeof id !== 'string') {
    return
  }
  var assets = options[type];
  // check local registration variations first
  if (hasOwn(assets, id)) { return assets[id] }
  var camelizedId = camelize(id);
  if (hasOwn(assets, camelizedId)) { return assets[camelizedId] }
  var PascalCaseId = capitalize(camelizedId);
  if (hasOwn(assets, PascalCaseId)) { return assets[PascalCaseId] }
  // fallback to prototype chain
  var res = assets[id] || assets[camelizedId] || assets[PascalCaseId];
  if (false) {
    warn(
      'Failed to resolve ' + type.slice(0, -1) + ': ' + id,
      options
    );
  }
  return res
}

/*  */



function validateProp (
  key,
  propOptions,
  propsData,
  vm
) {
  var prop = propOptions[key];
  var absent = !hasOwn(propsData, key);
  var value = propsData[key];
  // boolean casting
  var booleanIndex = getTypeIndex(Boolean, prop.type);
  if (booleanIndex > -1) {
    if (absent && !hasOwn(prop, 'default')) {
      value = false;
    } else if (value === '' || value === hyphenate(key)) {
      // only cast empty string / same name to boolean if
      // boolean has higher priority
      var stringIndex = getTypeIndex(String, prop.type);
      if (stringIndex < 0 || booleanIndex < stringIndex) {
        value = true;
      }
    }
  }
  // check default value
  if (value === undefined) {
    value = getPropDefaultValue(vm, prop, key);
    // since the default value is a fresh copy,
    // make sure to observe it.
    var prevShouldObserve = shouldObserve;
    toggleObserving(true);
    observe(value);
    toggleObserving(prevShouldObserve);
  }
  if (
    false
  ) {
    assertProp(prop, key, value, vm, absent);
  }
  return value
}

/**
 * Get the default value of a prop.
 */
function getPropDefaultValue (vm, prop, key) {
  // no default, return undefined
  if (!hasOwn(prop, 'default')) {
    return undefined
  }
  var def = prop.default;
  // warn against non-factory defaults for Object & Array
  if (false) {
    warn(
      'Invalid default value for prop "' + key + '": ' +
      'Props with type Object/Array must use a factory function ' +
      'to return the default value.',
      vm
    );
  }
  // the raw prop value was also undefined from previous render,
  // return previous default value to avoid unnecessary watcher trigger
  if (vm && vm.$options.propsData &&
    vm.$options.propsData[key] === undefined &&
    vm._props[key] !== undefined
  ) {
    return vm._props[key]
  }
  // call factory function for non-Function types
  // a value is Function if its prototype is function even across different execution context
  return typeof def === 'function' && getType(prop.type) !== 'Function'
    ? def.call(vm)
    : def
}

/**
 * Assert whether a prop is valid.
 */
function assertProp (
  prop,
  name,
  value,
  vm,
  absent
) {
  if (prop.required && absent) {
    warn(
      'Missing required prop: "' + name + '"',
      vm
    );
    return
  }
  if (value == null && !prop.required) {
    return
  }
  var type = prop.type;
  var valid = !type || type === true;
  var expectedTypes = [];
  if (type) {
    if (!Array.isArray(type)) {
      type = [type];
    }
    for (var i = 0; i < type.length && !valid; i++) {
      var assertedType = assertType(value, type[i]);
      expectedTypes.push(assertedType.expectedType || '');
      valid = assertedType.valid;
    }
  }

  if (!valid) {
    warn(
      getInvalidTypeMessage(name, value, expectedTypes),
      vm
    );
    return
  }
  var validator = prop.validator;
  if (validator) {
    if (!validator(value)) {
      warn(
        'Invalid prop: custom validator check failed for prop "' + name + '".',
        vm
      );
    }
  }
}

var simpleCheckRE = /^(String|Number|Boolean|Function|Symbol)$/;

function assertType (value, type) {
  var valid;
  var expectedType = getType(type);
  if (simpleCheckRE.test(expectedType)) {
    var t = typeof value;
    valid = t === expectedType.toLowerCase();
    // for primitive wrapper objects
    if (!valid && t === 'object') {
      valid = value instanceof type;
    }
  } else if (expectedType === 'Object') {
    valid = isPlainObject(value);
  } else if (expectedType === 'Array') {
    valid = Array.isArray(value);
  } else {
    valid = value instanceof type;
  }
  return {
    valid: valid,
    expectedType: expectedType
  }
}

/**
 * Use function string name to check built-in types,
 * because a simple equality check will fail when running
 * across different vms / iframes.
 */
function getType (fn) {
  var match = fn && fn.toString().match(/^\s*function (\w+)/);
  return match ? match[1] : ''
}

function isSameType (a, b) {
  return getType(a) === getType(b)
}

function getTypeIndex (type, expectedTypes) {
  if (!Array.isArray(expectedTypes)) {
    return isSameType(expectedTypes, type) ? 0 : -1
  }
  for (var i = 0, len = expectedTypes.length; i < len; i++) {
    if (isSameType(expectedTypes[i], type)) {
      return i
    }
  }
  return -1
}

function getInvalidTypeMessage (name, value, expectedTypes) {
  var message = "Invalid prop: type check failed for prop \"" + name + "\"." +
    " Expected " + (expectedTypes.map(capitalize).join(', '));
  var expectedType = expectedTypes[0];
  var receivedType = toRawType(value);
  var expectedValue = styleValue(value, expectedType);
  var receivedValue = styleValue(value, receivedType);
  // check if we need to specify expected value
  if (expectedTypes.length === 1 &&
      isExplicable(expectedType) &&
      !isBoolean(expectedType, receivedType)) {
    message += " with value " + expectedValue;
  }
  message += ", got " + receivedType + " ";
  // check if we need to specify received value
  if (isExplicable(receivedType)) {
    message += "with value " + receivedValue + ".";
  }
  return message
}

function styleValue (value, type) {
  if (type === 'String') {
    return ("\"" + value + "\"")
  } else if (type === 'Number') {
    return ("" + (Number(value)))
  } else {
    return ("" + value)
  }
}

function isExplicable (value) {
  var explicitTypes = ['string', 'number', 'boolean'];
  return explicitTypes.some(function (elem) { return value.toLowerCase() === elem; })
}

function isBoolean () {
  var args = [], len = arguments.length;
  while ( len-- ) args[ len ] = arguments[ len ];

  return args.some(function (elem) { return elem.toLowerCase() === 'boolean'; })
}

/*  */

function handleError (err, vm, info) {
  // Deactivate deps tracking while processing error handler to avoid possible infinite rendering.
  // See: https://github.com/vuejs/vuex/issues/1505
  pushTarget();
  try {
    if (vm) {
      var cur = vm;
      while ((cur = cur.$parent)) {
        var hooks = cur.$options.errorCaptured;
        if (hooks) {
          for (var i = 0; i < hooks.length; i++) {
            try {
              var capture = hooks[i].call(cur, err, vm, info) === false;
              if (capture) { return }
            } catch (e) {
              globalHandleError(e, cur, 'errorCaptured hook');
            }
          }
        }
      }
    }
    globalHandleError(err, vm, info);
  } finally {
    popTarget();
  }
}

function invokeWithErrorHandling (
  handler,
  context,
  args,
  vm,
  info
) {
  var res;
  try {
    res = args ? handler.apply(context, args) : handler.call(context);
    if (res && !res._isVue && isPromise(res) && !res._handled) {
      res.catch(function (e) { return handleError(e, vm, info + " (Promise/async)"); });
      // issue #9511
      // avoid catch triggering multiple times when nested calls
      res._handled = true;
    }
  } catch (e) {
    handleError(e, vm, info);
  }
  return res
}

function globalHandleError (err, vm, info) {
  if (config.errorHandler) {
    try {
      return config.errorHandler.call(null, err, vm, info)
    } catch (e) {
      // if the user intentionally throws the original error in the handler,
      // do not log it twice
      if (e !== err) {
        logError(e, null, 'config.errorHandler');
      }
    }
  }
  logError(err, vm, info);
}

function logError (err, vm, info) {
  if (false) {
    warn(("Error in " + info + ": \"" + (err.toString()) + "\""), vm);
  }
  /* istanbul ignore else */
  if ((inBrowser || inWeex) && typeof console !== 'undefined') {
    console.error(err);
  } else {
    throw err
  }
}

/*  */

var isUsingMicroTask = false;

var callbacks = [];
var pending = false;

function flushCallbacks () {
  pending = false;
  var copies = callbacks.slice(0);
  callbacks.length = 0;
  for (var i = 0; i < copies.length; i++) {
    copies[i]();
  }
}

// Here we have async deferring wrappers using microtasks.
// In 2.5 we used (macro) tasks (in combination with microtasks).
// However, it has subtle problems when state is changed right before repaint
// (e.g. #6813, out-in transitions).
// Also, using (macro) tasks in event handler would cause some weird behaviors
// that cannot be circumvented (e.g. #7109, #7153, #7546, #7834, #8109).
// So we now use microtasks everywhere, again.
// A major drawback of this tradeoff is that there are some scenarios
// where microtasks have too high a priority and fire in between supposedly
// sequential events (e.g. #4521, #6690, which have workarounds)
// or even between bubbling of the same event (#6566).
var timerFunc;

// The nextTick behavior leverages the microtask queue, which can be accessed
// via either native Promise.then or MutationObserver.
// MutationObserver has wider support, however it is seriously bugged in
// UIWebView in iOS >= 9.3.3 when triggered in touch event handlers. It
// completely stops working after triggering a few times... so, if native
// Promise is available, we will use it:
/* istanbul ignore next, $flow-disable-line */
if (typeof Promise !== 'undefined' && isNative(Promise)) {
  var p = Promise.resolve();
  timerFunc = function () {
    p.then(flushCallbacks);
    // In problematic UIWebViews, Promise.then doesn't completely break, but
    // it can get stuck in a weird state where callbacks are pushed into the
    // microtask queue but the queue isn't being flushed, until the browser
    // needs to do some other work, e.g. handle a timer. Therefore we can
    // "force" the microtask queue to be flushed by adding an empty timer.
    if (isIOS) { setTimeout(noop); }
  };
  isUsingMicroTask = true;
} else if (!isIE && typeof MutationObserver !== 'undefined' && (
  isNative(MutationObserver) ||
  // PhantomJS and iOS 7.x
  MutationObserver.toString() === '[object MutationObserverConstructor]'
)) {
  // Use MutationObserver where native Promise is not available,
  // e.g. PhantomJS, iOS7, Android 4.4
  // (#6466 MutationObserver is unreliable in IE11)
  var counter = 1;
  var observer = new MutationObserver(flushCallbacks);
  var textNode = document.createTextNode(String(counter));
  observer.observe(textNode, {
    characterData: true
  });
  timerFunc = function () {
    counter = (counter + 1) % 2;
    textNode.data = String(counter);
  };
  isUsingMicroTask = true;
} else if (typeof setImmediate !== 'undefined' && isNative(setImmediate)) {
  // Fallback to setImmediate.
  // Technically it leverages the (macro) task queue,
  // but it is still a better choice than setTimeout.
  timerFunc = function () {
    setImmediate(flushCallbacks);
  };
} else {
  // Fallback to setTimeout.
  timerFunc = function () {
    setTimeout(flushCallbacks, 0);
  };
}

function nextTick (cb, ctx) {
  var _resolve;
  callbacks.push(function () {
    if (cb) {
      try {
        cb.call(ctx);
      } catch (e) {
        handleError(e, ctx, 'nextTick');
      }
    } else if (_resolve) {
      _resolve(ctx);
    }
  });
  if (!pending) {
    pending = true;
    timerFunc();
  }
  // $flow-disable-line
  if (!cb && typeof Promise !== 'undefined') {
    return new Promise(function (resolve) {
      _resolve = resolve;
    })
  }
}

/*  */

var mark;
var measure;

if (false) {
  var perf = inBrowser && window.performance;
  /* istanbul ignore if */
  if (
    perf &&
    perf.mark &&
    perf.measure &&
    perf.clearMarks &&
    perf.clearMeasures
  ) {
    mark = function (tag) { return perf.mark(tag); };
    measure = function (name, startTag, endTag) {
      perf.measure(name, startTag, endTag);
      perf.clearMarks(startTag);
      perf.clearMarks(endTag);
      // perf.clearMeasures(name)
    };
  }
}

/* not type checking this file because flow doesn't play well with Proxy */

var initProxy;

if (false) {
  var allowedGlobals = makeMap(
    'Infinity,undefined,NaN,isFinite,isNaN,' +
    'parseFloat,parseInt,decodeURI,decodeURIComponent,encodeURI,encodeURIComponent,' +
    'Math,Number,Date,Array,Object,Boolean,String,RegExp,Map,Set,JSON,Intl,' +
    'require' // for Webpack/Browserify
  );

  var warnNonPresent = function (target, key) {
    warn(
      "Property or method \"" + key + "\" is not defined on the instance but " +
      'referenced during render. Make sure that this property is reactive, ' +
      'either in the data option, or for class-based components, by ' +
      'initializing the property. ' +
      'See: https://vuejs.org/v2/guide/reactivity.html#Declaring-Reactive-Properties.',
      target
    );
  };

  var warnReservedPrefix = function (target, key) {
    warn(
      "Property \"" + key + "\" must be accessed with \"$data." + key + "\" because " +
      'properties starting with "$" or "_" are not proxied in the Vue instance to ' +
      'prevent conflicts with Vue internals. ' +
      'See: https://vuejs.org/v2/api/#data',
      target
    );
  };

  var hasProxy =
    typeof Proxy !== 'undefined' && isNative(Proxy);

  if (hasProxy) {
    var isBuiltInModifier = makeMap('stop,prevent,self,ctrl,shift,alt,meta,exact');
    config.keyCodes = new Proxy(config.keyCodes, {
      set: function set (target, key, value) {
        if (isBuiltInModifier(key)) {
          warn(("Avoid overwriting built-in modifier in config.keyCodes: ." + key));
          return false
        } else {
          target[key] = value;
          return true
        }
      }
    });
  }

  var hasHandler = {
    has: function has (target, key) {
      var has = key in target;
      var isAllowed = allowedGlobals(key) ||
        (typeof key === 'string' && key.charAt(0) === '_' && !(key in target.$data));
      if (!has && !isAllowed) {
        if (key in target.$data) { warnReservedPrefix(target, key); }
        else { warnNonPresent(target, key); }
      }
      return has || !isAllowed
    }
  };

  var getHandler = {
    get: function get (target, key) {
      if (typeof key === 'string' && !(key in target)) {
        if (key in target.$data) { warnReservedPrefix(target, key); }
        else { warnNonPresent(target, key); }
      }
      return target[key]
    }
  };

  initProxy = function initProxy (vm) {
    if (hasProxy) {
      // determine which proxy handler to use
      var options = vm.$options;
      var handlers = options.render && options.render._withStripped
        ? getHandler
        : hasHandler;
      vm._renderProxy = new Proxy(vm, handlers);
    } else {
      vm._renderProxy = vm;
    }
  };
}

/*  */

var seenObjects = new _Set();

/**
 * Recursively traverse an object to evoke all converted
 * getters, so that every nested property inside the object
 * is collected as a "deep" dependency.
 */
function traverse (val) {
  _traverse(val, seenObjects);
  seenObjects.clear();
}

function _traverse (val, seen) {
  var i, keys;
  var isA = Array.isArray(val);
  if ((!isA && !isObject(val)) || Object.isFrozen(val) || val instanceof VNode) {
    return
  }
  if (val.__ob__) {
    var depId = val.__ob__.dep.id;
    if (seen.has(depId)) {
      return
    }
    seen.add(depId);
  }
  if (isA) {
    i = val.length;
    while (i--) { _traverse(val[i], seen); }
  } else {
    keys = Object.keys(val);
    i = keys.length;
    while (i--) { _traverse(val[keys[i]], seen); }
  }
}

/*  */

var normalizeEvent = cached(function (name) {
  var passive = name.charAt(0) === '&';
  name = passive ? name.slice(1) : name;
  var once$$1 = name.charAt(0) === '~'; // Prefixed last, checked first
  name = once$$1 ? name.slice(1) : name;
  var capture = name.charAt(0) === '!';
  name = capture ? name.slice(1) : name;
  return {
    name: name,
    once: once$$1,
    capture: capture,
    passive: passive
  }
});

function createFnInvoker (fns, vm) {
  function invoker () {
    var arguments$1 = arguments;

    var fns = invoker.fns;
    if (Array.isArray(fns)) {
      var cloned = fns.slice();
      for (var i = 0; i < cloned.length; i++) {
        invokeWithErrorHandling(cloned[i], null, arguments$1, vm, "v-on handler");
      }
    } else {
      // return handler return value for single handlers
      return invokeWithErrorHandling(fns, null, arguments, vm, "v-on handler")
    }
  }
  invoker.fns = fns;
  return invoker
}

function updateListeners (
  on,
  oldOn,
  add,
  remove$$1,
  createOnceHandler,
  vm
) {
  var name, def$$1, cur, old, event;
  for (name in on) {
    def$$1 = cur = on[name];
    old = oldOn[name];
    event = normalizeEvent(name);
    if (isUndef(cur)) {
      "production" !== 'production' && warn(
        "Invalid handler for event \"" + (event.name) + "\": got " + String(cur),
        vm
      );
    } else if (isUndef(old)) {
      if (isUndef(cur.fns)) {
        cur = on[name] = createFnInvoker(cur, vm);
      }
      if (isTrue(event.once)) {
        cur = on[name] = createOnceHandler(event.name, cur, event.capture);
      }
      add(event.name, cur, event.capture, event.passive, event.params);
    } else if (cur !== old) {
      old.fns = cur;
      on[name] = old;
    }
  }
  for (name in oldOn) {
    if (isUndef(on[name])) {
      event = normalizeEvent(name);
      remove$$1(event.name, oldOn[name], event.capture);
    }
  }
}

/*  */

function mergeVNodeHook (def, hookKey, hook) {
  if (def instanceof VNode) {
    def = def.data.hook || (def.data.hook = {});
  }
  var invoker;
  var oldHook = def[hookKey];

  function wrappedHook () {
    hook.apply(this, arguments);
    // important: remove merged hook to ensure it's called only once
    // and prevent memory leak
    remove(invoker.fns, wrappedHook);
  }

  if (isUndef(oldHook)) {
    // no existing hook
    invoker = createFnInvoker([wrappedHook]);
  } else {
    /* istanbul ignore if */
    if (isDef(oldHook.fns) && isTrue(oldHook.merged)) {
      // already a merged invoker
      invoker = oldHook;
      invoker.fns.push(wrappedHook);
    } else {
      // existing plain hook
      invoker = createFnInvoker([oldHook, wrappedHook]);
    }
  }

  invoker.merged = true;
  def[hookKey] = invoker;
}

/*  */

function extractPropsFromVNodeData (
  data,
  Ctor,
  tag
) {
  // we are only extracting raw values here.
  // validation and default values are handled in the child
  // component itself.
  var propOptions = Ctor.options.props;
  if (isUndef(propOptions)) {
    return
  }
  var res = {};
  var attrs = data.attrs;
  var props = data.props;
  if (isDef(attrs) || isDef(props)) {
    for (var key in propOptions) {
      var altKey = hyphenate(key);
      if (false) {
        var keyInLowerCase = key.toLowerCase();
        if (
          key !== keyInLowerCase &&
          attrs && hasOwn(attrs, keyInLowerCase)
        ) {
          tip(
            "Prop \"" + keyInLowerCase + "\" is passed to component " +
            (formatComponentName(tag || Ctor)) + ", but the declared prop name is" +
            " \"" + key + "\". " +
            "Note that HTML attributes are case-insensitive and camelCased " +
            "props need to use their kebab-case equivalents when using in-DOM " +
            "templates. You should probably use \"" + altKey + "\" instead of \"" + key + "\"."
          );
        }
      }
      checkProp(res, props, key, altKey, true) ||
      checkProp(res, attrs, key, altKey, false);
    }
  }
  return res
}

function checkProp (
  res,
  hash,
  key,
  altKey,
  preserve
) {
  if (isDef(hash)) {
    if (hasOwn(hash, key)) {
      res[key] = hash[key];
      if (!preserve) {
        delete hash[key];
      }
      return true
    } else if (hasOwn(hash, altKey)) {
      res[key] = hash[altKey];
      if (!preserve) {
        delete hash[altKey];
      }
      return true
    }
  }
  return false
}

/*  */

// The template compiler attempts to minimize the need for normalization by
// statically analyzing the template at compile time.
//
// For plain HTML markup, normalization can be completely skipped because the
// generated render function is guaranteed to return Array<VNode>. There are
// two cases where extra normalization is needed:

// 1. When the children contains components - because a functional component
// may return an Array instead of a single root. In this case, just a simple
// normalization is needed - if any child is an Array, we flatten the whole
// thing with Array.prototype.concat. It is guaranteed to be only 1-level deep
// because functional components already normalize their own children.
function simpleNormalizeChildren (children) {
  for (var i = 0; i < children.length; i++) {
    if (Array.isArray(children[i])) {
      return Array.prototype.concat.apply([], children)
    }
  }
  return children
}

// 2. When the children contains constructs that always generated nested Arrays,
// e.g. <template>, <slot>, v-for, or when the children is provided by user
// with hand-written render functions / JSX. In such cases a full normalization
// is needed to cater to all possible types of children values.
function normalizeChildren (children) {
  return isPrimitive(children)
    ? [createTextVNode(children)]
    : Array.isArray(children)
      ? normalizeArrayChildren(children)
      : undefined
}

function isTextNode (node) {
  return isDef(node) && isDef(node.text) && isFalse(node.isComment)
}

function normalizeArrayChildren (children, nestedIndex) {
  var res = [];
  var i, c, lastIndex, last;
  for (i = 0; i < children.length; i++) {
    c = children[i];
    if (isUndef(c) || typeof c === 'boolean') { continue }
    lastIndex = res.length - 1;
    last = res[lastIndex];
    //  nested
    if (Array.isArray(c)) {
      if (c.length > 0) {
        c = normalizeArrayChildren(c, ((nestedIndex || '') + "_" + i));
        // merge adjacent text nodes
        if (isTextNode(c[0]) && isTextNode(last)) {
          res[lastIndex] = createTextVNode(last.text + (c[0]).text);
          c.shift();
        }
        res.push.apply(res, c);
      }
    } else if (isPrimitive(c)) {
      if (isTextNode(last)) {
        // merge adjacent text nodes
        // this is necessary for SSR hydration because text nodes are
        // essentially merged when rendered to HTML strings
        res[lastIndex] = createTextVNode(last.text + c);
      } else if (c !== '') {
        // convert primitive to vnode
        res.push(createTextVNode(c));
      }
    } else {
      if (isTextNode(c) && isTextNode(last)) {
        // merge adjacent text nodes
        res[lastIndex] = createTextVNode(last.text + c.text);
      } else {
        // default key for nested array children (likely generated by v-for)
        if (isTrue(children._isVList) &&
          isDef(c.tag) &&
          isUndef(c.key) &&
          isDef(nestedIndex)) {
          c.key = "__vlist" + nestedIndex + "_" + i + "__";
        }
        res.push(c);
      }
    }
  }
  return res
}

/*  */

function initProvide (vm) {
  var provide = vm.$options.provide;
  if (provide) {
    vm._provided = typeof provide === 'function'
      ? provide.call(vm)
      : provide;
  }
}

function initInjections (vm) {
  var result = resolveInject(vm.$options.inject, vm);
  if (result) {
    toggleObserving(false);
    Object.keys(result).forEach(function (key) {
      /* istanbul ignore else */
      if (false) {
        defineReactive$$1(vm, key, result[key], function () {
          warn(
            "Avoid mutating an injected value directly since the changes will be " +
            "overwritten whenever the provided component re-renders. " +
            "injection being mutated: \"" + key + "\"",
            vm
          );
        });
      } else {
        defineReactive$$1(vm, key, result[key]);
      }
    });
    toggleObserving(true);
  }
}

function resolveInject (inject, vm) {
  if (inject) {
    // inject is :any because flow is not smart enough to figure out cached
    var result = Object.create(null);
    var keys = hasSymbol
      ? Reflect.ownKeys(inject)
      : Object.keys(inject);

    for (var i = 0; i < keys.length; i++) {
      var key = keys[i];
      // #6574 in case the inject object is observed...
      if (key === '__ob__') { continue }
      var provideKey = inject[key].from;
      var source = vm;
      while (source) {
        if (source._provided && hasOwn(source._provided, provideKey)) {
          result[key] = source._provided[provideKey];
          break
        }
        source = source.$parent;
      }
      if (!source) {
        if ('default' in inject[key]) {
          var provideDefault = inject[key].default;
          result[key] = typeof provideDefault === 'function'
            ? provideDefault.call(vm)
            : provideDefault;
        } else if (false) {
          warn(("Injection \"" + key + "\" not found"), vm);
        }
      }
    }
    return result
  }
}

/*  */



/**
 * Runtime helper for resolving raw children VNodes into a slot object.
 */
function resolveSlots (
  children,
  context
) {
  if (!children || !children.length) {
    return {}
  }
  var slots = {};
  for (var i = 0, l = children.length; i < l; i++) {
    var child = children[i];
    var data = child.data;
    // remove slot attribute if the node is resolved as a Vue slot node
    if (data && data.attrs && data.attrs.slot) {
      delete data.attrs.slot;
    }
    // named slots should only be respected if the vnode was rendered in the
    // same context.
    if ((child.context === context || child.fnContext === context) &&
      data && data.slot != null
    ) {
      var name = data.slot;
      var slot = (slots[name] || (slots[name] = []));
      if (child.tag === 'template') {
        slot.push.apply(slot, child.children || []);
      } else {
        slot.push(child);
      }
    } else {
      (slots.default || (slots.default = [])).push(child);
    }
  }
  // ignore slots that contains only whitespace
  for (var name$1 in slots) {
    if (slots[name$1].every(isWhitespace)) {
      delete slots[name$1];
    }
  }
  return slots
}

function isWhitespace (node) {
  return (node.isComment && !node.asyncFactory) || node.text === ' '
}

/*  */

function normalizeScopedSlots (
  slots,
  normalSlots,
  prevSlots
) {
  var res;
  var hasNormalSlots = Object.keys(normalSlots).length > 0;
  var isStable = slots ? !!slots.$stable : !hasNormalSlots;
  var key = slots && slots.$key;
  if (!slots) {
    res = {};
  } else if (slots._normalized) {
    // fast path 1: child component re-render only, parent did not change
    return slots._normalized
  } else if (
    isStable &&
    prevSlots &&
    prevSlots !== emptyObject &&
    key === prevSlots.$key &&
    !hasNormalSlots &&
    !prevSlots.$hasNormal
  ) {
    // fast path 2: stable scoped slots w/ no normal slots to proxy,
    // only need to normalize once
    return prevSlots
  } else {
    res = {};
    for (var key$1 in slots) {
      if (slots[key$1] && key$1[0] !== '$') {
        res[key$1] = normalizeScopedSlot(normalSlots, key$1, slots[key$1]);
      }
    }
  }
  // expose normal slots on scopedSlots
  for (var key$2 in normalSlots) {
    if (!(key$2 in res)) {
      res[key$2] = proxyNormalSlot(normalSlots, key$2);
    }
  }
  // avoriaz seems to mock a non-extensible $scopedSlots object
  // and when that is passed down this would cause an error
  if (slots && Object.isExtensible(slots)) {
    (slots)._normalized = res;
  }
  def(res, '$stable', isStable);
  def(res, '$key', key);
  def(res, '$hasNormal', hasNormalSlots);
  return res
}

function normalizeScopedSlot(normalSlots, key, fn) {
  var normalized = function () {
    var res = arguments.length ? fn.apply(null, arguments) : fn({});
    res = res && typeof res === 'object' && !Array.isArray(res)
      ? [res] // single vnode
      : normalizeChildren(res);
    return res && (
      res.length === 0 ||
      (res.length === 1 && res[0].isComment) // #9658
    ) ? undefined
      : res
  };
  // this is a slot using the new v-slot syntax without scope. although it is
  // compiled as a scoped slot, render fn users would expect it to be present
  // on this.$slots because the usage is semantically a normal slot.
  if (fn.proxy) {
    Object.defineProperty(normalSlots, key, {
      get: normalized,
      enumerable: true,
      configurable: true
    });
  }
  return normalized
}

function proxyNormalSlot(slots, key) {
  return function () { return slots[key]; }
}

/*  */

/**
 * Runtime helper for rendering v-for lists.
 */
function renderList (
  val,
  render
) {
  var ret, i, l, keys, key;
  if (Array.isArray(val) || typeof val === 'string') {
    ret = new Array(val.length);
    for (i = 0, l = val.length; i < l; i++) {
      ret[i] = render(val[i], i);
    }
  } else if (typeof val === 'number') {
    ret = new Array(val);
    for (i = 0; i < val; i++) {
      ret[i] = render(i + 1, i);
    }
  } else if (isObject(val)) {
    if (hasSymbol && val[Symbol.iterator]) {
      ret = [];
      var iterator = val[Symbol.iterator]();
      var result = iterator.next();
      while (!result.done) {
        ret.push(render(result.value, ret.length));
        result = iterator.next();
      }
    } else {
      keys = Object.keys(val);
      ret = new Array(keys.length);
      for (i = 0, l = keys.length; i < l; i++) {
        key = keys[i];
        ret[i] = render(val[key], key, i);
      }
    }
  }
  if (!isDef(ret)) {
    ret = [];
  }
  (ret)._isVList = true;
  return ret
}

/*  */

/**
 * Runtime helper for rendering <slot>
 */
function renderSlot (
  name,
  fallback,
  props,
  bindObject
) {
  var scopedSlotFn = this.$scopedSlots[name];
  var nodes;
  if (scopedSlotFn) { // scoped slot
    props = props || {};
    if (bindObject) {
      if (false) {
        warn(
          'slot v-bind without argument expects an Object',
          this
        );
      }
      props = extend(extend({}, bindObject), props);
    }
    nodes = scopedSlotFn(props) || fallback;
  } else {
    nodes = this.$slots[name] || fallback;
  }

  var target = props && props.slot;
  if (target) {
    return this.$createElement('template', { slot: target }, nodes)
  } else {
    return nodes
  }
}

/*  */

/**
 * Runtime helper for resolving filters
 */
function resolveFilter (id) {
  return resolveAsset(this.$options, 'filters', id, true) || identity
}

/*  */

function isKeyNotMatch (expect, actual) {
  if (Array.isArray(expect)) {
    return expect.indexOf(actual) === -1
  } else {
    return expect !== actual
  }
}

/**
 * Runtime helper for checking keyCodes from config.
 * exposed as Vue.prototype._k
 * passing in eventKeyName as last argument separately for backwards compat
 */
function checkKeyCodes (
  eventKeyCode,
  key,
  builtInKeyCode,
  eventKeyName,
  builtInKeyName
) {
  var mappedKeyCode = config.keyCodes[key] || builtInKeyCode;
  if (builtInKeyName && eventKeyName && !config.keyCodes[key]) {
    return isKeyNotMatch(builtInKeyName, eventKeyName)
  } else if (mappedKeyCode) {
    return isKeyNotMatch(mappedKeyCode, eventKeyCode)
  } else if (eventKeyName) {
    return hyphenate(eventKeyName) !== key
  }
}

/*  */

/**
 * Runtime helper for merging v-bind="object" into a VNode's data.
 */
function bindObjectProps (
  data,
  tag,
  value,
  asProp,
  isSync
) {
  if (value) {
    if (!isObject(value)) {
      "production" !== 'production' && warn(
        'v-bind without argument expects an Object or Array value',
        this
      );
    } else {
      if (Array.isArray(value)) {
        value = toObject(value);
      }
      var hash;
      var loop = function ( key ) {
        if (
          key === 'class' ||
          key === 'style' ||
          isReservedAttribute(key)
        ) {
          hash = data;
        } else {
          var type = data.attrs && data.attrs.type;
          hash = asProp || config.mustUseProp(tag, type, key)
            ? data.domProps || (data.domProps = {})
            : data.attrs || (data.attrs = {});
        }
        var camelizedKey = camelize(key);
        var hyphenatedKey = hyphenate(key);
        if (!(camelizedKey in hash) && !(hyphenatedKey in hash)) {
          hash[key] = value[key];

          if (isSync) {
            var on = data.on || (data.on = {});
            on[("update:" + key)] = function ($event) {
              value[key] = $event;
            };
          }
        }
      };

      for (var key in value) loop( key );
    }
  }
  return data
}

/*  */

/**
 * Runtime helper for rendering static trees.
 */
function renderStatic (
  index,
  isInFor
) {
  var cached = this._staticTrees || (this._staticTrees = []);
  var tree = cached[index];
  // if has already-rendered static tree and not inside v-for,
  // we can reuse the same tree.
  if (tree && !isInFor) {
    return tree
  }
  // otherwise, render a fresh tree.
  tree = cached[index] = this.$options.staticRenderFns[index].call(
    this._renderProxy,
    null,
    this // for render fns generated for functional component templates
  );
  markStatic(tree, ("__static__" + index), false);
  return tree
}

/**
 * Runtime helper for v-once.
 * Effectively it means marking the node as static with a unique key.
 */
function markOnce (
  tree,
  index,
  key
) {
  markStatic(tree, ("__once__" + index + (key ? ("_" + key) : "")), true);
  return tree
}

function markStatic (
  tree,
  key,
  isOnce
) {
  if (Array.isArray(tree)) {
    for (var i = 0; i < tree.length; i++) {
      if (tree[i] && typeof tree[i] !== 'string') {
        markStaticNode(tree[i], (key + "_" + i), isOnce);
      }
    }
  } else {
    markStaticNode(tree, key, isOnce);
  }
}

function markStaticNode (node, key, isOnce) {
  node.isStatic = true;
  node.key = key;
  node.isOnce = isOnce;
}

/*  */

function bindObjectListeners (data, value) {
  if (value) {
    if (!isPlainObject(value)) {
      "production" !== 'production' && warn(
        'v-on without argument expects an Object value',
        this
      );
    } else {
      var on = data.on = data.on ? extend({}, data.on) : {};
      for (var key in value) {
        var existing = on[key];
        var ours = value[key];
        on[key] = existing ? [].concat(existing, ours) : ours;
      }
    }
  }
  return data
}

/*  */

function resolveScopedSlots (
  fns, // see flow/vnode
  res,
  // the following are added in 2.6
  hasDynamicKeys,
  contentHashKey
) {
  res = res || { $stable: !hasDynamicKeys };
  for (var i = 0; i < fns.length; i++) {
    var slot = fns[i];
    if (Array.isArray(slot)) {
      resolveScopedSlots(slot, res, hasDynamicKeys);
    } else if (slot) {
      // marker for reverse proxying v-slot without scope on this.$slots
      if (slot.proxy) {
        slot.fn.proxy = true;
      }
      res[slot.key] = slot.fn;
    }
  }
  if (contentHashKey) {
    (res).$key = contentHashKey;
  }
  return res
}

/*  */

function bindDynamicKeys (baseObj, values) {
  for (var i = 0; i < values.length; i += 2) {
    var key = values[i];
    if (typeof key === 'string' && key) {
      baseObj[values[i]] = values[i + 1];
    } else if (false) {
      // null is a special value for explicitly removing a binding
      warn(
        ("Invalid value for dynamic directive argument (expected string or null): " + key),
        this
      );
    }
  }
  return baseObj
}

// helper to dynamically append modifier runtime markers to event names.
// ensure only append when value is already string, otherwise it will be cast
// to string and cause the type check to miss.
function prependModifier (value, symbol) {
  return typeof value === 'string' ? symbol + value : value
}

/*  */

function installRenderHelpers (target) {
  target._o = markOnce;
  target._n = toNumber;
  target._s = toString;
  target._l = renderList;
  target._t = renderSlot;
  target._q = looseEqual;
  target._i = looseIndexOf;
  target._m = renderStatic;
  target._f = resolveFilter;
  target._k = checkKeyCodes;
  target._b = bindObjectProps;
  target._v = createTextVNode;
  target._e = createEmptyVNode;
  target._u = resolveScopedSlots;
  target._g = bindObjectListeners;
  target._d = bindDynamicKeys;
  target._p = prependModifier;
}

/*  */

function FunctionalRenderContext (
  data,
  props,
  children,
  parent,
  Ctor
) {
  var this$1 = this;

  var options = Ctor.options;
  // ensure the createElement function in functional components
  // gets a unique context - this is necessary for correct named slot check
  var contextVm;
  if (hasOwn(parent, '_uid')) {
    contextVm = Object.create(parent);
    // $flow-disable-line
    contextVm._original = parent;
  } else {
    // the context vm passed in is a functional context as well.
    // in this case we want to make sure we are able to get a hold to the
    // real context instance.
    contextVm = parent;
    // $flow-disable-line
    parent = parent._original;
  }
  var isCompiled = isTrue(options._compiled);
  var needNormalization = !isCompiled;

  this.data = data;
  this.props = props;
  this.children = children;
  this.parent = parent;
  this.listeners = data.on || emptyObject;
  this.injections = resolveInject(options.inject, parent);
  this.slots = function () {
    if (!this$1.$slots) {
      normalizeScopedSlots(
        data.scopedSlots,
        this$1.$slots = resolveSlots(children, parent)
      );
    }
    return this$1.$slots
  };

  Object.defineProperty(this, 'scopedSlots', ({
    enumerable: true,
    get: function get () {
      return normalizeScopedSlots(data.scopedSlots, this.slots())
    }
  }));

  // support for compiled functional template
  if (isCompiled) {
    // exposing $options for renderStatic()
    this.$options = options;
    // pre-resolve slots for renderSlot()
    this.$slots = this.slots();
    this.$scopedSlots = normalizeScopedSlots(data.scopedSlots, this.$slots);
  }

  if (options._scopeId) {
    this._c = function (a, b, c, d) {
      var vnode = createElement(contextVm, a, b, c, d, needNormalization);
      if (vnode && !Array.isArray(vnode)) {
        vnode.fnScopeId = options._scopeId;
        vnode.fnContext = parent;
      }
      return vnode
    };
  } else {
    this._c = function (a, b, c, d) { return createElement(contextVm, a, b, c, d, needNormalization); };
  }
}

installRenderHelpers(FunctionalRenderContext.prototype);

function createFunctionalComponent (
  Ctor,
  propsData,
  data,
  contextVm,
  children
) {
  var options = Ctor.options;
  var props = {};
  var propOptions = options.props;
  if (isDef(propOptions)) {
    for (var key in propOptions) {
      props[key] = validateProp(key, propOptions, propsData || emptyObject);
    }
  } else {
    if (isDef(data.attrs)) { mergeProps(props, data.attrs); }
    if (isDef(data.props)) { mergeProps(props, data.props); }
  }

  var renderContext = new FunctionalRenderContext(
    data,
    props,
    children,
    contextVm,
    Ctor
  );

  var vnode = options.render.call(null, renderContext._c, renderContext);

  if (vnode instanceof VNode) {
    return cloneAndMarkFunctionalResult(vnode, data, renderContext.parent, options, renderContext)
  } else if (Array.isArray(vnode)) {
    var vnodes = normalizeChildren(vnode) || [];
    var res = new Array(vnodes.length);
    for (var i = 0; i < vnodes.length; i++) {
      res[i] = cloneAndMarkFunctionalResult(vnodes[i], data, renderContext.parent, options, renderContext);
    }
    return res
  }
}

function cloneAndMarkFunctionalResult (vnode, data, contextVm, options, renderContext) {
  // #7817 clone node before setting fnContext, otherwise if the node is reused
  // (e.g. it was from a cached normal slot) the fnContext causes named slots
  // that should not be matched to match.
  var clone = cloneVNode(vnode);
  clone.fnContext = contextVm;
  clone.fnOptions = options;
  if (false) {
    (clone.devtoolsMeta = clone.devtoolsMeta || {}).renderContext = renderContext;
  }
  if (data.slot) {
    (clone.data || (clone.data = {})).slot = data.slot;
  }
  return clone
}

function mergeProps (to, from) {
  for (var key in from) {
    to[camelize(key)] = from[key];
  }
}

/*  */

/*  */

/*  */

/*  */

// inline hooks to be invoked on component VNodes during patch
var componentVNodeHooks = {
  init: function init (vnode, hydrating) {
    if (
      vnode.componentInstance &&
      !vnode.componentInstance._isDestroyed &&
      vnode.data.keepAlive
    ) {
      // kept-alive components, treat as a patch
      var mountedNode = vnode; // work around flow
      componentVNodeHooks.prepatch(mountedNode, mountedNode);
    } else {
      var child = vnode.componentInstance = createComponentInstanceForVnode(
        vnode,
        activeInstance
      );
      child.$mount(hydrating ? vnode.elm : undefined, hydrating);
    }
  },

  prepatch: function prepatch (oldVnode, vnode) {
    var options = vnode.componentOptions;
    var child = vnode.componentInstance = oldVnode.componentInstance;
    updateChildComponent(
      child,
      options.propsData, // updated props
      options.listeners, // updated listeners
      vnode, // new parent vnode
      options.children // new children
    );
  },

  insert: function insert (vnode) {
    var context = vnode.context;
    var componentInstance = vnode.componentInstance;
    if (!componentInstance._isMounted) {
      componentInstance._isMounted = true;
      callHook(componentInstance, 'mounted');
    }
    if (vnode.data.keepAlive) {
      if (context._isMounted) {
        // vue-router#1212
        // During updates, a kept-alive component's child components may
        // change, so directly walking the tree here may call activated hooks
        // on incorrect children. Instead we push them into a queue which will
        // be processed after the whole patch process ended.
        queueActivatedComponent(componentInstance);
      } else {
        activateChildComponent(componentInstance, true /* direct */);
      }
    }
  },

  destroy: function destroy (vnode) {
    var componentInstance = vnode.componentInstance;
    if (!componentInstance._isDestroyed) {
      if (!vnode.data.keepAlive) {
        componentInstance.$destroy();
      } else {
        deactivateChildComponent(componentInstance, true /* direct */);
      }
    }
  }
};

var hooksToMerge = Object.keys(componentVNodeHooks);

function createComponent (
  Ctor,
  data,
  context,
  children,
  tag
) {
  if (isUndef(Ctor)) {
    return
  }

  var baseCtor = context.$options._base;

  // plain options object: turn it into a constructor
  if (isObject(Ctor)) {
    Ctor = baseCtor.extend(Ctor);
  }

  // if at this stage it's not a constructor or an async component factory,
  // reject.
  if (typeof Ctor !== 'function') {
    if (false) {
      warn(("Invalid Component definition: " + (String(Ctor))), context);
    }
    return
  }

  // async component
  var asyncFactory;
  if (isUndef(Ctor.cid)) {
    asyncFactory = Ctor;
    Ctor = resolveAsyncComponent(asyncFactory, baseCtor);
    if (Ctor === undefined) {
      // return a placeholder node for async component, which is rendered
      // as a comment node but preserves all the raw information for the node.
      // the information will be used for async server-rendering and hydration.
      return createAsyncPlaceholder(
        asyncFactory,
        data,
        context,
        children,
        tag
      )
    }
  }

  data = data || {};

  // resolve constructor options in case global mixins are applied after
  // component constructor creation
  resolveConstructorOptions(Ctor);

  // transform component v-model data into props & events
  if (isDef(data.model)) {
    transformModel(Ctor.options, data);
  }

  // extract props
  var propsData = extractPropsFromVNodeData(data, Ctor, tag);

  // functional component
  if (isTrue(Ctor.options.functional)) {
    return createFunctionalComponent(Ctor, propsData, data, context, children)
  }

  // extract listeners, since these needs to be treated as
  // child component listeners instead of DOM listeners
  var listeners = data.on;
  // replace with listeners with .native modifier
  // so it gets processed during parent component patch.
  data.on = data.nativeOn;

  if (isTrue(Ctor.options.abstract)) {
    // abstract components do not keep anything
    // other than props & listeners & slot

    // work around flow
    var slot = data.slot;
    data = {};
    if (slot) {
      data.slot = slot;
    }
  }

  // install component management hooks onto the placeholder node
  installComponentHooks(data);

  // return a placeholder vnode
  var name = Ctor.options.name || tag;
  var vnode = new VNode(
    ("vue-component-" + (Ctor.cid) + (name ? ("-" + name) : '')),
    data, undefined, undefined, undefined, context,
    { Ctor: Ctor, propsData: propsData, listeners: listeners, tag: tag, children: children },
    asyncFactory
  );

  return vnode
}

function createComponentInstanceForVnode (
  vnode, // we know it's MountedComponentVNode but flow doesn't
  parent // activeInstance in lifecycle state
) {
  var options = {
    _isComponent: true,
    _parentVnode: vnode,
    parent: parent
  };
  // check inline-template render functions
  var inlineTemplate = vnode.data.inlineTemplate;
  if (isDef(inlineTemplate)) {
    options.render = inlineTemplate.render;
    options.staticRenderFns = inlineTemplate.staticRenderFns;
  }
  return new vnode.componentOptions.Ctor(options)
}

function installComponentHooks (data) {
  var hooks = data.hook || (data.hook = {});
  for (var i = 0; i < hooksToMerge.length; i++) {
    var key = hooksToMerge[i];
    var existing = hooks[key];
    var toMerge = componentVNodeHooks[key];
    if (existing !== toMerge && !(existing && existing._merged)) {
      hooks[key] = existing ? mergeHook$1(toMerge, existing) : toMerge;
    }
  }
}

function mergeHook$1 (f1, f2) {
  var merged = function (a, b) {
    // flow complains about extra args which is why we use any
    f1(a, b);
    f2(a, b);
  };
  merged._merged = true;
  return merged
}

// transform component v-model info (value and callback) into
// prop and event handler respectively.
function transformModel (options, data) {
  var prop = (options.model && options.model.prop) || 'value';
  var event = (options.model && options.model.event) || 'input'
  ;(data.attrs || (data.attrs = {}))[prop] = data.model.value;
  var on = data.on || (data.on = {});
  var existing = on[event];
  var callback = data.model.callback;
  if (isDef(existing)) {
    if (
      Array.isArray(existing)
        ? existing.indexOf(callback) === -1
        : existing !== callback
    ) {
      on[event] = [callback].concat(existing);
    }
  } else {
    on[event] = callback;
  }
}

/*  */

var SIMPLE_NORMALIZE = 1;
var ALWAYS_NORMALIZE = 2;

// wrapper function for providing a more flexible interface
// without getting yelled at by flow
function createElement (
  context,
  tag,
  data,
  children,
  normalizationType,
  alwaysNormalize
) {
  if (Array.isArray(data) || isPrimitive(data)) {
    normalizationType = children;
    children = data;
    data = undefined;
  }
  if (isTrue(alwaysNormalize)) {
    normalizationType = ALWAYS_NORMALIZE;
  }
  return _createElement(context, tag, data, children, normalizationType)
}

function _createElement (
  context,
  tag,
  data,
  children,
  normalizationType
) {
  if (isDef(data) && isDef((data).__ob__)) {
    "production" !== 'production' && warn(
      "Avoid using observed data object as vnode data: " + (JSON.stringify(data)) + "\n" +
      'Always create fresh vnode data objects in each render!',
      context
    );
    return createEmptyVNode()
  }
  // object syntax in v-bind
  if (isDef(data) && isDef(data.is)) {
    tag = data.is;
  }
  if (!tag) {
    // in case of component :is set to falsy value
    return createEmptyVNode()
  }
  // warn against non-primitive key
  if (false
  ) {
    {
      warn(
        'Avoid using non-primitive value as key, ' +
        'use string/number value instead.',
        context
      );
    }
  }
  // support single function children as default scoped slot
  if (Array.isArray(children) &&
    typeof children[0] === 'function'
  ) {
    data = data || {};
    data.scopedSlots = { default: children[0] };
    children.length = 0;
  }
  if (normalizationType === ALWAYS_NORMALIZE) {
    children = normalizeChildren(children);
  } else if (normalizationType === SIMPLE_NORMALIZE) {
    children = simpleNormalizeChildren(children);
  }
  var vnode, ns;
  if (typeof tag === 'string') {
    var Ctor;
    ns = (context.$vnode && context.$vnode.ns) || config.getTagNamespace(tag);
    if (config.isReservedTag(tag)) {
      // platform built-in elements
      if (false) {
        warn(
          ("The .native modifier for v-on is only valid on components but it was used on <" + tag + ">."),
          context
        );
      }
      vnode = new VNode(
        config.parsePlatformTagName(tag), data, children,
        undefined, undefined, context
      );
    } else if ((!data || !data.pre) && isDef(Ctor = resolveAsset(context.$options, 'components', tag))) {
      // component
      vnode = createComponent(Ctor, data, context, children, tag);
    } else {
      // unknown or unlisted namespaced elements
      // check at runtime because it may get assigned a namespace when its
      // parent normalizes children
      vnode = new VNode(
        tag, data, children,
        undefined, undefined, context
      );
    }
  } else {
    // direct component options / constructor
    vnode = createComponent(tag, data, context, children);
  }
  if (Array.isArray(vnode)) {
    return vnode
  } else if (isDef(vnode)) {
    if (isDef(ns)) { applyNS(vnode, ns); }
    if (isDef(data)) { registerDeepBindings(data); }
    return vnode
  } else {
    return createEmptyVNode()
  }
}

function applyNS (vnode, ns, force) {
  vnode.ns = ns;
  if (vnode.tag === 'foreignObject') {
    // use default namespace inside foreignObject
    ns = undefined;
    force = true;
  }
  if (isDef(vnode.children)) {
    for (var i = 0, l = vnode.children.length; i < l; i++) {
      var child = vnode.children[i];
      if (isDef(child.tag) && (
        isUndef(child.ns) || (isTrue(force) && child.tag !== 'svg'))) {
        applyNS(child, ns, force);
      }
    }
  }
}

// ref #5318
// necessary to ensure parent re-render when deep bindings like :style and
// :class are used on slot nodes
function registerDeepBindings (data) {
  if (isObject(data.style)) {
    traverse(data.style);
  }
  if (isObject(data.class)) {
    traverse(data.class);
  }
}

/*  */

function initRender (vm) {
  vm._vnode = null; // the root of the child tree
  vm._staticTrees = null; // v-once cached trees
  var options = vm.$options;
  var parentVnode = vm.$vnode = options._parentVnode; // the placeholder node in parent tree
  var renderContext = parentVnode && parentVnode.context;
  vm.$slots = resolveSlots(options._renderChildren, renderContext);
  vm.$scopedSlots = emptyObject;
  // bind the createElement fn to this instance
  // so that we get proper render context inside it.
  // args order: tag, data, children, normalizationType, alwaysNormalize
  // internal version is used by render functions compiled from templates
  vm._c = function (a, b, c, d) { return createElement(vm, a, b, c, d, false); };
  // normalization is always applied for the public version, used in
  // user-written render functions.
  vm.$createElement = function (a, b, c, d) { return createElement(vm, a, b, c, d, true); };

  // $attrs & $listeners are exposed for easier HOC creation.
  // they need to be reactive so that HOCs using them are always updated
  var parentData = parentVnode && parentVnode.data;

  /* istanbul ignore else */
  if (false) {
    defineReactive$$1(vm, '$attrs', parentData && parentData.attrs || emptyObject, function () {
      !isUpdatingChildComponent && warn("$attrs is readonly.", vm);
    }, true);
    defineReactive$$1(vm, '$listeners', options._parentListeners || emptyObject, function () {
      !isUpdatingChildComponent && warn("$listeners is readonly.", vm);
    }, true);
  } else {
    defineReactive$$1(vm, '$attrs', parentData && parentData.attrs || emptyObject, null, true);
    defineReactive$$1(vm, '$listeners', options._parentListeners || emptyObject, null, true);
  }
}

var currentRenderingInstance = null;

function renderMixin (Vue) {
  // install runtime convenience helpers
  installRenderHelpers(Vue.prototype);

  Vue.prototype.$nextTick = function (fn) {
    return nextTick(fn, this)
  };

  Vue.prototype._render = function () {
    var vm = this;
    var ref = vm.$options;
    var render = ref.render;
    var _parentVnode = ref._parentVnode;

    if (_parentVnode) {
      vm.$scopedSlots = normalizeScopedSlots(
        _parentVnode.data.scopedSlots,
        vm.$slots,
        vm.$scopedSlots
      );
    }

    // set parent vnode. this allows render functions to have access
    // to the data on the placeholder node.
    vm.$vnode = _parentVnode;
    // render self
    var vnode;
    try {
      // There's no need to maintain a stack because all render fns are called
      // separately from one another. Nested component's render fns are called
      // when parent component is patched.
      currentRenderingInstance = vm;
      vnode = render.call(vm._renderProxy, vm.$createElement);
    } catch (e) {
      handleError(e, vm, "render");
      // return error render result,
      // or previous vnode to prevent render error causing blank component
      /* istanbul ignore else */
      if (false) {
        try {
          vnode = vm.$options.renderError.call(vm._renderProxy, vm.$createElement, e);
        } catch (e) {
          handleError(e, vm, "renderError");
          vnode = vm._vnode;
        }
      } else {
        vnode = vm._vnode;
      }
    } finally {
      currentRenderingInstance = null;
    }
    // if the returned array contains only a single node, allow it
    if (Array.isArray(vnode) && vnode.length === 1) {
      vnode = vnode[0];
    }
    // return empty vnode in case the render function errored out
    if (!(vnode instanceof VNode)) {
      if (false) {
        warn(
          'Multiple root nodes returned from render function. Render function ' +
          'should return a single root node.',
          vm
        );
      }
      vnode = createEmptyVNode();
    }
    // set parent
    vnode.parent = _parentVnode;
    return vnode
  };
}

/*  */

function ensureCtor (comp, base) {
  if (
    comp.__esModule ||
    (hasSymbol && comp[Symbol.toStringTag] === 'Module')
  ) {
    comp = comp.default;
  }
  return isObject(comp)
    ? base.extend(comp)
    : comp
}

function createAsyncPlaceholder (
  factory,
  data,
  context,
  children,
  tag
) {
  var node = createEmptyVNode();
  node.asyncFactory = factory;
  node.asyncMeta = { data: data, context: context, children: children, tag: tag };
  return node
}

function resolveAsyncComponent (
  factory,
  baseCtor
) {
  if (isTrue(factory.error) && isDef(factory.errorComp)) {
    return factory.errorComp
  }

  if (isDef(factory.resolved)) {
    return factory.resolved
  }

  var owner = currentRenderingInstance;
  if (owner && isDef(factory.owners) && factory.owners.indexOf(owner) === -1) {
    // already pending
    factory.owners.push(owner);
  }

  if (isTrue(factory.loading) && isDef(factory.loadingComp)) {
    return factory.loadingComp
  }

  if (owner && !isDef(factory.owners)) {
    var owners = factory.owners = [owner];
    var sync = true;
    var timerLoading = null;
    var timerTimeout = null

    ;(owner).$on('hook:destroyed', function () { return remove(owners, owner); });

    var forceRender = function (renderCompleted) {
      for (var i = 0, l = owners.length; i < l; i++) {
        (owners[i]).$forceUpdate();
      }

      if (renderCompleted) {
        owners.length = 0;
        if (timerLoading !== null) {
          clearTimeout(timerLoading);
          timerLoading = null;
        }
        if (timerTimeout !== null) {
          clearTimeout(timerTimeout);
          timerTimeout = null;
        }
      }
    };

    var resolve = once(function (res) {
      // cache resolved
      factory.resolved = ensureCtor(res, baseCtor);
      // invoke callbacks only if this is not a synchronous resolve
      // (async resolves are shimmed as synchronous during SSR)
      if (!sync) {
        forceRender(true);
      } else {
        owners.length = 0;
      }
    });

    var reject = once(function (reason) {
      "production" !== 'production' && warn(
        "Failed to resolve async component: " + (String(factory)) +
        (reason ? ("\nReason: " + reason) : '')
      );
      if (isDef(factory.errorComp)) {
        factory.error = true;
        forceRender(true);
      }
    });

    var res = factory(resolve, reject);

    if (isObject(res)) {
      if (isPromise(res)) {
        // () => Promise
        if (isUndef(factory.resolved)) {
          res.then(resolve, reject);
        }
      } else if (isPromise(res.component)) {
        res.component.then(resolve, reject);

        if (isDef(res.error)) {
          factory.errorComp = ensureCtor(res.error, baseCtor);
        }

        if (isDef(res.loading)) {
          factory.loadingComp = ensureCtor(res.loading, baseCtor);
          if (res.delay === 0) {
            factory.loading = true;
          } else {
            timerLoading = setTimeout(function () {
              timerLoading = null;
              if (isUndef(factory.resolved) && isUndef(factory.error)) {
                factory.loading = true;
                forceRender(false);
              }
            }, res.delay || 200);
          }
        }

        if (isDef(res.timeout)) {
          timerTimeout = setTimeout(function () {
            timerTimeout = null;
            if (isUndef(factory.resolved)) {
              reject(
                 false
                  ? ("timeout (" + (res.timeout) + "ms)")
                  : null
              );
            }
          }, res.timeout);
        }
      }
    }

    sync = false;
    // return in case resolved synchronously
    return factory.loading
      ? factory.loadingComp
      : factory.resolved
  }
}

/*  */

function isAsyncPlaceholder (node) {
  return node.isComment && node.asyncFactory
}

/*  */

function getFirstComponentChild (children) {
  if (Array.isArray(children)) {
    for (var i = 0; i < children.length; i++) {
      var c = children[i];
      if (isDef(c) && (isDef(c.componentOptions) || isAsyncPlaceholder(c))) {
        return c
      }
    }
  }
}

/*  */

/*  */

function initEvents (vm) {
  vm._events = Object.create(null);
  vm._hasHookEvent = false;
  // init parent attached events
  var listeners = vm.$options._parentListeners;
  if (listeners) {
    updateComponentListeners(vm, listeners);
  }
}

var target;

function add (event, fn) {
  target.$on(event, fn);
}

function remove$1 (event, fn) {
  target.$off(event, fn);
}

function createOnceHandler (event, fn) {
  var _target = target;
  return function onceHandler () {
    var res = fn.apply(null, arguments);
    if (res !== null) {
      _target.$off(event, onceHandler);
    }
  }
}

function updateComponentListeners (
  vm,
  listeners,
  oldListeners
) {
  target = vm;
  updateListeners(listeners, oldListeners || {}, add, remove$1, createOnceHandler, vm);
  target = undefined;
}

function eventsMixin (Vue) {
  var hookRE = /^hook:/;
  Vue.prototype.$on = function (event, fn) {
    var vm = this;
    if (Array.isArray(event)) {
      for (var i = 0, l = event.length; i < l; i++) {
        vm.$on(event[i], fn);
      }
    } else {
      (vm._events[event] || (vm._events[event] = [])).push(fn);
      // optimize hook:event cost by using a boolean flag marked at registration
      // instead of a hash lookup
      if (hookRE.test(event)) {
        vm._hasHookEvent = true;
      }
    }
    return vm
  };

  Vue.prototype.$once = function (event, fn) {
    var vm = this;
    function on () {
      vm.$off(event, on);
      fn.apply(vm, arguments);
    }
    on.fn = fn;
    vm.$on(event, on);
    return vm
  };

  Vue.prototype.$off = function (event, fn) {
    var vm = this;
    // all
    if (!arguments.length) {
      vm._events = Object.create(null);
      return vm
    }
    // array of events
    if (Array.isArray(event)) {
      for (var i$1 = 0, l = event.length; i$1 < l; i$1++) {
        vm.$off(event[i$1], fn);
      }
      return vm
    }
    // specific event
    var cbs = vm._events[event];
    if (!cbs) {
      return vm
    }
    if (!fn) {
      vm._events[event] = null;
      return vm
    }
    // specific handler
    var cb;
    var i = cbs.length;
    while (i--) {
      cb = cbs[i];
      if (cb === fn || cb.fn === fn) {
        cbs.splice(i, 1);
        break
      }
    }
    return vm
  };

  Vue.prototype.$emit = function (event) {
    var vm = this;
    if (false) {
      var lowerCaseEvent = event.toLowerCase();
      if (lowerCaseEvent !== event && vm._events[lowerCaseEvent]) {
        tip(
          "Event \"" + lowerCaseEvent + "\" is emitted in component " +
          (formatComponentName(vm)) + " but the handler is registered for \"" + event + "\". " +
          "Note that HTML attributes are case-insensitive and you cannot use " +
          "v-on to listen to camelCase events when using in-DOM templates. " +
          "You should probably use \"" + (hyphenate(event)) + "\" instead of \"" + event + "\"."
        );
      }
    }
    var cbs = vm._events[event];
    if (cbs) {
      cbs = cbs.length > 1 ? toArray(cbs) : cbs;
      var args = toArray(arguments, 1);
      var info = "event handler for \"" + event + "\"";
      for (var i = 0, l = cbs.length; i < l; i++) {
        invokeWithErrorHandling(cbs[i], vm, args, vm, info);
      }
    }
    return vm
  };
}

/*  */

var activeInstance = null;
var isUpdatingChildComponent = false;

function setActiveInstance(vm) {
  var prevActiveInstance = activeInstance;
  activeInstance = vm;
  return function () {
    activeInstance = prevActiveInstance;
  }
}

function initLifecycle (vm) {
  var options = vm.$options;

  // locate first non-abstract parent
  var parent = options.parent;
  if (parent && !options.abstract) {
    while (parent.$options.abstract && parent.$parent) {
      parent = parent.$parent;
    }
    parent.$children.push(vm);
  }

  vm.$parent = parent;
  vm.$root = parent ? parent.$root : vm;

  vm.$children = [];
  vm.$refs = {};

  vm._watcher = null;
  vm._inactive = null;
  vm._directInactive = false;
  vm._isMounted = false;
  vm._isDestroyed = false;
  vm._isBeingDestroyed = false;
}

function lifecycleMixin (Vue) {
  Vue.prototype._update = function (vnode, hydrating) {
    var vm = this;
    var prevEl = vm.$el;
    var prevVnode = vm._vnode;
    var restoreActiveInstance = setActiveInstance(vm);
    vm._vnode = vnode;
    // Vue.prototype.__patch__ is injected in entry points
    // based on the rendering backend used.
    if (!prevVnode) {
      // initial render
      vm.$el = vm.__patch__(vm.$el, vnode, hydrating, false /* removeOnly */);
    } else {
      // updates
      vm.$el = vm.__patch__(prevVnode, vnode);
    }
    restoreActiveInstance();
    // update __vue__ reference
    if (prevEl) {
      prevEl.__vue__ = null;
    }
    if (vm.$el) {
      vm.$el.__vue__ = vm;
    }
    // if parent is an HOC, update its $el as well
    if (vm.$vnode && vm.$parent && vm.$vnode === vm.$parent._vnode) {
      vm.$parent.$el = vm.$el;
    }
    // updated hook is called by the scheduler to ensure that children are
    // updated in a parent's updated hook.
  };

  Vue.prototype.$forceUpdate = function () {
    var vm = this;
    if (vm._watcher) {
      vm._watcher.update();
    }
  };

  Vue.prototype.$destroy = function () {
    var vm = this;
    if (vm._isBeingDestroyed) {
      return
    }
    callHook(vm, 'beforeDestroy');
    vm._isBeingDestroyed = true;
    // remove self from parent
    var parent = vm.$parent;
    if (parent && !parent._isBeingDestroyed && !vm.$options.abstract) {
      remove(parent.$children, vm);
    }
    // teardown watchers
    if (vm._watcher) {
      vm._watcher.teardown();
    }
    var i = vm._watchers.length;
    while (i--) {
      vm._watchers[i].teardown();
    }
    // remove reference from data ob
    // frozen object may not have observer.
    if (vm._data.__ob__) {
      vm._data.__ob__.vmCount--;
    }
    // call the last hook...
    vm._isDestroyed = true;
    // invoke destroy hooks on current rendered tree
    vm.__patch__(vm._vnode, null);
    // fire destroyed hook
    callHook(vm, 'destroyed');
    // turn off all instance listeners.
    vm.$off();
    // remove __vue__ reference
    if (vm.$el) {
      vm.$el.__vue__ = null;
    }
    // release circular reference (#6759)
    if (vm.$vnode) {
      vm.$vnode.parent = null;
    }
  };
}

function mountComponent (
  vm,
  el,
  hydrating
) {
  vm.$el = el;
  if (!vm.$options.render) {
    vm.$options.render = createEmptyVNode;
    if (false) {
      /* istanbul ignore if */
      if ((vm.$options.template && vm.$options.template.charAt(0) !== '#') ||
        vm.$options.el || el) {
        warn(
          'You are using the runtime-only build of Vue where the template ' +
          'compiler is not available. Either pre-compile the templates into ' +
          'render functions, or use the compiler-included build.',
          vm
        );
      } else {
        warn(
          'Failed to mount component: template or render function not defined.',
          vm
        );
      }
    }
  }
  callHook(vm, 'beforeMount');

  var updateComponent;
  /* istanbul ignore if */
  if (false) {
    updateComponent = function () {
      var name = vm._name;
      var id = vm._uid;
      var startTag = "vue-perf-start:" + id;
      var endTag = "vue-perf-end:" + id;

      mark(startTag);
      var vnode = vm._render();
      mark(endTag);
      measure(("vue " + name + " render"), startTag, endTag);

      mark(startTag);
      vm._update(vnode, hydrating);
      mark(endTag);
      measure(("vue " + name + " patch"), startTag, endTag);
    };
  } else {
    updateComponent = function () {
      vm._update(vm._render(), hydrating);
    };
  }

  // we set this to vm._watcher inside the watcher's constructor
  // since the watcher's initial patch may call $forceUpdate (e.g. inside child
  // component's mounted hook), which relies on vm._watcher being already defined
  new Watcher(vm, updateComponent, noop, {
    before: function before () {
      if (vm._isMounted && !vm._isDestroyed) {
        callHook(vm, 'beforeUpdate');
      }
    }
  }, true /* isRenderWatcher */);
  hydrating = false;

  // manually mounted instance, call mounted on self
  // mounted is called for render-created child components in its inserted hook
  if (vm.$vnode == null) {
    vm._isMounted = true;
    callHook(vm, 'mounted');
  }
  return vm
}

function updateChildComponent (
  vm,
  propsData,
  listeners,
  parentVnode,
  renderChildren
) {
  if (false) {
    isUpdatingChildComponent = true;
  }

  // determine whether component has slot children
  // we need to do this before overwriting $options._renderChildren.

  // check if there are dynamic scopedSlots (hand-written or compiled but with
  // dynamic slot names). Static scoped slots compiled from template has the
  // "$stable" marker.
  var newScopedSlots = parentVnode.data.scopedSlots;
  var oldScopedSlots = vm.$scopedSlots;
  var hasDynamicScopedSlot = !!(
    (newScopedSlots && !newScopedSlots.$stable) ||
    (oldScopedSlots !== emptyObject && !oldScopedSlots.$stable) ||
    (newScopedSlots && vm.$scopedSlots.$key !== newScopedSlots.$key)
  );

  // Any static slot children from the parent may have changed during parent's
  // update. Dynamic scoped slots may also have changed. In such cases, a forced
  // update is necessary to ensure correctness.
  var needsForceUpdate = !!(
    renderChildren ||               // has new static slots
    vm.$options._renderChildren ||  // has old static slots
    hasDynamicScopedSlot
  );

  vm.$options._parentVnode = parentVnode;
  vm.$vnode = parentVnode; // update vm's placeholder node without re-render

  if (vm._vnode) { // update child tree's parent
    vm._vnode.parent = parentVnode;
  }
  vm.$options._renderChildren = renderChildren;

  // update $attrs and $listeners hash
  // these are also reactive so they may trigger child update if the child
  // used them during render
  vm.$attrs = parentVnode.data.attrs || emptyObject;
  vm.$listeners = listeners || emptyObject;

  // update props
  if (propsData && vm.$options.props) {
    toggleObserving(false);
    var props = vm._props;
    var propKeys = vm.$options._propKeys || [];
    for (var i = 0; i < propKeys.length; i++) {
      var key = propKeys[i];
      var propOptions = vm.$options.props; // wtf flow?
      props[key] = validateProp(key, propOptions, propsData, vm);
    }
    toggleObserving(true);
    // keep a copy of raw propsData
    vm.$options.propsData = propsData;
  }

  // update listeners
  listeners = listeners || emptyObject;
  var oldListeners = vm.$options._parentListeners;
  vm.$options._parentListeners = listeners;
  updateComponentListeners(vm, listeners, oldListeners);

  // resolve slots + force update if has children
  if (needsForceUpdate) {
    vm.$slots = resolveSlots(renderChildren, parentVnode.context);
    vm.$forceUpdate();
  }

  if (false) {
    isUpdatingChildComponent = false;
  }
}

function isInInactiveTree (vm) {
  while (vm && (vm = vm.$parent)) {
    if (vm._inactive) { return true }
  }
  return false
}

function activateChildComponent (vm, direct) {
  if (direct) {
    vm._directInactive = false;
    if (isInInactiveTree(vm)) {
      return
    }
  } else if (vm._directInactive) {
    return
  }
  if (vm._inactive || vm._inactive === null) {
    vm._inactive = false;
    for (var i = 0; i < vm.$children.length; i++) {
      activateChildComponent(vm.$children[i]);
    }
    callHook(vm, 'activated');
  }
}

function deactivateChildComponent (vm, direct) {
  if (direct) {
    vm._directInactive = true;
    if (isInInactiveTree(vm)) {
      return
    }
  }
  if (!vm._inactive) {
    vm._inactive = true;
    for (var i = 0; i < vm.$children.length; i++) {
      deactivateChildComponent(vm.$children[i]);
    }
    callHook(vm, 'deactivated');
  }
}

function callHook (vm, hook) {
  // #7573 disable dep collection when invoking lifecycle hooks
  pushTarget();
  var handlers = vm.$options[hook];
  var info = hook + " hook";
  if (handlers) {
    for (var i = 0, j = handlers.length; i < j; i++) {
      invokeWithErrorHandling(handlers[i], vm, null, vm, info);
    }
  }
  if (vm._hasHookEvent) {
    vm.$emit('hook:' + hook);
  }
  popTarget();
}

/*  */

var MAX_UPDATE_COUNT = 100;

var queue = [];
var activatedChildren = [];
var has = {};
var circular = {};
var waiting = false;
var flushing = false;
var index = 0;

/**
 * Reset the scheduler's state.
 */
function resetSchedulerState () {
  index = queue.length = activatedChildren.length = 0;
  has = {};
  if (false) {
    circular = {};
  }
  waiting = flushing = false;
}

// Async edge case #6566 requires saving the timestamp when event listeners are
// attached. However, calling performance.now() has a perf overhead especially
// if the page has thousands of event listeners. Instead, we take a timestamp
// every time the scheduler flushes and use that for all event listeners
// attached during that flush.
var currentFlushTimestamp = 0;

// Async edge case fix requires storing an event listener's attach timestamp.
var getNow = Date.now;

// Determine what event timestamp the browser is using. Annoyingly, the
// timestamp can either be hi-res (relative to page load) or low-res
// (relative to UNIX epoch), so in order to compare time we have to use the
// same timestamp type when saving the flush timestamp.
// All IE versions use low-res event timestamps, and have problematic clock
// implementations (#9632)
if (inBrowser && !isIE) {
  var performance = window.performance;
  if (
    performance &&
    typeof performance.now === 'function' &&
    getNow() > document.createEvent('Event').timeStamp
  ) {
    // if the event timestamp, although evaluated AFTER the Date.now(), is
    // smaller than it, it means the event is using a hi-res timestamp,
    // and we need to use the hi-res version for event listener timestamps as
    // well.
    getNow = function () { return performance.now(); };
  }
}

/**
 * Flush both queues and run the watchers.
 */
function flushSchedulerQueue () {
  currentFlushTimestamp = getNow();
  flushing = true;
  var watcher, id;

  // Sort queue before flush.
  // This ensures that:
  // 1. Components are updated from parent to child. (because parent is always
  //    created before the child)
  // 2. A component's user watchers are run before its render watcher (because
  //    user watchers are created before the render watcher)
  // 3. If a component is destroyed during a parent component's watcher run,
  //    its watchers can be skipped.
  queue.sort(function (a, b) { return a.id - b.id; });

  // do not cache length because more watchers might be pushed
  // as we run existing watchers
  for (index = 0; index < queue.length; index++) {
    watcher = queue[index];
    if (watcher.before) {
      watcher.before();
    }
    id = watcher.id;
    has[id] = null;
    watcher.run();
    // in dev build, check and stop circular updates.
    if (false) {
      circular[id] = (circular[id] || 0) + 1;
      if (circular[id] > MAX_UPDATE_COUNT) {
        warn(
          'You may have an infinite update loop ' + (
            watcher.user
              ? ("in watcher with expression \"" + (watcher.expression) + "\"")
              : "in a component render function."
          ),
          watcher.vm
        );
        break
      }
    }
  }

  // keep copies of post queues before resetting state
  var activatedQueue = activatedChildren.slice();
  var updatedQueue = queue.slice();

  resetSchedulerState();

  // call component updated and activated hooks
  callActivatedHooks(activatedQueue);
  callUpdatedHooks(updatedQueue);

  // devtool hook
  /* istanbul ignore if */
  if (devtools && config.devtools) {
    devtools.emit('flush');
  }
}

function callUpdatedHooks (queue) {
  var i = queue.length;
  while (i--) {
    var watcher = queue[i];
    var vm = watcher.vm;
    if (vm._watcher === watcher && vm._isMounted && !vm._isDestroyed) {
      callHook(vm, 'updated');
    }
  }
}

/**
 * Queue a kept-alive component that was activated during patch.
 * The queue will be processed after the entire tree has been patched.
 */
function queueActivatedComponent (vm) {
  // setting _inactive to false here so that a render function can
  // rely on checking whether it's in an inactive tree (e.g. router-view)
  vm._inactive = false;
  activatedChildren.push(vm);
}

function callActivatedHooks (queue) {
  for (var i = 0; i < queue.length; i++) {
    queue[i]._inactive = true;
    activateChildComponent(queue[i], true /* true */);
  }
}

/**
 * Push a watcher into the watcher queue.
 * Jobs with duplicate IDs will be skipped unless it's
 * pushed when the queue is being flushed.
 */
function queueWatcher (watcher) {
  var id = watcher.id;
  if (has[id] == null) {
    has[id] = true;
    if (!flushing) {
      queue.push(watcher);
    } else {
      // if already flushing, splice the watcher based on its id
      // if already past its id, it will be run next immediately.
      var i = queue.length - 1;
      while (i > index && queue[i].id > watcher.id) {
        i--;
      }
      queue.splice(i + 1, 0, watcher);
    }
    // queue the flush
    if (!waiting) {
      waiting = true;

      if (false) {
        flushSchedulerQueue();
        return
      }
      nextTick(flushSchedulerQueue);
    }
  }
}

/*  */



var uid$2 = 0;

/**
 * A watcher parses an expression, collects dependencies,
 * and fires callback when the expression value changes.
 * This is used for both the $watch() api and directives.
 */
var Watcher = function Watcher (
  vm,
  expOrFn,
  cb,
  options,
  isRenderWatcher
) {
  this.vm = vm;
  if (isRenderWatcher) {
    vm._watcher = this;
  }
  vm._watchers.push(this);
  // options
  if (options) {
    this.deep = !!options.deep;
    this.user = !!options.user;
    this.lazy = !!options.lazy;
    this.sync = !!options.sync;
    this.before = options.before;
  } else {
    this.deep = this.user = this.lazy = this.sync = false;
  }
  this.cb = cb;
  this.id = ++uid$2; // uid for batching
  this.active = true;
  this.dirty = this.lazy; // for lazy watchers
  this.deps = [];
  this.newDeps = [];
  this.depIds = new _Set();
  this.newDepIds = new _Set();
  this.expression =  false
    ? expOrFn.toString()
    : '';
  // parse expression for getter
  if (typeof expOrFn === 'function') {
    this.getter = expOrFn;
  } else {
    this.getter = parsePath(expOrFn);
    if (!this.getter) {
      this.getter = noop;
      "production" !== 'production' && warn(
        "Failed watching path: \"" + expOrFn + "\" " +
        'Watcher only accepts simple dot-delimited paths. ' +
        'For full control, use a function instead.',
        vm
      );
    }
  }
  this.value = this.lazy
    ? undefined
    : this.get();
};

/**
 * Evaluate the getter, and re-collect dependencies.
 */
Watcher.prototype.get = function get () {
  pushTarget(this);
  var value;
  var vm = this.vm;
  try {
    value = this.getter.call(vm, vm);
  } catch (e) {
    if (this.user) {
      handleError(e, vm, ("getter for watcher \"" + (this.expression) + "\""));
    } else {
      throw e
    }
  } finally {
    // "touch" every property so they are all tracked as
    // dependencies for deep watching
    if (this.deep) {
      traverse(value);
    }
    popTarget();
    this.cleanupDeps();
  }
  return value
};

/**
 * Add a dependency to this directive.
 */
Watcher.prototype.addDep = function addDep (dep) {
  var id = dep.id;
  if (!this.newDepIds.has(id)) {
    this.newDepIds.add(id);
    this.newDeps.push(dep);
    if (!this.depIds.has(id)) {
      dep.addSub(this);
    }
  }
};

/**
 * Clean up for dependency collection.
 */
Watcher.prototype.cleanupDeps = function cleanupDeps () {
  var i = this.deps.length;
  while (i--) {
    var dep = this.deps[i];
    if (!this.newDepIds.has(dep.id)) {
      dep.removeSub(this);
    }
  }
  var tmp = this.depIds;
  this.depIds = this.newDepIds;
  this.newDepIds = tmp;
  this.newDepIds.clear();
  tmp = this.deps;
  this.deps = this.newDeps;
  this.newDeps = tmp;
  this.newDeps.length = 0;
};

/**
 * Subscriber interface.
 * Will be called when a dependency changes.
 */
Watcher.prototype.update = function update () {
  /* istanbul ignore else */
  if (this.lazy) {
    this.dirty = true;
  } else if (this.sync) {
    this.run();
  } else {
    queueWatcher(this);
  }
};

/**
 * Scheduler job interface.
 * Will be called by the scheduler.
 */
Watcher.prototype.run = function run () {
  if (this.active) {
    var value = this.get();
    if (
      value !== this.value ||
      // Deep watchers and watchers on Object/Arrays should fire even
      // when the value is the same, because the value may
      // have mutated.
      isObject(value) ||
      this.deep
    ) {
      // set new value
      var oldValue = this.value;
      this.value = value;
      if (this.user) {
        try {
          this.cb.call(this.vm, value, oldValue);
        } catch (e) {
          handleError(e, this.vm, ("callback for watcher \"" + (this.expression) + "\""));
        }
      } else {
        this.cb.call(this.vm, value, oldValue);
      }
    }
  }
};

/**
 * Evaluate the value of the watcher.
 * This only gets called for lazy watchers.
 */
Watcher.prototype.evaluate = function evaluate () {
  this.value = this.get();
  this.dirty = false;
};

/**
 * Depend on all deps collected by this watcher.
 */
Watcher.prototype.depend = function depend () {
  var i = this.deps.length;
  while (i--) {
    this.deps[i].depend();
  }
};

/**
 * Remove self from all dependencies' subscriber list.
 */
Watcher.prototype.teardown = function teardown () {
  if (this.active) {
    // remove self from vm's watcher list
    // this is a somewhat expensive operation so we skip it
    // if the vm is being destroyed.
    if (!this.vm._isBeingDestroyed) {
      remove(this.vm._watchers, this);
    }
    var i = this.deps.length;
    while (i--) {
      this.deps[i].removeSub(this);
    }
    this.active = false;
  }
};

/*  */

var sharedPropertyDefinition = {
  enumerable: true,
  configurable: true,
  get: noop,
  set: noop
};

function proxy (target, sourceKey, key) {
  sharedPropertyDefinition.get = function proxyGetter () {
    return this[sourceKey][key]
  };
  sharedPropertyDefinition.set = function proxySetter (val) {
    this[sourceKey][key] = val;
  };
  Object.defineProperty(target, key, sharedPropertyDefinition);
}

function initState (vm) {
  vm._watchers = [];
  var opts = vm.$options;
  if (opts.props) { initProps(vm, opts.props); }
  if (opts.methods) { initMethods(vm, opts.methods); }
  if (opts.data) {
    initData(vm);
  } else {
    observe(vm._data = {}, true /* asRootData */);
  }
  if (opts.computed) { initComputed(vm, opts.computed); }
  if (opts.watch && opts.watch !== nativeWatch) {
    initWatch(vm, opts.watch);
  }
}

function initProps (vm, propsOptions) {
  var propsData = vm.$options.propsData || {};
  var props = vm._props = {};
  // cache prop keys so that future props updates can iterate using Array
  // instead of dynamic object key enumeration.
  var keys = vm.$options._propKeys = [];
  var isRoot = !vm.$parent;
  // root instance props should be converted
  if (!isRoot) {
    toggleObserving(false);
  }
  var loop = function ( key ) {
    keys.push(key);
    var value = validateProp(key, propsOptions, propsData, vm);
    /* istanbul ignore else */
    if (false) {
      var hyphenatedKey = hyphenate(key);
      if (isReservedAttribute(hyphenatedKey) ||
          config.isReservedAttr(hyphenatedKey)) {
        warn(
          ("\"" + hyphenatedKey + "\" is a reserved attribute and cannot be used as component prop."),
          vm
        );
      }
      defineReactive$$1(props, key, value, function () {
        if (!isRoot && !isUpdatingChildComponent) {
          warn(
            "Avoid mutating a prop directly since the value will be " +
            "overwritten whenever the parent component re-renders. " +
            "Instead, use a data or computed property based on the prop's " +
            "value. Prop being mutated: \"" + key + "\"",
            vm
          );
        }
      });
    } else {
      defineReactive$$1(props, key, value);
    }
    // static props are already proxied on the component's prototype
    // during Vue.extend(). We only need to proxy props defined at
    // instantiation here.
    if (!(key in vm)) {
      proxy(vm, "_props", key);
    }
  };

  for (var key in propsOptions) loop( key );
  toggleObserving(true);
}

function initData (vm) {
  var data = vm.$options.data;
  data = vm._data = typeof data === 'function'
    ? getData(data, vm)
    : data || {};
  if (!isPlainObject(data)) {
    data = {};
    "production" !== 'production' && warn(
      'data functions should return an object:\n' +
      'https://vuejs.org/v2/guide/components.html#data-Must-Be-a-Function',
      vm
    );
  }
  // proxy data on instance
  var keys = Object.keys(data);
  var props = vm.$options.props;
  var methods = vm.$options.methods;
  var i = keys.length;
  while (i--) {
    var key = keys[i];
    if (false) {
      if (methods && hasOwn(methods, key)) {
        warn(
          ("Method \"" + key + "\" has already been defined as a data property."),
          vm
        );
      }
    }
    if (props && hasOwn(props, key)) {
      "production" !== 'production' && warn(
        "The data property \"" + key + "\" is already declared as a prop. " +
        "Use prop default value instead.",
        vm
      );
    } else if (!isReserved(key)) {
      proxy(vm, "_data", key);
    }
  }
  // observe data
  observe(data, true /* asRootData */);
}

function getData (data, vm) {
  // #7573 disable dep collection when invoking data getters
  pushTarget();
  try {
    return data.call(vm, vm)
  } catch (e) {
    handleError(e, vm, "data()");
    return {}
  } finally {
    popTarget();
  }
}

var computedWatcherOptions = { lazy: true };

function initComputed (vm, computed) {
  // $flow-disable-line
  var watchers = vm._computedWatchers = Object.create(null);
  // computed properties are just getters during SSR
  var isSSR = isServerRendering();

  for (var key in computed) {
    var userDef = computed[key];
    var getter = typeof userDef === 'function' ? userDef : userDef.get;
    if (false) {
      warn(
        ("Getter is missing for computed property \"" + key + "\"."),
        vm
      );
    }

    if (!isSSR) {
      // create internal watcher for the computed property.
      watchers[key] = new Watcher(
        vm,
        getter || noop,
        noop,
        computedWatcherOptions
      );
    }

    // component-defined computed properties are already defined on the
    // component prototype. We only need to define computed properties defined
    // at instantiation here.
    if (!(key in vm)) {
      defineComputed(vm, key, userDef);
    } else if (false) {
      if (key in vm.$data) {
        warn(("The computed property \"" + key + "\" is already defined in data."), vm);
      } else if (vm.$options.props && key in vm.$options.props) {
        warn(("The computed property \"" + key + "\" is already defined as a prop."), vm);
      }
    }
  }
}

function defineComputed (
  target,
  key,
  userDef
) {
  var shouldCache = !isServerRendering();
  if (typeof userDef === 'function') {
    sharedPropertyDefinition.get = shouldCache
      ? createComputedGetter(key)
      : createGetterInvoker(userDef);
    sharedPropertyDefinition.set = noop;
  } else {
    sharedPropertyDefinition.get = userDef.get
      ? shouldCache && userDef.cache !== false
        ? createComputedGetter(key)
        : createGetterInvoker(userDef.get)
      : noop;
    sharedPropertyDefinition.set = userDef.set || noop;
  }
  if (false) {
    sharedPropertyDefinition.set = function () {
      warn(
        ("Computed property \"" + key + "\" was assigned to but it has no setter."),
        this
      );
    };
  }
  Object.defineProperty(target, key, sharedPropertyDefinition);
}

function createComputedGetter (key) {
  return function computedGetter () {
    var watcher = this._computedWatchers && this._computedWatchers[key];
    if (watcher) {
      if (watcher.dirty) {
        watcher.evaluate();
      }
      if (Dep.target) {
        watcher.depend();
      }
      return watcher.value
    }
  }
}

function createGetterInvoker(fn) {
  return function computedGetter () {
    return fn.call(this, this)
  }
}

function initMethods (vm, methods) {
  var props = vm.$options.props;
  for (var key in methods) {
    if (false) {
      if (typeof methods[key] !== 'function') {
        warn(
          "Method \"" + key + "\" has type \"" + (typeof methods[key]) + "\" in the component definition. " +
          "Did you reference the function correctly?",
          vm
        );
      }
      if (props && hasOwn(props, key)) {
        warn(
          ("Method \"" + key + "\" has already been defined as a prop."),
          vm
        );
      }
      if ((key in vm) && isReserved(key)) {
        warn(
          "Method \"" + key + "\" conflicts with an existing Vue instance method. " +
          "Avoid defining component methods that start with _ or $."
        );
      }
    }
    vm[key] = typeof methods[key] !== 'function' ? noop : bind(methods[key], vm);
  }
}

function initWatch (vm, watch) {
  for (var key in watch) {
    var handler = watch[key];
    if (Array.isArray(handler)) {
      for (var i = 0; i < handler.length; i++) {
        createWatcher(vm, key, handler[i]);
      }
    } else {
      createWatcher(vm, key, handler);
    }
  }
}

function createWatcher (
  vm,
  expOrFn,
  handler,
  options
) {
  if (isPlainObject(handler)) {
    options = handler;
    handler = handler.handler;
  }
  if (typeof handler === 'string') {
    handler = vm[handler];
  }
  return vm.$watch(expOrFn, handler, options)
}

function stateMixin (Vue) {
  // flow somehow has problems with directly declared definition object
  // when using Object.defineProperty, so we have to procedurally build up
  // the object here.
  var dataDef = {};
  dataDef.get = function () { return this._data };
  var propsDef = {};
  propsDef.get = function () { return this._props };
  if (false) {
    dataDef.set = function () {
      warn(
        'Avoid replacing instance root $data. ' +
        'Use nested data properties instead.',
        this
      );
    };
    propsDef.set = function () {
      warn("$props is readonly.", this);
    };
  }
  Object.defineProperty(Vue.prototype, '$data', dataDef);
  Object.defineProperty(Vue.prototype, '$props', propsDef);

  Vue.prototype.$set = set;
  Vue.prototype.$delete = del;

  Vue.prototype.$watch = function (
    expOrFn,
    cb,
    options
  ) {
    var vm = this;
    if (isPlainObject(cb)) {
      return createWatcher(vm, expOrFn, cb, options)
    }
    options = options || {};
    options.user = true;
    var watcher = new Watcher(vm, expOrFn, cb, options);
    if (options.immediate) {
      try {
        cb.call(vm, watcher.value);
      } catch (error) {
        handleError(error, vm, ("callback for immediate watcher \"" + (watcher.expression) + "\""));
      }
    }
    return function unwatchFn () {
      watcher.teardown();
    }
  };
}

/*  */

var uid$3 = 0;

function initMixin (Vue) {
  Vue.prototype._init = function (options) {
    var vm = this;
    // a uid
    vm._uid = uid$3++;

    var startTag, endTag;
    /* istanbul ignore if */
    if (false) {
      startTag = "vue-perf-start:" + (vm._uid);
      endTag = "vue-perf-end:" + (vm._uid);
      mark(startTag);
    }

    // a flag to avoid this being observed
    vm._isVue = true;
    // merge options
    if (options && options._isComponent) {
      // optimize internal component instantiation
      // since dynamic options merging is pretty slow, and none of the
      // internal component options needs special treatment.
      initInternalComponent(vm, options);
    } else {
      vm.$options = mergeOptions(
        resolveConstructorOptions(vm.constructor),
        options || {},
        vm
      );
    }
    /* istanbul ignore else */
    if (false) {
      initProxy(vm);
    } else {
      vm._renderProxy = vm;
    }
    // expose real self
    vm._self = vm;
    initLifecycle(vm);
    initEvents(vm);
    initRender(vm);
    callHook(vm, 'beforeCreate');
    initInjections(vm); // resolve injections before data/props
    initState(vm);
    initProvide(vm); // resolve provide after data/props
    callHook(vm, 'created');

    /* istanbul ignore if */
    if (false) {
      vm._name = formatComponentName(vm, false);
      mark(endTag);
      measure(("vue " + (vm._name) + " init"), startTag, endTag);
    }

    if (vm.$options.el) {
      vm.$mount(vm.$options.el);
    }
  };
}

function initInternalComponent (vm, options) {
  var opts = vm.$options = Object.create(vm.constructor.options);
  // doing this because it's faster than dynamic enumeration.
  var parentVnode = options._parentVnode;
  opts.parent = options.parent;
  opts._parentVnode = parentVnode;

  var vnodeComponentOptions = parentVnode.componentOptions;
  opts.propsData = vnodeComponentOptions.propsData;
  opts._parentListeners = vnodeComponentOptions.listeners;
  opts._renderChildren = vnodeComponentOptions.children;
  opts._componentTag = vnodeComponentOptions.tag;

  if (options.render) {
    opts.render = options.render;
    opts.staticRenderFns = options.staticRenderFns;
  }
}

function resolveConstructorOptions (Ctor) {
  var options = Ctor.options;
  if (Ctor.super) {
    var superOptions = resolveConstructorOptions(Ctor.super);
    var cachedSuperOptions = Ctor.superOptions;
    if (superOptions !== cachedSuperOptions) {
      // super option changed,
      // need to resolve new options.
      Ctor.superOptions = superOptions;
      // check if there are any late-modified/attached options (#4976)
      var modifiedOptions = resolveModifiedOptions(Ctor);
      // update base extend options
      if (modifiedOptions) {
        extend(Ctor.extendOptions, modifiedOptions);
      }
      options = Ctor.options = mergeOptions(superOptions, Ctor.extendOptions);
      if (options.name) {
        options.components[options.name] = Ctor;
      }
    }
  }
  return options
}

function resolveModifiedOptions (Ctor) {
  var modified;
  var latest = Ctor.options;
  var sealed = Ctor.sealedOptions;
  for (var key in latest) {
    if (latest[key] !== sealed[key]) {
      if (!modified) { modified = {}; }
      modified[key] = latest[key];
    }
  }
  return modified
}

function Vue (options) {
  if (false
  ) {
    warn('Vue is a constructor and should be called with the `new` keyword');
  }
  this._init(options);
}

initMixin(Vue);
stateMixin(Vue);
eventsMixin(Vue);
lifecycleMixin(Vue);
renderMixin(Vue);

/*  */

function initUse (Vue) {
  Vue.use = function (plugin) {
    var installedPlugins = (this._installedPlugins || (this._installedPlugins = []));
    if (installedPlugins.indexOf(plugin) > -1) {
      return this
    }

    // additional parameters
    var args = toArray(arguments, 1);
    args.unshift(this);
    if (typeof plugin.install === 'function') {
      plugin.install.apply(plugin, args);
    } else if (typeof plugin === 'function') {
      plugin.apply(null, args);
    }
    installedPlugins.push(plugin);
    return this
  };
}

/*  */

function initMixin$1 (Vue) {
  Vue.mixin = function (mixin) {
    this.options = mergeOptions(this.options, mixin);
    return this
  };
}

/*  */

function initExtend (Vue) {
  /**
   * Each instance constructor, including Vue, has a unique
   * cid. This enables us to create wrapped "child
   * constructors" for prototypal inheritance and cache them.
   */
  Vue.cid = 0;
  var cid = 1;

  /**
   * Class inheritance
   */
  Vue.extend = function (extendOptions) {
    extendOptions = extendOptions || {};
    var Super = this;
    var SuperId = Super.cid;
    var cachedCtors = extendOptions._Ctor || (extendOptions._Ctor = {});
    if (cachedCtors[SuperId]) {
      return cachedCtors[SuperId]
    }

    var name = extendOptions.name || Super.options.name;
    if (false) {
      validateComponentName(name);
    }

    var Sub = function VueComponent (options) {
      this._init(options);
    };
    Sub.prototype = Object.create(Super.prototype);
    Sub.prototype.constructor = Sub;
    Sub.cid = cid++;
    Sub.options = mergeOptions(
      Super.options,
      extendOptions
    );
    Sub['super'] = Super;

    // For props and computed properties, we define the proxy getters on
    // the Vue instances at extension time, on the extended prototype. This
    // avoids Object.defineProperty calls for each instance created.
    if (Sub.options.props) {
      initProps$1(Sub);
    }
    if (Sub.options.computed) {
      initComputed$1(Sub);
    }

    // allow further extension/mixin/plugin usage
    Sub.extend = Super.extend;
    Sub.mixin = Super.mixin;
    Sub.use = Super.use;

    // create asset registers, so extended classes
    // can have their private assets too.
    ASSET_TYPES.forEach(function (type) {
      Sub[type] = Super[type];
    });
    // enable recursive self-lookup
    if (name) {
      Sub.options.components[name] = Sub;
    }

    // keep a reference to the super options at extension time.
    // later at instantiation we can check if Super's options have
    // been updated.
    Sub.superOptions = Super.options;
    Sub.extendOptions = extendOptions;
    Sub.sealedOptions = extend({}, Sub.options);

    // cache constructor
    cachedCtors[SuperId] = Sub;
    return Sub
  };
}

function initProps$1 (Comp) {
  var props = Comp.options.props;
  for (var key in props) {
    proxy(Comp.prototype, "_props", key);
  }
}

function initComputed$1 (Comp) {
  var computed = Comp.options.computed;
  for (var key in computed) {
    defineComputed(Comp.prototype, key, computed[key]);
  }
}

/*  */

function initAssetRegisters (Vue) {
  /**
   * Create asset registration methods.
   */
  ASSET_TYPES.forEach(function (type) {
    Vue[type] = function (
      id,
      definition
    ) {
      if (!definition) {
        return this.options[type + 's'][id]
      } else {
        /* istanbul ignore if */
        if (false) {
          validateComponentName(id);
        }
        if (type === 'component' && isPlainObject(definition)) {
          definition.name = definition.name || id;
          definition = this.options._base.extend(definition);
        }
        if (type === 'directive' && typeof definition === 'function') {
          definition = { bind: definition, update: definition };
        }
        this.options[type + 's'][id] = definition;
        return definition
      }
    };
  });
}

/*  */



function getComponentName (opts) {
  return opts && (opts.Ctor.options.name || opts.tag)
}

function matches (pattern, name) {
  if (Array.isArray(pattern)) {
    return pattern.indexOf(name) > -1
  } else if (typeof pattern === 'string') {
    return pattern.split(',').indexOf(name) > -1
  } else if (isRegExp(pattern)) {
    return pattern.test(name)
  }
  /* istanbul ignore next */
  return false
}

function pruneCache (keepAliveInstance, filter) {
  var cache = keepAliveInstance.cache;
  var keys = keepAliveInstance.keys;
  var _vnode = keepAliveInstance._vnode;
  for (var key in cache) {
    var cachedNode = cache[key];
    if (cachedNode) {
      var name = getComponentName(cachedNode.componentOptions);
      if (name && !filter(name)) {
        pruneCacheEntry(cache, key, keys, _vnode);
      }
    }
  }
}

function pruneCacheEntry (
  cache,
  key,
  keys,
  current
) {
  var cached$$1 = cache[key];
  if (cached$$1 && (!current || cached$$1.tag !== current.tag)) {
    cached$$1.componentInstance.$destroy();
  }
  cache[key] = null;
  remove(keys, key);
}

var patternTypes = [String, RegExp, Array];

var KeepAlive = {
  name: 'keep-alive',
  abstract: true,

  props: {
    include: patternTypes,
    exclude: patternTypes,
    max: [String, Number]
  },

  created: function created () {
    this.cache = Object.create(null);
    this.keys = [];
  },

  destroyed: function destroyed () {
    for (var key in this.cache) {
      pruneCacheEntry(this.cache, key, this.keys);
    }
  },

  mounted: function mounted () {
    var this$1 = this;

    this.$watch('include', function (val) {
      pruneCache(this$1, function (name) { return matches(val, name); });
    });
    this.$watch('exclude', function (val) {
      pruneCache(this$1, function (name) { return !matches(val, name); });
    });
  },

  render: function render () {
    var slot = this.$slots.default;
    var vnode = getFirstComponentChild(slot);
    var componentOptions = vnode && vnode.componentOptions;
    if (componentOptions) {
      // check pattern
      var name = getComponentName(componentOptions);
      var ref = this;
      var include = ref.include;
      var exclude = ref.exclude;
      if (
        // not included
        (include && (!name || !matches(include, name))) ||
        // excluded
        (exclude && name && matches(exclude, name))
      ) {
        return vnode
      }

      var ref$1 = this;
      var cache = ref$1.cache;
      var keys = ref$1.keys;
      var key = vnode.key == null
        // same constructor may get registered as different local components
        // so cid alone is not enough (#3269)
        ? componentOptions.Ctor.cid + (componentOptions.tag ? ("::" + (componentOptions.tag)) : '')
        : vnode.key;
      if (cache[key]) {
        vnode.componentInstance = cache[key].componentInstance;
        // make current key freshest
        remove(keys, key);
        keys.push(key);
      } else {
        cache[key] = vnode;
        keys.push(key);
        // prune oldest entry
        if (this.max && keys.length > parseInt(this.max)) {
          pruneCacheEntry(cache, keys[0], keys, this._vnode);
        }
      }

      vnode.data.keepAlive = true;
    }
    return vnode || (slot && slot[0])
  }
};

var builtInComponents = {
  KeepAlive: KeepAlive
};

/*  */

function initGlobalAPI (Vue) {
  // config
  var configDef = {};
  configDef.get = function () { return config; };
  if (false) {
    configDef.set = function () {
      warn(
        'Do not replace the Vue.config object, set individual fields instead.'
      );
    };
  }
  Object.defineProperty(Vue, 'config', configDef);

  // exposed util methods.
  // NOTE: these are not considered part of the public API - avoid relying on
  // them unless you are aware of the risk.
  Vue.util = {
    warn: warn,
    extend: extend,
    mergeOptions: mergeOptions,
    defineReactive: defineReactive$$1
  };

  Vue.set = set;
  Vue.delete = del;
  Vue.nextTick = nextTick;

  // 2.6 explicit observable API
  Vue.observable = function (obj) {
    observe(obj);
    return obj
  };

  Vue.options = Object.create(null);
  ASSET_TYPES.forEach(function (type) {
    Vue.options[type + 's'] = Object.create(null);
  });

  // this is used to identify the "base" constructor to extend all plain-object
  // components with in Weex's multi-instance scenarios.
  Vue.options._base = Vue;

  extend(Vue.options.components, builtInComponents);

  initUse(Vue);
  initMixin$1(Vue);
  initExtend(Vue);
  initAssetRegisters(Vue);
}

initGlobalAPI(Vue);

Object.defineProperty(Vue.prototype, '$isServer', {
  get: isServerRendering
});

Object.defineProperty(Vue.prototype, '$ssrContext', {
  get: function get () {
    /* istanbul ignore next */
    return this.$vnode && this.$vnode.ssrContext
  }
});

// expose FunctionalRenderContext for ssr runtime helper installation
Object.defineProperty(Vue, 'FunctionalRenderContext', {
  value: FunctionalRenderContext
});

Vue.version = '2.6.12';

/*  */

// these are reserved for web because they are directly compiled away
// during template compilation
var isReservedAttr = makeMap('style,class');

// attributes that should be using props for binding
var acceptValue = makeMap('input,textarea,option,select,progress');
var mustUseProp = function (tag, type, attr) {
  return (
    (attr === 'value' && acceptValue(tag)) && type !== 'button' ||
    (attr === 'selected' && tag === 'option') ||
    (attr === 'checked' && tag === 'input') ||
    (attr === 'muted' && tag === 'video')
  )
};

var isEnumeratedAttr = makeMap('contenteditable,draggable,spellcheck');

var isValidContentEditableValue = makeMap('events,caret,typing,plaintext-only');

var convertEnumeratedValue = function (key, value) {
  return isFalsyAttrValue(value) || value === 'false'
    ? 'false'
    // allow arbitrary string value for contenteditable
    : key === 'contenteditable' && isValidContentEditableValue(value)
      ? value
      : 'true'
};

var isBooleanAttr = makeMap(
  'allowfullscreen,async,autofocus,autoplay,checked,compact,controls,declare,' +
  'default,defaultchecked,defaultmuted,defaultselected,defer,disabled,' +
  'enabled,formnovalidate,hidden,indeterminate,inert,ismap,itemscope,loop,multiple,' +
  'muted,nohref,noresize,noshade,novalidate,nowrap,open,pauseonexit,readonly,' +
  'required,reversed,scoped,seamless,selected,sortable,translate,' +
  'truespeed,typemustmatch,visible'
);

var xlinkNS = 'http://www.w3.org/1999/xlink';

var isXlink = function (name) {
  return name.charAt(5) === ':' && name.slice(0, 5) === 'xlink'
};

var getXlinkProp = function (name) {
  return isXlink(name) ? name.slice(6, name.length) : ''
};

var isFalsyAttrValue = function (val) {
  return val == null || val === false
};

/*  */

function genClassForVnode (vnode) {
  var data = vnode.data;
  var parentNode = vnode;
  var childNode = vnode;
  while (isDef(childNode.componentInstance)) {
    childNode = childNode.componentInstance._vnode;
    if (childNode && childNode.data) {
      data = mergeClassData(childNode.data, data);
    }
  }
  while (isDef(parentNode = parentNode.parent)) {
    if (parentNode && parentNode.data) {
      data = mergeClassData(data, parentNode.data);
    }
  }
  return renderClass(data.staticClass, data.class)
}

function mergeClassData (child, parent) {
  return {
    staticClass: concat(child.staticClass, parent.staticClass),
    class: isDef(child.class)
      ? [child.class, parent.class]
      : parent.class
  }
}

function renderClass (
  staticClass,
  dynamicClass
) {
  if (isDef(staticClass) || isDef(dynamicClass)) {
    return concat(staticClass, stringifyClass(dynamicClass))
  }
  /* istanbul ignore next */
  return ''
}

function concat (a, b) {
  return a ? b ? (a + ' ' + b) : a : (b || '')
}

function stringifyClass (value) {
  if (Array.isArray(value)) {
    return stringifyArray(value)
  }
  if (isObject(value)) {
    return stringifyObject(value)
  }
  if (typeof value === 'string') {
    return value
  }
  /* istanbul ignore next */
  return ''
}

function stringifyArray (value) {
  var res = '';
  var stringified;
  for (var i = 0, l = value.length; i < l; i++) {
    if (isDef(stringified = stringifyClass(value[i])) && stringified !== '') {
      if (res) { res += ' '; }
      res += stringified;
    }
  }
  return res
}

function stringifyObject (value) {
  var res = '';
  for (var key in value) {
    if (value[key]) {
      if (res) { res += ' '; }
      res += key;
    }
  }
  return res
}

/*  */

var namespaceMap = {
  svg: 'http://www.w3.org/2000/svg',
  math: 'http://www.w3.org/1998/Math/MathML'
};

var isHTMLTag = makeMap(
  'html,body,base,head,link,meta,style,title,' +
  'address,article,aside,footer,header,h1,h2,h3,h4,h5,h6,hgroup,nav,section,' +
  'div,dd,dl,dt,figcaption,figure,picture,hr,img,li,main,ol,p,pre,ul,' +
  'a,b,abbr,bdi,bdo,br,cite,code,data,dfn,em,i,kbd,mark,q,rp,rt,rtc,ruby,' +
  's,samp,small,span,strong,sub,sup,time,u,var,wbr,area,audio,map,track,video,' +
  'embed,object,param,source,canvas,script,noscript,del,ins,' +
  'caption,col,colgroup,table,thead,tbody,td,th,tr,' +
  'button,datalist,fieldset,form,input,label,legend,meter,optgroup,option,' +
  'output,progress,select,textarea,' +
  'details,dialog,menu,menuitem,summary,' +
  'content,element,shadow,template,blockquote,iframe,tfoot'
);

// this map is intentionally selective, only covering SVG elements that may
// contain child elements.
var isSVG = makeMap(
  'svg,animate,circle,clippath,cursor,defs,desc,ellipse,filter,font-face,' +
  'foreignObject,g,glyph,image,line,marker,mask,missing-glyph,path,pattern,' +
  'polygon,polyline,rect,switch,symbol,text,textpath,tspan,use,view',
  true
);

var isPreTag = function (tag) { return tag === 'pre'; };

var isReservedTag = function (tag) {
  return isHTMLTag(tag) || isSVG(tag)
};

function getTagNamespace (tag) {
  if (isSVG(tag)) {
    return 'svg'
  }
  // basic support for MathML
  // note it doesn't support other MathML elements being component roots
  if (tag === 'math') {
    return 'math'
  }
}

var unknownElementCache = Object.create(null);
function isUnknownElement (tag) {
  /* istanbul ignore if */
  if (!inBrowser) {
    return true
  }
  if (isReservedTag(tag)) {
    return false
  }
  tag = tag.toLowerCase();
  /* istanbul ignore if */
  if (unknownElementCache[tag] != null) {
    return unknownElementCache[tag]
  }
  var el = document.createElement(tag);
  if (tag.indexOf('-') > -1) {
    // http://stackoverflow.com/a/28210364/1070244
    return (unknownElementCache[tag] = (
      el.constructor === window.HTMLUnknownElement ||
      el.constructor === window.HTMLElement
    ))
  } else {
    return (unknownElementCache[tag] = /HTMLUnknownElement/.test(el.toString()))
  }
}

var isTextInputType = makeMap('text,number,password,search,email,tel,url');

/*  */

/**
 * Query an element selector if it's not an element already.
 */
function query (el) {
  if (typeof el === 'string') {
    var selected = document.querySelector(el);
    if (!selected) {
      "production" !== 'production' && warn(
        'Cannot find element: ' + el
      );
      return document.createElement('div')
    }
    return selected
  } else {
    return el
  }
}

/*  */

function createElement$1 (tagName, vnode) {
  var elm = document.createElement(tagName);
  if (tagName !== 'select') {
    return elm
  }
  // false or null will remove the attribute but undefined will not
  if (vnode.data && vnode.data.attrs && vnode.data.attrs.multiple !== undefined) {
    elm.setAttribute('multiple', 'multiple');
  }
  return elm
}

function createElementNS (namespace, tagName) {
  return document.createElementNS(namespaceMap[namespace], tagName)
}

function createTextNode (text) {
  return document.createTextNode(text)
}

function createComment (text) {
  return document.createComment(text)
}

function insertBefore (parentNode, newNode, referenceNode) {
  parentNode.insertBefore(newNode, referenceNode);
}

function removeChild (node, child) {
  node.removeChild(child);
}

function appendChild (node, child) {
  node.appendChild(child);
}

function parentNode (node) {
  return node.parentNode
}

function nextSibling (node) {
  return node.nextSibling
}

function tagName (node) {
  return node.tagName
}

function setTextContent (node, text) {
  node.textContent = text;
}

function setStyleScope (node, scopeId) {
  node.setAttribute(scopeId, '');
}

var nodeOps = /*#__PURE__*/Object.freeze({
  createElement: createElement$1,
  createElementNS: createElementNS,
  createTextNode: createTextNode,
  createComment: createComment,
  insertBefore: insertBefore,
  removeChild: removeChild,
  appendChild: appendChild,
  parentNode: parentNode,
  nextSibling: nextSibling,
  tagName: tagName,
  setTextContent: setTextContent,
  setStyleScope: setStyleScope
});

/*  */

var ref = {
  create: function create (_, vnode) {
    registerRef(vnode);
  },
  update: function update (oldVnode, vnode) {
    if (oldVnode.data.ref !== vnode.data.ref) {
      registerRef(oldVnode, true);
      registerRef(vnode);
    }
  },
  destroy: function destroy (vnode) {
    registerRef(vnode, true);
  }
};

function registerRef (vnode, isRemoval) {
  var key = vnode.data.ref;
  if (!isDef(key)) { return }

  var vm = vnode.context;
  var ref = vnode.componentInstance || vnode.elm;
  var refs = vm.$refs;
  if (isRemoval) {
    if (Array.isArray(refs[key])) {
      remove(refs[key], ref);
    } else if (refs[key] === ref) {
      refs[key] = undefined;
    }
  } else {
    if (vnode.data.refInFor) {
      if (!Array.isArray(refs[key])) {
        refs[key] = [ref];
      } else if (refs[key].indexOf(ref) < 0) {
        // $flow-disable-line
        refs[key].push(ref);
      }
    } else {
      refs[key] = ref;
    }
  }
}

/**
 * Virtual DOM patching algorithm based on Snabbdom by
 * Simon Friis Vindum (@paldepind)
 * Licensed under the MIT License
 * https://github.com/paldepind/snabbdom/blob/master/LICENSE
 *
 * modified by Evan You (@yyx990803)
 *
 * Not type-checking this because this file is perf-critical and the cost
 * of making flow understand it is not worth it.
 */

var emptyNode = new VNode('', {}, []);

var hooks = ['create', 'activate', 'update', 'remove', 'destroy'];

function sameVnode (a, b) {
  return (
    a.key === b.key && (
      (
        a.tag === b.tag &&
        a.isComment === b.isComment &&
        isDef(a.data) === isDef(b.data) &&
        sameInputType(a, b)
      ) || (
        isTrue(a.isAsyncPlaceholder) &&
        a.asyncFactory === b.asyncFactory &&
        isUndef(b.asyncFactory.error)
      )
    )
  )
}

function sameInputType (a, b) {
  if (a.tag !== 'input') { return true }
  var i;
  var typeA = isDef(i = a.data) && isDef(i = i.attrs) && i.type;
  var typeB = isDef(i = b.data) && isDef(i = i.attrs) && i.type;
  return typeA === typeB || isTextInputType(typeA) && isTextInputType(typeB)
}

function createKeyToOldIdx (children, beginIdx, endIdx) {
  var i, key;
  var map = {};
  for (i = beginIdx; i <= endIdx; ++i) {
    key = children[i].key;
    if (isDef(key)) { map[key] = i; }
  }
  return map
}

function createPatchFunction (backend) {
  var i, j;
  var cbs = {};

  var modules = backend.modules;
  var nodeOps = backend.nodeOps;

  for (i = 0; i < hooks.length; ++i) {
    cbs[hooks[i]] = [];
    for (j = 0; j < modules.length; ++j) {
      if (isDef(modules[j][hooks[i]])) {
        cbs[hooks[i]].push(modules[j][hooks[i]]);
      }
    }
  }

  function emptyNodeAt (elm) {
    return new VNode(nodeOps.tagName(elm).toLowerCase(), {}, [], undefined, elm)
  }

  function createRmCb (childElm, listeners) {
    function remove$$1 () {
      if (--remove$$1.listeners === 0) {
        removeNode(childElm);
      }
    }
    remove$$1.listeners = listeners;
    return remove$$1
  }

  function removeNode (el) {
    var parent = nodeOps.parentNode(el);
    // element may have already been removed due to v-html / v-text
    if (isDef(parent)) {
      nodeOps.removeChild(parent, el);
    }
  }

  function isUnknownElement$$1 (vnode, inVPre) {
    return (
      !inVPre &&
      !vnode.ns &&
      !(
        config.ignoredElements.length &&
        config.ignoredElements.some(function (ignore) {
          return isRegExp(ignore)
            ? ignore.test(vnode.tag)
            : ignore === vnode.tag
        })
      ) &&
      config.isUnknownElement(vnode.tag)
    )
  }

  var creatingElmInVPre = 0;

  function createElm (
    vnode,
    insertedVnodeQueue,
    parentElm,
    refElm,
    nested,
    ownerArray,
    index
  ) {
    if (isDef(vnode.elm) && isDef(ownerArray)) {
      // This vnode was used in a previous render!
      // now it's used as a new node, overwriting its elm would cause
      // potential patch errors down the road when it's used as an insertion
      // reference node. Instead, we clone the node on-demand before creating
      // associated DOM element for it.
      vnode = ownerArray[index] = cloneVNode(vnode);
    }

    vnode.isRootInsert = !nested; // for transition enter check
    if (createComponent(vnode, insertedVnodeQueue, parentElm, refElm)) {
      return
    }

    var data = vnode.data;
    var children = vnode.children;
    var tag = vnode.tag;
    if (isDef(tag)) {
      if (false) {
        if (data && data.pre) {
          creatingElmInVPre++;
        }
        if (isUnknownElement$$1(vnode, creatingElmInVPre)) {
          warn(
            'Unknown custom element: <' + tag + '> - did you ' +
            'register the component correctly? For recursive components, ' +
            'make sure to provide the "name" option.',
            vnode.context
          );
        }
      }

      vnode.elm = vnode.ns
        ? nodeOps.createElementNS(vnode.ns, tag)
        : nodeOps.createElement(tag, vnode);
      setScope(vnode);

      /* istanbul ignore if */
      {
        createChildren(vnode, children, insertedVnodeQueue);
        if (isDef(data)) {
          invokeCreateHooks(vnode, insertedVnodeQueue);
        }
        insert(parentElm, vnode.elm, refElm);
      }

      if (false) {
        creatingElmInVPre--;
      }
    } else if (isTrue(vnode.isComment)) {
      vnode.elm = nodeOps.createComment(vnode.text);
      insert(parentElm, vnode.elm, refElm);
    } else {
      vnode.elm = nodeOps.createTextNode(vnode.text);
      insert(parentElm, vnode.elm, refElm);
    }
  }

  function createComponent (vnode, insertedVnodeQueue, parentElm, refElm) {
    var i = vnode.data;
    if (isDef(i)) {
      var isReactivated = isDef(vnode.componentInstance) && i.keepAlive;
      if (isDef(i = i.hook) && isDef(i = i.init)) {
        i(vnode, false /* hydrating */);
      }
      // after calling the init hook, if the vnode is a child component
      // it should've created a child instance and mounted it. the child
      // component also has set the placeholder vnode's elm.
      // in that case we can just return the element and be done.
      if (isDef(vnode.componentInstance)) {
        initComponent(vnode, insertedVnodeQueue);
        insert(parentElm, vnode.elm, refElm);
        if (isTrue(isReactivated)) {
          reactivateComponent(vnode, insertedVnodeQueue, parentElm, refElm);
        }
        return true
      }
    }
  }

  function initComponent (vnode, insertedVnodeQueue) {
    if (isDef(vnode.data.pendingInsert)) {
      insertedVnodeQueue.push.apply(insertedVnodeQueue, vnode.data.pendingInsert);
      vnode.data.pendingInsert = null;
    }
    vnode.elm = vnode.componentInstance.$el;
    if (isPatchable(vnode)) {
      invokeCreateHooks(vnode, insertedVnodeQueue);
      setScope(vnode);
    } else {
      // empty component root.
      // skip all element-related modules except for ref (#3455)
      registerRef(vnode);
      // make sure to invoke the insert hook
      insertedVnodeQueue.push(vnode);
    }
  }

  function reactivateComponent (vnode, insertedVnodeQueue, parentElm, refElm) {
    var i;
    // hack for #4339: a reactivated component with inner transition
    // does not trigger because the inner node's created hooks are not called
    // again. It's not ideal to involve module-specific logic in here but
    // there doesn't seem to be a better way to do it.
    var innerNode = vnode;
    while (innerNode.componentInstance) {
      innerNode = innerNode.componentInstance._vnode;
      if (isDef(i = innerNode.data) && isDef(i = i.transition)) {
        for (i = 0; i < cbs.activate.length; ++i) {
          cbs.activate[i](emptyNode, innerNode);
        }
        insertedVnodeQueue.push(innerNode);
        break
      }
    }
    // unlike a newly created component,
    // a reactivated keep-alive component doesn't insert itself
    insert(parentElm, vnode.elm, refElm);
  }

  function insert (parent, elm, ref$$1) {
    if (isDef(parent)) {
      if (isDef(ref$$1)) {
        if (nodeOps.parentNode(ref$$1) === parent) {
          nodeOps.insertBefore(parent, elm, ref$$1);
        }
      } else {
        nodeOps.appendChild(parent, elm);
      }
    }
  }

  function createChildren (vnode, children, insertedVnodeQueue) {
    if (Array.isArray(children)) {
      if (false) {
        checkDuplicateKeys(children);
      }
      for (var i = 0; i < children.length; ++i) {
        createElm(children[i], insertedVnodeQueue, vnode.elm, null, true, children, i);
      }
    } else if (isPrimitive(vnode.text)) {
      nodeOps.appendChild(vnode.elm, nodeOps.createTextNode(String(vnode.text)));
    }
  }

  function isPatchable (vnode) {
    while (vnode.componentInstance) {
      vnode = vnode.componentInstance._vnode;
    }
    return isDef(vnode.tag)
  }

  function invokeCreateHooks (vnode, insertedVnodeQueue) {
    for (var i$1 = 0; i$1 < cbs.create.length; ++i$1) {
      cbs.create[i$1](emptyNode, vnode);
    }
    i = vnode.data.hook; // Reuse variable
    if (isDef(i)) {
      if (isDef(i.create)) { i.create(emptyNode, vnode); }
      if (isDef(i.insert)) { insertedVnodeQueue.push(vnode); }
    }
  }

  // set scope id attribute for scoped CSS.
  // this is implemented as a special case to avoid the overhead
  // of going through the normal attribute patching process.
  function setScope (vnode) {
    var i;
    if (isDef(i = vnode.fnScopeId)) {
      nodeOps.setStyleScope(vnode.elm, i);
    } else {
      var ancestor = vnode;
      while (ancestor) {
        if (isDef(i = ancestor.context) && isDef(i = i.$options._scopeId)) {
          nodeOps.setStyleScope(vnode.elm, i);
        }
        ancestor = ancestor.parent;
      }
    }
    // for slot content they should also get the scopeId from the host instance.
    if (isDef(i = activeInstance) &&
      i !== vnode.context &&
      i !== vnode.fnContext &&
      isDef(i = i.$options._scopeId)
    ) {
      nodeOps.setStyleScope(vnode.elm, i);
    }
  }

  function addVnodes (parentElm, refElm, vnodes, startIdx, endIdx, insertedVnodeQueue) {
    for (; startIdx <= endIdx; ++startIdx) {
      createElm(vnodes[startIdx], insertedVnodeQueue, parentElm, refElm, false, vnodes, startIdx);
    }
  }

  function invokeDestroyHook (vnode) {
    var i, j;
    var data = vnode.data;
    if (isDef(data)) {
      if (isDef(i = data.hook) && isDef(i = i.destroy)) { i(vnode); }
      for (i = 0; i < cbs.destroy.length; ++i) { cbs.destroy[i](vnode); }
    }
    if (isDef(i = vnode.children)) {
      for (j = 0; j < vnode.children.length; ++j) {
        invokeDestroyHook(vnode.children[j]);
      }
    }
  }

  function removeVnodes (vnodes, startIdx, endIdx) {
    for (; startIdx <= endIdx; ++startIdx) {
      var ch = vnodes[startIdx];
      if (isDef(ch)) {
        if (isDef(ch.tag)) {
          removeAndInvokeRemoveHook(ch);
          invokeDestroyHook(ch);
        } else { // Text node
          removeNode(ch.elm);
        }
      }
    }
  }

  function removeAndInvokeRemoveHook (vnode, rm) {
    if (isDef(rm) || isDef(vnode.data)) {
      var i;
      var listeners = cbs.remove.length + 1;
      if (isDef(rm)) {
        // we have a recursively passed down rm callback
        // increase the listeners count
        rm.listeners += listeners;
      } else {
        // directly removing
        rm = createRmCb(vnode.elm, listeners);
      }
      // recursively invoke hooks on child component root node
      if (isDef(i = vnode.componentInstance) && isDef(i = i._vnode) && isDef(i.data)) {
        removeAndInvokeRemoveHook(i, rm);
      }
      for (i = 0; i < cbs.remove.length; ++i) {
        cbs.remove[i](vnode, rm);
      }
      if (isDef(i = vnode.data.hook) && isDef(i = i.remove)) {
        i(vnode, rm);
      } else {
        rm();
      }
    } else {
      removeNode(vnode.elm);
    }
  }

  function updateChildren (parentElm, oldCh, newCh, insertedVnodeQueue, removeOnly) {
    var oldStartIdx = 0;
    var newStartIdx = 0;
    var oldEndIdx = oldCh.length - 1;
    var oldStartVnode = oldCh[0];
    var oldEndVnode = oldCh[oldEndIdx];
    var newEndIdx = newCh.length - 1;
    var newStartVnode = newCh[0];
    var newEndVnode = newCh[newEndIdx];
    var oldKeyToIdx, idxInOld, vnodeToMove, refElm;

    // removeOnly is a special flag used only by <transition-group>
    // to ensure removed elements stay in correct relative positions
    // during leaving transitions
    var canMove = !removeOnly;

    if (false) {
      checkDuplicateKeys(newCh);
    }

    while (oldStartIdx <= oldEndIdx && newStartIdx <= newEndIdx) {
      if (isUndef(oldStartVnode)) {
        oldStartVnode = oldCh[++oldStartIdx]; // Vnode has been moved left
      } else if (isUndef(oldEndVnode)) {
        oldEndVnode = oldCh[--oldEndIdx];
      } else if (sameVnode(oldStartVnode, newStartVnode)) {
        patchVnode(oldStartVnode, newStartVnode, insertedVnodeQueue, newCh, newStartIdx);
        oldStartVnode = oldCh[++oldStartIdx];
        newStartVnode = newCh[++newStartIdx];
      } else if (sameVnode(oldEndVnode, newEndVnode)) {
        patchVnode(oldEndVnode, newEndVnode, insertedVnodeQueue, newCh, newEndIdx);
        oldEndVnode = oldCh[--oldEndIdx];
        newEndVnode = newCh[--newEndIdx];
      } else if (sameVnode(oldStartVnode, newEndVnode)) { // Vnode moved right
        patchVnode(oldStartVnode, newEndVnode, insertedVnodeQueue, newCh, newEndIdx);
        canMove && nodeOps.insertBefore(parentElm, oldStartVnode.elm, nodeOps.nextSibling(oldEndVnode.elm));
        oldStartVnode = oldCh[++oldStartIdx];
        newEndVnode = newCh[--newEndIdx];
      } else if (sameVnode(oldEndVnode, newStartVnode)) { // Vnode moved left
        patchVnode(oldEndVnode, newStartVnode, insertedVnodeQueue, newCh, newStartIdx);
        canMove && nodeOps.insertBefore(parentElm, oldEndVnode.elm, oldStartVnode.elm);
        oldEndVnode = oldCh[--oldEndIdx];
        newStartVnode = newCh[++newStartIdx];
      } else {
        if (isUndef(oldKeyToIdx)) { oldKeyToIdx = createKeyToOldIdx(oldCh, oldStartIdx, oldEndIdx); }
        idxInOld = isDef(newStartVnode.key)
          ? oldKeyToIdx[newStartVnode.key]
          : findIdxInOld(newStartVnode, oldCh, oldStartIdx, oldEndIdx);
        if (isUndef(idxInOld)) { // New element
          createElm(newStartVnode, insertedVnodeQueue, parentElm, oldStartVnode.elm, false, newCh, newStartIdx);
        } else {
          vnodeToMove = oldCh[idxInOld];
          if (sameVnode(vnodeToMove, newStartVnode)) {
            patchVnode(vnodeToMove, newStartVnode, insertedVnodeQueue, newCh, newStartIdx);
            oldCh[idxInOld] = undefined;
            canMove && nodeOps.insertBefore(parentElm, vnodeToMove.elm, oldStartVnode.elm);
          } else {
            // same key but different element. treat as new element
            createElm(newStartVnode, insertedVnodeQueue, parentElm, oldStartVnode.elm, false, newCh, newStartIdx);
          }
        }
        newStartVnode = newCh[++newStartIdx];
      }
    }
    if (oldStartIdx > oldEndIdx) {
      refElm = isUndef(newCh[newEndIdx + 1]) ? null : newCh[newEndIdx + 1].elm;
      addVnodes(parentElm, refElm, newCh, newStartIdx, newEndIdx, insertedVnodeQueue);
    } else if (newStartIdx > newEndIdx) {
      removeVnodes(oldCh, oldStartIdx, oldEndIdx);
    }
  }

  function checkDuplicateKeys (children) {
    var seenKeys = {};
    for (var i = 0; i < children.length; i++) {
      var vnode = children[i];
      var key = vnode.key;
      if (isDef(key)) {
        if (seenKeys[key]) {
          warn(
            ("Duplicate keys detected: '" + key + "'. This may cause an update error."),
            vnode.context
          );
        } else {
          seenKeys[key] = true;
        }
      }
    }
  }

  function findIdxInOld (node, oldCh, start, end) {
    for (var i = start; i < end; i++) {
      var c = oldCh[i];
      if (isDef(c) && sameVnode(node, c)) { return i }
    }
  }

  function patchVnode (
    oldVnode,
    vnode,
    insertedVnodeQueue,
    ownerArray,
    index,
    removeOnly
  ) {
    if (oldVnode === vnode) {
      return
    }

    if (isDef(vnode.elm) && isDef(ownerArray)) {
      // clone reused vnode
      vnode = ownerArray[index] = cloneVNode(vnode);
    }

    var elm = vnode.elm = oldVnode.elm;

    if (isTrue(oldVnode.isAsyncPlaceholder)) {
      if (isDef(vnode.asyncFactory.resolved)) {
        hydrate(oldVnode.elm, vnode, insertedVnodeQueue);
      } else {
        vnode.isAsyncPlaceholder = true;
      }
      return
    }

    // reuse element for static trees.
    // note we only do this if the vnode is cloned -
    // if the new node is not cloned it means the render functions have been
    // reset by the hot-reload-api and we need to do a proper re-render.
    if (isTrue(vnode.isStatic) &&
      isTrue(oldVnode.isStatic) &&
      vnode.key === oldVnode.key &&
      (isTrue(vnode.isCloned) || isTrue(vnode.isOnce))
    ) {
      vnode.componentInstance = oldVnode.componentInstance;
      return
    }

    var i;
    var data = vnode.data;
    if (isDef(data) && isDef(i = data.hook) && isDef(i = i.prepatch)) {
      i(oldVnode, vnode);
    }

    var oldCh = oldVnode.children;
    var ch = vnode.children;
    if (isDef(data) && isPatchable(vnode)) {
      for (i = 0; i < cbs.update.length; ++i) { cbs.update[i](oldVnode, vnode); }
      if (isDef(i = data.hook) && isDef(i = i.update)) { i(oldVnode, vnode); }
    }
    if (isUndef(vnode.text)) {
      if (isDef(oldCh) && isDef(ch)) {
        if (oldCh !== ch) { updateChildren(elm, oldCh, ch, insertedVnodeQueue, removeOnly); }
      } else if (isDef(ch)) {
        if (false) {
          checkDuplicateKeys(ch);
        }
        if (isDef(oldVnode.text)) { nodeOps.setTextContent(elm, ''); }
        addVnodes(elm, null, ch, 0, ch.length - 1, insertedVnodeQueue);
      } else if (isDef(oldCh)) {
        removeVnodes(oldCh, 0, oldCh.length - 1);
      } else if (isDef(oldVnode.text)) {
        nodeOps.setTextContent(elm, '');
      }
    } else if (oldVnode.text !== vnode.text) {
      nodeOps.setTextContent(elm, vnode.text);
    }
    if (isDef(data)) {
      if (isDef(i = data.hook) && isDef(i = i.postpatch)) { i(oldVnode, vnode); }
    }
  }

  function invokeInsertHook (vnode, queue, initial) {
    // delay insert hooks for component root nodes, invoke them after the
    // element is really inserted
    if (isTrue(initial) && isDef(vnode.parent)) {
      vnode.parent.data.pendingInsert = queue;
    } else {
      for (var i = 0; i < queue.length; ++i) {
        queue[i].data.hook.insert(queue[i]);
      }
    }
  }

  var hydrationBailed = false;
  // list of modules that can skip create hook during hydration because they
  // are already rendered on the client or has no need for initialization
  // Note: style is excluded because it relies on initial clone for future
  // deep updates (#7063).
  var isRenderedModule = makeMap('attrs,class,staticClass,staticStyle,key');

  // Note: this is a browser-only function so we can assume elms are DOM nodes.
  function hydrate (elm, vnode, insertedVnodeQueue, inVPre) {
    var i;
    var tag = vnode.tag;
    var data = vnode.data;
    var children = vnode.children;
    inVPre = inVPre || (data && data.pre);
    vnode.elm = elm;

    if (isTrue(vnode.isComment) && isDef(vnode.asyncFactory)) {
      vnode.isAsyncPlaceholder = true;
      return true
    }
    // assert node match
    if (false) {
      if (!assertNodeMatch(elm, vnode, inVPre)) {
        return false
      }
    }
    if (isDef(data)) {
      if (isDef(i = data.hook) && isDef(i = i.init)) { i(vnode, true /* hydrating */); }
      if (isDef(i = vnode.componentInstance)) {
        // child component. it should have hydrated its own tree.
        initComponent(vnode, insertedVnodeQueue);
        return true
      }
    }
    if (isDef(tag)) {
      if (isDef(children)) {
        // empty element, allow client to pick up and populate children
        if (!elm.hasChildNodes()) {
          createChildren(vnode, children, insertedVnodeQueue);
        } else {
          // v-html and domProps: innerHTML
          if (isDef(i = data) && isDef(i = i.domProps) && isDef(i = i.innerHTML)) {
            if (i !== elm.innerHTML) {
              /* istanbul ignore if */
              if (false
              ) {
                hydrationBailed = true;
                console.warn('Parent: ', elm);
                console.warn('server innerHTML: ', i);
                console.warn('client innerHTML: ', elm.innerHTML);
              }
              return false
            }
          } else {
            // iterate and compare children lists
            var childrenMatch = true;
            var childNode = elm.firstChild;
            for (var i$1 = 0; i$1 < children.length; i$1++) {
              if (!childNode || !hydrate(childNode, children[i$1], insertedVnodeQueue, inVPre)) {
                childrenMatch = false;
                break
              }
              childNode = childNode.nextSibling;
            }
            // if childNode is not null, it means the actual childNodes list is
            // longer than the virtual children list.
            if (!childrenMatch || childNode) {
              /* istanbul ignore if */
              if (false
              ) {
                hydrationBailed = true;
                console.warn('Parent: ', elm);
                console.warn('Mismatching childNodes vs. VNodes: ', elm.childNodes, children);
              }
              return false
            }
          }
        }
      }
      if (isDef(data)) {
        var fullInvoke = false;
        for (var key in data) {
          if (!isRenderedModule(key)) {
            fullInvoke = true;
            invokeCreateHooks(vnode, insertedVnodeQueue);
            break
          }
        }
        if (!fullInvoke && data['class']) {
          // ensure collecting deps for deep class bindings for future updates
          traverse(data['class']);
        }
      }
    } else if (elm.data !== vnode.text) {
      elm.data = vnode.text;
    }
    return true
  }

  function assertNodeMatch (node, vnode, inVPre) {
    if (isDef(vnode.tag)) {
      return vnode.tag.indexOf('vue-component') === 0 || (
        !isUnknownElement$$1(vnode, inVPre) &&
        vnode.tag.toLowerCase() === (node.tagName && node.tagName.toLowerCase())
      )
    } else {
      return node.nodeType === (vnode.isComment ? 8 : 3)
    }
  }

  return function patch (oldVnode, vnode, hydrating, removeOnly) {
    if (isUndef(vnode)) {
      if (isDef(oldVnode)) { invokeDestroyHook(oldVnode); }
      return
    }

    var isInitialPatch = false;
    var insertedVnodeQueue = [];

    if (isUndef(oldVnode)) {
      // empty mount (likely as component), create new root element
      isInitialPatch = true;
      createElm(vnode, insertedVnodeQueue);
    } else {
      var isRealElement = isDef(oldVnode.nodeType);
      if (!isRealElement && sameVnode(oldVnode, vnode)) {
        // patch existing root node
        patchVnode(oldVnode, vnode, insertedVnodeQueue, null, null, removeOnly);
      } else {
        if (isRealElement) {
          // mounting to a real element
          // check if this is server-rendered content and if we can perform
          // a successful hydration.
          if (oldVnode.nodeType === 1 && oldVnode.hasAttribute(SSR_ATTR)) {
            oldVnode.removeAttribute(SSR_ATTR);
            hydrating = true;
          }
          if (isTrue(hydrating)) {
            if (hydrate(oldVnode, vnode, insertedVnodeQueue)) {
              invokeInsertHook(vnode, insertedVnodeQueue, true);
              return oldVnode
            } else if (false) {
              warn(
                'The client-side rendered virtual DOM tree is not matching ' +
                'server-rendered content. This is likely caused by incorrect ' +
                'HTML markup, for example nesting block-level elements inside ' +
                '<p>, or missing <tbody>. Bailing hydration and performing ' +
                'full client-side render.'
              );
            }
          }
          // either not server-rendered, or hydration failed.
          // create an empty node and replace it
          oldVnode = emptyNodeAt(oldVnode);
        }

        // replacing existing element
        var oldElm = oldVnode.elm;
        var parentElm = nodeOps.parentNode(oldElm);

        // create new node
        createElm(
          vnode,
          insertedVnodeQueue,
          // extremely rare edge case: do not insert if old element is in a
          // leaving transition. Only happens when combining transition +
          // keep-alive + HOCs. (#4590)
          oldElm._leaveCb ? null : parentElm,
          nodeOps.nextSibling(oldElm)
        );

        // update parent placeholder node element, recursively
        if (isDef(vnode.parent)) {
          var ancestor = vnode.parent;
          var patchable = isPatchable(vnode);
          while (ancestor) {
            for (var i = 0; i < cbs.destroy.length; ++i) {
              cbs.destroy[i](ancestor);
            }
            ancestor.elm = vnode.elm;
            if (patchable) {
              for (var i$1 = 0; i$1 < cbs.create.length; ++i$1) {
                cbs.create[i$1](emptyNode, ancestor);
              }
              // #6513
              // invoke insert hooks that may have been merged by create hooks.
              // e.g. for directives that uses the "inserted" hook.
              var insert = ancestor.data.hook.insert;
              if (insert.merged) {
                // start at index 1 to avoid re-invoking component mounted hook
                for (var i$2 = 1; i$2 < insert.fns.length; i$2++) {
                  insert.fns[i$2]();
                }
              }
            } else {
              registerRef(ancestor);
            }
            ancestor = ancestor.parent;
          }
        }

        // destroy old node
        if (isDef(parentElm)) {
          removeVnodes([oldVnode], 0, 0);
        } else if (isDef(oldVnode.tag)) {
          invokeDestroyHook(oldVnode);
        }
      }
    }

    invokeInsertHook(vnode, insertedVnodeQueue, isInitialPatch);
    return vnode.elm
  }
}

/*  */

var directives = {
  create: updateDirectives,
  update: updateDirectives,
  destroy: function unbindDirectives (vnode) {
    updateDirectives(vnode, emptyNode);
  }
};

function updateDirectives (oldVnode, vnode) {
  if (oldVnode.data.directives || vnode.data.directives) {
    _update(oldVnode, vnode);
  }
}

function _update (oldVnode, vnode) {
  var isCreate = oldVnode === emptyNode;
  var isDestroy = vnode === emptyNode;
  var oldDirs = normalizeDirectives$1(oldVnode.data.directives, oldVnode.context);
  var newDirs = normalizeDirectives$1(vnode.data.directives, vnode.context);

  var dirsWithInsert = [];
  var dirsWithPostpatch = [];

  var key, oldDir, dir;
  for (key in newDirs) {
    oldDir = oldDirs[key];
    dir = newDirs[key];
    if (!oldDir) {
      // new directive, bind
      callHook$1(dir, 'bind', vnode, oldVnode);
      if (dir.def && dir.def.inserted) {
        dirsWithInsert.push(dir);
      }
    } else {
      // existing directive, update
      dir.oldValue = oldDir.value;
      dir.oldArg = oldDir.arg;
      callHook$1(dir, 'update', vnode, oldVnode);
      if (dir.def && dir.def.componentUpdated) {
        dirsWithPostpatch.push(dir);
      }
    }
  }

  if (dirsWithInsert.length) {
    var callInsert = function () {
      for (var i = 0; i < dirsWithInsert.length; i++) {
        callHook$1(dirsWithInsert[i], 'inserted', vnode, oldVnode);
      }
    };
    if (isCreate) {
      mergeVNodeHook(vnode, 'insert', callInsert);
    } else {
      callInsert();
    }
  }

  if (dirsWithPostpatch.length) {
    mergeVNodeHook(vnode, 'postpatch', function () {
      for (var i = 0; i < dirsWithPostpatch.length; i++) {
        callHook$1(dirsWithPostpatch[i], 'componentUpdated', vnode, oldVnode);
      }
    });
  }

  if (!isCreate) {
    for (key in oldDirs) {
      if (!newDirs[key]) {
        // no longer present, unbind
        callHook$1(oldDirs[key], 'unbind', oldVnode, oldVnode, isDestroy);
      }
    }
  }
}

var emptyModifiers = Object.create(null);

function normalizeDirectives$1 (
  dirs,
  vm
) {
  var res = Object.create(null);
  if (!dirs) {
    // $flow-disable-line
    return res
  }
  var i, dir;
  for (i = 0; i < dirs.length; i++) {
    dir = dirs[i];
    if (!dir.modifiers) {
      // $flow-disable-line
      dir.modifiers = emptyModifiers;
    }
    res[getRawDirName(dir)] = dir;
    dir.def = resolveAsset(vm.$options, 'directives', dir.name, true);
  }
  // $flow-disable-line
  return res
}

function getRawDirName (dir) {
  return dir.rawName || ((dir.name) + "." + (Object.keys(dir.modifiers || {}).join('.')))
}

function callHook$1 (dir, hook, vnode, oldVnode, isDestroy) {
  var fn = dir.def && dir.def[hook];
  if (fn) {
    try {
      fn(vnode.elm, dir, vnode, oldVnode, isDestroy);
    } catch (e) {
      handleError(e, vnode.context, ("directive " + (dir.name) + " " + hook + " hook"));
    }
  }
}

var baseModules = [
  ref,
  directives
];

/*  */

function updateAttrs (oldVnode, vnode) {
  var opts = vnode.componentOptions;
  if (isDef(opts) && opts.Ctor.options.inheritAttrs === false) {
    return
  }
  if (isUndef(oldVnode.data.attrs) && isUndef(vnode.data.attrs)) {
    return
  }
  var key, cur, old;
  var elm = vnode.elm;
  var oldAttrs = oldVnode.data.attrs || {};
  var attrs = vnode.data.attrs || {};
  // clone observed objects, as the user probably wants to mutate it
  if (isDef(attrs.__ob__)) {
    attrs = vnode.data.attrs = extend({}, attrs);
  }

  for (key in attrs) {
    cur = attrs[key];
    old = oldAttrs[key];
    if (old !== cur) {
      setAttr(elm, key, cur);
    }
  }
  // #4391: in IE9, setting type can reset value for input[type=radio]
  // #6666: IE/Edge forces progress value down to 1 before setting a max
  /* istanbul ignore if */
  if ((isIE || isEdge) && attrs.value !== oldAttrs.value) {
    setAttr(elm, 'value', attrs.value);
  }
  for (key in oldAttrs) {
    if (isUndef(attrs[key])) {
      if (isXlink(key)) {
        elm.removeAttributeNS(xlinkNS, getXlinkProp(key));
      } else if (!isEnumeratedAttr(key)) {
        elm.removeAttribute(key);
      }
    }
  }
}

function setAttr (el, key, value) {
  if (el.tagName.indexOf('-') > -1) {
    baseSetAttr(el, key, value);
  } else if (isBooleanAttr(key)) {
    // set attribute for blank value
    // e.g. <option disabled>Select one</option>
    if (isFalsyAttrValue(value)) {
      el.removeAttribute(key);
    } else {
      // technically allowfullscreen is a boolean attribute for <iframe>,
      // but Flash expects a value of "true" when used on <embed> tag
      value = key === 'allowfullscreen' && el.tagName === 'EMBED'
        ? 'true'
        : key;
      el.setAttribute(key, value);
    }
  } else if (isEnumeratedAttr(key)) {
    el.setAttribute(key, convertEnumeratedValue(key, value));
  } else if (isXlink(key)) {
    if (isFalsyAttrValue(value)) {
      el.removeAttributeNS(xlinkNS, getXlinkProp(key));
    } else {
      el.setAttributeNS(xlinkNS, key, value);
    }
  } else {
    baseSetAttr(el, key, value);
  }
}

function baseSetAttr (el, key, value) {
  if (isFalsyAttrValue(value)) {
    el.removeAttribute(key);
  } else {
    // #7138: IE10 & 11 fires input event when setting placeholder on
    // <textarea>... block the first input event and remove the blocker
    // immediately.
    /* istanbul ignore if */
    if (
      isIE && !isIE9 &&
      el.tagName === 'TEXTAREA' &&
      key === 'placeholder' && value !== '' && !el.__ieph
    ) {
      var blocker = function (e) {
        e.stopImmediatePropagation();
        el.removeEventListener('input', blocker);
      };
      el.addEventListener('input', blocker);
      // $flow-disable-line
      el.__ieph = true; /* IE placeholder patched */
    }
    el.setAttribute(key, value);
  }
}

var attrs = {
  create: updateAttrs,
  update: updateAttrs
};

/*  */

function updateClass (oldVnode, vnode) {
  var el = vnode.elm;
  var data = vnode.data;
  var oldData = oldVnode.data;
  if (
    isUndef(data.staticClass) &&
    isUndef(data.class) && (
      isUndef(oldData) || (
        isUndef(oldData.staticClass) &&
        isUndef(oldData.class)
      )
    )
  ) {
    return
  }

  var cls = genClassForVnode(vnode);

  // handle transition classes
  var transitionClass = el._transitionClasses;
  if (isDef(transitionClass)) {
    cls = concat(cls, stringifyClass(transitionClass));
  }

  // set the class
  if (cls !== el._prevClass) {
    el.setAttribute('class', cls);
    el._prevClass = cls;
  }
}

var klass = {
  create: updateClass,
  update: updateClass
};

/*  */

var validDivisionCharRE = /[\w).+\-_$\]]/;

function parseFilters (exp) {
  var inSingle = false;
  var inDouble = false;
  var inTemplateString = false;
  var inRegex = false;
  var curly = 0;
  var square = 0;
  var paren = 0;
  var lastFilterIndex = 0;
  var c, prev, i, expression, filters;

  for (i = 0; i < exp.length; i++) {
    prev = c;
    c = exp.charCodeAt(i);
    if (inSingle) {
      if (c === 0x27 && prev !== 0x5C) { inSingle = false; }
    } else if (inDouble) {
      if (c === 0x22 && prev !== 0x5C) { inDouble = false; }
    } else if (inTemplateString) {
      if (c === 0x60 && prev !== 0x5C) { inTemplateString = false; }
    } else if (inRegex) {
      if (c === 0x2f && prev !== 0x5C) { inRegex = false; }
    } else if (
      c === 0x7C && // pipe
      exp.charCodeAt(i + 1) !== 0x7C &&
      exp.charCodeAt(i - 1) !== 0x7C &&
      !curly && !square && !paren
    ) {
      if (expression === undefined) {
        // first filter, end of expression
        lastFilterIndex = i + 1;
        expression = exp.slice(0, i).trim();
      } else {
        pushFilter();
      }
    } else {
      switch (c) {
        case 0x22: inDouble = true; break         // "
        case 0x27: inSingle = true; break         // '
        case 0x60: inTemplateString = true; break // `
        case 0x28: paren++; break                 // (
        case 0x29: paren--; break                 // )
        case 0x5B: square++; break                // [
        case 0x5D: square--; break                // ]
        case 0x7B: curly++; break                 // {
        case 0x7D: curly--; break                 // }
      }
      if (c === 0x2f) { // /
        var j = i - 1;
        var p = (void 0);
        // find first non-whitespace prev char
        for (; j >= 0; j--) {
          p = exp.charAt(j);
          if (p !== ' ') { break }
        }
        if (!p || !validDivisionCharRE.test(p)) {
          inRegex = true;
        }
      }
    }
  }

  if (expression === undefined) {
    expression = exp.slice(0, i).trim();
  } else if (lastFilterIndex !== 0) {
    pushFilter();
  }

  function pushFilter () {
    (filters || (filters = [])).push(exp.slice(lastFilterIndex, i).trim());
    lastFilterIndex = i + 1;
  }

  if (filters) {
    for (i = 0; i < filters.length; i++) {
      expression = wrapFilter(expression, filters[i]);
    }
  }

  return expression
}

function wrapFilter (exp, filter) {
  var i = filter.indexOf('(');
  if (i < 0) {
    // _f: resolveFilter
    return ("_f(\"" + filter + "\")(" + exp + ")")
  } else {
    var name = filter.slice(0, i);
    var args = filter.slice(i + 1);
    return ("_f(\"" + name + "\")(" + exp + (args !== ')' ? ',' + args : args))
  }
}

/*  */



/* eslint-disable no-unused-vars */
function baseWarn (msg, range) {
  console.error(("[Vue compiler]: " + msg));
}
/* eslint-enable no-unused-vars */

function pluckModuleFunction (
  modules,
  key
) {
  return modules
    ? modules.map(function (m) { return m[key]; }).filter(function (_) { return _; })
    : []
}

function addProp (el, name, value, range, dynamic) {
  (el.props || (el.props = [])).push(rangeSetItem({ name: name, value: value, dynamic: dynamic }, range));
  el.plain = false;
}

function addAttr (el, name, value, range, dynamic) {
  var attrs = dynamic
    ? (el.dynamicAttrs || (el.dynamicAttrs = []))
    : (el.attrs || (el.attrs = []));
  attrs.push(rangeSetItem({ name: name, value: value, dynamic: dynamic }, range));
  el.plain = false;
}

// add a raw attr (use this in preTransforms)
function addRawAttr (el, name, value, range) {
  el.attrsMap[name] = value;
  el.attrsList.push(rangeSetItem({ name: name, value: value }, range));
}

function addDirective (
  el,
  name,
  rawName,
  value,
  arg,
  isDynamicArg,
  modifiers,
  range
) {
  (el.directives || (el.directives = [])).push(rangeSetItem({
    name: name,
    rawName: rawName,
    value: value,
    arg: arg,
    isDynamicArg: isDynamicArg,
    modifiers: modifiers
  }, range));
  el.plain = false;
}

function prependModifierMarker (symbol, name, dynamic) {
  return dynamic
    ? ("_p(" + name + ",\"" + symbol + "\")")
    : symbol + name // mark the event as captured
}

function addHandler (
  el,
  name,
  value,
  modifiers,
  important,
  warn,
  range,
  dynamic
) {
  modifiers = modifiers || emptyObject;
  // warn prevent and passive modifier
  /* istanbul ignore if */
  if (
    false
  ) {
    warn(
      'passive and prevent can\'t be used together. ' +
      'Passive handler can\'t prevent default event.',
      range
    );
  }

  // normalize click.right and click.middle since they don't actually fire
  // this is technically browser-specific, but at least for now browsers are
  // the only target envs that have right/middle clicks.
  if (modifiers.right) {
    if (dynamic) {
      name = "(" + name + ")==='click'?'contextmenu':(" + name + ")";
    } else if (name === 'click') {
      name = 'contextmenu';
      delete modifiers.right;
    }
  } else if (modifiers.middle) {
    if (dynamic) {
      name = "(" + name + ")==='click'?'mouseup':(" + name + ")";
    } else if (name === 'click') {
      name = 'mouseup';
    }
  }

  // check capture modifier
  if (modifiers.capture) {
    delete modifiers.capture;
    name = prependModifierMarker('!', name, dynamic);
  }
  if (modifiers.once) {
    delete modifiers.once;
    name = prependModifierMarker('~', name, dynamic);
  }
  /* istanbul ignore if */
  if (modifiers.passive) {
    delete modifiers.passive;
    name = prependModifierMarker('&', name, dynamic);
  }

  var events;
  if (modifiers.native) {
    delete modifiers.native;
    events = el.nativeEvents || (el.nativeEvents = {});
  } else {
    events = el.events || (el.events = {});
  }

  var newHandler = rangeSetItem({ value: value.trim(), dynamic: dynamic }, range);
  if (modifiers !== emptyObject) {
    newHandler.modifiers = modifiers;
  }

  var handlers = events[name];
  /* istanbul ignore if */
  if (Array.isArray(handlers)) {
    important ? handlers.unshift(newHandler) : handlers.push(newHandler);
  } else if (handlers) {
    events[name] = important ? [newHandler, handlers] : [handlers, newHandler];
  } else {
    events[name] = newHandler;
  }

  el.plain = false;
}

function getRawBindingAttr (
  el,
  name
) {
  return el.rawAttrsMap[':' + name] ||
    el.rawAttrsMap['v-bind:' + name] ||
    el.rawAttrsMap[name]
}

function getBindingAttr (
  el,
  name,
  getStatic
) {
  var dynamicValue =
    getAndRemoveAttr(el, ':' + name) ||
    getAndRemoveAttr(el, 'v-bind:' + name);
  if (dynamicValue != null) {
    return parseFilters(dynamicValue)
  } else if (getStatic !== false) {
    var staticValue = getAndRemoveAttr(el, name);
    if (staticValue != null) {
      return JSON.stringify(staticValue)
    }
  }
}

// note: this only removes the attr from the Array (attrsList) so that it
// doesn't get processed by processAttrs.
// By default it does NOT remove it from the map (attrsMap) because the map is
// needed during codegen.
function getAndRemoveAttr (
  el,
  name,
  removeFromMap
) {
  var val;
  if ((val = el.attrsMap[name]) != null) {
    var list = el.attrsList;
    for (var i = 0, l = list.length; i < l; i++) {
      if (list[i].name === name) {
        list.splice(i, 1);
        break
      }
    }
  }
  if (removeFromMap) {
    delete el.attrsMap[name];
  }
  return val
}

function getAndRemoveAttrByRegex (
  el,
  name
) {
  var list = el.attrsList;
  for (var i = 0, l = list.length; i < l; i++) {
    var attr = list[i];
    if (name.test(attr.name)) {
      list.splice(i, 1);
      return attr
    }
  }
}

function rangeSetItem (
  item,
  range
) {
  if (range) {
    if (range.start != null) {
      item.start = range.start;
    }
    if (range.end != null) {
      item.end = range.end;
    }
  }
  return item
}

/*  */

/**
 * Cross-platform code generation for component v-model
 */
function genComponentModel (
  el,
  value,
  modifiers
) {
  var ref = modifiers || {};
  var number = ref.number;
  var trim = ref.trim;

  var baseValueExpression = '$$v';
  var valueExpression = baseValueExpression;
  if (trim) {
    valueExpression =
      "(typeof " + baseValueExpression + " === 'string'" +
      "? " + baseValueExpression + ".trim()" +
      ": " + baseValueExpression + ")";
  }
  if (number) {
    valueExpression = "_n(" + valueExpression + ")";
  }
  var assignment = genAssignmentCode(value, valueExpression);

  el.model = {
    value: ("(" + value + ")"),
    expression: JSON.stringify(value),
    callback: ("function (" + baseValueExpression + ") {" + assignment + "}")
  };
}

/**
 * Cross-platform codegen helper for generating v-model value assignment code.
 */
function genAssignmentCode (
  value,
  assignment
) {
  var res = parseModel(value);
  if (res.key === null) {
    return (value + "=" + assignment)
  } else {
    return ("$set(" + (res.exp) + ", " + (res.key) + ", " + assignment + ")")
  }
}

/**
 * Parse a v-model expression into a base path and a final key segment.
 * Handles both dot-path and possible square brackets.
 *
 * Possible cases:
 *
 * - test
 * - test[key]
 * - test[test1[key]]
 * - test["a"][key]
 * - xxx.test[a[a].test1[key]]
 * - test.xxx.a["asa"][test1[key]]
 *
 */

var len, str, chr, index$1, expressionPos, expressionEndPos;



function parseModel (val) {
  // Fix https://github.com/vuejs/vue/pull/7730
  // allow v-model="obj.val " (trailing whitespace)
  val = val.trim();
  len = val.length;

  if (val.indexOf('[') < 0 || val.lastIndexOf(']') < len - 1) {
    index$1 = val.lastIndexOf('.');
    if (index$1 > -1) {
      return {
        exp: val.slice(0, index$1),
        key: '"' + val.slice(index$1 + 1) + '"'
      }
    } else {
      return {
        exp: val,
        key: null
      }
    }
  }

  str = val;
  index$1 = expressionPos = expressionEndPos = 0;

  while (!eof()) {
    chr = next();
    /* istanbul ignore if */
    if (isStringStart(chr)) {
      parseString(chr);
    } else if (chr === 0x5B) {
      parseBracket(chr);
    }
  }

  return {
    exp: val.slice(0, expressionPos),
    key: val.slice(expressionPos + 1, expressionEndPos)
  }
}

function next () {
  return str.charCodeAt(++index$1)
}

function eof () {
  return index$1 >= len
}

function isStringStart (chr) {
  return chr === 0x22 || chr === 0x27
}

function parseBracket (chr) {
  var inBracket = 1;
  expressionPos = index$1;
  while (!eof()) {
    chr = next();
    if (isStringStart(chr)) {
      parseString(chr);
      continue
    }
    if (chr === 0x5B) { inBracket++; }
    if (chr === 0x5D) { inBracket--; }
    if (inBracket === 0) {
      expressionEndPos = index$1;
      break
    }
  }
}

function parseString (chr) {
  var stringQuote = chr;
  while (!eof()) {
    chr = next();
    if (chr === stringQuote) {
      break
    }
  }
}

/*  */

var warn$1;

// in some cases, the event used has to be determined at runtime
// so we used some reserved tokens during compile.
var RANGE_TOKEN = '__r';
var CHECKBOX_RADIO_TOKEN = '__c';

function model (
  el,
  dir,
  _warn
) {
  warn$1 = _warn;
  var value = dir.value;
  var modifiers = dir.modifiers;
  var tag = el.tag;
  var type = el.attrsMap.type;

  if (false) {
    // inputs with type="file" are read only and setting the input's
    // value will throw an error.
    if (tag === 'input' && type === 'file') {
      warn$1(
        "<" + (el.tag) + " v-model=\"" + value + "\" type=\"file\">:\n" +
        "File inputs are read only. Use a v-on:change listener instead.",
        el.rawAttrsMap['v-model']
      );
    }
  }

  if (el.component) {
    genComponentModel(el, value, modifiers);
    // component v-model doesn't need extra runtime
    return false
  } else if (tag === 'select') {
    genSelect(el, value, modifiers);
  } else if (tag === 'input' && type === 'checkbox') {
    genCheckboxModel(el, value, modifiers);
  } else if (tag === 'input' && type === 'radio') {
    genRadioModel(el, value, modifiers);
  } else if (tag === 'input' || tag === 'textarea') {
    genDefaultModel(el, value, modifiers);
  } else if (!config.isReservedTag(tag)) {
    genComponentModel(el, value, modifiers);
    // component v-model doesn't need extra runtime
    return false
  } else if (false) {
    warn$1(
      "<" + (el.tag) + " v-model=\"" + value + "\">: " +
      "v-model is not supported on this element type. " +
      'If you are working with contenteditable, it\'s recommended to ' +
      'wrap a library dedicated for that purpose inside a custom component.',
      el.rawAttrsMap['v-model']
    );
  }

  // ensure runtime directive metadata
  return true
}

function genCheckboxModel (
  el,
  value,
  modifiers
) {
  var number = modifiers && modifiers.number;
  var valueBinding = getBindingAttr(el, 'value') || 'null';
  var trueValueBinding = getBindingAttr(el, 'true-value') || 'true';
  var falseValueBinding = getBindingAttr(el, 'false-value') || 'false';
  addProp(el, 'checked',
    "Array.isArray(" + value + ")" +
    "?_i(" + value + "," + valueBinding + ")>-1" + (
      trueValueBinding === 'true'
        ? (":(" + value + ")")
        : (":_q(" + value + "," + trueValueBinding + ")")
    )
  );
  addHandler(el, 'change',
    "var $$a=" + value + "," +
        '$$el=$event.target,' +
        "$$c=$$el.checked?(" + trueValueBinding + "):(" + falseValueBinding + ");" +
    'if(Array.isArray($$a)){' +
      "var $$v=" + (number ? '_n(' + valueBinding + ')' : valueBinding) + "," +
          '$$i=_i($$a,$$v);' +
      "if($$el.checked){$$i<0&&(" + (genAssignmentCode(value, '$$a.concat([$$v])')) + ")}" +
      "else{$$i>-1&&(" + (genAssignmentCode(value, '$$a.slice(0,$$i).concat($$a.slice($$i+1))')) + ")}" +
    "}else{" + (genAssignmentCode(value, '$$c')) + "}",
    null, true
  );
}

function genRadioModel (
  el,
  value,
  modifiers
) {
  var number = modifiers && modifiers.number;
  var valueBinding = getBindingAttr(el, 'value') || 'null';
  valueBinding = number ? ("_n(" + valueBinding + ")") : valueBinding;
  addProp(el, 'checked', ("_q(" + value + "," + valueBinding + ")"));
  addHandler(el, 'change', genAssignmentCode(value, valueBinding), null, true);
}

function genSelect (
  el,
  value,
  modifiers
) {
  var number = modifiers && modifiers.number;
  var selectedVal = "Array.prototype.filter" +
    ".call($event.target.options,function(o){return o.selected})" +
    ".map(function(o){var val = \"_value\" in o ? o._value : o.value;" +
    "return " + (number ? '_n(val)' : 'val') + "})";

  var assignment = '$event.target.multiple ? $$selectedVal : $$selectedVal[0]';
  var code = "var $$selectedVal = " + selectedVal + ";";
  code = code + " " + (genAssignmentCode(value, assignment));
  addHandler(el, 'change', code, null, true);
}

function genDefaultModel (
  el,
  value,
  modifiers
) {
  var type = el.attrsMap.type;

  // warn if v-bind:value conflicts with v-model
  // except for inputs with v-bind:type
  if (false) {
    var value$1 = el.attrsMap['v-bind:value'] || el.attrsMap[':value'];
    var typeBinding = el.attrsMap['v-bind:type'] || el.attrsMap[':type'];
    if (value$1 && !typeBinding) {
      var binding = el.attrsMap['v-bind:value'] ? 'v-bind:value' : ':value';
      warn$1(
        binding + "=\"" + value$1 + "\" conflicts with v-model on the same element " +
        'because the latter already expands to a value binding internally',
        el.rawAttrsMap[binding]
      );
    }
  }

  var ref = modifiers || {};
  var lazy = ref.lazy;
  var number = ref.number;
  var trim = ref.trim;
  var needCompositionGuard = !lazy && type !== 'range';
  var event = lazy
    ? 'change'
    : type === 'range'
      ? RANGE_TOKEN
      : 'input';

  var valueExpression = '$event.target.value';
  if (trim) {
    valueExpression = "$event.target.value.trim()";
  }
  if (number) {
    valueExpression = "_n(" + valueExpression + ")";
  }

  var code = genAssignmentCode(value, valueExpression);
  if (needCompositionGuard) {
    code = "if($event.target.composing)return;" + code;
  }

  addProp(el, 'value', ("(" + value + ")"));
  addHandler(el, event, code, null, true);
  if (trim || number) {
    addHandler(el, 'blur', '$forceUpdate()');
  }
}

/*  */

// normalize v-model event tokens that can only be determined at runtime.
// it's important to place the event as the first in the array because
// the whole point is ensuring the v-model callback gets called before
// user-attached handlers.
function normalizeEvents (on) {
  /* istanbul ignore if */
  if (isDef(on[RANGE_TOKEN])) {
    // IE input[type=range] only supports `change` event
    var event = isIE ? 'change' : 'input';
    on[event] = [].concat(on[RANGE_TOKEN], on[event] || []);
    delete on[RANGE_TOKEN];
  }
  // This was originally intended to fix #4521 but no longer necessary
  // after 2.5. Keeping it for backwards compat with generated code from < 2.4
  /* istanbul ignore if */
  if (isDef(on[CHECKBOX_RADIO_TOKEN])) {
    on.change = [].concat(on[CHECKBOX_RADIO_TOKEN], on.change || []);
    delete on[CHECKBOX_RADIO_TOKEN];
  }
}

var target$1;

function createOnceHandler$1 (event, handler, capture) {
  var _target = target$1; // save current target element in closure
  return function onceHandler () {
    var res = handler.apply(null, arguments);
    if (res !== null) {
      remove$2(event, onceHandler, capture, _target);
    }
  }
}

// #9446: Firefox <= 53 (in particular, ESR 52) has incorrect Event.timeStamp
// implementation and does not fire microtasks in between event propagation, so
// safe to exclude.
var useMicrotaskFix = isUsingMicroTask && !(isFF && Number(isFF[1]) <= 53);

function add$1 (
  name,
  handler,
  capture,
  passive
) {
  // async edge case #6566: inner click event triggers patch, event handler
  // attached to outer element during patch, and triggered again. This
  // happens because browsers fire microtask ticks between event propagation.
  // the solution is simple: we save the timestamp when a handler is attached,
  // and the handler would only fire if the event passed to it was fired
  // AFTER it was attached.
  if (useMicrotaskFix) {
    var attachedTimestamp = currentFlushTimestamp;
    var original = handler;
    handler = original._wrapper = function (e) {
      if (
        // no bubbling, should always fire.
        // this is just a safety net in case event.timeStamp is unreliable in
        // certain weird environments...
        e.target === e.currentTarget ||
        // event is fired after handler attachment
        e.timeStamp >= attachedTimestamp ||
        // bail for environments that have buggy event.timeStamp implementations
        // #9462 iOS 9 bug: event.timeStamp is 0 after history.pushState
        // #9681 QtWebEngine event.timeStamp is negative value
        e.timeStamp <= 0 ||
        // #9448 bail if event is fired in another document in a multi-page
        // electron/nw.js app, since event.timeStamp will be using a different
        // starting reference
        e.target.ownerDocument !== document
      ) {
        return original.apply(this, arguments)
      }
    };
  }
  target$1.addEventListener(
    name,
    handler,
    supportsPassive
      ? { capture: capture, passive: passive }
      : capture
  );
}

function remove$2 (
  name,
  handler,
  capture,
  _target
) {
  (_target || target$1).removeEventListener(
    name,
    handler._wrapper || handler,
    capture
  );
}

function updateDOMListeners (oldVnode, vnode) {
  if (isUndef(oldVnode.data.on) && isUndef(vnode.data.on)) {
    return
  }
  var on = vnode.data.on || {};
  var oldOn = oldVnode.data.on || {};
  target$1 = vnode.elm;
  normalizeEvents(on);
  updateListeners(on, oldOn, add$1, remove$2, createOnceHandler$1, vnode.context);
  target$1 = undefined;
}

var events = {
  create: updateDOMListeners,
  update: updateDOMListeners
};

/*  */

var svgContainer;

function updateDOMProps (oldVnode, vnode) {
  if (isUndef(oldVnode.data.domProps) && isUndef(vnode.data.domProps)) {
    return
  }
  var key, cur;
  var elm = vnode.elm;
  var oldProps = oldVnode.data.domProps || {};
  var props = vnode.data.domProps || {};
  // clone observed objects, as the user probably wants to mutate it
  if (isDef(props.__ob__)) {
    props = vnode.data.domProps = extend({}, props);
  }

  for (key in oldProps) {
    if (!(key in props)) {
      elm[key] = '';
    }
  }

  for (key in props) {
    cur = props[key];
    // ignore children if the node has textContent or innerHTML,
    // as these will throw away existing DOM nodes and cause removal errors
    // on subsequent patches (#3360)
    if (key === 'textContent' || key === 'innerHTML') {
      if (vnode.children) { vnode.children.length = 0; }
      if (cur === oldProps[key]) { continue }
      // #6601 work around Chrome version <= 55 bug where single textNode
      // replaced by innerHTML/textContent retains its parentNode property
      if (elm.childNodes.length === 1) {
        elm.removeChild(elm.childNodes[0]);
      }
    }

    if (key === 'value' && elm.tagName !== 'PROGRESS') {
      // store value as _value as well since
      // non-string values will be stringified
      elm._value = cur;
      // avoid resetting cursor position when value is the same
      var strCur = isUndef(cur) ? '' : String(cur);
      if (shouldUpdateValue(elm, strCur)) {
        elm.value = strCur;
      }
    } else if (key === 'innerHTML' && isSVG(elm.tagName) && isUndef(elm.innerHTML)) {
      // IE doesn't support innerHTML for SVG elements
      svgContainer = svgContainer || document.createElement('div');
      svgContainer.innerHTML = "<svg>" + cur + "</svg>";
      var svg = svgContainer.firstChild;
      while (elm.firstChild) {
        elm.removeChild(elm.firstChild);
      }
      while (svg.firstChild) {
        elm.appendChild(svg.firstChild);
      }
    } else if (
      // skip the update if old and new VDOM state is the same.
      // `value` is handled separately because the DOM value may be temporarily
      // out of sync with VDOM state due to focus, composition and modifiers.
      // This  #4521 by skipping the unnecessary `checked` update.
      cur !== oldProps[key]
    ) {
      // some property updates can throw
      // e.g. `value` on <progress> w/ non-finite value
      try {
        elm[key] = cur;
      } catch (e) {}
    }
  }
}

// check platforms/web/util/attrs.js acceptValue


function shouldUpdateValue (elm, checkVal) {
  return (!elm.composing && (
    elm.tagName === 'OPTION' ||
    isNotInFocusAndDirty(elm, checkVal) ||
    isDirtyWithModifiers(elm, checkVal)
  ))
}

function isNotInFocusAndDirty (elm, checkVal) {
  // return true when textbox (.number and .trim) loses focus and its value is
  // not equal to the updated value
  var notInFocus = true;
  // #6157
  // work around IE bug when accessing document.activeElement in an iframe
  try { notInFocus = document.activeElement !== elm; } catch (e) {}
  return notInFocus && elm.value !== checkVal
}

function isDirtyWithModifiers (elm, newVal) {
  var value = elm.value;
  var modifiers = elm._vModifiers; // injected by v-model runtime
  if (isDef(modifiers)) {
    if (modifiers.number) {
      return toNumber(value) !== toNumber(newVal)
    }
    if (modifiers.trim) {
      return value.trim() !== newVal.trim()
    }
  }
  return value !== newVal
}

var domProps = {
  create: updateDOMProps,
  update: updateDOMProps
};

/*  */

var parseStyleText = cached(function (cssText) {
  var res = {};
  var listDelimiter = /;(?![^(]*\))/g;
  var propertyDelimiter = /:(.+)/;
  cssText.split(listDelimiter).forEach(function (item) {
    if (item) {
      var tmp = item.split(propertyDelimiter);
      tmp.length > 1 && (res[tmp[0].trim()] = tmp[1].trim());
    }
  });
  return res
});

// merge static and dynamic style data on the same vnode
function normalizeStyleData (data) {
  var style = normalizeStyleBinding(data.style);
  // static style is pre-processed into an object during compilation
  // and is always a fresh object, so it's safe to merge into it
  return data.staticStyle
    ? extend(data.staticStyle, style)
    : style
}

// normalize possible array / string values into Object
function normalizeStyleBinding (bindingStyle) {
  if (Array.isArray(bindingStyle)) {
    return toObject(bindingStyle)
  }
  if (typeof bindingStyle === 'string') {
    return parseStyleText(bindingStyle)
  }
  return bindingStyle
}

/**
 * parent component style should be after child's
 * so that parent component's style could override it
 */
function getStyle (vnode, checkChild) {
  var res = {};
  var styleData;

  if (checkChild) {
    var childNode = vnode;
    while (childNode.componentInstance) {
      childNode = childNode.componentInstance._vnode;
      if (
        childNode && childNode.data &&
        (styleData = normalizeStyleData(childNode.data))
      ) {
        extend(res, styleData);
      }
    }
  }

  if ((styleData = normalizeStyleData(vnode.data))) {
    extend(res, styleData);
  }

  var parentNode = vnode;
  while ((parentNode = parentNode.parent)) {
    if (parentNode.data && (styleData = normalizeStyleData(parentNode.data))) {
      extend(res, styleData);
    }
  }
  return res
}

/*  */

var cssVarRE = /^--/;
var importantRE = /\s*!important$/;
var setProp = function (el, name, val) {
  /* istanbul ignore if */
  if (cssVarRE.test(name)) {
    el.style.setProperty(name, val);
  } else if (importantRE.test(val)) {
    el.style.setProperty(hyphenate(name), val.replace(importantRE, ''), 'important');
  } else {
    var normalizedName = normalize(name);
    if (Array.isArray(val)) {
      // Support values array created by autoprefixer, e.g.
      // {display: ["-webkit-box", "-ms-flexbox", "flex"]}
      // Set them one by one, and the browser will only set those it can recognize
      for (var i = 0, len = val.length; i < len; i++) {
        el.style[normalizedName] = val[i];
      }
    } else {
      el.style[normalizedName] = val;
    }
  }
};

var vendorNames = ['Webkit', 'Moz', 'ms'];

var emptyStyle;
var normalize = cached(function (prop) {
  emptyStyle = emptyStyle || document.createElement('div').style;
  prop = camelize(prop);
  if (prop !== 'filter' && (prop in emptyStyle)) {
    return prop
  }
  var capName = prop.charAt(0).toUpperCase() + prop.slice(1);
  for (var i = 0; i < vendorNames.length; i++) {
    var name = vendorNames[i] + capName;
    if (name in emptyStyle) {
      return name
    }
  }
});

function updateStyle (oldVnode, vnode) {
  var data = vnode.data;
  var oldData = oldVnode.data;

  if (isUndef(data.staticStyle) && isUndef(data.style) &&
    isUndef(oldData.staticStyle) && isUndef(oldData.style)
  ) {
    return
  }

  var cur, name;
  var el = vnode.elm;
  var oldStaticStyle = oldData.staticStyle;
  var oldStyleBinding = oldData.normalizedStyle || oldData.style || {};

  // if static style exists, stylebinding already merged into it when doing normalizeStyleData
  var oldStyle = oldStaticStyle || oldStyleBinding;

  var style = normalizeStyleBinding(vnode.data.style) || {};

  // store normalized style under a different key for next diff
  // make sure to clone it if it's reactive, since the user likely wants
  // to mutate it.
  vnode.data.normalizedStyle = isDef(style.__ob__)
    ? extend({}, style)
    : style;

  var newStyle = getStyle(vnode, true);

  for (name in oldStyle) {
    if (isUndef(newStyle[name])) {
      setProp(el, name, '');
    }
  }
  for (name in newStyle) {
    cur = newStyle[name];
    if (cur !== oldStyle[name]) {
      // ie9 setting to null has no effect, must use empty string
      setProp(el, name, cur == null ? '' : cur);
    }
  }
}

var style = {
  create: updateStyle,
  update: updateStyle
};

/*  */

var whitespaceRE = /\s+/;

/**
 * Add class with compatibility for SVG since classList is not supported on
 * SVG elements in IE
 */
function addClass (el, cls) {
  /* istanbul ignore if */
  if (!cls || !(cls = cls.trim())) {
    return
  }

  /* istanbul ignore else */
  if (el.classList) {
    if (cls.indexOf(' ') > -1) {
      cls.split(whitespaceRE).forEach(function (c) { return el.classList.add(c); });
    } else {
      el.classList.add(cls);
    }
  } else {
    var cur = " " + (el.getAttribute('class') || '') + " ";
    if (cur.indexOf(' ' + cls + ' ') < 0) {
      el.setAttribute('class', (cur + cls).trim());
    }
  }
}

/**
 * Remove class with compatibility for SVG since classList is not supported on
 * SVG elements in IE
 */
function removeClass (el, cls) {
  /* istanbul ignore if */
  if (!cls || !(cls = cls.trim())) {
    return
  }

  /* istanbul ignore else */
  if (el.classList) {
    if (cls.indexOf(' ') > -1) {
      cls.split(whitespaceRE).forEach(function (c) { return el.classList.remove(c); });
    } else {
      el.classList.remove(cls);
    }
    if (!el.classList.length) {
      el.removeAttribute('class');
    }
  } else {
    var cur = " " + (el.getAttribute('class') || '') + " ";
    var tar = ' ' + cls + ' ';
    while (cur.indexOf(tar) >= 0) {
      cur = cur.replace(tar, ' ');
    }
    cur = cur.trim();
    if (cur) {
      el.setAttribute('class', cur);
    } else {
      el.removeAttribute('class');
    }
  }
}

/*  */

function resolveTransition (def$$1) {
  if (!def$$1) {
    return
  }
  /* istanbul ignore else */
  if (typeof def$$1 === 'object') {
    var res = {};
    if (def$$1.css !== false) {
      extend(res, autoCssTransition(def$$1.name || 'v'));
    }
    extend(res, def$$1);
    return res
  } else if (typeof def$$1 === 'string') {
    return autoCssTransition(def$$1)
  }
}

var autoCssTransition = cached(function (name) {
  return {
    enterClass: (name + "-enter"),
    enterToClass: (name + "-enter-to"),
    enterActiveClass: (name + "-enter-active"),
    leaveClass: (name + "-leave"),
    leaveToClass: (name + "-leave-to"),
    leaveActiveClass: (name + "-leave-active")
  }
});

var hasTransition = inBrowser && !isIE9;
var TRANSITION = 'transition';
var ANIMATION = 'animation';

// Transition property/event sniffing
var transitionProp = 'transition';
var transitionEndEvent = 'transitionend';
var animationProp = 'animation';
var animationEndEvent = 'animationend';
if (hasTransition) {
  /* istanbul ignore if */
  if (window.ontransitionend === undefined &&
    window.onwebkittransitionend !== undefined
  ) {
    transitionProp = 'WebkitTransition';
    transitionEndEvent = 'webkitTransitionEnd';
  }
  if (window.onanimationend === undefined &&
    window.onwebkitanimationend !== undefined
  ) {
    animationProp = 'WebkitAnimation';
    animationEndEvent = 'webkitAnimationEnd';
  }
}

// binding to window is necessary to make hot reload work in IE in strict mode
var raf = inBrowser
  ? window.requestAnimationFrame
    ? window.requestAnimationFrame.bind(window)
    : setTimeout
  : /* istanbul ignore next */ function (fn) { return fn(); };

function nextFrame (fn) {
  raf(function () {
    raf(fn);
  });
}

function addTransitionClass (el, cls) {
  var transitionClasses = el._transitionClasses || (el._transitionClasses = []);
  if (transitionClasses.indexOf(cls) < 0) {
    transitionClasses.push(cls);
    addClass(el, cls);
  }
}

function removeTransitionClass (el, cls) {
  if (el._transitionClasses) {
    remove(el._transitionClasses, cls);
  }
  removeClass(el, cls);
}

function whenTransitionEnds (
  el,
  expectedType,
  cb
) {
  var ref = getTransitionInfo(el, expectedType);
  var type = ref.type;
  var timeout = ref.timeout;
  var propCount = ref.propCount;
  if (!type) { return cb() }
  var event = type === TRANSITION ? transitionEndEvent : animationEndEvent;
  var ended = 0;
  var end = function () {
    el.removeEventListener(event, onEnd);
    cb();
  };
  var onEnd = function (e) {
    if (e.target === el) {
      if (++ended >= propCount) {
        end();
      }
    }
  };
  setTimeout(function () {
    if (ended < propCount) {
      end();
    }
  }, timeout + 1);
  el.addEventListener(event, onEnd);
}

var transformRE = /\b(transform|all)(,|$)/;

function getTransitionInfo (el, expectedType) {
  var styles = window.getComputedStyle(el);
  // JSDOM may return undefined for transition properties
  var transitionDelays = (styles[transitionProp + 'Delay'] || '').split(', ');
  var transitionDurations = (styles[transitionProp + 'Duration'] || '').split(', ');
  var transitionTimeout = getTimeout(transitionDelays, transitionDurations);
  var animationDelays = (styles[animationProp + 'Delay'] || '').split(', ');
  var animationDurations = (styles[animationProp + 'Duration'] || '').split(', ');
  var animationTimeout = getTimeout(animationDelays, animationDurations);

  var type;
  var timeout = 0;
  var propCount = 0;
  /* istanbul ignore if */
  if (expectedType === TRANSITION) {
    if (transitionTimeout > 0) {
      type = TRANSITION;
      timeout = transitionTimeout;
      propCount = transitionDurations.length;
    }
  } else if (expectedType === ANIMATION) {
    if (animationTimeout > 0) {
      type = ANIMATION;
      timeout = animationTimeout;
      propCount = animationDurations.length;
    }
  } else {
    timeout = Math.max(transitionTimeout, animationTimeout);
    type = timeout > 0
      ? transitionTimeout > animationTimeout
        ? TRANSITION
        : ANIMATION
      : null;
    propCount = type
      ? type === TRANSITION
        ? transitionDurations.length
        : animationDurations.length
      : 0;
  }
  var hasTransform =
    type === TRANSITION &&
    transformRE.test(styles[transitionProp + 'Property']);
  return {
    type: type,
    timeout: timeout,
    propCount: propCount,
    hasTransform: hasTransform
  }
}

function getTimeout (delays, durations) {
  /* istanbul ignore next */
  while (delays.length < durations.length) {
    delays = delays.concat(delays);
  }

  return Math.max.apply(null, durations.map(function (d, i) {
    return toMs(d) + toMs(delays[i])
  }))
}

// Old versions of Chromium (below 61.0.3163.100) formats floating pointer numbers
// in a locale-dependent way, using a comma instead of a dot.
// If comma is not replaced with a dot, the input will be rounded down (i.e. acting
// as a floor function) causing unexpected behaviors
function toMs (s) {
  return Number(s.slice(0, -1).replace(',', '.')) * 1000
}

/*  */

function enter (vnode, toggleDisplay) {
  var el = vnode.elm;

  // call leave callback now
  if (isDef(el._leaveCb)) {
    el._leaveCb.cancelled = true;
    el._leaveCb();
  }

  var data = resolveTransition(vnode.data.transition);
  if (isUndef(data)) {
    return
  }

  /* istanbul ignore if */
  if (isDef(el._enterCb) || el.nodeType !== 1) {
    return
  }

  var css = data.css;
  var type = data.type;
  var enterClass = data.enterClass;
  var enterToClass = data.enterToClass;
  var enterActiveClass = data.enterActiveClass;
  var appearClass = data.appearClass;
  var appearToClass = data.appearToClass;
  var appearActiveClass = data.appearActiveClass;
  var beforeEnter = data.beforeEnter;
  var enter = data.enter;
  var afterEnter = data.afterEnter;
  var enterCancelled = data.enterCancelled;
  var beforeAppear = data.beforeAppear;
  var appear = data.appear;
  var afterAppear = data.afterAppear;
  var appearCancelled = data.appearCancelled;
  var duration = data.duration;

  // activeInstance will always be the <transition> component managing this
  // transition. One edge case to check is when the <transition> is placed
  // as the root node of a child component. In that case we need to check
  // <transition>'s parent for appear check.
  var context = activeInstance;
  var transitionNode = activeInstance.$vnode;
  while (transitionNode && transitionNode.parent) {
    context = transitionNode.context;
    transitionNode = transitionNode.parent;
  }

  var isAppear = !context._isMounted || !vnode.isRootInsert;

  if (isAppear && !appear && appear !== '') {
    return
  }

  var startClass = isAppear && appearClass
    ? appearClass
    : enterClass;
  var activeClass = isAppear && appearActiveClass
    ? appearActiveClass
    : enterActiveClass;
  var toClass = isAppear && appearToClass
    ? appearToClass
    : enterToClass;

  var beforeEnterHook = isAppear
    ? (beforeAppear || beforeEnter)
    : beforeEnter;
  var enterHook = isAppear
    ? (typeof appear === 'function' ? appear : enter)
    : enter;
  var afterEnterHook = isAppear
    ? (afterAppear || afterEnter)
    : afterEnter;
  var enterCancelledHook = isAppear
    ? (appearCancelled || enterCancelled)
    : enterCancelled;

  var explicitEnterDuration = toNumber(
    isObject(duration)
      ? duration.enter
      : duration
  );

  if (false) {
    checkDuration(explicitEnterDuration, 'enter', vnode);
  }

  var expectsCSS = css !== false && !isIE9;
  var userWantsControl = getHookArgumentsLength(enterHook);

  var cb = el._enterCb = once(function () {
    if (expectsCSS) {
      removeTransitionClass(el, toClass);
      removeTransitionClass(el, activeClass);
    }
    if (cb.cancelled) {
      if (expectsCSS) {
        removeTransitionClass(el, startClass);
      }
      enterCancelledHook && enterCancelledHook(el);
    } else {
      afterEnterHook && afterEnterHook(el);
    }
    el._enterCb = null;
  });

  if (!vnode.data.show) {
    // remove pending leave element on enter by injecting an insert hook
    mergeVNodeHook(vnode, 'insert', function () {
      var parent = el.parentNode;
      var pendingNode = parent && parent._pending && parent._pending[vnode.key];
      if (pendingNode &&
        pendingNode.tag === vnode.tag &&
        pendingNode.elm._leaveCb
      ) {
        pendingNode.elm._leaveCb();
      }
      enterHook && enterHook(el, cb);
    });
  }

  // start enter transition
  beforeEnterHook && beforeEnterHook(el);
  if (expectsCSS) {
    addTransitionClass(el, startClass);
    addTransitionClass(el, activeClass);
    nextFrame(function () {
      removeTransitionClass(el, startClass);
      if (!cb.cancelled) {
        addTransitionClass(el, toClass);
        if (!userWantsControl) {
          if (isValidDuration(explicitEnterDuration)) {
            setTimeout(cb, explicitEnterDuration);
          } else {
            whenTransitionEnds(el, type, cb);
          }
        }
      }
    });
  }

  if (vnode.data.show) {
    toggleDisplay && toggleDisplay();
    enterHook && enterHook(el, cb);
  }

  if (!expectsCSS && !userWantsControl) {
    cb();
  }
}

function leave (vnode, rm) {
  var el = vnode.elm;

  // call enter callback now
  if (isDef(el._enterCb)) {
    el._enterCb.cancelled = true;
    el._enterCb();
  }

  var data = resolveTransition(vnode.data.transition);
  if (isUndef(data) || el.nodeType !== 1) {
    return rm()
  }

  /* istanbul ignore if */
  if (isDef(el._leaveCb)) {
    return
  }

  var css = data.css;
  var type = data.type;
  var leaveClass = data.leaveClass;
  var leaveToClass = data.leaveToClass;
  var leaveActiveClass = data.leaveActiveClass;
  var beforeLeave = data.beforeLeave;
  var leave = data.leave;
  var afterLeave = data.afterLeave;
  var leaveCancelled = data.leaveCancelled;
  var delayLeave = data.delayLeave;
  var duration = data.duration;

  var expectsCSS = css !== false && !isIE9;
  var userWantsControl = getHookArgumentsLength(leave);

  var explicitLeaveDuration = toNumber(
    isObject(duration)
      ? duration.leave
      : duration
  );

  if (false) {
    checkDuration(explicitLeaveDuration, 'leave', vnode);
  }

  var cb = el._leaveCb = once(function () {
    if (el.parentNode && el.parentNode._pending) {
      el.parentNode._pending[vnode.key] = null;
    }
    if (expectsCSS) {
      removeTransitionClass(el, leaveToClass);
      removeTransitionClass(el, leaveActiveClass);
    }
    if (cb.cancelled) {
      if (expectsCSS) {
        removeTransitionClass(el, leaveClass);
      }
      leaveCancelled && leaveCancelled(el);
    } else {
      rm();
      afterLeave && afterLeave(el);
    }
    el._leaveCb = null;
  });

  if (delayLeave) {
    delayLeave(performLeave);
  } else {
    performLeave();
  }

  function performLeave () {
    // the delayed leave may have already been cancelled
    if (cb.cancelled) {
      return
    }
    // record leaving element
    if (!vnode.data.show && el.parentNode) {
      (el.parentNode._pending || (el.parentNode._pending = {}))[(vnode.key)] = vnode;
    }
    beforeLeave && beforeLeave(el);
    if (expectsCSS) {
      addTransitionClass(el, leaveClass);
      addTransitionClass(el, leaveActiveClass);
      nextFrame(function () {
        removeTransitionClass(el, leaveClass);
        if (!cb.cancelled) {
          addTransitionClass(el, leaveToClass);
          if (!userWantsControl) {
            if (isValidDuration(explicitLeaveDuration)) {
              setTimeout(cb, explicitLeaveDuration);
            } else {
              whenTransitionEnds(el, type, cb);
            }
          }
        }
      });
    }
    leave && leave(el, cb);
    if (!expectsCSS && !userWantsControl) {
      cb();
    }
  }
}

// only used in dev mode
function checkDuration (val, name, vnode) {
  if (typeof val !== 'number') {
    warn(
      "<transition> explicit " + name + " duration is not a valid number - " +
      "got " + (JSON.stringify(val)) + ".",
      vnode.context
    );
  } else if (isNaN(val)) {
    warn(
      "<transition> explicit " + name + " duration is NaN - " +
      'the duration expression might be incorrect.',
      vnode.context
    );
  }
}

function isValidDuration (val) {
  return typeof val === 'number' && !isNaN(val)
}

/**
 * Normalize a transition hook's argument length. The hook may be:
 * - a merged hook (invoker) with the original in .fns
 * - a wrapped component method (check ._length)
 * - a plain function (.length)
 */
function getHookArgumentsLength (fn) {
  if (isUndef(fn)) {
    return false
  }
  var invokerFns = fn.fns;
  if (isDef(invokerFns)) {
    // invoker
    return getHookArgumentsLength(
      Array.isArray(invokerFns)
        ? invokerFns[0]
        : invokerFns
    )
  } else {
    return (fn._length || fn.length) > 1
  }
}

function _enter (_, vnode) {
  if (vnode.data.show !== true) {
    enter(vnode);
  }
}

var transition = inBrowser ? {
  create: _enter,
  activate: _enter,
  remove: function remove$$1 (vnode, rm) {
    /* istanbul ignore else */
    if (vnode.data.show !== true) {
      leave(vnode, rm);
    } else {
      rm();
    }
  }
} : {};

var platformModules = [
  attrs,
  klass,
  events,
  domProps,
  style,
  transition
];

/*  */

// the directive module should be applied last, after all
// built-in modules have been applied.
var modules = platformModules.concat(baseModules);

var patch = createPatchFunction({ nodeOps: nodeOps, modules: modules });

/**
 * Not type checking this file because flow doesn't like attaching
 * properties to Elements.
 */

/* istanbul ignore if */
if (isIE9) {
  // http://www.matts411.com/post/internet-explorer-9-oninput/
  document.addEventListener('selectionchange', function () {
    var el = document.activeElement;
    if (el && el.vmodel) {
      trigger(el, 'input');
    }
  });
}

var directive = {
  inserted: function inserted (el, binding, vnode, oldVnode) {
    if (vnode.tag === 'select') {
      // #6903
      if (oldVnode.elm && !oldVnode.elm._vOptions) {
        mergeVNodeHook(vnode, 'postpatch', function () {
          directive.componentUpdated(el, binding, vnode);
        });
      } else {
        setSelected(el, binding, vnode.context);
      }
      el._vOptions = [].map.call(el.options, getValue);
    } else if (vnode.tag === 'textarea' || isTextInputType(el.type)) {
      el._vModifiers = binding.modifiers;
      if (!binding.modifiers.lazy) {
        el.addEventListener('compositionstart', onCompositionStart);
        el.addEventListener('compositionend', onCompositionEnd);
        // Safari < 10.2 & UIWebView doesn't fire compositionend when
        // switching focus before confirming composition choice
        // this also fixes the issue where some browsers e.g. iOS Chrome
        // fires "change" instead of "input" on autocomplete.
        el.addEventListener('change', onCompositionEnd);
        /* istanbul ignore if */
        if (isIE9) {
          el.vmodel = true;
        }
      }
    }
  },

  componentUpdated: function componentUpdated (el, binding, vnode) {
    if (vnode.tag === 'select') {
      setSelected(el, binding, vnode.context);
      // in case the options rendered by v-for have changed,
      // it's possible that the value is out-of-sync with the rendered options.
      // detect such cases and filter out values that no longer has a matching
      // option in the DOM.
      var prevOptions = el._vOptions;
      var curOptions = el._vOptions = [].map.call(el.options, getValue);
      if (curOptions.some(function (o, i) { return !looseEqual(o, prevOptions[i]); })) {
        // trigger change event if
        // no matching option found for at least one value
        var needReset = el.multiple
          ? binding.value.some(function (v) { return hasNoMatchingOption(v, curOptions); })
          : binding.value !== binding.oldValue && hasNoMatchingOption(binding.value, curOptions);
        if (needReset) {
          trigger(el, 'change');
        }
      }
    }
  }
};

function setSelected (el, binding, vm) {
  actuallySetSelected(el, binding, vm);
  /* istanbul ignore if */
  if (isIE || isEdge) {
    setTimeout(function () {
      actuallySetSelected(el, binding, vm);
    }, 0);
  }
}

function actuallySetSelected (el, binding, vm) {
  var value = binding.value;
  var isMultiple = el.multiple;
  if (isMultiple && !Array.isArray(value)) {
    "production" !== 'production' && warn(
      "<select multiple v-model=\"" + (binding.expression) + "\"> " +
      "expects an Array value for its binding, but got " + (Object.prototype.toString.call(value).slice(8, -1)),
      vm
    );
    return
  }
  var selected, option;
  for (var i = 0, l = el.options.length; i < l; i++) {
    option = el.options[i];
    if (isMultiple) {
      selected = looseIndexOf(value, getValue(option)) > -1;
      if (option.selected !== selected) {
        option.selected = selected;
      }
    } else {
      if (looseEqual(getValue(option), value)) {
        if (el.selectedIndex !== i) {
          el.selectedIndex = i;
        }
        return
      }
    }
  }
  if (!isMultiple) {
    el.selectedIndex = -1;
  }
}

function hasNoMatchingOption (value, options) {
  return options.every(function (o) { return !looseEqual(o, value); })
}

function getValue (option) {
  return '_value' in option
    ? option._value
    : option.value
}

function onCompositionStart (e) {
  e.target.composing = true;
}

function onCompositionEnd (e) {
  // prevent triggering an input event for no reason
  if (!e.target.composing) { return }
  e.target.composing = false;
  trigger(e.target, 'input');
}

function trigger (el, type) {
  var e = document.createEvent('HTMLEvents');
  e.initEvent(type, true, true);
  el.dispatchEvent(e);
}

/*  */

// recursively search for possible transition defined inside the component root
function locateNode (vnode) {
  return vnode.componentInstance && (!vnode.data || !vnode.data.transition)
    ? locateNode(vnode.componentInstance._vnode)
    : vnode
}

var show = {
  bind: function bind (el, ref, vnode) {
    var value = ref.value;

    vnode = locateNode(vnode);
    var transition$$1 = vnode.data && vnode.data.transition;
    var originalDisplay = el.__vOriginalDisplay =
      el.style.display === 'none' ? '' : el.style.display;
    if (value && transition$$1) {
      vnode.data.show = true;
      enter(vnode, function () {
        el.style.display = originalDisplay;
      });
    } else {
      el.style.display = value ? originalDisplay : 'none';
    }
  },

  update: function update (el, ref, vnode) {
    var value = ref.value;
    var oldValue = ref.oldValue;

    /* istanbul ignore if */
    if (!value === !oldValue) { return }
    vnode = locateNode(vnode);
    var transition$$1 = vnode.data && vnode.data.transition;
    if (transition$$1) {
      vnode.data.show = true;
      if (value) {
        enter(vnode, function () {
          el.style.display = el.__vOriginalDisplay;
        });
      } else {
        leave(vnode, function () {
          el.style.display = 'none';
        });
      }
    } else {
      el.style.display = value ? el.__vOriginalDisplay : 'none';
    }
  },

  unbind: function unbind (
    el,
    binding,
    vnode,
    oldVnode,
    isDestroy
  ) {
    if (!isDestroy) {
      el.style.display = el.__vOriginalDisplay;
    }
  }
};

var platformDirectives = {
  model: directive,
  show: show
};

/*  */

var transitionProps = {
  name: String,
  appear: Boolean,
  css: Boolean,
  mode: String,
  type: String,
  enterClass: String,
  leaveClass: String,
  enterToClass: String,
  leaveToClass: String,
  enterActiveClass: String,
  leaveActiveClass: String,
  appearClass: String,
  appearActiveClass: String,
  appearToClass: String,
  duration: [Number, String, Object]
};

// in case the child is also an abstract component, e.g. <keep-alive>
// we want to recursively retrieve the real component to be rendered
function getRealChild (vnode) {
  var compOptions = vnode && vnode.componentOptions;
  if (compOptions && compOptions.Ctor.options.abstract) {
    return getRealChild(getFirstComponentChild(compOptions.children))
  } else {
    return vnode
  }
}

function extractTransitionData (comp) {
  var data = {};
  var options = comp.$options;
  // props
  for (var key in options.propsData) {
    data[key] = comp[key];
  }
  // events.
  // extract listeners and pass them directly to the transition methods
  var listeners = options._parentListeners;
  for (var key$1 in listeners) {
    data[camelize(key$1)] = listeners[key$1];
  }
  return data
}

function placeholder (h, rawChild) {
  if (/\d-keep-alive$/.test(rawChild.tag)) {
    return h('keep-alive', {
      props: rawChild.componentOptions.propsData
    })
  }
}

function hasParentTransition (vnode) {
  while ((vnode = vnode.parent)) {
    if (vnode.data.transition) {
      return true
    }
  }
}

function isSameChild (child, oldChild) {
  return oldChild.key === child.key && oldChild.tag === child.tag
}

var isNotTextNode = function (c) { return c.tag || isAsyncPlaceholder(c); };

var isVShowDirective = function (d) { return d.name === 'show'; };

var Transition = {
  name: 'transition',
  props: transitionProps,
  abstract: true,

  render: function render (h) {
    var this$1 = this;

    var children = this.$slots.default;
    if (!children) {
      return
    }

    // filter out text nodes (possible whitespaces)
    children = children.filter(isNotTextNode);
    /* istanbul ignore if */
    if (!children.length) {
      return
    }

    // warn multiple elements
    if (false) {
      warn(
        '<transition> can only be used on a single element. Use ' +
        '<transition-group> for lists.',
        this.$parent
      );
    }

    var mode = this.mode;

    // warn invalid mode
    if (false
    ) {
      warn(
        'invalid <transition> mode: ' + mode,
        this.$parent
      );
    }

    var rawChild = children[0];

    // if this is a component root node and the component's
    // parent container node also has transition, skip.
    if (hasParentTransition(this.$vnode)) {
      return rawChild
    }

    // apply transition data to child
    // use getRealChild() to ignore abstract components e.g. keep-alive
    var child = getRealChild(rawChild);
    /* istanbul ignore if */
    if (!child) {
      return rawChild
    }

    if (this._leaving) {
      return placeholder(h, rawChild)
    }

    // ensure a key that is unique to the vnode type and to this transition
    // component instance. This key will be used to remove pending leaving nodes
    // during entering.
    var id = "__transition-" + (this._uid) + "-";
    child.key = child.key == null
      ? child.isComment
        ? id + 'comment'
        : id + child.tag
      : isPrimitive(child.key)
        ? (String(child.key).indexOf(id) === 0 ? child.key : id + child.key)
        : child.key;

    var data = (child.data || (child.data = {})).transition = extractTransitionData(this);
    var oldRawChild = this._vnode;
    var oldChild = getRealChild(oldRawChild);

    // mark v-show
    // so that the transition module can hand over the control to the directive
    if (child.data.directives && child.data.directives.some(isVShowDirective)) {
      child.data.show = true;
    }

    if (
      oldChild &&
      oldChild.data &&
      !isSameChild(child, oldChild) &&
      !isAsyncPlaceholder(oldChild) &&
      // #6687 component root is a comment node
      !(oldChild.componentInstance && oldChild.componentInstance._vnode.isComment)
    ) {
      // replace old child transition data with fresh one
      // important for dynamic transitions!
      var oldData = oldChild.data.transition = extend({}, data);
      // handle transition mode
      if (mode === 'out-in') {
        // return placeholder node and queue update when leave finishes
        this._leaving = true;
        mergeVNodeHook(oldData, 'afterLeave', function () {
          this$1._leaving = false;
          this$1.$forceUpdate();
        });
        return placeholder(h, rawChild)
      } else if (mode === 'in-out') {
        if (isAsyncPlaceholder(child)) {
          return oldRawChild
        }
        var delayedLeave;
        var performLeave = function () { delayedLeave(); };
        mergeVNodeHook(data, 'afterEnter', performLeave);
        mergeVNodeHook(data, 'enterCancelled', performLeave);
        mergeVNodeHook(oldData, 'delayLeave', function (leave) { delayedLeave = leave; });
      }
    }

    return rawChild
  }
};

/*  */

var props = extend({
  tag: String,
  moveClass: String
}, transitionProps);

delete props.mode;

var TransitionGroup = {
  props: props,

  beforeMount: function beforeMount () {
    var this$1 = this;

    var update = this._update;
    this._update = function (vnode, hydrating) {
      var restoreActiveInstance = setActiveInstance(this$1);
      // force removing pass
      this$1.__patch__(
        this$1._vnode,
        this$1.kept,
        false, // hydrating
        true // removeOnly (!important, avoids unnecessary moves)
      );
      this$1._vnode = this$1.kept;
      restoreActiveInstance();
      update.call(this$1, vnode, hydrating);
    };
  },

  render: function render (h) {
    var tag = this.tag || this.$vnode.data.tag || 'span';
    var map = Object.create(null);
    var prevChildren = this.prevChildren = this.children;
    var rawChildren = this.$slots.default || [];
    var children = this.children = [];
    var transitionData = extractTransitionData(this);

    for (var i = 0; i < rawChildren.length; i++) {
      var c = rawChildren[i];
      if (c.tag) {
        if (c.key != null && String(c.key).indexOf('__vlist') !== 0) {
          children.push(c);
          map[c.key] = c
          ;(c.data || (c.data = {})).transition = transitionData;
        } else if (false) {
          var opts = c.componentOptions;
          var name = opts ? (opts.Ctor.options.name || opts.tag || '') : c.tag;
          warn(("<transition-group> children must be keyed: <" + name + ">"));
        }
      }
    }

    if (prevChildren) {
      var kept = [];
      var removed = [];
      for (var i$1 = 0; i$1 < prevChildren.length; i$1++) {
        var c$1 = prevChildren[i$1];
        c$1.data.transition = transitionData;
        c$1.data.pos = c$1.elm.getBoundingClientRect();
        if (map[c$1.key]) {
          kept.push(c$1);
        } else {
          removed.push(c$1);
        }
      }
      this.kept = h(tag, null, kept);
      this.removed = removed;
    }

    return h(tag, null, children)
  },

  updated: function updated () {
    var children = this.prevChildren;
    var moveClass = this.moveClass || ((this.name || 'v') + '-move');
    if (!children.length || !this.hasMove(children[0].elm, moveClass)) {
      return
    }

    // we divide the work into three loops to avoid mixing DOM reads and writes
    // in each iteration - which helps prevent layout thrashing.
    children.forEach(callPendingCbs);
    children.forEach(recordPosition);
    children.forEach(applyTranslation);

    // force reflow to put everything in position
    // assign to this to avoid being removed in tree-shaking
    // $flow-disable-line
    this._reflow = document.body.offsetHeight;

    children.forEach(function (c) {
      if (c.data.moved) {
        var el = c.elm;
        var s = el.style;
        addTransitionClass(el, moveClass);
        s.transform = s.WebkitTransform = s.transitionDuration = '';
        el.addEventListener(transitionEndEvent, el._moveCb = function cb (e) {
          if (e && e.target !== el) {
            return
          }
          if (!e || /transform$/.test(e.propertyName)) {
            el.removeEventListener(transitionEndEvent, cb);
            el._moveCb = null;
            removeTransitionClass(el, moveClass);
          }
        });
      }
    });
  },

  methods: {
    hasMove: function hasMove (el, moveClass) {
      /* istanbul ignore if */
      if (!hasTransition) {
        return false
      }
      /* istanbul ignore if */
      if (this._hasMove) {
        return this._hasMove
      }
      // Detect whether an element with the move class applied has
      // CSS transitions. Since the element may be inside an entering
      // transition at this very moment, we make a clone of it and remove
      // all other transition classes applied to ensure only the move class
      // is applied.
      var clone = el.cloneNode();
      if (el._transitionClasses) {
        el._transitionClasses.forEach(function (cls) { removeClass(clone, cls); });
      }
      addClass(clone, moveClass);
      clone.style.display = 'none';
      this.$el.appendChild(clone);
      var info = getTransitionInfo(clone);
      this.$el.removeChild(clone);
      return (this._hasMove = info.hasTransform)
    }
  }
};

function callPendingCbs (c) {
  /* istanbul ignore if */
  if (c.elm._moveCb) {
    c.elm._moveCb();
  }
  /* istanbul ignore if */
  if (c.elm._enterCb) {
    c.elm._enterCb();
  }
}

function recordPosition (c) {
  c.data.newPos = c.elm.getBoundingClientRect();
}

function applyTranslation (c) {
  var oldPos = c.data.pos;
  var newPos = c.data.newPos;
  var dx = oldPos.left - newPos.left;
  var dy = oldPos.top - newPos.top;
  if (dx || dy) {
    c.data.moved = true;
    var s = c.elm.style;
    s.transform = s.WebkitTransform = "translate(" + dx + "px," + dy + "px)";
    s.transitionDuration = '0s';
  }
}

var platformComponents = {
  Transition: Transition,
  TransitionGroup: TransitionGroup
};

/*  */

// install platform specific utils
Vue.config.mustUseProp = mustUseProp;
Vue.config.isReservedTag = isReservedTag;
Vue.config.isReservedAttr = isReservedAttr;
Vue.config.getTagNamespace = getTagNamespace;
Vue.config.isUnknownElement = isUnknownElement;

// install platform runtime directives & components
extend(Vue.options.directives, platformDirectives);
extend(Vue.options.components, platformComponents);

// install platform patch function
Vue.prototype.__patch__ = inBrowser ? patch : noop;

// public mount method
Vue.prototype.$mount = function (
  el,
  hydrating
) {
  el = el && inBrowser ? query(el) : undefined;
  return mountComponent(this, el, hydrating)
};

// devtools global hook
/* istanbul ignore next */
if (inBrowser) {
  setTimeout(function () {
    if (config.devtools) {
      if (devtools) {
        devtools.emit('init', Vue);
      } else if (
        false
      ) {
        console[console.info ? 'info' : 'log'](
          'Download the Vue Devtools extension for a better development experience:\n' +
          'https://github.com/vuejs/vue-devtools'
        );
      }
    }
    if (false
    ) {
      console[console.info ? 'info' : 'log'](
        "You are running Vue in development mode.\n" +
        "Make sure to turn on production mode when deploying for production.\n" +
        "See more tips at https://vuejs.org/guide/deployment.html"
      );
    }
  }, 0);
}

/*  */

var defaultTagRE = /\{\{((?:.|\r?\n)+?)\}\}/g;
var regexEscapeRE = /[-.*+?^${}()|[\]\/\\]/g;

var buildRegex = cached(function (delimiters) {
  var open = delimiters[0].replace(regexEscapeRE, '\\$&');
  var close = delimiters[1].replace(regexEscapeRE, '\\$&');
  return new RegExp(open + '((?:.|\\n)+?)' + close, 'g')
});



function parseText (
  text,
  delimiters
) {
  var tagRE = delimiters ? buildRegex(delimiters) : defaultTagRE;
  if (!tagRE.test(text)) {
    return
  }
  var tokens = [];
  var rawTokens = [];
  var lastIndex = tagRE.lastIndex = 0;
  var match, index, tokenValue;
  while ((match = tagRE.exec(text))) {
    index = match.index;
    // push text token
    if (index > lastIndex) {
      rawTokens.push(tokenValue = text.slice(lastIndex, index));
      tokens.push(JSON.stringify(tokenValue));
    }
    // tag token
    var exp = parseFilters(match[1].trim());
    tokens.push(("_s(" + exp + ")"));
    rawTokens.push({ '@binding': exp });
    lastIndex = index + match[0].length;
  }
  if (lastIndex < text.length) {
    rawTokens.push(tokenValue = text.slice(lastIndex));
    tokens.push(JSON.stringify(tokenValue));
  }
  return {
    expression: tokens.join('+'),
    tokens: rawTokens
  }
}

/*  */

function transformNode (el, options) {
  var warn = options.warn || baseWarn;
  var staticClass = getAndRemoveAttr(el, 'class');
  if (false) {
    var res = parseText(staticClass, options.delimiters);
    if (res) {
      warn(
        "class=\"" + staticClass + "\": " +
        'Interpolation inside attributes has been removed. ' +
        'Use v-bind or the colon shorthand instead. For example, ' +
        'instead of <div class="{{ val }}">, use <div :class="val">.',
        el.rawAttrsMap['class']
      );
    }
  }
  if (staticClass) {
    el.staticClass = JSON.stringify(staticClass);
  }
  var classBinding = getBindingAttr(el, 'class', false /* getStatic */);
  if (classBinding) {
    el.classBinding = classBinding;
  }
}

function genData (el) {
  var data = '';
  if (el.staticClass) {
    data += "staticClass:" + (el.staticClass) + ",";
  }
  if (el.classBinding) {
    data += "class:" + (el.classBinding) + ",";
  }
  return data
}

var klass$1 = {
  staticKeys: ['staticClass'],
  transformNode: transformNode,
  genData: genData
};

/*  */

function transformNode$1 (el, options) {
  var warn = options.warn || baseWarn;
  var staticStyle = getAndRemoveAttr(el, 'style');
  if (staticStyle) {
    /* istanbul ignore if */
    if (false) {
      var res = parseText(staticStyle, options.delimiters);
      if (res) {
        warn(
          "style=\"" + staticStyle + "\": " +
          'Interpolation inside attributes has been removed. ' +
          'Use v-bind or the colon shorthand instead. For example, ' +
          'instead of <div style="{{ val }}">, use <div :style="val">.',
          el.rawAttrsMap['style']
        );
      }
    }
    el.staticStyle = JSON.stringify(parseStyleText(staticStyle));
  }

  var styleBinding = getBindingAttr(el, 'style', false /* getStatic */);
  if (styleBinding) {
    el.styleBinding = styleBinding;
  }
}

function genData$1 (el) {
  var data = '';
  if (el.staticStyle) {
    data += "staticStyle:" + (el.staticStyle) + ",";
  }
  if (el.styleBinding) {
    data += "style:(" + (el.styleBinding) + "),";
  }
  return data
}

var style$1 = {
  staticKeys: ['staticStyle'],
  transformNode: transformNode$1,
  genData: genData$1
};

/*  */

var decoder;

var he = {
  decode: function decode (html) {
    decoder = decoder || document.createElement('div');
    decoder.innerHTML = html;
    return decoder.textContent
  }
};

/*  */

var isUnaryTag = makeMap(
  'area,base,br,col,embed,frame,hr,img,input,isindex,keygen,' +
  'link,meta,param,source,track,wbr'
);

// Elements that you can, intentionally, leave open
// (and which close themselves)
var canBeLeftOpenTag = makeMap(
  'colgroup,dd,dt,li,options,p,td,tfoot,th,thead,tr,source'
);

// HTML5 tags https://html.spec.whatwg.org/multipage/indices.html#elements-3
// Phrasing Content https://html.spec.whatwg.org/multipage/dom.html#phrasing-content
var isNonPhrasingTag = makeMap(
  'address,article,aside,base,blockquote,body,caption,col,colgroup,dd,' +
  'details,dialog,div,dl,dt,fieldset,figcaption,figure,footer,form,' +
  'h1,h2,h3,h4,h5,h6,head,header,hgroup,hr,html,legend,li,menuitem,meta,' +
  'optgroup,option,param,rp,rt,source,style,summary,tbody,td,tfoot,th,thead,' +
  'title,tr,track'
);

/**
 * Not type-checking this file because it's mostly vendor code.
 */

// Regular Expressions for parsing tags and attributes
var attribute = /^\s*([^\s"'<>\/=]+)(?:\s*(=)\s*(?:"([^"]*)"+|'([^']*)'+|([^\s"'=<>`]+)))?/;
var dynamicArgAttribute = /^\s*((?:v-[\w-]+:|@|:|#)\[[^=]+\][^\s"'<>\/=]*)(?:\s*(=)\s*(?:"([^"]*)"+|'([^']*)'+|([^\s"'=<>`]+)))?/;
var ncname = "[a-zA-Z_][\\-\\.0-9_a-zA-Z" + (unicodeRegExp.source) + "]*";
var qnameCapture = "((?:" + ncname + "\\:)?" + ncname + ")";
var startTagOpen = new RegExp(("^<" + qnameCapture));
var startTagClose = /^\s*(\/?)>/;
var endTag = new RegExp(("^<\\/" + qnameCapture + "[^>]*>"));
var doctype = /^<!DOCTYPE [^>]+>/i;
// #7298: escape - to avoid being passed as HTML comment when inlined in page
var comment = /^<!\--/;
var conditionalComment = /^<!\[/;

// Special Elements (can contain anything)
var isPlainTextElement = makeMap('script,style,textarea', true);
var reCache = {};

var decodingMap = {
  '&lt;': '<',
  '&gt;': '>',
  '&quot;': '"',
  '&amp;': '&',
  '&#10;': '\n',
  '&#9;': '\t',
  '&#39;': "'"
};
var encodedAttr = /&(?:lt|gt|quot|amp|#39);/g;
var encodedAttrWithNewLines = /&(?:lt|gt|quot|amp|#39|#10|#9);/g;

// #5992
var isIgnoreNewlineTag = makeMap('pre,textarea', true);
var shouldIgnoreFirstNewline = function (tag, html) { return tag && isIgnoreNewlineTag(tag) && html[0] === '\n'; };

function decodeAttr (value, shouldDecodeNewlines) {
  var re = shouldDecodeNewlines ? encodedAttrWithNewLines : encodedAttr;
  return value.replace(re, function (match) { return decodingMap[match]; })
}

function parseHTML (html, options) {
  var stack = [];
  var expectHTML = options.expectHTML;
  var isUnaryTag$$1 = options.isUnaryTag || no;
  var canBeLeftOpenTag$$1 = options.canBeLeftOpenTag || no;
  var index = 0;
  var last, lastTag;
  while (html) {
    last = html;
    // Make sure we're not in a plaintext content element like script/style
    if (!lastTag || !isPlainTextElement(lastTag)) {
      var textEnd = html.indexOf('<');
      if (textEnd === 0) {
        // Comment:
        if (comment.test(html)) {
          var commentEnd = html.indexOf('-->');

          if (commentEnd >= 0) {
            if (options.shouldKeepComment) {
              options.comment(html.substring(4, commentEnd), index, index + commentEnd + 3);
            }
            advance(commentEnd + 3);
            continue
          }
        }

        // http://en.wikipedia.org/wiki/Conditional_comment#Downlevel-revealed_conditional_comment
        if (conditionalComment.test(html)) {
          var conditionalEnd = html.indexOf(']>');

          if (conditionalEnd >= 0) {
            advance(conditionalEnd + 2);
            continue
          }
        }

        // Doctype:
        var doctypeMatch = html.match(doctype);
        if (doctypeMatch) {
          advance(doctypeMatch[0].length);
          continue
        }

        // End tag:
        var endTagMatch = html.match(endTag);
        if (endTagMatch) {
          var curIndex = index;
          advance(endTagMatch[0].length);
          parseEndTag(endTagMatch[1], curIndex, index);
          continue
        }

        // Start tag:
        var startTagMatch = parseStartTag();
        if (startTagMatch) {
          handleStartTag(startTagMatch);
          if (shouldIgnoreFirstNewline(startTagMatch.tagName, html)) {
            advance(1);
          }
          continue
        }
      }

      var text = (void 0), rest = (void 0), next = (void 0);
      if (textEnd >= 0) {
        rest = html.slice(textEnd);
        while (
          !endTag.test(rest) &&
          !startTagOpen.test(rest) &&
          !comment.test(rest) &&
          !conditionalComment.test(rest)
        ) {
          // < in plain text, be forgiving and treat it as text
          next = rest.indexOf('<', 1);
          if (next < 0) { break }
          textEnd += next;
          rest = html.slice(textEnd);
        }
        text = html.substring(0, textEnd);
      }

      if (textEnd < 0) {
        text = html;
      }

      if (text) {
        advance(text.length);
      }

      if (options.chars && text) {
        options.chars(text, index - text.length, index);
      }
    } else {
      var endTagLength = 0;
      var stackedTag = lastTag.toLowerCase();
      var reStackedTag = reCache[stackedTag] || (reCache[stackedTag] = new RegExp('([\\s\\S]*?)(</' + stackedTag + '[^>]*>)', 'i'));
      var rest$1 = html.replace(reStackedTag, function (all, text, endTag) {
        endTagLength = endTag.length;
        if (!isPlainTextElement(stackedTag) && stackedTag !== 'noscript') {
          text = text
            .replace(/<!\--([\s\S]*?)-->/g, '$1') // #7298
            .replace(/<!\[CDATA\[([\s\S]*?)]]>/g, '$1');
        }
        if (shouldIgnoreFirstNewline(stackedTag, text)) {
          text = text.slice(1);
        }
        if (options.chars) {
          options.chars(text);
        }
        return ''
      });
      index += html.length - rest$1.length;
      html = rest$1;
      parseEndTag(stackedTag, index - endTagLength, index);
    }

    if (html === last) {
      options.chars && options.chars(html);
      if (false) {
        options.warn(("Mal-formatted tag at end of template: \"" + html + "\""), { start: index + html.length });
      }
      break
    }
  }

  // Clean up any remaining tags
  parseEndTag();

  function advance (n) {
    index += n;
    html = html.substring(n);
  }

  function parseStartTag () {
    var start = html.match(startTagOpen);
    if (start) {
      var match = {
        tagName: start[1],
        attrs: [],
        start: index
      };
      advance(start[0].length);
      var end, attr;
      while (!(end = html.match(startTagClose)) && (attr = html.match(dynamicArgAttribute) || html.match(attribute))) {
        attr.start = index;
        advance(attr[0].length);
        attr.end = index;
        match.attrs.push(attr);
      }
      if (end) {
        match.unarySlash = end[1];
        advance(end[0].length);
        match.end = index;
        return match
      }
    }
  }

  function handleStartTag (match) {
    var tagName = match.tagName;
    var unarySlash = match.unarySlash;

    if (expectHTML) {
      if (lastTag === 'p' && isNonPhrasingTag(tagName)) {
        parseEndTag(lastTag);
      }
      if (canBeLeftOpenTag$$1(tagName) && lastTag === tagName) {
        parseEndTag(tagName);
      }
    }

    var unary = isUnaryTag$$1(tagName) || !!unarySlash;

    var l = match.attrs.length;
    var attrs = new Array(l);
    for (var i = 0; i < l; i++) {
      var args = match.attrs[i];
      var value = args[3] || args[4] || args[5] || '';
      var shouldDecodeNewlines = tagName === 'a' && args[1] === 'href'
        ? options.shouldDecodeNewlinesForHref
        : options.shouldDecodeNewlines;
      attrs[i] = {
        name: args[1],
        value: decodeAttr(value, shouldDecodeNewlines)
      };
      if (false) {
        attrs[i].start = args.start + args[0].match(/^\s*/).length;
        attrs[i].end = args.end;
      }
    }

    if (!unary) {
      stack.push({ tag: tagName, lowerCasedTag: tagName.toLowerCase(), attrs: attrs, start: match.start, end: match.end });
      lastTag = tagName;
    }

    if (options.start) {
      options.start(tagName, attrs, unary, match.start, match.end);
    }
  }

  function parseEndTag (tagName, start, end) {
    var pos, lowerCasedTagName;
    if (start == null) { start = index; }
    if (end == null) { end = index; }

    // Find the closest opened tag of the same type
    if (tagName) {
      lowerCasedTagName = tagName.toLowerCase();
      for (pos = stack.length - 1; pos >= 0; pos--) {
        if (stack[pos].lowerCasedTag === lowerCasedTagName) {
          break
        }
      }
    } else {
      // If no tag name is provided, clean shop
      pos = 0;
    }

    if (pos >= 0) {
      // Close all the open elements, up the stack
      for (var i = stack.length - 1; i >= pos; i--) {
        if (false
        ) {
          options.warn(
            ("tag <" + (stack[i].tag) + "> has no matching end tag."),
            { start: stack[i].start, end: stack[i].end }
          );
        }
        if (options.end) {
          options.end(stack[i].tag, start, end);
        }
      }

      // Remove the open elements from the stack
      stack.length = pos;
      lastTag = pos && stack[pos - 1].tag;
    } else if (lowerCasedTagName === 'br') {
      if (options.start) {
        options.start(tagName, [], true, start, end);
      }
    } else if (lowerCasedTagName === 'p') {
      if (options.start) {
        options.start(tagName, [], false, start, end);
      }
      if (options.end) {
        options.end(tagName, start, end);
      }
    }
  }
}

/*  */

var onRE = /^@|^v-on:/;
var dirRE = /^v-|^@|^:|^#/;
var forAliasRE = /([\s\S]*?)\s+(?:in|of)\s+([\s\S]*)/;
var forIteratorRE = /,([^,\}\]]*)(?:,([^,\}\]]*))?$/;
var stripParensRE = /^\(|\)$/g;
var dynamicArgRE = /^\[.*\]$/;

var argRE = /:(.*)$/;
var bindRE = /^:|^\.|^v-bind:/;
var modifierRE = /\.[^.\]]+(?=[^\]]*$)/g;

var slotRE = /^v-slot(:|$)|^#/;

var lineBreakRE = /[\r\n]/;
var whitespaceRE$1 = /\s+/g;

var invalidAttributeRE = /[\s"'<>\/=]/;

var decodeHTMLCached = cached(he.decode);

var emptySlotScopeToken = "_empty_";

// configurable state
var warn$2;
var delimiters;
var transforms;
var preTransforms;
var postTransforms;
var platformIsPreTag;
var platformMustUseProp;
var platformGetTagNamespace;
var maybeComponent;

function createASTElement (
  tag,
  attrs,
  parent
) {
  return {
    type: 1,
    tag: tag,
    attrsList: attrs,
    attrsMap: makeAttrsMap(attrs),
    rawAttrsMap: {},
    parent: parent,
    children: []
  }
}

/**
 * Convert HTML string to AST.
 */
function parse (
  template,
  options
) {
  warn$2 = options.warn || baseWarn;

  platformIsPreTag = options.isPreTag || no;
  platformMustUseProp = options.mustUseProp || no;
  platformGetTagNamespace = options.getTagNamespace || no;
  var isReservedTag = options.isReservedTag || no;
  maybeComponent = function (el) { return !!el.component || !isReservedTag(el.tag); };

  transforms = pluckModuleFunction(options.modules, 'transformNode');
  preTransforms = pluckModuleFunction(options.modules, 'preTransformNode');
  postTransforms = pluckModuleFunction(options.modules, 'postTransformNode');

  delimiters = options.delimiters;

  var stack = [];
  var preserveWhitespace = options.preserveWhitespace !== false;
  var whitespaceOption = options.whitespace;
  var root;
  var currentParent;
  var inVPre = false;
  var inPre = false;
  var warned = false;

  function warnOnce (msg, range) {
    if (!warned) {
      warned = true;
      warn$2(msg, range);
    }
  }

  function closeElement (element) {
    trimEndingWhitespace(element);
    if (!inVPre && !element.processed) {
      element = processElement(element, options);
    }
    // tree management
    if (!stack.length && element !== root) {
      // allow root elements with v-if, v-else-if and v-else
      if (root.if && (element.elseif || element.else)) {
        if (false) {
          checkRootConstraints(element);
        }
        addIfCondition(root, {
          exp: element.elseif,
          block: element
        });
      } else if (false) {
        warnOnce(
          "Component template should contain exactly one root element. " +
          "If you are using v-if on multiple elements, " +
          "use v-else-if to chain them instead.",
          { start: element.start }
        );
      }
    }
    if (currentParent && !element.forbidden) {
      if (element.elseif || element.else) {
        processIfConditions(element, currentParent);
      } else {
        if (element.slotScope) {
          // scoped slot
          // keep it in the children list so that v-else(-if) conditions can
          // find it as the prev node.
          var name = element.slotTarget || '"default"'
          ;(currentParent.scopedSlots || (currentParent.scopedSlots = {}))[name] = element;
        }
        currentParent.children.push(element);
        element.parent = currentParent;
      }
    }

    // final children cleanup
    // filter out scoped slots
    element.children = element.children.filter(function (c) { return !(c).slotScope; });
    // remove trailing whitespace node again
    trimEndingWhitespace(element);

    // check pre state
    if (element.pre) {
      inVPre = false;
    }
    if (platformIsPreTag(element.tag)) {
      inPre = false;
    }
    // apply post-transforms
    for (var i = 0; i < postTransforms.length; i++) {
      postTransforms[i](element, options);
    }
  }

  function trimEndingWhitespace (el) {
    // remove trailing whitespace node
    if (!inPre) {
      var lastNode;
      while (
        (lastNode = el.children[el.children.length - 1]) &&
        lastNode.type === 3 &&
        lastNode.text === ' '
      ) {
        el.children.pop();
      }
    }
  }

  function checkRootConstraints (el) {
    if (el.tag === 'slot' || el.tag === 'template') {
      warnOnce(
        "Cannot use <" + (el.tag) + "> as component root element because it may " +
        'contain multiple nodes.',
        { start: el.start }
      );
    }
    if (el.attrsMap.hasOwnProperty('v-for')) {
      warnOnce(
        'Cannot use v-for on stateful component root element because ' +
        'it renders multiple elements.',
        el.rawAttrsMap['v-for']
      );
    }
  }

  parseHTML(template, {
    warn: warn$2,
    expectHTML: options.expectHTML,
    isUnaryTag: options.isUnaryTag,
    canBeLeftOpenTag: options.canBeLeftOpenTag,
    shouldDecodeNewlines: options.shouldDecodeNewlines,
    shouldDecodeNewlinesForHref: options.shouldDecodeNewlinesForHref,
    shouldKeepComment: options.comments,
    outputSourceRange: options.outputSourceRange,
    start: function start (tag, attrs, unary, start$1, end) {
      // check namespace.
      // inherit parent ns if there is one
      var ns = (currentParent && currentParent.ns) || platformGetTagNamespace(tag);

      // handle IE svg bug
      /* istanbul ignore if */
      if (isIE && ns === 'svg') {
        attrs = guardIESVGBug(attrs);
      }

      var element = createASTElement(tag, attrs, currentParent);
      if (ns) {
        element.ns = ns;
      }

      if (false) {
        if (options.outputSourceRange) {
          element.start = start$1;
          element.end = end;
          element.rawAttrsMap = element.attrsList.reduce(function (cumulated, attr) {
            cumulated[attr.name] = attr;
            return cumulated
          }, {});
        }
        attrs.forEach(function (attr) {
          if (invalidAttributeRE.test(attr.name)) {
            warn$2(
              "Invalid dynamic argument expression: attribute names cannot contain " +
              "spaces, quotes, <, >, / or =.",
              {
                start: attr.start + attr.name.indexOf("["),
                end: attr.start + attr.name.length
              }
            );
          }
        });
      }

      if (isForbiddenTag(element) && !isServerRendering()) {
        element.forbidden = true;
        "production" !== 'production' && warn$2(
          'Templates should only be responsible for mapping the state to the ' +
          'UI. Avoid placing tags with side-effects in your templates, such as ' +
          "<" + tag + ">" + ', as they will not be parsed.',
          { start: element.start }
        );
      }

      // apply pre-transforms
      for (var i = 0; i < preTransforms.length; i++) {
        element = preTransforms[i](element, options) || element;
      }

      if (!inVPre) {
        processPre(element);
        if (element.pre) {
          inVPre = true;
        }
      }
      if (platformIsPreTag(element.tag)) {
        inPre = true;
      }
      if (inVPre) {
        processRawAttrs(element);
      } else if (!element.processed) {
        // structural directives
        processFor(element);
        processIf(element);
        processOnce(element);
      }

      if (!root) {
        root = element;
        if (false) {
          checkRootConstraints(root);
        }
      }

      if (!unary) {
        currentParent = element;
        stack.push(element);
      } else {
        closeElement(element);
      }
    },

    end: function end (tag, start, end$1) {
      var element = stack[stack.length - 1];
      // pop stack
      stack.length -= 1;
      currentParent = stack[stack.length - 1];
      if (false) {
        element.end = end$1;
      }
      closeElement(element);
    },

    chars: function chars (text, start, end) {
      if (!currentParent) {
        if (false) {
          if (text === template) {
            warnOnce(
              'Component template requires a root element, rather than just text.',
              { start: start }
            );
          } else if ((text = text.trim())) {
            warnOnce(
              ("text \"" + text + "\" outside root element will be ignored."),
              { start: start }
            );
          }
        }
        return
      }
      // IE textarea placeholder bug
      /* istanbul ignore if */
      if (isIE &&
        currentParent.tag === 'textarea' &&
        currentParent.attrsMap.placeholder === text
      ) {
        return
      }
      var children = currentParent.children;
      if (inPre || text.trim()) {
        text = isTextTag(currentParent) ? text : decodeHTMLCached(text);
      } else if (!children.length) {
        // remove the whitespace-only node right after an opening tag
        text = '';
      } else if (whitespaceOption) {
        if (whitespaceOption === 'condense') {
          // in condense mode, remove the whitespace node if it contains
          // line break, otherwise condense to a single space
          text = lineBreakRE.test(text) ? '' : ' ';
        } else {
          text = ' ';
        }
      } else {
        text = preserveWhitespace ? ' ' : '';
      }
      if (text) {
        if (!inPre && whitespaceOption === 'condense') {
          // condense consecutive whitespaces into single space
          text = text.replace(whitespaceRE$1, ' ');
        }
        var res;
        var child;
        if (!inVPre && text !== ' ' && (res = parseText(text, delimiters))) {
          child = {
            type: 2,
            expression: res.expression,
            tokens: res.tokens,
            text: text
          };
        } else if (text !== ' ' || !children.length || children[children.length - 1].text !== ' ') {
          child = {
            type: 3,
            text: text
          };
        }
        if (child) {
          if (false) {
            child.start = start;
            child.end = end;
          }
          children.push(child);
        }
      }
    },
    comment: function comment (text, start, end) {
      // adding anything as a sibling to the root node is forbidden
      // comments should still be allowed, but ignored
      if (currentParent) {
        var child = {
          type: 3,
          text: text,
          isComment: true
        };
        if (false) {
          child.start = start;
          child.end = end;
        }
        currentParent.children.push(child);
      }
    }
  });
  return root
}

function processPre (el) {
  if (getAndRemoveAttr(el, 'v-pre') != null) {
    el.pre = true;
  }
}

function processRawAttrs (el) {
  var list = el.attrsList;
  var len = list.length;
  if (len) {
    var attrs = el.attrs = new Array(len);
    for (var i = 0; i < len; i++) {
      attrs[i] = {
        name: list[i].name,
        value: JSON.stringify(list[i].value)
      };
      if (list[i].start != null) {
        attrs[i].start = list[i].start;
        attrs[i].end = list[i].end;
      }
    }
  } else if (!el.pre) {
    // non root node in pre blocks with no attributes
    el.plain = true;
  }
}

function processElement (
  element,
  options
) {
  processKey(element);

  // determine whether this is a plain element after
  // removing structural attributes
  element.plain = (
    !element.key &&
    !element.scopedSlots &&
    !element.attrsList.length
  );

  processRef(element);
  processSlotContent(element);
  processSlotOutlet(element);
  processComponent(element);
  for (var i = 0; i < transforms.length; i++) {
    element = transforms[i](element, options) || element;
  }
  processAttrs(element);
  return element
}

function processKey (el) {
  var exp = getBindingAttr(el, 'key');
  if (exp) {
    if (false) {
      if (el.tag === 'template') {
        warn$2(
          "<template> cannot be keyed. Place the key on real elements instead.",
          getRawBindingAttr(el, 'key')
        );
      }
      if (el.for) {
        var iterator = el.iterator2 || el.iterator1;
        var parent = el.parent;
        if (iterator && iterator === exp && parent && parent.tag === 'transition-group') {
          warn$2(
            "Do not use v-for index as key on <transition-group> children, " +
            "this is the same as not using keys.",
            getRawBindingAttr(el, 'key'),
            true /* tip */
          );
        }
      }
    }
    el.key = exp;
  }
}

function processRef (el) {
  var ref = getBindingAttr(el, 'ref');
  if (ref) {
    el.ref = ref;
    el.refInFor = checkInFor(el);
  }
}

function processFor (el) {
  var exp;
  if ((exp = getAndRemoveAttr(el, 'v-for'))) {
    var res = parseFor(exp);
    if (res) {
      extend(el, res);
    } else if (false) {
      warn$2(
        ("Invalid v-for expression: " + exp),
        el.rawAttrsMap['v-for']
      );
    }
  }
}



function parseFor (exp) {
  var inMatch = exp.match(forAliasRE);
  if (!inMatch) { return }
  var res = {};
  res.for = inMatch[2].trim();
  var alias = inMatch[1].trim().replace(stripParensRE, '');
  var iteratorMatch = alias.match(forIteratorRE);
  if (iteratorMatch) {
    res.alias = alias.replace(forIteratorRE, '').trim();
    res.iterator1 = iteratorMatch[1].trim();
    if (iteratorMatch[2]) {
      res.iterator2 = iteratorMatch[2].trim();
    }
  } else {
    res.alias = alias;
  }
  return res
}

function processIf (el) {
  var exp = getAndRemoveAttr(el, 'v-if');
  if (exp) {
    el.if = exp;
    addIfCondition(el, {
      exp: exp,
      block: el
    });
  } else {
    if (getAndRemoveAttr(el, 'v-else') != null) {
      el.else = true;
    }
    var elseif = getAndRemoveAttr(el, 'v-else-if');
    if (elseif) {
      el.elseif = elseif;
    }
  }
}

function processIfConditions (el, parent) {
  var prev = findPrevElement(parent.children);
  if (prev && prev.if) {
    addIfCondition(prev, {
      exp: el.elseif,
      block: el
    });
  } else if (false) {
    warn$2(
      "v-" + (el.elseif ? ('else-if="' + el.elseif + '"') : 'else') + " " +
      "used on element <" + (el.tag) + "> without corresponding v-if.",
      el.rawAttrsMap[el.elseif ? 'v-else-if' : 'v-else']
    );
  }
}

function findPrevElement (children) {
  var i = children.length;
  while (i--) {
    if (children[i].type === 1) {
      return children[i]
    } else {
      if (false) {
        warn$2(
          "text \"" + (children[i].text.trim()) + "\" between v-if and v-else(-if) " +
          "will be ignored.",
          children[i]
        );
      }
      children.pop();
    }
  }
}

function addIfCondition (el, condition) {
  if (!el.ifConditions) {
    el.ifConditions = [];
  }
  el.ifConditions.push(condition);
}

function processOnce (el) {
  var once$$1 = getAndRemoveAttr(el, 'v-once');
  if (once$$1 != null) {
    el.once = true;
  }
}

// handle content being passed to a component as slot,
// e.g. <template slot="xxx">, <div slot-scope="xxx">
function processSlotContent (el) {
  var slotScope;
  if (el.tag === 'template') {
    slotScope = getAndRemoveAttr(el, 'scope');
    /* istanbul ignore if */
    if (false) {
      warn$2(
        "the \"scope\" attribute for scoped slots have been deprecated and " +
        "replaced by \"slot-scope\" since 2.5. The new \"slot-scope\" attribute " +
        "can also be used on plain elements in addition to <template> to " +
        "denote scoped slots.",
        el.rawAttrsMap['scope'],
        true
      );
    }
    el.slotScope = slotScope || getAndRemoveAttr(el, 'slot-scope');
  } else if ((slotScope = getAndRemoveAttr(el, 'slot-scope'))) {
    /* istanbul ignore if */
    if (false) {
      warn$2(
        "Ambiguous combined usage of slot-scope and v-for on <" + (el.tag) + "> " +
        "(v-for takes higher priority). Use a wrapper <template> for the " +
        "scoped slot to make it clearer.",
        el.rawAttrsMap['slot-scope'],
        true
      );
    }
    el.slotScope = slotScope;
  }

  // slot="xxx"
  var slotTarget = getBindingAttr(el, 'slot');
  if (slotTarget) {
    el.slotTarget = slotTarget === '""' ? '"default"' : slotTarget;
    el.slotTargetDynamic = !!(el.attrsMap[':slot'] || el.attrsMap['v-bind:slot']);
    // preserve slot as an attribute for native shadow DOM compat
    // only for non-scoped slots.
    if (el.tag !== 'template' && !el.slotScope) {
      addAttr(el, 'slot', slotTarget, getRawBindingAttr(el, 'slot'));
    }
  }

  // 2.6 v-slot syntax
  {
    if (el.tag === 'template') {
      // v-slot on <template>
      var slotBinding = getAndRemoveAttrByRegex(el, slotRE);
      if (slotBinding) {
        if (false) {
          if (el.slotTarget || el.slotScope) {
            warn$2(
              "Unexpected mixed usage of different slot syntaxes.",
              el
            );
          }
          if (el.parent && !maybeComponent(el.parent)) {
            warn$2(
              "<template v-slot> can only appear at the root level inside " +
              "the receiving component",
              el
            );
          }
        }
        var ref = getSlotName(slotBinding);
        var name = ref.name;
        var dynamic = ref.dynamic;
        el.slotTarget = name;
        el.slotTargetDynamic = dynamic;
        el.slotScope = slotBinding.value || emptySlotScopeToken; // force it into a scoped slot for perf
      }
    } else {
      // v-slot on component, denotes default slot
      var slotBinding$1 = getAndRemoveAttrByRegex(el, slotRE);
      if (slotBinding$1) {
        if (false) {
          if (!maybeComponent(el)) {
            warn$2(
              "v-slot can only be used on components or <template>.",
              slotBinding$1
            );
          }
          if (el.slotScope || el.slotTarget) {
            warn$2(
              "Unexpected mixed usage of different slot syntaxes.",
              el
            );
          }
          if (el.scopedSlots) {
            warn$2(
              "To avoid scope ambiguity, the default slot should also use " +
              "<template> syntax when there are other named slots.",
              slotBinding$1
            );
          }
        }
        // add the component's children to its default slot
        var slots = el.scopedSlots || (el.scopedSlots = {});
        var ref$1 = getSlotName(slotBinding$1);
        var name$1 = ref$1.name;
        var dynamic$1 = ref$1.dynamic;
        var slotContainer = slots[name$1] = createASTElement('template', [], el);
        slotContainer.slotTarget = name$1;
        slotContainer.slotTargetDynamic = dynamic$1;
        slotContainer.children = el.children.filter(function (c) {
          if (!c.slotScope) {
            c.parent = slotContainer;
            return true
          }
        });
        slotContainer.slotScope = slotBinding$1.value || emptySlotScopeToken;
        // remove children as they are returned from scopedSlots now
        el.children = [];
        // mark el non-plain so data gets generated
        el.plain = false;
      }
    }
  }
}

function getSlotName (binding) {
  var name = binding.name.replace(slotRE, '');
  if (!name) {
    if (binding.name[0] !== '#') {
      name = 'default';
    } else if (false) {
      warn$2(
        "v-slot shorthand syntax requires a slot name.",
        binding
      );
    }
  }
  return dynamicArgRE.test(name)
    // dynamic [name]
    ? { name: name.slice(1, -1), dynamic: true }
    // static name
    : { name: ("\"" + name + "\""), dynamic: false }
}

// handle <slot/> outlets
function processSlotOutlet (el) {
  if (el.tag === 'slot') {
    el.slotName = getBindingAttr(el, 'name');
    if (false) {
      warn$2(
        "`key` does not work on <slot> because slots are abstract outlets " +
        "and can possibly expand into multiple elements. " +
        "Use the key on a wrapping element instead.",
        getRawBindingAttr(el, 'key')
      );
    }
  }
}

function processComponent (el) {
  var binding;
  if ((binding = getBindingAttr(el, 'is'))) {
    el.component = binding;
  }
  if (getAndRemoveAttr(el, 'inline-template') != null) {
    el.inlineTemplate = true;
  }
}

function processAttrs (el) {
  var list = el.attrsList;
  var i, l, name, rawName, value, modifiers, syncGen, isDynamic;
  for (i = 0, l = list.length; i < l; i++) {
    name = rawName = list[i].name;
    value = list[i].value;
    if (dirRE.test(name)) {
      // mark element as dynamic
      el.hasBindings = true;
      // modifiers
      modifiers = parseModifiers(name.replace(dirRE, ''));
      // support .foo shorthand syntax for the .prop modifier
      if (modifiers) {
        name = name.replace(modifierRE, '');
      }
      if (bindRE.test(name)) { // v-bind
        name = name.replace(bindRE, '');
        value = parseFilters(value);
        isDynamic = dynamicArgRE.test(name);
        if (isDynamic) {
          name = name.slice(1, -1);
        }
        if (
          false
        ) {
          warn$2(
            ("The value for a v-bind expression cannot be empty. Found in \"v-bind:" + name + "\"")
          );
        }
        if (modifiers) {
          if (modifiers.prop && !isDynamic) {
            name = camelize(name);
            if (name === 'innerHtml') { name = 'innerHTML'; }
          }
          if (modifiers.camel && !isDynamic) {
            name = camelize(name);
          }
          if (modifiers.sync) {
            syncGen = genAssignmentCode(value, "$event");
            if (!isDynamic) {
              addHandler(
                el,
                ("update:" + (camelize(name))),
                syncGen,
                null,
                false,
                warn$2,
                list[i]
              );
              if (hyphenate(name) !== camelize(name)) {
                addHandler(
                  el,
                  ("update:" + (hyphenate(name))),
                  syncGen,
                  null,
                  false,
                  warn$2,
                  list[i]
                );
              }
            } else {
              // handler w/ dynamic event name
              addHandler(
                el,
                ("\"update:\"+(" + name + ")"),
                syncGen,
                null,
                false,
                warn$2,
                list[i],
                true // dynamic
              );
            }
          }
        }
        if ((modifiers && modifiers.prop) || (
          !el.component && platformMustUseProp(el.tag, el.attrsMap.type, name)
        )) {
          addProp(el, name, value, list[i], isDynamic);
        } else {
          addAttr(el, name, value, list[i], isDynamic);
        }
      } else if (onRE.test(name)) { // v-on
        name = name.replace(onRE, '');
        isDynamic = dynamicArgRE.test(name);
        if (isDynamic) {
          name = name.slice(1, -1);
        }
        addHandler(el, name, value, modifiers, false, warn$2, list[i], isDynamic);
      } else { // normal directives
        name = name.replace(dirRE, '');
        // parse arg
        var argMatch = name.match(argRE);
        var arg = argMatch && argMatch[1];
        isDynamic = false;
        if (arg) {
          name = name.slice(0, -(arg.length + 1));
          if (dynamicArgRE.test(arg)) {
            arg = arg.slice(1, -1);
            isDynamic = true;
          }
        }
        addDirective(el, name, rawName, value, arg, isDynamic, modifiers, list[i]);
        if (false) {
          checkForAliasModel(el, value);
        }
      }
    } else {
      // literal attribute
      if (false) {
        var res = parseText(value, delimiters);
        if (res) {
          warn$2(
            name + "=\"" + value + "\": " +
            'Interpolation inside attributes has been removed. ' +
            'Use v-bind or the colon shorthand instead. For example, ' +
            'instead of <div id="{{ val }}">, use <div :id="val">.',
            list[i]
          );
        }
      }
      addAttr(el, name, JSON.stringify(value), list[i]);
      // #6887 firefox doesn't update muted state if set via attribute
      // even immediately after element creation
      if (!el.component &&
          name === 'muted' &&
          platformMustUseProp(el.tag, el.attrsMap.type, name)) {
        addProp(el, name, 'true', list[i]);
      }
    }
  }
}

function checkInFor (el) {
  var parent = el;
  while (parent) {
    if (parent.for !== undefined) {
      return true
    }
    parent = parent.parent;
  }
  return false
}

function parseModifiers (name) {
  var match = name.match(modifierRE);
  if (match) {
    var ret = {};
    match.forEach(function (m) { ret[m.slice(1)] = true; });
    return ret
  }
}

function makeAttrsMap (attrs) {
  var map = {};
  for (var i = 0, l = attrs.length; i < l; i++) {
    if (
      false
    ) {
      warn$2('duplicate attribute: ' + attrs[i].name, attrs[i]);
    }
    map[attrs[i].name] = attrs[i].value;
  }
  return map
}

// for script (e.g. type="x/template") or style, do not decode content
function isTextTag (el) {
  return el.tag === 'script' || el.tag === 'style'
}

function isForbiddenTag (el) {
  return (
    el.tag === 'style' ||
    (el.tag === 'script' && (
      !el.attrsMap.type ||
      el.attrsMap.type === 'text/javascript'
    ))
  )
}

var ieNSBug = /^xmlns:NS\d+/;
var ieNSPrefix = /^NS\d+:/;

/* istanbul ignore next */
function guardIESVGBug (attrs) {
  var res = [];
  for (var i = 0; i < attrs.length; i++) {
    var attr = attrs[i];
    if (!ieNSBug.test(attr.name)) {
      attr.name = attr.name.replace(ieNSPrefix, '');
      res.push(attr);
    }
  }
  return res
}

function checkForAliasModel (el, value) {
  var _el = el;
  while (_el) {
    if (_el.for && _el.alias === value) {
      warn$2(
        "<" + (el.tag) + " v-model=\"" + value + "\">: " +
        "You are binding v-model directly to a v-for iteration alias. " +
        "This will not be able to modify the v-for source array because " +
        "writing to the alias is like modifying a function local variable. " +
        "Consider using an array of objects and use v-model on an object property instead.",
        el.rawAttrsMap['v-model']
      );
    }
    _el = _el.parent;
  }
}

/*  */

function preTransformNode (el, options) {
  if (el.tag === 'input') {
    var map = el.attrsMap;
    if (!map['v-model']) {
      return
    }

    var typeBinding;
    if (map[':type'] || map['v-bind:type']) {
      typeBinding = getBindingAttr(el, 'type');
    }
    if (!map.type && !typeBinding && map['v-bind']) {
      typeBinding = "(" + (map['v-bind']) + ").type";
    }

    if (typeBinding) {
      var ifCondition = getAndRemoveAttr(el, 'v-if', true);
      var ifConditionExtra = ifCondition ? ("&&(" + ifCondition + ")") : "";
      var hasElse = getAndRemoveAttr(el, 'v-else', true) != null;
      var elseIfCondition = getAndRemoveAttr(el, 'v-else-if', true);
      // 1. checkbox
      var branch0 = cloneASTElement(el);
      // process for on the main node
      processFor(branch0);
      addRawAttr(branch0, 'type', 'checkbox');
      processElement(branch0, options);
      branch0.processed = true; // prevent it from double-processed
      branch0.if = "(" + typeBinding + ")==='checkbox'" + ifConditionExtra;
      addIfCondition(branch0, {
        exp: branch0.if,
        block: branch0
      });
      // 2. add radio else-if condition
      var branch1 = cloneASTElement(el);
      getAndRemoveAttr(branch1, 'v-for', true);
      addRawAttr(branch1, 'type', 'radio');
      processElement(branch1, options);
      addIfCondition(branch0, {
        exp: "(" + typeBinding + ")==='radio'" + ifConditionExtra,
        block: branch1
      });
      // 3. other
      var branch2 = cloneASTElement(el);
      getAndRemoveAttr(branch2, 'v-for', true);
      addRawAttr(branch2, ':type', typeBinding);
      processElement(branch2, options);
      addIfCondition(branch0, {
        exp: ifCondition,
        block: branch2
      });

      if (hasElse) {
        branch0.else = true;
      } else if (elseIfCondition) {
        branch0.elseif = elseIfCondition;
      }

      return branch0
    }
  }
}

function cloneASTElement (el) {
  return createASTElement(el.tag, el.attrsList.slice(), el.parent)
}

var model$1 = {
  preTransformNode: preTransformNode
};

var modules$1 = [
  klass$1,
  style$1,
  model$1
];

/*  */

function text (el, dir) {
  if (dir.value) {
    addProp(el, 'textContent', ("_s(" + (dir.value) + ")"), dir);
  }
}

/*  */

function html (el, dir) {
  if (dir.value) {
    addProp(el, 'innerHTML', ("_s(" + (dir.value) + ")"), dir);
  }
}

var directives$1 = {
  model: model,
  text: text,
  html: html
};

/*  */

var baseOptions = {
  expectHTML: true,
  modules: modules$1,
  directives: directives$1,
  isPreTag: isPreTag,
  isUnaryTag: isUnaryTag,
  mustUseProp: mustUseProp,
  canBeLeftOpenTag: canBeLeftOpenTag,
  isReservedTag: isReservedTag,
  getTagNamespace: getTagNamespace,
  staticKeys: genStaticKeys(modules$1)
};

/*  */

var isStaticKey;
var isPlatformReservedTag;

var genStaticKeysCached = cached(genStaticKeys$1);

/**
 * Goal of the optimizer: walk the generated template AST tree
 * and detect sub-trees that are purely static, i.e. parts of
 * the DOM that never needs to change.
 *
 * Once we detect these sub-trees, we can:
 *
 * 1. Hoist them into constants, so that we no longer need to
 *    create fresh nodes for them on each re-render;
 * 2. Completely skip them in the patching process.
 */
function optimize (root, options) {
  if (!root) { return }
  isStaticKey = genStaticKeysCached(options.staticKeys || '');
  isPlatformReservedTag = options.isReservedTag || no;
  // first pass: mark all non-static nodes.
  markStatic$1(root);
  // second pass: mark static roots.
  markStaticRoots(root, false);
}

function genStaticKeys$1 (keys) {
  return makeMap(
    'type,tag,attrsList,attrsMap,plain,parent,children,attrs,start,end,rawAttrsMap' +
    (keys ? ',' + keys : '')
  )
}

function markStatic$1 (node) {
  node.static = isStatic(node);
  if (node.type === 1) {
    // do not make component slot content static. this avoids
    // 1. components not able to mutate slot nodes
    // 2. static slot content fails for hot-reloading
    if (
      !isPlatformReservedTag(node.tag) &&
      node.tag !== 'slot' &&
      node.attrsMap['inline-template'] == null
    ) {
      return
    }
    for (var i = 0, l = node.children.length; i < l; i++) {
      var child = node.children[i];
      markStatic$1(child);
      if (!child.static) {
        node.static = false;
      }
    }
    if (node.ifConditions) {
      for (var i$1 = 1, l$1 = node.ifConditions.length; i$1 < l$1; i$1++) {
        var block = node.ifConditions[i$1].block;
        markStatic$1(block);
        if (!block.static) {
          node.static = false;
        }
      }
    }
  }
}

function markStaticRoots (node, isInFor) {
  if (node.type === 1) {
    if (node.static || node.once) {
      node.staticInFor = isInFor;
    }
    // For a node to qualify as a static root, it should have children that
    // are not just static text. Otherwise the cost of hoisting out will
    // outweigh the benefits and it's better off to just always render it fresh.
    if (node.static && node.children.length && !(
      node.children.length === 1 &&
      node.children[0].type === 3
    )) {
      node.staticRoot = true;
      return
    } else {
      node.staticRoot = false;
    }
    if (node.children) {
      for (var i = 0, l = node.children.length; i < l; i++) {
        markStaticRoots(node.children[i], isInFor || !!node.for);
      }
    }
    if (node.ifConditions) {
      for (var i$1 = 1, l$1 = node.ifConditions.length; i$1 < l$1; i$1++) {
        markStaticRoots(node.ifConditions[i$1].block, isInFor);
      }
    }
  }
}

function isStatic (node) {
  if (node.type === 2) { // expression
    return false
  }
  if (node.type === 3) { // text
    return true
  }
  return !!(node.pre || (
    !node.hasBindings && // no dynamic bindings
    !node.if && !node.for && // not v-if or v-for or v-else
    !isBuiltInTag(node.tag) && // not a built-in
    isPlatformReservedTag(node.tag) && // not a component
    !isDirectChildOfTemplateFor(node) &&
    Object.keys(node).every(isStaticKey)
  ))
}

function isDirectChildOfTemplateFor (node) {
  while (node.parent) {
    node = node.parent;
    if (node.tag !== 'template') {
      return false
    }
    if (node.for) {
      return true
    }
  }
  return false
}

/*  */

var fnExpRE = /^([\w$_]+|\([^)]*?\))\s*=>|^function(?:\s+[\w$]+)?\s*\(/;
var fnInvokeRE = /\([^)]*?\);*$/;
var simplePathRE = /^[A-Za-z_$][\w$]*(?:\.[A-Za-z_$][\w$]*|\['[^']*?']|\["[^"]*?"]|\[\d+]|\[[A-Za-z_$][\w$]*])*$/;

// KeyboardEvent.keyCode aliases
var keyCodes = {
  esc: 27,
  tab: 9,
  enter: 13,
  space: 32,
  up: 38,
  left: 37,
  right: 39,
  down: 40,
  'delete': [8, 46]
};

// KeyboardEvent.key aliases
var keyNames = {
  // #7880: IE11 and Edge use `Esc` for Escape key name.
  esc: ['Esc', 'Escape'],
  tab: 'Tab',
  enter: 'Enter',
  // #9112: IE11 uses `Spacebar` for Space key name.
  space: [' ', 'Spacebar'],
  // #7806: IE11 uses key names without `Arrow` prefix for arrow keys.
  up: ['Up', 'ArrowUp'],
  left: ['Left', 'ArrowLeft'],
  right: ['Right', 'ArrowRight'],
  down: ['Down', 'ArrowDown'],
  // #9112: IE11 uses `Del` for Delete key name.
  'delete': ['Backspace', 'Delete', 'Del']
};

// #4868: modifiers that prevent the execution of the listener
// need to explicitly return null so that we can determine whether to remove
// the listener for .once
var genGuard = function (condition) { return ("if(" + condition + ")return null;"); };

var modifierCode = {
  stop: '$event.stopPropagation();',
  prevent: '$event.preventDefault();',
  self: genGuard("$event.target !== $event.currentTarget"),
  ctrl: genGuard("!$event.ctrlKey"),
  shift: genGuard("!$event.shiftKey"),
  alt: genGuard("!$event.altKey"),
  meta: genGuard("!$event.metaKey"),
  left: genGuard("'button' in $event && $event.button !== 0"),
  middle: genGuard("'button' in $event && $event.button !== 1"),
  right: genGuard("'button' in $event && $event.button !== 2")
};

function genHandlers (
  events,
  isNative
) {
  var prefix = isNative ? 'nativeOn:' : 'on:';
  var staticHandlers = "";
  var dynamicHandlers = "";
  for (var name in events) {
    var handlerCode = genHandler(events[name]);
    if (events[name] && events[name].dynamic) {
      dynamicHandlers += name + "," + handlerCode + ",";
    } else {
      staticHandlers += "\"" + name + "\":" + handlerCode + ",";
    }
  }
  staticHandlers = "{" + (staticHandlers.slice(0, -1)) + "}";
  if (dynamicHandlers) {
    return prefix + "_d(" + staticHandlers + ",[" + (dynamicHandlers.slice(0, -1)) + "])"
  } else {
    return prefix + staticHandlers
  }
}

function genHandler (handler) {
  if (!handler) {
    return 'function(){}'
  }

  if (Array.isArray(handler)) {
    return ("[" + (handler.map(function (handler) { return genHandler(handler); }).join(',')) + "]")
  }

  var isMethodPath = simplePathRE.test(handler.value);
  var isFunctionExpression = fnExpRE.test(handler.value);
  var isFunctionInvocation = simplePathRE.test(handler.value.replace(fnInvokeRE, ''));

  if (!handler.modifiers) {
    if (isMethodPath || isFunctionExpression) {
      return handler.value
    }
    return ("function($event){" + (isFunctionInvocation ? ("return " + (handler.value)) : handler.value) + "}") // inline statement
  } else {
    var code = '';
    var genModifierCode = '';
    var keys = [];
    for (var key in handler.modifiers) {
      if (modifierCode[key]) {
        genModifierCode += modifierCode[key];
        // left/right
        if (keyCodes[key]) {
          keys.push(key);
        }
      } else if (key === 'exact') {
        var modifiers = (handler.modifiers);
        genModifierCode += genGuard(
          ['ctrl', 'shift', 'alt', 'meta']
            .filter(function (keyModifier) { return !modifiers[keyModifier]; })
            .map(function (keyModifier) { return ("$event." + keyModifier + "Key"); })
            .join('||')
        );
      } else {
        keys.push(key);
      }
    }
    if (keys.length) {
      code += genKeyFilter(keys);
    }
    // Make sure modifiers like prevent and stop get executed after key filtering
    if (genModifierCode) {
      code += genModifierCode;
    }
    var handlerCode = isMethodPath
      ? ("return " + (handler.value) + "($event)")
      : isFunctionExpression
        ? ("return (" + (handler.value) + ")($event)")
        : isFunctionInvocation
          ? ("return " + (handler.value))
          : handler.value;
    return ("function($event){" + code + handlerCode + "}")
  }
}

function genKeyFilter (keys) {
  return (
    // make sure the key filters only apply to KeyboardEvents
    // #9441: can't use 'keyCode' in $event because Chrome autofill fires fake
    // key events that do not have keyCode property...
    "if(!$event.type.indexOf('key')&&" +
    (keys.map(genFilterCode).join('&&')) + ")return null;"
  )
}

function genFilterCode (key) {
  var keyVal = parseInt(key, 10);
  if (keyVal) {
    return ("$event.keyCode!==" + keyVal)
  }
  var keyCode = keyCodes[key];
  var keyName = keyNames[key];
  return (
    "_k($event.keyCode," +
    (JSON.stringify(key)) + "," +
    (JSON.stringify(keyCode)) + "," +
    "$event.key," +
    "" + (JSON.stringify(keyName)) +
    ")"
  )
}

/*  */

function on (el, dir) {
  if (false) {
    warn("v-on without argument does not support modifiers.");
  }
  el.wrapListeners = function (code) { return ("_g(" + code + "," + (dir.value) + ")"); };
}

/*  */

function bind$1 (el, dir) {
  el.wrapData = function (code) {
    return ("_b(" + code + ",'" + (el.tag) + "'," + (dir.value) + "," + (dir.modifiers && dir.modifiers.prop ? 'true' : 'false') + (dir.modifiers && dir.modifiers.sync ? ',true' : '') + ")")
  };
}

/*  */

var baseDirectives = {
  on: on,
  bind: bind$1,
  cloak: noop
};

/*  */





var CodegenState = function CodegenState (options) {
  this.options = options;
  this.warn = options.warn || baseWarn;
  this.transforms = pluckModuleFunction(options.modules, 'transformCode');
  this.dataGenFns = pluckModuleFunction(options.modules, 'genData');
  this.directives = extend(extend({}, baseDirectives), options.directives);
  var isReservedTag = options.isReservedTag || no;
  this.maybeComponent = function (el) { return !!el.component || !isReservedTag(el.tag); };
  this.onceId = 0;
  this.staticRenderFns = [];
  this.pre = false;
};



function generate (
  ast,
  options
) {
  var state = new CodegenState(options);
  var code = ast ? genElement(ast, state) : '_c("div")';
  return {
    render: ("with(this){return " + code + "}"),
    staticRenderFns: state.staticRenderFns
  }
}

function genElement (el, state) {
  if (el.parent) {
    el.pre = el.pre || el.parent.pre;
  }

  if (el.staticRoot && !el.staticProcessed) {
    return genStatic(el, state)
  } else if (el.once && !el.onceProcessed) {
    return genOnce(el, state)
  } else if (el.for && !el.forProcessed) {
    return genFor(el, state)
  } else if (el.if && !el.ifProcessed) {
    return genIf(el, state)
  } else if (el.tag === 'template' && !el.slotTarget && !state.pre) {
    return genChildren(el, state) || 'void 0'
  } else if (el.tag === 'slot') {
    return genSlot(el, state)
  } else {
    // component or element
    var code;
    if (el.component) {
      code = genComponent(el.component, el, state);
    } else {
      var data;
      if (!el.plain || (el.pre && state.maybeComponent(el))) {
        data = genData$2(el, state);
      }

      var children = el.inlineTemplate ? null : genChildren(el, state, true);
      code = "_c('" + (el.tag) + "'" + (data ? ("," + data) : '') + (children ? ("," + children) : '') + ")";
    }
    // module transforms
    for (var i = 0; i < state.transforms.length; i++) {
      code = state.transforms[i](el, code);
    }
    return code
  }
}

// hoist static sub-trees out
function genStatic (el, state) {
  el.staticProcessed = true;
  // Some elements (templates) need to behave differently inside of a v-pre
  // node.  All pre nodes are static roots, so we can use this as a location to
  // wrap a state change and reset it upon exiting the pre node.
  var originalPreState = state.pre;
  if (el.pre) {
    state.pre = el.pre;
  }
  state.staticRenderFns.push(("with(this){return " + (genElement(el, state)) + "}"));
  state.pre = originalPreState;
  return ("_m(" + (state.staticRenderFns.length - 1) + (el.staticInFor ? ',true' : '') + ")")
}

// v-once
function genOnce (el, state) {
  el.onceProcessed = true;
  if (el.if && !el.ifProcessed) {
    return genIf(el, state)
  } else if (el.staticInFor) {
    var key = '';
    var parent = el.parent;
    while (parent) {
      if (parent.for) {
        key = parent.key;
        break
      }
      parent = parent.parent;
    }
    if (!key) {
      "production" !== 'production' && state.warn(
        "v-once can only be used inside v-for that is keyed. ",
        el.rawAttrsMap['v-once']
      );
      return genElement(el, state)
    }
    return ("_o(" + (genElement(el, state)) + "," + (state.onceId++) + "," + key + ")")
  } else {
    return genStatic(el, state)
  }
}

function genIf (
  el,
  state,
  altGen,
  altEmpty
) {
  el.ifProcessed = true; // avoid recursion
  return genIfConditions(el.ifConditions.slice(), state, altGen, altEmpty)
}

function genIfConditions (
  conditions,
  state,
  altGen,
  altEmpty
) {
  if (!conditions.length) {
    return altEmpty || '_e()'
  }

  var condition = conditions.shift();
  if (condition.exp) {
    return ("(" + (condition.exp) + ")?" + (genTernaryExp(condition.block)) + ":" + (genIfConditions(conditions, state, altGen, altEmpty)))
  } else {
    return ("" + (genTernaryExp(condition.block)))
  }

  // v-if with v-once should generate code like (a)?_m(0):_m(1)
  function genTernaryExp (el) {
    return altGen
      ? altGen(el, state)
      : el.once
        ? genOnce(el, state)
        : genElement(el, state)
  }
}

function genFor (
  el,
  state,
  altGen,
  altHelper
) {
  var exp = el.for;
  var alias = el.alias;
  var iterator1 = el.iterator1 ? ("," + (el.iterator1)) : '';
  var iterator2 = el.iterator2 ? ("," + (el.iterator2)) : '';

  if (false
  ) {
    state.warn(
      "<" + (el.tag) + " v-for=\"" + alias + " in " + exp + "\">: component lists rendered with " +
      "v-for should have explicit keys. " +
      "See https://vuejs.org/guide/list.html#key for more info.",
      el.rawAttrsMap['v-for'],
      true /* tip */
    );
  }

  el.forProcessed = true; // avoid recursion
  return (altHelper || '_l') + "((" + exp + ")," +
    "function(" + alias + iterator1 + iterator2 + "){" +
      "return " + ((altGen || genElement)(el, state)) +
    '})'
}

function genData$2 (el, state) {
  var data = '{';

  // directives first.
  // directives may mutate the el's other properties before they are generated.
  var dirs = genDirectives(el, state);
  if (dirs) { data += dirs + ','; }

  // key
  if (el.key) {
    data += "key:" + (el.key) + ",";
  }
  // ref
  if (el.ref) {
    data += "ref:" + (el.ref) + ",";
  }
  if (el.refInFor) {
    data += "refInFor:true,";
  }
  // pre
  if (el.pre) {
    data += "pre:true,";
  }
  // record original tag name for components using "is" attribute
  if (el.component) {
    data += "tag:\"" + (el.tag) + "\",";
  }
  // module data generation functions
  for (var i = 0; i < state.dataGenFns.length; i++) {
    data += state.dataGenFns[i](el);
  }
  // attributes
  if (el.attrs) {
    data += "attrs:" + (genProps(el.attrs)) + ",";
  }
  // DOM props
  if (el.props) {
    data += "domProps:" + (genProps(el.props)) + ",";
  }
  // event handlers
  if (el.events) {
    data += (genHandlers(el.events, false)) + ",";
  }
  if (el.nativeEvents) {
    data += (genHandlers(el.nativeEvents, true)) + ",";
  }
  // slot target
  // only for non-scoped slots
  if (el.slotTarget && !el.slotScope) {
    data += "slot:" + (el.slotTarget) + ",";
  }
  // scoped slots
  if (el.scopedSlots) {
    data += (genScopedSlots(el, el.scopedSlots, state)) + ",";
  }
  // component v-model
  if (el.model) {
    data += "model:{value:" + (el.model.value) + ",callback:" + (el.model.callback) + ",expression:" + (el.model.expression) + "},";
  }
  // inline-template
  if (el.inlineTemplate) {
    var inlineTemplate = genInlineTemplate(el, state);
    if (inlineTemplate) {
      data += inlineTemplate + ",";
    }
  }
  data = data.replace(/,$/, '') + '}';
  // v-bind dynamic argument wrap
  // v-bind with dynamic arguments must be applied using the same v-bind object
  // merge helper so that class/style/mustUseProp attrs are handled correctly.
  if (el.dynamicAttrs) {
    data = "_b(" + data + ",\"" + (el.tag) + "\"," + (genProps(el.dynamicAttrs)) + ")";
  }
  // v-bind data wrap
  if (el.wrapData) {
    data = el.wrapData(data);
  }
  // v-on data wrap
  if (el.wrapListeners) {
    data = el.wrapListeners(data);
  }
  return data
}

function genDirectives (el, state) {
  var dirs = el.directives;
  if (!dirs) { return }
  var res = 'directives:[';
  var hasRuntime = false;
  var i, l, dir, needRuntime;
  for (i = 0, l = dirs.length; i < l; i++) {
    dir = dirs[i];
    needRuntime = true;
    var gen = state.directives[dir.name];
    if (gen) {
      // compile-time directive that manipulates AST.
      // returns true if it also needs a runtime counterpart.
      needRuntime = !!gen(el, dir, state.warn);
    }
    if (needRuntime) {
      hasRuntime = true;
      res += "{name:\"" + (dir.name) + "\",rawName:\"" + (dir.rawName) + "\"" + (dir.value ? (",value:(" + (dir.value) + "),expression:" + (JSON.stringify(dir.value))) : '') + (dir.arg ? (",arg:" + (dir.isDynamicArg ? dir.arg : ("\"" + (dir.arg) + "\""))) : '') + (dir.modifiers ? (",modifiers:" + (JSON.stringify(dir.modifiers))) : '') + "},";
    }
  }
  if (hasRuntime) {
    return res.slice(0, -1) + ']'
  }
}

function genInlineTemplate (el, state) {
  var ast = el.children[0];
  if (false) {
    state.warn(
      'Inline-template components must have exactly one child element.',
      { start: el.start }
    );
  }
  if (ast && ast.type === 1) {
    var inlineRenderFns = generate(ast, state.options);
    return ("inlineTemplate:{render:function(){" + (inlineRenderFns.render) + "},staticRenderFns:[" + (inlineRenderFns.staticRenderFns.map(function (code) { return ("function(){" + code + "}"); }).join(',')) + "]}")
  }
}

function genScopedSlots (
  el,
  slots,
  state
) {
  // by default scoped slots are considered "stable", this allows child
  // components with only scoped slots to skip forced updates from parent.
  // but in some cases we have to bail-out of this optimization
  // for example if the slot contains dynamic names, has v-if or v-for on them...
  var needsForceUpdate = el.for || Object.keys(slots).some(function (key) {
    var slot = slots[key];
    return (
      slot.slotTargetDynamic ||
      slot.if ||
      slot.for ||
      containsSlotChild(slot) // is passing down slot from parent which may be dynamic
    )
  });

  // #9534: if a component with scoped slots is inside a conditional branch,
  // it's possible for the same component to be reused but with different
  // compiled slot content. To avoid that, we generate a unique key based on
  // the generated code of all the slot contents.
  var needsKey = !!el.if;

  // OR when it is inside another scoped slot or v-for (the reactivity may be
  // disconnected due to the intermediate scope variable)
  // #9438, #9506
  // TODO: this can be further optimized by properly analyzing in-scope bindings
  // and skip force updating ones that do not actually use scope variables.
  if (!needsForceUpdate) {
    var parent = el.parent;
    while (parent) {
      if (
        (parent.slotScope && parent.slotScope !== emptySlotScopeToken) ||
        parent.for
      ) {
        needsForceUpdate = true;
        break
      }
      if (parent.if) {
        needsKey = true;
      }
      parent = parent.parent;
    }
  }

  var generatedSlots = Object.keys(slots)
    .map(function (key) { return genScopedSlot(slots[key], state); })
    .join(',');

  return ("scopedSlots:_u([" + generatedSlots + "]" + (needsForceUpdate ? ",null,true" : "") + (!needsForceUpdate && needsKey ? (",null,false," + (hash(generatedSlots))) : "") + ")")
}

function hash(str) {
  var hash = 5381;
  var i = str.length;
  while(i) {
    hash = (hash * 33) ^ str.charCodeAt(--i);
  }
  return hash >>> 0
}

function containsSlotChild (el) {
  if (el.type === 1) {
    if (el.tag === 'slot') {
      return true
    }
    return el.children.some(containsSlotChild)
  }
  return false
}

function genScopedSlot (
  el,
  state
) {
  var isLegacySyntax = el.attrsMap['slot-scope'];
  if (el.if && !el.ifProcessed && !isLegacySyntax) {
    return genIf(el, state, genScopedSlot, "null")
  }
  if (el.for && !el.forProcessed) {
    return genFor(el, state, genScopedSlot)
  }
  var slotScope = el.slotScope === emptySlotScopeToken
    ? ""
    : String(el.slotScope);
  var fn = "function(" + slotScope + "){" +
    "return " + (el.tag === 'template'
      ? el.if && isLegacySyntax
        ? ("(" + (el.if) + ")?" + (genChildren(el, state) || 'undefined') + ":undefined")
        : genChildren(el, state) || 'undefined'
      : genElement(el, state)) + "}";
  // reverse proxy v-slot without scope on this.$slots
  var reverseProxy = slotScope ? "" : ",proxy:true";
  return ("{key:" + (el.slotTarget || "\"default\"") + ",fn:" + fn + reverseProxy + "}")
}

function genChildren (
  el,
  state,
  checkSkip,
  altGenElement,
  altGenNode
) {
  var children = el.children;
  if (children.length) {
    var el$1 = children[0];
    // optimize single v-for
    if (children.length === 1 &&
      el$1.for &&
      el$1.tag !== 'template' &&
      el$1.tag !== 'slot'
    ) {
      var normalizationType = checkSkip
        ? state.maybeComponent(el$1) ? ",1" : ",0"
        : "";
      return ("" + ((altGenElement || genElement)(el$1, state)) + normalizationType)
    }
    var normalizationType$1 = checkSkip
      ? getNormalizationType(children, state.maybeComponent)
      : 0;
    var gen = altGenNode || genNode;
    return ("[" + (children.map(function (c) { return gen(c, state); }).join(',')) + "]" + (normalizationType$1 ? ("," + normalizationType$1) : ''))
  }
}

// determine the normalization needed for the children array.
// 0: no normalization needed
// 1: simple normalization needed (possible 1-level deep nested array)
// 2: full normalization needed
function getNormalizationType (
  children,
  maybeComponent
) {
  var res = 0;
  for (var i = 0; i < children.length; i++) {
    var el = children[i];
    if (el.type !== 1) {
      continue
    }
    if (needsNormalization(el) ||
        (el.ifConditions && el.ifConditions.some(function (c) { return needsNormalization(c.block); }))) {
      res = 2;
      break
    }
    if (maybeComponent(el) ||
        (el.ifConditions && el.ifConditions.some(function (c) { return maybeComponent(c.block); }))) {
      res = 1;
    }
  }
  return res
}

function needsNormalization (el) {
  return el.for !== undefined || el.tag === 'template' || el.tag === 'slot'
}

function genNode (node, state) {
  if (node.type === 1) {
    return genElement(node, state)
  } else if (node.type === 3 && node.isComment) {
    return genComment(node)
  } else {
    return genText(node)
  }
}

function genText (text) {
  return ("_v(" + (text.type === 2
    ? text.expression // no need for () because already wrapped in _s()
    : transformSpecialNewlines(JSON.stringify(text.text))) + ")")
}

function genComment (comment) {
  return ("_e(" + (JSON.stringify(comment.text)) + ")")
}

function genSlot (el, state) {
  var slotName = el.slotName || '"default"';
  var children = genChildren(el, state);
  var res = "_t(" + slotName + (children ? ("," + children) : '');
  var attrs = el.attrs || el.dynamicAttrs
    ? genProps((el.attrs || []).concat(el.dynamicAttrs || []).map(function (attr) { return ({
        // slot props are camelized
        name: camelize(attr.name),
        value: attr.value,
        dynamic: attr.dynamic
      }); }))
    : null;
  var bind$$1 = el.attrsMap['v-bind'];
  if ((attrs || bind$$1) && !children) {
    res += ",null";
  }
  if (attrs) {
    res += "," + attrs;
  }
  if (bind$$1) {
    res += (attrs ? '' : ',null') + "," + bind$$1;
  }
  return res + ')'
}

// componentName is el.component, take it as argument to shun flow's pessimistic refinement
function genComponent (
  componentName,
  el,
  state
) {
  var children = el.inlineTemplate ? null : genChildren(el, state, true);
  return ("_c(" + componentName + "," + (genData$2(el, state)) + (children ? ("," + children) : '') + ")")
}

function genProps (props) {
  var staticProps = "";
  var dynamicProps = "";
  for (var i = 0; i < props.length; i++) {
    var prop = props[i];
    var value = transformSpecialNewlines(prop.value);
    if (prop.dynamic) {
      dynamicProps += (prop.name) + "," + value + ",";
    } else {
      staticProps += "\"" + (prop.name) + "\":" + value + ",";
    }
  }
  staticProps = "{" + (staticProps.slice(0, -1)) + "}";
  if (dynamicProps) {
    return ("_d(" + staticProps + ",[" + (dynamicProps.slice(0, -1)) + "])")
  } else {
    return staticProps
  }
}

// #3895, #4268
function transformSpecialNewlines (text) {
  return text
    .replace(/\u2028/g, '\\u2028')
    .replace(/\u2029/g, '\\u2029')
}

/*  */



// these keywords should not appear inside expressions, but operators like
// typeof, instanceof and in are allowed
var prohibitedKeywordRE = new RegExp('\\b' + (
  'do,if,for,let,new,try,var,case,else,with,await,break,catch,class,const,' +
  'super,throw,while,yield,delete,export,import,return,switch,default,' +
  'extends,finally,continue,debugger,function,arguments'
).split(',').join('\\b|\\b') + '\\b');

// these unary operators should not be used as property/method names
var unaryOperatorsRE = new RegExp('\\b' + (
  'delete,typeof,void'
).split(',').join('\\s*\\([^\\)]*\\)|\\b') + '\\s*\\([^\\)]*\\)');

// strip strings in expressions
var stripStringRE = /'(?:[^'\\]|\\.)*'|"(?:[^"\\]|\\.)*"|`(?:[^`\\]|\\.)*\$\{|\}(?:[^`\\]|\\.)*`|`(?:[^`\\]|\\.)*`/g;

// detect problematic expressions in a template
function detectErrors (ast, warn) {
  if (ast) {
    checkNode(ast, warn);
  }
}

function checkNode (node, warn) {
  if (node.type === 1) {
    for (var name in node.attrsMap) {
      if (dirRE.test(name)) {
        var value = node.attrsMap[name];
        if (value) {
          var range = node.rawAttrsMap[name];
          if (name === 'v-for') {
            checkFor(node, ("v-for=\"" + value + "\""), warn, range);
          } else if (name === 'v-slot' || name[0] === '#') {
            checkFunctionParameterExpression(value, (name + "=\"" + value + "\""), warn, range);
          } else if (onRE.test(name)) {
            checkEvent(value, (name + "=\"" + value + "\""), warn, range);
          } else {
            checkExpression(value, (name + "=\"" + value + "\""), warn, range);
          }
        }
      }
    }
    if (node.children) {
      for (var i = 0; i < node.children.length; i++) {
        checkNode(node.children[i], warn);
      }
    }
  } else if (node.type === 2) {
    checkExpression(node.expression, node.text, warn, node);
  }
}

function checkEvent (exp, text, warn, range) {
  var stripped = exp.replace(stripStringRE, '');
  var keywordMatch = stripped.match(unaryOperatorsRE);
  if (keywordMatch && stripped.charAt(keywordMatch.index - 1) !== '$') {
    warn(
      "avoid using JavaScript unary operator as property name: " +
      "\"" + (keywordMatch[0]) + "\" in expression " + (text.trim()),
      range
    );
  }
  checkExpression(exp, text, warn, range);
}

function checkFor (node, text, warn, range) {
  checkExpression(node.for || '', text, warn, range);
  checkIdentifier(node.alias, 'v-for alias', text, warn, range);
  checkIdentifier(node.iterator1, 'v-for iterator', text, warn, range);
  checkIdentifier(node.iterator2, 'v-for iterator', text, warn, range);
}

function checkIdentifier (
  ident,
  type,
  text,
  warn,
  range
) {
  if (typeof ident === 'string') {
    try {
      new Function(("var " + ident + "=_"));
    } catch (e) {
      warn(("invalid " + type + " \"" + ident + "\" in expression: " + (text.trim())), range);
    }
  }
}

function checkExpression (exp, text, warn, range) {
  try {
    new Function(("return " + exp));
  } catch (e) {
    var keywordMatch = exp.replace(stripStringRE, '').match(prohibitedKeywordRE);
    if (keywordMatch) {
      warn(
        "avoid using JavaScript keyword as property name: " +
        "\"" + (keywordMatch[0]) + "\"\n  Raw expression: " + (text.trim()),
        range
      );
    } else {
      warn(
        "invalid expression: " + (e.message) + " in\n\n" +
        "    " + exp + "\n\n" +
        "  Raw expression: " + (text.trim()) + "\n",
        range
      );
    }
  }
}

function checkFunctionParameterExpression (exp, text, warn, range) {
  try {
    new Function(exp, '');
  } catch (e) {
    warn(
      "invalid function parameter expression: " + (e.message) + " in\n\n" +
      "    " + exp + "\n\n" +
      "  Raw expression: " + (text.trim()) + "\n",
      range
    );
  }
}

/*  */

var range = 2;

function generateCodeFrame (
  source,
  start,
  end
) {
  if ( start === void 0 ) start = 0;
  if ( end === void 0 ) end = source.length;

  var lines = source.split(/\r?\n/);
  var count = 0;
  var res = [];
  for (var i = 0; i < lines.length; i++) {
    count += lines[i].length + 1;
    if (count >= start) {
      for (var j = i - range; j <= i + range || end > count; j++) {
        if (j < 0 || j >= lines.length) { continue }
        res.push(("" + (j + 1) + (repeat$1(" ", 3 - String(j + 1).length)) + "|  " + (lines[j])));
        var lineLength = lines[j].length;
        if (j === i) {
          // push underline
          var pad = start - (count - lineLength) + 1;
          var length = end > count ? lineLength - pad : end - start;
          res.push("   |  " + repeat$1(" ", pad) + repeat$1("^", length));
        } else if (j > i) {
          if (end > count) {
            var length$1 = Math.min(end - count, lineLength);
            res.push("   |  " + repeat$1("^", length$1));
          }
          count += lineLength + 1;
        }
      }
      break
    }
  }
  return res.join('\n')
}

function repeat$1 (str, n) {
  var result = '';
  if (n > 0) {
    while (true) { // eslint-disable-line
      if (n & 1) { result += str; }
      n >>>= 1;
      if (n <= 0) { break }
      str += str;
    }
  }
  return result
}

/*  */



function createFunction (code, errors) {
  try {
    return new Function(code)
  } catch (err) {
    errors.push({ err: err, code: code });
    return noop
  }
}

function createCompileToFunctionFn (compile) {
  var cache = Object.create(null);

  return function compileToFunctions (
    template,
    options,
    vm
  ) {
    options = extend({}, options);
    var warn$$1 = options.warn || warn;
    delete options.warn;

    /* istanbul ignore if */
    if (false) {
      // detect possible CSP restriction
      try {
        new Function('return 1');
      } catch (e) {
        if (e.toString().match(/unsafe-eval|CSP/)) {
          warn$$1(
            'It seems you are using the standalone build of Vue.js in an ' +
            'environment with Content Security Policy that prohibits unsafe-eval. ' +
            'The template compiler cannot work in this environment. Consider ' +
            'relaxing the policy to allow unsafe-eval or pre-compiling your ' +
            'templates into render functions.'
          );
        }
      }
    }

    // check cache
    var key = options.delimiters
      ? String(options.delimiters) + template
      : template;
    if (cache[key]) {
      return cache[key]
    }

    // compile
    var compiled = compile(template, options);

    // check compilation errors/tips
    if (false) {
      if (compiled.errors && compiled.errors.length) {
        if (options.outputSourceRange) {
          compiled.errors.forEach(function (e) {
            warn$$1(
              "Error compiling template:\n\n" + (e.msg) + "\n\n" +
              generateCodeFrame(template, e.start, e.end),
              vm
            );
          });
        } else {
          warn$$1(
            "Error compiling template:\n\n" + template + "\n\n" +
            compiled.errors.map(function (e) { return ("- " + e); }).join('\n') + '\n',
            vm
          );
        }
      }
      if (compiled.tips && compiled.tips.length) {
        if (options.outputSourceRange) {
          compiled.tips.forEach(function (e) { return tip(e.msg, vm); });
        } else {
          compiled.tips.forEach(function (msg) { return tip(msg, vm); });
        }
      }
    }

    // turn code into functions
    var res = {};
    var fnGenErrors = [];
    res.render = createFunction(compiled.render, fnGenErrors);
    res.staticRenderFns = compiled.staticRenderFns.map(function (code) {
      return createFunction(code, fnGenErrors)
    });

    // check function generation errors.
    // this should only happen if there is a bug in the compiler itself.
    // mostly for codegen development use
    /* istanbul ignore if */
    if (false) {
      if ((!compiled.errors || !compiled.errors.length) && fnGenErrors.length) {
        warn$$1(
          "Failed to generate render function:\n\n" +
          fnGenErrors.map(function (ref) {
            var err = ref.err;
            var code = ref.code;

            return ((err.toString()) + " in\n\n" + code + "\n");
        }).join('\n'),
          vm
        );
      }
    }

    return (cache[key] = res)
  }
}

/*  */

function createCompilerCreator (baseCompile) {
  return function createCompiler (baseOptions) {
    function compile (
      template,
      options
    ) {
      var finalOptions = Object.create(baseOptions);
      var errors = [];
      var tips = [];

      var warn = function (msg, range, tip) {
        (tip ? tips : errors).push(msg);
      };

      if (options) {
        if (false) {
          // $flow-disable-line
          var leadingSpaceLength = template.match(/^\s*/)[0].length;

          warn = function (msg, range, tip) {
            var data = { msg: msg };
            if (range) {
              if (range.start != null) {
                data.start = range.start + leadingSpaceLength;
              }
              if (range.end != null) {
                data.end = range.end + leadingSpaceLength;
              }
            }
            (tip ? tips : errors).push(data);
          };
        }
        // merge custom modules
        if (options.modules) {
          finalOptions.modules =
            (baseOptions.modules || []).concat(options.modules);
        }
        // merge custom directives
        if (options.directives) {
          finalOptions.directives = extend(
            Object.create(baseOptions.directives || null),
            options.directives
          );
        }
        // copy other options
        for (var key in options) {
          if (key !== 'modules' && key !== 'directives') {
            finalOptions[key] = options[key];
          }
        }
      }

      finalOptions.warn = warn;

      var compiled = baseCompile(template.trim(), finalOptions);
      if (false) {
        detectErrors(compiled.ast, warn);
      }
      compiled.errors = errors;
      compiled.tips = tips;
      return compiled
    }

    return {
      compile: compile,
      compileToFunctions: createCompileToFunctionFn(compile)
    }
  }
}

/*  */

// `createCompilerCreator` allows creating compilers that use alternative
// parser/optimizer/codegen, e.g the SSR optimizing compiler.
// Here we just export a default compiler using the default parts.
var createCompiler = createCompilerCreator(function baseCompile (
  template,
  options
) {
  var ast = parse(template.trim(), options);
  if (options.optimize !== false) {
    optimize(ast, options);
  }
  var code = generate(ast, options);
  return {
    ast: ast,
    render: code.render,
    staticRenderFns: code.staticRenderFns
  }
});

/*  */

var ref$1 = createCompiler(baseOptions);
var compile = ref$1.compile;
var compileToFunctions = ref$1.compileToFunctions;

/*  */

// check whether current browser encodes a char inside attribute values
var div;
function getShouldDecode (href) {
  div = div || document.createElement('div');
  div.innerHTML = href ? "<a href=\"\n\"/>" : "<div a=\"\n\"/>";
  return div.innerHTML.indexOf('&#10;') > 0
}

// #3663: IE encodes newlines inside attribute values while other browsers don't
var shouldDecodeNewlines = inBrowser ? getShouldDecode(false) : false;
// #6828: chrome encodes content in a[href]
var shouldDecodeNewlinesForHref = inBrowser ? getShouldDecode(true) : false;

/*  */

var idToTemplate = cached(function (id) {
  var el = query(id);
  return el && el.innerHTML
});

var mount = Vue.prototype.$mount;
Vue.prototype.$mount = function (
  el,
  hydrating
) {
  el = el && query(el);

  /* istanbul ignore if */
  if (el === document.body || el === document.documentElement) {
    "production" !== 'production' && warn(
      "Do not mount Vue to <html> or <body> - mount to normal elements instead."
    );
    return this
  }

  var options = this.$options;
  // resolve template/el and convert to render function
  if (!options.render) {
    var template = options.template;
    if (template) {
      if (typeof template === 'string') {
        if (template.charAt(0) === '#') {
          template = idToTemplate(template);
          /* istanbul ignore if */
          if (false) {
            warn(
              ("Template element not found or is empty: " + (options.template)),
              this
            );
          }
        }
      } else if (template.nodeType) {
        template = template.innerHTML;
      } else {
        if (false) {
          warn('invalid template option:' + template, this);
        }
        return this
      }
    } else if (el) {
      template = getOuterHTML(el);
    }
    if (template) {
      /* istanbul ignore if */
      if (false) {
        mark('compile');
      }

      var ref = compileToFunctions(template, {
        outputSourceRange: "production" !== 'production',
        shouldDecodeNewlines: shouldDecodeNewlines,
        shouldDecodeNewlinesForHref: shouldDecodeNewlinesForHref,
        delimiters: options.delimiters,
        comments: options.comments
      }, this);
      var render = ref.render;
      var staticRenderFns = ref.staticRenderFns;
      options.render = render;
      options.staticRenderFns = staticRenderFns;

      /* istanbul ignore if */
      if (false) {
        mark('compile end');
        measure(("vue " + (this._name) + " compile"), 'compile', 'compile end');
      }
    }
  }
  return mount.call(this, el, hydrating)
};

/**
 * Get outerHTML of elements, taking care
 * of SVG elements in IE as well.
 */
function getOuterHTML (el) {
  if (el.outerHTML) {
    return el.outerHTML
  } else {
    var container = document.createElement('div');
    container.appendChild(el.cloneNode(true));
    return container.innerHTML
  }
}

Vue.compile = compileToFunctions;

/* harmony default export */ __webpack_exports__["a"] = (Vue);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4), __webpack_require__(18).setImmediate))

/***/ }),
/* 4 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 5 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(3);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]());

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(25),
  /* template */
  __webpack_require__(28),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(26),
  /* template */
  __webpack_require__(27),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function bind(fn, thisArg) {
  return function wrap() {
    var args = new Array(arguments.length);
    for (var i = 0; i < args.length; i++) {
      args[i] = arguments[i];
    }
    return fn.apply(thisArg, args);
  };
};


/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);

function encode(val) {
  return encodeURIComponent(val).
    replace(/%40/gi, '@').
    replace(/%3A/gi, ':').
    replace(/%24/g, '$').
    replace(/%2C/gi, ',').
    replace(/%20/g, '+').
    replace(/%5B/gi, '[').
    replace(/%5D/gi, ']');
}

/**
 * Build a URL by appending params to the end
 *
 * @param {string} url The base of the url (e.g., http://www.google.com)
 * @param {object} [params] The params to be appended
 * @returns {string} The formatted url
 */
module.exports = function buildURL(url, params, paramsSerializer) {
  /*eslint no-param-reassign:0*/
  if (!params) {
    return url;
  }

  var serializedParams;
  if (paramsSerializer) {
    serializedParams = paramsSerializer(params);
  } else if (utils.isURLSearchParams(params)) {
    serializedParams = params.toString();
  } else {
    var parts = [];

    utils.forEach(params, function serialize(val, key) {
      if (val === null || typeof val === 'undefined') {
        return;
      }

      if (utils.isArray(val)) {
        key = key + '[]';
      } else {
        val = [val];
      }

      utils.forEach(val, function parseValue(v) {
        if (utils.isDate(v)) {
          v = v.toISOString();
        } else if (utils.isObject(v)) {
          v = JSON.stringify(v);
        }
        parts.push(encode(key) + '=' + encode(v));
      });
    });

    serializedParams = parts.join('&');
  }

  if (serializedParams) {
    var hashmarkIndex = url.indexOf('#');
    if (hashmarkIndex !== -1) {
      url = url.slice(0, hashmarkIndex);
    }

    url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
  }

  return url;
};


/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function isCancel(value) {
  return !!(value && value.__CANCEL__);
};


/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {

var utils = __webpack_require__(1);
var normalizeHeaderName = __webpack_require__(35);

var DEFAULT_CONTENT_TYPE = {
  'Content-Type': 'application/x-www-form-urlencoded'
};

function setContentTypeIfUnset(headers, value) {
  if (!utils.isUndefined(headers) && utils.isUndefined(headers['Content-Type'])) {
    headers['Content-Type'] = value;
  }
}

function getDefaultAdapter() {
  var adapter;
  if (typeof XMLHttpRequest !== 'undefined') {
    // For browsers use XHR adapter
    adapter = __webpack_require__(12);
  } else if (typeof process !== 'undefined' && Object.prototype.toString.call(process) === '[object process]') {
    // For node use HTTP adapter
    adapter = __webpack_require__(12);
  }
  return adapter;
}

var defaults = {
  adapter: getDefaultAdapter(),

  transformRequest: [function transformRequest(data, headers) {
    normalizeHeaderName(headers, 'Accept');
    normalizeHeaderName(headers, 'Content-Type');
    if (utils.isFormData(data) ||
      utils.isArrayBuffer(data) ||
      utils.isBuffer(data) ||
      utils.isStream(data) ||
      utils.isFile(data) ||
      utils.isBlob(data)
    ) {
      return data;
    }
    if (utils.isArrayBufferView(data)) {
      return data.buffer;
    }
    if (utils.isURLSearchParams(data)) {
      setContentTypeIfUnset(headers, 'application/x-www-form-urlencoded;charset=utf-8');
      return data.toString();
    }
    if (utils.isObject(data)) {
      setContentTypeIfUnset(headers, 'application/json;charset=utf-8');
      return JSON.stringify(data);
    }
    return data;
  }],

  transformResponse: [function transformResponse(data) {
    /*eslint no-param-reassign:0*/
    if (typeof data === 'string') {
      try {
        data = JSON.parse(data);
      } catch (e) { /* Ignore */ }
    }
    return data;
  }],

  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,

  xsrfCookieName: 'XSRF-TOKEN',
  xsrfHeaderName: 'X-XSRF-TOKEN',

  maxContentLength: -1,

  validateStatus: function validateStatus(status) {
    return status >= 200 && status < 300;
  }
};

defaults.headers = {
  common: {
    'Accept': 'application/json, text/plain, */*'
  }
};

utils.forEach(['delete', 'get', 'head'], function forEachMethodNoData(method) {
  defaults.headers[method] = {};
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  defaults.headers[method] = utils.merge(DEFAULT_CONTENT_TYPE);
});

module.exports = defaults;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);
var settle = __webpack_require__(36);
var buildURL = __webpack_require__(9);
var buildFullPath = __webpack_require__(38);
var parseHeaders = __webpack_require__(41);
var isURLSameOrigin = __webpack_require__(42);
var createError = __webpack_require__(13);

module.exports = function xhrAdapter(config) {
  return new Promise(function dispatchXhrRequest(resolve, reject) {
    var requestData = config.data;
    var requestHeaders = config.headers;

    if (utils.isFormData(requestData)) {
      delete requestHeaders['Content-Type']; // Let the browser set it
    }

    var request = new XMLHttpRequest();

    // HTTP basic authentication
    if (config.auth) {
      var username = config.auth.username || '';
      var password = config.auth.password || '';
      requestHeaders.Authorization = 'Basic ' + btoa(username + ':' + password);
    }

    var fullPath = buildFullPath(config.baseURL, config.url);
    request.open(config.method.toUpperCase(), buildURL(fullPath, config.params, config.paramsSerializer), true);

    // Set the request timeout in MS
    request.timeout = config.timeout;

    // Listen for ready state
    request.onreadystatechange = function handleLoad() {
      if (!request || request.readyState !== 4) {
        return;
      }

      // The request errored out and we didn't get a response, this will be
      // handled by onerror instead
      // With one exception: request that using file: protocol, most browsers
      // will return status as 0 even though it's a successful request
      if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) {
        return;
      }

      // Prepare the response
      var responseHeaders = 'getAllResponseHeaders' in request ? parseHeaders(request.getAllResponseHeaders()) : null;
      var responseData = !config.responseType || config.responseType === 'text' ? request.responseText : request.response;
      var response = {
        data: responseData,
        status: request.status,
        statusText: request.statusText,
        headers: responseHeaders,
        config: config,
        request: request
      };

      settle(resolve, reject, response);

      // Clean up request
      request = null;
    };

    // Handle browser request cancellation (as opposed to a manual cancellation)
    request.onabort = function handleAbort() {
      if (!request) {
        return;
      }

      reject(createError('Request aborted', config, 'ECONNABORTED', request));

      // Clean up request
      request = null;
    };

    // Handle low level network errors
    request.onerror = function handleError() {
      // Real errors are hidden from us by the browser
      // onerror should only fire if it's a network error
      reject(createError('Network Error', config, null, request));

      // Clean up request
      request = null;
    };

    // Handle timeout
    request.ontimeout = function handleTimeout() {
      var timeoutErrorMessage = 'timeout of ' + config.timeout + 'ms exceeded';
      if (config.timeoutErrorMessage) {
        timeoutErrorMessage = config.timeoutErrorMessage;
      }
      reject(createError(timeoutErrorMessage, config, 'ECONNABORTED',
        request));

      // Clean up request
      request = null;
    };

    // Add xsrf header
    // This is only done if running in a standard browser environment.
    // Specifically not if we're in a web worker, or react-native.
    if (utils.isStandardBrowserEnv()) {
      var cookies = __webpack_require__(43);

      // Add xsrf header
      var xsrfValue = (config.withCredentials || isURLSameOrigin(fullPath)) && config.xsrfCookieName ?
        cookies.read(config.xsrfCookieName) :
        undefined;

      if (xsrfValue) {
        requestHeaders[config.xsrfHeaderName] = xsrfValue;
      }
    }

    // Add headers to the request
    if ('setRequestHeader' in request) {
      utils.forEach(requestHeaders, function setRequestHeader(val, key) {
        if (typeof requestData === 'undefined' && key.toLowerCase() === 'content-type') {
          // Remove Content-Type if data is undefined
          delete requestHeaders[key];
        } else {
          // Otherwise add header to the request
          request.setRequestHeader(key, val);
        }
      });
    }

    // Add withCredentials to request if needed
    if (!utils.isUndefined(config.withCredentials)) {
      request.withCredentials = !!config.withCredentials;
    }

    // Add responseType to request if needed
    if (config.responseType) {
      try {
        request.responseType = config.responseType;
      } catch (e) {
        // Expected DOMException thrown by browsers not compatible XMLHttpRequest Level 2.
        // But, this can be suppressed for 'json' type as it can be parsed by default 'transformResponse' function.
        if (config.responseType !== 'json') {
          throw e;
        }
      }
    }

    // Handle progress if needed
    if (typeof config.onDownloadProgress === 'function') {
      request.addEventListener('progress', config.onDownloadProgress);
    }

    // Not all browsers support upload events
    if (typeof config.onUploadProgress === 'function' && request.upload) {
      request.upload.addEventListener('progress', config.onUploadProgress);
    }

    if (config.cancelToken) {
      // Handle cancellation
      config.cancelToken.promise.then(function onCanceled(cancel) {
        if (!request) {
          return;
        }

        request.abort();
        reject(cancel);
        // Clean up request
        request = null;
      });
    }

    if (requestData === undefined) {
      requestData = null;
    }

    // Send the request
    request.send(requestData);
  });
};


/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var enhanceError = __webpack_require__(37);

/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The created error.
 */
module.exports = function createError(message, config, code, request, response) {
  var error = new Error(message);
  return enhanceError(error, config, code, request, response);
};


/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);

/**
 * Config-specific merge-function which creates a new config-object
 * by merging two configuration objects together.
 *
 * @param {Object} config1
 * @param {Object} config2
 * @returns {Object} New object resulting from merging config2 to config1
 */
module.exports = function mergeConfig(config1, config2) {
  // eslint-disable-next-line no-param-reassign
  config2 = config2 || {};
  var config = {};

  var valueFromConfig2Keys = ['url', 'method', 'params', 'data'];
  var mergeDeepPropertiesKeys = ['headers', 'auth', 'proxy'];
  var defaultToConfig2Keys = [
    'baseURL', 'url', 'transformRequest', 'transformResponse', 'paramsSerializer',
    'timeout', 'withCredentials', 'adapter', 'responseType', 'xsrfCookieName',
    'xsrfHeaderName', 'onUploadProgress', 'onDownloadProgress',
    'maxContentLength', 'validateStatus', 'maxRedirects', 'httpAgent',
    'httpsAgent', 'cancelToken', 'socketPath'
  ];

  utils.forEach(valueFromConfig2Keys, function valueFromConfig2(prop) {
    if (typeof config2[prop] !== 'undefined') {
      config[prop] = config2[prop];
    }
  });

  utils.forEach(mergeDeepPropertiesKeys, function mergeDeepProperties(prop) {
    if (utils.isObject(config2[prop])) {
      config[prop] = utils.deepMerge(config1[prop], config2[prop]);
    } else if (typeof config2[prop] !== 'undefined') {
      config[prop] = config2[prop];
    } else if (utils.isObject(config1[prop])) {
      config[prop] = utils.deepMerge(config1[prop]);
    } else if (typeof config1[prop] !== 'undefined') {
      config[prop] = config1[prop];
    }
  });

  utils.forEach(defaultToConfig2Keys, function defaultToConfig2(prop) {
    if (typeof config2[prop] !== 'undefined') {
      config[prop] = config2[prop];
    } else if (typeof config1[prop] !== 'undefined') {
      config[prop] = config1[prop];
    }
  });

  var axiosKeys = valueFromConfig2Keys
    .concat(mergeDeepPropertiesKeys)
    .concat(defaultToConfig2Keys);

  var otherKeys = Object
    .keys(config2)
    .filter(function filterAxiosKeys(key) {
      return axiosKeys.indexOf(key) === -1;
    });

  utils.forEach(otherKeys, function otherKeysDefaultToConfig2(prop) {
    if (typeof config2[prop] !== 'undefined') {
      config[prop] = config2[prop];
    } else if (typeof config1[prop] !== 'undefined') {
      config[prop] = config1[prop];
    }
  });

  return config;
};


/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * A `Cancel` is an object that is thrown when an operation is canceled.
 *
 * @class
 * @param {string=} message The message.
 */
function Cancel(message) {
  this.message = message;
}

Cancel.prototype.toString = function toString() {
  return 'Cancel' + (this.message ? ': ' + this.message : '');
};

Cancel.prototype.__CANCEL__ = true;

module.exports = Cancel;


/***/ }),
/* 16 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuetify__ = __webpack_require__(526);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuetify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vuetify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_shortkey__ = __webpack_require__(527);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_shortkey___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_shortkey__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_touch__ = __webpack_require__(528);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_touch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_touch__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_resource__ = __webpack_require__(530);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_analytics__ = __webpack_require__(532);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_analytics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vue_analytics__);
/*jshint esversion: 6 */
/* The Vue build version to load with the `import` command
(runtime-only or standalone) has been set in webpack.base.conf with an alias. */

var path = __webpack_require__(17);










__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_3_vuetify___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_4_vue_shortkey___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_6_vue_resource__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_5_vue_touch___default.a.config.swipe = {
  direction: 'horizontal',
  threshold: 10,
  velocity: 0.3,
  pointers: 1
};

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_5_vue_touch___default.a, { name: 'v-touch' });

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_7_vue_analytics___default.a, {
  id: ['UA-137347938-1', 'UA-64435914-1'],
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  autoTracking: {
    pageviewTemplate: function pageviewTemplate(route) {
      return {
        page: path.join(window.location.pathname, route.path),
        title: document.title,
        location: window.location.href
      };
    }
  },
  debug: {
    enabled: false
  }
});

var app = new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  data: {},
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  render: function render(h) {
    return h(__WEBPACK_IMPORTED_MODULE_1__App___default.a);
  }
}).$mount('#app');

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process) {// .dirname, .basename, and .extname methods are extracted from Node.js v8.11.1,
// backported and transplited with Babel, with backwards-compat fixes

// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// resolves . and .. elements in a path array with directory names there
// must be no slashes, empty elements, or device names (c:\) in the array
// (so also no leading and trailing slashes - it does not distinguish
// relative and absolute paths)
function normalizeArray(parts, allowAboveRoot) {
  // if the path tries to go above the root, `up` ends up > 0
  var up = 0;
  for (var i = parts.length - 1; i >= 0; i--) {
    var last = parts[i];
    if (last === '.') {
      parts.splice(i, 1);
    } else if (last === '..') {
      parts.splice(i, 1);
      up++;
    } else if (up) {
      parts.splice(i, 1);
      up--;
    }
  }

  // if the path is allowed to go above the root, restore leading ..s
  if (allowAboveRoot) {
    for (; up--; up) {
      parts.unshift('..');
    }
  }

  return parts;
}

// path.resolve([from ...], to)
// posix version
exports.resolve = function() {
  var resolvedPath = '',
      resolvedAbsolute = false;

  for (var i = arguments.length - 1; i >= -1 && !resolvedAbsolute; i--) {
    var path = (i >= 0) ? arguments[i] : process.cwd();

    // Skip empty and invalid entries
    if (typeof path !== 'string') {
      throw new TypeError('Arguments to path.resolve must be strings');
    } else if (!path) {
      continue;
    }

    resolvedPath = path + '/' + resolvedPath;
    resolvedAbsolute = path.charAt(0) === '/';
  }

  // At this point the path should be resolved to a full absolute path, but
  // handle relative paths to be safe (might happen when process.cwd() fails)

  // Normalize the path
  resolvedPath = normalizeArray(filter(resolvedPath.split('/'), function(p) {
    return !!p;
  }), !resolvedAbsolute).join('/');

  return ((resolvedAbsolute ? '/' : '') + resolvedPath) || '.';
};

// path.normalize(path)
// posix version
exports.normalize = function(path) {
  var isAbsolute = exports.isAbsolute(path),
      trailingSlash = substr(path, -1) === '/';

  // Normalize the path
  path = normalizeArray(filter(path.split('/'), function(p) {
    return !!p;
  }), !isAbsolute).join('/');

  if (!path && !isAbsolute) {
    path = '.';
  }
  if (path && trailingSlash) {
    path += '/';
  }

  return (isAbsolute ? '/' : '') + path;
};

// posix version
exports.isAbsolute = function(path) {
  return path.charAt(0) === '/';
};

// posix version
exports.join = function() {
  var paths = Array.prototype.slice.call(arguments, 0);
  return exports.normalize(filter(paths, function(p, index) {
    if (typeof p !== 'string') {
      throw new TypeError('Arguments to path.join must be strings');
    }
    return p;
  }).join('/'));
};


// path.relative(from, to)
// posix version
exports.relative = function(from, to) {
  from = exports.resolve(from).substr(1);
  to = exports.resolve(to).substr(1);

  function trim(arr) {
    var start = 0;
    for (; start < arr.length; start++) {
      if (arr[start] !== '') break;
    }

    var end = arr.length - 1;
    for (; end >= 0; end--) {
      if (arr[end] !== '') break;
    }

    if (start > end) return [];
    return arr.slice(start, end - start + 1);
  }

  var fromParts = trim(from.split('/'));
  var toParts = trim(to.split('/'));

  var length = Math.min(fromParts.length, toParts.length);
  var samePartsLength = length;
  for (var i = 0; i < length; i++) {
    if (fromParts[i] !== toParts[i]) {
      samePartsLength = i;
      break;
    }
  }

  var outputParts = [];
  for (var i = samePartsLength; i < fromParts.length; i++) {
    outputParts.push('..');
  }

  outputParts = outputParts.concat(toParts.slice(samePartsLength));

  return outputParts.join('/');
};

exports.sep = '/';
exports.delimiter = ':';

exports.dirname = function (path) {
  if (typeof path !== 'string') path = path + '';
  if (path.length === 0) return '.';
  var code = path.charCodeAt(0);
  var hasRoot = code === 47 /*/*/;
  var end = -1;
  var matchedSlash = true;
  for (var i = path.length - 1; i >= 1; --i) {
    code = path.charCodeAt(i);
    if (code === 47 /*/*/) {
        if (!matchedSlash) {
          end = i;
          break;
        }
      } else {
      // We saw the first non-path separator
      matchedSlash = false;
    }
  }

  if (end === -1) return hasRoot ? '/' : '.';
  if (hasRoot && end === 1) {
    // return '//';
    // Backwards-compat fix:
    return '/';
  }
  return path.slice(0, end);
};

function basename(path) {
  if (typeof path !== 'string') path = path + '';

  var start = 0;
  var end = -1;
  var matchedSlash = true;
  var i;

  for (i = path.length - 1; i >= 0; --i) {
    if (path.charCodeAt(i) === 47 /*/*/) {
        // If we reached a path separator that was not part of a set of path
        // separators at the end of the string, stop now
        if (!matchedSlash) {
          start = i + 1;
          break;
        }
      } else if (end === -1) {
      // We saw the first non-path separator, mark this as the end of our
      // path component
      matchedSlash = false;
      end = i + 1;
    }
  }

  if (end === -1) return '';
  return path.slice(start, end);
}

// Uses a mixed approach for backwards-compatibility, as ext behavior changed
// in new Node.js versions, so only basename() above is backported here
exports.basename = function (path, ext) {
  var f = basename(path);
  if (ext && f.substr(-1 * ext.length) === ext) {
    f = f.substr(0, f.length - ext.length);
  }
  return f;
};

exports.extname = function (path) {
  if (typeof path !== 'string') path = path + '';
  var startDot = -1;
  var startPart = 0;
  var end = -1;
  var matchedSlash = true;
  // Track the state of characters (if any) we see before our first dot and
  // after any path separator we find
  var preDotState = 0;
  for (var i = path.length - 1; i >= 0; --i) {
    var code = path.charCodeAt(i);
    if (code === 47 /*/*/) {
        // If we reached a path separator that was not part of a set of path
        // separators at the end of the string, stop now
        if (!matchedSlash) {
          startPart = i + 1;
          break;
        }
        continue;
      }
    if (end === -1) {
      // We saw the first non-path separator, mark this as the end of our
      // extension
      matchedSlash = false;
      end = i + 1;
    }
    if (code === 46 /*.*/) {
        // If this is our first dot, mark it as the start of our extension
        if (startDot === -1)
          startDot = i;
        else if (preDotState !== 1)
          preDotState = 1;
    } else if (startDot !== -1) {
      // We saw a non-dot and non-path separator before our dot, so we should
      // have a good chance at having a non-empty extension
      preDotState = -1;
    }
  }

  if (startDot === -1 || end === -1 ||
      // We saw a non-dot character immediately before the dot
      preDotState === 0 ||
      // The (right-most) trimmed path component is exactly '..'
      preDotState === 1 && startDot === end - 1 && startDot === startPart + 1) {
    return '';
  }
  return path.slice(startDot, end);
};

function filter (xs, f) {
    if (xs.filter) return xs.filter(f);
    var res = [];
    for (var i = 0; i < xs.length; i++) {
        if (f(xs[i], i, xs)) res.push(xs[i]);
    }
    return res;
}

// String.prototype.substr - negative index don't work in IE8
var substr = 'ab'.substr(-1) === 'b'
    ? function (str, start, len) { return str.substr(start, len) }
    : function (str, start, len) {
        if (start < 0) start = str.length + start;
        return str.substr(start, len);
    }
;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var scope = (typeof global !== "undefined" && global) ||
            (typeof self !== "undefined" && self) ||
            window;
var apply = Function.prototype.apply;

// DOM APIs, for completeness

exports.setTimeout = function() {
  return new Timeout(apply.call(setTimeout, scope, arguments), clearTimeout);
};
exports.setInterval = function() {
  return new Timeout(apply.call(setInterval, scope, arguments), clearInterval);
};
exports.clearTimeout =
exports.clearInterval = function(timeout) {
  if (timeout) {
    timeout.close();
  }
};

function Timeout(id, clearFn) {
  this._id = id;
  this._clearFn = clearFn;
}
Timeout.prototype.unref = Timeout.prototype.ref = function() {};
Timeout.prototype.close = function() {
  this._clearFn.call(scope, this._id);
};

// Does not start the time, just sets up the members needed.
exports.enroll = function(item, msecs) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = msecs;
};

exports.unenroll = function(item) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = -1;
};

exports._unrefActive = exports.active = function(item) {
  clearTimeout(item._idleTimeoutId);

  var msecs = item._idleTimeout;
  if (msecs >= 0) {
    item._idleTimeoutId = setTimeout(function onTimeout() {
      if (item._onTimeout)
        item._onTimeout();
    }, msecs);
  }
};

// setimmediate attaches itself to the global object
__webpack_require__(19);
// On some exotic environments, it's not clear which object `setimmediate` was
// able to install onto.  Search each possibility in the same order as the
// `setimmediate` library.
exports.setImmediate = (typeof self !== "undefined" && self.setImmediate) ||
                       (typeof global !== "undefined" && global.setImmediate) ||
                       (this && this.setImmediate);
exports.clearImmediate = (typeof self !== "undefined" && self.clearImmediate) ||
                         (typeof global !== "undefined" && global.clearImmediate) ||
                         (this && this.clearImmediate);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, process) {(function (global, undefined) {
    "use strict";

    if (global.setImmediate) {
        return;
    }

    var nextHandle = 1; // Spec says greater than zero
    var tasksByHandle = {};
    var currentlyRunningATask = false;
    var doc = global.document;
    var registerImmediate;

    function setImmediate(callback) {
      // Callback can either be a function or a string
      if (typeof callback !== "function") {
        callback = new Function("" + callback);
      }
      // Copy function arguments
      var args = new Array(arguments.length - 1);
      for (var i = 0; i < args.length; i++) {
          args[i] = arguments[i + 1];
      }
      // Store and register the task
      var task = { callback: callback, args: args };
      tasksByHandle[nextHandle] = task;
      registerImmediate(nextHandle);
      return nextHandle++;
    }

    function clearImmediate(handle) {
        delete tasksByHandle[handle];
    }

    function run(task) {
        var callback = task.callback;
        var args = task.args;
        switch (args.length) {
        case 0:
            callback();
            break;
        case 1:
            callback(args[0]);
            break;
        case 2:
            callback(args[0], args[1]);
            break;
        case 3:
            callback(args[0], args[1], args[2]);
            break;
        default:
            callback.apply(undefined, args);
            break;
        }
    }

    function runIfPresent(handle) {
        // From the spec: "Wait until any invocations of this algorithm started before this one have completed."
        // So if we're currently running a task, we'll need to delay this invocation.
        if (currentlyRunningATask) {
            // Delay by doing a setTimeout. setImmediate was tried instead, but in Firefox 7 it generated a
            // "too much recursion" error.
            setTimeout(runIfPresent, 0, handle);
        } else {
            var task = tasksByHandle[handle];
            if (task) {
                currentlyRunningATask = true;
                try {
                    run(task);
                } finally {
                    clearImmediate(handle);
                    currentlyRunningATask = false;
                }
            }
        }
    }

    function installNextTickImplementation() {
        registerImmediate = function(handle) {
            process.nextTick(function () { runIfPresent(handle); });
        };
    }

    function canUsePostMessage() {
        // The test against `importScripts` prevents this implementation from being installed inside a web worker,
        // where `global.postMessage` means something completely different and can't be used for this purpose.
        if (global.postMessage && !global.importScripts) {
            var postMessageIsAsynchronous = true;
            var oldOnMessage = global.onmessage;
            global.onmessage = function() {
                postMessageIsAsynchronous = false;
            };
            global.postMessage("", "*");
            global.onmessage = oldOnMessage;
            return postMessageIsAsynchronous;
        }
    }

    function installPostMessageImplementation() {
        // Installs an event handler on `global` for the `message` event: see
        // * https://developer.mozilla.org/en/DOM/window.postMessage
        // * http://www.whatwg.org/specs/web-apps/current-work/multipage/comms.html#crossDocumentMessages

        var messagePrefix = "setImmediate$" + Math.random() + "$";
        var onGlobalMessage = function(event) {
            if (event.source === global &&
                typeof event.data === "string" &&
                event.data.indexOf(messagePrefix) === 0) {
                runIfPresent(+event.data.slice(messagePrefix.length));
            }
        };

        if (global.addEventListener) {
            global.addEventListener("message", onGlobalMessage, false);
        } else {
            global.attachEvent("onmessage", onGlobalMessage);
        }

        registerImmediate = function(handle) {
            global.postMessage(messagePrefix + handle, "*");
        };
    }

    function installMessageChannelImplementation() {
        var channel = new MessageChannel();
        channel.port1.onmessage = function(event) {
            var handle = event.data;
            runIfPresent(handle);
        };

        registerImmediate = function(handle) {
            channel.port2.postMessage(handle);
        };
    }

    function installReadyStateChangeImplementation() {
        var html = doc.documentElement;
        registerImmediate = function(handle) {
            // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
            // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
            var script = doc.createElement("script");
            script.onreadystatechange = function () {
                runIfPresent(handle);
                script.onreadystatechange = null;
                html.removeChild(script);
                script = null;
            };
            html.appendChild(script);
        };
    }

    function installSetTimeoutImplementation() {
        registerImmediate = function(handle) {
            setTimeout(runIfPresent, 0, handle);
        };
    }

    // If supported, we should attach to the prototype of global, since that is where setTimeout et al. live.
    var attachTo = Object.getPrototypeOf && Object.getPrototypeOf(global);
    attachTo = attachTo && attachTo.setTimeout ? attachTo : global;

    // Don't get fooled by e.g. browserify environments.
    if ({}.toString.call(global.process) === "[object process]") {
        // For Node.js before 0.9
        installNextTickImplementation();

    } else if (canUsePostMessage()) {
        // For non-IE10 modern browsers
        installPostMessageImplementation();

    } else if (global.MessageChannel) {
        // For web workers, where supported
        installMessageChannelImplementation();

    } else if (doc && "onreadystatechange" in doc.createElement("script")) {
        // For IE 6–8
        installReadyStateChangeImplementation();

    } else {
        // For older browsers
        installSetTimeoutImplementation();
    }

    attachTo.setImmediate = setImmediate;
    attachTo.clearImmediate = clearImmediate;
}(typeof self === "undefined" ? typeof global === "undefined" ? this : global : self));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4), __webpack_require__(2)))

/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(21)
  __webpack_require__(22)
  __webpack_require__(23)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(24),
  /* template */
  __webpack_require__(46),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 21 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 22 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 23 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 24 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Reader_vue__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Reader_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Reader_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Settings_vue__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Settings_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_Settings_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__event_hub_js__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    pageNum: {
      type: Number,
      default: 0
    },
    ttlPages: {
      type: Number,
      default: 0
    }
  },
  data: function data() {
    return {
      pageNumber: this.pageNum,
      totalPages: this.ttlPages,
      info: false,
      buyBar: true,
      buyMenu: false,
      socialMenu: false,
      otherBooks: false,
      focused: false,
      dialogBuy: false,
      dialogShare: false,
      notifications: false,
      sound: true,
      widgets: false,
      show: false,
      iSize: 50,
      selectBook: "Books",
      home: this.$route.path,
      drawer: false,
      drawerRight: false,
      items: [],
      books: [],
      booksChanged: '',
      socials: [{
        title: "LinkedIn",
        img: "static/img/linkedin-logo.svg",
        url: "https://www.linkedin.com/shareArticle?mini=true&url=https://textcafe.co/books/7Zm0kx/%3F1734266445367&title=Novels%20of%20Stephen%20Birmingham&summary=A%20quartet%20of%20novels%20from%20the%20New%20York%20Times%26ndash%3Bbestselling%20author%20of%20%26ldquo%3BOur%20Crowd%26rdquo%3B%20and%20master%20chronicler%20of%20Manhattan%26rsquo%3Bs%20rich%2C%20famous%2C%20and%20deceitful.%20These%20four%20gripping%20novels%20prove%20that%20%26ldquo%3Bwhen%20it%20c&source=LinkedIn",
        icon: "ion-social-linkedin"
      }, {
        title: "Facebook",
        img: "static/img/facebook-logo.svg",
        url: "https://www.facebook.com/sharer/sharer.php?u=https://textcafe.co/books/7Zm0kx/%3F1734266445367",
        icon: "ion-social-facebook"
      }, {
        title: "Twitter",
        img: "static/img/twitter-logo-silhouette.svg",
        url: "https://twitter.com/intent/tweet?text=A%20quartet%20of%20novels%20from%20the%20New%20York%20Times%26ndash%3Bbestselling%20author%20of%20%26ldquo%3BOur%20Crowd%26rdquo%3B%20and%20master%20chronicler%20of%20Manhat%0Dhttps://textcafe.co/books/7Zm0kx/%3F1734266445367&amp;via=textcafecom",
        icon: "ion-social-twitter"
      }, {
        title: "Tumblr",
        img: "static/img/tumblr-letter-logo.svg",
        url: "https://www.tumblr.com/widgets/share/tool?canonicalUrl=https://textcafe.co/books/7Zm0kx/%3F1734266445367&posttype=link&caption=A%20quartet%20of%20novels%20from%20the%20New%20York%20Times%26ndash%3Bbestselling%20author%20of%20%26ldquo%3BOur%20Crowd%26rdquo%3B%20and%20master%20chronicler%20of%20Manhattan%26rsquo%3Bs%20rich%2C%20famous%2C%20and%20deceitful.%20These%20four%20gripping%20novels%20prove%20that%20%26ldquo%3Bwhen%20it%20c",
        icon: "ion-social-tumblr"
      }, {
        title: "Pinterest",
        img: "static/img/pinterest-logo.svg",
        url: "http://www.pinterest.com/pin/create/button/?url=https://textcafe.co/books/7Zm0kx/%3F1734266445367&description=A%20quartet%20of%20novels%20from%20the%20New%20York%20Times%26ndash%3Bbestselling%20author%20of%20%26ldquo%3BOur%20Crowd%26rdquo%3B%20and%20master%20chronicler%20of%20Manhattan%26rsquo%3Bs%20rich%2C%20famous%2C%20and%20deceitful.%20These%20four%20gripping%20novels%20prove%20that%20%26ldquo%3Bwhen%20it%20c&media=https://textcafe.co/books/7Zm0kx/tc-custom/9781504047999.jpg",
        icon: "ion-social-pinterest"
      }],
      buys: [{
        title: 'Amazon US',
        img: 'https://textcafe.co/domain-icons/Amazon.com_A_Smile.svg',
        url: 'https://www.amazon.com/s?k=9781504047999&i=stripbooks&linkCode=qs&tag=mobilebookcom-20',
        alt: 'None'
      }, {
        title: 'Google Play',
        img: 'https://textcafe.co/global-css/img/Google_Play_symbol.svg',
        url: 'https://play.google.com/store/books/details?id=yGowDwAAQBAJ&amp;rdid=book-yGowDwAAQBAJ&amp;rdot=1&amp;source=gbs_atb&amp;pcampaignid=books_booksearch_atb&gl=us',
        alt: 'None'
      }],
      right: null,
      left: null
    };
  },
  mounted: function mounted() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get('https://www.textcafe.com/widget/get-samples.json?related=9781504047999').then(function (response) {
      return _this.books = response.data.map(function (item) {
        return {
          title: item.title,
          img: item.coverImagePath,
          url: item.socialUrl,
          alt: "This image is the cover for the book " + item.title
        };
      });
    }).catch(function (error) {
      return (
        // handle error
        console.log(error)
      );
    });
  },

  created: function created() {
    var _this2 = this;

    this.$router.options.routes.forEach(function (route) {
      _this2.items.push({
        path: route.path,
        name: route.name,
        component: route.component,
        //image: "static/img/ilG6Mf.jpg"
        image: '/books/7Zm0kx/tc-custom/9781504047999.jpg?1734266445367',
        alt: 'Novels of Stephen Birmingham'
      });
    });
    __WEBPACK_IMPORTED_MODULE_2__event_hub_js__["a" /* default */].$on("pageNum", function (newValue) {
      _this2.pageNum = newValue;
    });
    __WEBPACK_IMPORTED_MODULE_2__event_hub_js__["a" /* default */].$on("ttlPages", function (newValue) {
      _this2.ttlPages = newValue;
    });
  },
  watch: {
    $route: function $route(to, from) {
      if (to.path === "/") {
        this.home = this.$route.path;
      } else {
        this.home = null;
      }
    },

    iSize: function iSize(newValue) {
      __WEBPACK_IMPORTED_MODULE_2__event_hub_js__["a" /* default */].$emit("iSizeChanged", newValue);
    },
    books: function books(newValue) {
      __WEBPACK_IMPORTED_MODULE_2__event_hub_js__["a" /* default */].$emit("booksChanged", Date.now());
    }
  },
  methods: {
    resetScroll: function resetScroll() {
      var page = this.$el.querySelector(".book-page");
      page.scrollLeft = 0;
    },
    onBlur: function onBlur() {
      if (this.show === true) {
        this.show = false;
        this.$emit("blur");
      }
    },
    onFocus: function onFocus() {
      if (this.show === false) {
        this.show = true;
        this.$el.querySelector(".book-page").$emit("focus");
      }
    },
    buyClick: function buyClick(url) {
      //const url = '/foo/bar'
      // this.$ga.query('send', 'event', 'outbound', 'click', url, {
      //     transport: 'beacon',
      //     hitCallback () {
      //        //document.location = url
      //     }
      // })
      this.$ga.event({
        eventCategory: 'purchase',
        eventAction: 'click',
        eventLabel: url
        // eventValue: 123
      });
    },
    shareClick: function shareClick(network) {
      this.$ga.event({
        eventCategory: 'share',
        eventAction: 'click',
        eventLabel: network
        // eventValue: 123
      });
    }
  },
  components: {
    settings: __WEBPACK_IMPORTED_MODULE_1__components_Settings_vue___default.a,
    reader: __WEBPACK_IMPORTED_MODULE_0__components_Reader_vue___default.a
  }
});

/***/ }),
/* 25 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__event_hub_js__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Settings__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Settings___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_Settings__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




var SLIDE_TIME = document.documentElement.clientWidth > 480 ? 500 : 300;

/* harmony default export */ __webpack_exports__["default"] = ({
  name: "reader",
  props: {
    value1: {
      type: Number,
      default: 22
    },
    selected: {
      type: String
    },
    ex8: {
      type: String,
      default: "Auto"
    },
    value2: {
      type: Number
    },
    value3: {
      type: Number,
      default: 100
    }
  },
  data: function data() {
    return {
      pageNum: 0,
      pageNumber: 1,
      ttlPages: 0,
      totalPages: 0,
      home: false,
      div: 0,
      prevX: null,
      xDownEnd: null,
      fontSize: this.value1,
      fontFamily: this.selected,
      columns: this.ex8,
      widthSize: this.value2,
      brightness: this.value3,
      currentColor: "#f3f3f3",
      cols: "2 220px",
      position: { scrollTop: 0, scrollLeft: 0 },
      offset: null,
      height: 0,
      isOver: false,
      routeNames: ["home", "bundle_content", "Book1/xhtml/cover", "Book1/xhtml/title", "Book1/xhtml/dedication", "Book1/xhtml/frontmatter02", "Book1/xhtml/part01", "Book1/xhtml/chapter001", "Book1/xhtml/chapter002", "Book1/xhtml/chapter003", "Book1/xhtml/chapter004", "Book1/xhtml/chapter005", "Book1/xhtml/chapter006", "Book1/xhtml/chapter007", "Book1/xhtml/chapter008", "Book1/xhtml/chapter009", "Book1/xhtml/chapter010", "last"],
      routeTransition: "slide-left",
      rest: true,
      selectedView: "Book1",
      progress: 0,
      hiddenEl: false,
      brandReaderUrl: "",
      brandLogoUrl: "",
      currentUrl: "https://textcafe.co/books/7Zm0kx/",
      waiting: false
    };
  },

  created: function created() {
    var _this = this;

    document.addEventListener("mousewheel", this.onScroll, false);
    window.addEventListener('resize', this.resize);
    this.resize();
    this.getTtlPages();

    if (document.documentElement.offsetWidth >= 768) {
      this.hiddenEl = true;
    } else {
      this.hiddenEl = false;
    }

    this.$router.options.routes.forEach(function (route) {
      _this.routeNames.push(route.name);
    });
    __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$on("fontSizeChanged", function (newValue) {
      _this.fontSize = newValue;
    });
    __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$on("fontFamilyChanged", function (newValue) {
      _this.fontFamily = newValue;
    });
    __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$on("columnsCountChanged", function (newValue) {
      _this.columns = newValue;
      if (_this.columns === "Single") {
        _this.cols = "1 auto";
      } else if (_this.columns === "Auto") {
        _this.cols = "2 220px";
      }
    });
    __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$on("widthChanged", function (newValue) {
      _this.widthSize = newValue;
    });
    __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$on("brightnessChanged", function (newValue) {
      _this.brightness = newValue;
    });
  },

  destroyed: function destroyed() {
    document.removeEventListener("mousewheel", this.onScroll, false);
    document.removeEventListener("resize", this.resize, false);
  },
  updated: function updated() {
    this.getTtlPages();
    this.resize();
    var links = document.getElementsByTagName("a");
    for (var i = 0; i < links.length; i++) {
      var that = this;
      var url = "/" + document.location.hash.split("#/")[1];
      if (links[i].href.split("#")[1] === url) {
        links[i].style.textDecoration = "underline";
        links[i].style.textDecorationStyle = "dotted";
        links[i].onclick = function (e) {
          e.preventDefault();
          var refr = this.href.split("#")[2];
          that.linkTo(refr);
        };
      };
    };
  },
  mounted: function mounted() {
    this.resize();

    var links = document.getElementsByTagName("a");
    for (var i = 0; i < links.length; i++) {
      var that = this;
      var url = "/" + document.location.hash.split("#/")[1];
      if (links[i].href.split("#")[1] === url) {
        links[i].style.textDecoration = "underline";
        links[i].style.textDecorationStyle = "dotted";
        links[i].onclick = function (e) {
          e.preventDefault();
          var refr = this.href.split("#")[2];
          that.linkTo(refr);
        };
      };
    };

    this.getTtlPages();

    var bgColor = document.getElementsByClassName("book-content")[0].style.backgroundColor,
        hexDigits = new Array("0", "1", "2", "3", "4", "5", "6", "7", "8", "9", "a", "b", "c", "d", "e", "f");
    function rgb2hex(rgb) {
      rgb = rgb.match(/^rgb\((\d+),\s*(\d+),\s*(\d+)\)$/);
      return "#" + hex(rgb[1]) + hex(rgb[2]) + hex(rgb[3]);
    }
    function hex(x) {
      return isNaN(x) ? "00" : hexDigits[(x - x % 16) / 16] + hexDigits[x % 16];
    }
    this.currentColor = rgb2hex(bgColor);
  },

  watch: {
    $route: function $route(to, from, next) {
      var toDepth = this.routeNames.indexOf(to.name);
      var fromDepth = this.routeNames.indexOf(from.name);
      this.routeTransition = toDepth < fromDepth ? "slide-right" : "slide-left";

      this.progress = 0;
      this.pageNumber = 1;
    },

    pageNum: function pageNum(newValue) {
      __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$emit("pageNum", newValue);
    },
    ttlPages: function ttlPages(newValue) {
      __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$emit("ttlPages", newValue);
    }
  },
  methods: {
    resize: function resize() {
      this.height = document.documentElement.clientHeight;
    },
    linkTo: function linkTo(refName) {
      var element = document.getElementById(refName);
      var elementOffset = Math.ceil(element.offsetLeft);
      var page = this.$el.querySelector(".book-page");
      var gap = parseInt(window.getComputedStyle(page).getPropertyValue("column-gap"), 10);
      var onStart = Math.ceil(page.scrollLeft);
      var destinationOffset = Math.floor(elementOffset / (page.offsetWidth + gap));
      var target = destinationOffset * (page.offsetWidth + gap) - onStart;
      if (destinationOffset + 1 !== this.pageNumber) {
        this.scrollIt(target, 300, "easeOutQuad", false);
        var scrollArea = page.scrollWidth - page.offsetWidth;
        var pctScrolled = Math.floor(destinationOffset * (page.offsetWidth + gap) / scrollArea * 100);
        this.progress = pctScrolled;
        this.pageNumber = destinationOffset + 1;
      }
    },
    getTtlPages: function getTtlPages() {
      this.$nextTick(function () {
        var page = this.$el.querySelector(".book-page");

        var gap = parseInt(window.getComputedStyle(page).getPropertyValue("column-gap"), 10);

        var scrollArea = page.scrollWidth - page.offsetWidth;
        var ttlPages = Math.round(scrollArea / (page.offsetWidth + gap));
        this.ttlPages = ttlPages;
        this.totalPages = this.ttlPages + 1;
      });
    },
    tapped: function tapped() {
      var el = this.$el.querySelector(".touch-swipe");
      this.hiddenEl = !this.hiddenEl;
    },
    tappedIn: function tappedIn() {
      var el = this.$el.querySelector(".touch-swipe");
      this.hiddenEl = !this.hiddenEl;
    },
    scrollIt: function scrollIt(destination) {
      var duration = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 200;

      var _this2 = this;

      var easing = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "easeInOutQuart";
      var callback = arguments[3];

      var easings = {
        linear: function linear(t) {
          return t;
        },
        easeInQuad: function easeInQuad(t) {
          return t * t;
        },
        easeOutQuad: function easeOutQuad(t) {
          return t * (2 - t);
        },
        easeInOutQuad: function easeInOutQuad(t) {
          return t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t;
        },
        easeInCubic: function easeInCubic(t) {
          return t * t * t;
        },
        easeOutCubic: function easeOutCubic(t) {
          return --t * t * t + 1;
        },
        easeInOutCubic: function easeInOutCubic(t) {
          return t < 0.5 ? 4 * t * t * t : (t - 1) * (2 * t - 2) * (2 * t - 2) + 1;
        },
        easeInQuart: function easeInQuart(t) {
          return t * t * t * t;
        },
        easeOutQuart: function easeOutQuart(t) {
          return 1 - --t * t * t * t;
        },
        easeInOutQuart: function easeInOutQuart(t) {
          return t < 0.5 ? 8 * t * t * t * t : 1 - 8 * --t * t * t * t;
        },
        easeInQuint: function easeInQuint(t) {
          return t * t * t * t * t;
        },
        easeOutQuint: function easeOutQuint(t) {
          return 1 + --t * t * t * t * t;
        },
        easeInOutQuint: function easeInOutQuint(t) {
          return t < 0.5 ? 16 * t * t * t * t * t : 1 + 16 * --t * t * t * t * t;
        }
      };

      var page = this.$el.querySelector(".book-page");
      var gap = parseInt(window.getComputedStyle(page).getPropertyValue("column-gap"), 10),
          offset = page.offsetWidth + gap;

      var start = Math.ceil(page.scrollLeft);

      var startTime = "now" in window.performance ? performance.now() : new Date().getTime();

      var documentWidth = Math.max(page.scrollWidth || page.offsetWidth || page.clientWidth);

      var windowWidth = window.innerWidth || window.clientWidth;

      var destinationOffsetToScroll = start + destination;

      function scroll() {
        var now = "now" in window.performance ? performance.now() : new Date().getTime();
        var time = Math.min(1, (now - startTime) / duration);
        var timeFunction = easings[easing](time);
        page.scroll(Math.ceil(timeFunction * (destinationOffsetToScroll - start) + start), 0);
        if (timeFunction === 1 || start === destinationOffsetToScroll) {
          if (callback) {
            callback();
          }
          return;
        }
        requestAnimationFrame(scroll);
      }
      scroll();
      setTimeout(function () {
        _this2.waiting = false;
      }, 250);
    },


    next: function next(e) {
      var el = this.$el.querySelector(".touch-swipe");
      if (el) el.style.pointerEvents = "auto";
      var book = this.$el.querySelector(".book-content");
      var page = this.$el.querySelector(".book-page"),
          gap = parseInt(window.getComputedStyle(page).getPropertyValue("column-gap"), 10),
          offset = page.offsetWidth + gap,
          index = this.routeNames.indexOf(this.$route.name);

      var scrollArea = page.scrollWidth - page.offsetWidth;
      var windowWidth = window.innerWidth || window.clientWidth;
      var trackLength = scrollArea - (page.offsetWidth + gap);

      // var pageNum = Math.floor(page.scrollLeft / (page.offsetWidth + gap));
      var scrollLeft = Math.ceil(page.scrollLeft);
      var pageNum = Math.floor(scrollLeft / (page.offsetWidth + gap));

      this.pageNum = pageNum;

      pageNum += 1;

      this.pageNumber += 1;

      if (page.scrollWidth - (scrollLeft + page.offsetWidth) !== 0 && pctScrolled !== 100) {
        var currentPage = Math.floor(pageNum * (page.offsetWidth + gap));

        var nextPage = Math.floor(pageNum * (page.offsetWidth + gap));

        var destination = nextPage - scrollLeft;

        this.scrollIt(destination, 300, "easeOutQuad", false);
      } else {
        this.$router.push({ name: this.routeNames[index + 1] });

        this.pageNumber = 1;
        pageNum = 0;
        var pctScrolled = Math.floor(pageNum * (page.offsetWidth + gap) / scrollArea * 100);
        this.progress = pctScrolled;
      }
      var pctScrolled = Math.floor(pageNum * (page.offsetWidth + gap) / scrollArea * 100);
      this.progress = pctScrolled;
    },
    prev: function prev(e) {
      var el = this.$el.querySelector(".touch-swipe");
      if (el) el.style.pointerEvents = "auto";

      var page = this.$el.querySelector(".book-page"),
          gap = parseInt(window.getComputedStyle(page).getPropertyValue("column-gap"), 10),
          offset = page.offsetWidth + gap,
          index = this.routeNames.indexOf(this.$route.name);

      var scrollArea = page.scrollWidth - page.offsetWidth;

      var scrollLeft = Math.ceil(page.scrollLeft);
      var pageNum = Math.round(scrollLeft / (page.offsetWidth + gap));
      var ttlPages = Math.round(scrollArea / (page.offsetWidth + gap));

      this.pageNum = pageNum;

      this.pageNumber -= 1;

      var currentPage = Math.floor(pageNum * (page.offsetWidth + gap));

      if (scrollLeft !== 0 && pageNum !== 0) {
        var pageNum = Math.round(scrollLeft / (page.offsetWidth + gap));
        var pageNumber = Math.floor(scrollLeft / (page.offsetWidth + gap));

        pageNum -= 1;
        var prevPage = Math.floor(pageNum * (page.offsetWidth + gap));

        var destination = -1 * (scrollLeft - prevPage);

        this.scrollIt(destination, 300, "easeOutQuad", false);
      } else {
        this.$router.push({ name: this.routeNames[index - 1] });

        this.pageNumber = 1;

        pageNum = 0;
        var pctScrolled = Math.floor(pageNum * (page.offsetWidth + gap) / scrollArea * 100);
        this.progress = pctScrolled;
      }
      var pctScrolled = Math.floor(pageNum * (page.offsetWidth + gap) / scrollArea * 100);
      this.progress = pctScrolled;
    },
    over: function over() {
      this.isOver = true;
    },
    out: function out() {
      this.isOver = false;
    },
    onScroll: function onScroll(e, position) {
      this.position = position;
      if (this.isOver === true) {
        var page = this.$el.querySelector(".book-page"),
            gap = parseInt(window.getComputedStyle(page).getPropertyValue("column-gap"), 10),
            deltaX = Math.max(-1, Math.min(1, e.wheelDelta || -e.detail)),
            end = page.scrollWidth - (page.scrollLeft + page.offsetWidth),
            offset = page.offsetWidth + gap;

        var scrollArea = page.scrollWidth - page.offsetWidth;
        var pageNum = Math.round(page.scrollLeft / (page.offsetWidth + gap));

        var pctScrolled = Math.floor(pageNum * (page.offsetWidth + gap) / scrollArea * 100);
        this.progress = pctScrolled;

        if (deltaX === 1) {
          if (page.scrollLeft !== 0) {
            if (this.waiting) {
              return;
            }
            this.waiting = true;

            pageNum -= 1;

            this.pageNumber -= 1;
            var prevPage = Math.floor(pageNum * (page.offsetWidth + gap));

            var destination = -1 * (page.scrollLeft - prevPage);

            this.scrollIt(destination, 300, "easeOutQuad", false);

            var pctScrolled = Math.floor(pageNum * (page.offsetWidth + gap) / scrollArea * 100);
            this.progress = pctScrolled;
          }
        } else if (deltaX === -1) {
          if (page.scrollWidth - (page.scrollLeft + page.offsetWidth) !== 0) {
            if (this.waiting) {
              return;
            }
            this.waiting = true;

            pageNum += 1;

            this.pageNumber += 1;
            var nextPage = Math.floor(pageNum * (page.offsetWidth + gap));

            var destination = nextPage - page.scrollLeft;

            this.scrollIt(destination, 300, "easeOutQuad", false);

            var pctScrolled = Math.floor(pageNum * (page.offsetWidth + gap) / scrollArea * 100);
            this.progress = pctScrolled;
          }
        }
      } else {
        return;
      }
    },
    fadeIn: function fadeIn() {
      var page = this.$el.querySelector(".book-page");
      page.style.opacity = 0;
      var last = +new Date();
      var tick = function tick() {
        page.style.opacity = +page.style.opacity + (new Date() - last) / 400;
        last = +new Date();
        if (+page.style.opacity < 1) {
          window.requestAnimationFrame && requestAnimationFrame(tick) || setTimeout(tick, 16);
        }
      };
      tick();
    },

    resetScroll: function resetScroll() {
      var page = this.$el.querySelector(".book-page");
      page.scrollLeft = 0;
    }
  },
  computed: {
    isMobile: function isMobile() {
      var check = false;
      (function (a) {
        if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))) check = true;
      })(navigator.userAgent || navigator.vendor || window.opera);
      return check;
    }
  },
  components: {
    Settings: __WEBPACK_IMPORTED_MODULE_1__components_Settings___default.a
  }
});

/***/ }),
/* 26 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__event_hub_js__ = __webpack_require__(5);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: "settings",
  data: function data() {
    return {
      events: [],
      value1: 22,
      value2: 70,
      value3: 100,
      ex8: "Auto",
      selected: "Old-Cabin",
      fonts: ["Old-Cabin", "Raleway-Bitter", "Ubuntu-Abel", "Droid-Abril", "Garamond-Clicker", "Alice-Playfair", "Judson-Quando"],
      classes: ["white", "black", "sepia"]
    };
  },

  watch: {
    value1: function value1(newValue) {
      __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$emit("fontSizeChanged", newValue);
    },
    selected: function selected(newValue) {
      __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$emit("fontFamilyChanged", newValue);
    },
    ex8: function ex8(newValue) {
      __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$emit("columnsCountChanged", newValue);
    },
    value2: function value2(newValue) {
      __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$emit("widthChanged", newValue);
    },
    value3: function value3(newValue) {
      __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$emit("brightnessChanged", newValue);
    }
  },
  methods: {
    reloadBook: function reloadBook() {
      window.location.reload(true);
    },
    changeClassWhite: function changeClassWhite() {
      var el = document.getElementsByClassName("book-content")[0];
      var el2 = document.getElementsByClassName("nav-btn")[0];
      var el3 = document.getElementsByClassName("nav-btn")[1];
      var el4 = document.getElementsByTagName("footer")[0];
      console.log(document.getElementsByTagName("footer")[0]);
      if (el.classList && el2.classList && el3.classList && el4.classList) {
        el.classList.remove("black");
        el2.classList.remove("black");
        el3.classList.remove("black");
        el4.classList.remove("black");
        el.classList.remove("sepia");
        el2.classList.remove("sepia");
        el3.classList.remove("sepia");
        el4.classList.remove("sepia");
        el.classList.add("white");
        el2.classList.add("white");
        el3.classList.add("white");
        el4.classList.add("white");
      } else {
        el.className += " white";
        el2.className += " white";
        el3.className += " white";
        el4.className += " white";
      }
    },
    changeClassBlack: function changeClassBlack() {
      var el = document.getElementsByClassName("book-content")[0];
      var el2 = document.getElementsByClassName("nav-btn")[0];
      var el3 = document.getElementsByClassName("nav-btn")[1];
      var el4 = document.getElementsByTagName("footer")[0];
      if (el.classList && el2.classList && el3.classList && el4.classList) {
        el.classList.remove("white");
        el2.classList.remove("white");
        el3.classList.remove("white");
        el4.classList.remove("white");
        el.classList.remove("sepia");
        el2.classList.remove("sepia");
        el3.classList.remove("sepia");
        el4.classList.remove("sepia");
        el.classList.add("black");
        el2.classList.add("black");
        el3.classList.add("black");
        el4.classList.add("black");
      } else {
        el.className += " black";
        el2.className += " black";
        el3.className += " black";
        el4.className += " black";
      }
    },
    changeClassSepia: function changeClassSepia() {
      var el = document.getElementsByClassName("book-content")[0];
      var el2 = document.getElementsByClassName("nav-btn")[0];
      var el3 = document.getElementsByClassName("nav-btn")[1];
      var el4 = document.getElementsByTagName("footer")[0];
      if (el.classList && el2.classList && el3.classList && el4.classList) {
        el.classList.remove("black");
        el2.classList.remove("black");
        el3.classList.remove("black");
        el4.classList.remove("black");
        el.classList.remove("white");
        el2.classList.remove("white");
        el3.classList.remove("white");
        el4.classList.remove("white");
        el.classList.add("sepia");
        el2.classList.add("sepia");
        el3.classList.add("sepia");
        el4.classList.add("sepia");
      } else {
        el.className += " sepia";
        el2.className += " sepia";
        el3.className += " sepia";
        el4.className += " sepia";
      }
    }
  }
});

/***/ }),
/* 27 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "settings"
  }, [_c('ul', {
    staticClass: "settings-list"
  }, [_c('li', [_c('span', [_vm._v("Reload book: ")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "id": "reloadBookBtn",
      "ripple": false
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.reloadBook()
      }
    }
  }, [_c('v-icon', [_vm._v("ion-ios-loop-strong")])], 1)], 1), _vm._v(" "), _c('li', [_c('span', [_vm._v("Font:")]), _vm._v(" "), _c('v-select', {
    attrs: {
      "items": _vm.fonts,
      "overflow": "",
      "single-line": "",
      "return-objectauto": "",
      "append-icon": "ion-ios-arrow-down",
      "hide-details": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.drawerRight = true
      }
    },
    model: {
      value: (_vm.selected),
      callback: function($$v) {
        _vm.selected = $$v
      },
      expression: "selected"
    }
  })], 1), _vm._v(" "), _c('li', [_c('span', [_vm._v("Font size:")]), _vm._v(" "), _c('p', {
    staticClass: "bold-font",
    domProps: {
      "innerHTML": _vm._s(_vm.value1 + 'px' || null)
    }
  }), _vm._v(" "), _c('v-slider', {
    attrs: {
      "min": 17,
      "max": 27,
      "step": 1
    },
    model: {
      value: (_vm.value1),
      callback: function($$v) {
        _vm.value1 = $$v
      },
      expression: "value1"
    }
  })], 1), _vm._v(" "), _c('li', {
    staticClass: "columns-setting"
  }, [_c('span', [_vm._v("Page columns:")]), _c('br'), _vm._v(" "), _c('v-radio', {
    attrs: {
      "label": "Auto",
      "value": "Auto",
      "flat": "",
      "ripple": false,
      "prepend-icon": ""
    },
    model: {
      value: (_vm.ex8),
      callback: function($$v) {
        _vm.ex8 = $$v
      },
      expression: "ex8"
    }
  }), _vm._v(" "), _c('v-radio', {
    attrs: {
      "label": "Single",
      "value": "Single",
      "flat": "",
      "ripple": false,
      "prepend-icon": ""
    },
    model: {
      value: (_vm.ex8),
      callback: function($$v) {
        _vm.ex8 = $$v
      },
      expression: "ex8"
    }
  })], 1), _vm._v(" "), _c('li', {
    staticClass: "width-setting"
  }, [_c('span', [_vm._v("Page width:")]), _vm._v(" "), _c('p', {
    staticClass: "bold-font",
    domProps: {
      "innerHTML": _vm._s(_vm.value2 + '%' || null)
    }
  }), _vm._v(" "), _c('v-slider', {
    attrs: {
      "min": 50,
      "max": 90
    },
    model: {
      value: (_vm.value2),
      callback: function($$v) {
        _vm.value2 = $$v
      },
      expression: "value2"
    }
  })], 1), _vm._v(" "), _c('li', [_c('span', [_vm._v("Brightness:")]), _vm._v(" "), _c('p', {
    staticClass: "bold-font",
    domProps: {
      "innerHTML": _vm._s((_vm.value3 - 100) + '%' || null)
    }
  }), _vm._v(" "), _c('v-slider', {
    attrs: {
      "step": 1,
      "min": 0,
      "max": 200
    },
    model: {
      value: (_vm.value3),
      callback: function($$v) {
        _vm.value3 = $$v
      },
      expression: "value3"
    }
  })], 1), _vm._v(" "), _c('li', [_c('span', [_vm._v("Color mode:")]), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('div', {
    attrs: {
      "id": "colors"
    }
  }, [_c('v-btn', {
    attrs: {
      "flat": "",
      "id": "white",
      "ripple": false
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.changeClassWhite()
      }
    }
  }, [_vm._v("\n          White\n        ")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "id": "black",
      "ripple": false
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.changeClassBlack()
      }
    }
  }, [_vm._v("\n          Black\n        ")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "id": "sepia",
      "ripple": false
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.changeClassSepia()
      }
    }
  }, [_vm._v("\n          Sepia\n        ")])], 1)])])])
},staticRenderFns: []}

/***/ }),
/* 28 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrap",
    style: ({
      'filter': 'brightness(' + _vm.brightness + '%)',
      'height': _vm.height - 49 + 'px'
    })
  }, [_c('v-progress-linear', {
    model: {
      value: (_vm.progress),
      callback: function($$v) {
        _vm.progress = $$v
      },
      expression: "progress"
    }
  }), _vm._v(" "), _c('v-btn', {
    directives: [{
      name: "shortkey",
      rawName: "v-shortkey",
      value: (['arrowleft']),
      expression: "['arrowleft']"
    }],
    staticClass: "nav-btn left",
    style: ({
      width: (100 - _vm.widthSize) + '%'
    }),
    attrs: {
      "ripple": false
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.prev($event)
      },
      "shortkey": _vm.prev
    }
  }, [_c('v-icon', {
    style: ({
      'left': (_vm.widthSize / 3.5) + '%'
    })
  }, [_vm._v("ion-ios-arrow-left")])], 1), _vm._v(" "), _c('v-btn', {
    directives: [{
      name: "shortkey",
      rawName: "v-shortkey",
      value: (['arrowright']),
      expression: "['arrowright']"
    }],
    staticClass: "nav-btn right",
    style: ({
      width: (100 - _vm.widthSize) + '%'
    }),
    attrs: {
      "ripple": false
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.next($event)
      },
      "shortkey": _vm.next
    }
  }, [_c('v-icon', {
    style: ({
      'right': (_vm.widthSize / 3.5) + '%'
    })
  }, [_vm._v("ion-ios-arrow-right")])], 1), _vm._v(" "), _c('div', {
    staticClass: "book-content",
    style: ({
      'width': _vm.widthSize + '%',
      'background-color': _vm.currentColor,
      'height': _vm.height - 78 + 'px'
    }),
    on: {
      "mouseenter": _vm.over,
      "mouseleave": _vm.out
    }
  }, [(_vm.isMobile) ? _c('v-touch', {
    staticClass: "touch-swipe",
    class: {
      active: _vm.hiddenEl
    },
    on: {
      "swipeleft": _vm.next,
      "swiperight": _vm.prev,
      "tap": _vm.tapped
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    key: _vm.div,
    staticClass: "book-page",
    class: _vm.fontFamily,
    style: ({
      'font-size': _vm.fontSize + 'px',
      'columns': _vm.cols
    }),
    attrs: {
      "enable-resize-watcher": ""
    },
    on: {
      "tap": _vm.tappedIn,
      "swipe": _vm.tappedIn,
      "click": _vm.tappedIn
    }
  }, [_c('transition', {
    attrs: {
      "name": _vm.routeTransition,
      "mode": "out-in"
    }
  }, [_c('router-view', {
    key: _vm.$route.name,
    staticClass: "view"
  })], 1)], 1)], 1), _vm._v(" "), _c('footer', {
    class: _vm.fontFamily,
    style: ({
      'font-size': (_vm.fontSize - 5) + 'px'
    })
  }, [(_vm.brandReaderUrl) ? _c('div', [_c('v-btn', {
    staticClass: "HC-footer-button",
    attrs: {
      "flat": "",
      "ripple": false,
      "tag": "a",
      "href": _vm.brandReaderUrl,
      "target": "_blank"
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.drawer = false, _vm.info = false, _vm.buyMenu = false, _vm.socialMenu = false, _vm.drawerRight = false, _vm.otherBooks = false
      }
    }
  }, [_c('i', [_c('img', {
    attrs: {
      "src": _vm.brandLogoUrl
    }
  })])])], 1) : _vm._e(), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('div', {
    staticClass: "foots"
  }, [_c('span', [_c('em', [_vm._v(_vm._s(this.$route.name))])]), _vm._v(" - page "), _c('span', [_c('em', [_vm._v(_vm._s(this.pageNumber))])]), _vm._v(" "), (this.totalPages > 1) ? _c('span', [_c('em', [_vm._v(_vm._s("/ " + this.totalPages))])]) : _vm._e()]), _vm._v(" "), _c('v-spacer')], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(30);

/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);
var bind = __webpack_require__(8);
var Axios = __webpack_require__(31);
var mergeConfig = __webpack_require__(14);
var defaults = __webpack_require__(11);

/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 * @return {Axios} A new instance of Axios
 */
function createInstance(defaultConfig) {
  var context = new Axios(defaultConfig);
  var instance = bind(Axios.prototype.request, context);

  // Copy axios.prototype to instance
  utils.extend(instance, Axios.prototype, context);

  // Copy context to instance
  utils.extend(instance, context);

  return instance;
}

// Create the default instance to be exported
var axios = createInstance(defaults);

// Expose Axios class to allow class inheritance
axios.Axios = Axios;

// Factory for creating new instances
axios.create = function create(instanceConfig) {
  return createInstance(mergeConfig(axios.defaults, instanceConfig));
};

// Expose Cancel & CancelToken
axios.Cancel = __webpack_require__(15);
axios.CancelToken = __webpack_require__(44);
axios.isCancel = __webpack_require__(10);

// Expose all/spread
axios.all = function all(promises) {
  return Promise.all(promises);
};
axios.spread = __webpack_require__(45);

module.exports = axios;

// Allow use of default import syntax in TypeScript
module.exports.default = axios;


/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);
var buildURL = __webpack_require__(9);
var InterceptorManager = __webpack_require__(32);
var dispatchRequest = __webpack_require__(33);
var mergeConfig = __webpack_require__(14);

/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 */
function Axios(instanceConfig) {
  this.defaults = instanceConfig;
  this.interceptors = {
    request: new InterceptorManager(),
    response: new InterceptorManager()
  };
}

/**
 * Dispatch a request
 *
 * @param {Object} config The config specific for this request (merged with this.defaults)
 */
Axios.prototype.request = function request(config) {
  /*eslint no-param-reassign:0*/
  // Allow for axios('example/url'[, config]) a la fetch API
  if (typeof config === 'string') {
    config = arguments[1] || {};
    config.url = arguments[0];
  } else {
    config = config || {};
  }

  config = mergeConfig(this.defaults, config);

  // Set config.method
  if (config.method) {
    config.method = config.method.toLowerCase();
  } else if (this.defaults.method) {
    config.method = this.defaults.method.toLowerCase();
  } else {
    config.method = 'get';
  }

  // Hook up interceptors middleware
  var chain = [dispatchRequest, undefined];
  var promise = Promise.resolve(config);

  this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
    chain.unshift(interceptor.fulfilled, interceptor.rejected);
  });

  this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
    chain.push(interceptor.fulfilled, interceptor.rejected);
  });

  while (chain.length) {
    promise = promise.then(chain.shift(), chain.shift());
  }

  return promise;
};

Axios.prototype.getUri = function getUri(config) {
  config = mergeConfig(this.defaults, config);
  return buildURL(config.url, config.params, config.paramsSerializer).replace(/^\?/, '');
};

// Provide aliases for supported request methods
utils.forEach(['delete', 'get', 'head', 'options'], function forEachMethodNoData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, config) {
    return this.request(utils.merge(config || {}, {
      method: method,
      url: url
    }));
  };
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, data, config) {
    return this.request(utils.merge(config || {}, {
      method: method,
      url: url,
      data: data
    }));
  };
});

module.exports = Axios;


/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);

function InterceptorManager() {
  this.handlers = [];
}

/**
 * Add a new interceptor to the stack
 *
 * @param {Function} fulfilled The function to handle `then` for a `Promise`
 * @param {Function} rejected The function to handle `reject` for a `Promise`
 *
 * @return {Number} An ID used to remove interceptor later
 */
InterceptorManager.prototype.use = function use(fulfilled, rejected) {
  this.handlers.push({
    fulfilled: fulfilled,
    rejected: rejected
  });
  return this.handlers.length - 1;
};

/**
 * Remove an interceptor from the stack
 *
 * @param {Number} id The ID that was returned by `use`
 */
InterceptorManager.prototype.eject = function eject(id) {
  if (this.handlers[id]) {
    this.handlers[id] = null;
  }
};

/**
 * Iterate over all the registered interceptors
 *
 * This method is particularly useful for skipping over any
 * interceptors that may have become `null` calling `eject`.
 *
 * @param {Function} fn The function to call for each interceptor
 */
InterceptorManager.prototype.forEach = function forEach(fn) {
  utils.forEach(this.handlers, function forEachHandler(h) {
    if (h !== null) {
      fn(h);
    }
  });
};

module.exports = InterceptorManager;


/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);
var transformData = __webpack_require__(34);
var isCancel = __webpack_require__(10);
var defaults = __webpack_require__(11);

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
function throwIfCancellationRequested(config) {
  if (config.cancelToken) {
    config.cancelToken.throwIfRequested();
  }
}

/**
 * Dispatch a request to the server using the configured adapter.
 *
 * @param {object} config The config that is to be used for the request
 * @returns {Promise} The Promise to be fulfilled
 */
module.exports = function dispatchRequest(config) {
  throwIfCancellationRequested(config);

  // Ensure headers exist
  config.headers = config.headers || {};

  // Transform request data
  config.data = transformData(
    config.data,
    config.headers,
    config.transformRequest
  );

  // Flatten headers
  config.headers = utils.merge(
    config.headers.common || {},
    config.headers[config.method] || {},
    config.headers
  );

  utils.forEach(
    ['delete', 'get', 'head', 'post', 'put', 'patch', 'common'],
    function cleanHeaderConfig(method) {
      delete config.headers[method];
    }
  );

  var adapter = config.adapter || defaults.adapter;

  return adapter(config).then(function onAdapterResolution(response) {
    throwIfCancellationRequested(config);

    // Transform response data
    response.data = transformData(
      response.data,
      response.headers,
      config.transformResponse
    );

    return response;
  }, function onAdapterRejection(reason) {
    if (!isCancel(reason)) {
      throwIfCancellationRequested(config);

      // Transform response data
      if (reason && reason.response) {
        reason.response.data = transformData(
          reason.response.data,
          reason.response.headers,
          config.transformResponse
        );
      }
    }

    return Promise.reject(reason);
  });
};


/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);

/**
 * Transform the data for a request or a response
 *
 * @param {Object|String} data The data to be transformed
 * @param {Array} headers The headers for the request or response
 * @param {Array|Function} fns A single function or Array of functions
 * @returns {*} The resulting transformed data
 */
module.exports = function transformData(data, headers, fns) {
  /*eslint no-param-reassign:0*/
  utils.forEach(fns, function transform(fn) {
    data = fn(data, headers);
  });

  return data;
};


/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);

module.exports = function normalizeHeaderName(headers, normalizedName) {
  utils.forEach(headers, function processHeader(value, name) {
    if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
      headers[normalizedName] = value;
      delete headers[name];
    }
  });
};


/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var createError = __webpack_require__(13);

/**
 * Resolve or reject a Promise based on response status.
 *
 * @param {Function} resolve A function that resolves the promise.
 * @param {Function} reject A function that rejects the promise.
 * @param {object} response The response.
 */
module.exports = function settle(resolve, reject, response) {
  var validateStatus = response.config.validateStatus;
  if (!validateStatus || validateStatus(response.status)) {
    resolve(response);
  } else {
    reject(createError(
      'Request failed with status code ' + response.status,
      response.config,
      null,
      response.request,
      response
    ));
  }
};


/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Update an Error with the specified config, error code, and response.
 *
 * @param {Error} error The error to update.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The error.
 */
module.exports = function enhanceError(error, config, code, request, response) {
  error.config = config;
  if (code) {
    error.code = code;
  }

  error.request = request;
  error.response = response;
  error.isAxiosError = true;

  error.toJSON = function() {
    return {
      // Standard
      message: this.message,
      name: this.name,
      // Microsoft
      description: this.description,
      number: this.number,
      // Mozilla
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      // Axios
      config: this.config,
      code: this.code
    };
  };
  return error;
};


/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var isAbsoluteURL = __webpack_require__(39);
var combineURLs = __webpack_require__(40);

/**
 * Creates a new URL by combining the baseURL with the requestedURL,
 * only when the requestedURL is not already an absolute URL.
 * If the requestURL is absolute, this function returns the requestedURL untouched.
 *
 * @param {string} baseURL The base URL
 * @param {string} requestedURL Absolute or relative URL to combine
 * @returns {string} The combined full path
 */
module.exports = function buildFullPath(baseURL, requestedURL) {
  if (baseURL && !isAbsoluteURL(requestedURL)) {
    return combineURLs(baseURL, requestedURL);
  }
  return requestedURL;
};


/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Determines whether the specified URL is absolute
 *
 * @param {string} url The URL to test
 * @returns {boolean} True if the specified URL is absolute, otherwise false
 */
module.exports = function isAbsoluteURL(url) {
  // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
  // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
  // by any combination of letters, digits, plus, period, or hyphen.
  return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(url);
};


/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Creates a new URL by combining the specified URLs
 *
 * @param {string} baseURL The base URL
 * @param {string} relativeURL The relative URL
 * @returns {string} The combined URL
 */
module.exports = function combineURLs(baseURL, relativeURL) {
  return relativeURL
    ? baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '')
    : baseURL;
};


/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);

// Headers whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
var ignoreDuplicateOf = [
  'age', 'authorization', 'content-length', 'content-type', 'etag',
  'expires', 'from', 'host', 'if-modified-since', 'if-unmodified-since',
  'last-modified', 'location', 'max-forwards', 'proxy-authorization',
  'referer', 'retry-after', 'user-agent'
];

/**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} headers Headers needing to be parsed
 * @returns {Object} Headers parsed into an object
 */
module.exports = function parseHeaders(headers) {
  var parsed = {};
  var key;
  var val;
  var i;

  if (!headers) { return parsed; }

  utils.forEach(headers.split('\n'), function parser(line) {
    i = line.indexOf(':');
    key = utils.trim(line.substr(0, i)).toLowerCase();
    val = utils.trim(line.substr(i + 1));

    if (key) {
      if (parsed[key] && ignoreDuplicateOf.indexOf(key) >= 0) {
        return;
      }
      if (key === 'set-cookie') {
        parsed[key] = (parsed[key] ? parsed[key] : []).concat([val]);
      } else {
        parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
      }
    }
  });

  return parsed;
};


/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs have full support of the APIs needed to test
  // whether the request URL is of the same origin as current location.
    (function standardBrowserEnv() {
      var msie = /(msie|trident)/i.test(navigator.userAgent);
      var urlParsingNode = document.createElement('a');
      var originURL;

      /**
    * Parse a URL to discover it's components
    *
    * @param {String} url The URL to be parsed
    * @returns {Object}
    */
      function resolveURL(url) {
        var href = url;

        if (msie) {
        // IE needs attribute set twice to normalize properties
          urlParsingNode.setAttribute('href', href);
          href = urlParsingNode.href;
        }

        urlParsingNode.setAttribute('href', href);

        // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
        return {
          href: urlParsingNode.href,
          protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
          host: urlParsingNode.host,
          search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
          hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
          hostname: urlParsingNode.hostname,
          port: urlParsingNode.port,
          pathname: (urlParsingNode.pathname.charAt(0) === '/') ?
            urlParsingNode.pathname :
            '/' + urlParsingNode.pathname
        };
      }

      originURL = resolveURL(window.location.href);

      /**
    * Determine if a URL shares the same origin as the current location
    *
    * @param {String} requestURL The URL to test
    * @returns {boolean} True if URL shares the same origin, otherwise false
    */
      return function isURLSameOrigin(requestURL) {
        var parsed = (utils.isString(requestURL)) ? resolveURL(requestURL) : requestURL;
        return (parsed.protocol === originURL.protocol &&
            parsed.host === originURL.host);
      };
    })() :

  // Non standard browser envs (web workers, react-native) lack needed support.
    (function nonStandardBrowserEnv() {
      return function isURLSameOrigin() {
        return true;
      };
    })()
);


/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs support document.cookie
    (function standardBrowserEnv() {
      return {
        write: function write(name, value, expires, path, domain, secure) {
          var cookie = [];
          cookie.push(name + '=' + encodeURIComponent(value));

          if (utils.isNumber(expires)) {
            cookie.push('expires=' + new Date(expires).toGMTString());
          }

          if (utils.isString(path)) {
            cookie.push('path=' + path);
          }

          if (utils.isString(domain)) {
            cookie.push('domain=' + domain);
          }

          if (secure === true) {
            cookie.push('secure');
          }

          document.cookie = cookie.join('; ');
        },

        read: function read(name) {
          var match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
          return (match ? decodeURIComponent(match[3]) : null);
        },

        remove: function remove(name) {
          this.write(name, '', Date.now() - 86400000);
        }
      };
    })() :

  // Non standard browser env (web workers, react-native) lack needed support.
    (function nonStandardBrowserEnv() {
      return {
        write: function write() {},
        read: function read() { return null; },
        remove: function remove() {}
      };
    })()
);


/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Cancel = __webpack_require__(15);

/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @class
 * @param {Function} executor The executor function.
 */
function CancelToken(executor) {
  if (typeof executor !== 'function') {
    throw new TypeError('executor must be a function.');
  }

  var resolvePromise;
  this.promise = new Promise(function promiseExecutor(resolve) {
    resolvePromise = resolve;
  });

  var token = this;
  executor(function cancel(message) {
    if (token.reason) {
      // Cancellation has already been requested
      return;
    }

    token.reason = new Cancel(message);
    resolvePromise(token.reason);
  });
}

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
CancelToken.prototype.throwIfRequested = function throwIfRequested() {
  if (this.reason) {
    throw this.reason;
  }
};

/**
 * Returns an object that contains a new `CancelToken` and a function that, when called,
 * cancels the `CancelToken`.
 */
CancelToken.source = function source() {
  var cancel;
  var token = new CancelToken(function executor(c) {
    cancel = c;
  });
  return {
    token: token,
    cancel: cancel
  };
};

module.exports = CancelToken;


/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Syntactic sugar for invoking a function and expanding an array for arguments.
 *
 * Common use case would be to use `Function.prototype.apply`.
 *
 *  ```js
 *  function f(x, y, z) {}
 *  var args = [1, 2, 3];
 *  f.apply(null, args);
 *  ```
 *
 * With `spread` this example can be re-written.
 *
 *  ```js
 *  spread(function(x, y, z) {})([1, 2, 3]);
 *  ```
 *
 * @param {Function} callback
 * @returns {Function}
 */
module.exports = function spread(callback) {
  return function wrap(arr) {
    return callback.apply(null, arr);
  };
};


/***/ }),
/* 46 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-app', {
    attrs: {
      "toolbar": ""
    }
  }, [_c('v-dialog', {
    attrs: {
      "fullscreen": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.info = !_vm.info
      }
    },
    model: {
      value: (_vm.info),
      callback: function($$v) {
        _vm.info = $$v
      },
      expression: "info"
    }
  }, [_c('v-card', {
    staticClass: "infoDialog"
  }, [_c('div', {
    staticClass: "menuIns"
  }, [_c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-navicon")]), _vm._v(" "), _c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-ios-browsers-outline")])], 1), _vm._v(" "), _c('div', {
    staticClass: "menuInsTip"
  }, [_c('br'), _vm._v(" "), _c('strong', [_vm._v("Contents")]), _c('br'), _vm._v(" "), _c('small', [_vm._v("Navigate to book chapters")])]), _vm._v(" "), _c('div', {
    staticClass: "menuInsTip2"
  }, [_c('br'), _vm._v(" "), _c('strong', [_vm._v("Related Books")]), _c('br'), _vm._v(" "), _c('small', [_vm._v("Other books you might like")])]), _vm._v(" "), _c('div', {
    staticClass: "socMenu"
  }, [_c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-social-linkedin")]), _vm._v(" "), _c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-social-facebook")]), _vm._v(" "), _c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-social-twitter")]), _vm._v(" "), _c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-social-tumblr")]), _vm._v(" "), _c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-social-pinterest")])], 1), _vm._v(" "), _c('div', {
    staticClass: "socMenuMob"
  }, [_c('v-icon', [_vm._v("ion-android-share-alt")])], 1), _vm._v(" "), _c('div', {
    staticClass: "socMenuTip"
  }, [_c('br'), _vm._v(" "), _c('strong', [_vm._v("Share Book")]), _c('br'), _vm._v(" "), _c('small', [_vm._v("Share book to your social network")])]), _vm._v(" "), _c('div', {
    staticClass: "resize-settings"
  }, [_c('v-icon', [_vm._v("ion-ios-gear-outline")])], 1), _vm._v(" "), _c('div', {
    staticClass: "resize-settings-tip"
  }, [_c('br'), _vm._v(" "), _c('strong', [_vm._v("Settings button")]), _c('br'), _vm._v(" "), _c('small', [_vm._v("Change colors and fonts")])]), _vm._v(" "), _c('div', {
    staticClass: "left-button"
  }, [_c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-ios-arrow-left")])], 1), _vm._v(" "), _c('div', {
    staticClass: "left-button-tip"
  }, [_c('br'), _vm._v(" "), _c('strong', [_vm._v("Left/Previous")]), _c('br'), _vm._v(" "), _c('small', [_vm._v("Go to previous page or chapter in book view."), _c('br'), _vm._v("On touch screen swipe right.")])]), _vm._v(" "), _c('div', {
    staticClass: "right-button"
  }, [_c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-ios-arrow-right")])], 1), _vm._v(" "), _c('div', {
    staticClass: "right-button-tip"
  }, [_c('br'), _vm._v(" "), _c('strong', [_vm._v("Right/Next")]), _c('br'), _vm._v(" "), _c('small', [_vm._v("Go to next page or chapter in book view."), _c('br'), _vm._v("On touch screen swipe left.")])]), _vm._v(" "), _c('div', {
    staticClass: "buy-buttons"
  }, [_c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-bag")])], 1), _vm._v(" "), _c('div', {
    staticClass: "buy-buttons-mob"
  }, [_c('v-icon', [_vm._v("ion-bag")])], 1), _vm._v(" "), _c('div', {
    staticClass: "buy-buttons-tip"
  }, [_c('br'), _vm._v(" "), _c('strong', [_vm._v("Buy Book")]), _c('br'), _vm._v(" "), _c('small', [_vm._v("Click to stores where you can buy this book")])]), _vm._v(" "), _c('div', {
    staticClass: "headline"
  }, [_vm._v("Instructions")]), _vm._v(" "), _c('v-btn', {
    staticClass: "closeDialog",
    attrs: {
      "flat": "",
      "ripple": false
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.info = false
      }
    }
  }, [_vm._v("Close")])], 1)], 1), _vm._v(" "), _c('v-navigation-drawer', {
    staticClass: "menu",
    attrs: {
      "temporary": "",
      "hide-overlay": "",
      "clipped": "",
      "enable-resize-watcher": "",
      "disable-route-watcher": "",
      "touchless": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.drawer = !_vm.drawer
      }
    },
    model: {
      value: (_vm.drawer),
      callback: function($$v) {
        _vm.drawer = $$v
      },
      expression: "drawer"
    }
  }, [_c('v-list', _vm._l((_vm.items), function(item) {
    return _c('v-list-tile', {
      key: item.name,
      attrs: {
        "href": item.path,
        "to": item.path,
        "exact": "",
        "ripple": false,
        "width": "100%"
      }
    }, [_c('v-list-tile-action', [_c('img', {
      attrs: {
        "height": "55px",
        "alt": item.alt,
        "src": item.image
      }
    })]), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', {
      attrs: {
        "active": ""
      }
    }, [_vm._v(_vm._s(item.name))])], 1)], 1)
  }), 1)], 1), _vm._v(" "), _c('v-navigation-drawer', {
    staticClass: "otherBooks",
    attrs: {
      "temporary": "",
      "hide-overlay": "",
      "clipped": "",
      "enable-resize-watcher": "",
      "disable-route-watcher": "",
      "touchless": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.otherBooks = !_vm.otherBooks
      }
    },
    model: {
      value: (_vm.otherBooks),
      callback: function($$v) {
        _vm.otherBooks = $$v
      },
      expression: "otherBooks"
    }
  }, [_c('v-list', [_c('h6', [_vm._v("Other books you might like:")]), _vm._v(" "), _vm._l((_vm.books), function(book) {
    return _c('v-list-tile', {
      key: book.title,
      attrs: {
        "href": book.url,
        "target": "_blank",
        "ripple": false,
        "width": "100%"
      }
    }, [_c('v-list-tile-action', [_c('img', {
      attrs: {
        "alt": book.alt,
        "src": book.img
      }
    })]), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', {
      attrs: {
        "active": ""
      }
    }, [_vm._v(_vm._s(book.title))])], 1)], 1)
  })], 2)], 1), _vm._v(" "), _c('v-navigation-drawer', {
    staticClass: "settings-drawer",
    attrs: {
      "temporary": "",
      "hide-overlay": "",
      "clipped": "",
      "right": "",
      "enable-resize-watcher": "",
      "touchless": ""
    },
    model: {
      value: (_vm.drawerRight),
      callback: function($$v) {
        _vm.drawerRight = $$v
      },
      expression: "drawerRight"
    }
  }, [_c('v-list', [_c('settings')], 1)], 1), _vm._v(" "), _c('v-navigation-drawer', {
    staticClass: "mini-bar",
    attrs: {
      "mini-variant": "",
      "enable-resize-watcher": "",
      "touchless": ""
    },
    model: {
      value: (_vm.buyBar),
      callback: function($$v) {
        _vm.buyBar = $$v
      },
      expression: "buyBar"
    }
  }, [_c('v-list', {
    attrs: {
      "ripple": false
    }
  }, [_vm._v("Shop:\n      "), _vm._l((_vm.buys), function(buy) {
    return _c('v-list-tile', {
      key: buy.title,
      attrs: {
        "href": buy.url,
        "target": "_blank"
      },
      on: {
        "click": function($event) {
          return _vm.buyClick(buy.url)
        }
      }
    }, [_c('img', {
      attrs: {
        "alt": buy.alt,
        "src": buy.img
      }
    })])
  })], 2)], 1), _vm._v(" "), _c('v-toolbar', {
    staticClass: "main-menu",
    attrs: {
      "fixed": "",
      "persistent": ""
    }
  }, [_c('v-btn', {
    staticClass: "main-menu-button",
    attrs: {
      "flat": "",
      "ripple": false
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.drawer = !_vm.drawer, _vm.info = false, _vm.buyMenu = false, _vm.socialMenu = false, _vm.drawerRight = false, _vm.otherBooks = false
      }
    }
  }, [_c('v-icon', [_vm._v("ion-navicon")])], 1), _vm._v(" "), (_vm.books.length > 0) ? _c('v-btn', {
    key: _vm.booksChanged,
    staticClass: "otherBooks-button",
    attrs: {
      "flat": "",
      "ripple": false
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.otherBooks = !_vm.otherBooks, _vm.info = false, _vm.buyMenu = false, _vm.socialMenu = false, _vm.drawerRight = false, _vm.drawer = false
      }
    }
  }, [_c('v-icon', [_vm._v("ion-ios-browsers-outline")])], 1) : _vm._e(), _vm._v(" "), _c('v-toolbar', {
    staticClass: "desktop-social-btn",
    staticStyle: {
      "margin-left": "5%"
    }
  }, _vm._l((_vm.socials), function(social) {
    return _c('v-btn', {
      key: social.title,
      attrs: {
        "flat": "",
        "href": social.url,
        "target": "_blank",
        "ripple": false
      },
      on: {
        "click": function($event) {
          return _vm.shareClick(social.title)
        }
      }
    }, [_c('v-icon', [_vm._v(_vm._s(social.icon))])], 1)
  }), 1), _vm._v(" "), _c('v-btn', {
    staticClass: "mobile-buy-btn",
    attrs: {
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.buyMenu = !_vm.buyMenu, _vm.info = false, _vm.drawer = false, _vm.socialMenu = false, _vm.drawerRight = false, _vm.otherBooks = false
      }
    }
  }, [_c('v-icon', [_vm._v("ion-bag")])], 1), _vm._v(" "), _c('v-navigation-drawer', {
    staticClass: "buy-menu",
    attrs: {
      "width": "100vw",
      "height": "auto",
      "hide-overlay": "",
      "temporary": "",
      "clipped": "",
      "disable-route-watcher": "",
      "touchless": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.buyMenu = !_vm.buyMenu
      }
    },
    model: {
      value: (_vm.buyMenu),
      callback: function($$v) {
        _vm.buyMenu = $$v
      },
      expression: "buyMenu"
    }
  }, [_c('v-list', [_c('span', [_vm._v("Purchase this book: ")]), _vm._v(" "), _vm._l((_vm.buys), function(buy) {
    return _c('v-list-tile', {
      key: buy.title,
      attrs: {
        "href": buy.url,
        "target": "_blank"
      },
      on: {
        "click": function($event) {
          return _vm.buyClick(buy.url)
        }
      }
    }, [_c('v-list-tile-action', [_c('img', {
      attrs: {
        "alt": buy.alt,
        "src": buy.img
      }
    })]), _vm._v(" "), _c('v-list-tile-title', {
      domProps: {
        "innerHTML": _vm._s(buy.title)
      }
    })], 1)
  })], 2)], 1), _vm._v(" "), _c('v-btn', {
    staticClass: "mobile-social-btn",
    attrs: {
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.socialMenu = !_vm.socialMenu, _vm.info = false, _vm.buyMenu = false, _vm.drawer = false, _vm.drawerRight = false, _vm.otherBooks = false
      }
    }
  }, [_c('v-icon', [_vm._v("ion-android-share-alt")])], 1), _vm._v(" "), _c('v-navigation-drawer', {
    staticClass: "social-menu",
    attrs: {
      "width": "100vw",
      "height": "auto",
      "hide-overlay": "",
      "temporary": "",
      "clipped": "",
      "disable-route-watcher": "",
      "persistent": "",
      "touchless": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.socialMenu = !_vm.socialMenu
      }
    },
    model: {
      value: (_vm.socialMenu),
      callback: function($$v) {
        _vm.socialMenu = $$v
      },
      expression: "socialMenu"
    }
  }, [_c('v-list', [_c('span', [_vm._v("Share this book: ")]), _vm._v(" "), _vm._l((_vm.socials), function(social) {
    return _c('v-list-tile', {
      key: social.title,
      attrs: {
        "href": social.url,
        "target": "_blank"
      },
      on: {
        "click": function($event) {
          return _vm.shareClick(social.title)
        }
      }
    }, [_c('v-list-tile-action', [_c('v-icon', [_vm._v(_vm._s(social.icon))])], 1), _vm._v(" "), _c('v-list-tile-title', {
      domProps: {
        "innerHTML": _vm._s(social.title)
      }
    })], 1)
  })], 2)], 1), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "info-btn",
    attrs: {
      "flat": "",
      "ripple": false
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.info = !_vm.info, _vm.drawer = false, _vm.buyMenu = false, _vm.socialMenu = false, _vm.drawerRight = false
      }
    }
  }, [_c('v-icon', [_vm._v("ion-ios-information-outline")])], 1), _vm._v(" "), _c('v-btn', {
    staticClass: "settings-button",
    attrs: {
      "flat": "",
      "ripple": false
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.drawerRight = !_vm.drawerRight, _vm.info = false, _vm.buyMenu = false, _vm.socialMenu = false, _vm.drawer = false, _vm.otherBooks = false
      }
    }
  }, [_c('v-icon', [_vm._v("ion-ios-gear-outline")])], 1)], 1), _vm._v(" "), _c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('reader')], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 47 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Reader__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Reader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_Reader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_home__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_home___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_home__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_bundle_cover__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_bundle_cover___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_bundle_cover__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Book1_Backed_birdsfront_1__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Book1_Backed_birdsfront_1___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_Book1_Backed_birdsfront_1__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Book1_xhtml_frontmatter01__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Book1_xhtml_frontmatter01___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_Book1_xhtml_frontmatter01__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_love_1__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_love_1___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_love_1__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_bundle_title__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_bundle_title___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_bundle_title__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_bundle_content__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_bundle_content___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_bundle_content__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_Book1_xhtml_cover__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_Book1_xhtml_cover___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__components_Book1_xhtml_cover__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_Book1_xhtml_title__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_Book1_xhtml_title___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__components_Book1_xhtml_title__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_Book1_xhtml_dedication__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_Book1_xhtml_dedication___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__components_Book1_xhtml_dedication__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_Book1_xhtml_frontmatter02__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_Book1_xhtml_frontmatter02___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__components_Book1_xhtml_frontmatter02__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_Book1_xhtml_part01__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_Book1_xhtml_part01___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__components_Book1_xhtml_part01__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_Book1_xhtml_chapter001__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_Book1_xhtml_chapter001___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__components_Book1_xhtml_chapter001__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_Book1_xhtml_chapter002__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_Book1_xhtml_chapter002___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__components_Book1_xhtml_chapter002__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_Book1_xhtml_chapter003__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_Book1_xhtml_chapter003___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__components_Book1_xhtml_chapter003__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_Book1_xhtml_chapter004__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_Book1_xhtml_chapter004___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__components_Book1_xhtml_chapter004__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_Book1_xhtml_chapter005__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_Book1_xhtml_chapter005___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__components_Book1_xhtml_chapter005__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_Book1_xhtml_chapter006__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_Book1_xhtml_chapter006___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__components_Book1_xhtml_chapter006__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__components_Book1_xhtml_chapter007__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__components_Book1_xhtml_chapter007___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21__components_Book1_xhtml_chapter007__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__components_Book1_xhtml_chapter008__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__components_Book1_xhtml_chapter008___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22__components_Book1_xhtml_chapter008__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__components_Book1_xhtml_chapter009__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__components_Book1_xhtml_chapter009___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23__components_Book1_xhtml_chapter009__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__components_Book1_xhtml_chapter010__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__components_Book1_xhtml_chapter010___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24__components_Book1_xhtml_chapter010__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__components_Book1_xhtml_chapter011__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__components_Book1_xhtml_chapter011___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25__components_Book1_xhtml_chapter011__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__components_Book1_xhtml_chapter012__ = __webpack_require__(118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__components_Book1_xhtml_chapter012___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26__components_Book1_xhtml_chapter012__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__components_Book1_xhtml_chapter013__ = __webpack_require__(121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__components_Book1_xhtml_chapter013___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_27__components_Book1_xhtml_chapter013__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__components_Book1_xhtml_part02__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__components_Book1_xhtml_part02___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_28__components_Book1_xhtml_part02__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__components_Book1_xhtml_chapter014__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__components_Book1_xhtml_chapter014___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_29__components_Book1_xhtml_chapter014__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__components_Book1_xhtml_chapter015__ = __webpack_require__(130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__components_Book1_xhtml_chapter015___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_30__components_Book1_xhtml_chapter015__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__components_Book1_xhtml_chapter016__ = __webpack_require__(133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__components_Book1_xhtml_chapter016___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_31__components_Book1_xhtml_chapter016__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__components_Book1_xhtml_chapter017__ = __webpack_require__(136);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__components_Book1_xhtml_chapter017___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_32__components_Book1_xhtml_chapter017__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__components_Book1_xhtml_chapter018__ = __webpack_require__(139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__components_Book1_xhtml_chapter018___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_33__components_Book1_xhtml_chapter018__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__components_Book1_xhtml_chapter019__ = __webpack_require__(142);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__components_Book1_xhtml_chapter019___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_34__components_Book1_xhtml_chapter019__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__components_Book1_xhtml_chapter020__ = __webpack_require__(145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__components_Book1_xhtml_chapter020___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_35__components_Book1_xhtml_chapter020__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__components_Book1_xhtml_chapter021__ = __webpack_require__(148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__components_Book1_xhtml_chapter021___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_36__components_Book1_xhtml_chapter021__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__components_Book1_xhtml_chapter022__ = __webpack_require__(151);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__components_Book1_xhtml_chapter022___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_37__components_Book1_xhtml_chapter022__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__components_Book1_xhtml_chapter023__ = __webpack_require__(154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__components_Book1_xhtml_chapter023___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_38__components_Book1_xhtml_chapter023__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__components_Book1_xhtml_chapter024__ = __webpack_require__(157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__components_Book1_xhtml_chapter024___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_39__components_Book1_xhtml_chapter024__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__components_Book1_xhtml_chapter025__ = __webpack_require__(160);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__components_Book1_xhtml_chapter025___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_40__components_Book1_xhtml_chapter025__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__components_Book1_xhtml_chapter026__ = __webpack_require__(163);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__components_Book1_xhtml_chapter026___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_41__components_Book1_xhtml_chapter026__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__components_Book1_xhtml_part03__ = __webpack_require__(166);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__components_Book1_xhtml_part03___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_42__components_Book1_xhtml_part03__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43__components_Book1_xhtml_chapter027__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43__components_Book1_xhtml_chapter027___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_43__components_Book1_xhtml_chapter027__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44__components_Book1_xhtml_chapter028__ = __webpack_require__(172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44__components_Book1_xhtml_chapter028___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_44__components_Book1_xhtml_chapter028__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45__components_Book1_xhtml_chapter029__ = __webpack_require__(175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45__components_Book1_xhtml_chapter029___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_45__components_Book1_xhtml_chapter029__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46__components_Book1_xhtml_chapter030__ = __webpack_require__(178);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46__components_Book1_xhtml_chapter030___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_46__components_Book1_xhtml_chapter030__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_47__components_Book1_xhtml_chapter031__ = __webpack_require__(181);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_47__components_Book1_xhtml_chapter031___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_47__components_Book1_xhtml_chapter031__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_48__components_Book1_xhtml_part04__ = __webpack_require__(184);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_48__components_Book1_xhtml_part04___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_48__components_Book1_xhtml_part04__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_49__components_Book1_xhtml_chapter032__ = __webpack_require__(187);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_49__components_Book1_xhtml_chapter032___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_49__components_Book1_xhtml_chapter032__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_50__components_Book1_xhtml_chapter033__ = __webpack_require__(190);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_50__components_Book1_xhtml_chapter033___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_50__components_Book1_xhtml_chapter033__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_51__components_Book1_xhtml_chapter034__ = __webpack_require__(193);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_51__components_Book1_xhtml_chapter034___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_51__components_Book1_xhtml_chapter034__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_52__components_Book1_xhtml_endmatter01__ = __webpack_require__(196);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_52__components_Book1_xhtml_endmatter01___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_52__components_Book1_xhtml_endmatter01__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_53__components_Book1_xhtml_endmatter02__ = __webpack_require__(199);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_53__components_Book1_xhtml_endmatter02___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_53__components_Book1_xhtml_endmatter02__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_54__components_Book2_xhtml_cover__ = __webpack_require__(202);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_54__components_Book2_xhtml_cover___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_54__components_Book2_xhtml_cover__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_55__components_Book2_xhtml_title__ = __webpack_require__(205);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_55__components_Book2_xhtml_title___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_55__components_Book2_xhtml_title__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_56__components_Book2_xhtml_dedication__ = __webpack_require__(208);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_56__components_Book2_xhtml_dedication___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_56__components_Book2_xhtml_dedication__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_57__components_Book2_xhtml_part01__ = __webpack_require__(211);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_57__components_Book2_xhtml_part01___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_57__components_Book2_xhtml_part01__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_58__components_Book2_xhtml_chapter001__ = __webpack_require__(214);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_58__components_Book2_xhtml_chapter001___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_58__components_Book2_xhtml_chapter001__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_59__components_Book2_xhtml_chapter002__ = __webpack_require__(217);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_59__components_Book2_xhtml_chapter002___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_59__components_Book2_xhtml_chapter002__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_60__components_Book2_xhtml_chapter003__ = __webpack_require__(220);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_60__components_Book2_xhtml_chapter003___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_60__components_Book2_xhtml_chapter003__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_61__components_Book2_xhtml_chapter004__ = __webpack_require__(223);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_61__components_Book2_xhtml_chapter004___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_61__components_Book2_xhtml_chapter004__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_62__components_Book2_xhtml_chapter005__ = __webpack_require__(226);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_62__components_Book2_xhtml_chapter005___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_62__components_Book2_xhtml_chapter005__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_63__components_Book2_xhtml_chapter006__ = __webpack_require__(229);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_63__components_Book2_xhtml_chapter006___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_63__components_Book2_xhtml_chapter006__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_64__components_Book2_xhtml_chapter007__ = __webpack_require__(232);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_64__components_Book2_xhtml_chapter007___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_64__components_Book2_xhtml_chapter007__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_65__components_Book2_xhtml_chapter008__ = __webpack_require__(235);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_65__components_Book2_xhtml_chapter008___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_65__components_Book2_xhtml_chapter008__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_66__components_Book2_xhtml_chapter009__ = __webpack_require__(238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_66__components_Book2_xhtml_chapter009___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_66__components_Book2_xhtml_chapter009__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_67__components_Book2_xhtml_chapter010__ = __webpack_require__(241);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_67__components_Book2_xhtml_chapter010___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_67__components_Book2_xhtml_chapter010__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_68__components_Book2_xhtml_chapter011__ = __webpack_require__(244);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_68__components_Book2_xhtml_chapter011___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_68__components_Book2_xhtml_chapter011__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_69__components_Book2_xhtml_chapter012__ = __webpack_require__(247);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_69__components_Book2_xhtml_chapter012___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_69__components_Book2_xhtml_chapter012__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_70__components_Book2_xhtml_part02__ = __webpack_require__(250);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_70__components_Book2_xhtml_part02___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_70__components_Book2_xhtml_part02__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_71__components_Book2_xhtml_chapter013__ = __webpack_require__(253);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_71__components_Book2_xhtml_chapter013___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_71__components_Book2_xhtml_chapter013__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_72__components_Book2_xhtml_chapter014__ = __webpack_require__(256);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_72__components_Book2_xhtml_chapter014___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_72__components_Book2_xhtml_chapter014__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_73__components_Book2_xhtml_chapter015__ = __webpack_require__(259);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_73__components_Book2_xhtml_chapter015___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_73__components_Book2_xhtml_chapter015__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_74__components_Book2_xhtml_chapter016__ = __webpack_require__(262);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_74__components_Book2_xhtml_chapter016___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_74__components_Book2_xhtml_chapter016__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_75__components_Book2_xhtml_chapter017__ = __webpack_require__(265);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_75__components_Book2_xhtml_chapter017___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_75__components_Book2_xhtml_chapter017__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_76__components_Book2_xhtml_chapter018__ = __webpack_require__(268);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_76__components_Book2_xhtml_chapter018___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_76__components_Book2_xhtml_chapter018__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_77__components_Book2_xhtml_chapter019__ = __webpack_require__(271);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_77__components_Book2_xhtml_chapter019___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_77__components_Book2_xhtml_chapter019__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_78__components_Book2_xhtml_chapter020__ = __webpack_require__(274);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_78__components_Book2_xhtml_chapter020___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_78__components_Book2_xhtml_chapter020__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_79__components_Book2_xhtml_part03__ = __webpack_require__(277);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_79__components_Book2_xhtml_part03___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_79__components_Book2_xhtml_part03__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_80__components_Book2_xhtml_chapter021__ = __webpack_require__(280);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_80__components_Book2_xhtml_chapter021___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_80__components_Book2_xhtml_chapter021__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_81__components_Book2_xhtml_chapter022__ = __webpack_require__(283);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_81__components_Book2_xhtml_chapter022___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_81__components_Book2_xhtml_chapter022__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_82__components_Book3_xhtml_cover__ = __webpack_require__(286);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_82__components_Book3_xhtml_cover___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_82__components_Book3_xhtml_cover__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_83__components_Book3_xhtml_title__ = __webpack_require__(289);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_83__components_Book3_xhtml_title___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_83__components_Book3_xhtml_title__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_84__components_Book3_xhtml_dedication__ = __webpack_require__(292);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_84__components_Book3_xhtml_dedication___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_84__components_Book3_xhtml_dedication__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_85__components_Book3_xhtml_part01__ = __webpack_require__(295);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_85__components_Book3_xhtml_part01___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_85__components_Book3_xhtml_part01__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_86__components_Book3_xhtml_chapter001__ = __webpack_require__(298);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_86__components_Book3_xhtml_chapter001___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_86__components_Book3_xhtml_chapter001__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_87__components_Book3_xhtml_chapter002__ = __webpack_require__(301);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_87__components_Book3_xhtml_chapter002___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_87__components_Book3_xhtml_chapter002__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_88__components_Book3_xhtml_chapter003__ = __webpack_require__(304);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_88__components_Book3_xhtml_chapter003___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_88__components_Book3_xhtml_chapter003__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_89__components_Book3_xhtml_chapter004__ = __webpack_require__(307);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_89__components_Book3_xhtml_chapter004___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_89__components_Book3_xhtml_chapter004__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_90__components_Book3_xhtml_chapter005__ = __webpack_require__(310);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_90__components_Book3_xhtml_chapter005___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_90__components_Book3_xhtml_chapter005__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_91__components_Book3_xhtml_chapter006__ = __webpack_require__(313);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_91__components_Book3_xhtml_chapter006___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_91__components_Book3_xhtml_chapter006__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_92__components_Book3_xhtml_chapter007__ = __webpack_require__(316);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_92__components_Book3_xhtml_chapter007___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_92__components_Book3_xhtml_chapter007__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_93__components_Book3_xhtml_part02__ = __webpack_require__(319);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_93__components_Book3_xhtml_part02___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_93__components_Book3_xhtml_part02__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_94__components_Book3_xhtml_chapter008__ = __webpack_require__(322);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_94__components_Book3_xhtml_chapter008___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_94__components_Book3_xhtml_chapter008__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_95__components_Book3_xhtml_chapter009__ = __webpack_require__(325);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_95__components_Book3_xhtml_chapter009___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_95__components_Book3_xhtml_chapter009__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_96__components_Book3_xhtml_chapter010__ = __webpack_require__(328);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_96__components_Book3_xhtml_chapter010___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_96__components_Book3_xhtml_chapter010__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_97__components_Book3_xhtml_chapter011__ = __webpack_require__(331);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_97__components_Book3_xhtml_chapter011___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_97__components_Book3_xhtml_chapter011__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_98__components_Book3_xhtml_chapter012__ = __webpack_require__(334);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_98__components_Book3_xhtml_chapter012___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_98__components_Book3_xhtml_chapter012__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_99__components_Book3_xhtml_chapter013__ = __webpack_require__(337);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_99__components_Book3_xhtml_chapter013___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_99__components_Book3_xhtml_chapter013__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_100__components_Book3_xhtml_chapter014__ = __webpack_require__(340);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_100__components_Book3_xhtml_chapter014___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_100__components_Book3_xhtml_chapter014__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_101__components_Book3_xhtml_part03__ = __webpack_require__(343);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_101__components_Book3_xhtml_part03___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_101__components_Book3_xhtml_part03__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_102__components_Book3_xhtml_chapter015__ = __webpack_require__(346);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_102__components_Book3_xhtml_chapter015___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_102__components_Book3_xhtml_chapter015__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_103__components_Book3_xhtml_chapter016__ = __webpack_require__(349);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_103__components_Book3_xhtml_chapter016___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_103__components_Book3_xhtml_chapter016__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_104__components_Book3_xhtml_chapter017__ = __webpack_require__(352);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_104__components_Book3_xhtml_chapter017___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_104__components_Book3_xhtml_chapter017__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_105__components_Book3_xhtml_chapter018__ = __webpack_require__(355);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_105__components_Book3_xhtml_chapter018___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_105__components_Book3_xhtml_chapter018__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_106__components_Book3_xhtml_chapter019__ = __webpack_require__(358);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_106__components_Book3_xhtml_chapter019___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_106__components_Book3_xhtml_chapter019__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_107__components_Book3_xhtml_chapter020__ = __webpack_require__(361);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_107__components_Book3_xhtml_chapter020___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_107__components_Book3_xhtml_chapter020__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_108__components_Book3_xhtml_chapter021__ = __webpack_require__(364);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_108__components_Book3_xhtml_chapter021___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_108__components_Book3_xhtml_chapter021__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_109__components_Book3_xhtml_chapter022__ = __webpack_require__(367);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_109__components_Book3_xhtml_chapter022___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_109__components_Book3_xhtml_chapter022__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_110__components_Book3_xhtml_part04__ = __webpack_require__(370);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_110__components_Book3_xhtml_part04___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_110__components_Book3_xhtml_part04__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_111__components_Book3_xhtml_chapter023__ = __webpack_require__(373);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_111__components_Book3_xhtml_chapter023___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_111__components_Book3_xhtml_chapter023__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_112__components_Book3_xhtml_chapter024__ = __webpack_require__(376);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_112__components_Book3_xhtml_chapter024___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_112__components_Book3_xhtml_chapter024__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_113__components_Book3_xhtml_chapter025__ = __webpack_require__(379);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_113__components_Book3_xhtml_chapter025___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_113__components_Book3_xhtml_chapter025__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_114__components_Book3_xhtml_chapter026__ = __webpack_require__(382);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_114__components_Book3_xhtml_chapter026___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_114__components_Book3_xhtml_chapter026__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_115__components_Book3_xhtml_chapter027__ = __webpack_require__(385);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_115__components_Book3_xhtml_chapter027___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_115__components_Book3_xhtml_chapter027__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_116__components_Book3_xhtml_chapter028__ = __webpack_require__(388);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_116__components_Book3_xhtml_chapter028___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_116__components_Book3_xhtml_chapter028__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_117__components_Book3_xhtml_part05__ = __webpack_require__(391);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_117__components_Book3_xhtml_part05___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_117__components_Book3_xhtml_part05__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_118__components_Book3_xhtml_endmatter001__ = __webpack_require__(394);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_118__components_Book3_xhtml_endmatter001___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_118__components_Book3_xhtml_endmatter001__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_119__components_Book4_xhtml_cover__ = __webpack_require__(397);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_119__components_Book4_xhtml_cover___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_119__components_Book4_xhtml_cover__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_120__components_Book4_xhtml_title__ = __webpack_require__(400);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_120__components_Book4_xhtml_title___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_120__components_Book4_xhtml_title__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_121__components_Book4_xhtml_part01__ = __webpack_require__(403);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_121__components_Book4_xhtml_part01___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_121__components_Book4_xhtml_part01__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_122__components_Book4_xhtml_chapter001__ = __webpack_require__(406);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_122__components_Book4_xhtml_chapter001___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_122__components_Book4_xhtml_chapter001__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_123__components_Book4_xhtml_chapter002__ = __webpack_require__(409);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_123__components_Book4_xhtml_chapter002___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_123__components_Book4_xhtml_chapter002__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_124__components_Book4_xhtml_chapter003__ = __webpack_require__(412);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_124__components_Book4_xhtml_chapter003___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_124__components_Book4_xhtml_chapter003__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_125__components_Book4_xhtml_chapter004__ = __webpack_require__(415);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_125__components_Book4_xhtml_chapter004___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_125__components_Book4_xhtml_chapter004__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_126__components_Book4_xhtml_part02__ = __webpack_require__(418);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_126__components_Book4_xhtml_part02___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_126__components_Book4_xhtml_part02__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_127__components_Book4_xhtml_chapter005__ = __webpack_require__(421);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_127__components_Book4_xhtml_chapter005___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_127__components_Book4_xhtml_chapter005__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_128__components_Book4_xhtml_chapter006__ = __webpack_require__(424);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_128__components_Book4_xhtml_chapter006___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_128__components_Book4_xhtml_chapter006__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_129__components_Book4_xhtml_chapter007__ = __webpack_require__(427);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_129__components_Book4_xhtml_chapter007___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_129__components_Book4_xhtml_chapter007__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_130__components_Book4_xhtml_chapter008__ = __webpack_require__(430);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_130__components_Book4_xhtml_chapter008___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_130__components_Book4_xhtml_chapter008__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_131__components_Book4_xhtml_chapter009__ = __webpack_require__(433);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_131__components_Book4_xhtml_chapter009___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_131__components_Book4_xhtml_chapter009__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_132__components_Book4_xhtml_chapter010__ = __webpack_require__(436);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_132__components_Book4_xhtml_chapter010___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_132__components_Book4_xhtml_chapter010__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_133__components_Book4_xhtml_chapter011__ = __webpack_require__(439);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_133__components_Book4_xhtml_chapter011___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_133__components_Book4_xhtml_chapter011__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_134__components_Book4_xhtml_chapter012__ = __webpack_require__(442);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_134__components_Book4_xhtml_chapter012___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_134__components_Book4_xhtml_chapter012__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_135__components_Book4_xhtml_part03__ = __webpack_require__(445);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_135__components_Book4_xhtml_part03___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_135__components_Book4_xhtml_part03__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_136__components_Book4_xhtml_chapter013__ = __webpack_require__(448);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_136__components_Book4_xhtml_chapter013___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_136__components_Book4_xhtml_chapter013__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_137__components_Book4_xhtml_chapter014__ = __webpack_require__(451);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_137__components_Book4_xhtml_chapter014___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_137__components_Book4_xhtml_chapter014__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_138__components_Book4_xhtml_chapter015__ = __webpack_require__(454);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_138__components_Book4_xhtml_chapter015___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_138__components_Book4_xhtml_chapter015__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_139__components_Book4_xhtml_chapter016__ = __webpack_require__(457);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_139__components_Book4_xhtml_chapter016___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_139__components_Book4_xhtml_chapter016__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_140__components_Book4_xhtml_chapter017__ = __webpack_require__(460);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_140__components_Book4_xhtml_chapter017___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_140__components_Book4_xhtml_chapter017__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_141__components_Book4_xhtml_chapter018__ = __webpack_require__(463);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_141__components_Book4_xhtml_chapter018___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_141__components_Book4_xhtml_chapter018__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_142__components_Book4_xhtml_chapter019__ = __webpack_require__(466);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_142__components_Book4_xhtml_chapter019___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_142__components_Book4_xhtml_chapter019__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_143__components_Book4_xhtml_chapter020__ = __webpack_require__(469);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_143__components_Book4_xhtml_chapter020___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_143__components_Book4_xhtml_chapter020__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_144__components_Book4_xhtml_chapter021__ = __webpack_require__(472);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_144__components_Book4_xhtml_chapter021___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_144__components_Book4_xhtml_chapter021__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_145__components_Book4_xhtml_chapter022__ = __webpack_require__(475);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_145__components_Book4_xhtml_chapter022___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_145__components_Book4_xhtml_chapter022__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_146__components_Book4_xhtml_chapter023__ = __webpack_require__(478);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_146__components_Book4_xhtml_chapter023___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_146__components_Book4_xhtml_chapter023__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_147__components_Book4_xhtml_chapter024__ = __webpack_require__(481);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_147__components_Book4_xhtml_chapter024___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_147__components_Book4_xhtml_chapter024__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_148__components_Book4_xhtml_part04__ = __webpack_require__(484);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_148__components_Book4_xhtml_part04___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_148__components_Book4_xhtml_part04__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_149__components_Book4_xhtml_chapter025__ = __webpack_require__(487);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_149__components_Book4_xhtml_chapter025___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_149__components_Book4_xhtml_chapter025__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_150__components_Book4_xhtml_chapter026__ = __webpack_require__(490);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_150__components_Book4_xhtml_chapter026___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_150__components_Book4_xhtml_chapter026__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_151__components_Book4_xhtml_chapter027__ = __webpack_require__(493);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_151__components_Book4_xhtml_chapter027___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_151__components_Book4_xhtml_chapter027__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_152__components_Book4_xhtml_chapter028__ = __webpack_require__(496);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_152__components_Book4_xhtml_chapter028___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_152__components_Book4_xhtml_chapter028__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_153__components_Book4_xhtml_chapter029__ = __webpack_require__(499);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_153__components_Book4_xhtml_chapter029___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_153__components_Book4_xhtml_chapter029__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_154__components_Book4_xhtml_chapter030__ = __webpack_require__(502);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_154__components_Book4_xhtml_chapter030___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_154__components_Book4_xhtml_chapter030__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_155__components_Book4_xhtml_chapter031__ = __webpack_require__(505);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_155__components_Book4_xhtml_chapter031___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_155__components_Book4_xhtml_chapter031__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_156__components_love_2__ = __webpack_require__(508);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_156__components_love_2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_156__components_love_2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_157__components_Book4_xhtml_endmatter01__ = __webpack_require__(511);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_157__components_Book4_xhtml_endmatter01___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_157__components_Book4_xhtml_endmatter01__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_158__components_copyright__ = __webpack_require__(514);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_158__components_copyright___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_158__components_copyright__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_159__components_Book1_xhtml_auba__ = __webpack_require__(517);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_159__components_Book1_xhtml_auba___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_159__components_Book1_xhtml_auba__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_160__components_Book1_Backed_ORIM_ad_1__ = __webpack_require__(520);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_160__components_Book1_Backed_ORIM_ad_1___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_160__components_Book1_Backed_ORIM_ad_1__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_161__components_last__ = __webpack_require__(523);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_161__components_last___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_161__components_last__);
/*jshint esversion: 6 */




































































































































































__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: [{
    "path": "/",
    "name": "home",
    "component": __WEBPACK_IMPORTED_MODULE_3__components_home___default.a
  }, {
    "path": "/bundle_content",
    "name": "bundle_content",
    "component": __WEBPACK_IMPORTED_MODULE_9__components_bundle_content___default.a
  }, {
    "path": "/Book1/xhtml/cover",
    "name": "Book1/xhtml/cover",
    "component": __WEBPACK_IMPORTED_MODULE_10__components_Book1_xhtml_cover___default.a
  }, {
    "path": "/Book1/xhtml/title",
    "name": "Book1/xhtml/title",
    "component": __WEBPACK_IMPORTED_MODULE_11__components_Book1_xhtml_title___default.a
  }, {
    "path": "/Book1/xhtml/dedication",
    "name": "Book1/xhtml/dedication",
    "component": __WEBPACK_IMPORTED_MODULE_12__components_Book1_xhtml_dedication___default.a
  }, {
    "path": "/Book1/xhtml/frontmatter02",
    "name": "Book1/xhtml/frontmatter02",
    "component": __WEBPACK_IMPORTED_MODULE_13__components_Book1_xhtml_frontmatter02___default.a
  }, {
    "path": "/Book1/xhtml/part01",
    "name": "Book1/xhtml/part01",
    "component": __WEBPACK_IMPORTED_MODULE_14__components_Book1_xhtml_part01___default.a
  }, {
    "path": "/Book1/xhtml/chapter001",
    "name": "Book1/xhtml/chapter001",
    "component": __WEBPACK_IMPORTED_MODULE_15__components_Book1_xhtml_chapter001___default.a
  }, {
    "path": "/Book1/xhtml/chapter002",
    "name": "Book1/xhtml/chapter002",
    "component": __WEBPACK_IMPORTED_MODULE_16__components_Book1_xhtml_chapter002___default.a
  }, {
    "path": "/Book1/xhtml/chapter003",
    "name": "Book1/xhtml/chapter003",
    "component": __WEBPACK_IMPORTED_MODULE_17__components_Book1_xhtml_chapter003___default.a
  }, {
    "path": "/Book1/xhtml/chapter004",
    "name": "Book1/xhtml/chapter004",
    "component": __WEBPACK_IMPORTED_MODULE_18__components_Book1_xhtml_chapter004___default.a
  }, {
    "path": "/Book1/xhtml/chapter005",
    "name": "Book1/xhtml/chapter005",
    "component": __WEBPACK_IMPORTED_MODULE_19__components_Book1_xhtml_chapter005___default.a
  }, {
    "path": "/Book1/xhtml/chapter006",
    "name": "Book1/xhtml/chapter006",
    "component": __WEBPACK_IMPORTED_MODULE_20__components_Book1_xhtml_chapter006___default.a
  }, {
    "path": "/Book1/xhtml/chapter007",
    "name": "Book1/xhtml/chapter007",
    "component": __WEBPACK_IMPORTED_MODULE_21__components_Book1_xhtml_chapter007___default.a
  }, {
    "path": "/Book1/xhtml/chapter008",
    "name": "Book1/xhtml/chapter008",
    "component": __WEBPACK_IMPORTED_MODULE_22__components_Book1_xhtml_chapter008___default.a
  }, {
    "path": "/Book1/xhtml/chapter009",
    "name": "Book1/xhtml/chapter009",
    "component": __WEBPACK_IMPORTED_MODULE_23__components_Book1_xhtml_chapter009___default.a
  }, {
    "path": "/Book1/xhtml/chapter010",
    "name": "Book1/xhtml/chapter010",
    "component": __WEBPACK_IMPORTED_MODULE_24__components_Book1_xhtml_chapter010___default.a
  }, {
    "path": "/last",
    "name": "last",
    "component": __WEBPACK_IMPORTED_MODULE_161__components_last___default.a
  }]
}));

/***/ }),
/* 48 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
  * vue-router v2.8.1
  * (c) 2017 Evan You
  * @license MIT
  */
/*  */

function assert (condition, message) {
  if (!condition) {
    throw new Error(("[vue-router] " + message))
  }
}

function warn (condition, message) {
  if (false) {
    typeof console !== 'undefined' && console.warn(("[vue-router] " + message));
  }
}

function isError (err) {
  return Object.prototype.toString.call(err).indexOf('Error') > -1
}

var View = {
  name: 'router-view',
  functional: true,
  props: {
    name: {
      type: String,
      default: 'default'
    }
  },
  render: function render (_, ref) {
    var props = ref.props;
    var children = ref.children;
    var parent = ref.parent;
    var data = ref.data;

    data.routerView = true;

    // directly use parent context's createElement() function
    // so that components rendered by router-view can resolve named slots
    var h = parent.$createElement;
    var name = props.name;
    var route = parent.$route;
    var cache = parent._routerViewCache || (parent._routerViewCache = {});

    // determine current view depth, also check to see if the tree
    // has been toggled inactive but kept-alive.
    var depth = 0;
    var inactive = false;
    while (parent && parent._routerRoot !== parent) {
      if (parent.$vnode && parent.$vnode.data.routerView) {
        depth++;
      }
      if (parent._inactive) {
        inactive = true;
      }
      parent = parent.$parent;
    }
    data.routerViewDepth = depth;

    // render previous view if the tree is inactive and kept-alive
    if (inactive) {
      return h(cache[name], data, children)
    }

    var matched = route.matched[depth];
    // render empty node if no matched route
    if (!matched) {
      cache[name] = null;
      return h()
    }

    var component = cache[name] = matched.components[name];

    // attach instance registration hook
    // this will be called in the instance's injected lifecycle hooks
    data.registerRouteInstance = function (vm, val) {
      // val could be undefined for unregistration
      var current = matched.instances[name];
      if (
        (val && current !== vm) ||
        (!val && current === vm)
      ) {
        matched.instances[name] = val;
      }
    }

    // also register instance in prepatch hook
    // in case the same component instance is reused across different routes
    ;(data.hook || (data.hook = {})).prepatch = function (_, vnode) {
      matched.instances[name] = vnode.componentInstance;
    };

    // resolve props
    var propsToPass = data.props = resolveProps(route, matched.props && matched.props[name]);
    if (propsToPass) {
      // clone to prevent mutation
      propsToPass = data.props = extend({}, propsToPass);
      // pass non-declared props as attrs
      var attrs = data.attrs = data.attrs || {};
      for (var key in propsToPass) {
        if (!component.props || !(key in component.props)) {
          attrs[key] = propsToPass[key];
          delete propsToPass[key];
        }
      }
    }

    return h(component, data, children)
  }
};

function resolveProps (route, config) {
  switch (typeof config) {
    case 'undefined':
      return
    case 'object':
      return config
    case 'function':
      return config(route)
    case 'boolean':
      return config ? route.params : undefined
    default:
      if (false) {
        warn(
          false,
          "props in \"" + (route.path) + "\" is a " + (typeof config) + ", " +
          "expecting an object, function or boolean."
        );
      }
  }
}

function extend (to, from) {
  for (var key in from) {
    to[key] = from[key];
  }
  return to
}

/*  */

var encodeReserveRE = /[!'()*]/g;
var encodeReserveReplacer = function (c) { return '%' + c.charCodeAt(0).toString(16); };
var commaRE = /%2C/g;

// fixed encodeURIComponent which is more conformant to RFC3986:
// - escapes [!'()*]
// - preserve commas
var encode = function (str) { return encodeURIComponent(str)
  .replace(encodeReserveRE, encodeReserveReplacer)
  .replace(commaRE, ','); };

var decode = decodeURIComponent;

function resolveQuery (
  query,
  extraQuery,
  _parseQuery
) {
  if ( extraQuery === void 0 ) extraQuery = {};

  var parse = _parseQuery || parseQuery;
  var parsedQuery;
  try {
    parsedQuery = parse(query || '');
  } catch (e) {
    "production" !== 'production' && warn(false, e.message);
    parsedQuery = {};
  }
  for (var key in extraQuery) {
    parsedQuery[key] = extraQuery[key];
  }
  return parsedQuery
}

function parseQuery (query) {
  var res = {};

  query = query.trim().replace(/^(\?|#|&)/, '');

  if (!query) {
    return res
  }

  query.split('&').forEach(function (param) {
    var parts = param.replace(/\+/g, ' ').split('=');
    var key = decode(parts.shift());
    var val = parts.length > 0
      ? decode(parts.join('='))
      : null;

    if (res[key] === undefined) {
      res[key] = val;
    } else if (Array.isArray(res[key])) {
      res[key].push(val);
    } else {
      res[key] = [res[key], val];
    }
  });

  return res
}

function stringifyQuery (obj) {
  var res = obj ? Object.keys(obj).map(function (key) {
    var val = obj[key];

    if (val === undefined) {
      return ''
    }

    if (val === null) {
      return encode(key)
    }

    if (Array.isArray(val)) {
      var result = [];
      val.forEach(function (val2) {
        if (val2 === undefined) {
          return
        }
        if (val2 === null) {
          result.push(encode(key));
        } else {
          result.push(encode(key) + '=' + encode(val2));
        }
      });
      return result.join('&')
    }

    return encode(key) + '=' + encode(val)
  }).filter(function (x) { return x.length > 0; }).join('&') : null;
  return res ? ("?" + res) : ''
}

/*  */


var trailingSlashRE = /\/?$/;

function createRoute (
  record,
  location,
  redirectedFrom,
  router
) {
  var stringifyQuery$$1 = router && router.options.stringifyQuery;

  var query = location.query || {};
  try {
    query = clone(query);
  } catch (e) {}

  var route = {
    name: location.name || (record && record.name),
    meta: (record && record.meta) || {},
    path: location.path || '/',
    hash: location.hash || '',
    query: query,
    params: location.params || {},
    fullPath: getFullPath(location, stringifyQuery$$1),
    matched: record ? formatMatch(record) : []
  };
  if (redirectedFrom) {
    route.redirectedFrom = getFullPath(redirectedFrom, stringifyQuery$$1);
  }
  return Object.freeze(route)
}

function clone (value) {
  if (Array.isArray(value)) {
    return value.map(clone)
  } else if (value && typeof value === 'object') {
    var res = {};
    for (var key in value) {
      res[key] = clone(value[key]);
    }
    return res
  } else {
    return value
  }
}

// the starting route that represents the initial state
var START = createRoute(null, {
  path: '/'
});

function formatMatch (record) {
  var res = [];
  while (record) {
    res.unshift(record);
    record = record.parent;
  }
  return res
}

function getFullPath (
  ref,
  _stringifyQuery
) {
  var path = ref.path;
  var query = ref.query; if ( query === void 0 ) query = {};
  var hash = ref.hash; if ( hash === void 0 ) hash = '';

  var stringify = _stringifyQuery || stringifyQuery;
  return (path || '/') + stringify(query) + hash
}

function isSameRoute (a, b) {
  if (b === START) {
    return a === b
  } else if (!b) {
    return false
  } else if (a.path && b.path) {
    return (
      a.path.replace(trailingSlashRE, '') === b.path.replace(trailingSlashRE, '') &&
      a.hash === b.hash &&
      isObjectEqual(a.query, b.query)
    )
  } else if (a.name && b.name) {
    return (
      a.name === b.name &&
      a.hash === b.hash &&
      isObjectEqual(a.query, b.query) &&
      isObjectEqual(a.params, b.params)
    )
  } else {
    return false
  }
}

function isObjectEqual (a, b) {
  if ( a === void 0 ) a = {};
  if ( b === void 0 ) b = {};

  // handle null value #1566
  if (!a || !b) { return a === b }
  var aKeys = Object.keys(a);
  var bKeys = Object.keys(b);
  if (aKeys.length !== bKeys.length) {
    return false
  }
  return aKeys.every(function (key) {
    var aVal = a[key];
    var bVal = b[key];
    // check nested equality
    if (typeof aVal === 'object' && typeof bVal === 'object') {
      return isObjectEqual(aVal, bVal)
    }
    return String(aVal) === String(bVal)
  })
}

function isIncludedRoute (current, target) {
  return (
    current.path.replace(trailingSlashRE, '/').indexOf(
      target.path.replace(trailingSlashRE, '/')
    ) === 0 &&
    (!target.hash || current.hash === target.hash) &&
    queryIncludes(current.query, target.query)
  )
}

function queryIncludes (current, target) {
  for (var key in target) {
    if (!(key in current)) {
      return false
    }
  }
  return true
}

/*  */

// work around weird flow bug
var toTypes = [String, Object];
var eventTypes = [String, Array];

var Link = {
  name: 'router-link',
  props: {
    to: {
      type: toTypes,
      required: true
    },
    tag: {
      type: String,
      default: 'a'
    },
    exact: Boolean,
    append: Boolean,
    replace: Boolean,
    activeClass: String,
    exactActiveClass: String,
    event: {
      type: eventTypes,
      default: 'click'
    }
  },
  render: function render (h) {
    var this$1 = this;

    var router = this.$router;
    var current = this.$route;
    var ref = router.resolve(this.to, current, this.append);
    var location = ref.location;
    var route = ref.route;
    var href = ref.href;

    var classes = {};
    var globalActiveClass = router.options.linkActiveClass;
    var globalExactActiveClass = router.options.linkExactActiveClass;
    // Support global empty active class
    var activeClassFallback = globalActiveClass == null
            ? 'router-link-active'
            : globalActiveClass;
    var exactActiveClassFallback = globalExactActiveClass == null
            ? 'router-link-exact-active'
            : globalExactActiveClass;
    var activeClass = this.activeClass == null
            ? activeClassFallback
            : this.activeClass;
    var exactActiveClass = this.exactActiveClass == null
            ? exactActiveClassFallback
            : this.exactActiveClass;
    var compareTarget = location.path
      ? createRoute(null, location, null, router)
      : route;

    classes[exactActiveClass] = isSameRoute(current, compareTarget);
    classes[activeClass] = this.exact
      ? classes[exactActiveClass]
      : isIncludedRoute(current, compareTarget);

    var handler = function (e) {
      if (guardEvent(e)) {
        if (this$1.replace) {
          router.replace(location);
        } else {
          router.push(location);
        }
      }
    };

    var on = { click: guardEvent };
    if (Array.isArray(this.event)) {
      this.event.forEach(function (e) { on[e] = handler; });
    } else {
      on[this.event] = handler;
    }

    var data = {
      class: classes
    };

    if (this.tag === 'a') {
      data.on = on;
      data.attrs = { href: href };
    } else {
      // find the first <a> child and apply listener and href
      var a = findAnchor(this.$slots.default);
      if (a) {
        // in case the <a> is a static node
        a.isStatic = false;
        var extend = _Vue.util.extend;
        var aData = a.data = extend({}, a.data);
        aData.on = on;
        var aAttrs = a.data.attrs = extend({}, a.data.attrs);
        aAttrs.href = href;
      } else {
        // doesn't have <a> child, apply listener to self
        data.on = on;
      }
    }

    return h(this.tag, data, this.$slots.default)
  }
};

function guardEvent (e) {
  // don't redirect with control keys
  if (e.metaKey || e.altKey || e.ctrlKey || e.shiftKey) { return }
  // don't redirect when preventDefault called
  if (e.defaultPrevented) { return }
  // don't redirect on right click
  if (e.button !== undefined && e.button !== 0) { return }
  // don't redirect if `target="_blank"`
  if (e.currentTarget && e.currentTarget.getAttribute) {
    var target = e.currentTarget.getAttribute('target');
    if (/\b_blank\b/i.test(target)) { return }
  }
  // this may be a Weex event which doesn't have this method
  if (e.preventDefault) {
    e.preventDefault();
  }
  return true
}

function findAnchor (children) {
  if (children) {
    var child;
    for (var i = 0; i < children.length; i++) {
      child = children[i];
      if (child.tag === 'a') {
        return child
      }
      if (child.children && (child = findAnchor(child.children))) {
        return child
      }
    }
  }
}

var _Vue;

function install (Vue) {
  if (install.installed && _Vue === Vue) { return }
  install.installed = true;

  _Vue = Vue;

  var isDef = function (v) { return v !== undefined; };

  var registerInstance = function (vm, callVal) {
    var i = vm.$options._parentVnode;
    if (isDef(i) && isDef(i = i.data) && isDef(i = i.registerRouteInstance)) {
      i(vm, callVal);
    }
  };

  Vue.mixin({
    beforeCreate: function beforeCreate () {
      if (isDef(this.$options.router)) {
        this._routerRoot = this;
        this._router = this.$options.router;
        this._router.init(this);
        Vue.util.defineReactive(this, '_route', this._router.history.current);
      } else {
        this._routerRoot = (this.$parent && this.$parent._routerRoot) || this;
      }
      registerInstance(this, this);
    },
    destroyed: function destroyed () {
      registerInstance(this);
    }
  });

  Object.defineProperty(Vue.prototype, '$router', {
    get: function get () { return this._routerRoot._router }
  });

  Object.defineProperty(Vue.prototype, '$route', {
    get: function get () { return this._routerRoot._route }
  });

  Vue.component('router-view', View);
  Vue.component('router-link', Link);

  var strats = Vue.config.optionMergeStrategies;
  // use the same hook merging strategy for route hooks
  strats.beforeRouteEnter = strats.beforeRouteLeave = strats.beforeRouteUpdate = strats.created;
}

/*  */

var inBrowser = typeof window !== 'undefined';

/*  */

function resolvePath (
  relative,
  base,
  append
) {
  var firstChar = relative.charAt(0);
  if (firstChar === '/') {
    return relative
  }

  if (firstChar === '?' || firstChar === '#') {
    return base + relative
  }

  var stack = base.split('/');

  // remove trailing segment if:
  // - not appending
  // - appending to trailing slash (last segment is empty)
  if (!append || !stack[stack.length - 1]) {
    stack.pop();
  }

  // resolve relative path
  var segments = relative.replace(/^\//, '').split('/');
  for (var i = 0; i < segments.length; i++) {
    var segment = segments[i];
    if (segment === '..') {
      stack.pop();
    } else if (segment !== '.') {
      stack.push(segment);
    }
  }

  // ensure leading slash
  if (stack[0] !== '') {
    stack.unshift('');
  }

  return stack.join('/')
}

function parsePath (path) {
  var hash = '';
  var query = '';

  var hashIndex = path.indexOf('#');
  if (hashIndex >= 0) {
    hash = path.slice(hashIndex);
    path = path.slice(0, hashIndex);
  }

  var queryIndex = path.indexOf('?');
  if (queryIndex >= 0) {
    query = path.slice(queryIndex + 1);
    path = path.slice(0, queryIndex);
  }

  return {
    path: path,
    query: query,
    hash: hash
  }
}

function cleanPath (path) {
  return path.replace(/\/\//g, '/')
}

var isarray = Array.isArray || function (arr) {
  return Object.prototype.toString.call(arr) == '[object Array]';
};

/**
 * Expose `pathToRegexp`.
 */
var pathToRegexp_1 = pathToRegexp;
var parse_1 = parse;
var compile_1 = compile;
var tokensToFunction_1 = tokensToFunction;
var tokensToRegExp_1 = tokensToRegExp;

/**
 * The main path matching regexp utility.
 *
 * @type {RegExp}
 */
var PATH_REGEXP = new RegExp([
  // Match escaped characters that would otherwise appear in future matches.
  // This allows the user to escape special characters that won't transform.
  '(\\\\.)',
  // Match Express-style parameters and un-named parameters with a prefix
  // and optional suffixes. Matches appear as:
  //
  // "/:test(\\d+)?" => ["/", "test", "\d+", undefined, "?", undefined]
  // "/route(\\d+)"  => [undefined, undefined, undefined, "\d+", undefined, undefined]
  // "/*"            => ["/", undefined, undefined, undefined, undefined, "*"]
  '([\\/.])?(?:(?:\\:(\\w+)(?:\\(((?:\\\\.|[^\\\\()])+)\\))?|\\(((?:\\\\.|[^\\\\()])+)\\))([+*?])?|(\\*))'
].join('|'), 'g');

/**
 * Parse a string for the raw tokens.
 *
 * @param  {string}  str
 * @param  {Object=} options
 * @return {!Array}
 */
function parse (str, options) {
  var tokens = [];
  var key = 0;
  var index = 0;
  var path = '';
  var defaultDelimiter = options && options.delimiter || '/';
  var res;

  while ((res = PATH_REGEXP.exec(str)) != null) {
    var m = res[0];
    var escaped = res[1];
    var offset = res.index;
    path += str.slice(index, offset);
    index = offset + m.length;

    // Ignore already escaped sequences.
    if (escaped) {
      path += escaped[1];
      continue
    }

    var next = str[index];
    var prefix = res[2];
    var name = res[3];
    var capture = res[4];
    var group = res[5];
    var modifier = res[6];
    var asterisk = res[7];

    // Push the current path onto the tokens.
    if (path) {
      tokens.push(path);
      path = '';
    }

    var partial = prefix != null && next != null && next !== prefix;
    var repeat = modifier === '+' || modifier === '*';
    var optional = modifier === '?' || modifier === '*';
    var delimiter = res[2] || defaultDelimiter;
    var pattern = capture || group;

    tokens.push({
      name: name || key++,
      prefix: prefix || '',
      delimiter: delimiter,
      optional: optional,
      repeat: repeat,
      partial: partial,
      asterisk: !!asterisk,
      pattern: pattern ? escapeGroup(pattern) : (asterisk ? '.*' : '[^' + escapeString(delimiter) + ']+?')
    });
  }

  // Match any characters still remaining.
  if (index < str.length) {
    path += str.substr(index);
  }

  // If the path exists, push it onto the end.
  if (path) {
    tokens.push(path);
  }

  return tokens
}

/**
 * Compile a string to a template function for the path.
 *
 * @param  {string}             str
 * @param  {Object=}            options
 * @return {!function(Object=, Object=)}
 */
function compile (str, options) {
  return tokensToFunction(parse(str, options))
}

/**
 * Prettier encoding of URI path segments.
 *
 * @param  {string}
 * @return {string}
 */
function encodeURIComponentPretty (str) {
  return encodeURI(str).replace(/[\/?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
  })
}

/**
 * Encode the asterisk parameter. Similar to `pretty`, but allows slashes.
 *
 * @param  {string}
 * @return {string}
 */
function encodeAsterisk (str) {
  return encodeURI(str).replace(/[?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
  })
}

/**
 * Expose a method for transforming tokens into the path function.
 */
function tokensToFunction (tokens) {
  // Compile all the tokens into regexps.
  var matches = new Array(tokens.length);

  // Compile all the patterns before compilation.
  for (var i = 0; i < tokens.length; i++) {
    if (typeof tokens[i] === 'object') {
      matches[i] = new RegExp('^(?:' + tokens[i].pattern + ')$');
    }
  }

  return function (obj, opts) {
    var path = '';
    var data = obj || {};
    var options = opts || {};
    var encode = options.pretty ? encodeURIComponentPretty : encodeURIComponent;

    for (var i = 0; i < tokens.length; i++) {
      var token = tokens[i];

      if (typeof token === 'string') {
        path += token;

        continue
      }

      var value = data[token.name];
      var segment;

      if (value == null) {
        if (token.optional) {
          // Prepend partial segment prefixes.
          if (token.partial) {
            path += token.prefix;
          }

          continue
        } else {
          throw new TypeError('Expected "' + token.name + '" to be defined')
        }
      }

      if (isarray(value)) {
        if (!token.repeat) {
          throw new TypeError('Expected "' + token.name + '" to not repeat, but received `' + JSON.stringify(value) + '`')
        }

        if (value.length === 0) {
          if (token.optional) {
            continue
          } else {
            throw new TypeError('Expected "' + token.name + '" to not be empty')
          }
        }

        for (var j = 0; j < value.length; j++) {
          segment = encode(value[j]);

          if (!matches[i].test(segment)) {
            throw new TypeError('Expected all "' + token.name + '" to match "' + token.pattern + '", but received `' + JSON.stringify(segment) + '`')
          }

          path += (j === 0 ? token.prefix : token.delimiter) + segment;
        }

        continue
      }

      segment = token.asterisk ? encodeAsterisk(value) : encode(value);

      if (!matches[i].test(segment)) {
        throw new TypeError('Expected "' + token.name + '" to match "' + token.pattern + '", but received "' + segment + '"')
      }

      path += token.prefix + segment;
    }

    return path
  }
}

/**
 * Escape a regular expression string.
 *
 * @param  {string} str
 * @return {string}
 */
function escapeString (str) {
  return str.replace(/([.+*?=^!:${}()[\]|\/\\])/g, '\\$1')
}

/**
 * Escape the capturing group by escaping special characters and meaning.
 *
 * @param  {string} group
 * @return {string}
 */
function escapeGroup (group) {
  return group.replace(/([=!:$\/()])/g, '\\$1')
}

/**
 * Attach the keys as a property of the regexp.
 *
 * @param  {!RegExp} re
 * @param  {Array}   keys
 * @return {!RegExp}
 */
function attachKeys (re, keys) {
  re.keys = keys;
  return re
}

/**
 * Get the flags for a regexp from the options.
 *
 * @param  {Object} options
 * @return {string}
 */
function flags (options) {
  return options.sensitive ? '' : 'i'
}

/**
 * Pull out keys from a regexp.
 *
 * @param  {!RegExp} path
 * @param  {!Array}  keys
 * @return {!RegExp}
 */
function regexpToRegexp (path, keys) {
  // Use a negative lookahead to match only capturing groups.
  var groups = path.source.match(/\((?!\?)/g);

  if (groups) {
    for (var i = 0; i < groups.length; i++) {
      keys.push({
        name: i,
        prefix: null,
        delimiter: null,
        optional: false,
        repeat: false,
        partial: false,
        asterisk: false,
        pattern: null
      });
    }
  }

  return attachKeys(path, keys)
}

/**
 * Transform an array into a regexp.
 *
 * @param  {!Array}  path
 * @param  {Array}   keys
 * @param  {!Object} options
 * @return {!RegExp}
 */
function arrayToRegexp (path, keys, options) {
  var parts = [];

  for (var i = 0; i < path.length; i++) {
    parts.push(pathToRegexp(path[i], keys, options).source);
  }

  var regexp = new RegExp('(?:' + parts.join('|') + ')', flags(options));

  return attachKeys(regexp, keys)
}

/**
 * Create a path regexp from string input.
 *
 * @param  {string}  path
 * @param  {!Array}  keys
 * @param  {!Object} options
 * @return {!RegExp}
 */
function stringToRegexp (path, keys, options) {
  return tokensToRegExp(parse(path, options), keys, options)
}

/**
 * Expose a function for taking tokens and returning a RegExp.
 *
 * @param  {!Array}          tokens
 * @param  {(Array|Object)=} keys
 * @param  {Object=}         options
 * @return {!RegExp}
 */
function tokensToRegExp (tokens, keys, options) {
  if (!isarray(keys)) {
    options = /** @type {!Object} */ (keys || options);
    keys = [];
  }

  options = options || {};

  var strict = options.strict;
  var end = options.end !== false;
  var route = '';

  // Iterate over the tokens and create our regexp string.
  for (var i = 0; i < tokens.length; i++) {
    var token = tokens[i];

    if (typeof token === 'string') {
      route += escapeString(token);
    } else {
      var prefix = escapeString(token.prefix);
      var capture = '(?:' + token.pattern + ')';

      keys.push(token);

      if (token.repeat) {
        capture += '(?:' + prefix + capture + ')*';
      }

      if (token.optional) {
        if (!token.partial) {
          capture = '(?:' + prefix + '(' + capture + '))?';
        } else {
          capture = prefix + '(' + capture + ')?';
        }
      } else {
        capture = prefix + '(' + capture + ')';
      }

      route += capture;
    }
  }

  var delimiter = escapeString(options.delimiter || '/');
  var endsWithDelimiter = route.slice(-delimiter.length) === delimiter;

  // In non-strict mode we allow a slash at the end of match. If the path to
  // match already ends with a slash, we remove it for consistency. The slash
  // is valid at the end of a path match, not in the middle. This is important
  // in non-ending mode, where "/test/" shouldn't match "/test//route".
  if (!strict) {
    route = (endsWithDelimiter ? route.slice(0, -delimiter.length) : route) + '(?:' + delimiter + '(?=$))?';
  }

  if (end) {
    route += '$';
  } else {
    // In non-ending mode, we need the capturing groups to match as much as
    // possible by using a positive lookahead to the end or next path segment.
    route += strict && endsWithDelimiter ? '' : '(?=' + delimiter + '|$)';
  }

  return attachKeys(new RegExp('^' + route, flags(options)), keys)
}

/**
 * Normalize the given path string, returning a regular expression.
 *
 * An empty array can be passed in for the keys, which will hold the
 * placeholder key descriptions. For example, using `/user/:id`, `keys` will
 * contain `[{ name: 'id', delimiter: '/', optional: false, repeat: false }]`.
 *
 * @param  {(string|RegExp|Array)} path
 * @param  {(Array|Object)=}       keys
 * @param  {Object=}               options
 * @return {!RegExp}
 */
function pathToRegexp (path, keys, options) {
  if (!isarray(keys)) {
    options = /** @type {!Object} */ (keys || options);
    keys = [];
  }

  options = options || {};

  if (path instanceof RegExp) {
    return regexpToRegexp(path, /** @type {!Array} */ (keys))
  }

  if (isarray(path)) {
    return arrayToRegexp(/** @type {!Array} */ (path), /** @type {!Array} */ (keys), options)
  }

  return stringToRegexp(/** @type {string} */ (path), /** @type {!Array} */ (keys), options)
}

pathToRegexp_1.parse = parse_1;
pathToRegexp_1.compile = compile_1;
pathToRegexp_1.tokensToFunction = tokensToFunction_1;
pathToRegexp_1.tokensToRegExp = tokensToRegExp_1;

/*  */

// $flow-disable-line
var regexpCompileCache = Object.create(null);

function fillParams (
  path,
  params,
  routeMsg
) {
  try {
    var filler =
      regexpCompileCache[path] ||
      (regexpCompileCache[path] = pathToRegexp_1.compile(path));
    return filler(params || {}, { pretty: true })
  } catch (e) {
    if (false) {
      warn(false, ("missing param for " + routeMsg + ": " + (e.message)));
    }
    return ''
  }
}

/*  */

function createRouteMap (
  routes,
  oldPathList,
  oldPathMap,
  oldNameMap
) {
  // the path list is used to control path matching priority
  var pathList = oldPathList || [];
  // $flow-disable-line
  var pathMap = oldPathMap || Object.create(null);
  // $flow-disable-line
  var nameMap = oldNameMap || Object.create(null);

  routes.forEach(function (route) {
    addRouteRecord(pathList, pathMap, nameMap, route);
  });

  // ensure wildcard routes are always at the end
  for (var i = 0, l = pathList.length; i < l; i++) {
    if (pathList[i] === '*') {
      pathList.push(pathList.splice(i, 1)[0]);
      l--;
      i--;
    }
  }

  return {
    pathList: pathList,
    pathMap: pathMap,
    nameMap: nameMap
  }
}

function addRouteRecord (
  pathList,
  pathMap,
  nameMap,
  route,
  parent,
  matchAs
) {
  var path = route.path;
  var name = route.name;
  if (false) {
    assert(path != null, "\"path\" is required in a route configuration.");
    assert(
      typeof route.component !== 'string',
      "route config \"component\" for path: " + (String(path || name)) + " cannot be a " +
      "string id. Use an actual component instead."
    );
  }

  var pathToRegexpOptions = route.pathToRegexpOptions || {};
  var normalizedPath = normalizePath(
    path,
    parent,
    pathToRegexpOptions.strict
  );

  if (typeof route.caseSensitive === 'boolean') {
    pathToRegexpOptions.sensitive = route.caseSensitive;
  }

  var record = {
    path: normalizedPath,
    regex: compileRouteRegex(normalizedPath, pathToRegexpOptions),
    components: route.components || { default: route.component },
    instances: {},
    name: name,
    parent: parent,
    matchAs: matchAs,
    redirect: route.redirect,
    beforeEnter: route.beforeEnter,
    meta: route.meta || {},
    props: route.props == null
      ? {}
      : route.components
        ? route.props
        : { default: route.props }
  };

  if (route.children) {
    // Warn if route is named, does not redirect and has a default child route.
    // If users navigate to this route by name, the default child will
    // not be rendered (GH Issue #629)
    if (false) {
      if (route.name && !route.redirect && route.children.some(function (child) { return /^\/?$/.test(child.path); })) {
        warn(
          false,
          "Named Route '" + (route.name) + "' has a default child route. " +
          "When navigating to this named route (:to=\"{name: '" + (route.name) + "'\"), " +
          "the default child route will not be rendered. Remove the name from " +
          "this route and use the name of the default child route for named " +
          "links instead."
        );
      }
    }
    route.children.forEach(function (child) {
      var childMatchAs = matchAs
        ? cleanPath((matchAs + "/" + (child.path)))
        : undefined;
      addRouteRecord(pathList, pathMap, nameMap, child, record, childMatchAs);
    });
  }

  if (route.alias !== undefined) {
    var aliases = Array.isArray(route.alias)
      ? route.alias
      : [route.alias];

    aliases.forEach(function (alias) {
      var aliasRoute = {
        path: alias,
        children: route.children
      };
      addRouteRecord(
        pathList,
        pathMap,
        nameMap,
        aliasRoute,
        parent,
        record.path || '/' // matchAs
      );
    });
  }

  if (!pathMap[record.path]) {
    pathList.push(record.path);
    pathMap[record.path] = record;
  }

  if (name) {
    if (!nameMap[name]) {
      nameMap[name] = record;
    } else if (false) {
      warn(
        false,
        "Duplicate named routes definition: " +
        "{ name: \"" + name + "\", path: \"" + (record.path) + "\" }"
      );
    }
  }
}

function compileRouteRegex (path, pathToRegexpOptions) {
  var regex = pathToRegexp_1(path, [], pathToRegexpOptions);
  if (false) {
    var keys = Object.create(null);
    regex.keys.forEach(function (key) {
      warn(!keys[key.name], ("Duplicate param keys in route with path: \"" + path + "\""));
      keys[key.name] = true;
    });
  }
  return regex
}

function normalizePath (path, parent, strict) {
  if (!strict) { path = path.replace(/\/$/, ''); }
  if (path[0] === '/') { return path }
  if (parent == null) { return path }
  return cleanPath(((parent.path) + "/" + path))
}

/*  */


function normalizeLocation (
  raw,
  current,
  append,
  router
) {
  var next = typeof raw === 'string' ? { path: raw } : raw;
  // named target
  if (next.name || next._normalized) {
    return next
  }

  // relative params
  if (!next.path && next.params && current) {
    next = assign({}, next);
    next._normalized = true;
    var params = assign(assign({}, current.params), next.params);
    if (current.name) {
      next.name = current.name;
      next.params = params;
    } else if (current.matched.length) {
      var rawPath = current.matched[current.matched.length - 1].path;
      next.path = fillParams(rawPath, params, ("path " + (current.path)));
    } else if (false) {
      warn(false, "relative params navigation requires a current route.");
    }
    return next
  }

  var parsedPath = parsePath(next.path || '');
  var basePath = (current && current.path) || '/';
  var path = parsedPath.path
    ? resolvePath(parsedPath.path, basePath, append || next.append)
    : basePath;

  var query = resolveQuery(
    parsedPath.query,
    next.query,
    router && router.options.parseQuery
  );

  var hash = next.hash || parsedPath.hash;
  if (hash && hash.charAt(0) !== '#') {
    hash = "#" + hash;
  }

  return {
    _normalized: true,
    path: path,
    query: query,
    hash: hash
  }
}

function assign (a, b) {
  for (var key in b) {
    a[key] = b[key];
  }
  return a
}

/*  */


function createMatcher (
  routes,
  router
) {
  var ref = createRouteMap(routes);
  var pathList = ref.pathList;
  var pathMap = ref.pathMap;
  var nameMap = ref.nameMap;

  function addRoutes (routes) {
    createRouteMap(routes, pathList, pathMap, nameMap);
  }

  function match (
    raw,
    currentRoute,
    redirectedFrom
  ) {
    var location = normalizeLocation(raw, currentRoute, false, router);
    var name = location.name;

    if (name) {
      var record = nameMap[name];
      if (false) {
        warn(record, ("Route with name '" + name + "' does not exist"));
      }
      if (!record) { return _createRoute(null, location) }
      var paramNames = record.regex.keys
        .filter(function (key) { return !key.optional; })
        .map(function (key) { return key.name; });

      if (typeof location.params !== 'object') {
        location.params = {};
      }

      if (currentRoute && typeof currentRoute.params === 'object') {
        for (var key in currentRoute.params) {
          if (!(key in location.params) && paramNames.indexOf(key) > -1) {
            location.params[key] = currentRoute.params[key];
          }
        }
      }

      if (record) {
        location.path = fillParams(record.path, location.params, ("named route \"" + name + "\""));
        return _createRoute(record, location, redirectedFrom)
      }
    } else if (location.path) {
      location.params = {};
      for (var i = 0; i < pathList.length; i++) {
        var path = pathList[i];
        var record$1 = pathMap[path];
        if (matchRoute(record$1.regex, location.path, location.params)) {
          return _createRoute(record$1, location, redirectedFrom)
        }
      }
    }
    // no match
    return _createRoute(null, location)
  }

  function redirect (
    record,
    location
  ) {
    var originalRedirect = record.redirect;
    var redirect = typeof originalRedirect === 'function'
        ? originalRedirect(createRoute(record, location, null, router))
        : originalRedirect;

    if (typeof redirect === 'string') {
      redirect = { path: redirect };
    }

    if (!redirect || typeof redirect !== 'object') {
      if (false) {
        warn(
          false, ("invalid redirect option: " + (JSON.stringify(redirect)))
        );
      }
      return _createRoute(null, location)
    }

    var re = redirect;
    var name = re.name;
    var path = re.path;
    var query = location.query;
    var hash = location.hash;
    var params = location.params;
    query = re.hasOwnProperty('query') ? re.query : query;
    hash = re.hasOwnProperty('hash') ? re.hash : hash;
    params = re.hasOwnProperty('params') ? re.params : params;

    if (name) {
      // resolved named direct
      var targetRecord = nameMap[name];
      if (false) {
        assert(targetRecord, ("redirect failed: named route \"" + name + "\" not found."));
      }
      return match({
        _normalized: true,
        name: name,
        query: query,
        hash: hash,
        params: params
      }, undefined, location)
    } else if (path) {
      // 1. resolve relative redirect
      var rawPath = resolveRecordPath(path, record);
      // 2. resolve params
      var resolvedPath = fillParams(rawPath, params, ("redirect route with path \"" + rawPath + "\""));
      // 3. rematch with existing query and hash
      return match({
        _normalized: true,
        path: resolvedPath,
        query: query,
        hash: hash
      }, undefined, location)
    } else {
      if (false) {
        warn(false, ("invalid redirect option: " + (JSON.stringify(redirect))));
      }
      return _createRoute(null, location)
    }
  }

  function alias (
    record,
    location,
    matchAs
  ) {
    var aliasedPath = fillParams(matchAs, location.params, ("aliased route with path \"" + matchAs + "\""));
    var aliasedMatch = match({
      _normalized: true,
      path: aliasedPath
    });
    if (aliasedMatch) {
      var matched = aliasedMatch.matched;
      var aliasedRecord = matched[matched.length - 1];
      location.params = aliasedMatch.params;
      return _createRoute(aliasedRecord, location)
    }
    return _createRoute(null, location)
  }

  function _createRoute (
    record,
    location,
    redirectedFrom
  ) {
    if (record && record.redirect) {
      return redirect(record, redirectedFrom || location)
    }
    if (record && record.matchAs) {
      return alias(record, location, record.matchAs)
    }
    return createRoute(record, location, redirectedFrom, router)
  }

  return {
    match: match,
    addRoutes: addRoutes
  }
}

function matchRoute (
  regex,
  path,
  params
) {
  var m = path.match(regex);

  if (!m) {
    return false
  } else if (!params) {
    return true
  }

  for (var i = 1, len = m.length; i < len; ++i) {
    var key = regex.keys[i - 1];
    var val = typeof m[i] === 'string' ? decodeURIComponent(m[i]) : m[i];
    if (key) {
      params[key.name] = val;
    }
  }

  return true
}

function resolveRecordPath (path, record) {
  return resolvePath(path, record.parent ? record.parent.path : '/', true)
}

/*  */


var positionStore = Object.create(null);

function setupScroll () {
  // Fix for #1585 for Firefox
  window.history.replaceState({ key: getStateKey() }, '');
  window.addEventListener('popstate', function (e) {
    saveScrollPosition();
    if (e.state && e.state.key) {
      setStateKey(e.state.key);
    }
  });
}

function handleScroll (
  router,
  to,
  from,
  isPop
) {
  if (!router.app) {
    return
  }

  var behavior = router.options.scrollBehavior;
  if (!behavior) {
    return
  }

  if (false) {
    assert(typeof behavior === 'function', "scrollBehavior must be a function");
  }

  // wait until re-render finishes before scrolling
  router.app.$nextTick(function () {
    var position = getScrollPosition();
    var shouldScroll = behavior(to, from, isPop ? position : null);

    if (!shouldScroll) {
      return
    }

    if (typeof shouldScroll.then === 'function') {
      shouldScroll.then(function (shouldScroll) {
        scrollToPosition((shouldScroll), position);
      }).catch(function (err) {
        if (false) {
          assert(false, err.toString());
        }
      });
    } else {
      scrollToPosition(shouldScroll, position);
    }
  });
}

function saveScrollPosition () {
  var key = getStateKey();
  if (key) {
    positionStore[key] = {
      x: window.pageXOffset,
      y: window.pageYOffset
    };
  }
}

function getScrollPosition () {
  var key = getStateKey();
  if (key) {
    return positionStore[key]
  }
}

function getElementPosition (el, offset) {
  var docEl = document.documentElement;
  var docRect = docEl.getBoundingClientRect();
  var elRect = el.getBoundingClientRect();
  return {
    x: elRect.left - docRect.left - offset.x,
    y: elRect.top - docRect.top - offset.y
  }
}

function isValidPosition (obj) {
  return isNumber(obj.x) || isNumber(obj.y)
}

function normalizePosition (obj) {
  return {
    x: isNumber(obj.x) ? obj.x : window.pageXOffset,
    y: isNumber(obj.y) ? obj.y : window.pageYOffset
  }
}

function normalizeOffset (obj) {
  return {
    x: isNumber(obj.x) ? obj.x : 0,
    y: isNumber(obj.y) ? obj.y : 0
  }
}

function isNumber (v) {
  return typeof v === 'number'
}

function scrollToPosition (shouldScroll, position) {
  var isObject = typeof shouldScroll === 'object';
  if (isObject && typeof shouldScroll.selector === 'string') {
    var el = document.querySelector(shouldScroll.selector);
    if (el) {
      var offset = shouldScroll.offset && typeof shouldScroll.offset === 'object' ? shouldScroll.offset : {};
      offset = normalizeOffset(offset);
      position = getElementPosition(el, offset);
    } else if (isValidPosition(shouldScroll)) {
      position = normalizePosition(shouldScroll);
    }
  } else if (isObject && isValidPosition(shouldScroll)) {
    position = normalizePosition(shouldScroll);
  }

  if (position) {
    window.scrollTo(position.x, position.y);
  }
}

/*  */

var supportsPushState = inBrowser && (function () {
  var ua = window.navigator.userAgent;

  if (
    (ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) &&
    ua.indexOf('Mobile Safari') !== -1 &&
    ua.indexOf('Chrome') === -1 &&
    ua.indexOf('Windows Phone') === -1
  ) {
    return false
  }

  return window.history && 'pushState' in window.history
})();

// use User Timing api (if present) for more accurate key precision
var Time = inBrowser && window.performance && window.performance.now
  ? window.performance
  : Date;

var _key = genKey();

function genKey () {
  return Time.now().toFixed(3)
}

function getStateKey () {
  return _key
}

function setStateKey (key) {
  _key = key;
}

function pushState (url, replace) {
  saveScrollPosition();
  // try...catch the pushState call to get around Safari
  // DOM Exception 18 where it limits to 100 pushState calls
  var history = window.history;
  try {
    if (replace) {
      history.replaceState({ key: _key }, '', url);
    } else {
      _key = genKey();
      history.pushState({ key: _key }, '', url);
    }
  } catch (e) {
    window.location[replace ? 'replace' : 'assign'](url);
  }
}

function replaceState (url) {
  pushState(url, true);
}

/*  */

function runQueue (queue, fn, cb) {
  var step = function (index) {
    if (index >= queue.length) {
      cb();
    } else {
      if (queue[index]) {
        fn(queue[index], function () {
          step(index + 1);
        });
      } else {
        step(index + 1);
      }
    }
  };
  step(0);
}

/*  */

function resolveAsyncComponents (matched) {
  return function (to, from, next) {
    var hasAsync = false;
    var pending = 0;
    var error = null;

    flatMapComponents(matched, function (def, _, match, key) {
      // if it's a function and doesn't have cid attached,
      // assume it's an async component resolve function.
      // we are not using Vue's default async resolving mechanism because
      // we want to halt the navigation until the incoming component has been
      // resolved.
      if (typeof def === 'function' && def.cid === undefined) {
        hasAsync = true;
        pending++;

        var resolve = once(function (resolvedDef) {
          if (isESModule(resolvedDef)) {
            resolvedDef = resolvedDef.default;
          }
          // save resolved on async factory in case it's used elsewhere
          def.resolved = typeof resolvedDef === 'function'
            ? resolvedDef
            : _Vue.extend(resolvedDef);
          match.components[key] = resolvedDef;
          pending--;
          if (pending <= 0) {
            next();
          }
        });

        var reject = once(function (reason) {
          var msg = "Failed to resolve async component " + key + ": " + reason;
          "production" !== 'production' && warn(false, msg);
          if (!error) {
            error = isError(reason)
              ? reason
              : new Error(msg);
            next(error);
          }
        });

        var res;
        try {
          res = def(resolve, reject);
        } catch (e) {
          reject(e);
        }
        if (res) {
          if (typeof res.then === 'function') {
            res.then(resolve, reject);
          } else {
            // new syntax in Vue 2.3
            var comp = res.component;
            if (comp && typeof comp.then === 'function') {
              comp.then(resolve, reject);
            }
          }
        }
      }
    });

    if (!hasAsync) { next(); }
  }
}

function flatMapComponents (
  matched,
  fn
) {
  return flatten(matched.map(function (m) {
    return Object.keys(m.components).map(function (key) { return fn(
      m.components[key],
      m.instances[key],
      m, key
    ); })
  }))
}

function flatten (arr) {
  return Array.prototype.concat.apply([], arr)
}

var hasSymbol =
  typeof Symbol === 'function' &&
  typeof Symbol.toStringTag === 'symbol';

function isESModule (obj) {
  return obj.__esModule || (hasSymbol && obj[Symbol.toStringTag] === 'Module')
}

// in Webpack 2, require.ensure now also returns a Promise
// so the resolve/reject functions may get called an extra time
// if the user uses an arrow function shorthand that happens to
// return that Promise.
function once (fn) {
  var called = false;
  return function () {
    var args = [], len = arguments.length;
    while ( len-- ) args[ len ] = arguments[ len ];

    if (called) { return }
    called = true;
    return fn.apply(this, args)
  }
}

/*  */

var History = function History (router, base) {
  this.router = router;
  this.base = normalizeBase(base);
  // start with a route object that stands for "nowhere"
  this.current = START;
  this.pending = null;
  this.ready = false;
  this.readyCbs = [];
  this.readyErrorCbs = [];
  this.errorCbs = [];
};

History.prototype.listen = function listen (cb) {
  this.cb = cb;
};

History.prototype.onReady = function onReady (cb, errorCb) {
  if (this.ready) {
    cb();
  } else {
    this.readyCbs.push(cb);
    if (errorCb) {
      this.readyErrorCbs.push(errorCb);
    }
  }
};

History.prototype.onError = function onError (errorCb) {
  this.errorCbs.push(errorCb);
};

History.prototype.transitionTo = function transitionTo (location, onComplete, onAbort) {
    var this$1 = this;

  var route = this.router.match(location, this.current);
  this.confirmTransition(route, function () {
    this$1.updateRoute(route);
    onComplete && onComplete(route);
    this$1.ensureURL();

    // fire ready cbs once
    if (!this$1.ready) {
      this$1.ready = true;
      this$1.readyCbs.forEach(function (cb) { cb(route); });
    }
  }, function (err) {
    if (onAbort) {
      onAbort(err);
    }
    if (err && !this$1.ready) {
      this$1.ready = true;
      this$1.readyErrorCbs.forEach(function (cb) { cb(err); });
    }
  });
};

History.prototype.confirmTransition = function confirmTransition (route, onComplete, onAbort) {
    var this$1 = this;

  var current = this.current;
  var abort = function (err) {
    if (isError(err)) {
      if (this$1.errorCbs.length) {
        this$1.errorCbs.forEach(function (cb) { cb(err); });
      } else {
        warn(false, 'uncaught error during route navigation:');
        console.error(err);
      }
    }
    onAbort && onAbort(err);
  };
  if (
    isSameRoute(route, current) &&
    // in the case the route map has been dynamically appended to
    route.matched.length === current.matched.length
  ) {
    this.ensureURL();
    return abort()
  }

  var ref = resolveQueue(this.current.matched, route.matched);
    var updated = ref.updated;
    var deactivated = ref.deactivated;
    var activated = ref.activated;

  var queue = [].concat(
    // in-component leave guards
    extractLeaveGuards(deactivated),
    // global before hooks
    this.router.beforeHooks,
    // in-component update hooks
    extractUpdateHooks(updated),
    // in-config enter guards
    activated.map(function (m) { return m.beforeEnter; }),
    // async components
    resolveAsyncComponents(activated)
  );

  this.pending = route;
  var iterator = function (hook, next) {
    if (this$1.pending !== route) {
      return abort()
    }
    try {
      hook(route, current, function (to) {
        if (to === false || isError(to)) {
          // next(false) -> abort navigation, ensure current URL
          this$1.ensureURL(true);
          abort(to);
        } else if (
          typeof to === 'string' ||
          (typeof to === 'object' && (
            typeof to.path === 'string' ||
            typeof to.name === 'string'
          ))
        ) {
          // next('/') or next({ path: '/' }) -> redirect
          abort();
          if (typeof to === 'object' && to.replace) {
            this$1.replace(to);
          } else {
            this$1.push(to);
          }
        } else {
          // confirm transition and pass on the value
          next(to);
        }
      });
    } catch (e) {
      abort(e);
    }
  };

  runQueue(queue, iterator, function () {
    var postEnterCbs = [];
    var isValid = function () { return this$1.current === route; };
    // wait until async components are resolved before
    // extracting in-component enter guards
    var enterGuards = extractEnterGuards(activated, postEnterCbs, isValid);
    var queue = enterGuards.concat(this$1.router.resolveHooks);
    runQueue(queue, iterator, function () {
      if (this$1.pending !== route) {
        return abort()
      }
      this$1.pending = null;
      onComplete(route);
      if (this$1.router.app) {
        this$1.router.app.$nextTick(function () {
          postEnterCbs.forEach(function (cb) { cb(); });
        });
      }
    });
  });
};

History.prototype.updateRoute = function updateRoute (route) {
  var prev = this.current;
  this.current = route;
  this.cb && this.cb(route);
  this.router.afterHooks.forEach(function (hook) {
    hook && hook(route, prev);
  });
};

function normalizeBase (base) {
  if (!base) {
    if (inBrowser) {
      // respect <base> tag
      var baseEl = document.querySelector('base');
      base = (baseEl && baseEl.getAttribute('href')) || '/';
      // strip full URL origin
      base = base.replace(/^https?:\/\/[^\/]+/, '');
    } else {
      base = '/';
    }
  }
  // make sure there's the starting slash
  if (base.charAt(0) !== '/') {
    base = '/' + base;
  }
  // remove trailing slash
  return base.replace(/\/$/, '')
}

function resolveQueue (
  current,
  next
) {
  var i;
  var max = Math.max(current.length, next.length);
  for (i = 0; i < max; i++) {
    if (current[i] !== next[i]) {
      break
    }
  }
  return {
    updated: next.slice(0, i),
    activated: next.slice(i),
    deactivated: current.slice(i)
  }
}

function extractGuards (
  records,
  name,
  bind,
  reverse
) {
  var guards = flatMapComponents(records, function (def, instance, match, key) {
    var guard = extractGuard(def, name);
    if (guard) {
      return Array.isArray(guard)
        ? guard.map(function (guard) { return bind(guard, instance, match, key); })
        : bind(guard, instance, match, key)
    }
  });
  return flatten(reverse ? guards.reverse() : guards)
}

function extractGuard (
  def,
  key
) {
  if (typeof def !== 'function') {
    // extend now so that global mixins are applied.
    def = _Vue.extend(def);
  }
  return def.options[key]
}

function extractLeaveGuards (deactivated) {
  return extractGuards(deactivated, 'beforeRouteLeave', bindGuard, true)
}

function extractUpdateHooks (updated) {
  return extractGuards(updated, 'beforeRouteUpdate', bindGuard)
}

function bindGuard (guard, instance) {
  if (instance) {
    return function boundRouteGuard () {
      return guard.apply(instance, arguments)
    }
  }
}

function extractEnterGuards (
  activated,
  cbs,
  isValid
) {
  return extractGuards(activated, 'beforeRouteEnter', function (guard, _, match, key) {
    return bindEnterGuard(guard, match, key, cbs, isValid)
  })
}

function bindEnterGuard (
  guard,
  match,
  key,
  cbs,
  isValid
) {
  return function routeEnterGuard (to, from, next) {
    return guard(to, from, function (cb) {
      next(cb);
      if (typeof cb === 'function') {
        cbs.push(function () {
          // #750
          // if a router-view is wrapped with an out-in transition,
          // the instance may not have been registered at this time.
          // we will need to poll for registration until current route
          // is no longer valid.
          poll(cb, match.instances, key, isValid);
        });
      }
    })
  }
}

function poll (
  cb, // somehow flow cannot infer this is a function
  instances,
  key,
  isValid
) {
  if (instances[key]) {
    cb(instances[key]);
  } else if (isValid()) {
    setTimeout(function () {
      poll(cb, instances, key, isValid);
    }, 16);
  }
}

/*  */


var HTML5History = (function (History$$1) {
  function HTML5History (router, base) {
    var this$1 = this;

    History$$1.call(this, router, base);

    var expectScroll = router.options.scrollBehavior;

    if (expectScroll) {
      setupScroll();
    }

    var initLocation = getLocation(this.base);
    window.addEventListener('popstate', function (e) {
      var current = this$1.current;

      // Avoiding first `popstate` event dispatched in some browsers but first
      // history route not updated since async guard at the same time.
      var location = getLocation(this$1.base);
      if (this$1.current === START && location === initLocation) {
        return
      }

      this$1.transitionTo(location, function (route) {
        if (expectScroll) {
          handleScroll(router, route, current, true);
        }
      });
    });
  }

  if ( History$$1 ) HTML5History.__proto__ = History$$1;
  HTML5History.prototype = Object.create( History$$1 && History$$1.prototype );
  HTML5History.prototype.constructor = HTML5History;

  HTML5History.prototype.go = function go (n) {
    window.history.go(n);
  };

  HTML5History.prototype.push = function push (location, onComplete, onAbort) {
    var this$1 = this;

    var ref = this;
    var fromRoute = ref.current;
    this.transitionTo(location, function (route) {
      pushState(cleanPath(this$1.base + route.fullPath));
      handleScroll(this$1.router, route, fromRoute, false);
      onComplete && onComplete(route);
    }, onAbort);
  };

  HTML5History.prototype.replace = function replace (location, onComplete, onAbort) {
    var this$1 = this;

    var ref = this;
    var fromRoute = ref.current;
    this.transitionTo(location, function (route) {
      replaceState(cleanPath(this$1.base + route.fullPath));
      handleScroll(this$1.router, route, fromRoute, false);
      onComplete && onComplete(route);
    }, onAbort);
  };

  HTML5History.prototype.ensureURL = function ensureURL (push) {
    if (getLocation(this.base) !== this.current.fullPath) {
      var current = cleanPath(this.base + this.current.fullPath);
      push ? pushState(current) : replaceState(current);
    }
  };

  HTML5History.prototype.getCurrentLocation = function getCurrentLocation () {
    return getLocation(this.base)
  };

  return HTML5History;
}(History));

function getLocation (base) {
  var path = window.location.pathname;
  if (base && path.indexOf(base) === 0) {
    path = path.slice(base.length);
  }
  return (path || '/') + window.location.search + window.location.hash
}

/*  */


var HashHistory = (function (History$$1) {
  function HashHistory (router, base, fallback) {
    History$$1.call(this, router, base);
    // check history fallback deeplinking
    if (fallback && checkFallback(this.base)) {
      return
    }
    ensureSlash();
  }

  if ( History$$1 ) HashHistory.__proto__ = History$$1;
  HashHistory.prototype = Object.create( History$$1 && History$$1.prototype );
  HashHistory.prototype.constructor = HashHistory;

  // this is delayed until the app mounts
  // to avoid the hashchange listener being fired too early
  HashHistory.prototype.setupListeners = function setupListeners () {
    var this$1 = this;

    var router = this.router;
    var expectScroll = router.options.scrollBehavior;
    var supportsScroll = supportsPushState && expectScroll;

    if (supportsScroll) {
      setupScroll();
    }

    window.addEventListener(supportsPushState ? 'popstate' : 'hashchange', function () {
      var current = this$1.current;
      if (!ensureSlash()) {
        return
      }
      this$1.transitionTo(getHash(), function (route) {
        if (supportsScroll) {
          handleScroll(this$1.router, route, current, true);
        }
        if (!supportsPushState) {
          replaceHash(route.fullPath);
        }
      });
    });
  };

  HashHistory.prototype.push = function push (location, onComplete, onAbort) {
    var this$1 = this;

    var ref = this;
    var fromRoute = ref.current;
    this.transitionTo(location, function (route) {
      pushHash(route.fullPath);
      handleScroll(this$1.router, route, fromRoute, false);
      onComplete && onComplete(route);
    }, onAbort);
  };

  HashHistory.prototype.replace = function replace (location, onComplete, onAbort) {
    var this$1 = this;

    var ref = this;
    var fromRoute = ref.current;
    this.transitionTo(location, function (route) {
      replaceHash(route.fullPath);
      handleScroll(this$1.router, route, fromRoute, false);
      onComplete && onComplete(route);
    }, onAbort);
  };

  HashHistory.prototype.go = function go (n) {
    window.history.go(n);
  };

  HashHistory.prototype.ensureURL = function ensureURL (push) {
    var current = this.current.fullPath;
    if (getHash() !== current) {
      push ? pushHash(current) : replaceHash(current);
    }
  };

  HashHistory.prototype.getCurrentLocation = function getCurrentLocation () {
    return getHash()
  };

  return HashHistory;
}(History));

function checkFallback (base) {
  var location = getLocation(base);
  if (!/^\/#/.test(location)) {
    window.location.replace(
      cleanPath(base + '/#' + location)
    );
    return true
  }
}

function ensureSlash () {
  var path = getHash();
  if (path.charAt(0) === '/') {
    return true
  }
  replaceHash('/' + path);
  return false
}

function getHash () {
  // We can't use window.location.hash here because it's not
  // consistent across browsers - Firefox will pre-decode it!
  var href = window.location.href;
  var index = href.indexOf('#');
  return index === -1 ? '' : href.slice(index + 1)
}

function getUrl (path) {
  var href = window.location.href;
  var i = href.indexOf('#');
  var base = i >= 0 ? href.slice(0, i) : href;
  return (base + "#" + path)
}

function pushHash (path) {
  if (supportsPushState) {
    pushState(getUrl(path));
  } else {
    window.location.hash = path;
  }
}

function replaceHash (path) {
  if (supportsPushState) {
    replaceState(getUrl(path));
  } else {
    window.location.replace(getUrl(path));
  }
}

/*  */


var AbstractHistory = (function (History$$1) {
  function AbstractHistory (router, base) {
    History$$1.call(this, router, base);
    this.stack = [];
    this.index = -1;
  }

  if ( History$$1 ) AbstractHistory.__proto__ = History$$1;
  AbstractHistory.prototype = Object.create( History$$1 && History$$1.prototype );
  AbstractHistory.prototype.constructor = AbstractHistory;

  AbstractHistory.prototype.push = function push (location, onComplete, onAbort) {
    var this$1 = this;

    this.transitionTo(location, function (route) {
      this$1.stack = this$1.stack.slice(0, this$1.index + 1).concat(route);
      this$1.index++;
      onComplete && onComplete(route);
    }, onAbort);
  };

  AbstractHistory.prototype.replace = function replace (location, onComplete, onAbort) {
    var this$1 = this;

    this.transitionTo(location, function (route) {
      this$1.stack = this$1.stack.slice(0, this$1.index).concat(route);
      onComplete && onComplete(route);
    }, onAbort);
  };

  AbstractHistory.prototype.go = function go (n) {
    var this$1 = this;

    var targetIndex = this.index + n;
    if (targetIndex < 0 || targetIndex >= this.stack.length) {
      return
    }
    var route = this.stack[targetIndex];
    this.confirmTransition(route, function () {
      this$1.index = targetIndex;
      this$1.updateRoute(route);
    });
  };

  AbstractHistory.prototype.getCurrentLocation = function getCurrentLocation () {
    var current = this.stack[this.stack.length - 1];
    return current ? current.fullPath : '/'
  };

  AbstractHistory.prototype.ensureURL = function ensureURL () {
    // noop
  };

  return AbstractHistory;
}(History));

/*  */

var VueRouter = function VueRouter (options) {
  if ( options === void 0 ) options = {};

  this.app = null;
  this.apps = [];
  this.options = options;
  this.beforeHooks = [];
  this.resolveHooks = [];
  this.afterHooks = [];
  this.matcher = createMatcher(options.routes || [], this);

  var mode = options.mode || 'hash';
  this.fallback = mode === 'history' && !supportsPushState && options.fallback !== false;
  if (this.fallback) {
    mode = 'hash';
  }
  if (!inBrowser) {
    mode = 'abstract';
  }
  this.mode = mode;

  switch (mode) {
    case 'history':
      this.history = new HTML5History(this, options.base);
      break
    case 'hash':
      this.history = new HashHistory(this, options.base, this.fallback);
      break
    case 'abstract':
      this.history = new AbstractHistory(this, options.base);
      break
    default:
      if (false) {
        assert(false, ("invalid mode: " + mode));
      }
  }
};

var prototypeAccessors = { currentRoute: { configurable: true } };

VueRouter.prototype.match = function match (
  raw,
  current,
  redirectedFrom
) {
  return this.matcher.match(raw, current, redirectedFrom)
};

prototypeAccessors.currentRoute.get = function () {
  return this.history && this.history.current
};

VueRouter.prototype.init = function init (app /* Vue component instance */) {
    var this$1 = this;

  "production" !== 'production' && assert(
    install.installed,
    "not installed. Make sure to call `Vue.use(VueRouter)` " +
    "before creating root instance."
  );

  this.apps.push(app);

  // main app already initialized.
  if (this.app) {
    return
  }

  this.app = app;

  var history = this.history;

  if (history instanceof HTML5History) {
    history.transitionTo(history.getCurrentLocation());
  } else if (history instanceof HashHistory) {
    var setupHashListener = function () {
      history.setupListeners();
    };
    history.transitionTo(
      history.getCurrentLocation(),
      setupHashListener,
      setupHashListener
    );
  }

  history.listen(function (route) {
    this$1.apps.forEach(function (app) {
      app._route = route;
    });
  });
};

VueRouter.prototype.beforeEach = function beforeEach (fn) {
  return registerHook(this.beforeHooks, fn)
};

VueRouter.prototype.beforeResolve = function beforeResolve (fn) {
  return registerHook(this.resolveHooks, fn)
};

VueRouter.prototype.afterEach = function afterEach (fn) {
  return registerHook(this.afterHooks, fn)
};

VueRouter.prototype.onReady = function onReady (cb, errorCb) {
  this.history.onReady(cb, errorCb);
};

VueRouter.prototype.onError = function onError (errorCb) {
  this.history.onError(errorCb);
};

VueRouter.prototype.push = function push (location, onComplete, onAbort) {
  this.history.push(location, onComplete, onAbort);
};

VueRouter.prototype.replace = function replace (location, onComplete, onAbort) {
  this.history.replace(location, onComplete, onAbort);
};

VueRouter.prototype.go = function go (n) {
  this.history.go(n);
};

VueRouter.prototype.back = function back () {
  this.go(-1);
};

VueRouter.prototype.forward = function forward () {
  this.go(1);
};

VueRouter.prototype.getMatchedComponents = function getMatchedComponents (to) {
  var route = to
    ? to.matched
      ? to
      : this.resolve(to).route
    : this.currentRoute;
  if (!route) {
    return []
  }
  return [].concat.apply([], route.matched.map(function (m) {
    return Object.keys(m.components).map(function (key) {
      return m.components[key]
    })
  }))
};

VueRouter.prototype.resolve = function resolve (
  to,
  current,
  append
) {
  var location = normalizeLocation(
    to,
    current || this.history.current,
    append,
    this
  );
  var route = this.match(location, current);
  var fullPath = route.redirectedFrom || route.fullPath;
  var base = this.history.base;
  var href = createHref(base, fullPath, this.mode);
  return {
    location: location,
    route: route,
    href: href,
    // for backwards compat
    normalizedTo: location,
    resolved: route
  }
};

VueRouter.prototype.addRoutes = function addRoutes (routes) {
  this.matcher.addRoutes(routes);
  if (this.history.current !== START) {
    this.history.transitionTo(this.history.getCurrentLocation());
  }
};

Object.defineProperties( VueRouter.prototype, prototypeAccessors );

function registerHook (list, fn) {
  list.push(fn);
  return function () {
    var i = list.indexOf(fn);
    if (i > -1) { list.splice(i, 1); }
  }
}

function createHref (base, fullPath, mode) {
  var path = mode === 'hash' ? '#' + fullPath : fullPath;
  return base ? cleanPath(base + '/' + path) : path
}

VueRouter.install = install;
VueRouter.version = '2.8.1';

if (inBrowser && window.Vue) {
  window.Vue.use(VueRouter);
}

/* harmony default export */ __webpack_exports__["a"] = (VueRouter);


/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(50),
  /* template */
  __webpack_require__(51),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 50 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import Navigation from '@/components/Navigation'
/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'home',
  data: function data() {
    return {};
  },

  components: {
    // 'navigation': Navigation
  }
});

/***/ }),
/* 51 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Stephen Birmingham\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Stephen Birmingham (1929–2015) was an American author of more than thirty books. Born in Hartford, Connecticut, he graduated from Williams College in 1953 and taught writing at the University of Cincinnati. Birmingham’s work focuses on the upper class in America. He’s written about the African American elite in "), _c('I', [_vm._v("Certain People")]), _vm._v(" and prominent Jewish society in "), _c('I', [_vm._v("Our Crowd: The Great Jewish Families of New York")]), _vm._v(", "), _c('I', [_vm._v("The Grandees: The Story of America’s Sephardic Elite")]), _vm._v(", and "), _c('I', [_vm._v("The Rest of Us: The Rise of America’s Eastern European Jews")]), _vm._v(". His work also encompasses several novels including"), _c('I', [_vm._v(" The Auerbach Will")]), _vm._v(", "), _c('I', [_vm._v("The LeBaron Secret")]), _vm._v(", "), _c('I', [_vm._v("Shades of Fortune")]), _vm._v(", and "), _c('I', [_vm._v("The Rothman Scandal")]), _vm._v(", and other non-fiction titles such as "), _c('I', [_vm._v("California Rich")]), _vm._v(", "), _c('I', [_vm._v("The Grandes Dames")]), _vm._v(", and "), _c('I', [_vm._v("Life at the Dakota: New York’s Most Unusual Address")]), _vm._v(".")], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/7Zm0kx/tc-custom/9781504047999.jpg?1734266445367",
      "alt": "This image is the cover for the book Novels of Stephen Birmingham"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Novels of Stephen Birmingham\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("A quartet of novels from the "), _c('i', [_vm._v("New York Times")]), _vm._v("–bestselling author of “"), _c('i', [_vm._v("Our Crowd")]), _vm._v("” and master chronicler of Manhattan’s rich, famous, and deceitful.")]), _c('br'), _c('br'), _vm._v(" These four gripping novels prove that “when it comes to the folkways of the rich, the powerful, and the privileged, Stephen Birmingham knows what he’s talking about” ("), _c('i', [_vm._v("Los Angeles Times")]), _vm._v(")."), _c('br'), _vm._v(" "), _c('br'), _c('i', [_vm._v("Carriage Trade")]), _vm._v(": One of New York’s most elegant and exclusive retail establishments, Tarkington’s has been the preferred shopping experience of Manhattan’s elite for decades. But the unexpected death of founder Silas Tarkington raises serious doubts about the future of the enterprise. At the reading of his will, disturbing questions arise about the tycoon’s past, and suggestions of a dark, secret life threaten to tear the family apart. The truth could destroy much more than the family business—especially as it becomes more and more likely that Silas’s death was no accident. “[A] page turner . . . [that] offers a little bit of the best of everything” ("), _c('i', [_vm._v("The New York Times")]), _vm._v(")."), _c('br'), _vm._v(" "), _c('br'), _c('i', [_vm._v("The Wrong Kind of Money")]), _vm._v(": The Liebling family is among the wealthiest in New York, but in the eyes of “old money” gentile aristocrats like the patrician Van Degans, they will always be lower-class Jewish "), _c('i', [_vm._v("nouveau riche")]), _vm._v(". Jules Liebling got his start selling liquor during Prohibition while in cahoots with dangerous mobsters, and his widow, Hannah, now runs the family business with a tyrannical hand. But when her daughter-in-law meets Georgette Van Degan for lunch at Le Cirque, gossip circulates about a thaw between the families and, quite possibly, a partnership. As rumors fly in this “fast and wonderful” novel that has “something for everyone,” family skeletons on both sides are exposed, leading to jealousy, betrayal, and even violence ("), _c('i', [_vm._v("Cincinnati Enquirer")]), _vm._v(")."), _c('br'), _vm._v(" "), _c('br'), _c('i', [_vm._v("The Auerbach Will")]), _vm._v(": The daughter of poor immigrant Russian-Jewish parents on the Lower East Side, Essie Litsky married Jack Auerbach, and together, they rose from poverty and amassed a fortune that dwarfed their wildest dreams. But money could never buy the affection of family or compensate for the true love Essie let slip away. And now, as she nears the end of her life, she must contend with blackmail and heartless legal assaults coming at her from all sides—the result of the ugly, persistent greed of her own children and grandchildren. But Essie is not dead yet, and those who underestimate the remarkable old woman are in for a shocking and powerful surprise. This "), _c('i', [_vm._v("New York Times ")]), _vm._v("bestseller is full of “delicious secrets” drawn from the “gossipy, Uptown/Downtown milieu Birmingham knows so well” ("), _c('i', [_vm._v("Kirkus Reviews")]), _vm._v(")."), _c('br'), _vm._v(" "), _c('br'), _c('i', [_vm._v("Shades of Fortune")]), _vm._v(": Mireille “Mimi” Myerson took her grandfather’s struggling cosmetics company and turned it into an empire. But suddenly, as she prepares to launch a new perfume line, she is faced with hidden threats at every turn. Her efforts to further expand the company could be sabotaged from within by her own treacherous family. With the discovery of her husband’s affair and the return of real estate magnate Michael Horowitz, her first and most enduring love, Mimi must determine whom she can trust—especially in light of the shocking revelations that are about to emerge regarding the birth of the Miray Corporation.\n    ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Open Road Integrated Media\n   ")])])
}]}

/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(53),
  /* template */
  __webpack_require__(54),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 53 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 54 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [
    [_c('div', {
      staticClass: "chapter"
    }, [_c('div', {
      staticClass: "inner_page"
    }, [
      [_vm._m(0)]
    ], 2)])]
  ], 2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(56),
  /* template */
  __webpack_require__(57),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 56 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 57 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [
    [_c('div', {
      staticClass: "chapter"
    }, [_c('div', {
      staticClass: "inner_page"
    }, [
      [_vm._m(0)]
    ], 2)])]
  ], 2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(59),
  /* template */
  __webpack_require__(60),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 59 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 60 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [
    [_c('div', {
      staticClass: "chapter"
    }, [_c('div', {
      staticClass: "inner_page"
    }, [
      [_vm._m(0)]
    ], 2)])]
  ], 2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(62),
  /* template */
  __webpack_require__(63),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 62 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 63 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [
    [_c('div', {
      staticClass: "chapter"
    }, [_c('div', {
      staticClass: "inner_page"
    }, [
      [_vm._m(0)]
    ], 2)])]
  ], 2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(65),
  /* template */
  __webpack_require__(66),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 65 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 66 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [
    [_c('div', {
      staticClass: "chapter"
    }, [_c('div', {
      staticClass: "inner_page"
    }, [
      [_vm._m(0)]
    ], 2)])]
  ], 2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(68),
  /* template */
  __webpack_require__(69),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 68 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 69 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "toc-title"
  }, [_c('span', [_vm._v("CONTENTS")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text-A"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/xhtml/cover"
    }
  }, [_vm._v("Carriage Trade")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/xhtml/frontmatter02"
    }
  }, [_vm._v("Prologue")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/xhtml/part01"
    }
  }, [_vm._v("Part One: Miranda’s World")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/xhtml/chapter001"
    }
  }, [_vm._v("1")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/xhtml/chapter002"
    }
  }, [_vm._v("2")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/xhtml/chapter003"
    }
  }, [_vm._v("3")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/xhtml/chapter004"
    }
  }, [_vm._v("4")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/xhtml/chapter005"
    }
  }, [_vm._v("5")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/xhtml/chapter006"
    }
  }, [_vm._v("6")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/xhtml/chapter007"
    }
  }, [_vm._v("7")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/xhtml/chapter008"
    }
  }, [_vm._v("8")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/xhtml/chapter009"
    }
  }, [_vm._v("9")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/xhtml/chapter010"
    }
  }, [_vm._v("10")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter011",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter012",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter013",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/part02",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Part Two: Rose’s Children")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter014",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("14")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter015",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("15")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter016",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("16")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter017",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("17")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter018",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("18")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter019",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("19")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter020",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("20")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter021",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("21")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter022",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("22")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter023",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("23")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter024",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("24")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter025",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("25")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter026",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("26")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/part03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Part Three: Diana’s Dream")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter027",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("27")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter028",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("28")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter029",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("29")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter030",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("30")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter031",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("31")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/part04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Part Four: Consuelo’s Garden")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter032",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("32")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter033",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("33")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter034",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("34")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/endmatter01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Epilogue")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/endmatter02",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Acknowledgments")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text-A1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/cover",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Wrong Kind of Money")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/part01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Part One: River House, 1994")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter001",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1 Nine Lives")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter002",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2 An Intermezzo")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter003",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3 Placement")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter004",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4 A Telephone Call")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter005",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5 Bike")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter006",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6 Tables for Two")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter007",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7 “Uncovered Treasures”")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter008",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8 A Delicate Matter")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter009",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9 Choices")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter010",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10 Rumney Depot")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter011",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11 The Mill")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter012",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12 Brief Encounters")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/part02",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Part Two: Grandmont, 1945")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter013",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13 Deals")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter014",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("14 Lightning")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter015",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("15 Piss-assed Drunk")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter016",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("16 Morning")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter017",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("17 Noon")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter018",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("18 Hannah’s Way")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter019",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("19 Afternoon")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter020",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("20 Night")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/part03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Part Three: Grandmont, 1994")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter021",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("21 Some Final Words")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter022",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("22 1995")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text-A1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/cover",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Auerbach Will")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/part01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Book of Esther")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter001",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("One")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter002",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Two")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter003",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Three")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter004",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Four")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter005",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Five")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter006",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Six")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter007",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Seven")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/part02",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Ladder")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter008",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Eight")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter009",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Nine")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter010",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Ten")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter011",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Eleven")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter012",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Twelve")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter013",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Thirteen")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter014",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fourteen")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/part03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Our Father’s House")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter015",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fifteen")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter016",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sixteen")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter017",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Seventeen")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter018",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Eighteen")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter019",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Nineteen")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter020",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Twenty")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter021",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Twenty-one")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter022",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Twenty-two")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/part04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Book of Revelations")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter023",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Twenty-three")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter024",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Twenty-four")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter025",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Twenty-five")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter026",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Twenty-six")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter027",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Twenty-seven")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter028",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Twenty-eight")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/part05",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Epilogue")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/endmatter001",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("ESTHER L. AUERBACH: In Memoriam")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text-A1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book4/xhtml/cover",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Shades of Fortune")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('span', {
    attrs: {
      "href": "#/Book4/xhtml/part01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Part One: A Family Album")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('span', {
    attrs: {
      "href": "#/Book4/xhtml/chapter001",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('span', {
    attrs: {
      "href": "#/Book4/xhtml/chapter002",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('span', {
    attrs: {
      "href": "#/Book4/xhtml/chapter003",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('span', {
    attrs: {
      "href": "#/Book4/xhtml/chapter004",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('span', {
    attrs: {
      "href": "#/Book4/xhtml/part02",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Part Two: In The Beginning")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('span', {
    attrs: {
      "href": "#/Book4/xhtml/chapter005",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('span', {
    attrs: {
      "href": "#/Book4/xhtml/chapter006",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('span', {
    attrs: {
      "href": "#/Book4/xhtml/chapter007",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('span', {
    attrs: {
      "href": "#/Book4/xhtml/chapter008",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('span', {
    attrs: {
      "href": "#/Book4/xhtml/chapter009",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('span', {
    attrs: {
      "href": "#/Book4/xhtml/chapter010",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('span', {
    attrs: {
      "href": "#/Book4/xhtml/chapter011",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('span', {
    attrs: {
      "href": "#/Book4/xhtml/chapter012",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('span', {
    attrs: {
      "href": "#/Book4/xhtml/part03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Part Three: A House Divided")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('span', {
    attrs: {
      "href": "#/Book4/xhtml/chapter013",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('span', {
    attrs: {
      "href": "#/Book4/xhtml/chapter014",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("14")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('span', {
    attrs: {
      "href": "#/Book4/xhtml/chapter015",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("15")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('span', {
    attrs: {
      "href": "#/Book4/xhtml/chapter016",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("16")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('span', {
    attrs: {
      "href": "#/Book4/xhtml/chapter017",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("17")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('span', {
    attrs: {
      "href": "#/Book4/xhtml/chapter018",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("18")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('span', {
    attrs: {
      "href": "#/Book4/xhtml/chapter019",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("19")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('span', {
    attrs: {
      "href": "#/Book4/xhtml/chapter020",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("20")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('span', {
    attrs: {
      "href": "#/Book4/xhtml/chapter021",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("21")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('span', {
    attrs: {
      "href": "#/Book4/xhtml/chapter022",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("22")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('span', {
    attrs: {
      "href": "#/Book4/xhtml/chapter023",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("23")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('span', {
    attrs: {
      "href": "#/Book4/xhtml/chapter024",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("24")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('span', {
    attrs: {
      "href": "#/Book4/xhtml/part04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Part Four: A Homecoming")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('span', {
    attrs: {
      "href": "#/Book4/xhtml/chapter025",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("25")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('span', {
    attrs: {
      "href": "#/Book4/xhtml/chapter026",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("26")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('span', {
    attrs: {
      "href": "#/Book4/xhtml/chapter027",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("27")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('span', {
    attrs: {
      "href": "#/Book4/xhtml/chapter028",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("28")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('span', {
    attrs: {
      "href": "#/Book4/xhtml/chapter029",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("29")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('span', {
    attrs: {
      "href": "#/Book4/xhtml/chapter030",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("30")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('span', {
    attrs: {
      "href": "#/Book4/xhtml/chapter031",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("31")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('span', {
    attrs: {
      "href": "#/Book4/xhtml/endmatter01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("About the Author")])])])])
}]}

/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(71),
  /* template */
  __webpack_require__(72),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 71 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 72 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', [_c('img', {
    staticStyle: {
      "height": "100%",
      "text-align": "center"
    },
    attrs: {
      "alt": "image",
      "src": "Book1/images/MyCoverImage.jpg"
    }
  })])])])
}]}

/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(74),
  /* template */
  __webpack_require__(75),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 74 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 75 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "bk-title"
  }, [_c('span', [_vm._v("Carriage Trade")])]), _vm._v(" "), _c('p', {
    staticClass: "bk-title1"
  }, [_c('span', [_vm._v("A Novel")])])])])
}]}

/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(77),
  /* template */
  __webpack_require__(78),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 77 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 78 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "ded"
  }, [_c('span', [_vm._v("For Beverley Gasner")])]), _vm._v(" "), _c('p', {
    staticClass: "ded1"
  }, [_c('span', [_vm._v("And nobody but nobody else")])])])])
}]}

/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(80),
  /* template */
  __webpack_require__(81),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 80 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 81 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "chapter-h"
  }, [_c('span', [_c('i', [_vm._v("Prologue")])])]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_vm._v("From "), _c('i', [_vm._v("The New York Times")]), _vm._v(", August 12, 1991:")]), _vm._v(" "), _c('p', {
    staticClass: "section1"
  }, [_c('span', [_vm._v("SILAS TARKINGTON, LEGENDARY RETAILING TYCOON, IS DEAD")])]), _vm._v(" "), _c('p', {
    staticClass: "section2"
  }, [_c('span', [_vm._v("Founder, Head of Tarkington’s 5th Ave.")])]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_vm._v("“He was to retailing as Carnegie was to steel, Ford to automobiles, Luce to publishing and Ruth to baseball.” So said former New York City Mayor Edward Koch when notified of his old friend’s sudden death. “His death not only constitutes a deep personal loss,” the former mayor added, “it is a great loss to the City of New York and to the nation.” He was Silas Rogers Tarkington, legendary founder and chief executive officer of Tarkington’s, the famed Fifth Avenue specialty store that bears his name.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Death came to the tycoon on Saturday at his country estate, Flying Horse Farm, in Old Westbury, L.I., while swimming laps in his pool. When Mr. Tarkington failed to join his wife for lunch, she went to search for him in the pool area and found him floating face downward in the water. The family physician, Dr. Henry J. Arnstein, who flew immediately to the scene by private helicopter from his office in Manhattan, pronounced death by myocardial infarction resulting from coronary occlusion. Mr. Tarkington, a trim and athletic-looking man, though small in stature, had no previous history of heart illness. “But these things can catch up with a man without warning,” Dr. Arnstein said. “He’d obviously been pushing himself harder than any of us realized.”")]), _vm._v(" "), _c('p', {
    staticClass: "section3"
  }, [_c('span', [_c('i', [_vm._v("An Innovative Merchant")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Tarkington’s became the favorite New York store of fashionable women around the world as a result of a number of merchandising innovations, most of them the result of the founder’s lively imagination and retailing savvy. For instance, never in its history has Tarkington’s had a sale or offered any merchandise that was marked down in price. “My kind of woman”—a phrase Mr. Tarkington often used—“is not interested in looking at merchandise that has been rejected by her peers, no matter how reduced the price,” he said. As a result of this philosophy, it is the store’s policy to keep no item in its inventory longer than three months. After that period, unsold merchandise, whether a $100,000 sable coat or a $100 pair of gloves, is stripped of its prestigious Tarkington’s label and offered for resale to discount outlets around the country, usually at considerable financial loss to the store. At the same time, the Tarkington’s shopper has always known that the goods she is buying are on the cutting edge of current high fashion.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“My land of woman would not be pleased to buy an $800 pair of Maud Frizon shoes in May and come back in October and see the same shoes marked down to $450,” Mr. Tarkington said.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You would be astonished to learn how many retailers—and I mean highly respected retailers—offer sales and markdowns that are completely phony,” he once told a group of Harvard Business School undergraduates in a retailing seminar. “Why do so many retailers use the words ‘regularly’ and ‘usually’ on price tags for marked-down merchandise? Simply because if they said ‘formerly’ or ‘was,’ they’d be lying. ‘Regularly’ and ‘usually’ are used to skirt around truth-in-advertising regulations. Beware also of merchandise tagged ‘special price.’ There is nothing special about the price, except that this is the price the retailer hopes to sell the item for. Every day in my newspaper, I see retail advertisements that use the phrase, You’d expect to pay. ‘You’d expect to pay $300 for a thingamabob like this.’ The words are meaningless and should fool no one, but many people are nonetheless taken in by this method of creating a fictitious comparative price.”")]), _vm._v(" "), _c('p', {
    staticClass: "section3"
  }, [_c('span', [_c('i', [_vm._v("Distinctive Advertising")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("As a part of its unique retailing philosophy, Tarkington’s has never advertised a specific item. Instead, the store’s small, discreet notices in newspapers like "), _c('i', [_vm._v("The Times")]), _vm._v(" and select fashion and shelter magazines say only “Tarkington’s, Fifth Avenue,” thereby steadily reinforcing the store’s image of quality, costliness and high fashion for a select and wealthy clientele. It is typical of Tarkington’s lofty approach to merchandising that when, during her 1972 state visit to New York, Queen Elizabeth II announced that the only retail establishment she wished to visit was Tarkington’s, the store refused to capitalize on the publicity generated by the royal shopper. Instead, the store referred all inquiries about the Queen’s visit to Buckingham Palace.")]), _vm._v(" "), _c('p', {
    staticClass: "section3"
  }, [_c('span', [_c('i', [_vm._v("Generous Credit Policy")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("At the same time, Tarkington’s has long been known for its generous credit policy. “Rich people always pay their bills,” Mr. Tarkington said. “They may pay them more slowly than other people, but that is perfectly all right with us. My kind of woman travels extensively; she has homes throughout the world. She is not the sort of woman who sits down at her desk once a month and writes out checks. It’s simply more convenient for her to do this once a year, or every two years, and our job is to cater to her convenience.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("As a result, when, in the 1960’s, retail stores began routinely adding finance charges to all accounts unpaid within 30 days, Mr. Tarkington refused to join this trend. “My kind of woman would be insulted if I ever tacked a finance charge on her bill,” he once said. “I am in the business of serving clients, most of whom are also my friends. I am not in the habit of insulting my friends.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("For most of its history, Tarkington’s neither issued nor accepted a credit card. A customer’s signature on a sales slip was sufficient. Then, in 1985, the store began issuing credit cards to customers who spent more than $10,000 annually in the store. These distinctive blue-and-pink cards have become something of an American status symbol—women have been known to place them conspicuously in their wallets and billfolds—and a woman with a Tarkington’s card has no trouble establishing credit anywhere in the world.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In this way Silas Tarkington built a reputation for his store, and made himself a very rich man, by catering to the very rich. At the same time, he never made public the names of his famous clientele. Unlike other upscale retailers, such as Bijan and Giorgio, the walls of whose establishments are scattered with affectionately signed photographs of celebrity customers, Mr. Tarkington’s office in the store contained only one photograph—of his wife. But the caliber of Tarkington’s shoppers could be judged by the sight of Mrs. C. V. Whitney, Jacqueline Onassis, or Brooke Astor stepping out of a limousine and being escorted into the store by James, Tarkington’s longtime doorman.")]), _vm._v(" "), _c('p', {
    staticClass: "section3"
  }, [_c('span', [_c('i', [_vm._v("Not Without His Critics")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Such personalized and idiosyncratic storekeeping earned Silas Tarkington his share of critics, however. “The so-called Tarkington philosophy is nothing but a gimmick,” said a Fifth Avenue retailer who asked not to be identified. “It’s a gimmick to get women to buy on the basis of cost, not on the basis of quality or brand name. Since a lot of his suppliers, both on Seventh Avenue and in Europe, create special lines just for Si Tarkington, he gets his so-called ‘Ours Alone’ label. It’s impossible to tell what his markup is, though I’m sure it’s more than the normal 50 to 60 percent. I’ve seen merchandise in his store that seemed to me ridiculously overpriced. But he’s created this mythical aura that if it’s from Tarkington’s it’s got to be the best, and his customers have fallen for it. He’s made it chic for a woman to be ripped off. It’s a gimmick that worked in the spendthrift 80’s, but it will be interesting to see how it works in the belt-tightening 90’s. Also, it will be interesting to see what happens now that Si is gone.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Indeed, there is already much speculation in the fashion industry as to who will succeed the founder. “He "), _c('i', [_vm._v("was")]), _vm._v(" the store,” one longtime employee told "), _c('i', [_vm._v("The Times")]), _vm._v(" today. “Nobody could do the things he did. His personal touch was everywhere.” Often cited was his habit of telephoning favorite customers to say, “Darling, I have something new in from Paris that I want you to be absolutely the first to see.” There were customers who insisted on being waited on by Mr. Tarkington personally and would accept help from no other salesperson. Though the store never opened in the evenings, closing its doors promptly at 5 P.M., an hour earlier than most New York retail establishments, favored customers were given special keys so they could enter the store after hours and shop undisturbed. The late Greta Garbo was known to do this; Miss Garbo was often seen leaving Tarkington’s late at night with an armload of garments to try on at home. Those she decided against were picked up by a store messenger the following morning. The store received some unwanted publicity in 1987 when the "), _c('i', [_vm._v("Daily News")]), _vm._v(" reported that Miami socialite Mrs. Curtis LeMosney returned a $15,000 ball gown to Tarkington’s a full two years after she had purchased it, demanding a refund. Mrs. LeMosney received credit for the cost of the gown.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Specially favored female customers were also invited to use Tarkington’s sumptuously decorated fitting and dressing rooms to change clothes for dinner and the theater. In these dressing rooms, cocktails and light snacks were served by a maid in a black uniform with white apron and cap. How many of these small personal touches will be retained by whoever succeeds Mr. Tarkington is a much-discussed question. It has long been assumed that Mr. Tarkington’s hand-picked successor was Thomas E. Bonham III, the store’s executive vice president and general manager, who has been with the company since 1970. Mr. Bonham, 44, a neighbor of the Tarkingtons on Long Island, reached at his home, was asked whether he would be Tarkington’s next president. “That’s an inappropriate question at this time,” Mr. Bonham told "), _c('i', [_vm._v("The Times")]), _vm._v(". “No one can replace Si Tarkington.” Mr. Bonham declined further comment, beyond adding that the store will be closed today in the founder’s honor.")]), _vm._v(" "), _c('p', {
    staticClass: "section3"
  }, [_c('span', [_c('i', [_vm._v("“Last of the Dinosaurs”")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Others emphasized the unique role that Silas Tarkington played in New York retailing. “He was the last of the dinosaurs,” said Eliza McCamber, president of the New York Fashion Group. “In my lifetime, I’ve seen the demise of any number of great specialty and department stores. Altman’s is gone, Bonwit’s is gone, Best’s is gone, DePinna and Arnold Constable and Franklin Simon are all gone. I can remember when the Gimbel family owned Gimbels, the Strauses owned Macy’s, and Andrew Goodman owned Bergdorf-Goodman. Now they’re all parts of chains and not nearly as good as they once were. The personal touch is missing. And Saks, which was also run by the Gimbel family, now belongs to the Sultan of Dubai!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Adding to the feeling that Tarkington’s was run as a kind of paternalistic oligarchy was the fact that, in addition to their Long Island home, Mr. Tarkington and his wife maintained a 22-room duplex apartment on the top two floors of the Fifth Avenue store. Because New York building codes prohibit anyone other than a janitor to live in a building where dressmaking or manufacturing takes place, Mr. Tarkington and his wife are listed in the city registry as “janitor” and “janitress.” “It made it such a cozy place to work,” said one longtime employee, “with the boss and his wife living over the store.”")]), _vm._v(" "), _c('p', {
    staticClass: "section3"
  }, [_c('span', [_c('i', [_vm._v("Mysterious Origins")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("And yet, for all his fame and fortune, Silas Tarkington remained an elusive, even mysterious figure. Very little about his actual origins is known. In 1956 he seemed to appear from nowhere, full-blown, on the New York fashion scene. That was the year when, using capital from an unknown source, Silas Tarkington purchased the old Truxton S. Van Degan mansion on Fifth Avenue and 59th Street, which was about to be razed. Initially, Mr. Tarkington used the various rooms in the mansion to lease small boutiques to other fashion retailers, retaining only the former foyer of the house for his own operations. Then, gradually, he took over these leases. Even today, the store’s floor plan creates the feeling of walking from one small boutique to another.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In 1967, needing more selling space, Mr. Tarkington added considerably to his store by building an L-shaped addition to the mansion’s northeast corner, an area that had originally contained the Van Degans’ carriage house and gardens. This move aroused the ire of preservationists, who argued that the addition destroyed the mansion’s setting and scale. However, since the mansion had never been given Landmark status, Mr. Tarkington was able to proceed with his plan.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“He was the most gracious and charming of men,” said a former associate who asked not to be identified, “but at the same time he was a man of mystery. He never talked about his youth or early days. That was part of his fascination.” Not even Mr. Tarkington’s exact age at the time of his death is known, though he was assumed to be in his early to mid 70’s. He studiously avoided the press and successfully resisted the efforts of a number of would-be biographers, sticking only to the scanty facts published in his company’s 1975 “official” corporate history.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("That corporate history, "), _c('i', [_vm._v("Only the Best")]), _vm._v(", omits the founder’s date and place of birth, his parents’ names, and other vital statistics. The corporate history merely speaks of the founder’s “Horatio Alger-like rise from poverty to fame and fortune.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Because so few hard facts are known, gossip and rumors about the man behind the facade have proliferated over the years. It has been said, for instance, that Silas Tarkington was not his original name. It has also been rumored that at some point in his career he had underworld connections, but no proof has been offered to back these allegations.")]), _vm._v(" "), _c('p', {
    staticClass: "section3"
  }, [_c('span', [_c('i', [_vm._v("An Aloof Executive")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("As an executive, Mr. Tarkington was so aloof as to be almost invisible at times, making his presence known only through terse memoranda. “He was always very courtly and attentive with his special lady clients—and we were always to call them ‘clients,’ never ‘customers’,” said Mrs. Estelle Winfield, a longtime Tarkington’s salesperson, “but when he walked through the store there was never much more than a polite nod to any of us. His office door was usually closed, and often no one was sure whether he was in there or not. Or we’d think he was there, and we’d find out he was actually in Paris or Rome or Tokyo, scouting new designers. One day he suddenly appeared with an armload of the most beautiful hand-knit sweaters I’d ever seen and plopped them on my counter. ‘Where did these come from, Mr. Si?’ I asked him. ‘I brought them back with me from New Zealand last night,’ he said. New Zealand! We didn’t even know he’d been out of town.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“And the apartment! That was a really mysterious place. None of us was ever invited up there. I don’t think even Mr. Bonham was ever there. The apartment was kind of a secret, sacred place, just for Mr. and Mrs. Tarkington.”")]), _vm._v(" "), _c('p', {
    staticClass: "section3"
  }, [_c('span', [_c('i', [_vm._v("“A Shy Man”")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I think my father was essentially a shy man,” his daughter, Miranda, 24, told "), _c('i', [_vm._v("The Times")]), _vm._v(" today. “I think he enjoyed the perks that went with being rich and powerful, and having rich and powerful clients, but he never got used to being in the limelight. He hated it when flashbulbs went off.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Indeed, Mr. Tarkington was famously averse to being photographed. Though he often spoke in public, he did so only after being assured that no cameras would be allowed in the room. And when he and his wife appeared at social functions and cameras appeared, he frequently nudged his somewhat taller wife to the front, saying, “Photograph her, she’s the beautiful one, not me.” He once declared, “I see no value in personal publicity,” and for news stories concerning him he usually insisted that one of a series of “official” photographs, taken in 1970, be used, rather than anything more recent. Similarly, Mr. Tarkington refused to be listed in "), _c('i', [_vm._v("Who’s Who in America")]), _vm._v(" or other biographical volumes.")]), _vm._v(" "), _c('p', {
    staticClass: "section3"
  }, [_c('span', [_c('i', [_vm._v("The Perfect Wife")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Mrs. Tarkington was considered the perfect wife for a man in her husband’s business. She is the former Consuelo Banning, one of a trio of sisters whom the press dubbed “The Beauteous Bannings,” and who were belles of the Philadelphia social scene in the 1960’s. The Banning sisters, Consuelo, Katharine and Lucinda, were the daughters of George F. Banning, a socially prominent Philadelphia attorney, and all three made socially auspicious marriages: Katharine to Andrew W. Mellon III; Lucinda to Nicholas de N. du Pont; and Consuelo, the youngest, to Mr. Tarkington.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("With her porcelain skin, blond hair, pale blue eyes and model’s size 8 figure, she became an ideal showcase for the designer fashions sold in her husband’s store, and for a number of years her name has appeared high on lists of the world’s best-dressed women. She has toiled for prominent charities, is a highly visible figure at New York’s most fashionable restaurants, and when designers show their collections Mrs. Tarkington is always seated front and center.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“She’s Tarkington’s merchandise personified,” says a friend who insisted on anonymity. “And having all those Mellons and du Ponts as in-laws didn’t hurt Si’s business either, in terms of attracting the kind of customers he wanted.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Mrs. Tarkington was in seclusion today and could not be reached for comment.")]), _vm._v(" "), _c('p', {
    staticClass: "section3"
  }, [_c('span', [_c('i', [_vm._v("A Regal Life Style")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Mr. and Mrs. Tarkington enjoyed a regal life style. In addition to Flying Horse Farm in Old Westbury and the New York apartment, the couple maintained homes in Lake Sunapee, N.H., and Palm Beach, Fla., and a pied-à-terre on the avenue Foch in Paris. Whenever Mr. Tarkington and his wife appeared in public, Mr. Tarkington, a man with an erect carriage and a full head of silvery hair, was always immaculately groomed and impeccably tailored.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Whatever his detractors may say about him, few would disagree that Silas Tarkington created and leaves behind him a retail establishment that is perhaps unique. In 1990 Mr. Tarkington received the Merchant of the Year award from the New York Retailers Association. In 1987 he received a special award from the Fifth Avenue Association for having done the most to maintain the tone of the street. Past recipients have been Pierre Cartier II, Dr. Aldo Gucci and Harry Winston.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Mr. Tarkington’s interests, other than his company, included racehorses, which he bred and raced in Britain, Ireland and France. Though he declined to race any of his horses in the United States, one of his stallions, Flying Flame, won the Arc de Triomphe in Paris in 1971 and went on to win other important purses before being put out to stud in 1975. Flying Horse Farm, the Tarkington estate on Long Island, was named for this stallion.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Mr. Tarkington also amassed an important collection of Impressionist and Post-Impressionist paintings. It has long been understood that the Tarkington collection will be left to the Metropolitan Museum of Art. “That has been our informal understanding,” Philippe de Montebello, the museum’s director, told "), _c('i', [_vm._v("The Times")]), _vm._v(". “But we shall have to see the terms of the will before we know whether the gift is a fact.”")]), _vm._v(" "), _c('p', {
    staticClass: "section3"
  }, [_c('span', [_c('i', [_vm._v("Shock Expressed")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Friends today expressed shock at Mr. Tarkington’s sudden death. “I saw him Friday at the Athletic Club,” said one. “He looked to be in the peak of health and good spirits. He was always exercising. He’d never had heart trouble that any of us knew about. He must simply have overdone it, doing his daily laps in the pool.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Mr. Tarkington is survived by his wife and daughter. A previous marriage ended in divorce. Cremation took place Saturday under the auspices of Frank E. Campbell, and interment at Salem Fields Cemetery in Brooklyn will be private. There will be no funeral service, though the family suggested that a memorial service may be held at a later date.")])])])
}]}

/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(83),
  /* template */
  __webpack_require__(84),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 83 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 84 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "part-h"
  }, [_c('span', [_c('i', [_vm._v("Part One")])])]), _vm._v(" "), _c('p', {
    staticClass: "part-title"
  }, [_c('span', [_vm._v("MIRANDA’S WORLD")])])])])
}]}

/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(86),
  /* template */
  __webpack_require__(87),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 86 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 87 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "chap-title"
  }, [_c('span', [_c('i', [_vm._v("1")])])]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_vm._v("The Lincoln Building at 60 East 42nd Street is one of those solid, dependable New York office buildings, put up between the two world wars, which manages to confer upon its business tenants an aura of instant sobriety and respectability. No one flashy would ever lease space here, the building seems to say; no one who was the least bit sleazy would be comfortable. Stepping through the big bronze-and-glass doors into the marble elevator lobby, the visitor is immediately surrounded by a sense of probity. You are expected to be on your best behavior here, the vaulted ceilings of the lobby whisper almost audibly.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("This is not a fashionable address; it is merely good. Forty-second Street isn’t what it once was. Across the street, behind the imposing granite facade of Commodore Cornelius Vanderbilt’s Grand Central Station, the homeless curl asleep in corners, looking like bunches of rags dropped from a great height. But from the twentieth-floor windows of the law offices of Mssrs. Kohlberg, Weiss, Griffen & McBurney, the blue-and-white flag of the Yale Club can be seen proudly flying above its Vanderbilt Avenue entrance, and it is from the Yale Club, and luncheon with his legal peers, that Mr. Jacob Kohlberg, senior partner of the firm, has just come for his two o’clock meeting. The "), _c('i', [_vm._v("Times")]), _vm._v(" obituary of Silas Tarkington is spread open on his desk.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Very nice,” Jake Kohlberg says, tapping the newspaper with the tip of his index finger. “He got the front page, and a full page inside the paper. Si couldn’t have asked for a better sendoff.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“That was Tommy Bonham’s doing,” Miranda Tarkington says, almost proudly. “When Daddy died Saturday, Tommy pointed out that if we notified the papers then, the obituary would be lost in the Sunday paper. Tommy said, ‘Wait till tomorrow morning. He’ll get the front page on Monday.’”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Of course one might have wished they hadn’t mentioned that business about underworld connections,” Jake Kohlberg says.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Those rumors have been around forever,” Miranda says. “No one pays attention to them anymore.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“And he received other awards that could have been mentioned.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“But those were the two that Daddy was proudest of.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“They might have mentioned that our father also had a son,” Blazer Tarkington says. This is the first time Blazer has spoken. Blazer is Miranda’s half brother, Silas Tarkington’s son by his first wife. Blazer is twenty-eight, and he has chosen today to defy the law office’s unwritten code of propriety. He is wearing a pair of faded Levi’s, without a belt, and one leg of his jeans is out at the knee, revealing his own knobby knee, which, for some reason, is scabbed. Did Blazer fall and skin his knee on the way to this meeting? His posture, slouched in the leather office chair, legs spread apart, suggests no explanation. His sockless feet are in dirty Reeboks, one of them untied. Blazer’s dark good looks are of a truculent variety. He is scowling now, his black eyebrows knitted over his black half-closed eyes and pleasantly off-center nose.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Shit,” Blazer says to no one in particular, and he removes a Camel cigarette from the pocket of his T-shirt, taps it against the heel of his untied sneaker, and lights it with a match.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In the brief silence that follows Blazer’s comment—to which, of course, there is no real reply—Miranda wonders whether Blazer has been drinking. As Blazer sucks deeply on his cigarette, he shakes his head, and a thick shock of dark brown hair falls across his forehead. Miranda watches as her mother reaches out and touches Blazer’s skinned knee with her gloved fingertips, a touch so gentle it would not ripple water. “You’ve skinned your knee,” Miranda hears her mother say.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("And Jacob Kohlberg presses a button on his desk. When his secretary appears at the doorway, he says, “Mildred, see if we can find an ashtray for Mr. Tarkington.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Needless to say, Blazer is not his real name. He was christened Silas Rogers Tarkington, Junior, but when he was just a little boy his father began saying of him, “This boy’s career is going to blaze across the skies! Just wait and see. "), _c('i', [_vm._v("He’s going to blaze across the skies.")]), _vm._v("” It is perhaps unnecessary to add that this has not happened, but the nickname stuck.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("When the ashtray has been delivered, Jake Kohlberg shuffles some papers on his desk and says, “Now, let’s see. Are we all here? Is Miss O’Malley—”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Pauline was going to try to make it,” Miranda says, “but she telephoned me this morning to say that she’s just too upset. She was afraid she’d break down. She’s taken this whole thing very badly, I’m afraid.” Pauline O’Malley was Silas Tarkington’s private secretary for thirty-two years.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I can understand that,” Jake Kohlberg says. “We’ll have to make do without her.” He turns to the third man in the room. “And you, sir? Forgive me, but I’ve forgotten—”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“My name is David Hockaday,” the fair young man says. “I represent Philippe de Montebello of the Metropolitan Museum.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Ah, yes,” Jake Kohlberg says. “Very good. Now, before we begin, let me explain that this is a somewhat old-fashioned procedure, the reading of the late Silas Tarkington’s last will and testament. It isn’t strictly necessary and is not legally required. I could easily have faxed copies to each of you. But I thought, considering the nature of some of the bequests and the somewhat unusual contents of the instrument itself, that it might be a good idea if we all met here this afternoon to go over the points herein, so that I might answer any questions you might have about the bequests or about the intent of the testator in certain clauses—”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Consuelo Tarkington clears her throat and leans forward slightly in her chair. “Jake?” she says in her soft, almost whispery voice. Miranda has noticed that her mother, as always, is dressed perfectly for the occasion in a navy blue Chanel suit with covered buttons, a blue Chanel over-the-shoulder bag with a gold chain, but with the gold double-C logo removed, and navy pumps—all chosen to emphasize her pale blue eyes. Her fluff-cut ash-blond hair is perfectly coifed, with two half-moon curls perfectly framing her perfect forehead. Miranda knows how much effort it takes to create perfect half-moon curls like these, nestled just so, just off the face. On any other woman, those curls might look too studied. But on her mother they look, as always—well, just perfectly right, the perfect touch. With a small frisson of jealousy, of which she is not proud, Miranda thinks her mother has the knack, the talent, the ability, call it whatever you want, to make every other woman in the room look overdressed, or under-dressed, or just plain put together wrong. Even Miranda, in a simple black silk sheath, cut to just above the knee, and a single strand of twelve-millimeter pearls, her chestnut hair pulled back in a ponytail and tied with a Hermès scarf, feels dressed all wrong, compared with her mother. But then, she always has.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Yes, Connie?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I wonder if I could ask just one question before we start,” her mother says.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Certainly.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Jake, as I think you know, Si wanted to make some changes in his will before he died.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Jacob Kohlberg pinches the bridge of his nose between his thumb and forefinger. “That is true,” he says.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“These were to be substantial changes,” she says. "), _c('i', [_vm._v("“I")]), _vm._v(" know what they were to be, and I believe "), _c('i', [_vm._v("you")]), _vm._v(" know what they were to be.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“That is true,” he says again, pulling a white manila envelope from his center drawer and placing it on his desk. “In fact, this office was in the process of preparing the new instrument for his signature when unfortunately he—”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Died,” Consuelo Tarkington says, a little sharply. “Please don’t say ‘he passed away,’ or ‘we lost him,’ or, like my black maid says, ‘he passed over.’ He died, is what he did.” She sits back in her chair. “I’m sorry. We’ve all been under a strain these last two days.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I understand,” Jake Kohlberg says. “But as I was saying, the new instrument was not yet ready for his signature when he—died.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Well, what I’m asking you,” she continues, “is whether, since you and I both know exactly what his final wishes really were, we can use that instrument—that draft, or whatever it was—whether we can use that as his last will and testament.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Unfortunately, no. The new will was never executed. It was never signed or witnessed.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“But we both know he’d changed his mind about certain things—important things. So couldn’t we consider—”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Unfortunately—”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“—what my husband really wanted?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Legally, you see—”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“But couldn’t we bend the law a little in this case, Jake? After all—”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“What you are suggesting constitutes fraud, Connie. And if it were even hinted that there was anything fraudulent about your late husband’s will, it would open us up to lawsuits from all directions, since the size of the estate is, to say the least, extensive. I cannot suggest that you and I be parties to a fraud.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Mr. David Hockaday from the museum clears his throat. “I am afraid I shall have to divorce myself from these proceedings right now if anything like that is being considered,” he says primly. “The Metropolitan Museum of Art would certainly not wish to be party to a fraud.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Miranda decides that she hates Mr. David Hockaday.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“And so,” Jake Kohlberg continues, after a brief pause, “we must accept as the last will and testament of the late Silas Tarkington the one dated”—he places his glasses on his nose and removes the stapled document from its envelope—“dated June twenty-second, nineteen-ninety.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Miranda’s mother sighs. “So we’re about to hear read to us a last will and testament that wasn’t his last will and testament at all.” Her tone is bitter as she folds her gloved hands in her lap.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Jacob Kohlberg begins. “‘I, Silas Tarkington, being of sound mind and body, do declare this to be—’”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("His voice drones on. Miranda fingers her pearls gingerly, and her mother, her head tilted slightly to one side, her chin resting on her fingertips, gazes absently into a middle distance somewhere between the lawyer’s chair and her own, her beautiful legs crossed gracefully at the ankle, just so.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The residences are disposed of first. Flying Horse Farm in Old Westbury, the house on Jungle Road in Palm Beach, and the Paris apartment all go “‘to my beloved wife, Consuelo Banning Tarkington.’” Next comes the stable of horses, a small but distinguished one. This, “‘unless either party has an interest in maintaining same,’” is directed to “‘be sold at public auction, with the proceeds of such sale, less commissions, to be divided equally between my wife and my beloved daughter, Miranda.’” Miranda, knowing that her mother has little interest in horses, and also knowing that it costs $30,000 a year to stable a single animal, decides that probably this is what will be done.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Next come items of personal jewelry. Most of these are bequeathed to longtime employees and old friends. A pre-Columbian gold tie clasp in the design of a man and a pre-Columbian gold frog go to the store’s chief of security. An eighteen-carat gold signet ring goes to James, the store’s doorman. A fourteen-carat yellow-gold gypsy-style ring containing a 1.78-carat emerald-cut emerald goes “‘to my old friend and associate, Thomas E. Bonham III.’”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“That should put an end to the rumor that there was any falling-out between Tommy and Daddy,” Miranda whispers.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("A pair of eighteen-carat gold cuff links set with cabochon rubies, and a matching set of studs, is left to Jacob Kohlberg himself, “with thanks for the years he has served as my principal legal counsel.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The list goes on and on, item by item, and Miranda tries to envision the pieces of jewelry her father liked the best, the cufflinks she occasionally helped him fasten when he dressed for dinner, and the pieces he liked less and rarely took out of the drawer in the bank, and gradually a vision of her father appears before her, a small but commanding presence, and in her mind she dresses him, from top to bottom, the way she used to dress her paper dolls as a child, until he stands, elegantly and impeccably clad, as always, before her. And she realizes that there are tears in her eyes, though her mother’s beautiful face is impassive.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Now comes the first small shocker. “‘To my faithful secretary, Miss Pauline O’Malley, I bequeath the sum of ten thousand dollars.’” There is a little collective gasp from the members of the family.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Shit!” Blazer says. “She slaved for him for thirty-two years and that’s all she gets, a lousy ten thousand bucks?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Perhaps to change the subject, Miranda’s mother interrupts. “Tell me,” she asks quietly. “Does the name of Moses Minskoff appear in the will?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“No, it does not,” Jake Kohlberg answers.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Well, thank God for small blessings,” her mother says.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Jake Kohlberg hesitates, then nods, almost imperceptibly, in agreement.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Now comes the first mention of the art collection, and David Hockaday sits forward in his chair and almost visibly seems to prick up his ears. Miranda watches as he opens his briefcase, removes a gold pen and a legal-size pad of yellow paper, and makes a desk out of the briefcase on his lap. This is all he cares about, she thinks: the art collection. It doesn’t matter to him that a man has died, and rather mysteriously at that. He doesn’t care about the troubled and divided family the dead man left behind. He doesn’t care about the uncertain future of Tarkington’s, that rare and special store her father created, the store that as a little girl she used to think of as her own private castle, the store she used to dream of running herself someday, if only her father would ever take her seriously. Who "), _c('i', [_vm._v("will")]), _vm._v(" run the store now? Perhaps the will offers an answer.…")]), _vm._v(" "), _c('p', {
    staticClass: "indent2"
  }, [_vm._v("As a little girl, Miranda used to come down from the apartment at night and wander through the store after the clients and the salespeople had gone, pressing her nose into the minks and sables and lynxes and foxes in the Fur Department on three to smell the pungent odor of the pelts, each different; touching the skirts of the gowns in the French Room, on four, and in the Bridal Salon next door. Then down to Sportswear, on two, and then down to the street floor, to Small Leather Goods and Shoes and Accessories, the gleaming cosmetics counters, and all the glittery contents of the locked glass cases of the Jewelry Department. “That you, Miss Mandy?” Oliver, the store’s night watchman, would say to her as he made his rounds with his time clock. “Just don’t leave no fingerprints on the glass or I’ll catch hell from your daddy.” Sometimes, in the dressing rooms, she would encounter some of her father’s special ladies—the ones who had been given their own keys—and sit and listen to them as they gossiped and tried on clothes. Two slender dark-haired women she got to know that way were Gloria Vanderbilt and her friend, Oona O’Neill. Normally, dogs were not welcomed in the store—James kept them on their leashes outside while the ladies shopped—but an exception was made for the pair of borzois belonging to Doris Duke. And a small, angular, homely woman, who seemed to expect deferential treatment and the right to precede other women through doorways, turned out to be the Duchess of Windsor.")]), _vm._v(" "), _c('p', {
    staticClass: "indent2"
  }, [_vm._v("“I think we can dispense with the reading of the full inventory of the art collection,” she hears Jake Kohlberg saying. “It is attached as Appendix A to the instrument. I’ve had a copy made for you, Mr. Hockaday, to review at your leisure. The entire collection, or rather the full list of items on this inventory, is bequeathed to the New York Metropolitan Museum of Art. However, there are some conditions.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Mr. Hockaday shifts the position of the briefcase on his lap and sits with his pen poised above his yellow pad.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Jacob Kohlberg reads: “‘Clause forty-six A: A gift in the sum of three million dollars is made to the Museum, to defray the costs of displaying and maintaining my collection, conditional upon the Museum’s acceptance of the full collection and the terms under which it is given. Clause forty-six B: The collection shall be displayed in its entirety, in a special gallery to be designated the Silas Tarkington Collection in letters no less than twelve inches high. Clause forty-six C: My beloved wife shall be permitted to select as many as twenty items from the aforesaid collection and to retain them in her home or homes throughout her lifetime. Testator suggests that Monet’s “Water Lilies,” always a particular favorite, may be one of the works she may wish to retain. But upon her death, those works thusly retained shall be turned over to the Museum proper. Clause forty-six D: In addition to housing, displaying, and maintaining the Silas Tarkington Collection, the Museum shall designate Miss Diana Smith as Special Curator of this Collection and shall employ her in this capacity for as long as she may wish.’”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("There is another small, collective gasp in the room.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Your Honor,” Mr. Hockaday begins.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You don’t have to call me Your Honor, sir. I am not a judge.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Mr. Kohlberg, then. May I interrupt to ask, who is Miss Diana Smith? An art historian, I assume? A Ph.D.?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“She’s an old friend of my husband’s,” Consuelo Tarkington says softly. “And no, she never actually went to college.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“She’s the jewelry buyer at Tarkington’s,” Miranda says.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“My husband always felt she had great taste in art.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Blazer sits forward, and as he does so the tear in his jeans splits wider, revealing more of his knee. “Goddammit, Mandy,” he says, slamming his fist in his palm, “why don’t you tell this fucker the fucking truth? She’s our father’s latest girlfriend, his latest mistress, our old man’s latest piece of ass. She may be the fucking jewelry buyer, but she’s also a thirty-four-year-old piece of old jade herself!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Miranda shoots a quick look at her mother, whose face is a mask.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Now, young man,” Jacob Kohlberg begins, “this is neither the time nor the place—”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Tell the truth, Mandy! You know who Smitty is as well as I do!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Blazer, I—”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“May I interrupt again?” David Hockaday asks. “Let me just say that the Museum cannot accept this gift without the approval of the board of directors. And so I must defer acceptance of the gift until the board has met and discussed these somewhat unusual terms and conditions, which may not, I should warn you, prove acceptable.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I understand perfectly,” Jake Kohlberg says.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Our curatorial staff will also want to inspect the items in the collection. This has not yet happened.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Perfectly understandable,” Jake Kohlberg says. “So I think any further discussion of Miss Smith is irrelevant at this juncture. Meanwhile, clause forty-seven of the will provides that, should the Museum decline the bequest, the collection, with the exception of those items Mrs. Tarkington may wish to retain for her lifetime, is bequeathed to the aforementioned Miss Smith without further restrictions.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Blazer stamps out his cigarette in the ashtray and immediately lights another. “So either you get it or the old man’s slut gets it. Take your pick, buddy-boy,” Blazer says. Mr. Hockaday merely lowers his eyes beneath his blond lashes.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Once again Miranda looks at her mother, whose face remains smooth and impassive. How, she wonders, can her mother listen to things like this and register no emotion whatsoever? The stage, she sometimes thinks, lost a great actress when her mother opted for being a tycoon’s wife.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Jacob Kohlberg clears his throat. “Shall we move along?” he says. “There are only a few more items.” He reads: “‘As to my shares of stock in Tarkington’s, Inc., which is located at’—et cetera, et cetera—‘I direct that these be divided equally between my beloved wife and my beloved daughter, Miranda—”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Once more Blazer interrupts. “Now wait a minute,” Blazer says, “I’ve been sitting here for the better part of an hour listening to crap about his beloved this one and his beloved that one. What about his beloved "), _c('i', [_vm._v("son")]), _vm._v("? Or don’t I figure in this goddamn thing at all? Like I somehow didn’t figure in his obituary?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Miranda sees Jake Kohlberg’s face redden. “I was just coming to that,” he says. And he reads: “‘My son, Silas R. Tarkington, Junior, is to receive no bequests under this instrument, for reasons he will understand.’”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Blazer jumps to his feet and crushes out his cigarette in the ashtray, all in the same quick movement. “So what the hell?” he says. “Why come all the way up from the Village just to hear that I’ve been zapped in my old man’s will? What a goddamn waste of time!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Blazer, that was one of the things he was going to change,” Miranda’s mother says. “I swear to you,” and she reaches out to touch his hand but he pulls away from her.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I’m not surprised,” he says. “He was always threatening to cut me off without a goddamn penny, and now he’s goddamn done it. But why the hell did you assholes have to drag me all the way up here to tell me he’d done it?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Jake, tell him this was one of the things his father was going to change!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“It’s true,” Jake says. “He’d had a change of heart. Unfortunately—”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Unfortunately, he changed his goddamn little heart too late!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I want to make it up to you, Blazer, out of my share, which is more than I need. I’ll give you—”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I don’t want your money, Connie! And I don’t want any of "), _c('i', [_vm._v("his")]), _vm._v(" goddamn money!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“He wanted you to have it. He was angry when he wrote that will, but he forgave you later on. He loved you, Blazer. He loved you very much. He told me so.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Well, I never wanted his goddamn love! And you—how can you sit there listening to crap about being his "), _c('i', [_vm._v("beloved wife")]), _vm._v("? You weren’t his beloved wife any more than my mother was his beloved wife! You were just—what? Just window dressing, no more important to him than one of the plaster mannequins in his Fifth Avenue windows! He didn’t love you, he didn’t love my mother, he didn’t love me, and he didn’t love Mandy. All he ever loved was his goddamn self!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Oh, Blazer, Blazer—”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“And meanwhile he was fucking every woman in New York, and you know it. You ought to know it, because he was fucking you while he was married to my mother. Well, you got what you were after, didn’t you, Connie? You got his money.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Blazer, don’t say such terrible things about our father,” Miranda says. “Or about my mother, for that matter.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Why not? He was a fucking terrible man. He was a terrible father and a terrible husband. He fucked everybody over, and now he’s fucking everybody over from the grave! Look! Look at how he’s trying to fuck over the fucking Metropolitan Museum. Look how he’s fucking you over, Connie, making you share the fucking art collection with Smitty, who was his last good fuck! Well, he’s fucked me over for the last time, and all I can say is I’m glad somebody else killed him, because if somebody else hadn’t killed him I’d probably have done it myself!” He strides toward the door of Jacob Kohlberg’s office, nearly tripping on the untied shoelace. “Fuck you all!” he says. “I never want to see any of you fucking assholes again.” And he pulls the door open, marches out, and slams the door behind him.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In the silence that follows, Miranda looks across at her mother again. Her mother has removed one of her gloves and is twisting it, twisting it, between her hands, but her pale face, framed by the ash-blond hair and the little crescent-moon curls, is still a mask.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I think he’s been drinking,” Miranda says at last, though she knows it probably isn’t true.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I want to give him some of my stock, Jake,” her mother says.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“He won’t take it, Mother,” Miranda says. “You know he won’t take it. He’ll never take anything from you. Or me.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("And so, Miranda thinks, that is the way it will be. One half of Daddy’s shares in the store will go to Mother, and the other half will go to me. Neither of us will have a clear majority, and together we can’t possibly have even a consensus. If anything, this arrangement can only turn us into adversaries, even more bitter adversaries than we were before.")]), _vm._v(" "), _c('p', {
    staticClass: "indent2"
  }, [_vm._v("In the days since her father’s death, she had dared to hope that things might have been left otherwise, even though she knew such a hope was unrealistic. He had never understood her feelings for the store, and neither had her mother, but to Miranda the store was home. It was the house she lived in. In her wanderings at night, after the store had closed, the racks and counters and fixtures and display cases became her furniture. In her mind, like a fastidious housewife, she changed and rearranged her rooms, mentally experimenting with different groupings, different color schemes. One night, in the shoe department, she had actually rearranged the little gilt chairs and footstools, putting them at conversational angles rather than in a straight row. This gave that corner of the street floor a much more welcoming look, she thought, and surely the department head would notice this when he arrived at the store in the morning. He had indeed noticed, and everything had been quickly replaced exactly as it had been before.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In her fantasy house, she also had fantasy parents. Each of the mannequins, in all their languid poses, was her mother. They all had her mother’s face. This was no accident, no coincidence. In 1985 her father had decided to update the store’s stock of waxen ladies, and suppliers had submitted sketches. But none of their submissions had quite satisfied her father. “Not aristocratic-looking enough,” he kept saying, “not classy enough for us,” so the artists would tear at their hair and go back to their drawing boards. “Show us the kind of woman you have in mind, Mr. Si,” they said at last, and on a sudden impulse he had pulled out some photographs of his wife. “Make them all look like her,” he said. “That’s what my kind of woman looks like.” And so, though Tarkington’s mannequins had been given various hairstyles and coloring, they all had Consuelo Tarkington’s sculptured facial bones.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Consuelo herself had been amused by this. Miranda had found it unnerving, at first, to encounter her mother’s face at every turn in the store, in every room of her house. But then she decided it was better to have dozens of beautiful mothers than no mother at all. These mothers were there whenever she needed one, and they all gazed at her with unerring approval and even curiosity.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("After store hours, a new and tangible and approachable father could be found in this house too. He sat in his empty corner office, in an empty chair, behind an empty desk, waiting for her to visit him where, in real life she was not supposed to venture without an appointment or without being announced by Pauline O’Malley. Here was a perfect place to talk to him, where he could give her his undivided attention and listen to her ideas. At night, she would slip into her father’s empty office, close the door behind her, and seat herself opposite the father who was sitting in the empty chair.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Daddy, I have a plan,” she would say to him. “It’s about me and the store. Please listen to it.…”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("And, even though he wasn’t there, he would listen, listen, listen.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("That way, he could become the most wonderful, caring father in the world while, downstairs on the selling floors, her mother, in a variety of welcoming gestures, greeted the guests who came to be treated to the wonders of Miranda Tarkington’s store.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("When a child isn’t blessed with much in the way of parents, she thinks a little wryly now, the child becomes attached to "), _c('i', [_vm._v("things")]), _vm._v(".")])])])
}]}

/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(89),
  /* template */
  __webpack_require__(90),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 89 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 90 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "chap-title"
  }, [_c('span', [_c('i', [_vm._v("2")])])]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("THE SCENE:")]), _vm._v(" "), _c('i', [_vm._v("A drab stretch of West 23rd Street in Manhattan. Outside a nondescript office building, a sign reads:")]), _vm._v(" "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("MOSES L. MINSKOFF, DEVELOPER")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "normal1"
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("THE TIME:")]), _vm._v(" "), _c('i', [_vm._v("A muggy morning in August 1991")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "blq-indent"
  }, [_c('i', [_vm._v("The lights go up to reveal the interior of this establishment: a pair of offices, cheaply furnished. In the smaller of the two rooms, the reception area, MINSKOFF’S secretary, SMYRNA, sits reading a movie magazine and chewing gum. In the larger office, MINSKOFF sits in a swivel chair at his desk, talking on the phone. He is a large man in his shirt sleeves, with an unlighted cigar clamped between his teeth. He wears a yellow Ultrasuede vest, and a heavy gold watch on a gold chain is slung across his middle. In addition to his desk and chair, the principal features of his office are a big old-fashioned Mosler wall safe and a spavined sofa against one wall. The sofa’s condition suggests that MINSKOFF often sleeps here")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "hang-indent"
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("MINSKOFF")]), _vm._v(" "), _c('i', [_vm._v("(on the phone):")]), _vm._v(" I’m making a credit card call. "), _c('i', [_vm._v("(He rattles off a fourteen-digit series of numbers. There is a pause.) What?")]), _vm._v(" What do you "), _c('i', [_vm._v("mean")]), _vm._v(" that credit card has been canceled? This is an outrage! I shall most certainly report you to your supervisor, young woman!")]), _vm._v(" "), _c('p', {
    staticClass: "blq-indent"
  }, [_c('i', [_vm._v("He slams the receiver down and simultaneously draws a line through the top number in the list of numbers on the pad in front of him. Then he picks up the phone and dials again. Credit card call.… (More numbers.)")])]), _vm._v(" "), _c('p', {
    staticClass: "blq-indent"
  }, [_vm._v("Thank "), _c('i', [_vm._v("you")]), _vm._v("! Thank "), _c('i', [_vm._v("you")]), _vm._v(" for thanking me for using AT&T. I always use AT&T, and with the greatest pleasure, my good fellow!")]), _vm._v(" "), _c('p', {
    staticClass: "blq-indent"
  }, [_c('i', [_vm._v("While he waits for his call to go through, he consults his watch")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "blq-indent"
  }, [_vm._v("Milton? Moe Minskoff here. How’s the weather out there? … Well, it’s hot as hell here. Listen, Miltie, we got a little problem, you and I. You know that rock group you got booked into East St. Louis next Friday night, the Whatchamacallems? … Yeah, the Hot Jockers, that’s them. Well, the fire chief’s brother out there is a good buddy of mine, and it seems like their stadium has a capacity seating of seventy thou. And it looks like you’ve already sold ninety-five thousand tickets to that concert at fifteen bucks a pop.… Yeah, I know you gotta overbook for no-shows, Miltie, and who cares if a few hundred coked-out "), _c('i', [_vm._v("shvartzers")]), _vm._v(" have to sit in the aisles? … Yeah, I know all that.")]), _vm._v(" "), _c('p', {
    staticClass: "blq-indent"
  }, [_vm._v("But listen, Miltie, this fire chief’s brother says the fire chief is real nervous. You’ve oversold by twenty-five thousand tickets! That’s a hell of a lot of no-shows. This fire chief’s brother says if the news got to the papers, the city council or whatever the hell it is would cancel the show and you’d have to fork back the entire gate. We’re talkin’ big bucks, Miltie. We’re talkin’ nearly a mil five, right? … Now wait a minute, Miltie, don’t fly off the handle. All I called for is to try to help you out. No need to make a federal case out of this. We’re just talkin’ fire laws, Miltie, and this fire chief’s brother says that for thirty big ones this fire chief will forget about the whole matter.… Yeah, I think I can get him down to twenty-five. You happy with that figure? … Okay, you Fed Ex the cash to me tonight, and I’ll take care of the whole thing. Plus my fifteen percent commission, naturally.… How’s the wife? Slap her butt for me, Miltie, and have a nice day.")]), _vm._v(" "), _c('p', {
    staticClass: "blq-indent"
  }, [_c('i', [_vm._v("He hangs up and immediately dials another call")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "blq-indent"
  }, [_vm._v("Credit card call … "), _c('i', [_vm._v("(More numbers.)")])]), _vm._v(" "), _c('p', {
    staticClass: "blq-indent"
  }, [_vm._v("Hello, Chief Gomez? Moe Minskoff here. It’s all set, big buddy. I got your ten big ones for you. They’re Fed Exing the cash to me tonight from LA, and I’ll Fed Ex it on to you first thing in the morning, minus my fifteen percent commission, naturally.… Not at all. Don’t thank me. That’s what I’m here for. Let me know if you have any more of these type of problems, and have a nice day.")]), _vm._v(" "), _c('p', {
    staticClass: "blq-indent"
  }, [_c('i', [_vm._v("He hangs up and dials a third call")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "blq-indent"
  }, [_vm._v("Credit card call …")]), _vm._v(" "), _c('p', {
    staticClass: "blq-indent"
  }, [_vm._v("Sal? Moe Minskoff here. Listen, big buddy, we got a little problem. You gotta lower your bid for construction of that casino down in the islands by at least five hundred big ones or you’re outa the ballpark, buddy.… Yeah, the prime minister seems pretty adamant about that.… Well, maybe I could talk him into it if you’d drop the price by three-fifty. But if I do that, Sal, I’m gonna hafta ask you a favor. I want you to put Irving Sender in charge of the construction down there.… You know who Irving Sender is. He’s Honeychile’s brother.… Whaddaya "), _c('i', [_vm._v("mean")]), _vm._v(" who’s Honeychile? Honeychile is my "), _c('i', [_vm._v("wife")]), _vm._v(", for Christ’s sake! Irving needs a job, and his wife wants to spend the winter in the Caribbean, okay? … Well, I’ll see what I can do. Get back to you, Sal. Have a nice day.")]), _vm._v(" "), _c('p', {
    staticClass: "blq-indent"
  }, [_c('i', [_vm._v("Another credit card call")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "blq-indent"
  }, [_vm._v("Ah, Mr. Prime Minister. This is Moses L. Minskoff calling. How is the weather down there, sir? Ah, how I envy you, basking in the tropical sun, the breezes rustling the palm fronds, those miles of sandy beaches, the blue crystalline waters of the sea. You truly live in paradise, sir.… Ah, but of course I have news for you. I wouldn’t have called you, sir, if I didn’t have news, and good news it is. Mr. Cortelli has lowered his bid by a quarter of a million dollars, just what you asked for. And the other good news is that he wants to place Mr. Irving Sender in charge of construction down there. You’re very lucky to be able to obtain Mr. Sender, because he’s the best in the business, the very best, and very much in demand. I couldn’t believe you could be that fortunate when I learned Mr. Sentler might be available. But he’s agreed, not without a certain amount of personal sacrifice, to take on your government’s job.…")]), _vm._v(" "), _c('p', {
    staticClass: "blq-indent"
  }, [_vm._v("Yes, sir.… Yes, all financial arrangements will be handled through this office, to spare you personal involvement in any awkward money matters.… But, sir, I wouldn’t consider asking for a commission from your government.… On the other hand, there was that little arrangement we discussed earlier.… Yes, once the casino is in full operation, we would each take a percentage—ten, I think, was the figure you mentioned—off the take from the tables and the slots.… No, I don’t think of it as a skim, Mr. Prime Minister. I think it would just give us both a sense of having a partnership in your government’s beautiful new casino.… Well, I do thank you, Mr. Prime Minister. It’s a pleasure to do business with a man of your caliber, and I hope you have a wonderful day in your island paradise.")]), _vm._v(" "), _c('p', {
    staticClass: "blq-indent"
  }, [_c('i', [_vm._v("Hangs up the phone. With his hand still on the receiver, he frowns thoughtfully. Clearly, his next call will be of a somewhat trickier nature. His lips move as he formulates his thoughts, then he picks up the receiver and dials another credit card call")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "blq-indent"
  }, [_vm._v("Mrs. Van Degan? This is Moses L. Minskoff, the investment banker, calling from New York. You may remember me. I handled a number of real estate transactions for your late husband, which were, if I may venture to say so, very profitable to him.… Ah, you "), _c('i', [_vm._v("do")]), _vm._v(" remember me! How are you enjoying retirement in Arizona? … Good.")]), _vm._v(" "), _c('p', {
    staticClass: "blq-indent"
  }, [_vm._v("Well, the reason I am calling you is that I have a very unusual offer to make to you, an offer I am making only to a few close friends and relatives. I’m letting my mother go in on this, by the way. You see, I happen to have in my possession some promissory notes—IOU’s, if you will—from the late Mr. Silas Tarkington. You may have read that Mr. Tarkington passed on recently.… Yes, I remember you were always a Tarkington’s shopper, Mrs. Van Degan. Now, these markers of his—these promissory notes, I should say—are in fairly large denominations, representing funds I advanced to Mr. Tarkington over the years. I am looking at one, for example, for five hundred thousand dollars. These promissory notes are, in effect, undated checks. Now, obviously I wouldn’t ask you to pay five hundred thousand dollars for a promissory note in that figure. On the other hand, I could offer you a fifty percent discount, the same discount I’m offering my mother, and let you have it for two hundred and fifty thousand.… What’s in it for you? Ah, there’s the beauty part, my dear Mrs. Van Degan.")]), _vm._v(" "), _c('p', {
    staticClass: "blq-indent"
  }, [_vm._v("You may have read in the financial press that Continental Stores has been for several months trying to take over Tarkington’s. Si Tarkington was fighting the takeover. But now that the old ba—now that Mr. Tarkington has passed on, Continental is really going to pull out their big guns and up their offer to Tarkington’s stockholders. In any takeover, these promissory notes become most valuable. Continental is going to have to buy them back, since they represent money Tarkington’s owes. They will come to you with an offer, and I think I can promise you a thirty to thirty-five percent return on your investment within just a few months, Mrs. Van Degan.…")]), _vm._v(" "), _c('p', {
    staticClass: "blq-indent"
  }, [_vm._v("Is it legal? Would I offer a woman of your caliber and social position anything that wasn’t legal? Certainly it’s legal. Here on Wall Street we call it factoring, the discounting of accounts receivable. You pay the discounted price, and I simply endorse the notes and turn them over to you.… Why don’t I hold on to them myself? Well, here on Wall Street this is known as streamlining. My interest in Tarkington’s is comparatively small in relation to the rest of my business, and managing these small matters just takes up too much of my time. Besides, I am in the business of serving my customers, and I thought of this as a way to repay your late husband for all the business he brought my way. He was a wonderful man, Truxton Van Degan, a truly wonderful man.… Yes, he did drink a bit, but never to excess, Mrs. Van Degan, never to excess, and I know he wanted you to be in comfortable circumstances after his untimely demise.…")]), _vm._v(" "), _c('p', {
    staticClass: "blq-indent"
  }, [_vm._v("Yes, you think about it, Mrs. Van Degan, but don’t think about it too long. Remember, I can promise you a yield of between thirty and forty percent within a few short months, and these units of mine are being snapped up right and left. I only have a few more left, Mrs. Van Degan, so think about how many units you’ll be wanting to buy. I’d recommend you get back to me no later than the end of the week. Let me give you my private, unpublished number.…")]), _vm._v(" "), _c('p', {
    staticClass: "blq-indent"
  }, [_c('i', [_vm._v("In the outer office, SMYRNA has been juggling some incoming calls on other lines, putting them on Hold. Seeing that her boss is briefly off the phone, she turns in her swivel chair and faces his door")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "hang-indent1"
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("SMYRNA")]), _vm._v(" "), _c('i', [_vm._v("(yelling):")]), _vm._v(" I got the President of Mexico on line one, Moe. And the credit manager of Bergdorf’s is on line two. It’s something about Honeychile’s charge account.")]), _vm._v(" "), _c('p', {
    staticClass: "hang-indent1"
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("MINSKOFF:")]), _vm._v(" Tell the President of Mexico to go to hell. I can’t do business with that spick. Tell him his Banco de Mexico isn’t the only bank in the damn third world. I’ll take the call from Bergdorf’s.")]), _vm._v(" "), _c('p', {
    staticClass: "blq-indent"
  }, [_c('i', [_vm._v("He presses one of the blinking buttons on his phone and picks up the receiver")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "blq-indent"
  }, [_vm._v("Moses Minskoff speaking, "), _c('i', [_vm._v("(a pause.)")]), _vm._v(" What do you "), _c('i', [_vm._v("mean")]), _vm._v(" Mrs. Minskoff has exhausted the credit limit on her Visa card? That’s quite impossible. Let me speak to your immediate superior, young woman.… You mean you "), _c('i', [_vm._v("are")]), _vm._v(" the credit manager? Then let me speak to the president of the store.… He’s in Europe? Young woman, do you realize who the person is to whom you are speaking? I am Moses Minskoff the developer, and even as we speak I have the President of Mexico waiting on hold to speak to me.… What? … Then your computer must be malfunctioning, unless—unless—"), _c('i', [_vm._v("(He strikes his forehead with the heel of his palm")]), _vm._v(".) Wait! Wait, please forgive me, but I had that Visa account closed last week. I just remembered, and I’m afraid I forgot to give Mrs. Minskoff the new account number. Surely that’s the cause of this misunderstanding. Let me give you the new number. "), _c('i', [_vm._v("(He paws through slips of paper scattered across his desktop.)")]), _vm._v(" Here it is. "), _c('i', [_vm._v("(He recites a thirteen-digit number.)")]), _vm._v(" There. Does that satisfy your computer? … Of course it does. Now you let Mrs. Minskoff charge whatever she wants. She’s a very good customer. I’m sorry about the mixup, but you were quite right to check. I’m going to commend you to the store’s president when he gets back from Europe.… Thank you, and have a nice day.")]), _vm._v(" "), _c('p', {
    staticClass: "blq-indent"
  }, [_c('i', [_vm._v("Once more, he appears to be deep in thought before placing his next call. Then he yells to the outer office")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "blq-indent"
  }, [_vm._v("Smyrna! Get me the president of Continental Stores in Chicago. Name’s Albert Martindale. Use the two-four-one credit card. See if you can get him on the line before you put me on the line; you know the routine. But if you can’t, I’ll go through his secretary.")]), _vm._v(" "), _c('p', {
    staticClass: "blq-indent"
  }, [_c('i', [_vm._v("We see SMYRNA placing the call and then, inaudibly, arguing with Martindale’s secretary. Finally, she yells into the inner office")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "hang-indent1"
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("SMYRNA:")]), _vm._v(" Won’t work, Moe! She says put you on the line first, then she’ll put Martindale on.")]), _vm._v(" "), _c('p', {
    staticClass: "hang-indent1"
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("MINSKOFF")]), _vm._v(" "), _c('i', [_vm._v("(sighs):")]), _vm._v(" Okay. "), _c('i', [_vm._v("(He picks up the phone.)")]), _vm._v(" Moses Minskoff here.… Yes, thank you.… Ah, Mr. Martindale! How are "), _c('i', [_vm._v("you? …")]), _vm._v(" Well, you may recall that you and I have been in correspondence about some shares of Tarkington stock which I own, and which you have made an offer to purchase in connection with your—ah—proposed acquisition—I dislike the term “hostile takeover”—of the Fifth Avenue store. As you may know, Mr. Martindale, I am something of an expert in the field of mergers and acquisitions, and, yes, I am considering selling my own small number of Tarkington shares to your investment group.…")]), _vm._v(" "), _c('p', {
    staticClass: "blq-indent"
  }, [_vm._v("Yes, but first let me tell you that, since the founder’s sudden death, the situation has changed somewhat.… Yes, the situation has changed considerably, Mr. Martindale. But permit me, if you will, to move back in time a bit. To begin with, Silas Tarkington was my oldest and dearest friend. He helped me start in my business, and I helped him start in his. I was perhaps his closest confidant. Over the years, in addition to being permitted to purchase small amounts of stock in his company, I was able to advance him certain amounts of cash from time to time. These loans, in the form of informal IOU’s, are still outstanding in my accounts receivable files.")]), _vm._v(" "), _c('p', {
    staticClass: "blq-indent"
  }, [_vm._v("Now, not long before his sudden death—just a couple weeks ago, in actual fact—Mr. Tarkington hinted to me that he felt his life might be in danger. He mentioned nothing that was actually specific, but as you and I know, any rich and successful man such as Si Tarkington—or even you yourself, or even I myself—is bound to acquire his share of enemies. In fact, when he mentioned his imminent death to me, I wasn’t even sure whether or not he was contemplating suicide.")]), _vm._v(" "), _c('p', {
    staticClass: "blq-indent"
  }, [_vm._v("The real point is that, when I learned that he feared he didn’t have long to live, I decided that it would be prudent if I were to call in these IOU’s. Collecting debts from the estate of a deceased person can be damnably complicated, as I’m sure you know, so I approached him on that specific subject.")]), _vm._v(" "), _c('p', {
    staticClass: "blq-indent"
  }, [_vm._v("I said, “See here, old sport, I think it’s time you settled my account and not leave your poor widow and children arguing with my lawyers.”")]), _vm._v(" "), _c('p', {
    staticClass: "blq-indent"
  }, [_vm._v("What he told me then, frankly, shocked me. He told me that the store was experiencing severe cash-flow problems. He told me that Tarkington’s had accounts receivable in the amount of many millions of dollars. He hinted that someone within his organization may have been embezzling from him, may have been cooking the books, may have had his hand in the till, and that he was on the verge of discovering who that person was.")]), _vm._v(" "), _c('p', {
    staticClass: "blq-indent"
  }, [_vm._v("In short, he was unable to repay the various debts he owed me.")]), _vm._v(" "), _c('p', {
    staticClass: "blq-indent"
  }, [_vm._v("Are you still with me, Mr. Martindale? … Why am I telling you all this? Because, Mr. Martindale, if you will let me broker this acquisition for your company, I would be willing to forgive those IOU’s, or at least offer them to you at a seriously discounted rate, thus facilitating your purchase greatly.")]), _vm._v(" "), _c('p', {
    staticClass: "blq-indent"
  }, [_vm._v("Greatly, Mr. Martindale. Greatly. I think you can hear what I am saying. Sound good to you?")]), _vm._v(" "), _c('p', {
    staticClass: "blq-indent"
  }, [_vm._v("And that’s not all I can offer you, Mr. Martindale. If the small matter of Si Tarkington’s indebtedness to me were all I was telephoning you about, I would not be wasting yours and my valuable time, now, would I? As you know, Si Tarkington ran his business in a way that was unusual, not to say unique. Yes, unique is the right word. After all, Tarkington’s is unique among American fashion retailers. Si Tarkington always kept the store’s figures very close to his vest. It was never clear, for instance, what the store’s markup was. As often as not, Si’s markup was a matter of whim. His suppliers, those who created his “Ours Alone” line, were equally secretive about their prices. And it was never clear where, and how, he disposed of his unsold inventory, though it was obviously sold somewhere. Back in ’eighty-nine, when the F.T.C. boys came to review the store’s operations, I remember Si chuckling—heh, heh, heh—about how the F.T.C. boys spent three weeks shuffling through piles of paper and went away scratching their heads.")]), _vm._v(" "), _c('p', {
    staticClass: "blq-indent"
  }, [_vm._v("But I am in a unique position, Mr. Martindale, to offer you the store’s actual sales figures. I’m talking the day-to-day sales figures, department by department, for the last twenty-four months or longer—the full and complete set of the company’s books. The person who controls these books is in my pocket, Mr. Martindale. And I can promise you that these figures will not amount to what you have been led to believe. Tarkington’s has suffered from the recent recession as much as other retailers, if not more so, considering the upscale nature of the store’s trade. I can supply you with the full list of accounts receivable. I can also supply you with an exact dollar figure for the store’s current inventory, which, I can also assure you, is worth nowhere near what you have been told.…")]), _vm._v(" "), _c('p', {
    staticClass: "blq-indent"
  }, [_vm._v("What would you do with this information? Well, Mr. Martindale, under one scenario I’m thinking of, if the news were leaked to your competitors that you have these figures and that the property is being offered at an inflated price—well, if you’re lucky, Mr. Martindale, your competitors will drop out of the picture, and the property will be yours. And you will have it at a distress-sale price, costing your company considerably less money. You’d have the advantage of knowing exactly what you’re getting for your money, a not inconsiderable advantage, it seems to me. Of course, once you acquire the property, you can do whatever the damn hell you want with it. The Tarkington name—one of the top fashion names in the world—has some value, though it’s hard to put a dollars-and-cents price on the value of a name. And the Fifth Avenue building has some value. But if your competitors were to learn that Continental has the precise operating figures.… Yes, I’d be happy to engineer that leak for you, Mr. Martindale, as part of our deal.")]), _vm._v(" "), _c('p', {
    staticClass: "blq-indent"
  }, [_vm._v("And I’d like to throw in one more offer, sir, while I have you on the line. In any proposal that is placed before Tarkington’s stockholders, there is one important stockholder whose vote will be pivotal, and I have that particular stockholder in my pocket, Mr. Martindale. That particular stockholder will vote whichever way I tell he or she to vote.… No, I’m not at liberty to reveal that stockholder’s name at this point in our negotiations, Mr. Martindale.… No, I can’t tell you whether that stockholder is a family member at this point in time. I can only say that he or she will have the swing vote, and without that vote you’re out of the ballpark, sir.…")]), _vm._v(" "), _c('p', {
    staticClass: "blq-indent"
  }, [_vm._v("Why am I making this offer to you? Well, let me put it this way. I’ve always admired the way you do business. And I understand that the other two serious bidders for the store are one of your arch-rival chains in the U.S. and a retail chain in Canada. Just say I’m enough of a red-blooded American to want to see Tarkington’s stay in American hands, the "), _c('i', [_vm._v("best")]), _vm._v(" American hands.…")]), _vm._v(" "), _c('p', {
    staticClass: "blq-indent"
  }, [_vm._v("My fee? Well, let’s say that would be negotiable, at the time you and I are ready to hammer out a contract. We wouldn’t call it a finder’s fee, exactly. I’d like to see it as a facilitator’s fee. Some sort of percentage that we’d both agree on.… Well, you do that, Mr. Martindale. You think about it. But don’t think about it too long. The heirs are anxious to get the estate settled.… No, there’s nobody in the family gives a damn about running the store, except maybe the daughter, who works there. But she’s just a kid. No experience. Too wet behind the ears. She’ll be easy to handle.… So, nice talking with you, Mr. Martindale. Let me hear from you by—let’s say Friday, latest. Thank you, sir, and you have a nice day, you hear?")]), _vm._v(" "), _c('p', {
    staticClass: "blq-indent"
  }, [_c('i', [_vm._v("He hangs up the phone, tilts back in his big chair, and rubs his belly. Then he makes another call, this time a local one")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "blq-indent"
  }, [_vm._v("Tommy Bonham, please, Moe Minskoff calling.… Well, if he’s out, where is he? … See if you can locate him, sweetheart. Tell him I need to talk to him right away. Tell him it’s urgent.")]), _vm._v(" "), _c('p', {
    staticClass: "blq-indent"
  }, [_c('i', [_vm._v("He hangs up again and dials another local call")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "blq-indent"
  }, [_vm._v("Eddie? Moe here. Listen, I need some new phone credit card numbers. Last ones you give me is turning into duds already. Get me corporate card numbers. They last the longest. Those individual numbers don’t last shit.…")]), _vm._v(" "), _c('p', {
    staticClass: "blq-indent"
  }, [_vm._v("Whaddaya "), _c('i', [_vm._v("mean")]), _vm._v(" how do ya get ’em? Same way you always get ’em. Go out to the airport, hang around the pay phones, and when you hear some guy give his number, "), _c('i', [_vm._v("write it down")]), _vm._v("—what’re you, some kind of jerk? And if he starts punching in numbers, watch what numbers he punches. You got "), _c('i', [_vm._v("eyes")]), _vm._v(", ain’tcha? Watch, and make a mental note. And remember what I told you about delayed flights. Check the TV screens for delayed flights. That’s when guys call their boss, or their wife or girlfriend, or who’s meeting their plane, to say they’ll be late. Just act like you’re waitin’ to use the phone.…")]), _vm._v(" "), _c('p', {
    staticClass: "blq-indent"
  }, [_vm._v("Whaddaya "), _c('i', [_vm._v("mean")]), _vm._v(" the price has went up? Listen to me, you little shmuck, there’s about fifteen thousand other shmucks out there who can do what you do for me! You want this job or not? … Okay, that’s more like it. The price stays the same, two bucks a pop. Now get out to La Guardia and start shlepping. I need fifty new numbers by five o’clock.")]), _vm._v(" "), _c('p', {
    staticClass: "blq-indent"
  }, [_c('i', [_vm._v("He slams down the receiver. Now he eases himself out of his chair. He checks the wall safe, then walks into the outer office")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "hang-indent1"
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("MINSKOFF")]), _vm._v(" "), _c('i', [_vm._v("(to Smyrna):")]), _vm._v(" Christ, I’m starving to death. I haven’t had anything to eat all day. Doctor keeps telling me I gotta take off sixty pounds, but a man’s gotta eat something, don’t he? I’m going across the street to Harold’s and grab a bite. If they locate Bonham, come get me.")]), _vm._v(" "), _c('p', {
    staticClass: "blq-indent"
  }, [_c('i', [_vm._v("Smyrna merely nods, not looking up from her magazine. He exits. Cut to: Interior, Harold’s Diner, a seedy luncheonette with a counter and butt-sprung stools, most of which have been taped together with masking tape. HAROLD, in a dirty white apron, stands behind the counter")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "blq-indent"
  }, [_c('i', [_vm._v("MINSKOFF enters, takes a seat at the counter, experiencing some difficulty squeezing his large frame between the stool and countertop")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "hang-indent1"
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("MINSKOFF:")]), _vm._v(" Harold, I keep tellin’ ya, ya got these stools too close to the counter. I got a friend in the bar fixture business. He could get ya some stools—")]), _vm._v(" "), _c('p', {
    staticClass: "hang-indent1"
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("HAROLD:")]), _vm._v(" Always sellin’ somethin’, ain’tcha, Moe?")]), _vm._v(" "), _c('p', {
    staticClass: "hang-indent1"
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("MINSKOFF:")]), _vm._v(" Just trying to be of service. I’m in a service business, after all.")]), _vm._v(" "), _c('p', {
    staticClass: "hang-indent1"
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("HAROLD:")]), _vm._v(" Well, what’ll you have today?")]), _vm._v(" "), _c('p', {
    staticClass: "hang-indent1"
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("MINSKOFF:")]), _vm._v(" Let’s see. "), _c('i', [_vm._v("(Studies the plastic-coated menu.)")]), _vm._v(" Gimme a bowl of your chili, a double bacon cheeseburger heavy on the mayo, a large fries, a large onion rings, and a diet Pepsi.")]), _vm._v(" "), _c('p', {
    staticClass: "hang-indent1"
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("HAROLD:")]), _vm._v(" Cash only, Moe. Remember my policy. Credit makes enemies. Let’s be friends.")]), _vm._v(" "), _c('p', {
    staticClass: "hang-indent1"
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("MINSKOFF:")]), _vm._v(" Cash, shmash.")]), _vm._v(" "), _c('p', {
    staticClass: "blq-indent"
  }, [_c('i', [_vm._v("He reaches in his back pocket and pulls out a large wad of bills. He waves this in front of Harold’s face before replacing it in his pocket")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "hang-indent1"
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("HAROLD")]), _vm._v(" "), _c('i', [_vm._v("(whistles):")]), _vm._v(" Comin’ right up, Moe!")]), _vm._v(" "), _c('p', {
    staticClass: "hang-indent1"
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("MINSKOFF")]), _vm._v(" "), _c('i', [_vm._v("(sighs, removes the unlighted cigar from between his clenched teeth, and balances it carefully on the counter’s edge):")]), _vm._v(" Hit an Exacta in the sixth at Belmont. Yeah, it’s been a pretty good week, all things considered. It ain’t gonna be long now before Honeychile and me can hang it all up and retire to the Bahamas.")]), _vm._v(" "), _c('p', {
    staticClass: "center2"
  }, [_c('span', [_c('i', [_vm._v("Blackout")])])])])])
}]}

/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(92),
  /* template */
  __webpack_require__(93),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 92 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 93 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "chap-title"
  }, [_c('span', [_c('i', [_vm._v("3")])])]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_vm._v("As she steps from the bright summer sunshine of the street into the seductively lighted Cafe Pierre, it takes a few moments for Miranda Tarkington’s eyes to grow accustomed to the gloom. She removes her sunglasses, and then she sees him. As usual, a tall, sleek, and expensively put-together woman has stopped at his banquette to talk to him, and Miranda watches the two of them in animated conversation. Tommy Bonham, she often thinks, must know every woman in New York, or at least every important woman in New York, and of course this is all a part of being vice president and general manager of Tarkington’s. Even today, when the store is closed, Tommy is doing business. Miranda watches as Tommy rises and kisses the tall woman’s outstretched hand to bid her adieu and the tall woman returns to her own table.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Who dat?” Miranda whispers as she slides into the banquette beside him. “Me think-um big-time rich squaw, huh?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Rich Texas broad,” he mutters out of the side of his mouth, still smiling in the direction of the departing woman’s back. “Came over to complain about the store being closed today. Can you believe it? Not a word about your father’s death. Just, When’s the store going to open? She needs an evening bag for a party tomorrow night. ‘Just a little clutch bag, but it’s got to be silver.’”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Not one of our latchkey ladies?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Are you kidding? Broad’s a kleptomaniac. She likes it when I wait on her, but she doesn’t know it’s because I have to watch her like a hawk whenever she’s in the store.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("From across the room a redheaded woman in a red Ungaro suit and a pink blouse waves at them and blows an air kiss, mouthing the words, “Hello, darlings!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Miranda blows an air kiss back, and Tommy smiles in the woman’s direction. When he smiles, he has three dimples—one on each cheek, and one on his chin.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Mona Potter,” Miranda whispers. “This means we’ll be in her column tomorrow morning.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Bitch owes us fourteen thousand dollars,” Tommy mutters. “She thinks she can pay her bill with column mentions.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Poor Tommy,” Miranda says. “I’d like a Lillet,” she says to the waiter who has approached them.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Certainly, Miss Tarkington,” he says, “and may I tell you how saddened we all were by the news of your father’s death? He often came in here, you know. We were all very fond of him.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Thank you,” Miranda says. “That’s very kind of you to say.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“And of course everybody’s wondering—will Tarkington’s ever be the same? Can it ever be the same without him?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I think it’s safe to say that Tarkington’s will always be Tarkington’s,” she says. “Right, Tommy?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Absolutely.” He nods his head in agreement. “Well,” he says, after the waiter has departed, “how’d it go with the lawyers?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Oh, not very well, I’m afraid,” she says. “Blazer made a terrible scene. I knew damn well he would. Because Daddy made good on his threat. He didn’t leave Blazer a penny. I don’t know why Blazer even came this afternoon. In fact, I called him this morning, and I said to him, ‘Blaze, honey, please don’t come to this meeting this afternoon, ’cause I don’t think you’re going to like what you’re going to hear in Daddy’s will.’ But he said, ‘No, I want to have the last word with the old son-of-a-bitch.’”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“And so he did.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Of course, and he began shouting about—oh, you know, Daddy’s girlfriends and all that. And about Smitty. And Mother just sat there, looking beautiful, saying nothing, as though she had ice water in her veins. Can you understand it? I know I could never put up with a husband who was flagrantly unfaithful to me, and "), _c('i', [_vm._v("all the time")]), _vm._v("! Could you? Could you put up with a wife who was unfaithful to you all the time?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He smiles. “Since I’ve never had a wife, I can’t say,” he says.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“That’s probably why you’ve never had a wife. To spare yourself that aggravation.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He merely lowers his eyes and stirs the olive, on its toothpick, in his martini.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“But Mother—she seems just as unconcerned about Daddy’s womanizing now that he’s dead as she was when he was alive. Maybe someday you can explain my mother to me, Tomcat.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I think,” he says carefully, “that your mother’s a very brave woman, Mandy.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Very brave or very stupid. Or maybe brave and stupid are the same damn thing.” She flips her chestnut ponytail with her left hand. “Anyway, I’ve stopped worrying about what my mother’s feelings are. But poor Blazer, on the other hand—”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Mandy,” he says, “maybe I shouldn’t say this, but don’t you think Blazer had it coming to him? He treated his father like shit, and your father wasn’t a man who liked to be treated like shit.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Oh, I know, I know. And particularly after that last big row of theirs. But still—”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“He threatened your father, Mandy. He tried to—”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I know, I know. But I think what hurt Blazer most of all was not being mentioned in the obituary this morning. It was like reading that he didn’t exist.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He shakes his head. “I don’t know how that happened,” he says. “I gave "), _c('i', [_vm._v("The Times")]), _vm._v(" all that information. Want me to see if I can get the paper to print a correction, mentioning that Silas R. Tarkington, Junior, was inadvertently omitted from the obit? They’re pretty good at doing things like that for us.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“No. No, I don’t think so. That would be like rubbing salt in his wounds. Like saying, ‘Oh, and we forgot to mention that he also had this son.’ No, the harm’s been done.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“If Blazer had ever tried to make anything of himself, it might have been different. But face it, Mandy, your half brother’s a bum.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She nods mutely, in agreement. “Still, he was always nice to me when I was growing up. And—in fact—it turns out that at the last minute Daddy was planning to rewrite his will.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Really?” he says, looking at her, interested. “How do you know that?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Jake Kohlberg told us so. He was apparently planning to reinstate Blazer in some way and make some other major changes. But then he—died—and it was too late.… Thank you,” she whispers to the waiter as he places her glass of Lillet in front of her.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“What sort of—major changes?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I don’t know. After Blazer went storming out, I asked Jake if we could see a copy of the new will he’d been drafting, but he wouldn’t show it to us. ‘Lawyer-client confidentiality,’ he said. ‘But I’m his daughter!’ I said. ‘And I’m his lawyer,’ he said. Stupid lawyers.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Hmm,” he says.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Anyway, he left you his emerald pinky ring. I thought that was sweet of him. It’s a good emerald, even though you-know-who picked it out for him.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Smitty.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Who else?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Smitty knows her stones. Anyway, I’m touched that he’d leave that to me, Mandy. Of course I could never wear it. It was like his signature. It was "), _c('i', [_vm._v("his")]), _vm._v(" ring. It will always be his ring.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I suppose so, yes.” She sips her Lillet.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“And what about the art collection?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“That was something of a shocker, too. Mother gets to keep up to twenty paintings for her lifetime. The rest go to the museum—"), _c('i', [_vm._v("but")]), _vm._v(" only if you-know-who is made special curator of the collection.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Smitty again.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“How’d you guess? That was a little callous of him, don’t you think, putting Mother and Smitty in the same paragraph of the will? But again, Mother was cool as a cucumber when she heard. Didn’t blink one mascaraed eyelash.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Callous? I’m not so sure, Mandy. It could be his way of giving Smitty a new job. Getting her out of the store—for your sake.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Really? You think so?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“That’s the way his mind worked. He’s left you and your mother a major share of the store’s ownership. And I don’t think Smitty is one of your favorite people.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Really? You noticed that? Well, aren’t you smart, Mr. Tomcat. I "), _c('i', [_vm._v("loathe")]), _vm._v(" Smitty!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“But you have to admit she’s been a good jewelry buyer. Her department’s figures have been among the best in the store.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Unless he let her pad them—among her other special perks.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“No. She never padded any figures. No figures were ever padded.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You mean those are her real boobs? Anyway, it’s nice to hear you speak of her in the past tense.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He winks at her, and she smiles back at him.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Actually,” she says, “I don’t know why I resent Smitty so. It’s not as though she was the first of Daddy’s girlfriends, and she probably wouldn’t have been his last. It was just that—”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“That she was getting to be a little too important to him. In a way, it may be good that he died when he did, before he did something—foolish.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You mean, like—”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“She told me she was going to marry him.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Miranda stares at him, but his eyes, as he sips his cocktail, wander away from hers.")]), _vm._v(" "), _c('p', {
    staticClass: "indent2"
  }, [_vm._v("Whenever Miranda looks at Tommy Bonham, she has never failed to be struck by his extraordinary good looks. “Heck, I was just a little Hoosier hick from Indiana,” she has often heard him say. “Until Si Tarkington plucked me out of a cornfield when I was a kid of twenty-three, on a hunch that I might have some ability, brought me into the store, and taught me everything I know about retailing.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Well, that makes a charming story, but Miranda knows enough about Tommy’s background to know that it isn’t entirely true. What would her boulevardier father have been doing in Indiana? And in a cornfield, no less? No. Tommy may have come from Indiana, but after graduating from Bloomington, where he’d been a theater major, he’d brought himself to New York, hoping to find work as an actor. In New York, Miranda supposes, Tommy’s good looks and—she imagines—his sexuality stood him in good stead. His first job at the store was as a salesman in the shoe department. But he rose fast, very fast—thanks, no doubt, to his good looks.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In his mid-forties, Tommy still has those good looks and that smoldering whiff of sexuality that is as lingering as his Giorgio cologne. But all traces of an Indiana cornfield have vanished, or been banished, by now, except perhaps in his slightly windblown blond hair, his deeply pigmented blue eyes, and that trio of dimples when he smiles. Otherwise, he suggests a cornfield about as much as a polished George III candlestick does. He has a burnished look, a finished look, the look of something designed and crafted with great care. She has heard Tommy Bonham described as “too good-looking,” but if he gets away with such good looks it is mainly because he seems to be so utterly unaware of them.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Miranda Tarkington has known plenty of handsome men—men who are handsome and know it—men whose eyes, when they enter a room, seem to travel on automatic pilot to the nearest mirror. But Tommy’s eyes never do this. They travel to the nearest woman and seem to tell her immediately that she is looking her best. Tommy is not the “"), _c('i', [_vm._v("Dah")]), _vm._v("ling, you look "), _c('i', [_vm._v("mah")]), _vm._v("velous” type. His eyes say that for him. This is also the double secret of her mother’s famous beauty. She appears to be completely unconscious of her looks. And when her azure eyes fix on the person she is talking to, that person suddenly feels that he or she is the most interesting, important, and desirable creature in the universe.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("It is Tommy’s good looks, Miranda often thinks, that have made him ideally suited for working in what is essentially a woman’s store. Tommy’s looks, she is certain, were what made her father elevate him to his second in command. In fact, all her father’s employees were chosen for their looks, Smitty included. Form over substance, any day. Miranda herself would never have been allowed to work in the store if she hadn’t been pretty. And it is interesting that Silas Tarkington should have chosen a man who could have been his wife’s fraternal twin to be his right-hand man. “I have always loved to be surrounded by beautiful things,” her father once said. Miranda sometimes wonders: What did—but it should be "), _c('i', [_vm._v("what does")]), _vm._v(", since she is still alive—Alice Tarkington, who is Blazer’s mother, look like? Miranda doesn’t know. She has never met her, and naturally there are no pictures of her father’s first wife. But Alice must be, or must have once been, a beauty, Miranda thinks.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Like her father, Tommy Bonham has his special ladies whom he always takes care of. When he spots one of Tommy’s special ladies alighting in front of the store from a taxi or a limousine, James, the doorman, presses a special button by his station. This causes a buzzer to sound in Tommy’s office. Then James steps forward, tips his cap, greets the woman by name—he is nearly as good at names as Tommy is—and offers her his hand to help her from her car. Meanwhile, Tommy is bounding down four flights of stairs—he doesn’t wait for the elevator—to greet his client as she enters the store, rather like the concierge at a small, expensive European hotel greeting a longtime favored guest.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Do you have anything to show me, Tommy?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“As a matter of fact, we have several pretty new things,” he says, taking her arm, not intimately but just so.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Other men occasionally feel uncomfortable with men as handsome as Tommy Bonham. Perhaps he stirs in them unwelcome feelings of homoerotic lust. But women fall in love with the Tommy Bonhams of this world. Most of Tommy’s special ladies, Miranda long ago decided, are to some degree or other in love with him. Most rich men’s wives, she also decided, must endure very boring husbands. And so Tommy, being unmarried, is able to perform, for his special ladies, all sorts of little tasks that their husbands have no interest in, or are unwilling or unable to take on. In addition to helping them select the perfect pair of sandals for the perfect ball gown, he takes them to lunch. He suggests new things they might do with their hair. He helps them decorate their apartments, escorts them to charity balls, to opening nights at the theater, to the shows at the galleries along Fifty-seventh Street and upper Madison. He listens to, and sympathizes with, their various tales of bitterness and woe. All this, of course, has been good for business and the store, and Miranda has often wondered how far these relationships have gone. But Tommy is too smart, she thinks, to have let any of these relationships progress through any bedroom doors. And he has been careful to spread the largesse of his attractive company around, so his name has never been attached to any of his special ladies as that lady’s special walker or, as they say in England, laughing-man.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The comparison of Tarkington’s to a small European hotel is an apt one, and in her father’s monthly meetings with his staff he often said, “We must always remember to treat our clients as our guests.” For the store’s best clients, Tommy’s office will make hotel, restaurant, and airline reservations. It will make massage and even dental appointments. It will suggest lawyers for divorces, doctors for plastic surgery. Last year, Tommy even escorted one of his special ladies as she toured New England, shopping for a boarding school for her son.")]), _vm._v(" "), _c('p', {
    staticClass: "indent2"
  }, [_vm._v("When Miranda first met Tommy—it was at the farm in 1980, when she was just thirteen—she fell in love with him herself. She was down from Ethel Walker for the weekend, and he came for the weekend too, and she thought he was simply the most gorgeous hunk of man she had ever met. Encountering him the next morning by the pool, clad only in his white bikini, she had been so embarrassed that she had run into the pool house, pretending to hear the telephone ring, rather than spend time with him in that nearly nude state. She carried fantasies of him with her back to school. Then, of course, she fell in love again with someone else, then out of love again. Then in love again, and out of love, with still another boy. Half of her life, she sometimes thinks, has been spent falling crazily in and out of love, each time harder and more cruelly than the last. There was even a time when she was convinced that she was in love with Blazer, her own half brother, rationalizing that, while sex with one’s full brother was definitely taboo, sex with one’s half brother would only be half bad—not that anything of the sort came close to happening.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Once she confessed to Kathy Williams, who had been her best friend at Walker, that there were times, when she was with a boy, that she had felt land of an electric shock down "), _c('i', [_vm._v("there")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You’re obviously a nymphomaniac,” Kathy had told her. Then Kathy had made a confession of her own. “I’m a lesbian,” she whispered. After that, Miranda never felt quite the same way about Kathy Williams. And she had also stopped signing the entries in her secret diary “M.T.T.,” which would become her stylish monogram when she married Blazer and became Miranda Tarkington Tarkington.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("At school and college, she had taken her good grades for granted. After all, good grades were what her parents expected of her. Then, when she was twenty-one, a senior at Sarah Lawrence, and was handed a gold Phi Beta Kappa key, she suddenly discovered she was smart. Smart women with Phi Beta Kappa keys didn’t fall in love, she decided. They had careers.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She had always loved the store. It had been her private castle, and the precious items it displayed she pretended were her personal treasures. And so, though her father had initially disapproved, she had persuaded him to let her go to work at Tarkington’s. She had started, at her father’s insistence, in the mail room, at the bottom—“Where you’ll discover that running a store like this isn’t all glamour”—sorting and delivering the letters and memos, delivering the copies of "), _c('i', [_vm._v("The Times, The Wall Street Journal")]), _vm._v(", and "), _c('i', [_vm._v("Women’s Wear Daily")]), _vm._v(" to the men on the executive floor, men like her father and her old crush Tommy Bonham, whose offices were in the older part of the building that had been the Van Degan house—big, walnut-paneled offices with high ceilings and tall windows facing Fifth Avenue and the park, offices that smelled of old wood and wax and leather—and to the less high-ups, the merchandise managers and buyers, whose offices were in the new L-shaped addition where, though efforts had been made to replicate the grandeur of the old building on the selling floors, the offices were often small, low-ceilinged, and windowless—and smelled new.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Delivering interoffice mail might have sounded like a dull job, but Miranda discovered that it didn’t have to be. She could read all the memos and learn what the buyers were buying and how much they were spending. She learned about the store’s markup policy, which was nothing if not whimsical; buyers marked up their merchandise to what they thought the traffic would bear. She also learned a lot about the politics of storekeeping: who was in favor and who was not, which departments were in trouble, and why, and what was going to be done about it. She learned that, though her father officially made all the decisions, it was really Tommy Bonham who ran the store.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Then, after her stint in the mail room, she had worked as a secretary for the sportswear buyer. Then she had been made an assistant buyer, which was just a fancier term for secretary. Then her father had given her the title of Director of Advertising.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("It was a flashy title, but it didn’t mean a hell of a lot, and her father certainly knew that when he created the position for her six months ago. After all, the store’s advertising was so-called institutional advertising—just advertising the store’s presence, never any specific merchandise—and it was always the same, just a way of saying rather grandly to the public, “We’re here.” Mostly, her father had explained to her, her job would consist of ordering the ad space, making sure the store got the column inches it ordered, keeping the scrapbooks, and periodically being taken to lunch by space salesmen.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Still, right from the beginning, Miranda had tried to make the job into something more than that. She had designed a new, and snappier, company letterhead and bill head. “Our bills and letters look as though they were being sent out by a Wall Street law firm,” she said to her father, showing him her new designs.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“That’s what I like about them,” he said with a smile.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Next, she had suggested colorful bill stuffers. The store had just opened a tiny new gift boutique with one-of-a-kind treasures, bibelots, and boxes, including a pair of rare Romanov Easter eggs designed by the court jeweler, Peter Carl Fabergé. Miranda proposed announcing the new boutique with a bill stuffer showing a color photograph of the eggs.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Bill stuffers are just that,” her father said. “Just stuff. They’re an annoyance. They go straight into the wastebasket, like the renewal slips that keep falling out of the pages of magazines. My kind of woman wouldn’t like them.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Her next campaign had been to have Tarkington’s produce a catalogue.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Catalogues are not our style,” her father said.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Saks does lovely catalogues. So does Bloomingdale’s. So do—”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“My kind of woman would give a catalogue to her cook, who’d use it to wrap yesterday’s fish. A catalogue would cheapen us, Miranda.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“But more and more people are shopping from catalogues. There was an article in yesterday’s "), _c('i', [_vm._v("Times")]), _vm._v("—”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“And where is yesterday’s "), _c('i', [_vm._v("Times")]), _vm._v("? Being used to wrap yesterday’s fish. There are too many catalogues coming in the mail nowadays. People just toss them out. People come from all over the world to experience our "), _c('i', [_vm._v("store")]), _vm._v(". Our store provides the Tarkington’s experience. The Tarkington’s experience cannot be conveyed through a catalogue, Miranda.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Gucci has a catalogue, Tiffany has catalogues. So does Cartier. Of course ours would be the most beautif—”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Does Harry Winston have a catalogue?” he asked her.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“No,” she admitted.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You see? I am in the Harry Winston league.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Try as she might, she had been unable to rock the boat or to change what had become “the Tarkington’s way of doing things.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Under the mantle of Advertising came Publicity, but since the store eschewed most publicity and closely guarded the names of its celebrity clients, that side of her job hadn’t yet amounted to much either. Frustrated, Miranda had often thought that any lackey could do what she did. She didn’t even require a secretary. But she had decided to take her job seriously, nonetheless, to be patient and wait for the day when her father might take one of her ideas seriously and take "), _c('i', [_vm._v("her")]), _vm._v(" seriously—and pay her more than $30,000 a year.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Retailing’s a man’s business,” her father often said to her. “Women just don’t take to it—except as buyers and salesgirls.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Which was a damned lie, and she could have told him so, but she didn’t. What about Dorothy Shaver of Lord & Taylor, Geraldine Stutz of Bendel’s, and Jo Hughes of Bonwit’s and Bergdorf’s? Those were all legendary women—legends in their day—just as legendary as Silas Tarkington, for God’s sake! Those legendary women were all dead now, or retired, and so wasn’t the business ready for some new, young, talented female blood? But she had held her tongue.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Instead, she had enrolled in some weekday evening classes in marketing and business at N.Y.U. It would be years before she got an M.B.A., but what the hell? She was learning something. And, because she knew what her father would think of this particular endeavor, she had held her tongue about that, too.")]), _vm._v(" "), _c('p', {
    staticClass: "indent2"
  }, [_vm._v("Now, after a little more than three years with the store, she is still patiently waiting for something to do where she will be asked to make a decision or at least to offer an opinion. After three years with the store, Thomas E. Bonham III is just another properly aloof executive, her father’s second in command, and his extraordinary good looks are just a familiar part of Tarkington’s general landscape, no more remarkable than the six Baccarat chandeliers that light the center aisle of the street floor. Who must she get to take her seriously now? she wonders. Tommy Bonham, of course.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("As though he had been reading her thoughts, he says, “One thing I wanted to ask you. When do you think we should reopen the store? With all due respect to your dad, do you think just being closed today in his memory is enough?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Absolutely,” she says firmly. “I think we should open for business tomorrow morning at ten o’clock, business as usual. I think Daddy would have wanted that. And I certainly hope we’re not going to drape the windows with black bunting, or have the salespeople wear black arm bands, or anything. Daddy would have hated that.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I agree,” he says. “So we reopen tomorrow and act as though nothing has happened, even though something monumental has.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Yes,” she says, and realizes, with a start, that she has just been asked for her opinion.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Of course,” he says, “I don’t really know who’s supposed to be running the store now that he’s gone. I don’t suppose there was anything said about that in his will.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“No, but obviously you are. You were always the heir apparent, Tommy.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Well, I don’t know,” he says with a faint smile. “There’s a board of directors and shareholders to consider.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Well, you’ve obviously got my vote, Tomcat,” she says, and immediately wishes she hadn’t said that. Now that she finds herself a major shareholder, she mustn’t start acting as though she thinks she’s Tommy’s boss or something, though, in a sense, she is.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“What about your mother?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Mother’s never had that much interest in the store, as you know. But I’m sure she’d agree with me. You’re the obvious man to take over.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Well, suppose I serve as president pro tern,” he says, “until the shareholders decide what course they want to take. You know there’ve been several outside offers to buy the business. Some of the shareholders may decide they’d like to sell.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“And let Tarkington’s become part of a chain? I don’t think any of us would like to see that happen.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I guess there was no mention of that in your dad’s will, either.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She shakes her head.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“So if it’s okay with you I’ll call a little meeting, before we open the doors in the morning, and explain that I’m assuming the title of president pro tern. After all, somebody’s got to run the place.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Absolutely,” she says, thinking: "), _c('i', [_vm._v("If it’s okay with you!")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Actually, I’m a little surprised your father made a will,” he says. “With all due respect to your dad—he was my closest friend, you know—men like him sometimes begin to think they’re immortal. They don’t make wills, because making a will reminds them that they’re not. Don’t misunderstand. I don’t mean to speak ill of your dad. I loved your dad.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I understand.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“And if I do end up becoming the store’s new president, I want to give you a position of real responsibility, Mandy. Your talents are being completely wasted in that advertising job, as I guess you know.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Well, "), _c('i', [_vm._v("I")]), _vm._v(" think so,” she says.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“And—you know—I was thinking before you got here, Tarkington’s has always seemed like a kind of mom-and-pop operation, what with your mother and dad living in the apartment upstairs. A kind of cozy, family atmosphere. I think that’s always been a part of Tarkington’s special aura, its special charm.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Daddy used to say he liked his clients to feel as though they’d been invited into Buckingham Palace. Or were staying at the Paris Ritz.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He laughs softly. “Well, you see? The Queen and Prince Philip live over the store, too. But I was thinking, what if you and I were to run the store as a partnership?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Partnership?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“As co-presidents, perhaps.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Co-"), _c('i', [_vm._v("presidents")]), _vm._v("?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Why not? Another mom-and-pop operation.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Oh, I don’t think I’m quite ready for that,” she says. “I don’t know as much about the business as I need to know. I’ve never even been out into the market, for instance. I’d need—”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I’d teach you everything you need to know,” he says.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“But I don’t have your experience, your—”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You could be in charge of what I call the creative end of the operation. I could be in charge of the financial end. That’s the way your father and I more or less divided things up for the past half dozen years or so.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“But as co-president?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Fifty-fifty partners. A team. Most of our clients are women, after all. I think they’d like the idea of knowing there was a woman at the top. And I know how much you love the store.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“That’s true, but—”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You see, I’ve always thought you had great retailing talent, Miranda. You’ve got the innate "), _c('i', [_vm._v("feel")]), _vm._v(" for it, the nose for it. Retailing’s in your blood, and why shouldn’t it be? You’re your father’s daughter.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She sips her wine thoughtfully. She would like to say, But in the two years I’ve been with the store, you hardly seemed to notice me. It was never more than a nod or a smile or a wave of your hand in my direction when we encountered each other in the hall. Months would go by, and you never seemed to know I was there. When did you notice this great retailing talent of mine—which, in fact, I do possess? But instead she says, “This is a big responsibility you’re suggesting for me, Tommy.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I know you’re up to it. I know you’d do a superb job. You and me, in tandem, at the top.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I’m certainly flattered, Tommy, but—why didn’t you ever mention this to me before? That you thought I had some talent.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I couldn’t. Your father had some pretty old-fashioned ideas about women in top spots in retailing. And after all, your father was my boss. I’m just telling you now what I’ve always thought, what I’ve noticed about you all along. I’d just like to see you become the great retailing genius that your father was.” He fixes his deep-blue eyes on her intensely. “I’m quite serious, Miranda,” he says.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Well, let me think about it,” she says. “After all, all I’m doing at the moment is buying the same ad space, for the same ads, in the same publications, week after week.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Pretty boring, isn’t it?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“True enough.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“And this idea of mine excites you, doesn’t it? I can tell it does.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She nods and takes another sip of wine. “You’re right, it does,” she says. She stares deeply into her wineglass. Co-president!")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Then do we have a deal?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("But at that moment, the maitre d’ approaches them with a white cellular phone in his hand. “Telephone for you, Mr. Bonham,” he says.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Tommy holds up his left hand. “No calls, Jean,” he says.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“It’s a Mr. Minskoff calling, sir. He says it’s urgent.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Tell him I’m not here. Tell him I just left. Tell him anything you want. I’m taking no calls.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("And now Mona Potter, in her red Ungaro suit, is also approaching their table. “When’s Tarkington’s going to open up again?” she demands in her loud voice. “I need to know for my column. And Miranda, sweetie, from you I need to know how it feels to’ve inherited a bundle of your old man’s money.”")])])])
}]}

/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(95),
  /* template */
  __webpack_require__(96),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 95 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 96 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "chap-title"
  }, [_c('span', [_c('i', [_vm._v("4")])])]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_vm._v("As Connie Tarkington and Jake Kohlberg wait for the light to cross Forty-second Street, they hear a woman waiting next to them say to a friend, “Look, isn’t that Consuelo Tarkington? It "), _c('i', [_vm._v("is")]), _vm._v("! Jeez, I wish I had her money!” Jake responds by looking down at his feet, and Connie by removing an oversize pair of sunglasses from her purse and putting them on. The light changes, Jake takes her arm, and they cross the street together, heading north.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Jake chuckles. “Those shades aren’t going to help you one damn bit,” he says. “You’re still one of the ten best-dressed women in the world. You’re still a celebrity.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She sighs and says nothing, the heels of her Chanel pumps clicking on the sidewalk. Then she says, “Where are you taking me?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“To the Yale Club, where we can have a quiet talk. Yale men are trained not to make noisy comments about their beautiful women guests.” Ahead of them, the blue-and-white flag flutters in the breeze from its mast. They mount the short flight of steps to the club, and the uniformed guard at the reception desk says, “Good afternoon, Mr. Kohlberg,” and nods politely to Connie.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("They find a quiet corner of the east sitting room and settle themselves in a pair of large easy chairs. Connie crosses her legs and lets the heel of one blue pump dangle from the tip of her toe.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("A waiter approaches them. “Tea, Mrs. Tarkington?” he asks.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Yes, please. Lemon, no sugar.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I’ll have a brandy,” Jake Kohlberg says. “Courvoisier.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Well,” she says after the waiter has departed, “maybe it will be nice not having to worry about being on the Best-Dressed List. Not having to worry about being a walking advertisement for Tarkington’s.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You’ve always been the best. The best there ever was.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Her lips part slightly to expose perfectly white and even teeth. “As Blazer said—like one of the mannequins in his Fifth Avenue windows.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Ah, you’ve been more than that, Connie. Much more than that.” To change the subject slightly, he chuckles softly again. “So many funny stories about Si,” he says. “Is it true he once went up to the apartment and took some dresses out of your closet when he couldn’t find anything in the store that a customer wanted?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Oh, that sort of thing happened all the time,” she says. “I was always going into my closet to get out a particular dress, only to find that he’d taken it out and sold it to one of his ladies. I’d find other things in my closet, too. And in other places.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Hmm? What sort of things?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Oh, like a pair of panties between the sheets when my maid went to turn down the bed. Or a box of tampons on the closet floor.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Now, Connie, don’t brood about those things.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I’m not brooding, Jake. You asked me what sort of things I found, and I told you. There were other things. Worse things.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("His brandy arrives, and her tea, and the waiter pours it for her.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Let’s talk business for a minute,” she says when they are alone again. “Am I really going to be rich?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Oh, I think you’re going to be very comfortably off,” he says. “The houses, the other properties, the shares in the store—”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“How many shares will I own?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Well, Si owned about thirty percent of the shares outstanding. That, divided by two, would give you and Miranda each about a fifteen-percent additional position in the company.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Plus the shares he gave us both from time to time—Christmases, birthdays, that sort of thing. But that wouldn’t give us a majority position, would it?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Probably not. You’d each own roughly twenty percent.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“How much would these shares be worth, do you suppose?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“That’s hard to say until we’ve had a chance to examine the books. Inventory. Accounts receivable. That sort of thing.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Of course.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“And I should warn you, Connie, that Moses Minskoff—whose name you mentioned this afternoon—has already resurfaced. He claims to be in possession of some IOU’s of Si’s, some promissory notes, representing loans he made to Si over the years. Of course until I’ve had a chance to examine these documents I’ve no way of knowing whether they’d stand up in a court of law. But I thought I should warn you that this Minskoff character has already started making sword-rattling noises.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She shivers. “How did Si ever get mixed up with a man like Moe Minskoff?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He sighs. “Well, there were times in your husband’s business when he needed ready cash, and needed it in a hurry. Minskoff was there to provide it.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She taps her lacquered fingertips on the tabletop. “He used my husband, and the store, to launder his filthy money—which came from God knows what crooked source!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Well,” he says with a small smile, “when a man needs ready cash and someone else is on hand to supply it, he doesn’t always question the source of the cash too closely.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I suppose not. But still—Moe Minskoff. Of all the people in the world—”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“That’s why I want to handle the Minskoff situation very carefully, Connie. I don’t want anything about this to get into the press. I don’t want anything to come out that would damage the store’s reputation. Meanwhile, I think a more important question is, who’s going to run the store now that Si is gone?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Well, I can’t run it, and couldn’t even if I wanted to, which I don’t. Miranda’s always said she’d like to run the store some day, but she hasn’t had any real experience. Retailing is a—a "), _c('i', [_vm._v("jungle")]), _vm._v(". Si often said so. And Miranda knows nothing about that jungle. Of course, that’s Si’s fault, too, in a way. He never wanted her to get any real retailing experience. He never even wanted her to work for the store.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“So I suppose it’ll be Bonham.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She sips her tea thoughtfully. “I don’t know,” she says. “The "), _c('i', [_vm._v("Times")]), _vm._v(" story didn’t mention it, but something happened between Si and Tommy a few months ago. I’ve no idea what it was. Si never discussed the business with me. But I got the distinct impression that Si had stopped trusting Tommy. I honestly think that if Si hadn’t died when he did, he would have—I mean, I believe Si was thinking of getting rid of Tommy.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Ah,” he says. “That explains something I wondered about.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You mean that in Si’s revised will Tommy Bonham wasn’t to be left the emerald ring.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Now, you know I can’t tell you that.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You don’t need to. You just did. And I think I know to whom, in the unfinished will, that ring was going to be left.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Don’t ask me that, Connie.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I don’t need to. I already know,” she says.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“And so,” he says, shifting the subject again, “I suppose the store will have to be sold.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She nods. “Yes, though it seems a shame, considering how hard Si worked to make Tarkington’s what it’s become. He built the business for Blazer, you know. It was all for that boy, but then Blazer—let him down.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“There’ve been several offers already. Some quite lucrative.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Yes, I guess I’d say sell it. Sell it to the highest bidder. Because, frankly, there was something troubling Si those last few months before he died. Part of it was Tommy, but part of it was something else. I don’t think business was as good as he pretended it was. He used to say, ‘My kind of woman isn’t affected by a recession. My kind of woman isn’t even aware of an economic downturn.’ But I think some of them were. I think a lot of them were. I think that was what was weighing on his mind. I think the store had begun losing money, perhaps was even hemorrhaging money. At times, these past six or eight months, I’d look at Si and see a very frightened look in his eyes, Jake—a terrified look.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Of course, if the store were sold, it would become a very different sort of store.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“But perhaps that’s inevitable. After all, that kind of store may not have any place in this city anymore—maybe not anywhere in the world. Think about it: all those famous little Tarkington’s touches. Chanel Number Five in the ladies’ room. Chaise longues in case a customer felt faint or wanted to get off her feet for a few minutes. Monogrammed hand towels. Maids running about serving tea or drinks or little watercress sandwiches—whatever the client asked for. Endless alterations to suit the client’s whim, and never a charge for any of it. That sort of thing may have worked in the eighties, and even in the seventies. But this is the nineties, and people are tightening their belts, pulling in their horns. Tarkington’s has become an anachronism. Specialty stores like ours are becoming a thing of the past. "), _c('i', [_vm._v("The Times")]), _vm._v(" was right—Si was the last of the dinosaurs. His breed’s extinct, and so’s his breed of store. I’m sorry, Jake. I didn’t mean to launch into a long lecture on the state of the retailing business, a subject I assure you I know absolutely nothing about.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I think you know more than you’re willing to admit,” he says.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("They sit in silence for a moment or two, and she sips her tea. “This tea simply "), _c('i', [_vm._v("will not cool,”")]), _vm._v(" she says, setting down her cup.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You know,” he says, “when Blazer made his little—outburst back there at the office, he said something about wanting to kill his father but somebody else beat him to it.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She shakes her head. “I have no idea what he meant by that.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You don’t think there was any chance of foul play, do you?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I don’t even want to think about it. What difference does it make? He’s dead. Foul play or not, he’s not coming back to life. Harry Arnstein said death was from a coronary, and that’s good enough for me.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“But still—”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“The thing you have to remember about me, Jake, is that I loved the little son-of-a-bitch. In spite of the way he treated me, I still loved him. He may have treated me badly, but he treated other women badly, too. I wasn’t singled out. Being unfaithful to me was part of his nature. I don’t think it was possible for him to be faithful to any woman, much less a wife. And I miss him. Last night, I spent the night in town. I let myself into the apartment alone and realized he wouldn’t be there. It’s not that he was often there. In fact, most of the time he wasn’t there. But I realized he was never going to be there again. I realized I’d never hear him say again that he was going out to walk Blackamoor, his big old Labrador. Even when there were times that he—and Blackamoor—were going to wind up in some girlfriend’s apartment, I knew I was going to miss hearing him say that. I was going to miss him telling me his transparent little lies. Isn’t it funny? I was even going to miss the bad things he did. Suddenly I felt terribly alone. I went from window to window, throughout that big, empty apartment, looking out into the street, thinking I’d see him walking Blackamoor, or see him stepping into a phone booth to call one of his girlfriends, even though I knew he was gone for good and was never coming back. And you know something? Even though I knew he was gone forever, and was never coming back, I was still jealous of him. Because I loved him. If anyone ever does decide to write his biography, I hope they’ll put that in.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“As a matter of fact, I’ve already been approached on that subject,” he says.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Oh, I don’t think so, Jake. I don’t think we want anybody writing his biography, do we? No.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“The young man has good credentials. He’s primarily a financial writer, and he understands retailing. He got some sort of an award for a piece he did in "), _c('i', [_vm._v("Fortune")]), _vm._v(" on Saks being taken over by the Arab consortium. His name is Peter Turner.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“No, I think not,” she says. “Si didn’t want anything written about him in his lifetime, and I think we should continue to honor those wishes. I hope you told him no.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I told him I’d talk to him after I talked to you.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“And there are some things in Si’s past that we wouldn’t want—”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I know what you mean, Connie. But just remember this one fact about journalists. If a journalist wants to write a story badly enough, he’ll go ahead and write it anyway, whether you cooperate or not. And if you cooperate, you have a certain amount of leverage. You have a certain amount of control over the material, over what goes into the story, if you see what I mean.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She looks thoughtful. “Yes, you have a point.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“So you might consider cooperating with this Peter Turner—in order to have that degree of control.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She smiles faintly. “You’re a very wise man, Jake,” she says. “I’ve always thought so. How long have you and I known each other?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Twenty-seven years. I was best man in your wedding. Remember?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Of course. The day he died was my fiftieth birthday. Did you know that? Jake—am I getting old?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Oh, no,” he says. “Not you.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Whatever else could be said about my husband, you have to admit that Si Tarkington had balls.” She sips her tea. “This tea is finally cool enough to drink,” she says.")])])])
}]}

/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(98),
  /* template */
  __webpack_require__(99),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 98 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 99 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "chap-title"
  }, [_c('span', [_c('i', [_vm._v("5")])])]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_vm._v("At the Beth-El Home for the Jewish Aged in Palm Beach Shores, Florida, it is time for Rose Tarcher’s weekly bridge game. Rose Tarcher is ninety-six and, she likes to boast, she still has all her faculties, though her hearing has begun to fail her in recent years. “Which way is north?” she asks. “Which? Is this north?” Rose is superstitious, and likes to be seated on the north side of the bridge table.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("No one really likes to play bridge with Rose Tarcher because she is notorious for being a bid hog. On the other hand, in the unwritten hierarchy of the Beth-El Home, Rose is what is known as “one of the higher-ups.” Being one of the higher-ups means that Rose has money—some money, at least, though of course no one knows how much. In her room, number 17, she has substituted her own chintz curtains and bedspread for the ones provided by the home. She also has her own colored sheets, which she likes changed twice a week, though most residents get only one change a week, on Mondays. In her room she has a large-screen TV, with cable. She has her own Touch Tone phone, with an extra line and a hold button, and a sterling silver mezuzah on her door.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Then there is her mink. It is a rather special mink, designed, she says, just for her. It can be worn at knee length. But then there is an eighteen-inch-deep panel of matched pelts that can be zipped onto the skirt of the coat, creating a floor-length garment. The coat has a high stand-up collar, and it also has a zip-on hood. Rose’s mink may have seen better days, but it still has its Tarkington’s label and Rose’s monogram stitched into the lining, and on chilly evenings she often appears at the dinner table wrapped from head to toe in her mink.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In the draw for partners, Rose has drawn Ben Rosenthal, one of the few gentlemen living at Beth-El, and this draw is fine with him because, if Rose likes to hog the bids, Ben enjoys being dummy. The other players are Esther Pinkus and Lily Sachs. The bidding proceeds.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Rose opens. “Two clubs.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Two spades,” says Esther.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Pass,” says Ben.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Four spades,” says Lily.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Two clubs,” says Rose.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Now, Rose, you know you can’t do that,” Esther says. “My partner said four spades.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“What?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“My partner said four spades,” Esther says, louder. “You can’t go back to two clubs!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I didn’t hear anybody say four spades,” Rose says. “It’s two clubs.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Rose, you spoil everybody’s fun when you play like this!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Let’s see what you’ve got for me, partner,” Rose says, and Ben lays down his hand. “Very pretty, partner,” she says as Esther leads. Her opposing partners look glum. Rose often plays like this, using poor hearing as an excuse for not noticing intervening bids, and it is very irritating to the others. But another unwritten rule of the home is that arguments and quarrels among the residents are to be avoided at all costs, and any long-standing feuds would surely raise the hackles of Shirley Weinstein, the home’s peppy redheaded Director of Activities.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Rose takes the first trick. Ben Rosenthal, as dummy, rises a little stiffly and slowly circles the table, examining the other hands. Then he moves toward the television set where, at low volume, a developer is extolling the wonders of time-share living at Delray Beach. At eighty-four, Ben is one of the youngsters at Beth-El, and several of the ladies consider him their special beau. On top of the set is a copy of today’s "), _c('i', [_vm._v("New York Times")]), _vm._v(", and Ben picks this up and idly glances at the headlines. “I see Silas Tarkington died,” he says to no one in particular.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“What?” Rose asks.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Silas Tarkington,” he says.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“What about him?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“He died.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Rose’s cards tumble into her lap, and she fumbles to gather them up again. The color has drained from her face.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Rose, are you all right?” Lily asks anxiously. Just the other day, old Mrs. Samuels suddenly turned pale like that and went to her Maker right at the dining room table.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“He didn’t tell me,” Rose whispers.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“How could he tell you?” Esther snaps. “He’s dead.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Didn’t tell me he was sick.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“He wasn’t sick. He drowned,” Ben says.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“How could that be? He was a beautiful swimmer.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“What’s he to you, anyway?” Esther asks.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Only my son,” she says. “Only my only son. You’d think someone would tell his only mother when her only son dies. Oh, Solly—” She reaches for the hanky in the bosom of her dress and dabs at her eyes.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Silas Tarkington’s your "), _c('i', [_vm._v("son")]), _vm._v("?” Esther says. “How could that be? Your name’s Tarcher.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“It was Solomon Tarcher before. Before he wanted to get fancy and changed it.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Esther snatches the newspaper from Ben and quickly scans the the obituary. “If you’re his mother, how come you’re not mentioned in his write-up?” she says. “They list all the survivors. They don’t mention any mother. I don’t believe you, Rose. How come he never came to see you?” She is clearly still cross at losing a bid for game in a major suit.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I guess you would say we weren’t close,” Rose says. She removes her glasses and wipes them with her hanky. “But still—still, he was my son. My firstborn. I had my feet in the stirrups on that table, and my doctor said, ‘Push, Rose … push hard … push as hard as you can … you’re pushing life into your baby. If you push hard enough, I won’t have to spank his bottom when he comes.’ And then they handed him to me, and he smelled—so sweet! Why did he have to die? Why is life so unfair?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The others are silent now, and Rose, trying to collect herself, replaces her glasses on her nose.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“We fought,” she says. “But he was still my little Solly.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“So that’s where your money comes from,” Esther says at last, and Lily, from across the table, makes soft hushing noises.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“That’s what we fought about. After my late husband died, God rest his soul, and Solly needed money to start his store, I loaned him some. It was called buying his store’s stock. I didn’t get as much as I was supposed to get. Not nearly as much. Simma was smarter. My daughter fought for her fair share and got it. Simma wouldn’t have anything to do with Solly either, after he tried to do to her what he did to me. So you see I’ve had my share of "), _c('i', [_vm._v("tsuris")]), _vm._v(". Lots of trouble in the family. My life hasn’t been the bowl of cherries some of you seem to think it was, or maybe I sometimes like to pretend it was. But what can you do? Oh, my.” She dabs at her eyes again. “Put one foot after the other, like my late husband used to say, God rest his soul. Funny, I always thought Simma was the brainy one in the family. I always thought Simma was the one who should have had all the success, not Solly. I can’t complain about Simma, can I? She’s given me a wonderful son-in-law I love like my own son, three beautiful grandchildren, and two greats. Simma visits me every week, come hell or high water, rain or shine.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“She’s nice, too,” Lily says.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Rose closes her eyes, and blinks twice, and takes a deep breath. “So Solly’s dead,” she says. “Well, I don’t guess there’s anything I can do about it now, is there? Solly lived in New York. Had fancy friends. Get on with your life, as my late husband used to say, God rest his soul. Pick up the pieces.” With a sniffle, she slowly picks up her hand again, re-sorts the cards into suits, and fans them out between her fingers. Her hand trembles slightly. “Oh, dear,” she says. “I’ve forgotten what our contract was.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Four spades,” Esther Pinkus says narrowly.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Rose studies the cards in her hand and then the cards arrayed before her on the board. “Partner, how could you have bid us up to four spades with that mess?” she says indignantly, and leads with her club ace.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Esther Pinkus promptly trumps it.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Ben Rosenthal crosses the room to Rose’s chair and rests his hands gently on her shoulders. “I’m sorry, Rose,” he says. “I just want to say that I’m truly, deeply sorry. I know how you feel. I lost one of mine, too. Car accident. It’s not easy.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Well, you should be sorry,” she says. “We’re definitely going to lose this one. Thank God we’re not vulnerable.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent2"
  }, [_vm._v("Early that same evening, Diana Smith, thirty-four, lets herself into the side entrance of the store with her own key. Inside, she leans against the door for a moment, feeling dizzy. The last three days seem to have passed in a trance. Her doctor has prescribed Valium for her, and the pills turn time into a dreamlike haze, through which she feels she is moving silently and disconnectedly, like a swimmer under water, but going nowhere. She reaches in her purse to fish out a cigarette but then remembers where she is. She is here, in Si’s store, where there is a no smoking policy. She closes the purse. She is not even entirely sure why she came here. What was it? Oh, yes. To check her department. To say goodbye to it, perhaps. Because, the way things stand now, this may be her last time inside these doors. Who knows, when Tommy Bonham takes over—as he surely will—what will become of her? She staggers forward, reaching out to steady herself against a display counter. "), _c('i', [_vm._v("Did I take two of those dreamy little pills or one? I can’t remember")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Oliver, the security guard on duty tonight, nods to her. “Evening, Miss Smith.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Good evening”—"), _c('i', [_vm._v("his name?")]), _vm._v("—“Oliver.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Sad day for all of us, ain’t it, Miss Smith?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“It surely is.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Say, you feeling all right, Miss Smith? You look a little—shaky, sort of. A bit off your feed. Green around the gills, like the fella says.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I’m fine. I’m just a little—upset. As we all are, Oliver.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Oliver nods again and continues on his rounds.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("At the Hermès boutique, she pauses and lifts a sample flask of Equipage and sprays it behind her ears, on the backs of her wrists, in the cleavage of her breasts. Equipage is Diana Smith’s signature fragrance, and the scent makes her feel more like herself. “I love the way you always smell,” he used to say to her.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“When a woman finds a scent that suits her, she should always stick to it,” she told him. He used to give her bottles.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She makes her way slowly down the center aisle, under the Baccarat chandeliers, toward the back of the store to where, under an archway of polished walnut, her own department is situated. There, in locked glass cases, her merchandise is displayed. On the store’s books, this merchandise is valued at four million dollars, but she knows enough about retailing to know that the value of a store’s inventory has little relationship to its real value, which is always considerably less. She moves slowly from case to case, earrings in one, rings in another, necklaces and bracelets in a third, pins and brooches and jeweled buttons in a fourth. Now she remembers why she came here tonight. She wanted to think about precious stones, and not about other things.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She has always had a special feeling for gems, and it is really only the precious ones that interest her. She has never been able to have much enthusiasm for semiprecious stones: the garnets, the tourmalines, the amethysts, turquoises, moonstones, opals, and the rest. But precious gemstones are quite another matter, and the sight of a nearly flawless, fiery diamond can induce in her an almost narcotic rush, a kind of adrenaline high.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Each stone—to her, at least—has its own distinct personality. An emerald, for instance, she sees as a man’s stone. Rubies and diamonds look cheap and vulgar on a man, and there is a reason why Tiffany has never offered a man’s diamond ring for sale. Tarkington’s doesn’t go quite that far, but when a man comes into the store looking for a diamond ring—or diamond studs or cuff links—Smitty’s salespeople try, as politely as they can, to discourage him, to steer him toward emeralds or some lesser green stone such as aquamarine or malachite: masculine stones.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Rubies are tarts’ stones, Smitty’s least favorite of the big four. She’s never met a woman wearing a ruby ring—or necklace, or ear clips—that she didn’t instantly dislike and consider a tart. Tarkington’s has its share of tart customers, of course—high-class tarts, to be sure, expensive tarts, but tarts just the same, or kept women. And when she sees such a woman sashay into her department, she will wink at her salesperson and slyly whisper, “Bring out the T.C.”—the Tart Collection.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("When a woman asks to look at emeralds, Smitty tends to think: Dyke.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Sapphires? Well, they are sort of a problem. Smitty has looked at some gorgeous sapphires in her time, but to her a sapphire has always been an old lady’s stone. Old ladies with blue hair seem to be made for sapphires. There is a particularly lovely sapphire and diamond necklace in one of her cases right now, sold to her with documentation indicating that it once belonged to the Grand Duchess Tatiana of Russia—and it may have, though the vendor’s price was almost suspiciously low—that Smitty has always admired. But she reminded herself that she is too young for sapphires. “You’ll have plenty of time for sapphires, Smitty old girl,” she told herself. “Puh-"), _c('i', [_vm._v("len")]), _vm._v("-ty of time.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("But diamonds—ah, diamonds are an altogether different story. They are ageless, forever young, pure, hard carbon, flash-formed in the volcanic bubbling of the young earth’s crust. A good diamond is as beautiful on the ring finger of a teenage bride as on a dowager’s lavaliere. In the glass case in front of her is the diamond he promised her: square-cut, 3.9 carats, finest gem quality, in a perfectly simple platinum setting. Using another key, she unlocks the cabinet, picks the ring out of its black velvet pocket, and slips it on the third finger of her left hand.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She could very easily turn, now, and walk out of the store wearing the ring. It was rightfully to have been hers. Oliver, even if he notices her walking out with an item from her own stock, would not question her. She has often borrowed items from stock before—for an important party, for instance, somewhere she might be recognized, photographed, written about. “Diana Smith, Tarkington’s savvy jewelry buyer, wearing a diamond butterfly in her hair,” Mona Potter might write. Si even encouraged this sort of thing. This sort of publicity did nothing but good for the store, and it cost Si absolutely nothing. He always encouraged his executives to look their absolute and most expensive best when they went out in public. It helped the store’s image. Longtime salesladies, whom Si trusted, were even allowed to borrow designer apparel from the store’s inventory. Smitty has done this too.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Right now, Smitty could go into her office and erase this item of her inventory from her computer’s memory and that would be the end of it.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Except …")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Except for Tommy Bonham, of course. Tommy Bonham’s eyes always seem to be everywhere in the store. His memory itself is like a computer, and often even better, and if Tommy is about to take over, even temporarily, it is much too risky.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She has had her share of run-ins with Tommy Bonham in the past, and she is certain he doesn’t like her. It was Tommy, for instance, who persuaded Si to open the two suburban outlets, in Westchester and Morris counties. Smitty opposed the idea from the beginning. “It won’t work,” she told Si.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Why not? Why won’t it work?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I’ll give you two reasons why it won’t work,” she said. “For one thing, your salespeople. Here in Manhattan, you have a supply of bright, attractive, well-bred, and well-spoken men and women who, for one reason or another, need jobs. These are people who learn to respect and care about the merchandise they sell. These are the kind of salespeople our clients expect—people with good manners and good taste. These are people who know how to write thank-you notes and who know that when a woman buys a fifteen-thousand-dollar dress she appreciates a thank-you note from the person who sold it to her. But who are you going to find in Westchester County? Wives of bankers and stockbrokers and lawyers and advertising executives who play golf and paddle tennis. They don’t need to work, and they’re not going to want to work for us. People of the sort who work for us in Manhattan aren’t going to want to commute to White Plains. We’re going to end up having to hire former cleaning ladies from Tuckahoe.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“That’s reason number one. Reason number two is that thirty percent of our clients are visitors from foreign countries. Is the wife of a Japanese businessman going to go to White Plains to shop? No way. Another thirty-five percent of our clients live in other parts of the country. Is a woman who’s in town from San Francisco going to get on a bus and go to New Jersey to buy a dress?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“But more and more of the city’s money is moving to the suburbs,” Tommy insisted, and he had charts and graphs and demographic studies to back him up, and Si decided to go along with him. Tarkington’s would take Scarsdale and Morristown by storm. The suburban stores would each add a new department, called “Country Living,” featuring more casual designer apparel.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Well, it hadn’t worked, for the very reasons Smitty outlined, and after a while both suburban branches closed. Smitty had been right, and Lord knows how much money Si lost in that experiment. And the day the suburban closings were announced—meeting Tommy Bonham in the hall—she hadn’t been able to resist saying sweetly, “I told you so!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He had given her a look of purest hatred. Tommy the hagfish.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Prettyboy Bonham didn’t like being told he was wrong. He liked it even less when that person was a mere buyer. He liked it less and less when that person was someone ten years younger than he, and even less than that when that person happened to be a woman.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She twists the ring slowly on her finger. A diamond of that size and importance looked smart when worn facing the palm of the hand. It would also look smart knotted in a scarf.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Suddenly, she is swept with an almost sexual longing for this stone. The feeling seizes at her very innards. She must have this stone and no other. It is hers. It was promised to her, and promises cannot be broken, can they? “A man is as good as his word.” Si was always saying that, and so it must be hers, and now is the time to claim it. That’s what she’s doing: not stealing it, claiming it. Claiming her rightful property. She extends her left hand to the light. This stone excels in all four C’s of gemology: color, clarity, cutting, and carat weight. It is ice blue. In the sunlight it will throw off prismatic flashes of red and lavender. In terms of clarity, it has been rated flawless. It has been cut in the full glory of fifty-eight facets, thirty-three above the girdle and twenty-five below. In the quaint language of gemology, this stone would be classified Extra River, from the early days of African mining when the finest diamonds were found in the alluvial wash of riverbeds. Yes, it is hers, it is hers.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She could write it up as a sale. There is a client in Venezuela whose husband’s bank pays all her charges. No bill has ever been challenged.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Nice-looking ring, Miss Smith.” It is Oliver, moving silently across the thick carpet, making his rounds, a witness.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She tries not to appear startled. “Yes, isn’t it?” she says easily. “I have a client, in town from Caracas. I’m thinking of taking this over to her hotel and showing it to her.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Caracas. Is that in Ohio?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Venezuela. South America.” Her alibi.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Larceny, she thinks. Grand theft. Zip to ten years in the state pen. Prettyboy Bonham would like to see her in jail. Next to seeing her dead, he would like to see her in jail.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("And yet, she thinks as Oliver moves away, would she ever feel the same about this ring as she would if he had actually slipped it on her finger, the way he had promised to do? That would always be missing, that one final gesture. Missing that final gesture means a lot. The promise cannot be real without that final gesture. And, worst of all, worse than knowing that the final gesture never came, will never come, is knowing that it was her own damn fault.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Yes, you really blew it this time, Smitty old girl,” she tells herself. “You really blew it this time, didn’t you? You blew your last chance.” Once again, she feels dizzy.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Someday that Irish temper of yours is going to get you into big trouble, young lady—"), _c('i', [_vm._v("big")]), _vm._v(" trouble,” her mother used to say when she was growing up, when she would sob and curse and kick the stairs whenever she didn’t get her way. Locked in the kitchen as a result of some infraction she can’t remember, she had hurled all her mother’s best china out of the cabinets, smashing it, piece by piece, on the tile floor, and then stamping on it with her feet until the Wedgwood looked like drifts of snow. “Oh, you rotten, rotten little girl, you worthless little girl!” her mother had screamed, chasing her through the rooms with her younger brother’s baseball bat. “You’re worthless! I’m going to kill you, you worthless little girl!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("And so, that day, their last time together, when she could have reasoned with him, could have tried to calm him down, instead she lost her Irish temper and then—")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Slowly she removes the ring from her finger, places it back in its little pocket, slides the drawer closed, and locks the cabinet. For a moment, she rests her hands on the cabinet, and her reflection in the glass is moonlike, disembodied, unreal. Perhaps my mother should have killed me, she thinks. Perhaps that is what I deserved.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("And so she makes her way out of the store, waves good night to Oliver as she passes him, and, ringless, leaves by the side door, knowing she will never be certain whether she left the ring behind because she is essentially an honest woman or was just afraid of getting caught.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("On the street, she joins the crowd of pedestrians moving uptown. If you saw her, you would think this was just another attractive, well-dressed young woman with something weighing heavily on her mind. The Valiums are wearing off.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She makes a decision. Tomorrow morning, when the store opens, she will march into Prettyboy’s office and resign. She will not give Prettyboy the satisfaction of firing her—or terminating her, as they say nowadays.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("There are other good jobs in this city, she thinks. There are other nice places to live, and there are even other cities; she is sick of New York, sick to death of it, and New York didn’t keep its promise to her.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("There are also other men, men who will keep their promises. There are plenty of other men. You’d think Si Tarkington was the last man on earth, for God’s sake! She’s still young, still has her looks, her figure. She’ll find someone.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Suddenly, instead of despair, her world is bright with expectation, hope, and a crimson thing called courage. She thinks of Scarlett O’Hara. Tomorrow is another day.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("At the corner, she raises her arm to flag a taxi, just another bright young Manhattan career woman in a hurry.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Hi, Smitty!” someone calls to her.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Hi!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She has always hated the name Smitty, which was given to her in high school, and has stuck, and now will probably never become unstuck. When they made love, he called her Diana, repeating it over and over, “Diana … Diana … my goddess of the hunt.…”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("A taxi pulls over to the curb.")])])])
}]}

/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(101),
  /* template */
  __webpack_require__(102),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 101 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 102 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "chap-title"
  }, [_c('span', [_c('i', [_vm._v("6")])])]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_vm._v("Peter Turner, struggling freelance writer, sits in his ninth-floor apartment at the Dakota, thinking.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The Dakota is considered a rather grand New York address, but Peter Turner’s apartment is far from grand. The grand apartments are on the floors below, particularly those facing south, over the breadth of West 72nd Street, and those facing east, overlooking Central Park. The grand apartments of the Dakota are owned by celebrities of the magnitude of Lauren Bacall, Yoko Ono Lennon, and Roberta Flack. Peter’s apartment is in the upper northwest corner of the building, tucked under a gabled, crenellated dormer window, and his only view is of the unadorned brick wall of the building next door.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The top two floors of the Dakota, on one of which Peter Turner lives, were once a warren of tiny servants’ rooms, from the days when people kept servants. Out of these rooms, small apartments were patched together in somewhat haphazard fashion, like Peter’s. The top two floors of the Dakota are where the gays live, and many little old ladies. Bicycles are parked outside apartment doors as often as wheelchairs, along the narrow corridors that link these residences in a pattern graspable only to those who live there. Peter Turner is not gay, though he lives alone, and though he has had admiring glances cast in his direction by certain neighbors. Not that Peter Turner is all that good-looking, though most would say he is not bad-looking, either. His face is composed of many planes and angles. “Your face is all corners,” a former girlfriend once said to him. But he has one feature he is secretly very proud of: a thick, curly mop of black hair. Someone once told him that if a man can keep his hair past the age of twenty-five, he need never fear baldness. Peter Turner passed that watershed year three years ago, heaved a sigh of relief, and stopped worrying about it.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Now he is thinking about Blazer Tarkington. He would not be interested in Silas Tarkington’s story if it hadn’t been for Blazer. If it hadn’t been for Blazer, he wouldn’t have thought twice about it, wouldn’t have given it the time of day.")]), _vm._v(" "), _c('p', {
    staticClass: "indent2"
  }, [_vm._v("Peter Turner and Blazer Tarkington were in the same class at Yale, and for a couple of years they both lived at Calhoun College. Peter had no idea why the guy was called Blazer. He assumed it might have something to do with the blazer jackets they all wore when they got dressed up. Every Yale man worth his salt owned a blazer, and it had to be dark blue, double-breasted, with solid brass buttons, preferably antique. The best blazers were custom made by Morty Sills. These jobs were made with real buttonholes on the sleeves that you could button and unbutton. So if you had a blue blazer with, say, a bright red silk lining, you could unbutton the sleeves and roll up the cuffs to show off the lining, and that was considered a real "), _c('i', [_vm._v("Yale")]), _vm._v(" look and you were ready for the tables down at Mory’s. No breast-pocket insignia, please. That was taboo.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("But the thing was, Peter doesn’t think he ever saw Blazer Tarkington wearing a blazer. He was always kind of a scruffy dresser—T-shirts with hostile messages printed on them, torn jeans, dirty sneakers, that sort of thing. There was also a dirty old cap he sometimes wore, a duckbill type, and he always wore it backward. That was very un-Yale, that cap. Sometimes he also wore wire-rimmed granny glasses. Peter used to think Blazer was trying to look like John Lennon. He was built kind of like Lennon, tall and lanky. You’d never have guessed he was a rich man’s son. For one thing, he never seemed to have any money. Sometimes Peter and his friends would ask Blazer to join them for a few beers, but he would just pull the insides of his pockets out, which was his nonverbal way of saying he was broke.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He wasn’t unpopular at Yale, exactly. But he wasn’t exactly popular, either. He was always kind of a loner, never seemed to want to be friendly, never seemed to want to get into a conversation. Blazer never had any real close friends at college. He wasn’t "), _c('i', [_vm._v("un")]), _vm._v("friendly, just aloof, as though he had some kind of private chip on his shoulder. He went out for boxing and made the team, which was unusual for a skinny guy, and Peter always thought boxing was a good choice. It helped him work off the hostilities he seemed to have.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He was into a lot of other things at New Haven. He worked on the "), _c('i', [_vm._v("Record")]), _vm._v(" as a photographer. He sang baritone in the glee club. He was a pretty good outfielder for the junior varsity baseball team. But you couldn’t really call these "), _c('i', [_vm._v("social")]), _vm._v(" activities. Boxing, taking photos for the "), _c('i', [_vm._v("Record")]), _vm._v(", singing baritone, playing outfielder—these weren’t activities that required much social contact, or interaction, with other team members. At Yale, Peter tended to think of Blazer as an outfielder, always somewhere out in left field. Later on, after his classmates had all more or less gotten used to him and his antisocial ways, many of them decided that Blazer Tarkington was just a bit peculiar.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Peter was born and raised in Wisconsin, so he had never heard of Tarkington’s store and the name meant nothing to him when he got to New Haven. Then, in the fall of their sophomore year, Blazer’s stepmother arrived on campus. Peter never forgot that afternoon. It was the first hint he’d had that there was money in the picture.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He happened to be standing in the quad when Consuelo Tarkington’s Rolls-Royce pulled up to the curb. Her driver, in a gray uniform and cap, hopped out of the car and opened the back door for her. First a long slender leg appeared. Then a gloved hand, holding a long cigarette holder with a lighted cigarette in it. Then the whole woman herself emerged and stood there. Just stood there.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("It was not just that she was beautiful. She most certainly was—an icy blond beauty, with perfect white skin and cool blue eyes. Her hair, done in what in those days was called a bouffant style, was almost the color of her cigarette smoke. She was about Peter’s own mother’s age, so it would not be accurate to say that he found this woman beautiful in terms of being desirable or sexy. And it was not just that she was elegantly dressed, which she certainly was, though he can’t really remember what she was wearing, except that it was something dark. It was simply the way she stood there. He’d never before seen a woman whose very posture could transmit such a sense of self-possession and self-command. She seemed to have complete authority over herself. Everything about this woman seemed so "), _c('i', [_vm._v("sure")]), _vm._v(". Then she stepped from the curb onto the sidewalk, and there was certainty in the way she moved, too. Though he was standing at least fifty feet away from her, Peter swore he could smell her perfume in the autumn air. He recognized, for the first time, that hers was the assurance and self-confidence of money, and he knew all at once, with a pang of self-realization, that he would never be that rich.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Come, Miranda,” he heard her say, and even her voice was moneyed. Then her daughter stepped from the car.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("None of his classmates had known that Blazer Tarkington had a sister—a half sister, as it turned out. She was no more than thirteen or fourteen at the time, and certainly no Yale man would expect himself to be magnetized by a fourteen-year-old kid. But this was no ordinary fourteen-year-old. She was not as tall as her mother, nor as fashionably thin, and she was darker. But everything about this girl seemed to glow. She shone. Her mother’s beauty was snowy, alpine, but this girl’s beauty was crackling, fiery. The sunlight caught her ponytailed chestnut hair and made it gleam like polished copper. She glanced in Peter’s direction, registering no particular interest in the boy she saw, and her huge eyes were the color of apple cider warmed by a hot poker. Mrs. Tarkington took her daughter’s arm, and they moved together across the grass under the few remaining English elms that still graced the campus, toward the entrance to Calhoun.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The Rolls alone would have been enough to attract its share of stares from bystanders. But as Peter looked around he saw that everyone in the vicinity—women with books spread out on the grass, men on their way to classes or the gym—had stopped what they were doing. Every pair of eyes, male and female, was following those breathtaking two. Then they disappeared inside the entrance, and the earth began turning on its axis once again.")]), _vm._v(" "), _c('p', {
    staticClass: "indent2"
  }, [_vm._v("It was in Blazer’s sophomore year that he took up diving. Peter would see him exercising on the trampoline in the gym and practicing his dives at the pool. Soon he was developing the long, smooth arm and leg muscles of a diver, and by winter he had made the team. By junior year, he was something of a star. But, again, diving is something of a loner’s sport, since one spends most of one’s time beyond communication, in silent concentration on the board or under water. Blazer was maturing into a nice-looking fellow, who would have been better-looking if he smiled, which he rarely did. Everything he did he threw himself into with a land of single-minded purposefulness and seriousness, humorlessly determined to be the best at whatever it was he undertook. He tackled his studies with the same furious determination and got excellent grades. But still he was not an easy person to get to know, and some of his classmates, having seen his younger sister—who went, they learned, to Ethel Walker, not that far away—would have liked to get to know him better.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("So that was how he entered his junior year—always polite but distant, a semi-hero of his class who refused to act like one or to join the gang.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Still, everyone expected that Blazer Tarkington would be tapped for one of the all-male senior societies, Scroll & Key, if not the big one, Skull & Bones. After all, coeducation notwithstanding, Yale was still a man’s school. Males still called all the important shots at New Haven; women were merely tolerated. And Blazer certainly qualified for membership in one of the elite clubs. He’d won his letter in three sports: boxing, baseball, and as a diver on the swimming team. He’d been made photo editor of the "), _c('i', [_vm._v("Record")]), _vm._v(". In his senior year, he’d gone out for the debating team—another lonely, pugilistic sort of activity—and made a name for himself there. He’d earned fine grades. All these considerations are supposedly given weight by the various tap committees in their top-secret deliberations. Then there was his father’s money. That sort of thing wasn’t supposed to be a factor in the selection process but it nearly always was, a big one. So Peter had assumed that Blazer would be a shoo-in for either Key or Bones, the perfect well-rounded Yale man.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("But when Tap Day came, nobody tapped Blazer Tarkington.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("People began saying that, where the senior societies were concerned, something was “wrong” with him, but nobody knew what it might be. Was his sexual orientation a little off? Not that anybody knew. As far as anybody knew, his romantic life at New Haven was nonexistent.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("As far as Blazer himself was concerned, he didn’t seem to care that the senior clubs had snubbed him. He was preoccupied with other matters. From his offhand attitude, he seemed to say that he hadn’t come to Yale to get involved in that sort of thing, even though to be tapped by a senior society is considered the college’s ultimate honor. He had other things on his mind, he seemed to say, though no one knew what they were. Perhaps he had come to Yale to exorcise some private demons, demons that only he knew about.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("On the night before graduation, he got drunk—all by himself, apparently—and around midnight who should come lurching into the Beta house, where a party was going on, but Blazer Tarkington. He hadn’t been invited, and he wasn’t a member of the house, so this was a serious breach of etiquette on his part, and quite unlike him. He stood there, swaying in the doorway, with an open beer can in one hand, and said, “Listen, you sons-of-bitches, there’s something’s been on my mind to tell you all for the last four years, and now I’m going to tell it!” Everyone grew silent. Then he leaned back out the door, vomited into a boxwood bush, and fell face forward into the bush, passed out. Peter and a friend carried him home and put him in bed. They never did find out what it was he’d had on his mind for four years and was finally going to tell them all.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("After college, Peter pretty much lost track of Blazer. He was not the sort of person one tended to stay in touch with, after all, and the rest of his class were becoming too caught up in their new lives and careers in the outside world to take the time to look up old classmates. Occasionally, Peter would read something about the Tarkingtons in the newspapers. Mrs. Tarkington had been named number one on the International Best-Dressed List. Miranda Tarkington’s coming-out party on Long Island was a big affair, and the gossip columnist Mona Potter anointed her Deb of the Year. There was no mention of whether Blazer was at that party or not. In fact, Peter read nothing in the papers about Blazer at all.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Then came today’s obituary of his father on the front page of "), _c('i', [_vm._v("The Times")]), _vm._v(". There were several things about this death notice that puzzled and intrigued Peter Turner. Why was the doctor flown in by helicopter from miles away in Manhattan? What were the reasons for the fact that no one knew Silas Tarkington’s exact age, that his origins were “mysterious,” that he disliked being photographed, avoided the press, and had “successfully resisted the efforts of a number of would-be biographers.” Who was this guy, anyway? Peter wondered.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Blazer’s name was not mentioned in the obituary. Had something happened to him? Peter looked him up in the Yale Alumni Directory, and Blazer was listed as living at an address in the East Village. The directory was a couple of years old, so he consulted the Manhattan telephone book and there he was, at the same address.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("There was still something about the obituary that bothered Peter, and he couldn’t put his finger on what it was. Then it dawned on him. It was in the very last paragraph: "), _c('i', [_vm._v("Interment at Salem Fields Cemetery in Brooklyn will be private")]), _vm._v(". Salem Fields is a Jewish cemetery. Blazer Tarkington was Jewish. That was why all the senior societies had snubbed him. Suddenly Peter was a little ashamed of himself for not having worked harder, at Yale, to make him a friend, for not having tried to get him to remove that chip on his shoulder.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He suddenly remembered, after the snub, hearing a Bones man say, “We just didn’t think he’d be happy here.” And as far as Silas Tarkington’s money was concerned, he supposed they just considered him another Jewish shopkeeper. That was what was wrong with Blazer. His Jewishness had given him a kind of birth defect.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("So Peter decided to call him. “I was sorry to hear about your dad,” he said, when he got him on the phone.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Yeah.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“He must have been quite a guy.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Yeah.” It was the same old Blazer, taciturn as ever.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I’m sorry I never knew him.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Why?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Well, because, as you say, he was quite a guy.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("There was a silence and, because this conversation wasn’t exactly moving right along, he decided to try a different tack and get right to the point.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Look,” he said, “I’m thinking of doing an article about your father. As you know, there’s been very little written about him, and he seems to have had an interesting life and career. I was wondering whether you and I could get together.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("There was another long silence, and for a moment Peter thought they’d been disconnected. Then he heard Blazer say, in an almost incredulous tone of voice, “You want to write something about "), _c('i', [_vm._v("him")]), _vm._v("? Why the hell would you want to do that?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Look,” he said. “The obituary in "), _c('i', [_vm._v("The Times")]), _vm._v(" seems to raise more questions than it answers. Like, where was he born, and when? How did he get his start? I think there’s a fascinating business story here, and a fascinating personal story too. After all, he created a specialty store like no other in the world. How did he actually "), _c('i', [_vm._v("do")]), _vm._v(" it? He was a kind of Horatio Alger hero, wasn’t he? The American success story. Rags to riches—”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Bullshit!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I’m serious. He seems to have been a completely self-made man. He—”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Bullshit.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Readers are always interested in finding out how a man, starting out with a single, rather specialized idea, can build—”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You really want to dig up all that crap?” Blazer said.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Maybe you’re familiar with some of the business stories I’ve been writing for "), _c('i', [_vm._v("Fortune")]), _vm._v(", Blazer,” he said, moving right along, even though he wasn’t getting much encouragement from the other end of the conversation. “I’m thinking of the corporate history of Tarkington’s. The personal history of your father. Because the store "), _c('i', [_vm._v("was")]), _vm._v(" your father. There’s even the question of who’s going to succeed him—or if anybody "), _c('i', [_vm._v("can")]), _vm._v(" succeed him. Or if, in a business recession, when a lot of retailers are having problems, a store like yours—”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Like mine? It ain’t my store, buddy. Never was.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Whether a store like Tarkington’s can survive as the kind of store it’s always been. There’ve been buy-out offers, I understand, and—”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You’re talking about opening up a real can of worms. I guess you know that.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“No,” he said carefully, “I didn’t know that.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Or are you just one of those guys who come sniffing around my family because you’ve got the hots for my kid sister?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Nonsense,” he said. “I’ve never met your sister.” Though he didn’t add that he’d certainly like to talk to his sister too.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“All you Yale guys were only nice to me because I had a sister who looked like a hot piece of ass.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Peter decided not to comment on this, though it seemed a crude way for a man to speak of his sister. He continued with his pitch. “So what do you say, Blazer? Can we get together? Can I present my case to you in person?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Are you going to go into the funny way the old man died?” Blazer asked suddenly.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“What do you mean?” Peter said, all at once excited.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Died of a coronary? There was nothing wrong with the old man’s heart, except that it was made of industrial-grade concrete.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You mean you think your father was—”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Ha! They only put in the obituary what the family told them to put in. I’m just saying that something damned fishy happened that day at the pool, no pun intended.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“But who?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“The old man had a lot of enemies,” Blazer said. Then he said, “But what the hell. I don’t really give a damn how the old man died. I hated the old bastard.” Then, without skipping a beat, he said, “And loved him too. Hated him, and loved him too. After all, he was my father.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Look,” Peter said, “let me take you to lunch. We could go to the Yale Club—”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Fuck the Yale Club! You won’t catch me dead inside the fucking Yale Club!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("But even as he said these harsh things, Peter had the strange feeling that there were tears in Blazer’s eyes. “Or wherever you say,” he said quietly.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Blazer paused and seemed to consider this. “Well,” he said at last, “if you’re going to write all that garbage about the old man, I guess I can’t stop you.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“It’s not garbage, Blazer. It’s hist—”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Talk to Jake Kohlberg,” Blazer said, interrupting. “Kohlberg was the old man’s lawyer. Kohlberg knew him longer and better than I ever did. He’ll tell you all the wonderful things the old man did. Then, maybe, if I talk to you, I can tell you some of the things that weren’t quite so wonderful about him. Isn’t that what you journalists like to get—a balanced view?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("A note of sarcasm had crept into his voice, particularly in the way he came down hard on the word “balanced,” so Peter decided to change the subject. “Okay,” he said pleasantly. “So—tell me what you’ve been up to, Blazer. It’s been a while.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Not much.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Interesting job?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“No.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Since that sort of left Peter hanging there, he said, “Well, look, I’ll call Mr. Kohlberg, and after I’ve talked to him I’ll give you a call, and maybe you and I can get together. It’d be great seeing you again, in any case.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("There was another short silence. Then Blazer said, “Listen, Turner, none of you guys ever did shit for me at Yale. Everything I did at Yale I did for myself. What makes you think I should do shit for you?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Peter took a deep breath. “Well, Blazer,” he said, “I helped carry you home after you vomited and passed out drunk in a boxwood hedge in front of the Beta house. I held your head over a toilet bowl while you puked some more. Then I laid you on top of your bed, took off your shoes, loosened your belt, undid your collar, and wiped all the stinking puke off the front of your shirt. I took off your granny glasses and that dumb cap you always wore and put them on top of your dresser, laying the glasses neatly with the stems down. I wet a towel with cold water and put it on your forehead. Then I put a pillow under your head, my friend, and covered you with a blanket, and put a bucket beside your bed in case you needed to puke again. Remember any of that? Maybe not, because you were passed-out drunk. But I certainly never got any thank-you for that from you.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("There was another little silence, followed by a short, humorless laugh. “Yeah,” Blazer said. “Maybe you did do that. So give me a call after you’ve talked to Kohlberg.” Then the line went dead.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("But when Peter Turner called Jacob Kohlberg, he felt he had struck a dead end. The lawyer’s tone was almost icily formal. “Silas Tarkington was a friend and client of mine throughout his entire business life,” he said. “I’m afraid client confidentiality prevents me from discussing either his business or his personal life with you. In my book, client confidentiality extends even after the client’s death. I’m sorry not to be able to help you, Mr. Turner.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Then, late in the afternoon, Jacob Kohlberg had called him back, and his tone was friendlier. “I mentioned your project to Mrs. Tarkington,” he said, “and I believe she’d be willing to talk to you. She gave me permission to give you her private number. But give her a few days, while she adjusts to—the loss of her husband.”")])])])
}]}

/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(104),
  /* template */
  __webpack_require__(105),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 104 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 105 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "chap-title"
  }, [_c('span', [_vm._v("7")])]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_vm._v("Miranda steps out from under the Pierre’s marquee, turns south and walks a block, and there it is, her father’s magical store, dark now in honor of his memory but still full of his life. As always, the sight of the grand old building, which appears to be nestled in its newer L-shaped addition, evokes a little inner gasp of wonder. How gracefully the elegant Nile-green awnings seem to reach out and embrace the avenue. She stands at the corner of 59th Street, waiting for the "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("WALK")]), _vm._v(" light, admiring the sheer presence of Tarkington’s as it manages to grace this corner of Manhattan.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Suddenly she turns, takes several rapid steps eastward down 59th, and steps into the recessed doorway of a religious bookstore, where she appears to be intensely interested in the titles displayed in its window. She has just seen Diana Smith emerging from Tarkington’s side entrance, looking not quite her usual spiffed-up self, looking preoccupied. She has no wish to encounter her late father’s mistress at this point, and out of the corner of her eye she watches as Smitty steps to the curb, raises her hand to flag a taxi, greets a passing friend, and finally steps into a cab and is borne away, southward, into the evening. This process, which takes mere minutes, seems to take hours. Then Miranda emerges from her hiding place, returns to the corner, and waits for the next "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("WALK")]), _vm._v(" light.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Inside the store, she waves a greeting to Oliver, the watchman.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Sad day, ain’t it, Miss Tarkington,” he says.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Yes, it is.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You have my deep condolences.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Thank you, Oliver,” she says.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You just missed Miss Smith,” he says. “She was just here.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Oh, what a pity,” she says.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“She was lookin’ real bad, real green around the gills, like the fella says. She’s takin’ it real bad. We all are.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“What did she want, I wonder?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“She took out a big ring she wanted to show to a customer from South America.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Oh?” she says, making a mental note, thinking, Have the vultures already begun to descend? In a book about Barbara Hutton, she read how, after the heiress’s death, all her jewelry was mysteriously missing by the time anyone from the family arrived. At least all of Smitty’s merchandise is comfortably insured.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In the bank of three elevators, the southernmost car goes directly to the apartment, and Miranda enters it, using the magnetic card that will permit her to be carried, nonstop, to the upper two floors. The elevator glides upward, and she steps out into the mirrored foyer of the apartment. Milliken, her mother’s major domo, greets her. “Mrs. Tarkington hasn’t arrived yet, ma’am,” he says. “She telephoned to say she’d be a few minutes late.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Thank you, Milliken.” She drops her bag on a chair and moves toward the green library.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Mrs. Tarkington said it would just be the two of you for dinner tonight, ma’am.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Yes.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Mrs. Tarkington suggested something simple, ma’am. Cook has made a crabmeat salad and a bread pudding for dessert. Will that be all right?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“That sounds fine, Milliken.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Shall I bring you a glass of wine in the library, ma’am?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Lovely, Milliken.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Milliken has just begun calling her ma’am, a title formerly reserved for her mother. Before her father’s death, she was Miss Tarkington. Some subtle change in her status, a change apparent only to Milliken, has occurred in the last two days, and now she and her mother are both ma’ams. Should she feel pleased to be so elevated? Miranda is not sure.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The green library was always her father’s favorite room. Of course it is really not a library at all. It is just a stage set for a library, just another of the stage sets her father created for his life. The walls and the bookshelves are covered in green leather, and so are the books themselves, but they are not real books. Behind these green leather bindings with their gold-lettered titles—"), _c('i', [_vm._v("Views of Ancient Rome, Seventeenth-Century French Architecture, A History of Opera")]), _vm._v(", and so on—are blank pages. One whole wall of these "), _c('i', [_vm._v("faux")]), _vm._v(" books, for instance, swings open to reveal an enormous television screen. The people her father entertained here—his bankers, certain special clients, a few close friends—did not come here to read. They came to talk of money and merchandise or to play gin rummy at ten dollars a point. His “official” photograph, taken by Bachrach in 1970, half smiles at her from a low table.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Tonight the room seems strangely still and empty. The rack containing his collection of pipes sits on his green-leather-topped desk. The elephant-foot stand—"), _c('i', [_vm._v("faux")]), _vm._v(", like the books—holding his collection of walking sticks is by the door, walking sticks topped with heads of eagles, sea gulls, lions, snakes, and horses, carved in teakwood, ivory, brass, silver, and baleen, some of them antiques but most of them copies. As she sits in her father’s green leather chair by the empty fireplace, Miranda thinks she can still smell her father’s pipe smoke in the air.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Milliken arrives with her wine on a silver tray. He places this on a low table beside her chair, along with a silver bowl of Cheese Doodles. Her father had a passion for Cheese Doodles and liked to nibble on them while he sipped his evening drink, which, of course, was never wine but Chivas Regal. His bar is still stocked with Chivas Regal, and the butler’s pantry contains shelf after shelf of nothing but Cheese Doodles. The sight of the Cheese Doodles moves her strangely. “Thank you, Milliken,” she says, and he withdraws.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She is sitting in the president’s chair.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Just think of the things you and I could do together,” Tommy Bonham said to her.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You mean I’d be your co-president?” she said.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Partners,” he said. “Full partners. Think about it, Miranda.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("And of course she is thinking about it now. Carefully.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Running the store. Running it with him. Fifty-fifty. Partners. Filling her father’s shoes, in a real sense. Working with Tommy, the way her father did, as a team. Sitting at his big desk, in the corner office, pushing buttons, with Tommy’s office right next door. Or, if they are to become co-presidents, will they both have corner offices?")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Of course she has always dreamed of running the store. But it was just that, a hazy dream, with none of the specifics filled in. Now she must consider these specifics. To begin with, there is the possibility that she would be taking this big step too fast, that she is emotionally and occupationally unprepared for it, and that she will fall flat on her face. That could happen, of course, but Miranda has enough confidence in her ability and adaptability to feel sure it won’t.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("But one of the practical questions to be asked is this one: What will it be like to work with Tommy? One of the nice things about her present job, despite its boring aspects, has been her independence. She is really her own boss. She "), _c('i', [_vm._v("is")]), _vm._v(" the Advertising Department. Each month she is presented with an advertising budget, and as long as she doesn’t exceed that budget the job virtually does itself, like a plane on automatic pilot. The only actually “creative” moments occur when she discovers a new publication, studies its demographics, and proposes that the store experiment by placing an ad in it. Otherwise, she reports to no one. Tommy Bonham and she have had no opportunities to clash, or disagree, or even to interact at all. He has always left her alone, treated her with distant but polite respect—after all, as he said, she was the boss’s daughter—but now they will be interacting a great deal.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Miranda knows she is well liked by the store’s personnel. That will not present a problem. On the other hand, she also knows that Tommy Bonham is less well liked. She has heard members of the staff complain that Tommy is overscrupulous in his attention to detail, that his eyes seem to be everywhere in the store at once, that he is too zealous in his criticism of the slightest oversight or shortcoming. Often, when an unpleasant chore had to be performed—the dismissal of an employee, for instance—her father delegated Tommy to perform that chore. She has heard Tommy referred to as her father’s hatchet man. What will it be like with Tommy looking over her shoulder all the time, ready to catch her in her first mistake? In the beginning, at least, she is bound to make a mistake or two. Maybe even three. How will she react when Tommy, however gently, reprimands her in this process he calls “teaching her everything she needs to know”?")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“No, Miranda,” she can hear him say, “that’s not the way we do it.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“But that’s the way "), _c('i', [_vm._v("I")]), _vm._v(" want to do it,” she can hear herself reply.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Stalemate. All at once, teamwork has ground to a halt.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Would the idea of co-presidents, where each had equal authority, really work? What would it be like? There are no ready answers to these questions, she thinks. We’d have to wait and see.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Then there is the question, What is Tommy Bonham really like? She doesn’t really know. A complicated man, she thinks. A bachelor. Tommy Bonham’s bachelorhood is by now an established fact of New York social life. Only the adjectives used to describe that famous bachelorhood have changed over the years. In the 1970’s, when he first appeared on the scene, the word for Tommy was "), _c('i', [_vm._v("eligible")]), _vm._v(". “Handsome Thomas Bonham, one of New York’s most eligible young bachelors,” Mona Potter called him, and that description prompted a number of eligible women to set about trying to correct the situation. They had not succeeded. By the 1980’s, he had become a "), _c('i', [_vm._v("perennial")]), _vm._v(" bachelor. And now, in the 1990’s, he is a "), _c('i', [_vm._v("confirmed")]), _vm._v(" bachelor, with the word “confirmed” implying that he has taken his final solemn vows to remain in an unmarried state. Women no longer bother offering themselves to Tommy Bonham—not, at least, with marriage as their goal.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Of course there have been the usual number of sly speculations about Tommy Bonham’s sexual orientation. Every single male past the age of thirty-five in this city is accustomed to this sort of talk, and Tommy himself has joked about it. “I know there are people who say I’m gay,” he once chuckled to Miranda’s father. “Maybe I should encourage those rumors. Maybe that would make some of these broads who are trying to get me to the altar leave me alone.” Miranda has never taken any of these innuendoes seriously. Many women Tommy has dated have offered opposing testimony. “My dear, he’s simply the best swordsman in town,” one woman gushed to her. “I’m amazed he’s never asked you out.” But Miranda knows why he never has. Because she was the boss’s daughter. Now, however, that situation has changed.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("But this in itself raises another ticklish question. Remembering her wild, schoolgirl crush on Tommy, she asks herself, What would happen if, working with him in such close proximity, those old feelings should come surging back? How would she react if he were to put his arm around her or draw her to him? That would certainly complicate things. Can she trust herself? She has often found herself more than idly wondering—what woman wouldn’t, with a man as handsome as Tommy?—whether he was just as handsomely constructed elsewhere. But no, she decides. That crush was too long ago. She has long since come to regard him as nothing more than her father’s business adjunct, a store fixture. And he has never expressed any sexual interest in her. None whatever.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("This afternoon, though, he said something that surprised her. “You know,” he said, “I was the one who talked your father into giving you a job at the store in the first place.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Really?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“He was very much opposed to it. He wanted you to marry a man like David Belknap, and move to Westchester, and start having babies.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She made a wry face. “That’s what David Belknap wanted.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“But I talked your father into hiring you,” he said.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“So it’s thanks to you that I’m working for the store at all?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He winked at her. “That’s right. You owe me one. You owe me one, Miranda.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Her father disapproved of many things about Tommy. He disapproved of his bachelor’s lifestyle. He disapproved of his reputation as a womanizer and ladies’ man and often said that Tommy should settle down with a Tarkington’s-type woman. “He dates these Junior League girls,” she had heard her father say. “Why doesn’t he marry one of them? It would be better for our image.” Her father said these things, despite the fact that his own reputation as a womanizer and ladies’ man was becoming widespread and the women her father chose weren’t all Junior Leaguers.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She had learned about her father’s tastes in women firsthand when she was seventeen. It was the end of her first semester at Sarah Lawrence, and her name was posted at the top of the freshman honor roll. Excited, she wanted her father to be the first to know, so she hopped on a train to Manhattan and went straight to her father’s office, feeling proud as punch, smart as paint. Looking up from her desk as Miranda marched toward her father’s closed door, Pauline O’Malley sprang to her feet and tried to block her path. “You can’t go in now, Miranda!” she cried. “He’s in conf—”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Nonsense,” Miranda said, “this is important,” and she pushed Pauline aside and tried the door. It was locked from the inside.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Mr. Si!” Pauline screamed into the intercom. "), _c('i', [_vm._v("“Your daughter is here!”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Miranda pounded on the door. “Open up, Daddy!” she said. “I’ve got great news!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("It was a few minutes before the door opened, and Miranda was astonished by what she saw. His office was in disarray. Two lampshades by his sofa were crooked, there were sofa cushions on the floor, and a picture over the sofa hung askew. Her normally impeccable father looked similarly disheveled. He was in his shirt sleeves—he never worked in his shirt sleeves—and his collar and necktie were undone. His usually perfectly combed white hair was mussed, his shoelaces were untied, and he was perspiring heavily.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“What happened, Daddy?” she cried.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I was just having a little nap.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("But she had never known him to take naps and, from the way he was breathing, he looked as though he had been running, not sleeping. “You must have had a bad dream,” she said. She knew that he sometimes did have bad dreams.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Yes, that’s it,” he said. “I was having this really very bad dream, Miranda.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Well,” she said, taking charge, “you just march into your bathroom and clean yourself up. I’ll straighten up this mess.” Almost meekly, he obeyed her, and from his bathroom she heard water running. She gathered up the papers from the floor, put the desk lamp back on its base, straightened the pictures, and picked up the sofa cushions. Suddenly she heard sort of a scratching sound from inside his coat closet. She pulled open the closet door, and a naked woman was crouched there, looking up at her with frightened eyes, one arm crossed across her bare breasts and the other hand covering her crotch. She didn’t know the young woman’s name, but she recognized one of the models who paraded in designer dresses on the fashion floors. The woman was not much older than Miranda herself. “Well, "), _c('i', [_vm._v("excuse me")]), _vm._v("!” Miranda said, and slammed the door closed. “I made the top of the honor roll, Daddy!” she shouted angrily in her father’s direction as she marched out of the office, though she doubted he could hear her over the running water.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("As she passed Pauline’s desk in the outer office, the secretary gave her a worried I-told-you-so look.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Disgusted with him, she decided to punish her father and refused to speak to him for a solid month. When he called her at college, she refused to come to the phone.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("When she got back to Bronxville, she told her roommate what had happened. “Should I tell my mother? Or not?” she asked.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Not,” her roommate said. “Don’t make waves. Besides, all men are like that.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Well, the man "), _c('i', [_vm._v("I")]), _vm._v(" marry is not going to be like that,” Miranda said firmly.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Later, when they were back on speaking terms, her father had tried to offer her an explanation. “I know you found Miss Rosenthal hiding in my closet that day.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I did indeed!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“She was in somewhat of a state of "), _c('i', [_vm._v("déshabille")]), _vm._v(",” he said. “But let me explain. These things are something of an occupational hazard for men in my position. These girls, these little models, think they can advance their careers by literally throwing themselves at the chief executive. Sometimes, one has to literally fight these advances off, Miranda. That was what happened that afternoon. I was in the middle of fighting her off. Needless to say, I had words with her later, she apologized for her indiscretion, and I forgave her. Meanwhile, you should really telephone before just barging into the office.… I’m happy about the honor roll.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Hmm,” was all she said. She didn’t believe a word of it.")]), _vm._v(" "), _c('p', {
    staticClass: "indent2"
  }, [_vm._v("“We have a lot of things we need to talk about, Miranda,” her mother said to her this afternoon as they were leaving Jake Kohlberg’s office. “Let’s have dinner together, just the two of us, tonight at the apartment.” Now Miranda is sipping her wine in the green library, waiting for her mother.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Well, one of the things they will definitely "), _c('i', [_vm._v("not")]), _vm._v(" talk about tonight is Tommy Bonham’s proposition. Whatever decision Miranda makes about that, she will make entirely on her own.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Still, she can’t help wondering what her father would have had to say about all this. “What do you think, Daddy?” she asks him now.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Do you really want to run the store?” the half-smiling Bachrach portrait answers her.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Yes!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Women can’t run stores, Miranda.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I’m taking night courses in marketing at N.Y.U. I got an A on my first big test.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You never told me that.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I was saving it to tell you now.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You don’t learn marketing from textbooks. You learn it from experience.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“What if I were to run the store with Tommy? He has plenty of experience.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The portrait has no response to this. She has lost his wavelength. "), _c('i', [_vm._v("What did you say, Daddy? I can’t hear you")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Idly, and for no real reason, she picks up the green telephone beside her chair and dials his private office number. It rings once, twice, three times; she can even hear it ringing faintly in the empty office on the floor below. Then, all at once, he answers!")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Hello. You have reached the voice-mail number of Silas Tarkington. I’m unable to take your call right now, but, when you hear the tone, please leave your name, telephone number, and any message, and I’ll get back to you as soon as possible. Your message can be of any length. If there is any item in the store you’re looking for, or if there is any way I can be of service to you, please let me know. Thank you for calling. Goodbye.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Miranda quickly replaces the receiver in its cradle. No one has erased the tape on his machine.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('i', [_vm._v("If there is any way I can be of service to you.…")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("For the first time since her father died, Miranda allows herself the luxury of a good, noisy sob.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Then, outside the room, she hears the elevator door slide open and the brisk click of her mother’s Chanel heels across the marble floor of the foyer.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Miss Tarkington’s waiting for you in the library, ma’am,” she hears Milliken say.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Be with you in a minute, darling!” her mother calls out, almost gaily. “I just want to slip into some more comfortable shoes.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent2"
  }, [_vm._v("How could her mother remain so composed? Of all the odd things that happened the day her father died, perhaps the oddest was her mother’s behavior. Miranda had been in East Hampton for the weekend, visiting with friends, when her mother telephoned her. “Darling, something terrible has happened,” she said, and then she told her.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Miranda, not even bothering to pack, had jumped into her blue BMW and driven directly to Old Westbury. But as she drove through the gates of Flying Horse Farm, everything there seemed as ordered and manicured as ever. She had expected to find the circular drive in front of the house filled with cars—police cars, an ambulance perhaps, reporters, television crews. She didn’t know what she had expected to find, but when she parked her car at the foot of the steps leading up to the house, hers was the only car in the drive. Everyone, it seemed, had already come and gone. Dr. Arnstein had arrived by helicopter, signed the death certificate, and departed. The hearse had arrived from Campbell’s, and her father’s body was already on its way to New York and the crematorium. All this, it seemed, had happened before Miranda’s mother telephoned her in East Hampton.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She ran up the steps to the house, where Milliken, who had obviously been weeping, greeted her. He squeezed her hand. “Your mother’s in the sun room,” he whispered.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She found her mother there, in the room decorated in sunny garden colors—pinks, yellows, pale greens, and blues—sitting in a wicker chair, looking as coolly beautiful as ever in a white silk blouse and white silk slacks, working on her needlepoint. She was making a cover for her tennis racket. Her mother rose when Miranda entered the room, and they embraced, Miranda fighting back tears.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Darling, we won’t have your father anymore,” her mother said simply. “He loved you so. He was so very proud of you.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“What happened, Mother?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“He was swimming his laps in the pool. He just decided to swim one more lap than his fine, strong heart would let him—that’s what Harry Arnstein said.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("They sat, and Consuelo Tarkington picked up her needlepoint and began listing the things she had done, and the people she had notified, since she had found his body floating earlier in the day.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Did you call—”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Smitty? Yes. Smitty has been notified.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Tommy?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Yes. Tommy is coming by for a drink a little later.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Blazer?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Of course.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Pauline?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“That’s one call I thought I’d ask you to make, darling,” her mother said. “Pauline tends to get so—emotional—and besides, you’ve worked more closely with her at the store.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("And so, feeling numb, Miranda had gone to the telephone and called Pauline O’Malley at her home in Kew Gardens. Pauline had immediately become so hysterical she had to hang up the phone.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Miranda returned to the sun room where her mother was pulling a thread of golden wool through her canvas, completing a flower in the pattern. She had tucked her slippered feet underneath her in the chair. She spread the canvas on her lap and examined it. Her pose was so serene it seemed almost Oriental. She could have been painted on a Chinese plate.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“What about the press?” Miranda asked her.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Tommy’s taking care of that,” her mother said. “He pointed out, correctly, that if we report it to the press today, the news will be printed tomorrow, which is a Sunday. Obituaries just get lost in the Sunday papers. But if we wait a day, there’s a good chance it will make the front page of "), _c('i', [_vm._v("The Times")]), _vm._v(" on Monday morning.” She returned to her needlework.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Miranda sat opposite her mother. “Now tell me exactly what happened,” she said.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“He told me he was going out to swim his laps,” her mother said, without looking up from her work. “It was about eleven-thirty. I reminded him that lunch was being served at twelve-thirty. When he hadn’t returned by then, I went out to the pool to look for him. That’s when I found him … floating. I immediately telephoned Harry Arnstein.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Miranda glanced at her watch. It was nearly six-thirty, which meant that her father had been dead for at least six hours. “Why didn’t you call nine-one-one?” she asked.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Her mother looked up at her briefly. “Nine-one-one is a "), _c('i', [_vm._v("police")]), _vm._v(" number, darling. There was no need to involve the police.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“But they would have sent the life squad. They might have—”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You would have had police sirens—police ambulances—screaming down Heather Lane? Upsetting all the neighbors who were trying to enjoy a quiet Saturday afternoon? Really, Miranda. You know the thing your father loved best about the country was the peace and quiet here.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“But they might have saved his life!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Her mother looped another stitch through her canvas. “Miranda, I assure you there was no life left to save,” she said. “Harry Arnstein confirmed this.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“But still, that’s what I’d have done!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She spread her canvas on her lap again. “I’ll tell you another reason why I didn’t do that,” she said. “If you get the police involved, they’re required by law to perform an autopsy. Do you know what an autopsy involves? If you don’t know, I’ll leave it to your imagination, but it’s horrible. I wouldn’t dream of having such a thing done to your father.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“How long did it take Dr. Arnstein to get here?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“He was here within the hour.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You see? That hour could have been crucial. The life squad could have—”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Miranda, "), _c('i', [_vm._v("please")]), _vm._v("!” Her mother was beginning to show her first signs of impatience. “I did what I had to do. I don’t think I even "), _c('i', [_vm._v("thought")]), _vm._v(" of calling nine-one-one. I’m not even sure I knew there was such a number. I wanted your father’s life to end the way he would have wanted it to end—with dignity, and taste, and grace, and with just me and his old friend Harry Arnstein with him. Not with sirens screaming.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("It seemed to Miranda that her mother was making a lot of different excuses that didn’t quite hang together. She hadn’t called 911 because the life squad would make too much noise and disturb the neighbors. The life squad would have meant an autopsy. She hadn’t even thought about calling 911. She didn’t even know there was such a number. She wanted the death to be dignified and private. “Why did you wait so long before calling me?” she asked. “You say he died at twelve-thirty. I didn’t hear from you until after four.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“What would have been the point? I felt I had to do first things first.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I might have liked to have seen him one last time. I might have liked to have said goodbye to him.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I wanted to spare you that,” her mother said.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Spare me? That’s what I’d have liked to "), _c('i', [_vm._v("do")]), _vm._v(", Mother!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She looked up from her needlework. “Death isn’t pretty, Miranda,” she said. “You don’t know that. I do. It takes a certain amount of—practice—to be able to deal with death. You’ve had none. I’ve had a great deal. My mother, my father, my grandparents. Perhaps, the first time, I wasn’t very good at it. But with practice I’ve gotten a lot better.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Suddenly Miranda was very angry. “How can you just "), _c('i', [_vm._v("sit")]), _vm._v(" there like that?” she had cried. “Just sit there like some goddamned female Buddha, as though nothing has happened! Sitting there with your goddamned needlepoint—like Madame Defarge, stitching away while heads roll off the guillotine! Don’t you have any human feelings, Mother? A man is dead. Your husband is dead. Maybe you didn’t love him, but he was still your husband. And he was also my father! Whom I happened to love very much!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Her mother rose slowly from her chair and folded the needlepoint canvas across her bosom. “This conversation isn’t really getting us anywhere, is it?” she said. “I’ve asked people who want to pay their respects to come here for drinks at seven-thirty, and I need to freshen up. If you’d like to join us, you might want to freshen up too. You look a little windblown from your trip in from the Hamptons. Run a comb through your hair. Powder your nose.” Then she was gone, leaving Miranda fuming.")]), _vm._v(" "), _c('p', {
    staticClass: "indent2"
  }, [_vm._v("That night at seven-thirty the guests started arriving—the old friends, some of the people from the store, the neighbors from up and down Heather Lane. Some people stayed for only a few minutes. Others stayed longer. Tommy Bonham was one of the first to appear, and Miranda watched as he took her mother in his arms, kissed her, and said, “Connie, I’m so sorry.” Blazer arrived from the Village, looking more stunned than sullen, and Miranda was pleased to see that he had put on a dark suit and necktie. Harry Arnstein was there, looking solemn and professional, and Smitty had also come out from the city, looking red-eyed and a little frightened. She shouldn’t be here, Miranda thought. And yet her mother had obviously asked her to come, and she watched as her mother made a special point of stepping over to Smitty, squeezing her hands, and kissing her lightly on both cheeks—kisses so light that flesh never touched flesh. Was this gesture done for the benefit of the audience, for the others in the room? “Isn’t Connie re"), _c('i', [_vm._v("mar")]), _vm._v("kable?” she heard someone whisper.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Moe Minskoff, who had had financial dealings with her father over the years, also appeared with his bleached-blond wife, who was called Honeychile—to her mother’s almost visible displeasure.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“What are those people doing here?” she heard her mother whisper to Tommy Bonham. “Who invited them? I certainly didn’t. How did they find out about this?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Tommy Bonham merely rolled his eyes.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Meanwhile, both Minskoffs seemed to have decided to make an evening of it, not just a polite condolence call. They seemed to be settling in for the night.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("By eight o’clock, there were perhaps twenty people in the formal living room. Milliken was serving drinks and passing trays of caviar on toast points, and Miranda’s mother—now in a slender white silk jump suit with tiny silver bells at the belt—was moving about the room, trying to spend a little time with each guest, explaining how Si had had “a coronary accident” while swimming his laps—“Dr. Arnstein assured me it was very sudden, and there was no pain”—and soon the noise level in the room had risen, and it was clear that all the men in their sober suits and ties, and their wives in their demure little black dresses, were drinking and generally beginning to have a pretty good time.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Si loved parties,” Miranda heard someone say. “He would have approved of this.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("But Miranda was not so sure.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Over the living room fireplace hung the large painting of Flying Flame, her father’s famous racehorse that had won the Arc de Triomphe in Paris in 1971, and, leaning against the mantel with a cigar in his fist, the portly Moses Minskoff was holding forth about the painting. “I remember when I came up with the name for that stallion for Si,” he was saying. “I said to Si, ‘Si, name him Flying Flame.’”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Don’t be ridiculous,” she heard her mother say. "), _c('i', [_vm._v("“I")]), _vm._v(" named that horse.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“No,” he said flatly. “In actual fact, I came up with the name for that horse. I’m something of an expert on horseflesh, you know. It was the year of Comet Kohoutek, and I’d read in the paper that morning that the comet would appear like a flying flame across the sky. I said to Si, I said, ‘Si, there’s the name for your stallion—Flying Flame.’”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I remember you telling me that story, Daddy,” Honeychile Minskoff put in.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Nonsense,” Miranda’s mother said. “I named him Flying Flame because his sire was named Fly By Night, and his dam was Torch Singer. You always try to do that—give a horse a name that will suggest the breeding line.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“No,” Moe Minskoff said again. “I named him after Comet Kohoutek.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I know you did, Daddy!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Comet Kohoutek didn’t come until years later!” her mother said sharply.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("With that, she saw Tommy Bonham’s hand reach out and touch her mother’s bare arm very gently. “I want to tell the story about the Queen’s visit to the store,” he said, changing the subject. “Si wouldn’t admit he was nervous. But he was.…”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("That was one of Tommy’s great talents, avoiding unpleasantness, defusing a confrontation.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Miranda could understand the cocktail-party atmosphere that had overtaken the evening. Right after a death, there is a need for a certain release, and this was it—a release from the shock. But she wasn’t feeling up to it, so she wandered from the party that was going on in the living room and out into the garden to the pool—where he died. It seemed as good a place as any to say goodbye to her father.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The pool was still as glass and inky black, though there were moonlight and starlight reflected in its glassy surface. She wondered briefly whether her mother would have the pool torn out and the excavation filled in, now that somebody had died there. She knelt by the edge and trailed her fingers in the still water. Then she put her fingertips to her lips, to taste the water in which her father had died. She stood up again.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The switch that turned on the underwater lights was mounted in a low stone wall that bordered the pool, and she walked to this and flipped it upward, but the lights did not come on. Then she realized why the surface of the pool was so still. The filter, which normally ran twenty-four hours a day, rippling the pool with its jets, was not working. She flipped the filter switch, but nothing happened. A third switch controlled the outdoor garden lights, but these were not working either.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She ran up the short flight of steps to the pool house and began flipping switches there. No lights were working in this part of the farm at all, and suddenly a shiver ran down her back, and she thought, "), _c('i', [_vm._v("electricity")]), _vm._v(", the television set. Even without lights, she could see that the television set was not sitting where it usually sat, on a shelf against the far wall of the room, in its Lucite case. In the moonlight semidarkness, she searched for the television set, but she could not find it.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("This was no ordinary television. In 1976, her father had made a special trip to Washington to show some designer dresses to Mrs. Betty Ford at the White House. To thank her for her purchases, Si had sent Mrs. Ford two silk Hermès scarves. The Fords responded by sending Silas Tarkington videotapes of all President Ford’s speeches, along with a portable television set to play them on. An engraved brass plaque on the top of the set read:")]), _vm._v(" "), _c('p', {
    staticClass: "center1"
  }, [_c('span', [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("FOR SILAS TARKINGTON")]), _vm._v(",")])]), _vm._v(" "), _c('p', {
    staticClass: "center2"
  }, [_c('span', [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("A GREAT MERCHANT")]), _vm._v(",")])]), _vm._v(" "), _c('p', {
    staticClass: "center2"
  }, [_c('span', [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("WITH WARMEST THANKS FROM")])])]), _vm._v(" "), _c('p', {
    staticClass: "center2"
  }, [_c('span', [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("PRESIDENT AND MRS")]), _vm._v(". "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("GERALD R")]), _vm._v(". "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("FORD")])])]), _vm._v(" "), _c('p', {
    staticClass: "center2"
  }, [_c('span', [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("1976")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent1"
  }, [_vm._v("Miranda doubted that her father had ever played the tapes of the President’s speeches, but he had the Lucite case made to display the set. And when he swam his laps, he plugged the set, tuned to the cable news network, into one of the outdoor outlets, and a red digital clock on the face of the set kept track of the time for him. He claimed that counting his laps was boring. Instead, he timed himself, swimming for half an hour, forty-five minutes, or sometimes for a full hour, whenever he was in the country.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The sight of that television set at the edge of the pool always made Miranda nervous. “What if it fell into the pool while you’re swimming, Daddy? You could be electrocuted.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“How could it fall into the pool? It must weigh twenty pounds.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Blackamoor, his big Lab, often ran up and down the length of the pool as he swam and sometimes got excited enough to leap into the water and swim alongside, yipping with pleasure.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“What if Blackie tripped on the cord and knocked it in?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Nonsense. Blackie knows our routine.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Two years ago, for his birthday, she had bought him a scuba diver’s underwater wrist chronometer. “It’s guaranteed for depths up to a hundred feet,” she told him.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Great, but why do I need it?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“It’s to use instead of the clock on the TV set,” she said.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He laughed. “It would break my rhythm if I had to keep looking at a watch all the time,” he said. “I prefer my TV clock.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Then, as a joke, she had bought him an ordinary kitchen timer, with a bell.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He had looked at it. “Will this also give me my cable TV news?” he said with a smile.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("And now the set was gone, and all the power in that corner of the farm was out, and her father was dead.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In the distance, from the main house, she could hear the sound of laughter. “Oh, he was a wonderful man, a wonderful man,” she heard Moe Minskoff saying. “Sucha sense-a yuma.…”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Behind the pool house was Blackamoor’s kennel, and she went to look for him. There were no lights there either, but Blackie bounded up from his bed, wagging his tail, and seemed pleased to see her. But when she offered him a milk bone, he didn’t want it and just dropped it back into her hand.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("And so she sat with the big dog for a while, stroking his ears, with his big head resting on her lap. He seemed sad, as sad as she was, and perhaps even sadder because there was no way for him to express his sadness. From the main house, farther up the hill, the party sounds continued, and she could even hear her mother’s tinkly, polished laugh. From Blackamoor now came soft whimpering sounds, whether of pleasure or sorrow she had no way of knowing.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Miranda rested her chin on the top of Blackie’s head and was suddenly certain he knew that her father was gone and would never be coming back. And she had another scary, eerie feeling that the dog knew something about her father’s death that she would never know. “Blackie,” she said to him, “if you could talk, is there something you could tell me?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent2"
  }, [_vm._v("In the green library now there is the sudden scent of Shalimar as Miranda’s mother enters the room, a little breathless. “Sorry to be late, darling,” she says, “but I couldn’t get a cab and ended up walking all the way from Forty-fourth Street.” She gives Miranda a peck on the cheek. She has changed into flats, but the two crescents of pale hair that frame her face are still perfectly in place. She steps to a mirror, touches her hair, and flicks an invisible speck of lint from the sleeve of her navy Chanel suit. Then she moves quickly away from the mirror, glides back across the room, and sits in the green leather chair opposite Miranda, under Monet’s painting of water lilies, where the museum light shines down on her hair, giving it frosty glints.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("It is another of her mother’s mysterious talents, Miranda thinks—to be able to position herself perfectly in a room, under a painting where her white skin reflects the tone and texture of the lily blossoms, and where the lamp echoes the reflected sunlight in the lily pond.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Milliken arrives with iced tea in a silver goblet, garnished with a lemon wedge and a sprig of fresh mint.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Thank you, Milliken.” Miranda’s mother fishes for a cigarette from the silver box on the coffee table, screws it into a silver cigarette holder, and lights it with a silver table lighter. Everything seems to glimmer in the lighter’s blue and orange flash. In her mother’s world, Miranda thinks, everything works, including silver table lighters, which never work for anyone else.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Her mother glances at the silver bowl. “Cheese Doodles,” she says. “Dear me. Remind me to tell Milliken to throw out all those Cheese Doodles in the larder.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I happen to like Cheese Doodles, Mother.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Her mother throws her a quick look. “Do you? Dear me. Well, "), _c('i', [_vm._v("chacun à son goût")]), _vm._v(". There’s apparently a young man who wants to write your father’s biography. What would he say if we told him that your elegant father’s favorite snack was junk food?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Do we want Daddy’s biography written, Mother? He never wanted it done.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I asked Jake Kohlberg the same question. He feels that if we don’t cooperate, this man might decide to write the story anyway, and we’d have no—leverage, as Jake put it, over what he decides to say.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Control, you mean.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Exactly. Anyway,” she continues, without skipping a beat, “the will’s been read, that’s over and done with, and we all know where we stand. Too bad about Blazer, because your father really was going to relent and leave Blazer something. Not a lot, I think, but something.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“But still—”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You know why your father did that to Blazer, don’t you? It wasn’t just because of the things Blazer said to him that day. It was because he hoped that leaving him out of the will would galvanize Blazer into finding a job. ‘Shock therapy,’ your father called it. Anyway, there’s nothing to be done about that now, is there? And”—she blows out a long thin stream of smoke—“we’ve got more important things to discuss, you and I. We’ve got to decide what’s going to happen next.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Yes.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I had a long talk with Jake Kohlberg after you left,” she says. “He feels very strongly, and I agree, that we ought to sell the store.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Oh, no!” Miranda cries.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Apparently Continental is planning to make us a nice tender offer, and there are a couple of other bidders, and Jake thinks, and I agree, that we ought to accept the best offer as soon as we can. A bird in the hand, as your father used to say. It’s the only sensible thing to do, darling.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“But we can’t give up the store, Mother!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Why can’t we? We’d all be paid a lot of money. And obviously I can’t run the place, and neither can you.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I’d sure as hell try!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Darling, I know you’ve always "), _c('i', [_vm._v("said")]), _vm._v(" you’d like to run the store, but do you have any idea what it’s really like? Of course you don’t. Do you have any idea of how to deal with the market? You don’t even know the market. Those are tough guys out there, those market people. Your father was a tough cookie, and he could deal with them. You’d be an innocent abroad, a babe in the woods. You’d be like a minnow swimming in a sea of sharks. They’d gobble you up in no time.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Retailing, Miranda thinks, is perhaps the only business in the world where the term “the market” does not mean the customers. It means the designers, the manufacturers, the suppliers, Seventh Avenue. And it is true that she has had absolutely no experience dealing with the market. “But what about Tommy?” she says.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“If the new owners want to use Tommy’s—talents, they can do so. Tommy’s a bright boy. He’ll always land on his feet. I’m not worried about Tommy.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“And what about me?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Your job, you mean? Well, it isn’t much of a job, is it, darling? Not that you don’t do what you do very well. But I suppose if you still wanted to work for the store, the new owners might be able to find something for you—if you wanted something. But why should you? You’ll have plenty of money.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“It’s not just money, Mother!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Darling, everything is money in the end, isn’t it? Of course it is. If I were Miranda Tarkington, age twenty-four, I wouldn’t be worried about a job. I’d be thinking about finding an eligible young man to marry. I’ve never understood how you could have let that nice David Belknap slip through your fingers. They’re calling him the new wunderkind of Wall Street.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I didn’t want to marry the wunderkind of Wall Street.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“At your age, I was already married to your father.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I’m not you, Mother. You Consuelo. Me Miranda.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Of course, darling. But the point is, under the new management, you surely wouldn’t want to work there. It would be Tarkington’s in name only. It would be an entirely different store.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“But that’s exactly what I don’t want to see happen!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“It’s got to happen, darling. You saw what "), _c('i', [_vm._v("The Times")]), _vm._v(" called your father—the last of the dinosaurs. This store is the last of the dinosaurs too, struggling in vain against extinction. It’s an anachronism, Miranda. The women your father used to call ‘my kind of woman’ are either dead or dying or their husbands are being carted off to jail. As Jake Kohlberg said to me tonight, and I agree, Tarkington’s is an idea whose time has come and gone. Jake reminded me of one of your father’s favorite sayings: ‘Running a store like mine is like putting on a piece of theater. It’s show business.’ Well, as Jake says, this piece of theater has had a nice long run, and now it’s time to ring down the curtain and post the closing notice.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Jake Kohlberg, Jake Kohlberg, stop telling me what Jake Kohlberg says!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Her mother looks at her, then stubs out her cigarette. “I may not always have agreed with Jake Kohlberg,” she says, “but I’ve followed his advice and never regretted it. And I intend to follow it this time. We tender our stock to the best offer that comes down the road.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Well, I’m "), _c('i', [_vm._v("not.”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Think about it a little bit, Miranda,” her mother says gently. “Think about it, and you’ll agree with me. Your father’s grand dream—for a specialty store to end all specialty stores—is as dead as he is.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I can’t believe you’re talking about this so cold-bloodedly,” Miranda says. “This store that he built from nothing, single-handedly, from scratch—”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Well, he had a little help,” her mother says with a small smile.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Help from whom?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“From me, among other people. As Jake Kohlberg said to me this very afternoon, I’ve been the best advertisement your father ever had for his store. Do you think that’s been easy? Do you think it’s easy to stay on the Best-Dressed List? It takes time and effort and study—working with designers, studying the competition, being seen at the right places with the right people. I’ve done all that, and I did it for him and for his store. The only thing was, I never got paid for it. Now I’m ready to get paid. And I’m also ready to relax, get out of my girdle, and stop worrying about how I look every time I step outside my front door. I’m thinking of doing some travel, the Mascarene Islands, the Seychelles. I’m ready to let my hair down, Miranda.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Will you give up your beauty routine? The Dead Sea mud packs?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Well,” she says, still smiling, “some habits are harder to break than others,” and she reaches for another cigarette.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Will you give up this apartment?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Of course, when the store is sold. I’ve always hated this apartment, you know. Everything in it is fake, including—but never mind.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Mother, where was Blackie when Daddy died?” Miranda asks suddenly.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Blackie?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Blackamoor. Daddy’s dog.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Why, in his kennel, I suppose. Yes, I’m sure he was in his kennel. Why do you ask?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Sometimes he swam with Daddy.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Well, he didn’t on Saturday,” her mother says. “But I don’t understand what—”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“What became of the TV set?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Her mother looks briefly at her hands, then up at Miranda. “The TV set?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“The TV set that President Ford gave him. It was always in the pool house. It wasn’t that night.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Oh, that,” her mother says. “It was sent out for repairs several weeks ago, I think.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Where was it sent?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“To a repair shop, I suppose! I don’t know "), _c('i', [_vm._v("which")]), _vm._v(" repair shop your father sent it to, for heaven’s sake!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Sent out for repairs in its Lucite case?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I suppose! I just remember your father mentioning something about repairs. Really, Miranda, I—”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“There was a power outage in the whole pool area of the farm that night. Did you know that?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Yes. Yes, I remember one of the maintenance men mentioning that. Something to do with a circuit breaker. It was fixed the next morning.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Yes, I know.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“What do you mean you know?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I went out the next morning, and everything was working fine.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“That’s what I just told you! There was a problem. It was fixed. But I really don’t understand this line of questioning, Miranda. What has any of this got to do with—?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I think you’re lying to me, Mother. I think there’s something you’re not telling me.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Lying? Why would I lie to you? Don’t be ridiculous, Miranda! What have dogs, TV sets, and power failures got to do with what we were talking about? We were talking about our need to sell the store. We were talking about my travel plans and—”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I think Blazer was right this afternoon,” Miranda says evenly. “All you ever cared about was Daddy’s money.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Oh, Miranda!” her mother says with a sob. “What a dreadful, wretched, cruel thing to say to me! You don’t understand anything, do you? You understand absolutely nothing at all!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("At that moment Milliken appears at the library door. “Supper is served,” he says.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Consuelo Tarkington rises from the green leather chair in one swift, synchronized motion. Miranda also rises and follows her mother out across the marble foyer to the dining room on the opposite side, where the smaller of the two tables is set for two with lighted candles in a seven-branched candelabrum.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("As Milliken seats Miranda at her place, she says to him, “Do you know what happened to Daddy’s TV set, Milliken, the one he kept in the pool house?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Ah, the one the President gave him. It was apparently stolen, ma’am.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Stolen? Was that it?” Consuelo says brightly. “I thought it was sent out for repairs. Well, I knew something happened to it.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Very proud of that TV set he was, too, ma’am. He always used to show it to visitors. We apparently had a prowler that day at the farm. I heard the dog barking, and I went out to investigate. The first thing I noticed was that the television set was gone.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Was anything else missing?” Miranda asks him.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Yes, ma’am, there was. There was an underwater watch that I believe you gave him for his birthday several years ago. He was very fond of that watch too, though he didn’t wear it all that much. He kept it in the pool house, and that was missing too. His clothes were hanging in the dressing room, and I found that his billfold was missing from his right rear pocket, where he always carried it. I doubt there was much money in it. He never liked to carry cash, but the burglar got that too.” He turns to Miranda’s mother. “I’m sorry, ma’am, but I didn’t tell you any of this at the time. I thought you’d had enough that day to upset you. Because, you see, when I found his clothes in the dressing room, that was when I went out to the pool and found him—Mr. Tarkington, your poor father, ma’am—floating there.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('i', [_vm._v("“You")]), _vm._v(" found him, Milliken? I thought you found him, Mother. That’s what the paper said. That’s what you told me.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“What difference does it make?” her mother cries. “One of us found him first, and then the other came! I can’t even remember it all that clearly!” Miranda looks across at her mother, and tears are streaming down her face, and Miranda realizes that she has never seen her mother weep before. Her mother makes small balls of her fists and pounds them on the polished tabletop, and the china and glassware rattle and the candle flames dance. “What I want to know is why you’re doing this to me, Miranda! The most horrible day of my entire life, and you keep harking back to it, harking back to it, trying to make me remember all the horror I’ve been trying so hard to forget! Let sleeping dogs lie, for God’s sake! Leave me alone—just leave me alone!” She dabs at her streaming eyes with her linen napkin. “Now look what you’ve done! Cook has made this beautiful crabmeat salad, made it with her famous Armagnac mayonnaise—my favorite—and I’ve lost my appetite completely. With all I had to do today, I skipped lunch. When I came home tonight, I was hungry, but now my appetite’s completely gone!” She flings her napkin onto her untouched plate, pushes back her chair, rises from the chair with a simple fluid motion, and runs sobbing from the room.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("As quickly and discreetly as he can, Milliken withdraws from this unhappy domestic scene into the pantry, and Miranda sits alone.")]), _vm._v(" "), _c('p', {
    staticClass: "indent2"
  }, [_vm._v("Arriving at his small cottage at the far end of Heather Lane, about four miles down from Flying Horse Farm, Thomas E. Bonham III parks his Mercedes, pockets the keys, and walks up the flagstone path to his front door. This cottage was once the gatekeeper’s lodge on one of the big estates, long since broken up by a developer into half-acre plots with split-level houses selling in the $450,000 to $750,000 range. Split-level or not, this is still Old Westbury, a fashionable country address.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("This cottage is Tommy Bonham’s weekend getaway place. Normally, on a Monday night, which this is, Tommy would be in Manhattan, in his apartment on Sutton Place. But today, with the store closed in Si’s honor, and with Tommy’s only appointment having been drinks with Miranda at the Pierre, he has decided to spend an extra night in the country and drive back to New York in the morning.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In his front entryway, Tommy Bonham tosses his Mark Cross briefcase in a chair, kicks off his Gucci loafers, and moves, in his stocking feet, into the lighted living room, loosening his Turnbull & Asser necktie and unbuttoning the collar button of his shirt. He tosses the necktie over a lampshade. Then he sheds his jacket, tosses it into a chair, unbuttons his shirt cuffs, and sinks into the big Victorian sofa, causing a large pile of retail trade journals on the sofa to slide precipitously toward him.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Nino, his Filipino houseboy, whose full name is Saturnino Salas, greets him, making clicking noises with his tongue. “Could burn your tie like that, Tommy,” Nino says, but instead of removing the necktie from the lampshade, Nino merely turns off the lamp.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Tommy Bonham is a notoriously slipshod housekeeper, and Nino doesn’t appear to do much to help. A number of people who have visited Tommy, both in New York and here, have wondered how such an elegantly put-together man can live, apparently quite happily, in such disarray. Though Miranda has never been in the Sutton Place apartment, she has visited her neighbor’s weekend cottage a number of times, and what is she apt to see there? A pair of dirty tennis sneakers on the coffee table, a half-filled cup of coffee on the window-sill with a dead fly floating in it. Coming in from the pool, he will drape his wet trunks over this same lampshade to dry.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("His dining room table is always covered with at least a week’s worth of newspapers and journals, along with paper clips, ballpoint pens, pencils, scissors, and a great deal else. This, he explains, is his “desk” when he works at home. His bedroom is even worse. Miranda has never seen his bed made. Overfilled dresser drawers hang open, their contents—socks, underwear, handkerchiefs—spilling out. In one corner of the bedroom is a stack of cardboard cartons, the kind you can pick up at a supermarket when you’re packing to move, and Lord knows what these contain. When Miranda used his bathroom, his jockstrap was hanging from the doorknob, and one peek at the unlovely contents of his medicine cabinet was enough for her—uncapped, half-empty tubes of toothpaste and shaving cream squeezed from the middle, slivers of soap, rusted razor blades, broken combs, hairbrushes matted with blond hair, ragged toothbrushes caked with dried paste, an open box of condoms, and a brown and gluey substance spilled across the glass shelves in which a rusting nail file, several pills and capsules of dubious origin, and a rolled condom had become more or less permanently embedded.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Why don’t you let me straighten this place up for you?” she asked him once.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“No!” he had cried, almost in panic. “Right now, I know exactly where everything is!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The kitchen, which is Nino’s domain, always seems to be piled with dirty dishes and pots and pans. Nino’s only duties seem to be laundering and ironing Tommy’s shirts, pressing his suits and dinner jackets, polishing his shoes, and preparing his meals.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Now, at the bar, Nino fixes drinks for them both and then comes and sits beside Tommy on the sofa, pushing the pile of magazines to the floor. They touch glasses. Then, with a sigh, Tommy says, “Well, Nino, phase one is completed.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You offer her big job?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Uh-huh.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“And she say?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I didn’t expect her to give me an answer right away,” he says. “I think she was a little overwhelmed. It’s a job she can’t possibly handle, of course, but she was definitely flattered when I told her I thought she could.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Flattered? What is flattered?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Happy. Pleased with herself. Pleased that I think she’s smarter than she really is. But she’ll be putty—you know what putty is?” He makes kneading motions with his hands. “She’ll be putty in my hands, Nino, and I’ll be completely in charge of things, wait and see. It’ll be my store at last.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“And you need her because? Explain again.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“So I can get control of how she votes her stock, before the enemy does.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Is like war.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Yeah. That’s why they call it a hostile takeover.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Tell me again, Tommy, what is stock?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Shares. Shares of ownership of the store.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“And when you have that, and war is over, we go to Paracale?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Yes, Nino, "), _c('i', [_vm._v("caro")]), _vm._v(" Nino. Then we’ll go to Paracale, and we’ll go there rich.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Nino, staring into his whiskey glass, swirls his ice cubes thoughtfully. Then, as though he has seen a vision in the glass, his whiskey-colored face breaks into a smile. “Oh, you must see Paracale, Tommy,” he says. “Is not a big place, not like New York. Is a very, very small place, and only one road leads there. But is so beautiful, you will love it, Tommy. The sea—the sea is so blue, bluer than any blue sky you ever see. And in the morning, even before the sun comes up across the sea, the fishermen, in their little boats, are going out.… My father, he will be there … my mother … my sisters.…”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Tommy Bonham closes his eyes. He leans back against the sofa and runs the tip of his left index finger slowly up and down the inner curve of Nino’s thigh. He has heard the description of Nino’s village in the Philippines so often that he knows it by heart. He yawns and pinches Nino’s knee. “I’ve got to get back to the city early in the morning, Nino,” he says. “Let’s get to bed.”")])])])
}]}

/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(107),
  /* template */
  __webpack_require__(108),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 107 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 108 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "chap-title"
  }, [_c('span', [_c('i', [_vm._v("8")])])]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_vm._v("Now it is Tuesday morning, and Moses Minskoff is on the telephone again. “Ah, Mr. Martindale,” he is saying. “How good of you to call me back, and to call me back so promptly. May I call you Al? Or do you prefer Albert? … Please call me Moe, then, Albert—all my good friends do.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Now what I have in mind for you, Albert—for you and Continental—is a two-tiered tender offer. I’m going to suggest that you make Tarkington’s shareholders an offer of sixty dollars a share for their holdings.… Whoa! Hold on. Yes, I know that seems a bit on the high side, Albert, but let me finish, please. Once I finish telling you my full proposal, everything will become as clear to you as a summer’s day. Let us start with the sixty-dollar figure. You will offer them eighty percent of this figure in cash and the rest in Continental’s stock, notes, debentures, what-the-hell—what we on Wall Street call cram-down paper. Who knows what that paper is worth? Nobody. Whatever the market will stand for, right? But everybody appreciates the value of cash, don’t you agree? Of course you do.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Now, Albert, this is going to be a two-tier offer with a kind of special spin on it, which I’ll get to momentarily. The first tier of the offer, the cash tier, will have a tight deadline on it. I’m suggesting a deadline of ten business days, Albert.… Why so tight? I’ll tell you why. For one thing, we don’t want to give the enemy any time to organize any kind of poison-pill defense. For another thing, it’s important to act fast because right now the company is in a state of shambles. Since the old man died, nobody knows who’s running the store. The whole family is at each other’s throats. The widow wants to sell the store, the daughter doesn’t. The son got zip in the old man’s will, and he may decide to sue. If he sues, the whole shmeer gets tied up in litigation, we’ll be up to our ass in lawyers, and none of us is gonna get anywhere.… How do I know all this? Let’s just say I got my sources. So strike while the iron is hot, Albert. Strike while the iron is hot.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Okay. Now, if the shareholders don’t agree to accept the two-tier offer within ten business days, they lose their chance to get any cash at all. All they’ll get is cram-down paper, whatever junk your company’s got lying around. This will force family members, and any die-hard Tarkington loyalists, to sign agree-to-sell papers fast and will put pressure on other shareholders to do the same. The widow and the daughter are important. They’re not a majority, but we need to get them in our pocket.… Of course it’s legal. Would I propose anything to a man of your caliber that wasn’t legal, Albert? All I want to do for you is help you maintain your record as a winner.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Now here’s the beauty part. Once we announce that Continental is about to do a hostile on Tarkington’s, I’m counting on our competitive bidders to come in with higher bids and force the price up. Let’s say you play the game for a day or so—raise your bid a point or two. Now the ball’s in play, right? At this point the press will be having a heyday with the story, and all the shareholders will be rubbing their hands over how much money they’ll be getting. This is the point at which you’ll announce that you intend to drop out of the bidding, ’cause the price is just too high.… Now wait a minute, Albert, please let me finish. You haven’t heard the spin yet.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“At precisely this point in the scenario, I leak the store’s secret figures to the press—the overvalued inventory, the accounts receivable, the whole shmeer, making Tarkington’s look like a two-bit shlock house. Your competition will back out fast, withdraw their offers. That’s when you come back into the game with a much lower offer—let’s say thirty bucks a share as a ballpark figure. The shareholders kick and scream, but what can they do? You’ve got their signed agreements to sell. These agreements don’t mention any price. They don’t sell, we can sue them for breach of contract. They’re in a take-it-or-leave-it situation.… I tell you it’s legal, Albert. I have checked with my attorneys, and it’s perfectly legal. It’s just that it’s never been done quite this way before. Albert, you’re going to end up—you and me, that is—with America’s top fashion label for thirty, thirty-two bucks a share max. And we’ll have reamed them, Albert, baby—we’ll have reamed ’em all! That’s the spin I’ve put on this ball for you.…")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Ah, you mention my personal shareholding in Tarkington’s. I was just coming to that, Albert. I personally own only about twelve percent of the voting shares. But I am willing to sell you those shares at the price I mentioned earlier, sixty dollars a share.… Now, wait! Hold on, Albert. I know that’s a high figure, it’s an arbitrarily high figure, but there is a sound reason for that high figure. There’s a method to my madness, heh-heh-heh. You need to pay me that high a figure to establish your "), _c('i', [_vm._v("credibility")]), _vm._v(", Albert. Once it becomes publicly known that you have purchased my shares, got your toe in Tarkington’s door at sixty dollars per, this establishes the sincerity of your offer. In real estate parlance, this can be called your earnest money. It establishes the earnestness of your intent. The other shareholders will be led to believe that sixty is your genuine offering price, even though—heh, heh—it really isn’t going to be in the end. To establish your credibility at the outset of this deal is very important, Albert. We’ve got to make the others "), _c('i', [_vm._v("think")]), _vm._v(" that’s the price they’re going to get, too.…")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Yes.… Yes.… But of course. At that price, I’m going to make a very special deal for you, Albert. At that price, I’m willing to accept only "), _c('i', [_vm._v("fifty")]), _vm._v(" percent in cash, not eighty. We won’t publicize that little aspect of the deal, naturally. That little aspect will be strictly between you and I—"), _c('i', [_vm._v("entre vous")]), _vm._v(", as they say in French. The other fifty percent I’ll take in whatever cram-down paper you want to offer me, any junk you want to let me have to make up.… Now, Albert, I’m not implying that any of your notes or bonds are junk. I’d be proud to be the owner of any paper you want to pass along to me in the deal, just for the prestige of being associated with your good name. But, you see, throwing in fifty percent in paper reduces your cost per share considerably. And, when you stop to think that you’re gonna get the rest of the shares you need for between thirty and thirty-two—eighty percent cash—that drops your cost per share even more. It’s a beauty of a deal I’ve worked out for you, Albert, and as your financial adviser in this takeover, I must recommend that you accept it.… Yes, I realize you’ve got a board of directors to consult. You do that, Albert, and get back to me. I’ll be in the office all day long. Just remember, that time is of the essence if we’re gonna pull this deal off, and "), _c('i', [_vm._v("tempo fugit")]), _vm._v(", as the fella says, Albert, "), _c('i', [_vm._v("tempo fugit.”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He hangs up the phone and, with a look of distaste on his face, briefly studies a slip of paper on his desk. Then he picks up the phone again and dials an 800 number. “Yes,” he says to the young woman who answers the phone. “This is Mr. Harvey B. Knowlton calling, and I’d like to order an item from your current catalogue, please. The item number is fourteen-C.… Yes, that is correct, the four-piece matched set of hand-tooled alligator luggage. Forty-six hundred dollars.… No, it is not for me. It is to be sent as a gift to a friend.… His name? His name is Mr. LeRoy Goldfarb, three-two-three West Ninety-seventh Street, New York City.… No, no monogramming. Mr. Goldfarb does not like monograms.… Yes, let me give you my American Express credit card number. The last name is Knowlton, K-N-O-W-L-T-O-N, and the credit card number—”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The details completed, he hangs up and makes another call.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Goldie? Moe here. Look, Goldie, we got a set of alligator luggage coming from the Smith and Summers catalogue. Forty-six hundred retail. You oughta get at least fifteen hundred for it off your truck, and I’ll take my usual percentage.… Listen, Goldie, I’m planning to sorta phase myself outa this aspect of my business. Too busy with heavy-duty arbitrage. So maybe you better look around for someone else to scout up credit card numbers for you.… Whaddaya mean where do ya find ’em? Dumpsters. Garbage cans. Give ya a tip. I passed a line of dumpsters on Park between Seventieth and Seventy-first on my way to the office this morning. That’s where you find the johns with the high credit limits, in the higher rent districts.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Smyrna, his secretary, calls from the outer office. “Tommy Bonham on one, Moe,” she says.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Ah, Tommy,” he says, picking up the phone. “You’re up bright and early this morning, aren’t you? Thank you for calling me back, thank you very much indeed. Look, reason why I called is I need those figures from you right away, buddy. I’m particularly needful of your accounts receivable figure.… Why? Now, Tommy, we’ve been through all this before. I just need it, is all. Just say I need that figure if I’m gonna help you take over the store, never mind why.… Tommy, Tommy, I want to be your friend in this, so don’t give me a hard time, okay? And I don’t need to mention that other little matter we both know about, do I? It would be … unfortunate if that got out, wouldn’t it? Just give me that figure, and we’ll still be buddies. Remember, you owe me one, Tommy. You owe me a big one.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("There is a sign on Moe Minskoff’s office wall: "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EVERYTHING IS LEGAL IF YOU DON’T GET CAUGHT")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "indent2"
  }, [_vm._v("Tommy Bonham has called a meeting of the store’s full staff for nine o’clock that morning, but Miranda has arrived a little early, and she taps on the frame of his office door just as he is hanging up the telephone. He smiles and waves to her to come in.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I found three,” she says, and places a pale blue Tarkington’s shopping bag on his desk. “I’ve taken all three out on memorandum.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Three what?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Clutch bags. In silver.” She lifts one out of the bag. “This is my favorite. It’s seven ninety-five.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“What—?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“For your rich Texas broad. The Lone Star klepto. Didn’t you say she needed a bag for a party tonight?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He laughs. “You’re right. I’d forgotten all about it.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I’d have messengered these over to her, but I didn’t know her name.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I’ll have Linda take care of it.” He rises from his chair and takes her hand. “Thanks for remembering,” he says. “See why you and I are going to make good partners? Now let’s get into our meeting.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Some ninety-two employees of Silas Tarkington’s store have gathered in the store’s fifth-floor employees’ cafeteria this morning, an hour before the store is scheduled to reopen its doors for business. There are the merchandise managers, the buyers, the saleswomen and men. There is Paul, the comptroller; Celestine, the credit manager; Walter, the display director, and his two willowy assistants who dress the store’s windows. There are Molly and Odile, the two little dressing-room maids in their starched black-and-white uniforms; Oliver, the night watchman; James, the doorman; Sam, the tailor in charge of the alterations department, and his two seamstress assistants, Becky and Francine. All their faces look solemn, and some look apprehensive. As she and Tommy enter the room together, Miranda notices two conspicuous absentees. Pauline O’Malley is not there, having telephoned to say that she is still too devastated by the loss of her boss to appear in public. Also, Smitty is not there. Miranda whispers this fact to Tommy, who merely shrugs.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Miranda takes a seat, and Tommy moves to the front of the room and takes an informal pose, seating himself on the edge of a cafeteria table with one perfectly pressed dark trouser leg swung over the side.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Good friends,” he begins. “Good friends of mine, good friends of the store’s, good friends of Silas Tarkington’s: I don’t need to tell you that this is a sad occasion for all of us here today. The sudden death of our founder—Mr. Si, as most of us called him—last Saturday was a profound shock to all of us. Not only will he be deeply missed, he can probably never be replaced.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I would like to say at the outset that I asked you all to come in early this morning not because I see myself as his successor or replacement, and not because I am assuming the title of the new president of Tarkington’s. That will be up to the store’s board and stockholders to decide. On the other hand, I feel—and I am sure all of you would agree—that Mr. Si would have wanted us to carry on during the next few trying weeks, just as we did when he was off on one of his buying trips, just as though he were still here. Therefore, I would ask that there be no long, sad faces in Mr. Si’s store today. I would ask that our clients—who are also our friends and our guests—be treated with the same bright helpfulness, the same attention to service and detail, as always. Some of our clients may express condolences to you. I would suggest responding to this with a simple Thank you.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Now, since it may be several weeks until a new president is named, I’d like to address myself to some of the problems we may be facing in this period. You’ve all heard, I’m sure, the rumors that Tarkington’s has become the object of a hostile takeover. My friends, these are more than rumors. These are facts, and the company making the most aggressive moves right now appears to be Continental Stores, Incorporated, of Chicago. Two foreign companies have also made overtures. Now that Mr. Si is dead, these overtures will certainly become more aggressive. Naturally, whether such a takeover succeeds will depend on the votes of our stockholders. I can only say this: I have no quarrel with Continental Stores. They have a right to exist, just as we have a right to exist. But I think you’ll agree with me that if Tarkington’s were to become part of the so-called Continental Family of Stores it would become a very different sort of store from the one Si Tarkington created, the store we have known and loved. I, for one, would be very sorry to see that happen. A number of you in this room are stockholders. I should like to ask you that in the event of a proxy war you vote with me, against a takeover.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("There is a polite round of applause.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I would like to be able to tell you,” he continues, “that we are in a strong position to fight any such takeover. Unfortunately, this is not the case. I would also like to be able to tell you that Si Tarkington died leaving the store in a powerful financial position. Unfortunately, this is not the case either. As all of you know, the past eighteen months have been very difficult for all retailers. Retailers’ profits nationwide have fallen between thirty-five and forty percent. I wish I could say that Tarkington’s has stayed ahead of the pack. But, in fact, in the fiscal year ending last January thirty-first, gross income was down to five-point-five million, from eleven million dollars the year before. That’s a drop, ladies and gentlemen, of fifty percent.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Even so, with a gross like that, you might say our balance sheet ought to look good. It does, but it is also misleading. Retailers such as ourselves list, in our balance sheets, something called Accounts Receivable, and Accounts Receivable are listed in the assets column. Accounts Receivable simply represents merchandise that has been sold but not paid for. Thus, while our Accounts Receivable figure appears as a very large asset on our balance sheet, it represents no cash whatsoever. Mr. Si, of course, believed in a very liberal credit policy. He never pressured clients to pay their bills. I believe, in the future, the store is going to have to take a very long, hard look at that policy. Don’t you agree, Celestine?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Absolutely!” replies the credit manager tartly. “I have one client—I won’t mention her name, but a lot of us know who she is—who’s owed the store twenty-seven thousand dollars for the past two years. The other day she was in the store, and I posted an eight-thousand-dollar Geoffrey Beene to her account, and she still hasn’t paid a penny! It costs my department ten dollars a month just to send out a bill. I used to say to Mr. Si, ‘They’re taking advantage of you, these clients.’ Not all of them, but some.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“There are other areas in which I think we could be more cost-efficient,” he continues. “For instance, Mr. Si never believed in keeping an item of apparel in the store for longer than a season. This is sound policy. But before shipping a garment out to be resold—to Filene’s Basement, Value City, Loehmann’s, and the rest—Mr. Si insisted on removing the Tarkington’s label. Obviously, we could get much better prices for our merchandise if we sold it label-in. It would be a change in policy that most of our regular clients would never be aware of, and it would greatly increase cash flow.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Hear, hear!” several department heads say.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Of course, any changes a store like Tarkington’s makes should be made very slowly and carefully,” he says. “We still like to be known as expensive, and even a bit intimidating. That’s part of our glamorous image. For instance, Si never believed in having a sale. I could see his point. Shoppers tend to develop a sale mentality. They never set foot inside a store unless there’s some sort of sale going on. As a result, there’s hardly anything being sold in New York anymore at the full retail price. I’m not suggesting we go the Saks route, where there’s something on sale in the store every day of the year. But I might suggest, with fall and the Christmas season coming on, that we have one storewide post-Christmas sale once a year, the way, for instance, Harrod’s does.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Hear, hear!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He nods in Miranda’s direction. “I’d even be in favor of advertising that sale.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Hear, hear!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You know, and I do too, that other merchants in town call Tarkington’s an anachronism. I don’t want us to become an anachronism.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Hear, hear!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Miss Rubinstein, head of the Bridal Department, raises her hand.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Yes, Sarah?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Tommy, let me ask a question,” she says. “You were talking about storewide gross figures a minute ago. If the store’s profits are down fifty percent from a year ago, why are my department’s figures down "), _c('i', [_vm._v("sixty")]), _vm._v(" percent? And why are Diana Smith’s jewelry department figures "), _c('i', [_vm._v("up")]), _vm._v(" ten percent? We’re both selling luxury goods. By the way, where is Smitty?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“She was notified of this meeting,” he says. “You have a good point, Sarah, and it’s another problem we face. Demographics show that our clientele is growing older. Every time I see in the paper that a rich society woman has died, I kind of groan and think, There goes another of our customers!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("There is laughter at this.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“And not enough rock stars, women like Madonna, are coming along to take those women’s places.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("More laughter.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Rich older women still buy jewelry. But they’re out of the market for bridal apparel.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Still more laughter.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“But seriously, Sarah, you have an important point. I’ve often thought that Tarkington’s ought to have a department offering designer apparel for children, and also for teenagers, so that we could start educating women to be Tarkington’s shoppers while they’re young.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Hear, hear.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I’d like to end this meeting on one final, even more serious note,” he says. “If we’re going to have the capital necessary to fight a takeover attempt, our company is going to have to do some serious belt tightening. I’m going to propose something you won’t like, but I hope it will be only temporary—a ten-percent cut in base pay, of those at the executive level only.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("There is a collective groan.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“To offset this, I’d like to increase the commission percentage to salespeople who exceed certain goals. And I’d also like to allow sales staff members to sell merchandise from departments other than their own.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("There is silence, as the members of the sales staff do mental arithmetic to try to figure what such a move will do to their take-home pay.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You mean,” says one, “that I could take a customer from Small Leather Goods up to the fur department and sell her a mink?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Absolutely.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“That would work fine for "), _c('i', [_vm._v("you")]), _vm._v(", wouldn’t it?” says a saleswoman from the fur department. “It wouldn’t work so fine for me, the other way around.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“It would work fine for you, Eunice, if you could sell the client the mink first,” Tommy says, giving her his best smile. “Well, that’s all I have for you this morning. Except to say that I hope you’ll all bear with me during this difficult interim period, while we all may literally find ourselves fighting to save Tarkington’s. Thank you, and God bless you all.” He hops down from his perch on the tabletop.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("There is applause. Muted applause, but applause.")]), _vm._v(" "), _c('p', {
    staticClass: "indent2"
  }, [_vm._v("“Well, you may not be president of the store yet, Tomcat,” Miranda says to him when they are back in his office, “but you were certainly acting like one. That was a good meeting, and they liked nearly everything you said. Except salaries, of course. You wouldn’t have expected them to like that. Is the situation really that serious? With Continental?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He nods. “I’m afraid it is. Albert Martindale has already sent out feelers to me about acquiring my stock. Of course I told him it was not for sale. But I sense a big fight coming.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“And I guess Daddy was a bit of a fuddy-duddy. A bit behind the times. He didn’t prepare the store for this at all, did he?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Your father was your father. He did things his own way.” He picks up a slip of paper from his desk, reads it, and hands it to Miranda. “This explains why Smitty wasn’t here today,” he says.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Miranda reads the note headed "), _c('i', [_vm._v("From the desk of Diana Smith")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "blq-normal"
  }, [_vm._v("Dear Tommy:")]), _vm._v(" "), _c('p', {
    staticClass: "blq-indent1"
  }, [_vm._v("Mr. Jacob Kohlberg, who is the attorney for Si Tarkington’s estate, has informed me that I have been named in Si’s will as Special Curator of the Tarkington Collection of Art when it is turned over to the Metropolitan Museum. This is an exciting new career opportunity for me in the field of Fine Art, and one I accept eagerly.")]), _vm._v(" "), _c('p', {
    staticClass: "blq-indent2"
  }, [_vm._v("Since such a curatorship will be a full-time job for me, I am herewith submitting my resignation, effective immediately.")]), _vm._v(" "), _c('p', {
    staticClass: "right1-1"
  }, [_c('span', [_vm._v("Smitty")])]), _vm._v(" "), _c('p', {
    staticClass: "indent2"
  }, [_vm._v("“So that solves that problem,” he says. “You should be pleased.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I just hope she really has that new job,” Miranda says grimly. “The representative from the museum didn’t exactly do handstands when he learned that Smitty came along as a condition of the gift.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“But it means we have one less salary to pay,” he says with a little laugh. “Every little bit helps, I guess. What would you say if I gave Jewelry to Gertie Elson of Small Leather Goods? She seemed happy with my idea of interdepartmental selling, and the two departments are right next to each other on the floor. Gertie could buy for both.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Good idea. Or what about Sarah Rubinstein of Bridal? They sort of go together: brides, wedding rings. And she complained that her figures weren’t as good as Smitty’s.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He lowers his voice. “Frankly, I think Sarah’s problem is her merchandise. Her figures are weak because her merchandise is lousy. If it were up to me, I’d get rid of Sarah and find someone else with a younger point of view. Sarah’s bridal apparel looks like it was designed for weddings in the nineteen-fifties.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I haven’t been in the Bridal Shop recently,” she admits. “I’ll stop by there and have a look.” She sits in a chair opposite his desk. Unlike his house in Old Westbury, his office is meticulously tidy, his desktop clear, the quilted pillows on his sofa plumped invitingly. But perhaps this is his secretary’s doing. “Now tell me,” she says, “who are these stockholders, besides Mother and myself, who we’ll have to deal with if there’s a takeover attempt?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You and your mother each own about twenty percent of the voting shares,” he says. “I own roughly five percent. Moses Minskoff owns about twelve percent.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Moe Minskoff is a "), _c('i', [_vm._v("stockholder")]), _vm._v("?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Unfortunately, yes.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“How in the world did that happen?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“He advanced your father money over the years. Your father repaid him in Tarkington’s stock. Then there’s your father’s sister, Mrs. Belsky—”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“My father’s "), _c('i', [_vm._v("sister")]), _vm._v("? I never knew my father had a sister! You mean I’ve got an aunt I never knew about?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Yes, she’s your father’s younger sister, Simma Belsky. Mrs. Leopold Belsky. She lives in Florida. She owns another twelve percent.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Does my mother know about her?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He hesitates. “I’m sure she does,” he says.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“More dumb family secrets!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Apparently something occurred in your father’s family years ago, and there was a serious falling out between your father, his sister, and his mother. I don’t know what it was all about. Money, probably—these things usually are. But there’s been absolutely no communication since. Did you know that your father’s mother is still living?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I have a grandmother "), _c('i', [_vm._v("too")]), _vm._v("?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Yes, you do. She’s a very old lady now. She lives in a nursing home near Palm Beach, and I understand she’s completely senile. On Mother’s Day your father used to send her something now and then—not often—from the store. But they haven’t spoken to each other in years.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She looks at him wonderingly. “You’re telling me about relatives I never knew I had! Of course I know why nobody ever mentioned those women. They were family skeletons, weren’t they? That’s quite typical of my parents. Those two didn’t match the Tarkington’s image. They weren’t glossy enough. They weren’t Tarkington types. They reminded Daddy of his quote-unquote humble origins, so he swept them under the rug, turned them into non-persons. Right?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I really don’t know the whole story, Miranda. Your father never discussed it with me. All I know is their names from the company books as stockholders.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“My grandmother is a stockholder too?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“She doesn’t own as much as your father’s sister. She only owns about three percent of the company. She always has.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Wait a minute,” she says, as a thought suddenly flashes across her mind. “What does she look like, this grandmother? Is she short and fat with long white hair? Did she used to live on West End Avenue?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He spreads his hands. “I don’t know. I’ve never met her either.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Do you remember, years ago, one evening at the farm—” But she breaks off. “Never mind.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Anyway, those are the six major shareholders. The other shares, the remaining twenty-eight percent, are owned in small blocks by individuals. Some are employees. Your father often rewarded longtime employees with gifts of Tarkington’s stock in lieu of raises. He felt it made them feel as though they owned at least a little piece of the company they worked for. And there are other individuals who’ve bought up shares whenever they appeared for trading, over the counter. I can show you the complete list, if you like.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“What percentage of the twenty-eight percent is owned by our employees, do you know?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“About half. Actually a little less than half.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Will they be loyal to us? Will they help us fight a takeover?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Who knows? It will depend on what form Continental’s tender offer takes. Never underestimate the human capacity for greed. I’d hope they’d be loyal. That’s why I made that little spiel to them this morning.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“But,” she says, quickly counting on her fingers, “if you and Mother and I and even "), _c('i', [_vm._v("half")]), _vm._v(" the employees refused to sell their shares, that would give us a clear majority, wouldn’t it? Nobody could take us over!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“That’s right,” he says. “But your mother wants to sell.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She bites her lip. “Yes,” she says. “At least that’s what she’s saying now. But let me work on her. I wasn’t very nice to her at dinner last night, but let me try being nice to her again. Let me see if I can butter her up. I’ll work on her and you work on the employees—take them to lunch, tell them what a great job they’re doing, what a great store we’re going to make this into, and I’ll tackle Mother. How’s that for a division of labor?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He shakes his head. “I wish I thought it would work,” he says.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Why not? Why won’t it work? I’ll make it work.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Your mother’s a very determined lady,” he says. “And I think you underestimate the depth of her bitterness.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Bitterness?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Over your father’s relationship with Smitty.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“But Smitty wasn’t the first, and she wouldn’t have been the last. There were lots of others—others Mother knew about, and others she probably didn’t.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I think she knew about them all,” he says. “But Smitty was different. Your father was besotted with Smitty.” He fixes her with his deep blue eyes. “I can’t lie to you, Miranda,” he says. “I’ve got to tell you the truth. This isn’t going to be easy, but you’ve got to know.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Her dark eyes flash. “What is it?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“On the day he died, your father was planning to leave your mother and run away with Smitty.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She takes a quick intake of breath. “How do you know?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I found a letter. About a week before he died, your father had gone out to lunch, and I needed some figures he had. As I rummaged through the papers on his desk, I found a typewritten note. And—I’m not proud of this—I read it. It was from Smitty. It named the date and time when they planned to meet at the farm, where they planned to confront your mother, and then go off together to Bermuda. That date was the day he died. Strange coincidence, don’t you think?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Tommy, you don’t think—”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I don’t know what happened that day at the farm,” he says, “but something did. The whole thing was handled so strangely. First, your mother finds him floating in the pool—”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“No, Milliken found him. Then he called Mother.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Oh?” he says, raising his eyebrows. “Is that the story now? Well—”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“That’s what Milliken told me last night. And Mother doesn’t deny that that was the way it happened. She says she doesn’t remember.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Anyway, nobody called the police or an ambulance. Instead, Si’s old crony Harry Arnstein is called from twenty-five miles away in Manhattan. He pronounces death from natural causes—no tests, no autopsy—and your father is whisked off to the crematorium. All this before anyone else is notified—not me, not even you.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Tommy, you don’t think that Mother—”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Hell hath no fury like a woman scorned,” he says. “But I honestly don’t know what happened that day, Miranda, and now I suppose no one ever will. But I did think you ought to know about the letter, and the fact that on the day he died your father had other plans.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("His gaze at her is so burning and intense that she looks away from him. “I think,” she says carefully, “that I hate him now.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Don’t say that, Miranda. He was your father. Women were attracted to him, and he was susceptible.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("They sit in silence for a moment, and then he says, “In the meantime, have you given any thought to that proposition I made to you yesterday afternoon?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Of course I have,” she says. “I’ve been weighing the pros and cons of that kind of an arrangement. There are a few of both, it seems to me, and I haven’t reached any decision yet.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I want to give you something,” he says. “I took something out on memorandum myself this morning.” He reaches in his pocket, removes a small blue box, and hands it to her. “Open it,” he says.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She lifts the lid. “What a beautiful diamond!” she says. “But Tommy, you can’t give this to me!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Why not? Diamonds are a symbol of faith and trust. I want you to have this as a symbol of the faith and trust I have in you to run this store in full partnership with me.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“It’s beautiful, but—”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Three point nine carats. Extra River Gem quality. Fifty-eight facets. Thirty-three above the girdle, twenty-five below.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She looks at the ring with some misgivings.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Put it on,” he says. He picks up the ring and slips it on the ring finger of her right hand. “Wear it on your right hand, so nobody will think you’ve become engaged. Wear it as a symbol of the faith I have in you to become as great a merchandising force as your father was. Wear it to remind you how much I believe in you, Miranda, and of how much I believe in our partnership. Wear it while you make up your mind.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent2"
  }, [_vm._v("Back in her own small office, Miranda sits down hard in her chair and distractedly sorts through her morning mail, pushing pieces of paper this way and that, to no particular purpose, while the ring glitters on her finger. She should not have let him give it to her, and she starts to remove it and slip it in her purse when she smells the unmistakable scent of Equipage. She looks up and sees Smitty standing at her door.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Smitty’s face is pale. “I came by to collect some of my things,” she says. “My Rolodex, things from my desk. It took some courage to come up here to see you, Miranda, but I felt I had to. I know you’ve never liked me, but I wanted to tell you how sorry I am about your father. I loved your father, Miranda, and I thought I could make him happy. That’s really all I have to say, that I’m sorry, and to say goodbye, and I hope we can say goodbye like ladies.” She extends her hand, and Miranda extends her own.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Goodbye, Smitty.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Suddenly Smitty screams, "), _c('i', [_vm._v("“Where did you get that?")]), _vm._v(" That ring is from my department! That’s my merchandise! Give it to me!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Miranda withdraws her hand. “Since you no longer work here, Smitty,” she says, “I don’t see how you can talk about "), _c('i', [_vm._v("your")]), _vm._v(" department and "), _c('i', [_vm._v("your")]), _vm._v(" merchandise.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Give it to me! It’s mine!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“It should take you about fifteen seconds to get from here to the elevator,” Miranda says. “I’ll give you ten.”")])])])
}]}

/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(110),
  /* template */
  __webpack_require__(111),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 110 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 111 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "chap-title"
  }, [_c('span', [_c('i', [_vm._v("9")])])]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_vm._v("On Friday afternoons—at least when he was in town—Miranda’s father would pick her up outside the entrance to the Brearley School in his car and they would drive together out to Old Westbury for the weekend. Oh, those were the best times.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Miranda loved those Friday rendezvous. They seemed to her displays of pure theater. The Rolls-Royce Corniche would stop grandly at the curb on East 83rd Street, and the chauffeur, in his snappy uniform—gray doeskin breeches, patent leather knee-high boots, tight jacket with silver buttons, and shiny cap—would hop smartly from the car, cross from the front, tip his cap smartly to Miranda, and hold the rear door open for her as she stepped into the back seat, with its mink lap robe, and took her seat beside her famous father. Then she would wave a gay goodbye to her schoolmates as they waited for their buses, the car door would close, and they would glide away. Other girls her age might have been embarrassed by such shows of raw privilege, but not Miranda Tarkington. In those days, she enjoyed being something of a show-off.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("What I was was a little snot, she thinks now.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("On that particular Friday—she is not sure of the year, but she must have been about twelve—the little princess in her Brearley uniform had been helped into her royal coach by her royal coachman and had waved a royal farewell to her less fortunate countrywomen, and the car had headed toward the Triborough Bridge. The day was special. The weather was brilliant. The East River sparkled like diamonds in the sunlight. Often, her mother joined them for this drive to the country for the weekend, but this week she had left for Old Westbury the day before, and today Miranda had her father all to herself. But even more important matters accounted for Miranda’s buoyant mood. Tonight, Tommy Bonham was coming to the farm for dinner, and Miranda was to be seated with the grown-ups. Since her mother and father sat at opposite ends of the table, this meant Miranda would be seated facing Tommy, where she could feast her eyes on him, and where he could feast his eyes on her. The dress she planned to wear was cut off-the-shoulder.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Meanwhile, a friend at school had introduced her to a paperback romance series called Lovedrenched. All the novels in the Lovedrenched series were about seduction, and Miranda had been wondering whether it would be possible to seduce a man twenty years her senior. Would her mother notice if she padded her bra with Kleenex for a little extra fullness in the bosom? The royal princess’s loins throbbed with quite plebian lust.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Her father was deep in the pages of "), _c('i', [_vm._v("Women’s Wear Daily")]), _vm._v(", and Miranda was deep in seductive fantasies, when her father had suddenly put down his newspaper and said, “Wait. I’ve forgotten something.” He leaned forward and gave the driver an address on West End Avenue. So the chauffeur turned west and headed across town through Central Park. “Just a quick errand,” her father said. “A small package to drop off.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("When they arrived at the address on West End Avenue, between 112th and 113th Streets, if Miranda remembers correctly, it turned out to be a drab brownstone sandwiched between two massive apartment buildings. Perhaps half a dozen doorbells were arrayed beside the front door. “I’ll only be a minute,” her father said, and got out of the car, his briefcase in his hand, and rang one of the bells.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The woman’s apartment must have been on the ground floor, because Miranda saw her come to the door—a little fat old lady with flowing white hair, wearing glasses and a dirty apron. She seemed pleased to see him, let him in, and he was gone for several minutes. Then he came out again, got back in the car, and the driver headed back toward the Triborough Bridge.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Miranda was mystified. “Who was that?” she asked him at last.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Who?” He seemed preoccupied.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“The fat lady. The woman whose house you just went into.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“She’s just one of our clients. You know I sometimes have to make deliveries in person.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Miranda giggled. “She certainly didn’t "), _c('i', [_vm._v("look")]), _vm._v(" like a Tarkington’s client, Daddy,” she said. “A fat old lady in a dirty apron.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“The woman you saw was my client’s maid,” he said.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She giggled again. “She didn’t even look like a Tarkington’s client’s "), _c('i', [_vm._v("maid,”")]), _vm._v(" she said.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Well, that’s who she was,” he said with a tone of finality.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“What was it you were delivering?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“It was a—a gold bracelet. My client wants to wear it to a party tonight.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Miranda was determined to get to the bottom of this mystery. She was positive he was holding something back from her.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I didn’t know Tarkington’s clients lived in places like that,” she said. “A crumby old brownstone with dirty windows and torn window shades, a brownstone that’s been cut up into at least six itty-bitty apartments.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He looked at her. “My, aren’t you the observant one,” he said at last. “Don’t you know that curiosity killed the cat?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Come on, Daddy. Tell me who she really is,” she said.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He leaned forward and rolled up the window that divided the passenger seats from the driver’s seat. “Well, if you must know,” he said quietly, “she’s someone I take care of.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“What do you mean, take care of?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Ssh! I just realized it’s the first of the month. Her rent’s due.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You mean you pay her "), _c('i', [_vm._v("rent")]), _vm._v("?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He nodded. “Please, Miranda, not so loud.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“But why?” she whispered.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“She’s a very poor woman. She’s penniless. If it weren’t for me, she’d be a homeless person.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“What’s her name?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I have no idea.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You mean you pay the rent for some old woman you don’t even "), _c('i', [_vm._v("know")]), _vm._v("?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He nodded again.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“But "), _c('i', [_vm._v("why")]), _vm._v("?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I found her begging in the streets, Miranda. Several years ago. There was something about her face. She seemed so pitiful. I gave her some money, and she said, ‘God bless you,’ and my heart just went out to her. I asked her where she lived, and she said, ‘Nowhere,’ and I felt terribly sorry for her. It didn’t seem right for people like us to have so much, and for decent people like her to have so little. She has no one—no family, nothing. I decided to find an apartment for her. It’s just a little place, as you can see, but it’s clean, and in a safe neighborhood, and she’s able to take care of herself. I pay her rent and give her a little extra.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Why, Daddy, what a super thing to do!” It was in the days when Miranda and her classmates were always using words like “super.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“At least she’s safe and off the streets.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Later, when they were across the bridge and on the Long Island Expressway heading east, she said to him, “Does she know who "), _c('i', [_vm._v("you")]), _vm._v(" are, Daddy?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Of course not,” he said.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Really?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Did you ever hear of Maimonides, Miranda?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She shook her head.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Maimonides was a great philosopher in the twelfth century. He wrote about ‘the golden ladder of charity.’ The highest rung on that golden ladder, he wrote, is when you give to someone whom you do not know, and when that person does not know who the donor is.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Does Mother know you’re doing this?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He seemed to hesitate. Then he said, “Yes.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She reached out and squeezed his arm. “She must be very proud of you,” she said. “I know "), _c('i', [_vm._v("I")]), _vm._v(" am. I think this is just the nicest, kindest, most super thing you’re doing, Daddy. It really is.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Well, one tries to do what one can to help the less fortunate in this world,” he said, with a little sigh. “Now, are you quite satisfied, Miranda?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Oh, yes!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He leaned forward and rolled down the window that separated them from Billings, the driver. “Think we’ll have rain this weekend, Billings?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“No, sir!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent2"
  }, [_vm._v("Now, sitting alone in her office, unable to take her eyes for long from the diamond ring Tommy placed on her finger and thinking of the things he said to her, and of all the events and revelations of the past few days, she wonders: Could the little fat old lady on West End Avenue actually have been his mother, her own paternal grandmother—a grandmother whose very existence she has been denied? A grandmother! Just think of it! There, all along, had been a dear little grandmother whom she could have taken Easter baskets to, who could have joined the family for Sunday dinners and at Christmastime; she had been right there, all through her childhood, just a few city blocks away. She had always been told that her father was an orphan. She had been robbed of a whole segment of her family history.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("But did that explain the curious scene that took place later that same evening, after dinner at the farm? Not only had Miranda been seated at the grown-ups’ table but her mother had allowed her to be served wine, and after dinner they had all withdrawn to the sun room for coffee. Miranda’s mother had picked up her needlepoint, and the two men were discussing, of all things, zippers. A manufacturer’s rep had shown Tommy some new zippers from France that were so skinny and narrow they were almost invisible, and Tommy was proposing that these new French zippers be introduced in the Custom Salon.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("There was a lull in the conversation, and Miranda said, “Daddy, tell Uncle Tommy about the little fat lady on West End Avenue.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Her mother dropped her needlepoint. “I think not,” she said sharply.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Oh, but it’s a super story, Daddy,” she persisted. “Tell it.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Miranda,” her mother said warningly, “I said I think not.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Tell him about Maimonides and the golden—”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Miranda, what did I just tell you? Your Uncle Tommy would be bored to tears.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Miranda looked imploringly at her father, who was looking uncomfortable. “Perhaps not,” he muttered. “Perhaps not tonight.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“But—”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Actually, I’d like to hear the story,” Tommy said pleasantly.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“No!” her mother said. “Miranda, it’s past your bedtime. Run along to bed.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Red-faced, humiliated, Miranda rose to her feet. “But Mother—”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Her mother clapped her hands. “Off to bed! Say good night to our guest and then off to bed with you, young lady.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("As she left the room, she heard her mother say brightly, “What has the store decided to do about designer jeans?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Alone in her bedroom but far from asleep, Miranda had been furious at her mother. She had been seated at the grown-ups’ table, she had been served wine, she had tried to keep up her end of the conversation, and then, at half-past nine, which was "), _c('i', [_vm._v("not")]), _vm._v(" her bedtime—and in front of Tommy Bonham, the man with whom she had decided she was passionately in love—she had been ordered to bed like a little child. She lay there, fully dressed, on top of her bedspread in the dark room, wanting to cry but comforting herself by plotting some sort of hideous and elaborate revenge against her mother. She would put itching powder in her sleep mask. She would put a whoopee cushion under the seat of her chair the next time she had a dinner party. She would poison the fish in the lake in her mother’s Dell Garden. She would …")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Later, she heard Tommy Bonham’s car drive away, and the light from his headlamps arced across her ceiling. Now she heard her mother and father exchanging loud words from the floor below, and she crept out of her bedroom and tiptoed to the head of the stairs to hear what they were saying. Her mother seemed to be pursuing him from room to room, and their angry voices rose and fell as they went.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Goddammit, Connie, it’s the first of the month! You know how she gets when I’m late!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Why did you have to take Miranda along? What kind of cock-and-bull story did you tell her anyway?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Goddammit, Connie!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Why do you have to include my daughter in your dirty little secrets? Isn’t it bad enough that I got dragged into it? Isn’t that bad enough? ‘To protect you,’ Tommy said. How can I protect you when you won’t even protect yourself? And now you’ve dragged my daughter into it too!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“She’s my daughter too, goddammit!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“A lot you care! I’ve tried to protect her from you. Now you’ve dragged her into it!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“She doesn’t know a goddamned thing!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“What if she finds out? What if she starts asking questions? What am I supposed to say? Answer me that one, Si? Or shall I call you Sol?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Shut up, Connie!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Why couldn’t you have had Billings deliver the money? Why did you have to drag Miranda along?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“And get Billings involved in it too?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Billings is "), _c('i', [_vm._v("already")]), _vm._v(" involved! He drove you there, didn’t he?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I told him I was delivering merchandise to a client.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Why couldn’t you have sent a messenger from the store? Why couldn’t you have just dropped a check in the mail? I’ll never understand—”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Because those are her terms, goddammit! "), _c('i', [_vm._v("Those are her terms!")]), _vm._v(" The money is to be delivered "), _c('i', [_vm._v("in cash")]), _vm._v(". By me. "), _c('i', [_vm._v("In person")]), _vm._v(". No messengers. No banks. I’ve told you all this a thousand times before. She set the terms. She calls the shots, whether you like it or not.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“But there’s nothing in the terms about dragging Miranda along!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I didn’t drag her along! She waited in the goddamn car!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“But she saw her! She knows about her! She suspects something, doesn’t she?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“She doesn’t suspect a goddamn thing! Now shut up, Connie.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Don’t tell me to shut up! I’m sick to death of trying to protect this family from your sordid, messy little secrets!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Who pays the bills for this family?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“And who’s seen to it that this family’s name hasn’t been dragged through the mud? I’m sick to death of covering up for you. I’m sick to death of covering up your filthy tracks, sweeping up your filthy messes!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“When have you ever covered up for me?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('i', [_vm._v("“When?")]), _vm._v(" I’m talking about June nineteen-seventy. "), _c('i', [_vm._v("Where?")]), _vm._v(" I’m talking about Boston and the Ritz-Carlton Hotel!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Moe Minskoff worked that one out for me, damn it! You had nothing to do with it!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“But I got dragged into it anyway, didn’t I? By you—and Moe—and Tommy! I’ve been covering up for you for the past nine years! Do you think that’s been fun for me? But I did it—and I did it for you! And this is the kind of thanks I get. If it hadn’t been for me and Tommy—”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“And Moe! Don’t forget Moe!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“—you could have gone to jail! If it hadn’t been for me, you could still be in jail!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Goddammit, Connie! Leave me alone!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“And why did I do it? I did it for you.…”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Their voices faded as they moved into another room, and Miranda crept back into her bedroom.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The next day Miranda asked her mother, “Who is the fat old lady on West End Avenue?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I don’t know what you’re talking about, Miranda.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You sent me to bed early when I asked Daddy to tell about her.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You were boring Mr. Bonham, dear.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I was not! What’s more boring than talking about zippers?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Please, Miranda,” her mother said, passing her hand across her forehead, “I don’t want to talk about this anymore. I have a terrible sick headache, and I’m going up to take my nap.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("And that was all Miranda ever knew.")]), _vm._v(" "), _c('p', {
    staticClass: "indent2"
  }, [_vm._v("In the northwest corner of Flying Horse Farm, Miranda’s mother had created what she called her Dell Garden. A natural hollow in the land provided the setting and suggested the name, and Consuelo had a deep artificial lake built at the center of the hollow, where it was fed by a nearby spring. In this lake swam many brightly colored carp and calicoes and koi fish, some of them quite rare and valuable. Along the shallower edges of the lake bloomed aquatic plants, lilies and water irises and water hyacinths, but the center of her lake she wanted at least twenty-five feet deep, so the fish could find plenty of room to survive, in semihibernation, under the winter ice. Also, she had been told that the deeper the lake the purer would be its reflective powers with sunlight and clouds and stars. Over the years, the fish had thrived, multiplied, and grown to considerable size.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Connie Tarkington had designed her garden without any formal training in landscape design. She had arranged her plantings by hunch. Along the banks of the lake she had planted low stands of dogwood, crab apples, oak-leaf hydrangeas, azaleas, willows, and golden bamboo that rustled in the breeze. Along the rim of the hollow she had wanted deeper greens, and so this was planted with ilex, boxwood, and Norway spruce. In early spring, the slopes of the garden exploded with swaths of yellow daffodils and blue grape hyacinths. Later came tulips, iris, tall lupines, and delphiniums. In summer there were bright patches of hollyhocks and daylilies, and in fall the Dell Garden was still bright with with asters, chrysanthemums, and the reddening leaves of the dogwoods.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Across the lake ran an arched wooden footbridge, in the Japanese moon-gate style. Along the bridge, spaced at intervals, were redwood benches, where the visitor could sit and look down at the reflection of clouds in the dark water and at the playful herding and leaping of the bright fish. It was on this footbridge that Richard Avedon posed Consuelo Tarkington, in a series of romantic outfits, for that famous fashion shoot in "), _c('i', [_vm._v("Harper’s Bazaar")]), _vm._v(" in the spring of 1980, the year she climbed to the top of the International Best-Dressed List.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In the summer of that same year, Miranda and her half brother were seated on one of the benches on the garden footbridge. He was seventeen then, and a freshman at Yale, and she was thirteen, in her first year at Ethel Walker. Over the past year, her passion for Tommy Bonham had faded, and now she was in love with Blazer, though he didn’t know it. Blazer wore his hair long in those days, in a shaggy ponytail pulled back with a rubber band, a style chosen—she is certain today—only because it was designed to infuriate his father. Their final blowup had not occurred, and Blazer still came down from Connecticut to visit his father at the farm on certain weekends, and this was one of them. Miranda and Blazer were feeding the fish.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("One particularly obnoxious blue-and-yellow koi was hogging all the food pellets, and Miranda and Blazer were trying to aim their pellets so the swarms of smaller fish would get their share, but the big koi was too fast for them, and when he opened his huge mouth he could engorge dozens of pellets at a time.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Tell me about your mother,” Miranda asked him. “What’s she like?” She had always been curious about Alice Tarkington, whose name was taboo in Miranda’s household.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Like? Well, let’s see,” he said. “To begin with, she’s ten years older than your mother and a little heavier.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She laughed. “You mean she’s fat?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“No, not fat. But she’s not as skinny as your mother. Your mother is too damned skinny, if you ask me.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“She has to be a model size to wear the clothes she likes.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Yeah, I know.” With a strong overhand, he pitched a handful of pellets far out into the water. “There!” he said. “There’s some that that overweight bastard won’t get.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“What else about her?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Well, she’s nice-looking. At least I think she’s nice-looking. She’s not a blonde, like your mother. She’s got red hair.” He grinned. “And a temper to go with it. Hell, I guess she’d have gray hair if she let it go natural. She, you know, dyes it.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“And?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“And, let’s see. She’s very athletic, my mother. She plays lots of tennis and golf. I guess you’d call her a very outdoorsy woman. She loves the out-of-doors.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“My mother loves to garden.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Ha! Your mother doesn’t "), _c('i', [_vm._v("garden")]), _vm._v(", Mandy. She just stands out here with her parasol and points out places to gardeners where she wants them to plant her trees.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“My mother thinks the sun can be very damaging to a woman’s skin.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Well, my mother doesn’t subscribe to that philosophy. She likes a year-round tan. In the summer she’s always out-of-doors. In the winter she goes to a tanning salon. At least she used to.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“In other words, she’s just the opposite of my mother.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Yeah, I guess you could more or less say that.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I wonder if I’ll ever meet her? I’d like to.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Well, don’t take this the wrong way, Mandy, but I don’t think you ever will. She doesn’t want to meet you. She’s very bitter.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She had tried not to feel hurt by this. “Bitter?” she said.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Yeah, she’s bitter, all right. She’s about the bitterest woman I’ve ever known. After all, the old man asked your mother to marry him even before he asked my mother for a divorce. Wouldn’t you be bitter? I’ll tell you how bitter she is. If I come out here for the weekend, she won’t even ask me how it went. She won’t ask me what I did or anything, and she won’t listen when I try to tell her. I’ve learned not even to mention Flying Horse Farm to her, or anything about Dad’s new family. When "), _c('i', [_vm._v("Architectural Digest")]), _vm._v(" published all those pictures of the farm, including this garden, she refused to look at the magazine. Needless to say, she won’t set foot inside the store. She won’t even walk on that side of Fifth Avenue when she’s in that part of town. If she happens to be walking across the street from the store, she won’t even look in the store’s direction. That’s how bitter she is.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“That’s sad,” Miranda said.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Yeah, I guess so. But it was a pretty bitter divorce.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Do you remember any of it?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Nah, I was too little. But that’s another thing she’s bitter about. She felt the old man abandoned her and her two-year-old kid.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She sighed. “What a strange family we are,” she said. They had run out of fish-food pellets.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Yeah. Strange. Sad. And add a couple of more S-words: shallowness, superficiality, and secrets. That’s what this family is all about, Mandy. I could add another word beginning with an S, but I couldn’t use it in front of a well-brung-up young lady.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Shallowness, superficiality—?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“What’s Tarkington’s all about, anyway? Putting a lot of shallow, superficial dresses on the backs of a bunch of shallow, superficial women, trying to turn them into something they’re not, telling some rich old broad she looks divine in a dress that makes her look like an Eighth Avenue hooker—an "), _c('i', [_vm._v("expensive")]), _vm._v(" Eighth Avenue hooker, but an Eighth Avenue hooker just the same.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Daddy says running a store like ours is like putting on a piece of theater.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Yeah, right, and what’s a piece of theater? Pretense. Make-believe. Lies. Phoniness. You don’t think a piece of theater is anything like "), _c('i', [_vm._v("life")]), _vm._v(", do you? And Tarkington’s isn’t even good theater, if you ask me. It’s more like Hollywood, like an old Joan Crawford movie. Its more like television, that tells you if you’ll just buy a Cadillac your neighbors will think you’re John D. Rockefeller. Or if you’ll try our deodorant you can have a date with Robert Redford. I’ll tell you what the store is "), _c('i', [_vm._v("really")]), _vm._v(" like. It’s like Chicago. Ever been to Chicago?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Uh-uh.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Chicago is the phoniest city in the world. All along the lakefront are these big mansions and apartment buildings with doormen in fancy uniforms. But walk two blocks inland from the lake and you’re in Scuzbagsville—cheap bars, flophouses, and porno shops. Chicago is all facade. Behind the facade, Tarkington’s is just a tarted-up version of the "), _c('i', [_vm._v("shmattes")]), _vm._v(" business.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Shmattes?” She giggled again. “Another S-word. What does shmattes mean?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Rags. Junk. Trash. That’s what all the family lies and secrets are designed to protect: the fact that the old man’s in the rag business. Secrets on top of secrets, lies on top of lies. Nobody even knows the old man’s age, for Chrissake. No, we gotta keep the old man’s age a secret to protect the image.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“He says age is a boring, unimportant statistic.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Sure—so nobody will know how old he is. Or where he was born, or who his parents were. That might hurt the old image, right? Image! It’s all done for image, for illusion. It’s all done with mirrors, so step right up, folks, and see the little lady sawed in half onstage. That’s about how real he is. Everything "), _c('i', [_vm._v("about")]), _vm._v(" the old man is phony, Miranda. Silas Tarkington isn’t even his real name. He was Solomon Tarcher before he changed it. My mom told me that.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She remembered her mother’s words: "), _c('i', [_vm._v("Or shall I call you Sol?")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“And look at the phonies he surrounds himself with—men like Tommy Bonham.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Is he a phony?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“The only thing he likes about Bonham is that he "), _c('i', [_vm._v("looks")]), _vm._v(" good. More facade. Bonham looks good, so he’s good at buttering up the ladies.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Blazer,” she asked him, “is my mother a phony too?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He hesitated. “I’ve got no quarrel with your mom,” he said. “I like her, actually. But she’s his shill, his beard, his showpiece, his flagship customer. She’s "), _c('i', [_vm._v("the")]), _vm._v(" Tarkington’s woman. But I’ll say this for her, she doesn’t seem to mind letting herself be used like that, to display the merchandise. That was one reason—one of the main reasons—why the old man divorced my mom and married yours. After I was born, Mom got a little heavy. She didn’t look good in designer dresses anymore. So the old man traded in a size twelve for a size eight, and got a ten-years’-newer model in the bargain. I once heard your mom say that when she was pregnant with you she only gained eight ounces. Can you imagine that? Eight ounces! No wonder you were such a shrimpy little thing when you were born.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She laughed. “Shrimpy? Was I?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I remember when they first showed you to me in your whatchamacallit—bassinet. You were only "), _c('i', [_vm._v("yea big.”")]), _vm._v(" He stretched out his hand. “I could have held you in the palm of one hand. You were even shrimpy-colored. Pink.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She was enjoying this immensely. “Tell me what else you remember,” she said.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I guess you don’t remember the old man before he had his face lifted, do you?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She looked at him, amazed. “I didn’t know he’d had his face lifted!” she said.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Oh, yeah. It must have been around nineteen-seventy. It changed his looks completely. My mom thought it was a big joke. ‘Now that he’s bought himself a new young wife, he’s bought himself a new young face to go with her,’ she said. More phoniness.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You think that? That he "), _c('i', [_vm._v("bought")]), _vm._v(" her?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“That was my mom talking. Remember, she was very bitter.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“It made him look younger, I suppose.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Not just that. It made him look completely different. He used to have a small mustache. After the facelift, that went. His nose was smaller. His eyes were bigger. He used to have dark hair. After the facelift, he decided that silver hair looked better with the new young face. For contrast, you see. New young face but older hair. But silver with a blond rinse thrown in so the hair didn’t look "), _c('i', [_vm._v("too")]), _vm._v(" old. Facade again. When I first saw him after the facelift, I didn’t even recognize him. That’s how much it changed him. The only thing it couldn’t change was his voice. It wasn’t until he spoke to me that I knew who he was!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("They sat in silence for a moment or two. “Secrets,” she said. “There’s a little fat old lady who lives on West End Avenue.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Huh?” he said. “Who dat?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She told him then of the odd experience the year before, and of its even odder aftermath.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He shrugged. “Probably one of the old man’s old girlfriends that he’s paying off,” he said.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You mean, blackmail?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Just a guess. But you won’t get him to tell you who she is.” He wagged his finger at her. “That’s a secret, Mandy! That’s for him to know and you to find out. To hell with it. It’s just more lies, more phoniness. Who gives a damn? Let him have his secrets.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("There was another little silence, and then she said, “What are you going to do after you graduate from Yale?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Do? Probably nothing.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“But you can’t just do nothing.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Why not? That was one thing my mother got out of him. A nice little trust fund that’ll be mine when I’m twenty-one.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“But still, you can’t just do nothing, Blazer.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Well, I’m sure as hell not going to work for his phony store,” he said. “I’m not going into the shmattes business, that’s for sure.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I think he’d like it if you did.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Well, I’m not. And what about you? What are you going to do when you grow up?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I "), _c('i', [_vm._v("am")]), _vm._v(" grown up!” she said. “But I’ll tell you what I’m going to do when I’m even "), _c('i', [_vm._v("more")]), _vm._v(" grown up! I’m going to be the queen of the circus and marry the man on the flying trapeze. I’m going to be Miranda, the daughter of Prospero, the Grand Duke of Milan! That’s who I’m named after, you know—Miranda in "), _c('i', [_vm._v("The Tempest")]), _vm._v(". I’m going to create a tempest of my own, and not in a teapot! I’m going to be a star! ‘Here she comes,’ they’re going to say. ‘There she goes!’ I don’t know how I’m going to do it yet, but I’m going to do it, wait and see. I may go to work at Tarkington’s, but if I do I’m going to end up running the store—you wait and see!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Just watch out for the phonies,” he said.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("There was another, longer silence. Then she said, “Blazer, is everything phony for you? Do you think I’m a phony too?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He grinned. “Of course not. You’re not a phony. You’re too young to be a phony. You’re just a kid. Phoniness happens later.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I’m not a kid! I’m a young woman, in case you haven’t noticed.” She hesitated. “But, sometimes—sometimes I feel so strange.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Strange? How strange?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Like right now. I feel strange. Not knowing if I’ll ever be able to do all the things I want to do.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Hey,” he said. “Just a minute ago you were the daughter of Prospero, the Duke of Milan! The world at your feet.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I know,” she said, and her tone was wistful.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Hey,” he said again. “I bet I know what you need. You need a neck and shoulder rub. My mom says I give great neck and shoulder rubs, and she always feels better afterward. Want me to give you one of my famous rubs?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“All right,” she said.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Turn around.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She turned her back to him, and he began to massage her neck and shoulder muscles with his long, strong fingers.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Let me tell you your future,” he said. “You shall have towers. Towers and minarets and spires and palace gates, forests, shores, and islands, gems and pearls and scepters and all the emperor’s diamonds, and everything brilliant in King Oberon’s bright diadem. For you, I foresee temples and mosques and fountains, fountains and waterfalls and tapestries and flowers and little thornless roses, rings on your fingers and bells on your toes—”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Blazer,” she interrupted him, “have you ever been in love?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Oh, yes,” he said easily.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“What’s it feel like?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Not much fun. Kind of like an ache in the pit of your gut.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I think I’m in love,” she said.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Tell me about this guy,” he said, still kneading her shoulders and the back of her neck.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Well, for one thing, he’s older than me.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Hmm,” he said, rubbing her back more slowly. “What else?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“He’s tall. And he’s dark. And handsome.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“What else?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“He’s—” But she couldn’t bring herself to finish the sentence.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He withdrew his hands. “Back rub’s over,” he said. “Feel better now?” He stood up and stretched. With his arms above his head, he appeared to be nine feet tall. She thought he had a beautiful body. “Well, I don’t much like the sound of this guy,” he said. “I think something better will come along. If you ask me, you’re just in love with the "), _c('i', [_vm._v("idea")]), _vm._v(" of being in love. I think I’ll go for a swim. Care to join me?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Okay,” she said, and she also rose.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He reached for the old duckbill cap he often wore, and put it on his head with the bill in the back, the way he liked to wear it, and she followed him across the footbridge.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Blazer,” she began.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Yeah?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I don’t know how to say this, but I like you—very much.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Yeah, you’re a good kid, Mandy,” he said, and she felt as though her heart were breaking. There were tears in her eyes, but since she was walking behind him he could not see them.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("When they got to the pool, their father was swimming his laps, up and down, and Blackamoor, his Labrador, who was just a big puppy then, was swimming beside him, while the television set, placed on the pool’s flagstone coping, broadcast the news.")]), _vm._v(" "), _c('p', {
    staticClass: "indent2"
  }, [_vm._v("Now, in her office at the store, Miranda is thinking of Blazer, who in the end did not even get his trust fund and now has been disinherited in his father’s will “for reasons he will understand.” Poor Blazer. Will he ever forgive his father? On an impulse—not that she has anything in particular to say to him except hello and to ask how he’s doing—she picks up her phone and dials his number. After several rings, she hears, “You’ve reached the number of Blazer T. You got my machine, but you ain’t got me. I’m either out or I’m fast asleep. So leave your name when you hear the beep. You may want to leave a message too. If you just hang up, well, then, fuck you!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Blazer,” she says. “It’s me, Miranda. I’m at the office. Please give me a call when you get a chance.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent2"
  }, [_vm._v("Not many blocks away, Moses Minskoff is also on the telephone. “Listen, Albert,” he is saying, “this Bonham character seems like he’s dragging his heels a little.… Sure we need him, so I’m suggesting you sweeten the deal. Offer him an employment contract. Offer him three hundred big ones for the next five years. Hell, with that kind of a deal, he won’t even have to come into the office.… What’s that add up to for you? Just a mil and a half over five years, and that’s peanuts, Albert, compared to what you’re going to walk off with. Peanuts. Shall I relay that offer to him? … No, to hell with the girl. She’ll do what her old lady tells her.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent1"
  }, [_vm._v("In the end, it had not been a ponytail that precipitated the final break with his father. It had been a T-shirt. Or perhaps you could say it was a bikini.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The ponytail disappeared at Yale when Blazer Tarkington took up diving. “A diver looks dumb bouncing on a diving board with a ponytail flopping up and down behind him,” his coach had told him. “Also, it can affect your scores. No matter how clean an entry you make into the water, a judge will knock off two points if the entry’s attached to a lot of hair.” So the ponytail had been sheared off. Begrudgingly.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Several years earlier, Blazer’s father had realized that something was happening to the city of New York—and to the world at large—when he had seen a young woman skating down Fifth Avenue, the city’s most fashionable thoroughfare, on roller skates, wearing a Walkman shoulder pack, earphones, and a bikini. Silas Tarkington had returned to his office and immediately called a meeting of his staff and announced that, no matter how far the standards of the world might have fallen, the store must never lower its own rigid standards.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He had often lectured on the value of what he called “the intimidation factor” to a store like Tarkington’s. Human beings actually enjoyed being a little bit intimidated, a little frightened, a little apprehensive, he argued. Fear was a positive, exciting emotion. Fear stirred the adrenal glands. How else did one account for the popularity of horror novels and horror movies? Some retail establishments had lost their power to intimidate. A prime example of this was Tiffany & Company. Years ago, Tiffany’s had been an intimidating store to shop in. But then had come "), _c('i', [_vm._v("Breakfast at Tiffany’s")]), _vm._v(", the popular novel and film, and now Tiffany’s was nothing more than a Manhattan tourist attraction where crowds came to browse and admire the merchandise but not to buy. Cartier’s, by contrast, had maintained its ability to daunt the shopper, and probably the most intimidating Manhattan merchant of all was Harry Winston. No one passed through Winston’s grand and fearsomely gilded gates unless he or she had a serious jewelry purchase in mind. The girl in the bikini on roller blades would never have dared to enter Winston’s. On the intimidation scale, Silas Tarkington saw his store as somewhere between Cartier and Winston.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Silas often compared his store with the Ritz Hotel in Paris, a hostelry that was always deliriously intimidating. The Ritz was a small hotel, with less than a hundred rooms. Tarkington’s was a small specialty store of less than twenty departments. Was there ever a more intimidating stretch of real estate than the Ritz’s arcade of display cases that ran from the lobby on the Place Vendome to the rear entrance on the rue Cambon, where goods from all the most expensive shops in Paris were trapped behind gleaming glass? Silas Tarkington wanted the aisles in his store to have the same awe-inspiring feel as the Ritz arcade. If you’re not our type of shopper, he wanted his store to say, you really should not be here. He also admired the way the Ritz staff treated its guests—warm and cordial to the people the hotel knew, but aloof and just a touch condescending to strangers and people who did not look as though they belonged there. He urged his staff to try to emulate that Ritz attitude, a delicate balance between coziness and hauteur.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("At that meeting, he had announced that the store would adopt an unwritten dress code for its clientele. Anyone who did not “look right” or was not “dressed right” would be shown to the door, politely but firmly.")]), _vm._v(" "), _c('p', {
    staticClass: "indent2"
  }, [_vm._v("The young man in the reversed duckbill cap, granny glasses, T-shirt, and jeans approached the Fifth Avenue entrance to the store, but James, the doorman blocked his path. “Deliveries through the side door, around the corner,” James said. Indeed, the young man did look like a delivery boy and was carrying a fat manila envelope under one arm.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Wait a minute, fella,” Blazer said. “Don’t you realize who I am?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("This immediately posed an agonizing dilemma for poor James because he did indeed now recognize the owner’s son. But, at the same time, he had been given strict instructions that men in T-shirts were not to be admitted to the store. “We have a rule against T-shirts on the selling floors, Mr. Tarkington,” he murmured. “So would you mind—?” He glanced nervously toward the corner and the service entrance.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“What the hell! You mean I gotta go in my old man’s store like I’m a goddamned delivery boy?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“If it’s your father you’ve come to see, Mr. Tarkington,” James said, “he’s not in the store at the moment. He left about half an hour ago, saying he’d be back around two.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“That’s okay. I just want to leave this envelope on his desk.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Perhaps I could take it up for you, then,” James suggested.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“No, I want to take it up myself. I need to write him a note when I get up there. It’s important.” He patted the manila envelope. “These are important legal papers, damn it!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Well, let me see what I can do,” James said, and he pressed the button by his station that connected him with Tommy Bonham’s office. “Mr. Tarkington, Junior, is downstairs, sir,” he said. “I wonder if I could ask you to come down, sir.” Turning to Blazer, he said, “Mr. Bonham will be right down.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("And so Blazer waited, fuming, on the sidewalk.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Presently Tommy appeared through the door and immediately grasped the situation. He took Blazer by the arm and said, “Let me take you down the street, Blazer, and buy you a cup of coffee.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In the coffee shop, the two of them settled in a booth, and Tommy said, “Have you had lunch? Would you like a sandwich? They do a good Reuben here. Good burgers, too.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Nah. Just coffee’s fine. Black.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Blazer,” Tommy began easily, “lots of places have dress codes. All the best restaurants in New York require jackets and ties on men, and some will not even permit blue jeans.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I don’t go to phony restaurants like that.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Well, phony or not, don’t you think restaurants have the right to enforce a dress code?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“We’re not talking about a restaurant, damn it.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Let me put it to you another way. Suppose you were taking a date to the Yale Prom—”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I wouldn’t be caught dead at the Yale Prom!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Then let me put it still another way. Suppose you were invited to a dinner dance, or a friend’s wedding, and the invitation said ‘black tie.’ How would you—?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I wouldn’t go!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Suppose this is your best friend’s wedding. He has asked you to be his best man. The wedding is to be black tie.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I still wouldn’t go. I wouldn’t accept.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“If he’s your best friend, wouldn’t he be hurt if you turned down the honor of being his best man?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“A phony who’d have that kind of wedding wouldn’t be my friend!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I see,” he said. “Your father tells me you’re fond of classical music.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“So? What’s that got to do with it?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I’m thinking of hypothetical situations, Blazer. Suppose there’s to be a Mozart symphony performed, by an orchestra you’ve always wanted to hear. Your seats are in the dress circle—”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I wouldn’t sit in the goddamned dress circle.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“What if the "), _c('i', [_vm._v("only seats available")]), _vm._v(" are in the dress circle, Blazer?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Then I’d stand in the back of the hall!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Tommy Bonham sighed. “Blazer,” he said, “don’t you think it’s rude—don’t you think it’s actually insulting to the other people around you—not to dress the way other people consider appropriate for certain occasions? Don’t you think that’s actually hostile behavior?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Nope. People are what they are, not what they wear.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“But don’t you think your attitude is maybe a little bit childish? I mean, I could understand this sort of rebelliousness from a fifteen-year-old. But you’re a grown man. You’re twenty-one, and you’ll be graduating from Yale at the end of May. You’re going to find a different world out there, a world where you’re going to be expected to conform to certain—”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Don’t give me a lecture about the big bad world out there!” Blazer snapped. “I’ve heard all that shit before.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Well, let me put it to you one final way,” he said. “Your father and I run a business. It’s known as a service business, which means that our job is to please and be of service to our clients. We are not in the business of insulting them. And our clients are people accustomed to observing certain standards of dress. And if any of our clients had seen you walking through the store this morning, dressed the way you are right now, our clients would be so upset and insulted—insulted, Blazer, that we’d allow such a thing to happen—that they’d never set foot in our store again. So, as far as we’re concerned, our dress code is simply a matter of good business. It’s simply a matter of dollars and cents. Would you dress like that to meet the Queen of England?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I wasn’t going to meet the Queen of England, for Chrissakes!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“No,” Tommy said with a slight smile. “But the Queen of England has shopped in our store.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Blazer said nothing, merely looked down at his empty coffee cup, and Tommy Bonham looked at him evenly. “You have no respect for your father, do you, Blazer. No respect at all.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I’ve got no beef with the old man,” he said. “It’s just this fucking, phony shmattes game he’s in.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Tommy Bonham’s eyebrows went up. He took a final sip of coffee and folded his paper napkin carefully on the table in front of him. “No wonder your father hates you,” he said.")]), _vm._v(" "), _c('p', {
    staticClass: "indent2"
  }, [_vm._v("“I hear we had a little problem with Blazer this morning at the store,” Si Tarkington said to Tommy Bonham later that afternoon.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Tommy steepled his fingers. “Your son’s attitude seems to me—well, a little bit immature,” he said.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“James did absolutely the right thing, and I told him so. We may decide to make exceptions to the rule now and then, but certainly not for members of my own family. If anyone in the store had recognized him, it would have looked even worse for us.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“That was the only argument I didn’t use with him,” Tommy said.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I mean Miss Garbo may look a little—peculiar when she comes into the store. But she’s Miss Garbo, and everyone knows who she is. She’s earned the right to dress as she chooses. Blazer hasn’t.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Mrs. Onassis and her sister happened to be in the shoe department at the time.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“And he would have walked right past them on his way to the elevator!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“He said he had some important legal documents to show you. He didn’t say what they were.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Si Tarkington looked grim. “I think I know,” he said. “What would you do with him, Tommy? If he were your son, how would you handle him?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Tommy spread his hands. “It’s hard to say, Si. But at times like this, I’m grateful that I’ve never been a parent. It isn’t easy, I know.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“It’s his mother’s fault, of course. It’s his goddamned mother’s fault. She encourages this sort of behavior. She "), _c('i', [_vm._v("applauds")]), _vm._v(" it! It’s all her goddamned fault.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“If I might make one small suggestion, Si,” Tommy began.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“What? What is it?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Perhaps—perhaps if you tried a little harder to show him that you love him, Si. Perhaps that might help.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He nodded. “I’m going to have a word with him,” he said. “Meanwhile, thanks for helping out with James this morning, Tommy. You certainly have better things to do with your time than deal with my family problems.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“That’s what I’m here for, Si. To help you in any way I can.” He paused. Then he said, “He referred to our business as the shmattes game. He called it ‘this fucking, phony shmattes game.’”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("And Tommy Bonham watched as Silas Tarkington’s face grew white with fury.")]), _vm._v(" "), _c('p', {
    staticClass: "indent2"
  }, [_vm._v("That evening, after the store had closed for the day, Blazer Tarkington appeared at his father’s office as he had been invited to do. He was dressed as he had been earlier in the day, but now he wore an unzipped leather airman’s jacket over the T-shirt. Unknown to him was the fact that, in the closed office next door, Tommy, at Si’s request (“So you can tell me how I do with him”), would be eavesdropping on this meeting over the intercom.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Sit down, son,” Si said, and Blazer slumped in the chair across from his father’s desk.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“We are a divided family,” his father began. “That fact is painful to me, but it is a fact that cannot be avoided. You are the product of a broken home, as they say, and I’m sure you blame me for the breakup of that home. All I can say to you is that in any divorce there are two sides to the issue, and the two people who are involved will probably never agree on who is to blame for the breakup of the marriage. Each partner in a divorce action thinks his side is right and the other side is wrong. I ask you to accept the possibility that, in your mother’s and my case, there were rights and wrongs on both sides. I have never tried to paint myself as the hero or your mother as the villainess. The greatest mistake, I suppose, was that your mother and I got married in the first place. But then, Blazer—but then we would not have had you, whom we both love very much.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I’d also like you to believe, son, that I have done everything in my power to make this divided family as happy and as privileged as I possibly can—to do everything I can for you, Miranda, and your mother. As you know, I’ve tried to give you and Miranda the finest of possible educations. Your stepmother and I have tried to make you feel welcome in our home. We wouldn’t do any of this, son, if we didn’t love both you children equally.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Bullshit,” Blazer muttered.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("His father pretended not to hear this. “And we wouldn’t have been able to do any of this,” he went on, “if it hadn’t been for my business. Now you may think that this is a phony business; I won’t argue with your right to think that. Perhaps any business designed to fulfill human needs is a phony business, but all I can say is that I would not have been successful in the business I’m in if I had not found a way of fulfilling certain needs. In my case, it is women’s needs for beautiful clothes, designed to make them look more beautiful. My success is proof of that need, son, and all I ask is that you understand why I am proud of it, very proud. This is a business I built from scratch, from nothing, with no help from anyone. And I didn’t build it just for myself, though that was certainly part of it—I won’t deny I have an ego—I also built it for my family, my wife, my children, and my children’s children, so that future generations of this family would have something to hold on to. That’s about all a man has in this life: his business, his family, and the future of his family. It’s like a religion. It’s like a love affair. For what are religion and love all about if it isn’t trying to find some security in the uncertain future? I ask you to try to understand that. Of course I used to think and hope that you—that you and I, as father and son—but never mind that.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Yeah, what about me?” Blazer said.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("His father studied him. “I’m asking you to understand me,” he said at last. “Is that too much to ask? Maybe it is.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Yeah.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You had your twenty-first birthday two weeks ago,” his father said, and Blazer nodded.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I assume you received your birthday check?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Blazer nodded again.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“That’s wrong. I don’t assume. I know you received it because you endorsed it, and the check has cleared the bank. I suppose I was asking too much to expect some sort of thank-you note from you for a check for five thousand dollars.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Blazer sat forward in his chair. “But what about this?” he said, slapping the manila envelope on his lap. “What happened to my fucking trust fund? I took these papers to Jake Kohlberg this morning to collect the money from my so-called trust fund, and he tells me all the money’s gone! Where is it?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I know about this,” his father said. “Jake Kohlberg called me this morning. This is a matter you will have to take up with your mother.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“But this was supposed to be "), _c('i', [_vm._v("your")]), _vm._v(" trust fund! For "), _c('i', [_vm._v("me")]), _vm._v("!” He waved the manila envelope in his father’s face.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Please don’t do that, Blazer,” his father said, holding up his hand. “It’s true that I funded the trust. But the two trustees were your mother and the First National Bank of Stamford, Connecticut. Somehow the funds have been expended. Don’t ask me how. Ask your mother.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“But what the fuck am I supposed to do, Dad?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I suppose you could sue your mother.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“That’s what Kohlberg said. He wants me to hire him to sue my own mother!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I doubt that Kohlberg, Weiss would be willing to represent you in such an action,” his father said, “since they are my legal counsel.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Sue my own mother! That’s typical of you, isn’t it? You’d sue your own mother! I know all about you! All this bullshit you’ve been slinging me about your business—how you started it from nothing, from scratch, with no help from anybody! You started it by jewing your own mother out of her inheritance! You jewed your sister, too. You jewed your mother and your sister, you jewed them both with your dirty Jew tricks. Mom told me all about it, Dad. I know all about it!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Your mother is a highly emotionally unstable woman with a serious drinking problem. And, it would seem, a serious streak of larceny.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Blazer jumped to his feet. “Don’t say such things about my mother!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Your mother is a lush. You know that as well as I do.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He raised his fist. “I’m warning you!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("His father reached for a button on his desk. “Are you going to strike me?” he said. “All I have to do is push this button, and Oliver from Security, who is a Pinkerton detective, and armed, will be here in a matter of seconds.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You’re not worth hitting,” Blazer said, lowering the fist. “You’re not worth it, Mr. Solomon Tarcher. Mr. Phony Silas Tarkington!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("His father’s eyes drew into narrow slits. “Did you refer to my business as the shmattes game?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Who told you that?” Blazer’s eyes were round.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I asked you a direct question, and I want a direct answer. Did you refer to my business as the shmattes game? "), _c('i', [_vm._v("Did you ever refer to it as that?”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Yeah, sure! Because that’s all it is! Fucking, phony shmattes game!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Get out of here, you filthy little piece of slime,” his father said. “Get out of here in your filthy jeans and filthy T-shirt and filthy shoes and everything else that’s covering your filthy body. "), _c('i', [_vm._v("You’re")]), _vm._v(" shmattes, is what you are. When you were a baby, your mother almost dropped you on your head and killed you in one of her drunken rages. Sometimes I wish she had succeeded. Get out of here. I never want to lay eyes on you again.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Blazer hurled the manila envelope at his father, who caught it deftly in mid-air, ripped the envelope in half, and dropped the two halves into his wastepaper basket.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("And Blazer charged out the office door.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I guess you heard all that,” Si Tarkington said when Tommy rejoined him in his office. Si’s face was drawn and weary.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“All of it,” Tommy said. “Si, you were magnificent. You gave him every opportunity. Some of the things you said—I made some notes. ‘What are religion and love all about, if it isn’t trying to find some security in an uncertain future?’ My God, that’s beautiful! It’s poetry. It almost brought tears to my eyes. But he didn’t hear a word of it. Give up on him, Si. The kid’s not worth it. And you’re right, it’s all his mother’s fault. She’s completely poisoned his mind against you—against you and against everything you’ve ever done or tried to do.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Silas Tarkington rose a little slowly from behind his desk. His face was pale and his shoulders sagged, and he suddenly seemed a man of even slighter stature than he actually was. “Worthless,” he repeated. “What should I do now?” His voice was soft, imploring, almost childlike.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“For God’s sake, just don’t give him any more money. He made it perfectly clear that’s all he wants from you. Don’t send any more good money after bad. Look at all you’ve given him, Si. The finest education money could buy—Hotchkiss, Yale—and this is the way he rewards you.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“But he’s my son,” he said. “My own flesh—”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Take him out of your will, Si. Lord knows you’ve threatened to do that often enough. Show him it wasn’t just a threat. Show him you mean it. Put your money where your mouth is. God knows what would happen if he ever got his hands on any Tarkington’s stock. He’d have this place down the tubes in five minutes. The little bastard doesn’t deserve a plugged nickel. Cut him off without a penny.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“It’s hard, Tom. It’s damned hard.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Of course it’s hard. But it’s time for you to play hardball now.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“The things he said about my mother … my sister.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Your mother and your sister were well taken care of—you and I know that. You were dealing with greedy and ungrateful people, and you had to be tough. You’re dealing with a greedy and ungrateful person now, and you’ve got to be tough again. Besides, you’d be doing him a favor. Let him learn that he can’t go through life living on handouts from a rich father. Let him learn that if he’s going to make a living he’s going to have to do it by the sweat of his balls—the way you did. A kid who’d speak to his father the way he just did to you? Cut him out of your will. Show him who’s boss.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You’re right … you’re right.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Listening to the things he was saying to you, it was all I could do to keep from walking in here and punching him in the face. After all you’ve done for him. For God’s sake, Si, don’t let this kid shit on you any longer. Be a man! Let him go. It’s called tough love.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You’re right. I’ll call Jake Kohlberg in the morning.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Good man. Now you’re talking like Si Tarkington. Now you’re talking like the legendary Silas R. Tarkington, the merchant prince.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“And doesn’t he … doesn’t he understand I couldn’t have done any of it if I’d kept the old name?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Listen, that kid has never even "), _c('i', [_vm._v("tried")]), _vm._v(" to understand you!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You understand me, don’t you, Tommy?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Damn right I do.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“But still—where did I go wrong with him, Tommy?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You didn’t. You’re not to blame. You said it yourself—it’s his mother’s fault, it’s Alice’s fault. She’s taught that kid to hate you since he was old enough to talk.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You’re right … you’re right.” Si Tarkington lowered his head, and his fingers riffling aimlessly through some papers on his desk, staring hard at the day-end sales figures as though they held the answer to some inscrutable riddle. He pressed his palms hard on the top of his desk and appeared to sway.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Tommy Bonham stepped forward. “Are you okay, Si?” he asked.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Oh, yes.… But still … but still, I had such high hopes for him,” he said. “My only son, and he called me a dirty Jew. I feel … I feel like camels just shat on my father’s grave. Blazer.… He was supposed … he was supposed to blaze across the sky like … a comet, like a shooting star. I wanted so much for him, Tommy … so much. Maybe I wanted too much. And now I have … no son.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Look, Si,” Tommy began gently, “you’ll always have—”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He had been about to say “me” when he realized that the founder and C.E.O. of Tarkington’s was weeping, that teardrops were falling across the page of sales figures, so Tommy Bonham left the rest of that sentence hanging in the air.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You’re doing the right thing,” he said instead.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You’re right … you’re right.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“His mother has poisoned his mind against you, Si. He’ll never change.”")])])])
}]}

/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(113),
  /* template */
  __webpack_require__(114),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 113 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 114 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "chap-title"
  }, [_c('span', [_c('i', [_vm._v("10")])])]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_vm._v("It is Wednesday, and Miranda has arrived to assist Pauline O’Malley clear out her father’s desk, bookshelves, cabinets, and files. “Pauline needs help going through the things in your father’s office,” Tommy Bonham told her. “Someone in the family should be there when she does this. Can you give her a hand?” Materials pertaining to the store’s operations will, of course, stay where they are, but personal items—her mother’s photograph in its silver frame, his silver calendar and water carafe, his collection of Baccarat "), _c('i', [_vm._v("millefleur")]), _vm._v(" paperweights, and so on—will be packed and shipped out to Flying Horse Farm. The shipping department has sent up cardboard cartons for the job, along with bags of Styrofoam peanuts for packing the more fragile things.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("This is Pauline’s first day back at work since Silas Tarkington’s death. She has taken his death very badly. When Miranda first encountered her this morning, she looked terrible. Her eyes were red from weeping, her hair was a mess, her lipstick was smeared, and her desk was awash with piles of wadded-up Kleenex. Seeing Miranda, she rose from her chair and quite literally threw herself into Miranda’s arms with a fresh burst of sobbing. “Oh, Miss Miranda,” she moaned, while Miranda patted her shoulder, “we’ve lost him … lost him … we’ll never see him again, will we? Never in this world. Your poor mother. How is she taking it?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“She’s—bearing up,” Miranda said.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Oh, the poor thing! She must be devastated, absolutely devastated. I should have written her a note, but I just couldn’t bring myself. I still can’t believe it. Our Mr. Si is gone … he’s gone … he’s gone!” Tears streamed down her pale cheeks.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“There, there,” Miranda said.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Tell your mother I’m making a very special novena for her. This is my fourth day. I’m asking Our Lady to bring your mother peace.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“She’ll be very touched to hear it,” Miranda said.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Now Pauline has more or less managed to collect herself, though there are still occasional sighs and sniffles as they pack the boxes. From her father’s bathroom, Miranda fetches a fresh box of Kleenex. She supposes that Pauline was secretly in love with her father—how else to justify such an excessive display of grief?—and she even wonders whether Pauline and her father had been lovers once upon a time. Was Pauline O’Malley ever pretty? It is hard to say at this point. Perhaps, but now she has developed the white papery skin and fine worry lines of secretarial spinsterhood. Why does a spinster’s skin become like parchment? Miranda doesn’t know, but it does.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“When we finish this, I’m going to have to clean my own desk out,” Pauline says, gently wrapping a paperweight in tissue paper and nestling it in a box of plastic peanuts.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Whatever for?” Miranda asks her.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("There is a little sob. “I can’t stay on here. I can’t stay on here now that Mr. Si is gone.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Oh, but we don’t want to lose you, Pauline. Mr. Bonham’s going to be running the store, at least for the time being. Couldn’t you stay and help him out?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I could never work for Mr. Bonham!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Why not?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Never! There was only Mr. Si. He was the only one I could ever work for, ever. No one can ever take his place.” Another sob.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“But what will you live on, Pauline?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She blows her nose noisily. “There’s my pension fund account. Every Tarkington’s employee with more than ten years’ service has a pension fund account. And there’s my Social Security. That will be more than enough.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“If it’s any comfort to you, Daddy left you some money in his will.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Her eyes grow wide. “He "), _c('i', [_vm._v("did")]), _vm._v("?” she gasps.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Ten thousand dollars. I know that’s not—”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('i', [_vm._v("“Ten thousand dollars!”")]), _vm._v(" she cries. “Why, that’s more money than I’ve ever had at one time in my entire life! What in the world will I ever do with that much money?” There is a fresh burst of sobbing. “Oh, what a wonderful man he was, your father, what a wonderful, generous man … I’ll have to ask my brother-in-law to help invest it for me. He’s a C.P.A.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Miranda is beginning to lose patience with this woman and her teary heartbrokenness. Here, after all, is a woman who always seemed to Miranda so coolly efficient and unemotional that she verged on iciness; her father’s death has reduced this virginal automaton to a blubbering mass of woe. Here is a woman who has spent thirty-four years working in a store where women spend ten thousand dollars for a single dress without giving it a thought, and Pauline is treating this sum as though she has been handed the output of King Solomon’s mines. “Come, come, Pauline,” she says a little crossly. “Please try to pull yourself together.” After all, she thinks, I am the one who should feel bereaved. She finds herself wishing her father had left this woman nothing at all, though she knows these thoughts are unworthy.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("All her comment produces, however, is another freshet of tears.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Look here,” Miranda says. On impulse, she picks up the signed photograph of President and Mrs. Ford. “I want you to have this too.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Oh, no, Miss Miranda! Not that! That was his most prized possession! That’s a signed photograph of a living United States President! Do you realize how valuable that is? That’s "), _c('i', [_vm._v("priceless")]), _vm._v(", Miss Miranda!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I hardly think so,” she says. “The Fords handed them out to everyone they met. But I’m going to make it even more valuable for you.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She slides the photograph out of its frame and, beneath the inscription "), _c('i', [_vm._v("(To Silas Tarkington, with grateful good wishes, from Gerald and Betty Ford)")]), _vm._v(", Miranda writes in her own hand, "), _c('i', [_vm._v("Presented to Pauline O’Malley, devoted secretary to Silas Tarkington, with gratitude and affection by his daughter, Miranda")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“There,” she says, handing it to her with a flourish. “That gives the photo a bit of a history, as the art dealers say. Now, no more tears, okay?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Oh, Miss Miranda, I shouldn’t accept this.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“But you will, right?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Pauline reads the new inscription. “‘Devoted,’” she says. “Yes, that’s right. I was devoted to him. I’d have laid down my life for him.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“And this too,” Miranda says, and reaches for a paperweight that is particularly nice. “I want you to have this too, as a little personal remembrance. Look, it’s even dated on the bottom: seventeen-eighty. Daddy was told that it once belonged to Catherine the Great of Russia.” She presses the paperweight into Pauline’s hand.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“But what would I ever do with it?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Just place it somewhere where it will catch the light.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Now there is yet another spell of weeping. “Oh, Miss Miranda. You’ve always been so kind to me. All your family. How can I ever thank you? My cup … my cup runneth over.” When she has managed to compose herself again, she says, through her Kleenex, “Now, what about these? What shall we do with these?” She points to a line of books bound identically in dark blue leather bindings. “These are his diaries.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Diaries? I didn’t know he kept a diary.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Well, they’re not diaries really. They’re date books, where he recorded his personal appointments. There’s one for each year. They go way back to when he opened the store.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Well, if they’re personal, I think they should go to the farm.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Miranda starts plucking the books from the shelf and stacking them in an empty carton. Then an idea strikes her. She picks up the most recent volume and turns to the date he died, Saturday, August 12. The page contains only a single notation: "), _c('i', [_vm._v("D.S")]), _vm._v(".—"), _c('i', [_vm._v("11 a.m")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She feels her heart sink. D.S. Diana Smith. So Tommy was right. He was planning to meet Smitty on the day he died.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She turns the pages backward, and a letter in its envelope falls out. It is addressed to him in what seems amateurish typing, and the envelope is marked "), _c('i', [_vm._v("Personal/Confidential")]), _vm._v(". Pauline is busy in another part of the room, so Miranda drops the letter quickly in her purse, to read later.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Then she remembers another date: June 1970. She runs her finger back along the books until she finds that year’s volume and begins turning the pages for the month of June. There, scrawled across two dates—June 24 and 25—she finds the notation: "), _c('i', [_vm._v("Boston, Ritz-Carlton, res. conf")]), _vm._v(". #384-86J.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She replaces the book in its proper sequence and continues packing the diaries in their carton.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Back in her own office, after she and Pauline have finished, Miranda cancels her luncheon date, pleading urgent family business. Instead of having lunch with an ad salesman from "), _c('i', [_vm._v("The Times")]), _vm._v(", Miranda goes to the public library. She is not sure, exactly, what she is looking for, but she has found out that the library files copies of the "), _c('i', [_vm._v("Boston Globe")]), _vm._v(" on microfiche.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She takes her little spool of film to one of the projection machines and begins running through June 1970. When she gets to the twenty-fourth, she slows the film down and begins studying the newspaper page by page as it moves across her screen. She finds what she wants in the issue of June 25. It is not a big item.")]), _vm._v(" "), _c('p', {
    staticClass: "section1"
  }, [_c('span', [_vm._v("MODEL, 19, PLUNGES TO DEATH AT RITZ-CARLTON")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("A sometime model and actress, whom Boston police have identified as Christine Wandrous, 19, of South Braintree, either jumped or was pushed from a window of the Ritz-Carlton Hotel yesterday evening. Her body struck the sidewalk on the Arlington Street side of the building, opposite the Public Garden.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Miss Wandrous, a spokesman for the hotel said, was not a registered guest at the time, and elevator operators could not recall transporting the young woman to an upper floor. Although there was no immediate sign of foul play, neither was any suicide note found. A thorough police search of all guest rooms immediately above the site of her fall revealed no guests who had any knowledge of, or acquaintance with, Miss Wandrous, who most recently worked as a part-time model for Filene’s.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("A sister of Miss Wandrous, Mrs. Helen McCullough of South Braintree, was contacted by police. “Somebody had to have done this to her,” Mrs. McCullough asserted. “She would never have committed suicide. She was a happy, healthy, beautiful girl, whose life was full of hope and promise.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Funeral arrangements will be made in South Braintree.")]), _vm._v(" "), _c('p', {
    staticClass: "indent1"
  }, [_vm._v("She flips through more editions of the paper, to see if there are any follow-up stories. She finds only one. It appeared two days later, buried in a back section of the paper:")]), _vm._v(" "), _c('p', {
    staticClass: "section1"
  }, [_c('span', [_vm._v("AUTOPSY REVEALS MODEL WHO PLUNGED TO DEATH AT THE RITZ WAS PREGNANT")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The Suffolk County Coroner’s Office revealed that in an autopsy performed on the body of Christine Wandrous, 19, the part-time model and actress who plunged to her death from the Ritz-Carlton Hotel Wednesday evening, it was discovered that the young woman was pregnant. Assistant Coroner James J. Bailey said that Miss Wandrous appeared to be in the second trimester of her pregnancy. The sex of the fetus was undetermined.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("A sister of Miss Wandrous, Mrs. Helen McCullough of South Braintree, told the Globe, “I had no idea that Christine was pregnant. But I’d noticed that she’d been terribly nervous and despondent in recent months. I could tell that something was deeply troubling her, and weighing on her mind. She would suddenly burst into tears for no apparent reason. I assumed it had something to do with her inability to find work.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Occupants of the hotel rooms and suites situated directly along Miss Wandrous’s line of fall expressed no knowledge of the young woman, leading police to speculate that she may have jumped from the roof. But how she could have reached the hotel’s roof is unclear, since access is possible only through the use of a specially magnetized key-card, supplied only to members of the hotel’s maintenance staff.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("A police investigation continues, with an interrogation of all hotel employees.")]), _vm._v(" "), _c('p', {
    staticClass: "indent1"
  }, [_vm._v("Well, a police investigation may have continued, but there is nothing about it in subsequent issues of the newspaper; Miranda runs the film through the next several weeks to be sure. The whole story seems to have been dropped.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Several things strike Miranda as odd about the story. First is the girl’s last name, Wandrous—like Gloria Wandrous in "), _c('i', [_vm._v("BUtterfield 8")]), _vm._v(", whose party-girl career ends with her fall into the paddle wheel of a ferryboat. Was Gloria Wandrous pregnant too? Miranda can’t remember. Then she thinks of the phrase “jumped or was pushed.” If Christine Wandrous managed to enter an unoccupied hotel room and jump out, she would have left behind her an open window. If she had been pushed by a guest of the hotel, would the murderer have left the window open? No, he would have closed it, to make it appear she had fallen from the roof. Neither of the stories mentioned an open window, which would have been the first thing the police looked for.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("But oddest of all is the way Mrs. Helen McCullough’s description of her sister changed over the course of two days. First, Christine Wandrous is a happy, healthy, beautiful girl whose life is filled with hope and promise. Two days later, she is despondent, deeply troubled, bursting into unexplained crying jags at the drop of a hat: unemployed, pregnant out of wedlock, suicidal. At least Miranda’s father appears to have nothing to do with the tragedy, beyond the coincidence that he happened to be in Boston and staying at the Ritz-Carlton when it occurred.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Deciding that she has been pursuing a red herring, Miranda rewinds the tape and snaps off the machine.")]), _vm._v(" "), _c('p', {
    staticClass: "indent2"
  }, [_vm._v("Now, in the back seat of the Rolls with Billings at the wheel, Miranda is being driven out to Old Westbury. Beside her on the seat, as well as on the floor and in the front seat beside Billings, are packed cartons. Still more are in the car’s trunk. Each carton is labeled as to its contents. She is still thinking of her mother’s words that night: “I’m talking about June nineteen-seventy! … I’m talking about Boston and the Ritz-Carlton Hotel!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("And her father’s reply: “Moe Minskoff worked that one out for me.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("But her afternoon in the library has provided no clues as to what it all means.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Then, suddenly, she remembers the letter that fell out of her father’s date book. She opens her purse, reaches for the letter, and shakes it out of its envelope.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("It is a very short letter, typewritten on a single sheet of plain white notepaper without a letterhead, and it has the look of having been typed in great haste. She reads:")]), _vm._v(" "), _c('p', {
    staticClass: "blq-normal"
  }, [_vm._v("My darling—")]), _vm._v(" "), _c('p', {
    staticClass: "blq-indent1"
  }, [_vm._v("Our long talk this morning has made this the happiest day of my life. This is my promise to you: We’ll leave that horrible old, boring, nagging "), _c('i', [_vm._v("hag")]), _vm._v(" behind—forever—and let me become the kind of "), _c('i', [_vm._v("new")]), _vm._v(" wife you’ve always deserved, one who loves you beyond measure, and then all the heartache I have endured for these past years—loving you unbearably, but knowing that I could not have you, "), _c('i', [_vm._v("all of you, all to myself")]), _vm._v(", as I have so longed to do, my dearest—seems worthwhile. I have made our reservations at the Princess, and Bermuda should be lovely at this time of year. I am walking on air, hardly able to wait until Saturday, when I will be "), _c('i', [_vm._v("all yours")]), _vm._v(", and you at last will be "), _c('i', [_vm._v("all mine")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "indent2"
  }, [_vm._v("The letter is signed, "), _c('i', [_vm._v("With all my love, the soon-to-be new Mrs. Silas Tarkington")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She is stunned. She feels as though she has been dealt a blow to the center of her stomach. She reads the letter once more, her hands shaking. She looks at the postmark. It was mailed in Manhattan. Then, all at once, she recognizes something else. She presses her nose into the fold of the letter, and there it is, unmistakably: the scent of Equipage. This is the letter Tommy told her about. Everything he told her was true.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Her temples are pounding, her breath feels short, and she feels almost physically nauseated. On the day he died, her father was planning to leave her mother and the family he professed to care so much about and not only run off with Smitty to Bermuda—of all the cliché places—but also to marry her. "), _c('i', [_vm._v("Oh, Daddy, Daddy")]), _vm._v(", she thinks, "), _c('i', [_vm._v("how could you have wanted to do such a thing to us?")]), _vm._v(" She tears the letter into tiny shreds, rolls down the window, and scatters the pieces into the wind from the speeding car.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Billings, glancing at her in his rearview mirror, senses that something is wrong. “Are you all right, ma’am?” he asks her.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Yes, I’m fine.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Her next reaction is rage—total, absolute, and unadulterated fury—not so much at Smitty as at her father. What had happened to her gutsy father? How could he have allowed himself to be reduced to such a state of groveling servitude, to have become so "), _c('i', [_vm._v("besotted")]), _vm._v(" with this woman, to use Tommy’s word? How could he allow this woman—or any woman, for that matter—to get him to promise to give "), _c('i', [_vm._v("all of himself")]), _vm._v(" to her? How could he allow this woman—any woman—to speak of her beautiful mother, his wife for almost thirty years, in such a trashily bitchy way? Had Smitty managed to castrate him? Had he become suddenly senile? This was not the father she knew at all! All at once her father the man has become her father the wimp. All at once she has nothing but contempt for him. If this was the way he planned to treat his family, Miranda is almost happy that he is dead.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Her next wave of feelings are of total confusion and disorientation, as Miranda asks herself how she can ever face her mother again, how she can ever look her mother straight in the eye again, without having to tell her mother the truth.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Unless, of course, her mother already knows.")]), _vm._v(" "), _c('p', {
    staticClass: "indent2"
  }, [_vm._v("Her mother greets her in the entrance hall with a little kiss. She is looking lovely, as always, relaxed from her massage and rested from her nap, wearing a long hostess gown of pale blue chiffon, belted with three silver chains that tinkle as she moves. Billings is taking the car around to the garage, where the cartons of her father’s things are to be stored temporarily. “Darling, come into the drawing room and meet our other dinner guests,” her mother says. Miranda was hoping to have a serious discussion with her mother tonight, without anger or recriminations, but apparently this is not to be. Some sort of party is going on.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Do I need to change?” she whispers.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Darling, you look perfect,” her mother says.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("They enter the drawing room together, and two young men, both in black tie, rise from their chairs. One is fair, the other dark. One looks familiar, the other does not. “Darling, you remember Mr. David Hockaday from the Metropolitan Museum,” her mother says. “And this is Mr. Peter Turner, who is interested in writing a book about your father. Is it a book? Something, anyway. Mr. Turner, this is my daughter, Miranda.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She shakes hands with the two young men. “Though we’ve never met, I feel I know you, Miss Tarkington,” the darker of the two says. “I saw you once when you came down to visit your brother at Yale. Blazer and I were both in Calhoun.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Oh, yes … I remember now. It was in the fall of Blazer’s sophomore year. Mother and I had driven up from New York. You were standing in the quad.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You really remember that?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Certainly. You were wearing a red shirt.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You know something—I think I "), _c('i', [_vm._v("was")]), _vm._v("!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Mr. Hockaday has come to look at your father’s art collection,” her mother says. “I thought that made sense, since most of it is here, scattered about the house. The only important piece in this room is the Gauguin over the fireplace.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Mr. Hockaday’s eyes travel to the Gauguin, and he steps closer to it. “I hadn’t noticed it,” he says. “Forgive me.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I understand it’s an early piece, before Gauguin went to Tahiti,” Connie says.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Milliken appears to take drink orders and then to pass hors d’oeuvres.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Tell me how your husband assembled his collection, Mrs. Tarkington,” Mr. Hockaday says. “Did he work through any particular dealers?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Oh, no,” Connie says. “He didn’t trust dealers. He read in a book somewhere that people like Duveen often got Bernard Berenson to falsify the authorship and provenance of paintings in order to make sales.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“That’s true,” he says. “Did he buy from galleries and auction houses, then—Sotheby’s, Christie’s?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Never. He didn’t trust the auction houses either. He bought only from private collectors.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“He didn’t want there to be any publicity about what he bought,” Miranda says. “That was another reason why he never went to auctions.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“But I assume he did turn to one or more art experts before making his purchases,” Mr. Hockaday says.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Well, in recent years he often consulted with Diana Smith—the woman mentioned in his will—before making an acquisition.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“But you say she is not an art historian.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“No, but he admired Smitty’s—taste. And before that he used to consult with Tommy Bonham.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“An art historian?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“No. Tommy was—well, I believe he was a drama major in college.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I see,” he says. “Very interesting.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“And even before Tommy—you see, my husband began his collection long before he and I ever met—he often made purchases through his friend Moses Minskoff. But always from private collectors.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Ah,” David Hockaday says. “Moses Minskoff. The name rings a definite bell. A European, isn’t he? Based in Paris? An expert on the Fauvists?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“No,” Miranda’s mother says. “I think you must be thinking of someone else. This Moses Minskoff is—” She turns to her daughter. “How would you describe Moe Minskoff, Miranda?” she asks.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Moe Minskoff is a financial person,” Miranda says.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I see,” he says. “Very interesting. I look forward to seeing the full collection.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You will, after dinner,” her mother says.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I take it that you yourself have very little interest in art, Mrs. Tarkington.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She laughs her tinkly laugh. “None at all, I’m afraid, though I think some of the paintings are awfully pretty. My favorite is the Monet water lilies, which is in the New York apartment. No, my interests are gardening and music. My late husband’s art collecting was something he did strictly on his own. It was his principal hobby, and I stayed out of it completely.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Milliken appears at the doorway. “Dinner is served, ma’am,” he says.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("During dinner, Miranda’s mother keeps the conversation bright and lively with her usual skill, shifting her attention back and forth between her two male guests. “We must all try to remember our favorite stories about your father,” she says to Miranda. “To help Mr. Turner with the story he’s writing. Oh, I remember one: Doris Duke and her dogs. There’s a rule about dogs in the store—I think it’s a city ordinance, in fact. And one day several years ago my husband happened to see this woman strolling through the store with two borzois on a double leash. My husband was about to speak to her, when suddenly Jimmy, the doorman, came running up behind him and whispered, ‘Mr. Si, that’s "), _c('i', [_vm._v("Doris Duke")]), _vm._v("!"), _c('i', [_vm._v("’")]), _vm._v(" Isn’t that funny? Jimmy the doorman recognized Doris Duke, and my husband didn’t. He’d been about to ask Miss Duke to leave the store. He often told that story on himself, so you see he had a sense of humor.… What else, Miranda?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Well, when I was nine years old, he persuaded American Airlines to let me pilot a seven-twenty-seven between New York and Washington.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Miranda, Mr. Turner wants to hear stories about how your father ran the "), _c('i', [_vm._v("store")]), _vm._v("—not stories about airplanes!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Well, there was one client in Florida who used to keep dresses for months and months and then return them for credit.” She eyes her mother. “Is that a suitable story?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Mrs. Curtis LeMosney?” Peter Turner says.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Yes. She’s dead now, so you can use her name if you want to. Once it got into the papers, and my husband was terribly embarrassed. It happened dozens and dozens of times. We always knew the clothes had been worn. She’d return them with wine stains, lipstick—”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“But she always was given credit.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Yes, and each time she returned a dress for credit, she bought something else. And she always paid her bills on time. So what she had was kind of a revolving credit line.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Do you remember Mrs. LeMosney’s fingernail, Mother?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Oh, yes, tell that story, Miranda!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Well, Mrs. LeMosney had these very long fingernails. They were sort of her trademark, and she always painted the undersides of her nails too—bright red, as red as the shirt you were wearing that day, Mr. Turner—”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“How can you remember that? It was at least ten years ago!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Anyway, she was terribly proud of her fingernails. And one day she was in the store, trying on some things, and Daddy was helping her, and suddenly from the dressing room came this blood-curdling scream. The little dressing room maid came running out, crying, ‘Mr. Si! Mr. Si! It’s Mrs. LeMosney!’ Well, Daddy naturally thought she’d died in there or something—she was well over eighty at the time, and Daddy was always worried that one of his—well, that one of his less youthful ladies would die in the store. So he went rushing into the dressing room, certain that Mrs. LeMosney had literally shopped until she dropped. There stood Mrs. LeMosney in her bra and half slip, in tears, staring at her left hand. ‘I’ve broken a fingernail!’ she sobbed. Well, the first thing Daddy did was to call Pauline and have her make an appointment with a manicurist to try to repair the damage—with a false nail or whatever. And after Mrs. LeMosney had gone off to the manicurist’s, still in tears, Daddy went back to the dressing room. Crawling around the floor on his hands and knees, he found the broken-off nail in the carpet. He had the nail embedded in the center of a Lucite cube as a paperweight, and he had the cube inscribed "), _c('i', [_vm._v("Left Index Fingernail of Audrey LeMosney, Broken at Tarkington’s Fifth Avenue, September 23, 1983")]), _vm._v(" and had it gift-wrapped and sent to her.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“For Christmas. He sent it to her for Christmas.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“And speaking of Christmas, do you remember my terrible Christmas, Mother?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I do indeed. You were a very naughty girl. Tell that story, Miranda.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I must have been five or six—”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Five and a half.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“And it was Christmas Day, and we were spending it in the apartment over the store. That morning, I’d opened all my presents, and by ten o’clock or so I was bored with them all, so I went downstairs to the store, which of course was closed. In the middle of the center aisle on the street floor, the display department had set up this magnificent Christmas tree. It seemed at least twenty feet high—”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Well, perhaps not quite. The ceiling is only eighteen.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“It seemed that tall to me. Anyway, it was covered with candy canes and tinsel and popcorn balls, and underneath it were all sorts of packages, beautifully wrapped in different colored papers, tied in gorgeous ribbons and bows—big packages, little packages, packages of all shapes and sizes. I suddenly got it in my head that this was a Christmas tree my parents had forgotten about and that all these packages were more Christmas presents for me, so I started tearing open the packages—there were hundreds of them. Of course each one I ripped open turned out to be nothing but an empty box, but I kept at it, thinking that at least some of them had to contain gifts for me. I don’t know where the store’s security staff was while I was doing this—maybe in the basement, having a cup of Christmas cheer. But when I’d opened every gift box and found them all empty, I started on the candy canes and popcorn balls. They turned out to be made of papier-mache, but I kept pulling them off the tree, anyway—as high up as I could reach—hoping to find a real one. I was in a gift-getting frenzy!")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Well, when somebody finally came to look for me, I was mad as hell. I was crying, stamping my feet, and saying, ‘There’s nothing here for me!’ When my parents saw what I had done, something told me that they were not pleased.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“It was the most godawful mess,” her mother says. “Your father was furious.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Naturally. That display was supposed to stay on the floor until after New Year’s. The store was going to open the next morning. Someone was going to have to rebuild the whole thing. I was miserable. I wasn’t just miserable for myself, but I was miserable because I soon realized all the trouble I was causing everybody else. Cyril Marx was still director of display then, and he had to leave his Christmas dinner on Staten Island and come in to supervise. So did two of his assistants. Everybody was in the basement, rewrapping boxes. Even Daddy helped.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“So did I,” her mother says.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I could tell how furious everybody was with me—people muttering, ‘Damn little kid, damn little brat.’ People worked halfway through the night, trying to find new candy canes and popcorn balls that hadn’t had bites taken out of them. I knew that my own Christmas was ruined and that I’d ruined Christmas for a lot of other people as well.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Well, while all this work and cleanup was going on, I guess my father realized how miserable I was. I’d been sent to my room, but suddenly my father came in and said, ‘Come downstairs with me, Miranda.’ As I went down in the elevator with him I thought I was going to be in for more punishment. The mess around the tree had been cleaned up, but there was one gift box under it, wrapped in—I remember—gold paper, with a red ribbon. ‘There’s one package you forgot to open, Miranda,’ he said. ‘It’s for you. Go ahead, open it.’ I opened it, and inside was the most beautiful French doll I’d ever seen, wearing white lace. I still have that doll. I don’t know where he managed to find it, on Christmas Day, with all the stores closed—”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Actually, I think it was a display piece,” her mother says. “But it was an antique doll. It was a pretty doll.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“And so, it was probably the worst Christmas of my entire life. But it was also one of the best. It was certainly a Christmas I’ll never forget.” She feels her eyes mist over, remembering it. “God, I was a rotten little kid, wasn’t I, Mother?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“No, just a normally active five-year-old,” her mother says. “Angry as your father was, he realized that.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("There is a silence around the dinner table now.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“And what about his philanthropies?” Miranda says suddenly. “There was a little old lady on West End Avenue whom he used to take care of—”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Her mother clears her throat and makes a face. “Let’s not go into that, Miranda,” she says. “She caused us a lot of trouble. She died about five years ago, thank goodness!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“What sort of trouble, Mother?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“She became very—demanding. Let’s just say that some of your father’s charities backfired.” And Miranda decides that the little old lady on West End Avenue cannot have been her long-lost grandmother, now living in Florida, after all.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("There is another brief silence, and then Peter Turner says, “How did you and Mr. Tarkington meet, Mrs. Tarkington?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Meet? Oh, that’s an amusing story too. It was my twenty-first birthday, and my father had given me a check for a thousand dollars. That was quite a lot of money in those days, and my father said, ‘Bobolink’—he called my two sisters and me his bobolinks—‘Bobolink, I’m giving you this only on condition that you buy yourself something pretty at Tarkington’s.” She breaks off, and her face grows pensive. “The day Si died was also my birthday. Funny coincidence, isn’t it? Two birthday presents. The day I found him, and the day I lost him.…")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Anyway, I came into the store, and who should come up to greet me but the owner himself? I was terribly impressed. ‘May I show you some of our things, Miss Banning?’ he said. Goodness, I thought. The great Silas Tarkington himself was waiting on little me.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Well, you were pretty well-known even then, Mother. Three years earlier, you’d been named Debutante of the Year. Your picture had been in "), _c('i', [_vm._v("Life")]), _vm._v(" magazine.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Yes, but later I found out that Fa had set up the whole thing in advance. Fa—that’s what we called my father—had phoned Silas Tarkington and told him I was coming in. It was part of the birthday present, getting the owner himself to greet me at the door and wait on me personally. But I was certainly impressed. And later, when I had decided on a dress—it was a white piqué short summer evening dress, by Dior, with red and yellow tulips appliqued on it—he said to me, ‘May I tell you that you are one of the most beautiful women who have ever set foot inside my store?’ And naturally that impressed me too. Later I found out that he said that to every first-time client. But at the time I was most definitely impressed. Oh, yes.” She touches the corner of her napkin to the corner of her eye. “Shall we take our coffee in the next room?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Once the foursome has moved into the sun room for coffee, Miranda’s mother says, “Now, Mr. Hockaday, why don’t you just wander through the house and look at the collection? You have the complete catalogue from Mr. Kohlberg’s office, and you’ll find paintings in nearly every room. Just wander through the house and take your time.… Miranda, darling, why don’t you read Mr. Turner’s cards? Find out if he’s a suitable biographer for your father.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Would you like me to, Mr. Turner?” she asks him. “Among my other talents, I’m an excellent tarot reader—or diviner, as we say in the fortune-telling business.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Please call me Peter. Can you really do that? Tell my fortune?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Absolutely. It’s one of the more important things I learned at Sarah Lawrence. In Psychics One-oh-one.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Please do it,” he says eagerly.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She fetches the tarot pack from a drawer in the card table. “Come sit beside me,” she says. “Now, first I have to select your significator card. This will be the card that represents "), _c('i', [_vm._v("you.”")]), _vm._v(" She studies his face. “Since you have dark brown hair and eyes and are a young man, your significator card will be the Knight of Cups. You see, even though this method of divination was devised by the ancient Celts, it’s very scientific. Remember that it was the ancient Celts who built Stonehenge, by which they predicted the solstices and the phases of the moon.” She makes a droll face. “This means that everything I say about you will be absolutely true.” She winks at him, removes the Knight of Cups from the deck, and places it face upward on the table.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I’m really amazed that you remember me from Yale,” he says. “Out of five thousand students.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“It was your red shirt,” she says. “It was fire-engine red. And you were—well, sort of staring at me.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Yes, I guess I was.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Now, I want you to shuffle the cards three times, very carefully, and while you’re shuffling them, I want you to think hard, really concentrate, on any question you want answered or any problem you want solved.… Now cut the cards into three piles, away from your heart, to your left.… Now give me the leftmost pile.” She begins to lay out her tableau. “This first card covers you. This card represents the general atmosphere surrounding the problem, or the question you want answered.… The atmosphere is favorable, as indicated by the Sun.… You will attain your personal goals.… And now the Hanged Man, in this quadrant, is another favorable sign. It suggests that you are introspective, spiritual, willing to make sacrifices.… I believe the question you have asked concerns a young woman. Am I correct?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You’re right!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Miranda’s mother picks up her needlepoint, the cover she is making for her tennis racket.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“This is unusual,” Miranda continues. “All the Major Arcana have fallen in this quadrant. One day you will be very famous. That is, your name will be known, but not your face.…”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Presently, Mr. Hockaday returns. “Mrs. Tarkington, I wonder if I could have a word with you in private?” The expression on his face is grave.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She hesitates, starts to rise, then sits again. “No, I think you can say whatever you have to say to me in front of Miranda and Mr. Turner. After all, Mr. Turner has been promised that we’ll hold nothing back about my late husband.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I don’t quite know how to put this to you, Mrs. Tarkington,” he begins. “But I’m afraid your late husband was—or whoever advised him on his purchases was—well, it was the Gauguin in the drawing room that first aroused my suspicion.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Her needlework falls briefly into her lap, but she picks it up again and quickly draws another pale blue thread through her canvas, completing a stitch. “Is it a fake?” she asks.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I’m afraid so, yes.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“The Vuillard?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Also.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“The three Cézannes?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He nods.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“The Van Gogh sunflowers?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He nods again.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“The Utrillos?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Yes.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“The Hoppers and the Bentons?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Yes.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“All of it?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“All.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I see,” she says.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“These are high-quality copies, Mrs. Tarkington. But—copies, I’m sorry to say.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("There is a silence, and then Miranda hears her mother say, “Well, that, I suppose, is that. It’s rather like Miranda’s empty Christmas boxes, isn’t it?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Miranda, who has been staring hard at the tableau of cards spread out in front of her, reaches out now and squeezes her mother’s hand, and their eyes lock briefly.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You mentioned a Monet water lilies, Mrs. Tarkington.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Yes. That’s in the apartment in the city.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I’d like to have a look at that too.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Certainly,” she says. And then, quickly, “No! I don’t want to know.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I think I’d better go now, Mrs. Tarkington.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“No. You haven’t had your coffee. After she finishes with Mr. Turner, Miranda will want to read your cards. She’s very clever. Do you take cream?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Now here in the King of Pentacles,” Miranda says, touching the cards with her fingertips, moving from one column to the next. “He is a very strong figure in your life. Pentacles and Swords dominate.…”")]), _vm._v(" "), _c('p', {
    staticClass: "indent2"
  }, [_vm._v("And now Miranda is alone in the sun room. It is almost midnight, and she is not thinking about love, exactly, though love is a part of it. The two male dinner guests have departed, and her mother has said good night and made her way up to her bedroom.")]), _vm._v(" "), _c('p', {
    staticClass: "indent2"
  }, [_vm._v("“Will you be spending the night here, dear?” her mother asked her from the doorway.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Would you like me to, Mother?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Whatever you like.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Well, if it’s okay with you, I think I’ll borrow the station wagon and drive back to the city. After all, tomorrow is another working day.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Oh, dear, I hate to hear you say that.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Why? I do have a job to do.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“The store, the store. It’s always the store. It’s dominated our lives. But soon we’ll be rid of it.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“No!” she said sharply. “The store is part mine now, and I’m going to keep it.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Miranda, such foolishness—”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“What would you have me do instead, Mother? Sit on my fanny for the rest of my life, doing nothing—like you?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Her mother turned on her heel, the silver chains at her waist tinkling as she did so. “Well, if you change your mind and decide to stay, just let Milliken know and Margaret will turn down your bed for you.” Then she was gone.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Miranda sat alone for a while, her thoughts racing, sipping what remained of her coffee. The coffee was cold, but she sipped it anyway. Her mother was a riddle that seemed to have no answer. She decided to make one more attempt at making peace, so she tiptoed up the stairs and down the hall to her mother’s room.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Her mother’s door was partway open, and her mother lay across the bed, propped up by many white lacy pillows, her face masked in a mud pack, her hair in its net. At the foot of the bed sat Margaret, who was massaging a cream called PrettiFeet between her mother’s toes. In her mud pack with its tiny slits for her eyes, nostrils, and mouth, Miranda’s mother looked both pitiful and comic—mummified and yet alive—and Miranda had to stifle an urge to laugh.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Is that you, Miranda?” her mother said. “Did you change your mind?” Her mother’s voice was hollow, for it was difficult to speak behind the pack. Any movement of her facial muscles tended to crack the drying mud. The mud smelled of cordite. At this point in her evening toilette, Consuelo’s bedroom smelled of a mixture of Guerlain and brimstone, Shalimar and sulfur.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I’m sorry, Mother. I didn’t mean to snap at you,” she said. “It was just that you took Mr. Hockaday’s terrible news so—calmly. But then you always seem to take bad news calmly. I wish I could learn to do that.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I’m not thinking of the paintings,” her mother said in the same hollow voice, trying not to move her lips. “I’m thinking of poor Smitty.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Poor "), _c('i', [_vm._v("Smitty")]), _vm._v("?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Yes. She’s been named special curator of an art collection that apparently doesn’t exist. Never did exist.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I think Smitty is getting exactly what she deserves!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Oh, no,” her mother said. “Not this—not this, on top of everything else.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Miranda felt herself about to lose her temper once more, but she refused to let that happen, so she simply said, “Well, I’m off. Good night, Mother.” And she turned and ran down the stairs.")]), _vm._v(" "), _c('p', {
    staticClass: "indent2"
  }, [_vm._v("And yet here she still is, in the quiet sun room at Flying Horse Farm. The house is asleep. She should be in the station wagon by now—its keys hang on a little board just inside the kitchen door—driving down the expressway toward Manhattan, speeding toward 11 East 66th Street and her comfortable apartment and her quiet bed. Outside, the garden is dark, for there is no moon. Somewhere in the invisible distance is her mother’s Dell Garden, with its deep lake and the moon-gate footbridge running across it, where she and Blazer fed the swarming fish and he had warned her to beware of the phonies.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('i', [_vm._v("“These are high-quality copies, Mrs. Tarkington. But copies, I’m sorry to say.”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The house is sleeping, but suddenly it is full of voices.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('i', [_vm._v("“Actually, it was a display piece. But it was an antique doll. It was a pretty doll.”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("And so there is another illusion shattered—the picture of her father, bundled up against the winter cold and snow, trudging through empty streets of closed and shuttered shops in search of a special gift that would in some way salvage, at least in part, a little girl’s unhappy Christmas. All he had done was go down to the basement Display Department and pick out an item from its carefully boxed, catalogued, and numbered contents. From the shelves of dismembered mannequins, the boxes of ornaments and trimmings and artificial foliage, he had found a doll with a china head and moving eyes wearing a white lace nightie.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You have to be very cynical in this business,” her father had said to her—yes, it was right in this room—when she was desperately trying to persuade him to give her a job in the store. “You’re not cynical enough, Miranda. This is a business for gamblers, high rollers. I don’t see you as a born gambler. Everything about designer apparel is in the roll of the dice. I’ve often compared retailing to show business, but, believe me, retailing is even riskier. A true gambler gets as much of a thrill out of losing as he does out of winning. That’s what gamblers call ‘heart,’ but a gambler’s heart is hard and his blood is cold. I don’t see you as a hard-hearted, cold-blooded person. You’re not tough enough for this business. You’re soft, you’re feminine, you’re easily hurt and easily disappointed. Cynicism is what you lack, knowing that you’re either going to win or lose, and that winning is all a matter of luck, of chance.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Just give "), _c('i', [_vm._v("me")]), _vm._v(" that chance, Daddy,” she said.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("On the card table, the tarot cards are still spread in a fan shape, face down. If I’m going to place my faith in luck and chance, she thinks, I might as well place a little of my faith in magic too. "), _c('i', [_vm._v("Think hard, really concentrate, on any question you want answered or any problem you want solved")]), _vm._v(". She thinks hard, and the question comes.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("It is: "), _c('i', [_vm._v("Who am I?")]), _vm._v(" She picks a card at random and turns it face up. It is the High Priestess.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Interesting. The High Priestess is the most powerful female court figure in the deck. She symbolizes wisdom and secret influence. She is also a figure of mystery and a certain ambiguity. She wears a strange headdress—an orb with antlers, signifying her ability to rule and also to fight for what she wants. A blue robe cascades from her head and shoulders and falls across her knees and feet like a freshet of spring water, denoting fluidity and an ability to compromise. Behind her grow palm and pomegranate trees, and in the far distance, on a hill, stands a castle—riches. The face of the High Priestess stares directly and serenely at Miranda. Studying that face, Miranda thinks, I am that loosely draped lady, she is me. See how surely and squarely she sits, chin tilted upward, resolute, proud, secure in her world, unafraid of the future. See how she seems to be spreading her wings, prepared to fly, borne by the wind. She is me. Oh! She is me.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Who am I? I am not my father’s soft and easily hurt and disappointed daughter. I am not his little china doll. I am tough and I am strong and I am cynical and also flexible, and flexibility was not exactly your strong suit, Daddy dear, and I am going to show them all how strong and tough and cynical yet flexible I can be. Oh, yes.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Of course there is another side to the High Priestess that reveals itself when the card is held upside down. She also symbolizes love, marriage, motherhood, relatedness, sexual passion, and supportiveness of friends and family, and suddenly, Miranda has another revelation. "), _c('i', [_vm._v("I will gather up the pieces of this fragmented family and put them together again")]), _vm._v(". I will find my long-lost grandmother and the Aunt Simma I never knew I had. I will bring back Blazer, too, and even his mother. That is all a part of my destiny, according to this little card. She feels a sudden rush—a rush of adrenaline almost like a burst of sexual excitement—as she contemplates all that she has suddenly been assigned to do.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Everything my father broke, I will mend.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I will even let myself fall in love again, for love is just another of the tools with which one builds a life.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Impulsively, she turns over another card, and there he is, the Magician, who denotes the power to turn mere ideas into action, to turn dreams into reality, to translate promises into deeds. He is Tommy Bonham, who has offered to help her. Of course.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In the distance, the hall clock strikes twelve, and still Miranda stays at the card table, studying the esoteric symbols in her hand.")]), _vm._v(" "), _c('p', {
    staticClass: "indent2"
  }, [_vm._v("It is the memory of that little gesture of Miranda’s—reaching out from that magic card table to touch her mother’s hand—and the look of a deeply shared intimacy that seemed to pass between the two women, that Peter Turner has carried home with him. Earlier, he had sensed a certain tension between them. But in that brief gesture they became a mother and a daughter.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Talk about grace under pressure, he thinks. Both women demonstrated that rare asset tonight. Considering the pressures they both must have been under during these past few days, he is even more impressed. Miranda is beginning to see the whole fabric of her father’s life, that he had stitched together as elaborately as a needlepoint design, fly apart before her eyes, he thinks. How much more will come?")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("As he slides his long legs between the cool sheets of his narrow bed at the Dakota, he also thinks, She noticed me standing there that day in the quad outside Calhoun. She remembers my red shirt. I remember her fiery mane of chestnut hair.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He turns out the light and, with a little sigh, realizes that tonight he has managed to fall in love with Miranda Tarkington.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Again.")]), _vm._v(" "), _c('p', {
    staticClass: "normal-1"
  }, [_vm._v("From "), _c('i', [_vm._v("The New York Times")]), _vm._v(", August 18, 1991:")]), _vm._v(" "), _c('p', {
    staticClass: "section1"
  }, [_c('span', [_vm._v("87 KILLED, HUNDREDS INJURED AT EAST ST. LOUIS ROCK EVENT")])]), _vm._v(" "), _c('p', {
    staticClass: "section2"
  }, [_c('span', [_vm._v("Many Listed as Critical After Fans Storm Stadium Entrance")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("East St. Louis, Ill., Aug. 17—At least 87 people, most of them teenagers, lay dead last night as thousands of screaming fans stormed a single narrow entrance to the Riverside Stadium in this impoverished and predominantly black city to hear a concert by the Hot Jockers, a popular heavy metal rock group. At least 300 others were admitted to local hospitals with injuries, many of them critical. The basement of the A.M.E. Church here was turned into a temporary morgue, as distraught families stood in long lines to identify their dead.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The concert, scheduled for 8 P.M. yesterday evening, was sold out, according to its promoter, Milton Prokesch, 47, and thousands of young people had gathered outside the stadium waiting to get inside. When, by 8:15, the gates failed to open, the crowd grew noticeably restless, and police officers with nightsticks attempted to restore order. And when, inexplicably, only one of the twelve gates was unlocked at 8:25, the crowd of impatient fans rushed toward this single entrance, less than ten feet wide. In the ensuing stampede, many young people were crushed to death under the feet of others, while still others appeared to have died from suffocation. By the time order was restored, many trampled and mangled bodies had literally to be scraped off the surrounding streets and sidewalks, and at least one mother, Mrs. Lula Barner, 26, was only able to identify her teenage son by the color of the sneakers he was wearing. A full list of the deceased is as yet incomplete.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The seating capacity of the stadium is 70,000, but police estimated the crowd outside was considerably larger than this. It is speculated that many of the rock group’s fans intended to hear the concert from outside the open-air arena, though many of the dead still clutched valid tickets in their hands. East St. Louis Fire Commissioner Julio G. Gomez, 56, insisted today that the event could not have been oversold. “This office regulates these matters very carefully,” Commissioner Gomez stated. “We were on top of the situation in every sense of the word. What happened here last night certainly should not have happened, but it did. It is too bad, but no one is really to blame. It was more like an act of God.”")]), _vm._v(" "), _c('p', {
    staticClass: "section3"
  }, [_c('span', [_c('i', [_vm._v("“Kids’ Own Fault”")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Commissioner Gomez did suggest, however, that the use of alcohol and drugs might have been a contributing factor to the slaughter. While drugs and alcohol are prohibited within the stadium proper, “There is no way of controlling the use of these substances outside the gates,” he said. Arriving quickly at the scene of the carnage, Commissioner Gomez pointed to the numbers of crushed beer cans, broken bottles, and at least one shattered hypodermic syringe that lay among the corpses and the bodies of the injured. “There’s your villain,” he announced, brandishing the twisted needle for photographers. “The kids like to get high before these concerts. When they get high on a controlled substance, they tend to act in an irrational and antisocial manner. In some ways, this was those kids’ own fault. This department expresses sympathy to their nearest and dearest.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The concert’s promoter, Mr. Prokesch, conceded that the concert may have been overbooked “by one or two seats.” This, he said, is customary procedure, “just as our finest and safest airline companies deliberately overbook seats,” to allow for no-shows. He added that seating at the concert was so-called festival style, a common arrangement at such events, whereby the best seats are available on a first-come basis. When the doors open, there is often a sudden surge on the audience’s part for the seats closest to the stage and the performers.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("As to why only one of twelve gates was unlocked to admit a capacity audience, Mr. Prokesch had no explanation. “You’ll have to ask the stadium’s management about that one,” he said. “All I do is hire the hall. I wasn’t even at the stadium when it happened. I was having dinner in my hotel suite across the river. I first learned about it on television.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The stadium is owned by the City of East St. Louis but is managed by a concessionaire, Halcyon Entertainments, Inc. Calls to Halcyon Entertainments were referred to the office of East St. Louis Mayor Clarence M. Thomas, who is no relation to the Supreme Court nominee, and calls to Mayor Thomas’s office were referred to Fire Commissioner Gomez.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Meanwhile, Sonny Lemontina, 21, the Hot Jockers’ lead guitarist, said he and his group, still backstage when the mob first surged toward the stadium entrance, were unaware that anything unusual was taking place. The sounds of police and ambulance sirens rushing to the scene and the screams of the injured and dying were apparently drowned out by the group’s own amplifiers, and the group itself did not learn of the tragedy until after their performance ended. “I thought we just had your normal, happy audience,” Mr. Lemontina said. “They gave us three encores. We’re all real, real sorry that there were people got killed.”")])])])
}]}

/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(116),
  /* template */
  __webpack_require__(117),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 116 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 117 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(119),
  /* template */
  __webpack_require__(120),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 119 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 120 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(122),
  /* template */
  __webpack_require__(123),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 122 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 123 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(125),
  /* template */
  __webpack_require__(126),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 125 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 126 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(128),
  /* template */
  __webpack_require__(129),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 128 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 129 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(131),
  /* template */
  __webpack_require__(132),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 131 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 132 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(134),
  /* template */
  __webpack_require__(135),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 134 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 135 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 136 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(137),
  /* template */
  __webpack_require__(138),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 137 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 138 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 139 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(140),
  /* template */
  __webpack_require__(141),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 140 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 141 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 142 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(143),
  /* template */
  __webpack_require__(144),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 143 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 144 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 145 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(146),
  /* template */
  __webpack_require__(147),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 146 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 147 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 148 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(149),
  /* template */
  __webpack_require__(150),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 149 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 150 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 151 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(152),
  /* template */
  __webpack_require__(153),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 152 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 153 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 154 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(155),
  /* template */
  __webpack_require__(156),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 155 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 156 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 157 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(158),
  /* template */
  __webpack_require__(159),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 158 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 159 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 160 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(161),
  /* template */
  __webpack_require__(162),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 161 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 162 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 163 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(164),
  /* template */
  __webpack_require__(165),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 164 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 165 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 166 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(167),
  /* template */
  __webpack_require__(168),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 167 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 168 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 169 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(170),
  /* template */
  __webpack_require__(171),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 170 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 171 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 172 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(173),
  /* template */
  __webpack_require__(174),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 173 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 174 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 175 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(176),
  /* template */
  __webpack_require__(177),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 176 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 177 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 178 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(179),
  /* template */
  __webpack_require__(180),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 179 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 180 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 181 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(182),
  /* template */
  __webpack_require__(183),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 182 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 183 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 184 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(185),
  /* template */
  __webpack_require__(186),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 185 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 186 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 187 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(188),
  /* template */
  __webpack_require__(189),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 188 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 189 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 190 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(191),
  /* template */
  __webpack_require__(192),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 191 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 192 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 193 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(194),
  /* template */
  __webpack_require__(195),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 194 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 195 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 196 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(197),
  /* template */
  __webpack_require__(198),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 197 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 198 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 199 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(200),
  /* template */
  __webpack_require__(201),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 200 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 201 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 202 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(203),
  /* template */
  __webpack_require__(204),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 203 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 204 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 205 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(206),
  /* template */
  __webpack_require__(207),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 206 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 207 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 208 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(209),
  /* template */
  __webpack_require__(210),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 209 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 210 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 211 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(212),
  /* template */
  __webpack_require__(213),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 212 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 213 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 214 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(215),
  /* template */
  __webpack_require__(216),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 215 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 216 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 217 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(218),
  /* template */
  __webpack_require__(219),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 218 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 219 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 220 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(221),
  /* template */
  __webpack_require__(222),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 221 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 222 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 223 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(224),
  /* template */
  __webpack_require__(225),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 224 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 225 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 226 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(227),
  /* template */
  __webpack_require__(228),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 227 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 228 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 229 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(230),
  /* template */
  __webpack_require__(231),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 230 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 231 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 232 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(233),
  /* template */
  __webpack_require__(234),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 233 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 234 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 235 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(236),
  /* template */
  __webpack_require__(237),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 236 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 237 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 238 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(239),
  /* template */
  __webpack_require__(240),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 239 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 240 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 241 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(242),
  /* template */
  __webpack_require__(243),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 242 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 243 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 244 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(245),
  /* template */
  __webpack_require__(246),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 245 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 246 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 247 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(248),
  /* template */
  __webpack_require__(249),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 248 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 249 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 250 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(251),
  /* template */
  __webpack_require__(252),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 251 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 252 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 253 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(254),
  /* template */
  __webpack_require__(255),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 254 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 255 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 256 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(257),
  /* template */
  __webpack_require__(258),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 257 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 258 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 259 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(260),
  /* template */
  __webpack_require__(261),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 260 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 261 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 262 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(263),
  /* template */
  __webpack_require__(264),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 263 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 264 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 265 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(266),
  /* template */
  __webpack_require__(267),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 266 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 267 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 268 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(269),
  /* template */
  __webpack_require__(270),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 269 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 270 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 271 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(272),
  /* template */
  __webpack_require__(273),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 272 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 273 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 274 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(275),
  /* template */
  __webpack_require__(276),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 275 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 276 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 277 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(278),
  /* template */
  __webpack_require__(279),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 278 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 279 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 280 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(281),
  /* template */
  __webpack_require__(282),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 281 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 282 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 283 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(284),
  /* template */
  __webpack_require__(285),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 284 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 285 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 286 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(287),
  /* template */
  __webpack_require__(288),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 287 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 288 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 289 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(290),
  /* template */
  __webpack_require__(291),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 290 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 291 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 292 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(293),
  /* template */
  __webpack_require__(294),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 293 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 294 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 295 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(296),
  /* template */
  __webpack_require__(297),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 296 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 297 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 298 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(299),
  /* template */
  __webpack_require__(300),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 299 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 300 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 301 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(302),
  /* template */
  __webpack_require__(303),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 302 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 303 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 304 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(305),
  /* template */
  __webpack_require__(306),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 305 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 306 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 307 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(308),
  /* template */
  __webpack_require__(309),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 308 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 309 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 310 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(311),
  /* template */
  __webpack_require__(312),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 311 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 312 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 313 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(314),
  /* template */
  __webpack_require__(315),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 314 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 315 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 316 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(317),
  /* template */
  __webpack_require__(318),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 317 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 318 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 319 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(320),
  /* template */
  __webpack_require__(321),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 320 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 321 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 322 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(323),
  /* template */
  __webpack_require__(324),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 323 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 324 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 325 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(326),
  /* template */
  __webpack_require__(327),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 326 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 327 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 328 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(329),
  /* template */
  __webpack_require__(330),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 329 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 330 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 331 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(332),
  /* template */
  __webpack_require__(333),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 332 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 333 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 334 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(335),
  /* template */
  __webpack_require__(336),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 335 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 336 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 337 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(338),
  /* template */
  __webpack_require__(339),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 338 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 339 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 340 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(341),
  /* template */
  __webpack_require__(342),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 341 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 342 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 343 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(344),
  /* template */
  __webpack_require__(345),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 344 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 345 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 346 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(347),
  /* template */
  __webpack_require__(348),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 347 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 348 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 349 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(350),
  /* template */
  __webpack_require__(351),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 350 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 351 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 352 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(353),
  /* template */
  __webpack_require__(354),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 353 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 354 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 355 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(356),
  /* template */
  __webpack_require__(357),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 356 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 357 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 358 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(359),
  /* template */
  __webpack_require__(360),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 359 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 360 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 361 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(362),
  /* template */
  __webpack_require__(363),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 362 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 363 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 364 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(365),
  /* template */
  __webpack_require__(366),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 365 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 366 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 367 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(368),
  /* template */
  __webpack_require__(369),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 368 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 369 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 370 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(371),
  /* template */
  __webpack_require__(372),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 371 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 372 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 373 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(374),
  /* template */
  __webpack_require__(375),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 374 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 375 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 376 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(377),
  /* template */
  __webpack_require__(378),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 377 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 378 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 379 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(380),
  /* template */
  __webpack_require__(381),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 380 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 381 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 382 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(383),
  /* template */
  __webpack_require__(384),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 383 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 384 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 385 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(386),
  /* template */
  __webpack_require__(387),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 386 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 387 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 388 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(389),
  /* template */
  __webpack_require__(390),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 389 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 390 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 391 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(392),
  /* template */
  __webpack_require__(393),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 392 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 393 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 394 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(395),
  /* template */
  __webpack_require__(396),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 395 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 396 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 397 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(398),
  /* template */
  __webpack_require__(399),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 398 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 399 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 400 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(401),
  /* template */
  __webpack_require__(402),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 401 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 402 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 403 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(404),
  /* template */
  __webpack_require__(405),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 404 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 405 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 406 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(407),
  /* template */
  __webpack_require__(408),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 407 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 408 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 409 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(410),
  /* template */
  __webpack_require__(411),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 410 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 411 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 412 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(413),
  /* template */
  __webpack_require__(414),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 413 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 414 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 415 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(416),
  /* template */
  __webpack_require__(417),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 416 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 417 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 418 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(419),
  /* template */
  __webpack_require__(420),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 419 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 420 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 421 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(422),
  /* template */
  __webpack_require__(423),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 422 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 423 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 424 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(425),
  /* template */
  __webpack_require__(426),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 425 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 426 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 427 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(428),
  /* template */
  __webpack_require__(429),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 428 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 429 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 430 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(431),
  /* template */
  __webpack_require__(432),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 431 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 432 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 433 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(434),
  /* template */
  __webpack_require__(435),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 434 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 435 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 436 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(437),
  /* template */
  __webpack_require__(438),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 437 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 438 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 439 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(440),
  /* template */
  __webpack_require__(441),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 440 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 441 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 442 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(443),
  /* template */
  __webpack_require__(444),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 443 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 444 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 445 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(446),
  /* template */
  __webpack_require__(447),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 446 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 447 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 448 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(449),
  /* template */
  __webpack_require__(450),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 449 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 450 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 451 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(452),
  /* template */
  __webpack_require__(453),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 452 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 453 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 454 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(455),
  /* template */
  __webpack_require__(456),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 455 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 456 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 457 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(458),
  /* template */
  __webpack_require__(459),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 458 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 459 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 460 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(461),
  /* template */
  __webpack_require__(462),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 461 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 462 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 463 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(464),
  /* template */
  __webpack_require__(465),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 464 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 465 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 466 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(467),
  /* template */
  __webpack_require__(468),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 467 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 468 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 469 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(470),
  /* template */
  __webpack_require__(471),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 470 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 471 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 472 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(473),
  /* template */
  __webpack_require__(474),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 473 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 474 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 475 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(476),
  /* template */
  __webpack_require__(477),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 476 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 477 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 478 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(479),
  /* template */
  __webpack_require__(480),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 479 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 480 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 481 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(482),
  /* template */
  __webpack_require__(483),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 482 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 483 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 484 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(485),
  /* template */
  __webpack_require__(486),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 485 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 486 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 487 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(488),
  /* template */
  __webpack_require__(489),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 488 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 489 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 490 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(491),
  /* template */
  __webpack_require__(492),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 491 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 492 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 493 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(494),
  /* template */
  __webpack_require__(495),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 494 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 495 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 496 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(497),
  /* template */
  __webpack_require__(498),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 497 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 498 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 499 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(500),
  /* template */
  __webpack_require__(501),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 500 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 501 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 502 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(503),
  /* template */
  __webpack_require__(504),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 503 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 504 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 505 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(506),
  /* template */
  __webpack_require__(507),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 506 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 507 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 508 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(509),
  /* template */
  __webpack_require__(510),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 509 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 510 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 511 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(512),
  /* template */
  __webpack_require__(513),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 512 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 513 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 514 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(515),
  /* template */
  __webpack_require__(516),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 515 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 516 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 517 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(518),
  /* template */
  __webpack_require__(519),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 518 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 519 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 520 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(521),
  /* template */
  __webpack_require__(522),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 521 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 522 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 523 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(524),
  /* template */
  __webpack_require__(525),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 524 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 525 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('p', [_vm._v("Thank you for reading this sample. Here are other books you might like.")]), _c('div', [_c('div', {
    attrs: {
      "id": "textcafe-gallery-widget-container"
    }
  }), _vm._v(" "), _c('script', {
    attrs: {
      "type": "application/javascript"
    }
  }, [_vm._v("\n      TextCafeWidget.config({\n          'type':'related',\n          'id':'9781504047999',\n          'coverImageWidth': '30',\n          'hideDescriptions': true\n      });\n      var textCafeGalleryWidget = TextCafeWidget.widgets.galleryWidget.new({selector:'#textcafe-gallery-widget-container'});\n      textCafeGalleryWidget.render();\n    ")])])])
}]}

/***/ }),
/* 526 */
/***/ (function(module, exports, __webpack_require__) {

(function webpackUniversalModuleDefinition(root, factory) {
	if(true)
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["Vuetify"] = factory();
	else
		root["Vuetify"] = factory();
})(this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/dist/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 29);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["d"] = createSimpleFunctional;
/* harmony export (immutable) */ __webpack_exports__["e"] = createSimpleTransition;
/* harmony export (immutable) */ __webpack_exports__["b"] = createJavaScriptTransition;
/* harmony export (immutable) */ __webpack_exports__["f"] = directiveConfig;
/* harmony export (immutable) */ __webpack_exports__["a"] = addOnceEventListener;
/* harmony export (immutable) */ __webpack_exports__["g"] = getObjectValueByPath;
/* harmony export (immutable) */ __webpack_exports__["c"] = createRange;
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function createSimpleFunctional(c) {
  var el = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'div';

  return {
    functional: true,

    render: function render(h, _ref) {
      var data = _ref.data,
          children = _ref.children;

      data.staticClass = (c + ' ' + (data.staticClass || '')).trim();

      return h(el, data, children);
    }
  };
}

function createSimpleTransition(name) {
  var origin = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'top center 0';
  var mode = arguments[2];

  return {
    functional: true,

    props: {
      origin: {
        type: String,
        default: origin
      }
    },

    render: function render(h, context) {
      context.data = context.data || {};
      context.data.props = { name: name };
      context.data.on = context.data.on || {};

      if (mode) context.data.props.mode = mode;

      context.data.on.beforeEnter = function (el) {
        el.style.transformOrigin = origin;
        el.style.webkitTransformOrigin = origin;
      };

      return h('transition', context.data, context.children);
    }
  };
}

function createJavaScriptTransition(name, functions) {
  var css = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  var mode = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'in-out';

  return {
    functional: true,

    props: {
      css: {
        type: Boolean,
        default: css
      },
      mode: {
        type: String,
        default: mode
      }
    },

    render: function render(h, context) {
      var data = {
        props: _extends({}, context.props, {
          name: name
        }),
        on: functions
      };

      return h('transition', data, context.children);
    }
  };
}

function directiveConfig(binding) {
  var defaults = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return Object.assign({}, defaults, binding.modifiers, { value: binding.arg }, binding.value || {});
}

function addOnceEventListener(el, event, cb) {
  var once = function once() {
    cb();
    el.removeEventListener(event, once, false);
  };

  el.addEventListener(event, once, false);
}

function getObjectValueByPath(obj, path) {
  // credit: http://stackoverflow.com/questions/6491463/accessing-nested-javascript-objects-with-string-key#comment55278413_6491621
  if (!path || path.constructor !== String) return;
  path = path.replace(/\[(\w+)\]/g, '.$1'); // convert indexes to properties
  path = path.replace(/^\./, ''); // strip a leading dot
  var a = path.split('.');
  for (var i = 0, n = a.length; i < n; ++i) {
    var k = a[i];
    if (obj instanceof Object && k in obj) {
      obj = obj[k];
    } else {
      return;
    }
  }
  return obj;
}

function createRange(length) {
  return [].concat(_toConsumableArray(Array.from({ length: length }, function (v, k) {
    return k;
  })));
}

/***/ }),
/* 1 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    dark: Boolean,
    light: Boolean
  }
});

/***/ }),
/* 2 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      isActive: !!this.value
    };
  },


  props: {
    value: {
      required: false
    }
  },

  watch: {
    value: function value(val) {
      this.isActive = !!val;
    },
    isActive: function isActive(val) {
      !!val !== this.value && this.$emit('input', val);
    }
  }
});

/***/ }),
/* 3 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_contextualable__ = __webpack_require__(8);



/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_contextualable__["a" /* default */]],

  props: {
    disabled: Boolean,
    fa: Boolean,
    mdi: Boolean,
    large: Boolean,
    left: Boolean,
    medium: Boolean,
    right: Boolean,
    xLarge: Boolean
  },

  render: function render(h, _ref) {
    var props = _ref.props,
        data = _ref.data,
        _ref$children = _ref.children,
        children = _ref$children === undefined ? [] : _ref$children;

    if (props.fa || props.mdi) console.warn('The v-icon prop \'fa\' and \'mdi\' will be deprecated in the next release. Use \'fa\' or \'mdi\' prefix in icon name instead.');
    var iconName = '';
    var iconType = 'material-icons';

    if (children.length) {
      iconName = children.pop().text;
    } else if (data.domProps && data.domProps.textContent) {
      iconName = data.domProps.textContent;
      delete data.domProps.textContent;
    } else if (data.domProps && data.domProps.innerHTML) {
      iconName = data.domProps.innerHTML;
      delete data.domProps.innerHTML;
    }

    var thirdPartyIcon = iconName.indexOf('-') > -1;
    if (thirdPartyIcon) iconType = iconName.slice(0, iconName.indexOf('-'));

    // To keep things backwards compatible for now
    iconType = props.fa ? 'fa' : props.mdi ? 'mdi' : iconType;

    data.staticClass = (iconType + ' icon ' + (data.staticClass || '')).trim();
    data.attrs = data.attrs || {};

    var classes = {
      'icon--large': props.large,
      'icon--left': props.left,
      'icon--medium': props.medium,
      'icon--right': props.right,
      'icon--x-large': props.xLarge,
      'primary--text': props.primary,
      'secondary--text': props.secondary,
      'success--text': props.success,
      'info--text': props.info,
      'warning--text': props.warning,
      'error--text': props.error,
      'theme--dark': props.dark,
      'theme--light': props.light
    };

    var iconClasses = Object.keys(classes).filter(function (k) {
      return classes[k];
    }).join(' ');
    iconClasses && (data.staticClass += ' ' + iconClasses);

    // To keep things backwards compatible for now
    if (props.fa || props.mdi) {
      var comparison = props.fa ? 'fa' : 'mdi';

      if (iconName.indexOf(' ') > -1) data.staticClass += ' ' + comparison + '-' + iconName;else data.staticClass += ' ' + comparison + '-' + iconName.split(' ').join('-');
    }

    if (thirdPartyIcon) data.staticClass += ' ' + iconName;
    if (props.disabled) data.attrs.disabled = props.disabled;
    !(thirdPartyIcon || props.fa || props.mdi) && children.push(iconName);

    return h('i', data, children);
  }
});

/***/ }),
/* 4 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__badge__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__click_outside__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__resize__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ripple__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__scroll__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__tooltip__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__touch__ = __webpack_require__(81);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Badge", function() { return __WEBPACK_IMPORTED_MODULE_0__badge__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "ClickOutside", function() { return __WEBPACK_IMPORTED_MODULE_1__click_outside__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Ripple", function() { return __WEBPACK_IMPORTED_MODULE_3__ripple__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Resize", function() { return __WEBPACK_IMPORTED_MODULE_2__resize__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Scroll", function() { return __WEBPACK_IMPORTED_MODULE_4__scroll__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Tooltip", function() { return __WEBPACK_IMPORTED_MODULE_5__tooltip__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Touch", function() { return __WEBPACK_IMPORTED_MODULE_6__touch__["a"]; });










/***/ }),
/* 5 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_contextualable__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_positionable__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_route_link__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_themeable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_toggleable__ = __webpack_require__(2);






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-btn',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_contextualable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_route_link__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_positionable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_themeable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__mixins_toggleable__["a" /* default */]],

  props: {
    activeClass: {
      type: String,
      default: 'btn--active'
    },
    block: Boolean,
    fab: Boolean,
    flat: Boolean,
    icon: Boolean,
    large: Boolean,
    loading: Boolean,
    outline: Boolean,
    ripple: {
      type: [Boolean, Object],
      default: true
    },
    round: Boolean,
    small: Boolean,
    tag: {
      type: String,
      default: 'button'
    },
    type: {
      type: String,
      default: 'button'
    }
  },

  computed: {
    classes: function classes() {
      return {
        'btn': true,
        'btn--absolute': this.absolute,
        'btn--active': this.isActive,
        'btn--block': this.block,
        'btn--bottom': this.bottom,
        'btn--disabled': this.disabled,
        'btn--flat': this.flat,
        'btn--floating': this.fab,
        'btn--fixed': this.fixed,
        'btn--hover': this.hover,
        'btn--icon': this.icon,
        'btn--large': this.large,
        'btn--left': this.left,
        'btn--loader': this.loading,
        'btn--outline': this.outline,
        'btn--raised': !this.flat,
        'btn--right': this.right,
        'btn--round': this.round,
        'btn--small': this.small,
        'btn--top': this.top,
        'theme--dark': this.dark,
        'theme--light': this.light,
        'primary': this.primary && !this.outline,
        'secondary': this.secondary && !this.outline,
        'success': this.success && !this.outline,
        'info': this.info && !this.outline,
        'warning': this.warning && !this.outline,
        'error': this.error && !this.outline,
        'primary--text': this.primary && (this.outline || this.flat),
        'secondary--text': this.secondary && (this.outline || this.flat),
        'success--text': this.success && (this.outline || this.flat),
        'info--text': this.info && (this.outline || this.flat),
        'warning--text': this.warning && (this.outline || this.flat),
        'error--text': this.error && (this.outline || this.flat)
      };
    }
  },

  methods: {
    // Prevent focus to match md spec
    click: function click(e) {
      !this.fab && e.detail && this.$el.blur();

      this.$emit('click', e);
    },
    genContent: function genContent() {
      return this.$createElement('div', { 'class': 'btn__content' }, [this.$slots.default]);
    },
    genLoader: function genLoader() {
      var children = [];

      if (!this.$slots.loader) {
        children.push(this.$createElement('v-progress-circular', {
          props: {
            indeterminate: true,
            size: 26
          }
        }));
      } else {
        children.push(this.$slots.loader);
      }

      return this.$createElement('span', { 'class': 'btn__loading' }, children);
    }
  },

  render: function render(h) {
    var _generateRouteLink = this.generateRouteLink(),
        tag = _generateRouteLink.tag,
        data = _generateRouteLink.data;

    var children = [this.genContent()];

    tag === 'button' && (data.attrs.type = this.type);
    this.loading && children.push(this.genLoader());

    return h(tag, data, children);
  }
});

/***/ }),
/* 6 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export VCarouselTransition */
/* unused harmony export VCarouselReverseTransition */
/* unused harmony export VTabTransition */
/* unused harmony export VTabReverseTransition */
/* unused harmony export VMenuTransition */
/* unused harmony export VFabTransition */
/* unused harmony export VDialogTransition */
/* unused harmony export VDialogBottomTransition */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return VFadeTransition; });
/* unused harmony export VScaleTransition */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return VSlideXTransition; });
/* unused harmony export VSlideXReverseTransition */
/* unused harmony export VSlideYTransition */
/* unused harmony export VSlideYReverseTransition */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return VExpandTransition; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__expand_transition__ = __webpack_require__(71);




// Component specific transitions
var VCarouselTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('carousel-transition');
var VCarouselReverseTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('carousel-reverse-transition');
var VTabTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('tab-transition');
var VTabReverseTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('tab-reverse-transition');
var VMenuTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('menu-transition');
var VFabTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('fab-transition', 'center center', 'out-in');

// Generic transitions
var VDialogTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('dialog-transition');
var VDialogBottomTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('dialog-bottom-transition');
var VFadeTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('fade-transition');
var VScaleTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('scale-transition');
var VSlideXTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('slide-x-transition');
var VSlideXReverseTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('slide-x-reverse-transition');
var VSlideYTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('slide-y-transition');
var VSlideYReverseTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('slide-y-reverse-transition');

// JavaScript transitions
var VExpandTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["b" /* createJavaScriptTransition */])('expand-transition', __WEBPACK_IMPORTED_MODULE_1__expand_transition__["a" /* default */]);

/* harmony default export */ __webpack_exports__["d"] = ({
  VCarouselTransition: VCarouselTransition,
  VCarouselReverseTransition: VCarouselReverseTransition,
  VDialogTransition: VDialogTransition,
  VDialogBottomTransition: VDialogBottomTransition,
  VFabTransition: VFabTransition,
  VFadeTransition: VFadeTransition,
  VMenuTransition: VMenuTransition,
  VScaleTransition: VScaleTransition,
  VSlideXTransition: VSlideXTransition,
  VSlideXReverseTransition: VSlideXReverseTransition,
  VSlideYTransition: VSlideYTransition,
  VSlideYReverseTransition: VSlideYReverseTransition,
  VTabReverseTransition: VTabReverseTransition,
  VTabTransition: VTabTransition,
  VExpandTransition: VExpandTransition
});

/***/ }),
/* 7 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__themeable__ = __webpack_require__(1);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }



/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_0__themeable__["a" /* default */]],

  data: function data() {
    return {
      errorBucket: [],
      focused: false,
      tabFocused: false,
      lazyValue: this.value
    };
  },


  props: {
    appendIcon: String,
    appendIconCb: Function,
    disabled: Boolean,
    error: Boolean,
    errorMessages: {
      type: [String, Array],
      default: function _default() {
        return [];
      }
    },
    hint: String,
    hideDetails: Boolean,
    label: String,
    persistentHint: Boolean,
    placeholder: String,
    prependIcon: String,
    prependIconCb: Function,
    required: Boolean,
    rules: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    tabindex: {
      default: 0
    },
    value: {
      required: false
    }
  },

  computed: {
    hasError: function hasError() {
      return this.validations.length || this.error;
    },
    inputGroupClasses: function inputGroupClasses() {
      return Object.assign({
        'input-group': true,
        'input-group--focused': this.focused,
        'input-group--dirty': this.isDirty,
        'input-group--tab-focused': this.tabFocused,
        'input-group--disabled': this.disabled,
        'input-group--error': this.hasError,
        'input-group--append-icon': this.appendIcon,
        'input-group--prepend-icon': this.prependIcon,
        'input-group--required': this.required,
        'input-group--hide-details': this.hideDetails,
        'input-group--placeholder': !!this.placeholder,
        'theme--dark': this.dark,
        'theme--light': this.light
      }, this.classes);
    },
    isDirty: function isDirty() {
      return this.inputValue;
    },
    modifiers: function modifiers() {
      var modifiers = {
        lazy: false,
        number: false,
        trim: false
      };

      if (!this.$vnode.data.directives) {
        return modifiers;
      }

      var model = this.$vnode.data.directives.find(function (i) {
        return i.name === 'model';
      });

      if (!model) {
        return modifiers;
      }

      return Object.assign(modifiers, model.modifiers);
    },
    validations: function validations() {
      return (!Array.isArray(this.errorMessages) ? [this.errorMessages] : this.errorMessages).concat(this.errorBucket);
    }
  },

  watch: {
    rules: function rules() {
      this.validate();
    }
  },

  mounted: function mounted() {
    this.validate();
  },


  methods: {
    genLabel: function genLabel() {
      return this.$createElement('label', {
        attrs: {
          for: this.$attrs.id
        }
      }, this.$slots.label || this.label);
    },
    genMessages: function genMessages() {
      var _this = this;

      var messages = [];

      if ((this.hint && this.focused || this.hint && this.persistentHint) && this.validations.length === 0) {
        messages = [this.genHint()];
      } else if (this.validations.length) {
        messages = this.validations.map(function (i) {
          return _this.genError(i);
        });
      }

      return this.$createElement('transition-group', {
        'class': 'input-group__messages',
        props: {
          tag: 'div',
          name: 'slide-y-transition'
        }
      }, messages);
    },
    genHint: function genHint() {
      return this.$createElement('div', {
        'class': 'input-group__hint',
        key: this.hint,
        domProps: { innerHTML: this.hint }
      });
    },
    genError: function genError(error) {
      return this.$createElement('div', {
        'class': 'input-group__error',
        key: error
      }, error);
    },
    genIcon: function genIcon(type) {
      var _class;

      var icon = this[type + 'Icon'];
      var cb = this[type + 'IconCb'];
      var hasCallback = typeof cb === 'function';

      return this.$createElement('v-icon', {
        'class': (_class = {}, _defineProperty(_class, 'input-group__' + type + '-icon', true), _defineProperty(_class, 'input-group__icon-cb', hasCallback), _class),
        on: {
          click: function click(e) {
            hasCallback && cb(e);
          }
        }
      }, icon);
    },
    genInputGroup: function genInputGroup(input) {
      var _this2 = this;

      var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      var children = [];
      var wrapperChildren = [];
      var detailsChildren = [];

      data = Object.assign({}, {
        'class': this.inputGroupClasses,
        attrs: {
          tabindex: this.tabindex
        },
        on: {
          blur: function blur() {
            return _this2.tabFocused = false;
          },
          click: function click() {
            return _this2.tabFocused = false;
          },
          keyup: function keyup(e) {
            if ([9, 16].includes(e.keyCode)) {
              _this2.tabFocused = true;
            }
          },
          keydown: function keydown(e) {
            if (!_this2.toggle) return;

            if ([13, 32].includes(e.keyCode)) {
              e.preventDefault();
              _this2.toggle();
            }
          }
        }
      }, data);

      if (this.$slots.label || this.label) {
        children.push(this.genLabel());
      }

      wrapperChildren.push(input);

      if (this.prependIcon) {
        wrapperChildren.unshift(this.genIcon('prepend'));
      }

      if (this.appendIcon) {
        wrapperChildren.push(this.genIcon('append'));
      }

      children.push(this.$createElement('div', {
        'class': 'input-group__input'
      }, wrapperChildren));

      detailsChildren.push(this.genMessages());
      this.counter && detailsChildren.push(this.genCounter());

      children.push(this.$createElement('div', {
        'class': 'input-group__details'
      }, detailsChildren));

      return this.$createElement('div', data, children);
    },
    validate: function validate() {
      var _this3 = this;

      this.errorBucket = [];

      this.rules.forEach(function (rule) {
        var valid = typeof rule === 'function' ? rule(_this3.value) : rule;

        if (valid !== true) {
          _this3.errorBucket.push(valid);
        }
      });
    }
  }
});

/***/ }),
/* 8 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    primary: Boolean,
    secondary: Boolean,
    success: Boolean,
    info: Boolean,
    warning: Boolean,
    error: Boolean
  }
});

/***/ }),
/* 9 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    append: Boolean,
    disabled: Boolean,
    exact: Boolean,
    href: [String, Object],
    to: [String, Object],
    nuxt: Boolean,
    replace: Boolean,
    router: Boolean,
    ripple: {
      type: Boolean,
      default: true
    },
    tag: String
  },

  methods: {
    click: function click() {},
    generateRouteLink: function generateRouteLink() {
      var exact = this.exact;
      var tag = void 0;

      var data = {
        attrs: { disabled: this.disabled },
        class: this.classes,
        props: {},
        directives: [{
          name: 'ripple',
          value: this.ripple || false
        }],
        on: Object.assign({
          click: this.click
        }, this.$listeners || {})
      };

      if (typeof this.exact === 'undefined') {
        exact = this.to === '/' || this.to === Object(this.to) && this.to.path === '/';
      }

      if (this.to) {
        tag = this.nuxt ? 'nuxt-link' : 'router-link';
        data.props.to = this.to;
        data.props.exact = exact;
        data.props.activeClass = this.activeClass;
        data.props.append = this.append;
        data.props.replace = this.replace;
      } else {
        tag = this.href && 'a' || this.tag || 'a';

        if (tag === 'a') {
          data.attrs.href = this.href || 'javascript:;';
        }
      }

      return { tag: tag, data: data };
    }
  }
});

/***/ }),
/* 10 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      isBooted: false
    };
  },


  watch: {
    isActive: function isActive() {
      this.isBooted = true;
    }
  },

  methods: {
    showLazyContent: function showLazyContent(content) {
      return this.lazy && this.isBooted || !this.lazy ? content : null;
    }
  }
});

/***/ }),
/* 11 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export VListTileActionText */
/* unused harmony export VListTileAvatar */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return VListTileContent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return VListTileTitle; });
/* unused harmony export VListTileSubTitle */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VList__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VListGroup__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__VListTile__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__VListTileAction__ = __webpack_require__(21);







var VListTileActionText = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('list__tile__action-text', 'span');
var VListTileAvatar = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('list__tile__avatar', 'v-avatar');
var VListTileContent = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('list__tile__content', 'div');
var VListTileTitle = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('list__tile__title', 'div');
var VListTileSubTitle = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('list__tile__sub-title', 'div');

/* harmony default export */ __webpack_exports__["c"] = ({
  VList: __WEBPACK_IMPORTED_MODULE_1__VList__["a" /* default */],
  VListTile: __WEBPACK_IMPORTED_MODULE_3__VListTile__["a" /* default */],
  VListGroup: __WEBPACK_IMPORTED_MODULE_2__VListGroup__["a" /* default */],
  VListTileAction: __WEBPACK_IMPORTED_MODULE_4__VListTileAction__["a" /* default */],
  VListTileActionText: VListTileActionText,
  VListTileAvatar: VListTileAvatar,
  VListTileContent: VListTileContent,
  VListTileTitle: VListTileTitle,
  VListTileSubTitle: VListTileSubTitle
});

/***/ }),
/* 12 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    absolute: Boolean,
    bottom: Boolean,
    fixed: Boolean,
    left: Boolean,
    right: Boolean,
    top: Boolean
  }
});

/***/ }),
/* 13 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);


/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */]],

  props: {
    flat: Boolean,
    height: {
      type: String,
      default: 'auto'
    },
    hover: Boolean,
    img: String,
    raised: Boolean,
    tile: Boolean
  },

  render: function render(h, _ref) {
    var data = _ref.data,
        props = _ref.props,
        children = _ref.children;

    data.staticClass = ('card ' + (data.staticClass || '')).trim();
    data.style = data.style || {};
    data.style.height = props.height;

    if (props.dark) data.staticClass += ' theme--dark';
    if (props.flat) data.staticClass += ' card--flat';
    if (props.horizontal) data.staticClass += ' card--horizontal';
    if (props.hover) data.staticClass += ' card--hover';
    if (props.light) data.staticClass += ' theme--light';
    if (props.raised) data.staticClass += ' card--raised';
    if (props.tile) data.staticClass += ' card--tile';

    if (props.img) {
      data.style.background = 'url(' + props.img + ') center center / cover no-repeat';
    }

    return h('div', data, children);
  }
});

/***/ }),
/* 14 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      isSaving: false
    };
  },


  props: {
    actions: Boolean,
    autosave: Boolean,
    landscape: Boolean,
    noTitle: Boolean,
    scrollable: Boolean,
    value: {
      required: true
    },
    light: {
      type: Boolean,
      default: true
    },
    dark: Boolean
  },

  methods: {
    save: function save() {},
    cancel: function cancel() {},
    genSlot: function genSlot() {
      return this.$scopedSlots.default({
        save: this.save,
        cancel: this.cancel
      });
    }
  }
});

/***/ }),
/* 15 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    contentClass: {
      default: ''
    }
  },

  mounted: function mounted() {
    var _this = this;

    this.$vuetify.load(function () {
      if (_this._isDestroyed) return;

      var app = document.querySelector('[data-app]');

      if (!app) {
        return console.warn('Application is missing <v-app> component.');
      }

      app.insertBefore(_this.$refs.content, app.firstChild);
    });
  },
  beforeDestroy: function beforeDestroy() {
    if (!this.$refs.content) return;

    // IE11 Fix
    try {
      this.$refs.content.parentNode.removeChild(this.$refs.content);
    } catch (e) {}
  }
});

/***/ }),
/* 16 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      overlay: null,
      overlayOffset: 0,
      overlayTransitionDuration: 500
    };
  },


  props: {
    hideOverlay: Boolean
  },

  beforeDestroy: function beforeDestroy() {
    this.removeOverlay();
  },


  methods: {
    genOverlay: function genOverlay() {
      var _this = this;

      if (!this.isActive || this.hideOverlay || this.isActive && this.overlay) return;

      this.overlay = document.createElement('div');
      this.overlay.className = 'overlay';
      this.overlay.onclick = function () {
        if (_this.permanent) return;else if (!_this.persistent) _this.isActive = false;else if (_this.isMobile) _this.isActive = false;
      };

      if (this.absolute) this.overlay.className += ' overlay--absolute';

      this.hideScroll();

      if (this.absolute) {
        // Required for IE11
        var parent = this.$el.parentNode;
        parent.insertBefore(this.overlay, parent.firstChild);
      } else {
        document.querySelector('[data-app]').appendChild(this.overlay);
      }

      this.overlay.clientHeight; // Force repaint
      requestAnimationFrame(function () {
        _this.overlay.className += ' overlay--active';
      });

      return true;
    },
    removeOverlay: function removeOverlay() {
      var _this2 = this;

      if (!this.overlay) {
        return this.showScroll();
      }

      this.overlay.classList.remove('overlay--active');

      setTimeout(function () {
        // IE11 Fix
        try {
          _this2.overlay.parentNode.removeChild(_this2.overlay);
          _this2.overlay = null;
          _this2.showScroll();
        } catch (e) {}
      }, this.overlayTransitionDuration);
    },
    hideScroll: function hideScroll() {
      // Check documentElement first for IE11
      // this.overlayOffset = document.documentElement &&
      //   document.documentElement.scrollTop ||
      //   document.body.scrollTop

      // document.body.style.top = `-${this.overlayOffset}px`
      // document.body.style.position = 'fixed'
      document.documentElement.style.overflow = 'hidden';
    },
    showScroll: function showScroll() {
      document.documentElement.removeAttribute('style');

      // if (!this.overlayOffset) return
      // document.body.scrollTop = this.overlayOffset
      // document.documentElement.scrollTop = this.overlayOffset
    }
  }
});

/***/ }),
/* 17 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-list',

  provide: function provide() {
    return {
      listClick: this.listClick,
      listClose: this.listClose
    };
  },


  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */]],

  data: function data() {
    return {
      uid: null,
      groups: []
    };
  },


  props: {
    dense: Boolean,
    subheader: Boolean,
    threeLine: Boolean,
    twoLine: Boolean
  },

  computed: {
    classes: function classes() {
      return {
        'list': true,
        'list--two-line': this.twoLine,
        'list--dense': this.dense,
        'list--three-line': this.threeLine,
        'list--subheader': this.subheader,
        'theme--dark dark--bg': this.dark,
        'theme--light light--bg': this.light
      };
    }
  },

  watch: {
    uid: function uid() {
      var _this = this;

      this.$children.filter(function (i) {
        return i.$options._componentTag === 'v-list-group';
      }).forEach(function (i) {
        return i.toggle(_this.uid);
      });
    }
  },

  methods: {
    listClick: function listClick(uid, force) {
      if (force) {
        this.uid = uid;
      } else {
        this.uid = this.uid === uid ? null : uid;
      }
    },
    listClose: function listClose(uid) {
      if (this.uid === uid) {
        this.uid = null;
      }
    }
  },

  render: function render(h) {
    var data = {
      'class': this.classes,
      attrs: { 'data-uid': this._uid }
    };

    return h('ul', data, [this.$slots.default]);
  }
});

/***/ }),
/* 18 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_route_link__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__directives__ = __webpack_require__(4);




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-list-tile',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_route_link__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__["a" /* default */]],

  directives: {
    Ripple: __WEBPACK_IMPORTED_MODULE_2__directives__["Ripple"]
  },

  inheritAttrs: false,

  props: {
    activeClass: {
      type: String,
      default: 'list__tile--active'
    },
    avatar: Boolean
  },

  computed: {
    classes: function classes() {
      return {
        'list__tile': true,
        'list__tile--avatar': this.avatar,
        'list__tile--disabled': this.disabled
      };
    }
  },

  render: function render(h) {
    var _generateRouteLink = this.generateRouteLink(),
        tag = _generateRouteLink.tag,
        data = _generateRouteLink.data;

    data.attrs = Object.assign({}, data.attrs, this.$attrs);

    return h('li', {
      attrs: {
        disabled: this.disabled
      }
    }, [h(tag, data, [this.$slots.default])]);
  }
});

/***/ }),
/* 19 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function directive(e, el, binding, v) {
  var cb = function cb() {
    return true;
  };

  if (binding.value) cb = binding.value;

  if (v.context.isActive && e && e.target && e.target !== el && !el.contains(e.target) && cb(e)) {
    v.context.isActive = false;
  }
}

/* harmony default export */ __webpack_exports__["a"] = ({
  bind: function bind(el, binding, v) {
    v.context.$vuetify.load(function () {
      var outside = document.querySelector('[data-app]');
      var click = function click(e) {
        return directive(e, el, binding, v);
      };
      outside.addEventListener('click', click, false);
      el._clickOutside = click;
    });
  },
  unbind: function unbind(el) {
    var outside = document.querySelector('[data-app]');
    outside && outside.removeEventListener('click', el._clickOutside, false);
  }
});

/***/ }),
/* 20 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function style(el, value) {
  ['transform', 'webkitTransform'].forEach(function (i) {
    el.style[i] = value;
  });
}

var ripple = {
  show: function show(e, el, _ref) {
    var _ref$value = _ref.value,
        value = _ref$value === undefined ? {} : _ref$value;

    var container = document.createElement('span');
    var animation = document.createElement('span');

    container.appendChild(animation);
    container.className = 'ripple__container';

    if (value.class) {
      container.className += ' ' + value.class;
    }

    var size = el.clientWidth > el.clientHeight ? el.clientWidth : el.clientHeight;
    animation.className = 'ripple__animation';
    animation.style.width = size * (value.center ? 1 : 2) + 'px';
    animation.style.height = animation.style.width;

    el.appendChild(container);
    var computed = window.getComputedStyle(el);
    if (computed.position !== 'absolute' && computed.position !== 'fixed') el.style.position = 'relative';

    var offset = el.getBoundingClientRect();
    var x = value.center ? '50%' : e.clientX - offset.left + 'px';
    var y = value.center ? '50%' : e.clientY - offset.top + 'px';

    animation.classList.add('ripple__animation--enter');
    animation.classList.add('ripple__animation--visible');
    style(animation, 'translate(-50%, -50%) translate(' + x + ', ' + y + ') scale3d(0.01,0.01,0.01)');
    animation.dataset.activated = Date.now();

    setTimeout(function () {
      animation.classList.remove('ripple__animation--enter');
      style(animation, 'translate(-50%, -50%) translate(' + x + ', ' + y + ')  scale3d(0.99,0.99,0.99)');
    }, 0);
  },

  hide: function hide(el) {
    var ripples = el.getElementsByClassName('ripple__animation');

    if (ripples.length === 0) return;
    var animation = ripples[ripples.length - 1];
    var diff = Date.now() - Number(animation.dataset.activated);
    var delay = 400 - diff;

    delay = delay < 0 ? 0 : delay;

    setTimeout(function () {
      animation.classList.remove('ripple__animation--visible');

      setTimeout(function () {
        // Need to figure out a new way to do this
        try {
          if (ripples.length < 1) el.style.position = null;
          animation.parentNode && el.removeChild(animation.parentNode);
        } catch (e) {}
      }, 300);
    }, delay);
  }
};

function directive(el, binding, v) {
  if (binding.value === false) return;

  if ('ontouchstart' in window) {
    el.addEventListener('touchend', function () {
      return ripple.hide(el);
    }, false);
    el.addEventListener('touchcancel', function () {
      return ripple.hide(el);
    }, false);
  }

  el.addEventListener('mousedown', function (e) {
    return ripple.show(e, el, binding);
  }, false);
  el.addEventListener('mouseup', function () {
    return ripple.hide(el);
  }, false);
  el.addEventListener('mouseleave', function () {
    return ripple.hide(el);
  }, false);
}

function unbind(el, binding) {
  el.removeEventListener('touchstart', function (e) {
    return ripple.show(e, el, binding);
  }, false);
  el.removeEventListener('mousedown', function (e) {
    return ripple.show(e, el, binding);
  }, false);
  el.removeEventListener('touchend', function () {
    return ripple.hide(el);
  }, false);
  el.removeEventListener('touchcancel', function () {
    return ripple.hide(el);
  }, false);
  el.removeEventListener('mouseup', function () {
    return ripple.hide(el);
  }, false);
  el.removeEventListener('mouseleave', function () {
    return ripple.hide(el);
  }, false);
}

/* harmony default export */ __webpack_exports__["a"] = ({
  bind: directive,
  unbind: unbind
});

/***/ }),
/* 21 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  name: 'list-tile-action',

  render: function render(h, _ref) {
    var data = _ref.data,
        children = _ref.children;

    data.staticClass = data.staticClass ? 'list__tile__action ' + (data.staticClass || '') : 'list__tile__action';
    if ((children || []).length > 1) data.staticClass += ' list__tile__action--stack';

    return h('div', data, children);
  }
});

/***/ }),
/* 22 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_activator__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_detachable__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_generators__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_position__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_utils__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mixins_toggleable__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__mixins_keyable__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__directives__ = __webpack_require__(4);










/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-menu',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_activator__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_detachable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_generators__["a" /* default */], __WEBPACK_IMPORTED_MODULE_6__mixins_keyable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_position__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__mixins_utils__["a" /* default */], __WEBPACK_IMPORTED_MODULE_5__mixins_toggleable__["a" /* default */]],

  directives: {
    ClickOutside: __WEBPACK_IMPORTED_MODULE_7__directives__["ClickOutside"]
  },

  data: function data() {
    return {
      autoIndex: null,
      dimensions: {
        activator: {
          top: 0, left: 0,
          bottom: 0, right: 0,
          width: 0, height: 0,
          offsetTop: 0, scrollHeight: 0
        },
        content: {
          top: 0, left: 0,
          bottom: 0, right: 0,
          width: 0, height: 0,
          offsetTop: 0, scrollHeight: 0
        },
        list: null,
        selected: null
      },
      direction: { vert: 'bottom', horiz: 'right' },
      isContentActive: false,
      isBooted: false,
      maxHeightAutoDefault: '200px',
      resizeTimeout: {},
      startIndex: 3,
      stopIndex: 0,
      tileLength: 0,
      window: {},
      absoluteX: 0,
      absoluteY: 0,
      hasJustFocused: false,
      focusedTimeout: {}
    };
  },


  props: {
    top: Boolean,
    left: Boolean,
    bottom: Boolean,
    right: Boolean,
    fullWidth: Boolean,
    auto: Boolean,
    offsetX: Boolean,
    offsetY: Boolean,
    disabled: Boolean,
    maxHeight: {
      default: 'auto'
    },
    nudgeTop: {
      type: Number,
      default: 0
    },
    nudgeBottom: {
      type: Number,
      default: 0
    },
    nudgeLeft: {
      type: Number,
      default: 0
    },
    nudgeRight: {
      type: Number,
      default: 0
    },
    nudgeWidth: {
      type: Number,
      default: 0
    },
    openOnClick: {
      type: Boolean,
      default: true
    },
    openOnHover: {
      type: Boolean,
      default: false
    },
    lazy: Boolean,
    closeOnClick: {
      type: Boolean,
      default: true
    },
    closeOnContentClick: {
      type: Boolean,
      default: true
    },
    activator: {
      default: null
    },
    origin: {
      type: String,
      default: 'top left'
    },
    transition: {
      type: String,
      default: 'menu-transition'
    },
    positionX: {
      type: Number,
      default: null
    },
    positionY: {
      type: Number,
      default: null
    },
    positionAbsolutely: {
      type: Boolean,
      default: false
    },
    maxWidth: [Number, String],
    minWidth: [Number, String]
  },

  computed: {
    calculatedMinWidth: function calculatedMinWidth() {
      var minWidth = parseInt(this.minWidth) || this.dimensions.activator.width + this.nudgeWidth + (this.auto ? 16 : 0);

      if (!this.maxWidth) return minWidth;

      var maxWidth = parseInt(this.maxWidth);

      return maxWidth < minWidth ? maxWidth : minWidth;
    },
    styles: function styles() {
      return {
        maxHeight: this.auto ? '200px' : isNaN(this.maxHeight) ? this.maxHeight : this.maxHeight + 'px',
        minWidth: this.calculatedMinWidth + 'px',
        maxWidth: parseInt(this.maxWidth) + 'px',
        top: this.calcTop() + 'px',
        left: this.calcLeft() + 'px'
      };
    },
    hasActivator: function hasActivator() {
      return !!this.$slots.activator || this.activator;
    }
  },

  watch: {
    activator: function activator(newActivator, oldActivator) {
      this.removeActivatorEvents(oldActivator);
      this.addActivatorEvents(newActivator);
    },
    disabled: function disabled(val) {
      val && this.deactivate();
    },
    hasJustFocused: function hasJustFocused(val) {
      var _this = this;

      if (!val) return;

      clearTimeout(this.focusedTimeout);
      this.focusedTimeout = setTimeout(function () {
        return _this.hasJustFocused = false;
      }, 550);
    },
    isActive: function isActive(val) {
      if (this.disabled) return;

      val && this.activate() || this.deactivate();
    },
    windowResizeHandler: function windowResizeHandler() {
      this.isBooted = false;
    }
  },

  mounted: function mounted() {
    window.addEventListener('resize', this.onResize, { passive: true });
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('resize', this.onResize, { passive: true });
    window.removeEventListener('resize', this.windowResizeHandler);
  },


  methods: {
    activate: function activate() {
      if (typeof window === 'undefined') return;
      this.isBooted = true;
      this.getTiles();
      this.updateDimensions();
      requestAnimationFrame(this.startTransition);
      this.$emit('activate');
    },
    deactivate: function deactivate() {
      this.isContentActive = false;
      this.$emit('deactivate');
    },
    onResize: function onResize() {
      clearTimeout(this.resizeTimeout);
      if (!this.isActive) return;
      this.resizeTimeout = setTimeout(this.updateDimensions, 200);
    },
    startTransition: function startTransition() {
      var _this2 = this;

      requestAnimationFrame(function () {
        return _this2.isContentActive = true;
      });
      requestAnimationFrame(this.calculateScroll);
    }
  },

  render: function render(h) {
    var _this3 = this;

    var data = {
      'class': 'menu',
      style: {
        display: this.fullWidth ? 'block' : 'inline-block'
      },
      directives: [{
        name: 'click-outside',
        value: function value() {
          return _this3.closeOnClick;
        }
      }],
      on: {
        keydown: function keydown(e) {
          if (e.keyCode === 27) _this3.isActive = false;else _this3.changeListIndex(e);
        }
      }
    };

    return h('div', data, [this.genActivator(), this.genTransition()]);
  }
});

/***/ }),
/* 23 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_transitions__ = __webpack_require__(6);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-progress-linear',

  components: {
    VFadeTransition: __WEBPACK_IMPORTED_MODULE_0__components_transitions__["b" /* VFadeTransition */],
    VSlideXTransition: __WEBPACK_IMPORTED_MODULE_0__components_transitions__["c" /* VSlideXTransition */]
  },

  props: {
    active: {
      type: Boolean,
      default: true
    },
    buffer: Boolean,
    bufferValue: Number,
    error: Boolean,
    height: {
      type: [Number, String],
      default: 7
    },
    indeterminate: Boolean,
    info: Boolean,
    secondary: Boolean,
    success: Boolean,
    query: Boolean,
    warning: Boolean,
    value: {
      type: [Number, String],
      default: 0
    },
    colorFront: {
      type: String,
      default: null
    },
    colorBack: {
      type: String,
      default: null
    }
  },

  computed: {
    classes: function classes() {
      return {
        'progress-linear--query': this.query,
        'progress-linear--secondary': this.secondary,
        'progress-linear--success': this.success,
        'progress-linear--info': this.info,
        'progress-linear--warning': this.warning,
        'progress-linear--error': this.error
      };
    },
    styles: function styles() {
      var styles = {};

      if (!this.active) {
        styles.height = 0;
      }

      if (this.buffer) {
        styles.width = this.bufferValue + '%';
      }

      return styles;
    },
    bufferStyles: function bufferStyles() {
      var styles = {};

      if (!this.active) {
        styles.height = 0;
      }

      return styles;
    }
  },

  methods: {
    genDeterminate: function genDeterminate(h) {
      return h('div', {
        ref: 'front',
        class: ['progress-linear__bar__determinate', this.colorFront],
        style: { width: this.value + '%' }
      });
    },
    genBar: function genBar(h, name) {
      return h('div', {
        class: ['progress-linear__bar__indeterminate', name, this.colorFront]
      });
    },
    genIndeterminate: function genIndeterminate(h) {
      return h('div', {
        ref: 'front',
        class: {
          'progress-linear__bar__indeterminate': true,
          'progress-linear__bar__indeterminate--active': this.active
        }
      }, [this.genBar(h, 'long'), this.genBar(h, 'short')]);
    }
  },

  render: function render(h) {
    var fade = h('v-fade-transition', [this.indeterminate && this.genIndeterminate(h)]);
    var slide = h('v-slide-x-transition', [!this.indeterminate && this.genDeterminate(h)]);

    var bar = h('div', { class: ['progress-linear__bar', this.colorBack], style: this.styles }, [fade, slide]);

    return h('div', {
      class: ['progress-linear', this.classes],
      style: { height: this.height + 'px' },
      on: this.$listeners
    }, [bar]);
  }
});

/***/ }),
/* 24 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_autocomplete__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_filterable__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_generators__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_input__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_cards_VCard__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_selection_controls_VCheckbox__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_icons_VIcon__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_lists_VList__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_lists_VListTile__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_lists_VListTileAction__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_lists__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_menus_VMenu__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__directives_click_outside__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__util_helpers__ = __webpack_require__(0);



















/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-select',

  components: {
    VCard: __WEBPACK_IMPORTED_MODULE_4__components_cards_VCard__["a" /* default */],
    VCheckbox: __WEBPACK_IMPORTED_MODULE_5__components_selection_controls_VCheckbox__["a" /* default */],
    VIcon: __WEBPACK_IMPORTED_MODULE_6__components_icons_VIcon__["a" /* default */],
    VList: __WEBPACK_IMPORTED_MODULE_7__components_lists_VList__["a" /* default */],
    VListTile: __WEBPACK_IMPORTED_MODULE_8__components_lists_VListTile__["a" /* default */],
    VListTileAction: __WEBPACK_IMPORTED_MODULE_9__components_lists_VListTileAction__["a" /* default */],
    VListTileContent: __WEBPACK_IMPORTED_MODULE_10__components_lists__["a" /* VListTileContent */],
    VListTileTitle: __WEBPACK_IMPORTED_MODULE_10__components_lists__["b" /* VListTileTitle */],
    VMenu: __WEBPACK_IMPORTED_MODULE_11__components_menus_VMenu__["a" /* default */]
  },

  directives: {
    clickOutside: __WEBPACK_IMPORTED_MODULE_12__directives_click_outside__["a" /* default */]
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_autocomplete__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_input__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_filterable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_generators__["a" /* default */]],

  data: function data() {
    return {
      content: {},
      hasFocused: false,
      inputValue: this.multiple && !this.value ? [] : this.value,
      isBooted: false,
      lastItem: 20,
      isActive: false,
      searchInputValue: this.searchInput
    };
  },


  props: {
    appendIcon: {
      type: String,
      default: 'arrow_drop_down'
    },
    auto: Boolean,
    autocomplete: Boolean,
    bottom: Boolean,
    chips: Boolean,
    close: Boolean,
    debounce: {
      type: Number,
      default: 200
    },
    items: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    filter: Function,
    itemText: {
      type: String,
      default: 'text'
    },
    itemValue: {
      type: String,
      default: 'value'
    },
    itemDisabled: {
      type: String,
      default: 'disabled'
    },
    maxHeight: {
      type: [Number, String],
      default: 300
    },
    minWidth: {
      type: [Boolean, Number, String],
      default: false
    },
    multiple: Boolean,
    multiLine: Boolean,
    offset: Boolean,
    searchInput: null,
    singleLine: Boolean,
    top: Boolean,
    returnObject: Boolean,
    overflow: Boolean,
    segmented: Boolean,
    editable: Boolean
  },

  computed: {
    classes: function classes() {
      return {
        'input-group--text-field input-group--select': true,
        'input-group--auto': this.auto,
        'input-group--overflow': this.overflow,
        'input-group--segmented': this.segmented,
        'input-group--editable': this.editable,
        'input-group--autocomplete': this.autocomplete,
        'input-group--single-line': this.singleLine || this.isDropdown,
        'input-group--multi-line': this.multiLine,
        'input-group--chips': this.chips,
        'input-group--multiple': this.multiple
      };
    },
    computedContentClass: function computedContentClass() {
      var children = [this.auto ? 'menu__content--auto' : '', this.isDropdown ? 'menu__content--dropdown' : ''];

      return children.join(' ');
    },
    filteredItems: function filteredItems() {
      var items = this.autocomplete && this.searchValue ? this.filterSearch() : this.items;

      return !this.auto ? items.slice(0, this.lastItem) : items;
    },
    hasError: function hasError() {
      return this.validations.length || this.error || this.hasFocused && !this.focused && !this.isDirty && this.required;
    },
    isDirty: function isDirty() {
      return this.selectedItems.length;
    },
    isDropdown: function isDropdown() {
      return this.segmented || this.overflow || this.editable;
    },

    searchValue: {
      get: function get() {
        return this.searchInput || this.searchInputValue;
      },
      set: function set(val) {
        this.searchInputValue = val;
        this.$emit('update:searchInput', val);
      }
    },
    selectedItems: function selectedItems() {
      var _this = this;

      if (this.inputValue === null || typeof this.inputValue === 'undefined') return [];

      return this.items.filter(function (i) {
        if (!_this.multiple) {
          return _this.getValue(i) === _this.getValue(_this.inputValue);
        } else {
          // Always return Boolean
          return _this.inputValue.find(function (j) {
            return _this.getValue(j) === _this.getValue(i);
          }) !== undefined;
        }
      });
    }
  },

  watch: {
    inputValue: function inputValue(val) {
      this.$emit('input', val);
    },
    value: function value(val) {
      this.inputValue = val;
      this.validate();
      if (this.autocomplete || this.editable) {
        this.$nextTick(this.$refs.menu.updateDimensions);
      }
    },
    isActive: function isActive(val) {
      this.isBooted = true;
      this.lastItem += !val ? 20 : 0;

      if (!val) this.blur();else this.focus();
    },
    isBooted: function isBooted() {
      var _this2 = this;

      this.$nextTick(function () {
        if (_this2.content) {
          _this2.content.addEventListener('scroll', _this2.onScroll, false);
        }
      });
    },
    searchValue: function searchValue() {
      this.$refs.menu.listIndex = -1;
    }
  },

  mounted: function mounted() {
    var _this3 = this;

    this.$vuetify.load(function () {
      if (_this3._isDestroyed) return;

      _this3.content = _this3.$refs.menu.$refs.content;
    });
  },
  beforeDestroy: function beforeDestroy() {
    if (this.isBooted) {
      if (this.content) {
        this.content.removeEventListener('scroll', this.onScroll, false);
      }
    }
  },


  methods: {
    blur: function blur() {
      var _this4 = this;

      this.$nextTick(function () {
        _this4.focused = false;
        _this4.hasFocused = true;
        _this4.searchValue = null;
        _this4.$el.blur();
      });
    },
    focus: function focus() {
      var _this5 = this;

      this.focused = true;
      this.$refs.input && (this.autocomplete || this.editable) && this.$refs.input.focus();

      if (this.editable && this.inputValue !== null && typeof this.inputValue !== 'undefined') {
        this.$nextTick(function () {
          _this5.$refs.input.value = _this5.getValue(_this5.inputValue);
        });
      }
    },
    genLabel: function genLabel() {
      if (this.searchValue && !this.focused && this.isDirty) return null;

      var data = {};

      if (this.id) data.attrs = { for: this.id };

      return this.$createElement('label', data, this.label);
    },
    getPropertyFromItem: function getPropertyFromItem(item, field) {
      if (item !== Object(item)) return item;

      var value = Object(__WEBPACK_IMPORTED_MODULE_13__util_helpers__["g" /* getObjectValueByPath */])(item, field);

      return typeof value === 'undefined' ? item : value;
    },
    getText: function getText(item) {
      return this.getPropertyFromItem(item, this.itemText);
    },
    getValue: function getValue(item) {
      return this.getPropertyFromItem(item, this.itemValue);
    },
    onScroll: function onScroll() {
      var _this6 = this;

      if (!this.isActive) {
        requestAnimationFrame(function () {
          return _this6.content.scrollTop = 0;
        });
      } else {
        var showMoreItems = this.content.scrollHeight - (this.content.scrollTop + this.content.clientHeight) < 200;

        if (showMoreItems) {
          this.lastItem += 20;
        }
      }
    },
    selectItem: function selectItem(item) {
      var _this7 = this;

      if (!this.multiple) {
        this.inputValue = this.returnObject ? item : this.getValue(item);
      } else {
        var inputValue = this.inputValue.slice();
        var i = this.inputValue.findIndex(function (i) {
          return _this7.getValue(i) === _this7.getValue(item);
        });

        i !== -1 && inputValue.splice(i, 1) || inputValue.push(item);
        this.inputValue = inputValue.map(function (i) {
          return _this7.returnObject ? i : _this7.getValue(i);
        });
      }

      if (this.autocomplete || this.editable) {
        this.$nextTick(function () {
          _this7.searchValue = null;
          _this7.$refs.input && _this7.$refs.input.focus();
        });
      }

      this.$emit('change', this.inputValue);
    }
  },

  render: function render(h) {
    var _this8 = this;

    return this.genInputGroup([this.genSelectionsAndSearch(), this.genMenu()], {
      ref: 'activator',
      directives: [{
        name: 'click-outside',
        value: function value() {
          return _this8.isActive = false;
        }
      }],
      on: {
        keydown: this.onKeyDown // Located in mixins/autocomplete.js
      }
    });
  }
});

/***/ }),
/* 25 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    noDataText: {
      type: String,
      default: 'No data available'
    }
  }
});

/***/ }),
/* 26 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_selectable__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__directives_ripple__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_transitions__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_icons_VIcon__ = __webpack_require__(3);





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-checkbox',

  components: {
    VFadeTransition: __WEBPACK_IMPORTED_MODULE_2__components_transitions__["b" /* VFadeTransition */],
    VIcon: __WEBPACK_IMPORTED_MODULE_3__components_icons_VIcon__["a" /* default */]
  },

  directives: {
    Ripple: __WEBPACK_IMPORTED_MODULE_1__directives_ripple__["a" /* default */]
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_selectable__["a" /* default */]],

  data: function data() {
    return {
      inputIndeterminate: this.indeterminate
    };
  },


  props: {
    indeterminate: Boolean
  },

  computed: {
    classes: function classes() {
      return this.addColorClassChecks({
        'checkbox': true,
        'input-group--selection-controls': true,
        'input-group--active': this.isActive
      });
    },
    icon: function icon() {
      if (this.inputIndeterminate) {
        return 'indeterminate_check_box';
      } else if (this.isActive) {
        return 'check_box';
      } else {
        return 'check_box_outline_blank';
      }
    }
  },

  render: function render(h) {
    var transition = h('v-fade-transition', [h('v-icon', {
      'class': {
        'icon--checkbox': this.icon === 'check_box'
      },
      key: this.icon
    }, this.icon)]);

    var ripple = h('div', {
      'class': 'input-group--selection-controls__ripple',
      on: Object.assign({}, {
        click: this.toggle
      }, this.$listeners),
      directives: [{
        name: 'ripple',
        value: { center: true }
      }]
    });

    var data = {
      attrs: {
        role: 'checkbox',
        'aria-checked': this.inputIndeterminate && 'mixed' || this.isActive && 'true' || 'false',
        'aria-label': this.label
      }
    };

    return this.genInputGroup([transition, ripple], data);
  }
});

/***/ }),
/* 27 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__colorable__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__input__ = __webpack_require__(7);



/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_1__input__["a" /* default */], __WEBPACK_IMPORTED_MODULE_0__colorable__["a" /* default */]],

  model: {
    prop: 'inputValue',
    event: 'change'
  },

  props: {
    inputValue: null,
    falseValue: null,
    trueValue: null
  },

  computed: {
    isActive: function isActive() {
      if (Array.isArray(this.inputValue)) {
        return this.inputValue.indexOf(this.value) !== -1;
      }

      if (!this.trueValue || !this.falseValue) {
        return this.value ? this.value === this.inputValue : Boolean(this.inputValue);
      }

      return this.inputValue === this.trueValue;
    }
  },

  watch: {
    indeterminate: function indeterminate(val) {
      this.inputIndeterminate = val;
    }
  },

  methods: {
    genLabel: function genLabel() {
      return this.$createElement('label', {
        on: { click: this.toggle },
        attrs: {
          for: this.$attrs.id
        }
      }, this.$slots.label || this.label);
    },
    toggle: function toggle() {
      if (this.disabled) {
        return;
      }

      var input = this.inputValue;
      if (Array.isArray(input)) {
        input = input.slice();
        var i = input.indexOf(this.value);

        if (i === -1) {
          input.push(this.value);
        } else {
          input.splice(i, 1);
        }
      } else if (this.trueValue || this.falseValue) {
        input = input === this.trueValue ? this.falseValue : this.trueValue;
      } else if (this.value) {
        input = this.value === this.inputValue ? null : this.value;
      } else {
        input = !input;
      }

      this.$emit('change', input);
    }
  }
});

/***/ }),
/* 28 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    color: String
  },
  methods: {
    addColorClassChecks: function addColorClassChecks(classes) {
      var parts = this.color ? this.color.trim().split(' ') : [''];
      var color = parts[0] + '--text';
      if (parts.length > 1) color += ' text--' + parts[1];
      classes[color] = !!this.color;
      return classes;
    }
  }
});

/***/ }),
/* 29 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__package_json__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__package_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__package_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__directives__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_load__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_semver__ = __webpack_require__(132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_semver___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_semver__);
__webpack_require__(30);







function plugin(Vue) {
  Object.keys(__WEBPACK_IMPORTED_MODULE_1__components__["a" /* default */]).forEach(function (key) {
    Vue.component(key, __WEBPACK_IMPORTED_MODULE_1__components__["a" /* default */][key]);
  });

  Object.keys(__WEBPACK_IMPORTED_MODULE_2__directives__).forEach(function (key) {
    Vue.directive(key, __WEBPACK_IMPORTED_MODULE_2__directives__[key]);
  });

  Vue.prototype.$vuetify = {
    load: __WEBPACK_IMPORTED_MODULE_3__util_load__["a" /* default */]
  };
}

function checkVueVersion() {
  var vueDep = __WEBPACK_IMPORTED_MODULE_0__package_json__["devDependencies"].vue;
  if (!__WEBPACK_IMPORTED_MODULE_4_semver___default.a.satisfies(window.Vue.version, vueDep)) {
    console.warn('Vuetify requires Vue version ' + vueDep);
  }
}

if (typeof window !== 'undefined' && window.Vue) {
  if (window.Vue.version) {
    checkVueVersion();
  }
  window.Vue.use(plugin);
}

/* harmony default export */ __webpack_exports__["default"] = (plugin);

/***/ }),
/* 30 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 31 */
/***/ (function(module, exports) {

module.exports = {
	"name": "vuetify",
	"version": "0.14.10",
	"author": {
		"name": "John Leider",
		"email": "john.j.leider@gmail.com"
	},
	"license": "MIT",
	"homepage": "http://vuetifyjs.com",
	"main": "dist/vuetify.js",
	"types": "index.d.ts",
	"scripts": {
		"watch": "cross-env TARGET=dev webpack --config build/config.js --progress --hide-modules --watch",
		"dev": "cross-env NODE_ENV=development webpack-dev-server --config build/webpack.dev.config.js --open --hot",
		"build": "rimraf dist && cross-env NODE_ENV=production node build/build.js --progress --hide-modules",
		"debug-build": "node --inspect --debug-brk build/build.js",
		"test": "cross-env NODE_ENV=test jest --no-cache --verbose",
		"test-coverage": "cross-env NODE_ENV=test jest --no-cache --coverage --verbose",
		"lint": "eslint --ext .js,.vue src"
	},
	"description": "Vue.js 2 Semantic Component Framework",
	"devDependencies": {
		"autoprefixer": "^6.6.0",
		"avoriaz": "^3.2.0",
		"babel-cli": "^6.24.1",
		"babel-core": "^6.24.1",
		"babel-eslint": "^7.1.1",
		"babel-jest": "^20.0.3",
		"babel-loader": "^7.1.1",
		"babel-plugin-add-filehash": "^6.9.4",
		"babel-plugin-module-resolver": "^2.7.1",
		"babel-plugin-transform-async-to-generator": "^6.24.1",
		"babel-plugin-transform-runtime": "^6.23.0",
		"babel-preset-env": "^1.5.1",
		"babel-preset-es2015": "^6.24.1",
		"babel-preset-stage-2": "^6.24.1",
		"chalk": "^1.1.3",
		"chromedriver": "^2.21.2",
		"cross-env": "^3.1.3",
		"cross-spawn": "^4.0.2",
		"css-loader": "^0.23.1",
		"css-mqpacker": "^6.0.1",
		"cssnano": "^3.10.0",
		"eslint": "^3.7.1",
		"eslint-config-standard": "^6.1.0",
		"eslint-config-vue": "^2.0.2",
		"eslint-friendly-formatter": "^2.0.5",
		"eslint-loader": "^1.6.1",
		"eslint-plugin-html": "^1.3.0",
		"eslint-plugin-promise": "^3.4.0",
		"eslint-plugin-pug": "^1.0.0",
		"eslint-plugin-standard": "^3.0.1",
		"eslint-plugin-vue": "^2.1.0",
		"eventsource-polyfill": "^0.9.6",
		"extract-text-webpack-plugin": "^3.0.0",
		"friendly-errors-webpack-plugin": "^1.6.1",
		"function-bind": "^1.0.2",
		"jest": "^20.0.4",
		"jest-cli": "^20.0.4",
		"jest-css-modules": "^1.1.0",
		"jest-serializer-html": "^4.0.0",
		"jest-vue-preprocessor": "^0.2.0",
		"lolex": "^1.4.0",
		"nightwatch": "^0.9.8",
		"opn": "^4.0.2",
		"optimize-css-assets-webpack-plugin": "^2.0.0",
		"optimize-js-plugin": "^0.0.4",
		"ora": "^0.3.0",
		"phantomjs-prebuilt": "^2.1.3",
		"postcss-loader": "^1.2.1",
		"precss": "^1.4.0",
		"pug": "^2.0.0-beta3",
		"pug-loader": "^2.3.0",
		"ress": "^1.1.1",
		"rimraf": "^2.5.4",
		"selenium-server": "2.53.1",
		"semver": "^5.3.0",
		"serialize-javascript": "^1.3.0",
		"shelljs": "^0.7.4",
		"style-loader": "^0.13.1",
		"stylus": "^0.54.5",
		"stylus-loader": "^2.1.1",
		"uglifyjs-webpack-plugin": "^0.4.6",
		"vue": "^2.4.1",
		"vue-loader": "^10.1.0",
		"vue-router": "^2.7.0",
		"vue-server-renderer": "^2.4.1",
		"vue-template-compiler": "^2.4.1",
		"webpack": "^3.2.0",
		"webpack-bundle-size-analyzer": "^2.7.0",
		"webpack-dev-server": "^2.6.1",
		"webpack-merge": "^4.1.0"
	},
	"dependencies": {},
	"engines": {
		"node": ">= 4.0.0",
		"npm": ">= 3.0.0"
	},
	"jest": {
		"verbose": false,
		"roots": [
			"<rootDir>/src"
		],
		"moduleFileExtensions": [
			"js",
			"vue"
		],
		"moduleDirectories": [
			"node_modules"
		],
		"moduleNameMapper": {
			"src/(.*)": "<rootDir>/src/$1"
		},
		"transform": {
			".*\\.(vue)$": "<rootDir>/node_modules/jest-vue-preprocessor",
			"\\.(styl)$": "<rootDir>/node_modules/jest-css-modules",
			".*\\.(vue|js)$": "<rootDir>/node_modules/babel-jest"
		},
		"transformIgnorePatterns": [
			"node_modules/(?!vue-router)"
		],
		"snapshotSerializers": [
			"jest-serializer-html"
		]
	}
};

/***/ }),
/* 32 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__alerts__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__app__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__avatars__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__bottom_nav__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__breadcrumbs__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__buttons__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__cards__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__carousel__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__chips__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__pickers__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__dialogs__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__dividers__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__expansion_panel__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__footer__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__grid__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__icons__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__lists__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__menus__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__navigation_drawer__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__toolbar__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__pagination__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__parallax__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__progress__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__selects__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__selection_controls__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__sliders__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__subheaders__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__steppers__ = __webpack_require__(111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__tables__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__tabs__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__text_fields__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__transitions__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__snackbars__ = __webpack_require__(129);


































/* harmony default export */ __webpack_exports__["a"] = (Object.assign({}, __WEBPACK_IMPORTED_MODULE_0__alerts__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__app__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__avatars__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__bottom_nav__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__breadcrumbs__["a" /* default */], __WEBPACK_IMPORTED_MODULE_5__buttons__["a" /* default */], __WEBPACK_IMPORTED_MODULE_6__cards__["a" /* default */], __WEBPACK_IMPORTED_MODULE_7__carousel__["a" /* default */], __WEBPACK_IMPORTED_MODULE_8__chips__["a" /* default */], __WEBPACK_IMPORTED_MODULE_9__pickers__["a" /* default */], __WEBPACK_IMPORTED_MODULE_10__dialogs__["a" /* default */], __WEBPACK_IMPORTED_MODULE_11__dividers__["a" /* default */], __WEBPACK_IMPORTED_MODULE_12__expansion_panel__["a" /* default */], __WEBPACK_IMPORTED_MODULE_13__footer__["a" /* default */], __WEBPACK_IMPORTED_MODULE_14__grid__["a" /* default */], __WEBPACK_IMPORTED_MODULE_15__icons__["a" /* default */], __WEBPACK_IMPORTED_MODULE_16__lists__["c" /* default */], __WEBPACK_IMPORTED_MODULE_17__menus__["a" /* default */], __WEBPACK_IMPORTED_MODULE_18__navigation_drawer__["a" /* default */], __WEBPACK_IMPORTED_MODULE_19__toolbar__["a" /* default */], __WEBPACK_IMPORTED_MODULE_20__pagination__["a" /* default */], __WEBPACK_IMPORTED_MODULE_21__parallax__["a" /* default */], __WEBPACK_IMPORTED_MODULE_22__progress__["a" /* default */], __WEBPACK_IMPORTED_MODULE_23__selects__["a" /* default */], __WEBPACK_IMPORTED_MODULE_24__selection_controls__["a" /* default */], __WEBPACK_IMPORTED_MODULE_25__sliders__["a" /* default */], __WEBPACK_IMPORTED_MODULE_26__subheaders__["a" /* default */], __WEBPACK_IMPORTED_MODULE_27__steppers__["a" /* default */], __WEBPACK_IMPORTED_MODULE_28__tables__["a" /* default */], __WEBPACK_IMPORTED_MODULE_29__tabs__["a" /* default */], __WEBPACK_IMPORTED_MODULE_30__text_fields__["a" /* default */], __WEBPACK_IMPORTED_MODULE_31__transitions__["d" /* default */], __WEBPACK_IMPORTED_MODULE_32__snackbars__["a" /* default */]));

/***/ }),
/* 33 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VAlert__ = __webpack_require__(34);


/* harmony default export */ __webpack_exports__["a"] = ({
  VAlert: __WEBPACK_IMPORTED_MODULE_0__VAlert__["a" /* default */]
});

/***/ }),
/* 34 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_contextualable__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_transitionable__ = __webpack_require__(35);




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-alert',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_contextualable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_transitionable__["a" /* default */]],

  props: {
    dismissible: Boolean,
    hideIcon: Boolean,
    icon: String
  },

  computed: {
    classes: function classes() {
      return {
        'alert': true,
        'alert--dismissible': this.dismissible,
        'error': this.error,
        'info': this.info,
        'primary': this.primary,
        'secondary': this.secondary,
        'success': this.success,
        'warning': this.warning
      };
    },
    mdIcon: function mdIcon() {
      switch (true) {
        case !!this.icon:
          return this.icon;
        case this.error:
          return 'warning';
        case this.info:
          return 'info';
        case this.success:
          return 'check_circle';
        case this.warning:
          return 'priority_high';
      }
    }
  },

  render: function render(h) {
    var _this = this;

    var children = [h('div', this.$slots.default)];

    if (!this.hideIcon && this.mdIcon) {
      children.unshift(h('v-icon', {
        'class': 'alert__icon'
      }, this.mdIcon));
    }

    if (this.dismissible) {
      var close = h('a', {
        'class': 'alert__dismissible',
        domProps: { href: 'javascript:;' },
        on: { click: function click() {
            return _this.$emit('input', false);
          } }
      }, [h('v-icon', {
        props: { right: true }
      }, 'cancel')]);

      children.push(close);
    }

    var alert = h('div', {
      'class': this.classes,
      directives: [{
        name: 'show',
        value: this.isActive
      }],
      on: this.$listeners
    }, children);

    if (!this.transition) return alert;

    return h('transition', {
      props: {
        name: this.transition,
        origin: this.origin,
        mode: this.mode
      }
    }, [alert]);
  }
});

/***/ }),
/* 35 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    mode: String,
    origin: String,
    transition: String
  }
});

/***/ }),
/* 36 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VApp__ = __webpack_require__(37);


/* harmony default export */ __webpack_exports__["a"] = ({
  VApp: __WEBPACK_IMPORTED_MODULE_0__VApp__["a" /* default */]
});

/***/ }),
/* 37 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);


/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */]],

  props: {
    fixedFooter: Boolean,
    footer: Boolean,
    id: {
      type: String,
      default: 'app'
    },
    toolbar: Boolean
  },

  render: function render(h, _ref) {
    var props = _ref.props,
        data = _ref.data,
        children = _ref.children;

    data.staticClass = ('application ' + (data.staticClass || '')).trim();
    data.staticClass += ' application--' + (props.dark ? 'dark' : 'light');

    props.footer && (data.staticClass += ' application--footer');
    props.fixedFooter && (data.staticClass += ' application--footer-fixed');
    props.toolbar && (data.staticClass += ' application--toolbar');

    data.attrs = { 'data-app': true };
    data.domProps = { id: props.id };

    return h('div', data, children);
  }
});

/***/ }),
/* 38 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export VAvatar */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);


var VAvatar = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('avatar');

/* harmony default export */ __webpack_exports__["a"] = ({
  VAvatar: VAvatar
});

/***/ }),
/* 39 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VBottomNav__ = __webpack_require__(40);


/* harmony default export */ __webpack_exports__["a"] = ({
  VBottomNav: __WEBPACK_IMPORTED_MODULE_0__VBottomNav__["a" /* default */]
});

/***/ }),
/* 40 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  props: {
    absolute: Boolean,
    shift: Boolean,
    value: { required: false }
  },

  render: function render(h, _ref) {
    var data = _ref.data,
        props = _ref.props,
        children = _ref.children;

    data.staticClass = ('bottom-nav ' + (data.staticClass || '')).trim();

    if (props.absolute) data.staticClass += ' bottom-nav--absolute';
    if (props.shift) data.staticClass += ' bottom-nav--shift';
    if (props.value) data.staticClass += ' bottom-nav--active';

    return h('div', data, children);
  }
});

/***/ }),
/* 41 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VBreadcrumbs__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VBreadcrumbsItem__ = __webpack_require__(43);



/* harmony default export */ __webpack_exports__["a"] = ({
  VBreadcrumbs: __WEBPACK_IMPORTED_MODULE_0__VBreadcrumbs__["a" /* default */],
  VBreadcrumbsItem: __WEBPACK_IMPORTED_MODULE_1__VBreadcrumbsItem__["a" /* default */]
});

/***/ }),
/* 42 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-breadcrumbs',

  provide: function provide() {
    return {
      divider: this.divider
    };
  },


  props: {
    divider: {
      type: String,
      default: '/'
    },
    icons: Boolean
  },

  computed: {
    classes: function classes() {
      return {
        'breadcrumbs': true,
        'breadcrumbs--with-icons': this.icons
      };
    }
  },

  render: function render(h) {
    return h('ul', {
      'class': this.classes,
      props: { items: this.items }
    }, this.$slots.default);
  }
});

/***/ }),
/* 43 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_route_link__ = __webpack_require__(9);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-breadcrumbs-item',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_route_link__["a" /* default */]],

  inject: ['divider'],

  props: {
    activeClass: {
      type: String,
      default: 'breadcrumbs__item--active'
    }
  },

  computed: {
    classes: function classes() {
      var classes = _defineProperty({
        'breadcrumbs__item': true
      }, this.activeClass, !this.disabled);

      return classes;
    }
  },

  render: function render(h) {
    var _generateRouteLink = this.generateRouteLink(),
        tag = _generateRouteLink.tag,
        data = _generateRouteLink.data;

    return h('li', {
      attrs: { 'data-divider': this.divider }
    }, [h(tag, data, this.$slots.default)]);
  }
});

/***/ }),
/* 44 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VBtn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VBtnToggle__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VSpeedDial__ = __webpack_require__(46);




/* harmony default export */ __webpack_exports__["a"] = ({
  VBtn: __WEBPACK_IMPORTED_MODULE_0__VBtn__["a" /* default */],
  VBtnToggle: __WEBPACK_IMPORTED_MODULE_1__VBtnToggle__["a" /* default */],
  VSpeedDial: __WEBPACK_IMPORTED_MODULE_2__VSpeedDial__["a" /* default */]
});

/***/ }),
/* 45 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_buttons_VBtn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_icons_VIcon__ = __webpack_require__(3);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-btn-toggle',

  model: {
    prop: 'inputValue',
    event: 'change'
  },

  props: {
    inputValue: {
      required: false
    },
    items: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    mandatory: Boolean,
    multiple: Boolean
  },

  computed: {
    classes: function classes() {
      return {
        'btn-toggle': true,
        'btn-toggle--selected': this.inputValue && (!this.multiple || this.inputValue.length)
      };
    }
  },

  methods: {
    isSelected: function isSelected(item) {
      if (!this.multiple) {
        return this.inputValue === item.value;
      }

      return this.inputValue.includes(item.value);
    },
    updateValue: function updateValue(item) {
      if (!this.multiple) {
        if (this.mandatory && this.inputValue === item.value) return;
        return this.$emit('change', this.inputValue === item.value ? null : item.value);
      }

      var items = this.inputValue.slice();

      var i = items.indexOf(item.value);
      if (i > -1) {
        items.length >= 1 && !this.mandatory && items.splice(i, 1);
      } else {
        items.push(item.value);
      }

      this.$emit('change', items);
    }
  },

  render: function render(h) {
    var _this = this;

    var buttons = this.items.map(function (item, index) {
      var children = [];

      item.text && children.push(h('span', item.text));
      item.icon && children.push(h(__WEBPACK_IMPORTED_MODULE_1__components_icons_VIcon__["a" /* default */], item.icon));

      return h(__WEBPACK_IMPORTED_MODULE_0__components_buttons_VBtn__["a" /* default */], {
        key: index,
        props: {
          flat: true
        },
        on: {
          click: function click(e) {
            e.stopPropagation();
            _this.updateValue(item);
          }
        },
        attrs: {
          'data-selected': _this.isSelected(item),
          'data-index': index,
          'data-only-child': _this.isSelected(item) && (!_this.multiple || _this.inputValue.length === 1)
        }
      }, children);
    });

    return h('div', { class: this.classes }, buttons);
  }
});

/***/ }),
/* 46 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_toggleable__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_positionable__ = __webpack_require__(12);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-speed-dial',

  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_positionable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_0__mixins_toggleable__["a" /* default */]],

  props: {
    direction: {
      type: String,
      default: 'top',
      validator: function validator(val) {
        return ['top', 'right', 'bottom', 'left'].includes(val);
      }
    },
    hover: Boolean,
    transition: {
      type: String,
      default: 'scale-transition'
    }
  },

  computed: {
    classes: function classes() {
      return _defineProperty({
        'speed-dial': true,
        'speed-dial--top': this.top,
        'speed-dial--right': this.right,
        'speed-dial--bottom': this.bottom,
        'speed-dial--left': this.left,
        'speed-dial--absolute': this.absolute,
        'speed-dial--fixed': this.fixed
      }, 'speed-dial--direction-' + this.direction, true);
    }
  },

  render: function render(h) {
    var _this = this;

    var children = [];
    var data = {
      'class': this.classes,
      directives: [{
        name: 'click-outside'
      }],
      on: {
        click: function click() {
          return _this.isActive = !_this.isActive;
        }
      }
    };

    if (this.hover) {
      data.on.mouseenter = function () {
        return _this.isActive = true;
      };
      data.on.mouseleave = function () {
        return _this.isActive = false;
      };
    }

    if (this.isActive) {
      children = (this.$slots.default || []).map(function (b, i) {
        b.key = i;

        return b;
      });
    }

    var list = h('transition-group', {
      'class': 'speed-dial__list',
      props: {
        name: this.transition,
        tag: 'div'
      }
    }, children);

    return h('div', data, [this.$slots.activator, list]);
  }
});

/***/ }),
/* 47 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VCard__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VCardMedia__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__VCardTitle__ = __webpack_require__(49);





var VCardActions = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('card__actions');
var VCardText = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('card__text');

/* harmony default export */ __webpack_exports__["a"] = ({
  VCard: __WEBPACK_IMPORTED_MODULE_1__VCard__["a" /* default */],
  VCardActions: VCardActions,
  VCardMedia: __WEBPACK_IMPORTED_MODULE_2__VCardMedia__["a" /* default */],
  VCardText: VCardText,
  VCardTitle: __WEBPACK_IMPORTED_MODULE_3__VCardTitle__["a" /* default */]
});

/***/ }),
/* 48 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-card-media',

  props: {
    contain: Boolean,
    height: {
      type: [Number, String],
      default: 'auto'
    },
    src: {
      type: String
    }
  },

  render: function render(h) {
    var data = {
      'class': 'card__media',
      style: {
        height: !isNaN(this.height) ? this.height + 'px' : this.height
      },
      on: this.$listeners
    };

    var children = [];

    if (this.src) {
      children.push(h('div', {
        'class': 'card__media__background',
        style: {
          background: 'url(' + this.src + ') center center / ' + (this.contain ? 'contain' : 'cover') + ' no-repeat'
        }
      }));
    }

    children.push(h('div', {
      'class': 'card__media__content'
    }, this.$slots.default));

    return h('div', data, children);
  }
});

/***/ }),
/* 49 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  props: {
    primaryTitle: Boolean
  },

  render: function render(h, _ref) {
    var data = _ref.data,
        props = _ref.props,
        children = _ref.children;

    data.staticClass = ('card__title ' + (data.staticClass || '')).trim();

    if (props.primaryTitle) data.staticClass += ' card__title--primary';

    return h('div', data, children);
  }
});

/***/ }),
/* 50 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VCarousel__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VCarouselItem__ = __webpack_require__(52);



/* harmony default export */ __webpack_exports__["a"] = ({
  VCarousel: __WEBPACK_IMPORTED_MODULE_0__VCarousel__["a" /* default */],
  VCarouselItem: __WEBPACK_IMPORTED_MODULE_1__VCarouselItem__["a" /* default */]
});

/***/ }),
/* 51 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_bootable__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_buttons_VBtn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_icons_VIcon__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_themeable__ = __webpack_require__(1);





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-carousel',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_bootable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_themeable__["a" /* default */]],

  data: function data() {
    return {
      current: null,
      items: [],
      slideInterval: {},
      reverse: false
    };
  },


  props: {
    cycle: {
      type: Boolean,
      default: true
    },
    icon: {
      type: String,
      default: 'fiber_manual_record'
    },
    interval: {
      type: Number,
      default: 6000
    },
    leftControlIcon: {
      type: [Boolean, String],
      default: 'chevron_left'
    },
    rightControlIcon: {
      type: [Boolean, String],
      default: 'chevron_right'
    }
  },

  computed: {
    defaultState: function defaultState() {
      return {
        current: null,
        reverse: false
      };
    }
  },

  watch: {
    current: function current() {
      var _this = this;

      // Evaluate items when current changes to account for
      // dynamic changing of children
      this.items = this.$children.filter(function (i) {
        return i.$el.classList && i.$el.classList.contains('carousel__item');
      });

      this.items.forEach(function (i) {
        return i.open(_this.items[_this.current]._uid, _this.reverse);
      });

      !this.isBooted && this.cycle && this.restartInterval();
      this.isBooted = true;
    },
    cycle: function cycle(val) {
      val && this.restartInterval() || clearInterval(this.slideInterval);
    }
  },

  mounted: function mounted() {
    this.init();
  },


  methods: {
    genControls: function genControls() {
      return this.$createElement('div', {
        staticClass: 'carousel__controls'
      }, this.genItems());
    },
    genIcon: function genIcon(direction, icon, fn) {
      if (!icon) return null;

      return this.$createElement('div', {
        staticClass: 'carousel__' + direction
      }, [this.$createElement(__WEBPACK_IMPORTED_MODULE_1__components_buttons_VBtn__["a" /* default */], {
        props: {
          icon: true,
          dark: this.dark || !this.light,
          light: this.light
        },
        on: { click: fn }
      }, [this.$createElement(__WEBPACK_IMPORTED_MODULE_2__components_icons_VIcon__["a" /* default */], icon)])]);
    },
    genItems: function genItems() {
      var _this2 = this;

      return this.items.map(function (item, index) {
        return _this2.$createElement(__WEBPACK_IMPORTED_MODULE_1__components_buttons_VBtn__["a" /* default */], {
          class: {
            'carousel__controls__item': true,
            'carousel__controls__item--active': index === _this2.current
          },
          props: {
            icon: true,
            dark: _this2.dark || !_this2.light,
            light: _this2.light
          },
          key: index,
          on: { click: _this2.select.bind(_this2, index) }
        }, [_this2.$createElement(__WEBPACK_IMPORTED_MODULE_2__components_icons_VIcon__["a" /* default */], _this2.icon)]);
      });
    },
    restartInterval: function restartInterval() {
      clearInterval(this.slideInterval);
      this.$nextTick(this.startInterval);
    },
    init: function init() {
      this.current = 0;
    },
    next: function next() {
      this.reverse = false;

      if (this.current + 1 === this.items.length) {
        return this.current = 0;
      }

      this.current++;
    },
    prev: function prev() {
      this.reverse = true;

      if (this.current - 1 < 0) {
        return this.current = this.items.length - 1;
      }

      this.current--;
    },
    select: function select(index) {
      this.reverse = index < this.current;
      this.current = index;
    },
    startInterval: function startInterval() {
      this.slideInterval = setInterval(this.next, this.interval);
    }
  },

  render: function render(h) {
    return h('div', {
      staticClass: 'carousel',
      directives: [{
        name: 'touch',
        value: {
          left: this.next,
          right: this.prev
        }
      }]
    }, [this.genIcon('left', this.leftControlIcon, this.prev), this.genIcon('right', this.rightControlIcon, this.next), this.genControls(), this.$slots.default]);
  }
});

/***/ }),
/* 52 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-carousel-item',

  data: function data() {
    return {
      active: false,
      reverse: false
    };
  },


  props: {
    src: {
      type: String,
      required: true
    },

    transition: {
      type: String,
      default: 'tab-transition'
    },

    reverseTransition: {
      type: String,
      default: 'tab-reverse-transition'
    }
  },

  computed: {
    computedTransition: function computedTransition() {
      return this.reverse ? this.reverseTransition : this.transition;
    },
    styles: function styles() {
      return {
        backgroundImage: 'url(' + this.src + ')'
      };
    }
  },

  methods: {
    open: function open(id, reverse) {
      this.active = this._uid === id;
      this.reverse = reverse;
    }
  },

  render: function render(h) {
    var item = h('div', {
      class: {
        'carousel__item': true,
        'reverse': this.reverse
      },
      style: this.styles,
      on: this.$listeners,
      directives: [{
        name: 'show',
        value: this.active
      }]
    }, [this.$slots.default]);

    return h('transition', { props: { name: this.computedTransition } }, [item]);
  }
});

/***/ }),
/* 53 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VChip__ = __webpack_require__(54);


/* harmony default export */ __webpack_exports__["a"] = ({
  VChip: __WEBPACK_IMPORTED_MODULE_0__VChip__["a" /* default */]
});

/***/ }),
/* 54 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_toggleable__ = __webpack_require__(2);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-chip',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_toggleable__["a" /* default */]],

  props: {
    close: Boolean,
    label: Boolean,
    outline: Boolean,
    small: Boolean,
    value: {
      type: Boolean,
      default: true
    }
  },

  computed: {
    classes: function classes() {
      return {
        'chip': true,
        'chip--label': this.label,
        'chip--outline': this.outline,
        'chip--small': this.small,
        'chip--removable': this.close
      };
    }
  },

  render: function render(h) {
    var _this = this;

    var children = [this.$slots.default];
    var data = {
      'class': this.classes,
      attrs: { tabindex: -1 },
      directives: [{
        name: 'show',
        value: this.isActive
      }],
      on: this.$listeners
    };

    if (this.close) {
      children.push(h('a', {
        'class': 'chip__close',
        domProps: { href: 'javascript:;' },
        on: {
          click: function click(e) {
            e.stopPropagation();

            _this.$emit('input', false);
          }
        }
      }, [h('v-icon', { props: { right: true } }, 'cancel')]));
    }

    return h('span', data, children);
  }
});

/***/ }),
/* 55 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VDatePicker__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VTimePicker__ = __webpack_require__(61);



/* harmony default export */ __webpack_exports__["a"] = ({
  VDatePicker: __WEBPACK_IMPORTED_MODULE_0__VDatePicker__["a" /* default */],
  VTimePicker: __WEBPACK_IMPORTED_MODULE_1__VTimePicker__["a" /* default */]
});

/***/ }),
/* 56 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_date_title__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_date_header__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_date_table__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_date_years__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_picker__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__util_helpers__ = __webpack_require__(0);







var defaultDateFormat = function defaultDateFormat(val) {
  return new Date(val).toISOString().substr(0, 10);
};

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-date-picker',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_date_title__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_date_header__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_date_table__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_date_years__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__mixins_picker__["a" /* default */]],

  data: function data() {
    return {
      tableDate: new Date(),
      originalDate: this.value,
      currentDay: null,
      currentMonth: null,
      currentYear: null,
      isSelected: false,
      isReversing: false,
      narrowDays: []
    };
  },


  props: {
    locale: {
      type: String,
      default: 'en-us'
    },
    dateFormat: {
      type: Function,
      default: defaultDateFormat
    },
    titleDateFormat: {
      type: Object,
      default: function _default() {
        return { weekday: 'short', month: 'short', day: 'numeric' };
      }
    },
    headerDateFormat: {
      type: Object,
      default: function _default() {
        return { month: 'long', year: 'numeric' };
      }
    },
    formattedValue: {
      required: false
    },
    allowedDates: {
      type: [Array, Object, Function],
      default: function _default() {
        return null;
      }
    },
    firstDayOfWeek: {
      type: [String, Number],
      default: 0
    },
    yearIcon: String
  },

  computed: {
    firstAllowedDate: function firstAllowedDate() {
      var date = new Date();
      date.setHours(12, 0, 0, 0);

      if (this.allowedDates) {
        var millisecondOffset = 1 * 24 * 60 * 60 * 1000;
        var valid = new Date(date);
        for (var i = 0; i < 31; i++) {
          if (this.isAllowed(valid)) return valid;

          valid.setTime(valid.getTime() + millisecondOffset);
        }
      }

      return date;
    },

    inputDate: {
      get: function get() {
        if (!this.value) return this.firstAllowedDate;
        if (this.value instanceof Date) return this.value;
        if (!isNaN(this.value) || typeof this.value === 'string' && this.value.indexOf(':') !== -1) return new Date(this.value);

        return new Date(this.value + 'T12:00:00');
      },
      set: function set(val) {
        this.$emit('input', val ? defaultDateFormat(val) : this.originalDate);
        this.$emit('update:formattedValue', val ? this.dateFormat(val) : this.dateFormat(this.originalDate));
      }
    },
    day: function day() {
      return this.inputDate.getDate();
    },
    month: function month() {
      return this.inputDate.getMonth();
    },
    year: function year() {
      return this.inputDate.getFullYear();
    },
    tableMonth: function tableMonth() {
      return this.tableDate.getMonth();
    },
    tableYear: function tableYear() {
      return this.tableDate.getFullYear();
    },
    computedTransition: function computedTransition() {
      return this.isReversing ? 'v-tab-reverse-transition' : 'v-tab-transition';
    }
  },

  watch: {
    isSelected: function isSelected(val) {
      var _this = this;

      val && this.$nextTick(function () {
        _this.$refs.years.scrollTop = _this.$refs.years.scrollHeight / 2 - 125;
      });
    },
    tableDate: function tableDate(val, prev) {
      this.isReversing = val < prev;
    },
    value: function value(val) {
      if (val) this.tableDate = this.inputDate;
    }
  },

  methods: {
    save: function save() {
      if (this.originalDate) {
        this.originalDate = this.value;
      } else {
        this.originalDate = this.inputDate;
      }

      if (this.$parent && this.$parent.isActive) this.$parent.isActive = false;
    },
    cancel: function cancel() {
      this.inputDate = this.originalDate;
      if (this.$parent && this.$parent.isActive) this.$parent.isActive = false;
    },
    isAllowed: function isAllowed(date) {
      if (!this.allowedDates) return true;

      if (Array.isArray(this.allowedDates)) {
        return !!this.allowedDates.find(function (allowedDate) {
          var d = new Date(allowedDate);
          d.setHours(12, 0, 0, 0);

          return d - date === 0;
        });
      } else if (this.allowedDates instanceof Function) {
        return this.allowedDates(date);
      } else if (this.allowedDates instanceof Object) {
        var min = new Date(this.allowedDates.min);
        min.setHours(12, 0, 0, 0);
        var max = new Date(this.allowedDates.max);
        max.setHours(12, 0, 0, 0);

        return date >= min && date <= max;
      }

      return true;
    }
  },

  created: function created() {
    var _this2 = this;

    var date = new Date();
    date.setDate(date.getDate() - date.getDay() + parseInt(this.firstDayOfWeek));

    Object(__WEBPACK_IMPORTED_MODULE_5__util_helpers__["c" /* createRange */])(7).forEach(function () {
      var narrow = date.toLocaleString(_this2.locale, { weekday: 'narrow' });
      _this2.narrowDays.push(narrow);

      date.setDate(date.getDate() + 1);
    });
  },
  mounted: function mounted() {
    this.currentDay = this.tableDate.getDate();
    this.currentMonth = this.tableDate.getMonth();
    this.currentYear = this.tableDate.getFullYear();
    this.tableDate = this.inputDate;
  },
  render: function render(h) {
    var children = [];

    !this.noTitle && children.push(this.genTitle());

    if (!this.isSelected) {
      var bodyChildren = [];

      bodyChildren.push(this.genHeader());
      bodyChildren.push(this.genTable());

      children.push(h('div', {
        'class': 'picker__body'
      }, bodyChildren));
    } else {
      children.push(this.genYears());
    }

    this.$scopedSlots.default && children.push(this.genSlot());

    return h('v-card', {
      'class': {
        'picker picker--date': true,
        'picker--landscape': this.landscape,
        'picker--dark': this.dark,
        'picker--light': this.light && !this.dark
      }
    }, children);
  }
});

/***/ }),
/* 57 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    genYearIcon: function genYearIcon() {
      return this.yearIcon ? this.$createElement('v-icon', {
        props: {
          dark: true
        }
      }, this.yearIcon) : null;
    },
    genTitle: function genTitle() {
      var _this = this;

      var date = new Date(this.year, this.month, this.day);
      date = date.toLocaleString(this.locale, this.titleDateFormat);

      if (this.landscape) {
        if (date.indexOf(',') > -1) date = date.replace(',', ',<br>');else if (date.indexOf(' ') > -1) date = date.replace(' ', '<br>');
      }

      var text = this.$createElement('transition', {
        props: {
          name: 'slide-x-transition',
          mode: 'out-in'
        }
      }, [this.$createElement('div', {
        domProps: { innerHTML: date },
        key: date
      })]);

      return this.$createElement('div', {
        'class': 'picker__title'
      }, [this.$createElement('div', {
        'class': {
          'picker--date__title-year': true,
          'active': this.isSelected
        },
        on: {
          click: function click(e) {
            e.stopPropagation();
            _this.isSelected = true;
          }
        }
      }, [this.year, this.genYearIcon()]), this.$createElement('div', {
        'class': {
          'picker--date__title-date': true,
          'active': !this.isSelected
        },
        on: {
          click: function click(e) {
            e.stopPropagation();
            _this.isSelected = false;
          }
        }
      }, [text])]);
    }
  }
});

/***/ }),
/* 58 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    genHeader: function genHeader() {
      return this.$createElement('div', {
        'class': 'picker--date__header'
      }, [this.genSelector()]);
    },
    genBtn: function genBtn(change, children) {
      var _this = this;

      return this.$createElement('v-btn', {
        props: {
          dark: this.dark,
          icon: true
        },
        nativeOn: {
          click: function click(e) {
            e.stopPropagation();
            _this.tableDate = new Date(_this.tableYear, change);
          }
        }
      }, children);
    },
    genSelector: function genSelector() {
      var date = new Date(this.tableYear, this.tableMonth);
      var header = this.$createElement('div', {
        'class': 'picker--date__header-selector-date'
      }, [this.$createElement(this.computedTransition, [this.$createElement('strong', {
        key: this.tableMonth
      }, date.toLocaleString(this.locale, this.headerDateFormat))])]);

      return this.$createElement('div', {
        'class': 'picker--date__header-selector'
      }, [this.genBtn(this.tableMonth - 1, [this.$createElement('v-icon', 'chevron_left')]), header, this.genBtn(this.tableMonth + 1, [this.$createElement('v-icon', 'chevron_right')])]);
    }
  }
});

/***/ }),
/* 59 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    wheelScroll: function wheelScroll(e) {
      e.preventDefault();

      var month = this.tableMonth;

      if (e.deltaY < 0) month++;else month--;

      this.tableDate = new Date(this.tableYear, month);
    },
    touch: function touch(value) {
      this.tableDate = new Date(this.tableYear, this.tableMonth + value);
    },
    genTable: function genTable() {
      var _this = this;

      var children = [];
      var data = {
        'class': 'picker--date__table',
        directives: [{
          name: 'touch',
          value: {
            left: function left(e) {
              return e.offsetX < -15 && _this.touch(1);
            },
            right: function right(e) {
              return e.offsetX > 15 && _this.touch(-1);
            }
          }
        }]
      };

      if (this.scrollable) {
        data.on = { wheel: this.wheelScroll };
      }

      children.push(this.$createElement('table', {
        key: this.tableMonth
      }, [this.genTHead(), this.genTBody()]));

      return this.$createElement('div', data, [this.$createElement(this.computedTransition, children)]);
    },
    genTHead: function genTHead() {
      var _this2 = this;

      var days = this.narrowDays.map(function (day) {
        return _this2.$createElement('th', day);
      });
      return this.$createElement('thead', this.genTR(days));
    },
    genTBody: function genTBody() {
      var _this3 = this;

      var children = [];
      var rows = [];
      var length = new Date(this.tableYear, this.tableMonth + 1, 0).getDate();

      var day = new Date(this.tableYear, this.tableMonth).getDay() - parseInt(this.firstDayOfWeek);

      for (var i = 0; i < day; i++) {
        rows.push(this.$createElement('td'));
      }

      var _loop = function _loop(_i) {
        var date = new Date(_this3.tableYear, _this3.tableMonth, _i, 12, 0, 0, 0);
        rows.push(_this3.$createElement('td', [_this3.$createElement('button', {
          'class': {
            'btn btn--floating btn--small btn--flat': true,
            'btn--active': _this3.isActive(_i),
            'btn--current': _this3.isCurrent(_i),
            'btn--light': _this3.dark,
            'btn--disabled': !_this3.isAllowed(date)
          },
          attrs: {
            type: 'button'
          },
          domProps: {
            innerHTML: '<span class="btn__content">' + _i + '</span>'
          },
          on: {
            click: function click() {
              var day = _i < 10 ? '0' + _i : _i;
              var tableYear = _this3.tableYear;
              var tableMonth = _this3.tableMonth + 1;
              tableMonth = tableMonth < 10 ? '0' + tableMonth : tableMonth;

              _this3.inputDate = tableYear + '-' + tableMonth + '-' + day + 'T12:00:00';
              _this3.$nextTick(function () {
                return _this3.autosave && _this3.save();
              });
            }
          }
        })]));

        if (rows.length % 7 === 0) {
          children.push(_this3.genTR(rows));
          rows = [];
        }
      };

      for (var _i = 1; _i <= length; _i++) {
        _loop(_i);
      }

      if (rows.length) {
        children.push(this.genTR(rows));
      }

      children.length < 6 && children.push(this.genTR([this.$createElement('td', { domProps: { innerHTML: '&nbsp;' } })]));

      return this.$createElement('tbody', children);
    },
    genTR: function genTR() {
      var children = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      return [this.$createElement('tr', data, children)];
    },
    isActive: function isActive(i) {
      return this.tableYear === this.year && this.tableMonth === this.month && this.day === i;
    },
    isCurrent: function isCurrent(i) {
      return this.currentYear === this.tableYear && this.currentMonth === this.tableMonth && this.currentDay === i;
    }
  }
});

/***/ }),
/* 60 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    genYears: function genYears() {
      return this.$createElement('ul', {
        'class': 'picker--date__years',
        ref: 'years'
      }, this.genYearItems());
    },
    genYearItems: function genYearItems() {
      var _this = this;

      var children = [];

      var _loop = function _loop(i, length) {
        children.push(_this.$createElement('li', {
          'class': {
            active: _this.year === i
          },
          on: {
            click: function click(e) {
              e.stopPropagation();

              var tableMonth = _this.tableMonth + 1;
              var day = _this.day;
              tableMonth = tableMonth < 10 ? '0' + tableMonth : tableMonth;
              day = day < 10 ? '0' + day : day;

              _this.inputDate = i + '-' + tableMonth + '-' + day;
              _this.isSelected = false;
            }
          }
        }, i));
      };

      for (var i = this.year + 100, length = this.year - 100; i > length; i--) {
        _loop(i, length);
      }
      return children;
    }
  }
});

/***/ }),
/* 61 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_picker__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_time_title__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_time_body__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_helpers__ = __webpack_require__(0);





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-time-picker',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_picker__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_time_body__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_time_title__["a" /* default */]],

  data: function data() {
    return {
      isDragging: false,
      rotate: 0,
      originalTime: this.value,
      period: 'am',
      selectingHour: true,
      ranges: {
        hours: Object(__WEBPACK_IMPORTED_MODULE_3__util_helpers__["c" /* createRange */])(24),
        minutes: Object(__WEBPACK_IMPORTED_MODULE_3__util_helpers__["c" /* createRange */])(60)
      }
    };
  },


  props: {
    format: {
      type: String,
      default: 'ampm',
      validator: function validator(val) {
        return ['ampm', '24hr'].includes(val);
      }
    },
    allowedHours: {
      type: [Array, Object, Function],
      default: function _default() {
        return null;
      }
    },
    allowedMinutes: {
      type: [Array, Object, Function],
      default: function _default() {
        return null;
      }
    }
  },

  computed: {
    is24hr: function is24hr() {
      return this.format !== 'ampm';
    },
    is24hrAfter12: function is24hrAfter12() {
      return this.selectingHour && this.is24hr && this.hour >= 12;
    },
    divider: function divider() {
      return this.selectingHour ? 12 : 60;
    },
    degrees: function degrees() {
      return this.degreesPerUnit * Math.PI / 180;
    },
    degreesPerUnit: function degreesPerUnit() {
      return 360 / this.divider;
    },

    inputTime: {
      get: function get() {
        if (this.value && !(this.value instanceof Date)) {
          if (!this.is24hr) {
            this.period = this.value.match(/pm/) ? 'pm' : 'am';
          }

          return this.value;
        }
        var value = new Date();

        if (this.value instanceof Date) {
          value = this.value;
        }

        var hour = value.getHours();
        var minute = value.getMinutes();
        var period = '';

        if (!this.is24hr) {
          hour = hour > 12 ? hour - 12 : hour;
          period = hour > 12 ? 'pm' : 'am';
        }

        period && (this.period = period);

        hour = this.firstAllowed('hour', hour);
        minute = this.firstAllowed('minute', minute);

        return hour + ':' + minute + period;
      },
      set: function set(val) {
        return this.$emit('input', val);
      }
    },
    timeArray: function timeArray() {
      return this.inputTime.replace(/(am|pm)/, '').split(':');
    },

    hour: {
      get: function get() {
        return parseInt(this.timeArray[0]);
      },
      set: function set(val) {
        if (!this.is24hr) {
          val = val > 12 ? val - 12 : val < 1 ? 12 : val;
        } else {
          val = val < 10 ? '0' + val : val > 23 ? '00' : val;
        }

        this.inputTime = val + ':' + this.minute + (!this.is24hr ? this.period : '');
      }
    },
    minute: {
      get: function get() {
        var minute = parseInt(this.timeArray[1]);

        return minute < 10 ? '0' + minute : minute > 59 ? '00' : minute;
      },
      set: function set(val) {
        val = val < 10 ? '0' + parseInt(val) : val > 59 ? '00' : val;
        var hour = this.hour;

        if (this.is24hr && hour < 10) {
          hour = '0' + hour;
        }

        this.inputTime = hour + ':' + val + (!this.is24hr ? this.period : '');
      }
    },
    clockHand: function clockHand() {
      if (this.selectingHour) return this.degreesPerUnit * this.hour;
      return this.degreesPerUnit * this.minute;
    },
    radius: function radius() {
      return this.clockSize / 2;
    },

    clockSize: {
      get: function get() {
        return this.size;
      },
      set: function set(val) {
        this.size = val;
      }
    },
    size: function size() {
      return this.landscape ? 250 : 280;
    }
  },

  watch: {
    period: function period(val) {
      var hour = !!this.allowedHours && this.selectingHour ? this.firstAllowed('hour', this.hour - 1) : this.hour;
      this.inputTime = hour + ':' + this.minute + val;
    },
    value: function value(val) {
      if (this.isSaving) {
        this.originalTime = this.inputTime;
        this.isSaving = false;
      }
    }
  },

  methods: {
    save: function save() {
      if (this.originalTime) {
        this.originalTime = this.value;
      } else {
        this.inputTime = this.inputTime;
        this.originalTime = this.inputTime;
      }

      if (this.$parent && this.$parent.isActive) this.$parent.isActive = false;
    },
    cancel: function cancel() {
      this.inputTime = this.originalTime;
      if (this.$parent && this.$parent.isActive) this.$parent.isActive = false;
    },
    isAllowed: function isAllowed(type, value) {
      var allowed = this['allowed' + (type.charAt(0).toUpperCase() + type.slice(1)) + 's'];

      if (!allowed) return true;

      if (Array.isArray(allowed)) {
        return !!allowed.find(function (v) {
          return v === value;
        });
      } else if (allowed instanceof Function) {
        return allowed(value);
      } else if (allowed === Object(allowed)) {
        var range = type === 'minute' ? this.ranges.minutes : this.ranges.hours;
        var mod = type === 'minute' ? 60 : 24;

        if (allowed.min === String(allowed.min)) {
          allowed.min = this.convert12to24hr(allowed.min);
        }

        if (allowed.max === String(allowed.max)) {
          allowed.max = this.convert12to24hr(allowed.max);
        }

        var steps = allowed.max - allowed.min;
        value = type === 'hour' && !this.is24hr && this.period === 'pm' ? value + 12 : value;

        for (var i = 0; i <= steps; i++) {
          var index = (allowed.min + i) % mod;
          if (range[index] === value) return true;
        }

        return false;
      }

      return true;
    },
    convert12to24hr: function convert12to24hr(input) {
      input = input.toLowerCase();
      var pm = input.indexOf('pm') !== -1;
      var hour = parseInt(input.slice(0, input.indexOf(pm ? 'pm' : 'am')));

      return pm ? hour + 12 : hour;
    },
    generateRange: function generateRange(type, start) {
      var range = type === 'hour' ? this.ranges.hours : this.ranges.minutes;
      var offset = 1;

      if (type === 'hour' && !this.is24hr) {
        range = range.slice(1, 13);
        offset = 0;
      }

      return range.slice(start + offset, range.length).concat(range.slice(0, start + offset));
    },
    firstAllowed: function firstAllowed(type, value) {
      var _this = this;

      var allowed = this['allowed' + (type.charAt(0).toUpperCase() + type.slice(1)) + 's'];

      if (!allowed) return value;

      var range = this.generateRange(type, value);

      var first = range.find(function (v) {
        return _this.isAllowed(type, v);
      });

      return first || value;
    }
  },

  render: function render(h) {
    var children = [this.genBody()];

    !this.noTitle && children.unshift(this.genTitle());
    this.$scopedSlots.default && children.push(this.genSlot());

    return h('v-card', {
      'class': {
        'picker picker--time': true,
        'picker--landscape': this.landscape,
        'picker--dark': this.dark,
        'picker--light': this.light && !this.dark,
        'picker--time--hours': this.selectingHour
      }
    }, children);
  }
});

/***/ }),
/* 62 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    genTitle: function genTitle() {
      var children = [this.genTime()];

      if (this.format === 'ampm') {
        children.push(this.genAMPM());
      }

      return this.$createElement('div', {
        'class': 'picker__title'
      }, children);
    },
    genTime: function genTime() {
      var _this = this;

      var hour = this.hour;

      if (this.is24hr && hour < 10) {
        hour = '0' + hour;
      }

      return this.$createElement('div', {
        'class': 'picker--time__title'
      }, [this.$createElement('span', {
        'class': { active: this.selectingHour },
        on: {
          click: function click() {
            return _this.selectingHour = true;
          }
        }
      }, hour), this.$createElement('span', {
        'class': { active: !this.selectingHour },
        on: {
          click: function click() {
            return _this.selectingHour = false;
          }
        }
      }, ':' + this.minute)]);
    },
    genAMPM: function genAMPM() {
      return this.$createElement('div', [this.genPeriod('am'), this.genPeriod('pm')]);
    },
    genPeriod: function genPeriod(period) {
      var _this2 = this;

      return this.$createElement('span', {
        'class': { active: this.period === period },
        on: { click: function click() {
            return _this2.period = period;
          } }
      }, period.toUpperCase());
    }
  }
});

/***/ }),
/* 63 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      hasChanged: false
    };
  },

  methods: {
    genBody: function genBody() {
      var _this = this;

      var children = [this.genHand(this.selectingHour ? 'hour' : 'minute')];
      var data = {
        'class': 'picker--time__clock',
        on: {
          mousedown: this.onMouseDown,
          mouseup: this.onMouseUp,
          mouseleave: function mouseleave() {
            _this.isDragging && _this.onMouseUp();
          },
          touchstart: this.onMouseDown,
          touchend: this.onMouseUp,
          mousemove: this.onDragMove,
          touchmove: this.onDragMove
        },
        key: this.selectingHour ? 'hour' : 'minute',
        ref: 'clock'
      };

      this.selectingHour && children.push(this.genHours()) || children.push(this.genMinutes());

      if (this.scrollable) {
        data.on.wheel = function (e) {
          e.preventDefault();

          var diff = e.wheelDelta > 0 ? 1 : -1;
          var changing = _this.selectingHour ? 'changeHour' : 'changeMinute';

          _this[changing](diff);
        };
      }

      return this.$createElement('div', {
        'class': 'picker__body'
      }, [this.$createElement('v-fade-transition', {
        props: { mode: 'out-in' }
      }, [this.$createElement('div', data, children)])]);
    },
    genHand: function genHand(type) {
      var scale = this.is24hrAfter12 ? 'scaleY(0.6)' : '';
      return [this.$createElement('div', {
        'class': 'picker--time__clock-hand ' + type,
        style: {
          transform: 'rotate(' + this.clockHand + 'deg) ' + scale
        }
      })];
    },
    genHours: function genHours() {
      var hours = this.is24hr ? 24 : 12;
      var children = [];
      var start = 0;

      if (hours === 12) {
        hours++;
        start = 1;
      }

      for (var i = start; i < hours; i++) {
        children.push(this.$createElement('span', {
          'class': {
            'active': i === this.hour,
            'disabled': !this.isAllowed('hour', i)
          },
          style: this.getTransform(i),
          domProps: { innerHTML: '<span>' + i + '</span>' }
        }));
      }

      return children;
    },
    genMinutes: function genMinutes() {
      var children = [];

      for (var i = 0; i < 60; i = i + 5) {
        var num = i;

        if (num < 10) num = '0' + num;
        if (num === 60) num = '00';

        children.push(this.$createElement('span', {
          'class': {
            'active': num.toString() === this.minute.toString(),
            'disabled': !this.isAllowed('minute', i)
          },
          style: this.getTransform(i),
          domProps: { innerHTML: '<span>' + num + '</span>' }
        }));
      }

      return children;
    },
    getTransform: function getTransform(i) {
      var _getPosition = this.getPosition(i),
          x = _getPosition.x,
          y = _getPosition.y;

      return { transform: 'translate(' + x + 'px, ' + y + 'px)' };
    },
    getPosition: function getPosition(i) {
      var radiusPercentage = this.selectingHour && this.is24hr && i >= 12 ? 0.5 : 0.8;
      var r = this.radius * radiusPercentage;
      i = this.selectingHour && this.is24hr ? i % 12 : i;
      return {
        x: Math.round(Math.sin(i * this.degrees) * r),
        y: Math.round(-Math.cos(i * this.degrees) * r)
      };
    },
    changeHour: function changeHour(time) {
      var _this2 = this;

      var range = this.generateRange('hour', this.hour);

      time < 0 && (range = range.reverse().slice(1));
      this.hour = range.find(function (h) {
        return _this2.allowedHours ? _this2.isAllowed('hour', h) : true;
      });

      return true;
    },
    changeMinute: function changeMinute(time) {
      var _this3 = this;

      var current = Number(this.minute);
      var range = this.generateRange('minute', current);

      time < 0 && (range = range.reverse().slice(1));
      var minute = range.find(function (m) {
        return _this3.allowedMinutes ? _this3.isAllowed('minute', m) : true;
      });

      this.minute = minute < 10 ? '0' + minute : minute;

      return true;
    },
    onMouseDown: function onMouseDown(e) {
      e.preventDefault();

      this.isDragging = true;
      this.onDragMove(e);
    },
    onMouseUp: function onMouseUp() {
      this.isDragging = false;
      !this.selectingHour && this.autosave && this.save();
      if (this.hasChanged) {
        this.selectingHour = false;
        this.hasChanged = false;
      }
    },
    onDragMove: function onDragMove(e) {
      e.preventDefault();
      if (!this.isDragging && e.type !== 'click') return;

      var rect = this.$refs.clock.getBoundingClientRect();
      var center = { x: rect.width / 2, y: 0 - rect.width / 2 };
      var clientY = 'touches' in e ? e.touches[0].clientY : e.clientY;
      var clientX = 'touches' in e ? e.touches[0].clientX : e.clientX;
      var coords = {
        y: rect.top - clientY,
        x: clientX - rect.left
      };

      var selecting = this.selectingHour ? 'hour' : 'minute';
      var value = Math.round(this.angle(center, coords) / this.degreesPerUnit);

      if (this.selectingHour && this.is24hr) {
        var insideClick = this.euclidean(center, coords) / this.radius < 0.65;
        value = insideClick ? value + 12 : value;

        // Necessary to fix edge case when selecting left part of 0 and 12
        value = this.angle(center, coords) >= 345 ? (value + 12) % 24 : value;
      }

      if (this.isAllowed(selecting, value)) {
        this[selecting] = value;
        this.hasChanged = true;
      }
    },
    euclidean: function euclidean(p0, p1) {
      var dx = Math.abs(p1.x - p0.x);
      var dy = Math.abs(p1.y - p0.y);

      return Math.sqrt(dx * dx + dy * dy);
    },
    angle: function angle(center, p1) {
      var p0 = {
        x: center.x,
        y: center.y + Math.sqrt(Math.abs(p1.x - center.x) * Math.abs(p1.x - center.x) + Math.abs(p1.y - center.y) * Math.abs(p1.y - center.y))
      };

      var value = 2 * Math.atan2(p1.y - p0.y, p1.x - p0.x);
      return Math.abs(value * 180 / Math.PI);
    }
  }
});

/***/ }),
/* 64 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VDialog__ = __webpack_require__(65);


/* harmony default export */ __webpack_exports__["a"] = ({
  VDialog: __WEBPACK_IMPORTED_MODULE_0__VDialog__["a" /* default */]
});

/***/ }),
/* 65 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_bootable__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_detachable__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_overlayable__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_toggleable__ = __webpack_require__(2);





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-dialog',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_bootable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_detachable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_overlayable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_toggleable__["a" /* default */]],

  props: {
    disabled: Boolean,
    persistent: Boolean,
    fullscreen: Boolean,
    fullWidth: Boolean,
    lazy: Boolean,
    origin: {
      type: String,
      default: 'center center'
    },
    width: {
      type: [String, Number],
      default: 290
    },
    scrollable: Boolean,
    transition: {
      type: [String, Boolean],
      default: 'dialog-transition'
    }
  },

  computed: {
    classes: function classes() {
      return {
        'dialog': true,
        'dialog--active': this.isActive,
        'dialog--persistent': this.persistent,
        'dialog--fullscreen': this.fullscreen,
        'dialog--stacked-actions': this.stackedActions && !this.fullscreen,
        'dialog--scrollable': this.scrollable
      };
    }
  },

  watch: {
    isActive: function isActive(val) {
      if (val) {
        !this.fullscreen && !this.hideOverlay && this.genOverlay();
        this.fullscreen && this.hideScroll();
      } else {
        if (!this.fullscreen) this.removeOverlay();else this.showScroll();
      }
    }
  },

  mounted: function mounted() {
    var _this = this;

    this.isBooted = this.isActive;
    this.$vuetify.load(function () {
      return _this.isActive && _this.genOverlay();
    });
  },


  methods: {
    closeConditional: function closeConditional(e) {
      // close dialog if !persistent and clicked outside
      return !this.persistent;
    }
  },

  render: function render(h) {
    var _this2 = this;

    var children = [];
    var data = {
      'class': this.classes,
      ref: 'dialog',
      directives: [{ name: 'click-outside', value: this.closeConditional }, { name: 'show', value: this.isActive }]
    };

    if (!this.fullscreen) {
      data.style = {
        width: isNaN(this.width) ? this.width : this.width + 'px'
      };
    }

    if (this.$slots.activator) {
      children.push(h('div', {
        'class': 'dialog__activator',
        on: {
          click: function click(e) {
            e.stopPropagation();
            if (!_this2.disabled) _this2.isActive = !_this2.isActive;
          }
        }
      }, [this.$slots.activator]));
    }

    var dialog = h('transition', {
      props: {
        name: this.transition || '', // If false, show nothing
        origin: this.origin
      }
    }, [h('div', data, this.showLazyContent(this.$slots.default))]);

    children.push(h('div', {
      'class': ('dialog__content ' + this.contentClass).trim(),
      ref: 'content'
    }, [dialog]));

    return h('div', {
      'class': 'dialog__container',
      style: {
        display: !this.$slots.activator && 'none' || this.fullWidth ? 'block' : 'inline-block'
      }
    }, children);
  }
});

/***/ }),
/* 66 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VDivider__ = __webpack_require__(67);


/* harmony default export */ __webpack_exports__["a"] = ({
  VDivider: __WEBPACK_IMPORTED_MODULE_0__VDivider__["a" /* default */]
});

/***/ }),
/* 67 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);


/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */]],

  props: {
    inset: Boolean
  },

  render: function render(h, _ref) {
    var props = _ref.props,
        data = _ref.data,
        children = _ref.children;

    data.staticClass = ('divider ' + (data.staticClass || '')).trim();

    if (props.dark) data.staticClass += ' theme--dark';
    if (props.inset) data.staticClass += ' divider--inset';
    if (props.light) data.staticClass += ' theme--light';

    return h('hr', data);
  }
});

/***/ }),
/* 68 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VExpansionPanel__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VExpansionPanelContent__ = __webpack_require__(70);



/* harmony default export */ __webpack_exports__["a"] = ({
  VExpansionPanel: __WEBPACK_IMPORTED_MODULE_0__VExpansionPanel__["a" /* default */],
  VExpansionPanelContent: __WEBPACK_IMPORTED_MODULE_1__VExpansionPanelContent__["a" /* default */]
});

/***/ }),
/* 69 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-expansion-panel',

  props: {
    expand: Boolean
  },

  computed: {
    params: function params() {
      return {
        expand: this.expand
      };
    }
  },

  render: function render(h) {
    return h('ul', {
      'class': 'expansion-panel'
    }, this.$slots.default);
  }
});

/***/ }),
/* 70 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_transitions__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__ = __webpack_require__(2);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-expansion-panel-content',

  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__["a" /* default */]],

  data: function data() {
    return {
      height: 'auto'
    };
  },


  props: {
    ripple: Boolean
  },

  computed: {
    classes: function classes() {
      return {
        'expansion-panel__header': true,
        'expansion-panel__header--active': this.isActive
      };
    }
  },

  methods: {
    closeConditional: function closeConditional(e) {
      return this.$parent.$el.contains(e.target) && !this.$parent.expand && !this.$el.contains(e.target);
    },
    toggle: function toggle() {
      this.isActive = !this.isActive;
    },
    genHeader: function genHeader(h) {
      var _this = this;

      return h('div', {
        class: this.classes,
        directives: [{
          name: 'click-outside',
          value: this.closeConditional
        }, {
          name: 'ripple',
          value: this.ripple
        }],
        on: {
          click: function click() {
            _this.isActive = !_this.isActive;
          }
        }
      }, [this.$slots.header]);
    },
    genBody: function genBody(h) {
      return h('div', {
        ref: 'body',
        class: 'expansion-panel__body',
        directives: [{
          name: 'show',
          value: this.isActive
        }]
      }, [this.$slots.default]);
    }
  },

  render: function render(h) {
    var children = [];

    this.$slots.header && children.push(this.genHeader(h));
    children.push(h(__WEBPACK_IMPORTED_MODULE_0__components_transitions__["a" /* VExpandTransition */], [this.genBody(h)]));

    return h('li', children);
  }
});

/***/ }),
/* 71 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);


/* harmony default export */ __webpack_exports__["a"] = ({
  enter: function enter(el, done) {
    // Remove initial transition
    el.style.transition = 'none';
    Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["a" /* addOnceEventListener */])(el, 'transitionend', done);

    // Get height that is to be scrolled
    el.style.overflow = 'hidden';
    el.style.height = null;
    el.style.display = 'block';
    var height = el.clientHeight + 'px';
    el.style.height = 0;
    el.style.transition = null;

    setTimeout(function () {
      return el.style.height = height;
    }, 50);
  },
  afterEnter: function afterEnter(el) {
    el.style.height = 'auto';
    el.style.overflow = null;
  },
  leave: function leave(el, done) {
    // Remove initial transition
    el.style.transition = 'none';
    Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["a" /* addOnceEventListener */])(el, 'transitionend', done);

    // Set height before we transition to 0
    el.style.overflow = 'hidden';
    el.style.height = el.clientHeight + 'px';
    el.style.transition = null;

    setTimeout(function () {
      return el.style.height = 0;
    }, 50);
  }
});

/***/ }),
/* 72 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VFooter__ = __webpack_require__(73);


/* harmony default export */ __webpack_exports__["a"] = ({
  VFooter: __WEBPACK_IMPORTED_MODULE_0__VFooter__["a" /* default */]
});

/***/ }),
/* 73 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  props: {
    absolute: Boolean,
    fixed: Boolean
  },

  render: function render(h, _ref) {
    var data = _ref.data,
        props = _ref.props,
        children = _ref.children;

    data.staticClass = ('footer ' + (data.staticClass || '')).trim();

    if (props.absolute) data.staticClass += ' footer--absolute';
    if (props.fixed) data.staticClass += ' footer--fixed';

    return h('footer', data, children);
  }
});

/***/ }),
/* 74 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);


var Grid = function Grid(name) {
  return {
    functional: true,

    props: {
      id: String
    },

    render: function render(h, _ref) {
      var props = _ref.props,
          data = _ref.data,
          children = _ref.children;

      data.staticClass = (name + ' ' + (data.staticClass || '')).trim();

      if (data.attrs) {
        data.staticClass += ' ' + Object.keys(data.attrs).join(' ');
        delete data.attrs;
      }

      if (props.id) {
        data.domProps = data.domProps || {};
        data.domProps.id = props.id;
      }

      return h('div', data, children);
    }
  };
};

var VContainer = Grid('container');
var VFlex = Grid('flex');
var VLayout = Grid('layout');
var VSpacer = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('spacer');

/* harmony default export */ __webpack_exports__["a"] = ({
  VContainer: VContainer,
  VFlex: VFlex,
  VLayout: VLayout,
  VSpacer: VSpacer
});

/***/ }),
/* 75 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VIcon__ = __webpack_require__(3);


/* harmony default export */ __webpack_exports__["a"] = ({
  VIcon: __WEBPACK_IMPORTED_MODULE_0__VIcon__["a" /* default */]
});

/***/ }),
/* 76 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_transitions__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__ = __webpack_require__(2);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-list-group',

  inject: ['listClick', 'listClose'],

  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__["a" /* default */]],

  data: function data() {
    return {
      isBooted: this.value
    };
  },


  props: {
    group: String,
    lazy: Boolean,
    noAction: Boolean
  },

  computed: {
    classes: function classes() {
      return {
        'list--group__header': true,
        'list--group__header--active': this.isActive,
        'list--group__header--no-action': this.noAction
      };
    }
  },

  watch: {
    isActive: function isActive() {
      this.isBooted = true;

      if (!this.isActive) {
        this.listClose(this._uid);
      }
    },
    $route: function $route(to) {
      var isActive = this.matchRoute(to.path);

      if (this.group) {
        if (isActive && this.isActive !== isActive) {
          this.listClick(this._uid);
        }
        this.isActive = isActive;
      }
    }
  },

  mounted: function mounted() {
    if (this.group) {
      this.isActive = this.matchRoute(this.$route.path);
    }

    if (this.isActive) {
      this.listClick(this._uid);
    }
  },


  methods: {
    click: function click() {
      var _this = this;

      if (!this.$refs.item.querySelector('.list__tile--disabled')) {
        requestAnimationFrame(function () {
          return _this.listClick(_this._uid);
        });
      }
    },
    toggle: function toggle(uid) {
      this.isActive = this._uid === uid;
    },
    matchRoute: function matchRoute(to) {
      if (!this.group) return false;
      return to.match(this.group) !== null;
    }
  },

  render: function render(h) {
    var group = h('ul', {
      'class': 'list list--group',
      directives: [{
        name: 'show',
        value: this.isActive
      }],
      ref: 'group'
    }, [this.lazy && !this.isBooted ? null : this.$slots.default]);

    var item = h('div', {
      'class': this.classes,
      on: Object.assign({}, { click: this.click }, this.$listeners),
      ref: 'item'
    }, [this.$slots.item]);

    var transition = h(__WEBPACK_IMPORTED_MODULE_0__components_transitions__["a" /* VExpandTransition */], [group]);

    return h('div', { 'class': 'list--group__container' }, [item, transition]);
  }
});

/***/ }),
/* 77 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);


function directive(el, binding) {
  var config = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["f" /* directiveConfig */])(binding, {
    icon: false,
    left: false,
    bottom: false,
    overlap: false,
    visible: true
  });

  if (!config.visible || binding.expression && !binding.value) {
    return unbind(el);
  }

  if (config.overlap) el.classList.add('badge--overlap');
  if (config.icon) el.classList.add('badge--icon');
  if (config.left) el.classList.add('badge--left');
  if (config.bottom) el.classList.add('badge--bottom');

  el.dataset.badge = config.value;
  el.classList.add('badge');
}

function unbind(el) {
  el.removeAttribute('data-badge');
  el.classList.remove('badge');
}

/* harmony default export */ __webpack_exports__["a"] = ({
  bind: directive,
  updated: directive,
  componentUpdated: directive,
  unbind: unbind
});

/***/ }),
/* 78 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function inserted(el, binding) {
  var debounce = function debounce(cb) {
    return setTimeout(cb, 50);
  };
  var onResize = function onResize() {
    clearTimeout(debounce);
    debounce(binding.value);
  };

  window.addEventListener('resize', onResize, { passive: true });
  el._onResize = onResize;
}

function unbind(el, binding) {
  window.removeEventListener('resize', el._onResize);
}

/* harmony default export */ __webpack_exports__["a"] = ({
  inserted: inserted,
  unbind: unbind
});

/***/ }),
/* 79 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function inserted(el, binding) {
  var callback = typeof binding.value === 'function' ? binding.value : binding.value.callback;
  var options = binding.value.options || { passive: true };
  var target = binding.value.target || window;
  if (target === 'undefined') return;

  if (target !== window) {
    target = document.querySelector(target);
  }

  target.addEventListener('scroll', callback, options);

  el._onScroll = {
    target: target,
    options: options
  };
}

function unbind(el, binding) {
  var _el$_onScroll = el._onScroll,
      target = _el$_onScroll.target,
      options = _el$_onScroll.options;


  target.removeEventListener('scroll', binding.callback, options);
}

/* harmony default export */ __webpack_exports__["a"] = ({
  inserted: inserted,
  unbind: unbind
});

/***/ }),
/* 80 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);


function directive(el, binding) {
  var config = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["f" /* directiveConfig */])(binding, {
    top: true,
    visible: true
  });

  if (!config.visible || binding.expression && !binding.value) {
    return unbind(el);
  }

  unbind(el, binding, config);

  el.dataset.tooltip = config.html;
  el.dataset['tooltipLocation'] = config.value;
}

function unbind(el) {
  el.removeAttribute('data-tooltip');
  el.removeAttribute('data-tooltip-location');
}

/* harmony default export */ __webpack_exports__["a"] = ({
  bind: directive,
  updated: directive,
  componentUpdated: directive,
  unbind: unbind
});

/***/ }),
/* 81 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var touchstart = function touchstart(event, wrapper) {
  var touch = event.changedTouches[0];
  wrapper.touchstartX = touch.clientX;
  wrapper.touchstartY = touch.clientY;

  wrapper.start && wrapper.start(Object.assign(event, wrapper));
};

var touchend = function touchend(event, wrapper) {
  var touch = event.changedTouches[0];
  wrapper.touchendX = touch.clientX;
  wrapper.touchendY = touch.clientY;

  wrapper.end && wrapper.end(Object.assign(event, wrapper));

  handleGesture(wrapper);
};

var touchmove = function touchmove(event, wrapper) {
  var touch = event.changedTouches[0];
  wrapper.touchmoveX = touch.clientX;
  wrapper.touchmoveY = touch.clientY;

  wrapper.move && wrapper.move(Object.assign(event, wrapper));
};

var handleGesture = function handleGesture(wrapper) {
  var touchstartX = wrapper.touchstartX,
      touchendX = wrapper.touchendX,
      touchstartY = wrapper.touchstartY,
      touchendY = wrapper.touchendY;

  wrapper.offsetX = touchendX - touchstartX;
  wrapper.offsetY = touchendY - touchstartY;

  if (touchendX < touchstartX) {
    wrapper.left && wrapper.left(wrapper);
  }
  if (touchendX > touchstartX) {
    wrapper.right && wrapper.right(wrapper);
  }
  if (touchendY < touchstartY) {
    wrapper.up && wrapper.up(wrapper);
  }
  if (touchendY > touchstartY) {
    wrapper.down && wrapper.down(wrapper);
  }
};

function inserted(el, _ref) {
  var value = _ref.value;

  var wrapper = {
    touchstartX: 0,
    touchstartY: 0,
    touchendX: 0,
    touchendY: 0,
    touchmoveX: 0,
    touchmoveY: 0,
    offsetX: 0,
    offsetY: 0,
    left: value.left,
    right: value.right,
    up: value.up,
    down: value.down,
    start: value.start,
    move: value.move,
    end: value.end
  };

  var target = value.parent ? el.parentNode : el;
  var options = value.options || {};

  target.addEventListener('touchstart', function (e) {
    return touchstart(e, wrapper);
  }, options);
  target.addEventListener('touchend', function (e) {
    return touchend(e, wrapper);
  }, options);
  target.addEventListener('touchmove', function (e) {
    return touchmove(e, wrapper);
  }, options);
}

function unbind(el, _ref2) {
  var value = _ref2.value;

  var target = value.parent ? el.parentNode : el;

  if (!target) return;

  target.removeEventListener('touchstart', touchstart);
  target.removeEventListener('touchend', touchend);
  target.removeEventListener('touchmove', touchmove);
}

/* harmony default export */ __webpack_exports__["a"] = ({
  inserted: inserted,
  unbind: unbind
});

/***/ }),
/* 82 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VMenu_js__ = __webpack_require__(22);


/* harmony default export */ __webpack_exports__["a"] = ({
  VMenu: __WEBPACK_IMPORTED_MODULE_0__VMenu_js__["a" /* default */]
});

/***/ }),
/* 83 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    getActivator: function getActivator() {
      if (this.activator) return this.activator;
      return this.$refs.activator.children ? this.$refs.activator.children[0] : this.$refs.activator;
    },
    activatorClickHandler: function activatorClickHandler(e) {
      if (this.disabled) return;else if (this.openOnClick && !this.isActive) {
        this.isActive = true;
        this.absoluteX = e.clientX;
        this.absoluteY = e.clientY;
      } else if (this.closeOnClick && this.isActive) this.isActive = false;
    },
    mouseEnterHandler: function mouseEnterHandler(e) {
      if (this.disabled || this.hasJustFocused) return;
      this.hasJustFocused = true;
      this.isActive = true;
    },
    mouseLeaveHandler: function mouseLeaveHandler(e) {
      if (this.isContentActive) return;
      this.isActive = false;
    },
    addActivatorEvents: function addActivatorEvents() {
      var activator = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      if (!activator) return;
      activator.addEventListener('click', this.activatorClickHandler);
    },
    removeActivatorEvents: function removeActivatorEvents() {
      var activator = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      if (!activator) return;
      activator.removeEventListener('click', this.activatorClickHandler);
    }
  }
});

/***/ }),
/* 84 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    genActivator: function genActivator() {
      if (!this.$slots.activator) return null;

      var options = {
        'class': {
          'menu__activator--active': this.hasJustFocused || this.isActive
        },
        staticClass: 'menu__activator',
        ref: 'activator',
        slot: 'activator',
        on: {}
      };

      if (this.openOnHover) {
        options.on['mouseenter'] = this.mouseEnterHandler;
        options.on['mouseleave'] = this.mouseLeaveHandler;
      } else if (this.openOnClick) {
        options.on['click'] = this.activatorClickHandler;
      }

      return this.$createElement('div', options, this.$slots.activator);
    },
    genTransition: function genTransition() {
      return this.$createElement('transition', {
        props: {
          name: this.transition,
          origin: this.origin
        }
      }, [this.genContent()]);
    },
    genContent: function genContent() {
      var _this = this;

      var booted = this.lazy && this.isBooted || !this.lazy;
      return this.$createElement('div', {
        'class': ('menu__content ' + this.contentClass).trim(),
        ref: 'content',
        style: this.styles,
        directives: [{
          name: 'show',
          value: this.isContentActive
        }],
        on: {
          click: function click(e) {
            e.stopPropagation();
            if (e.target.getAttribute('disabled')) return;
            if (_this.closeOnContentClick) _this.isActive = false;
          },
          mouseleave: function mouseleave(e) {
            _this.openOnHover && (_this.isActive = false);
          }
        }
      }, [booted ? this.$slots.default : null]);
    }
  }
});

/***/ }),
/* 85 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    // Revisit this
    calculateScroll: function calculateScroll() {
      if (this.selectedIndex === null) return;

      var scrollTop = 0;

      if (this.selectedIndex >= this.stopIndex) {
        scrollTop = this.$refs.content.scrollHeight;
      } else if (this.selectedIndex > this.startIndex) {
        scrollTop = this.selectedIndex * 48 - 56;
      }

      this.$refs.content.scrollTop = scrollTop;
    },
    calcLeftAuto: function calcLeftAuto() {
      var a = this.dimensions.activator;

      return parseInt(a.left - 16);
    },
    calcTopAuto: function calcTopAuto() {
      if (!this.hasActivator) return this.calcTop(true);

      var selectedIndex = Array.from(this.tiles).findIndex(function (n) {
        return n.classList.contains('list__tile--active');
      });

      if (selectedIndex === -1) {
        this.selectedIndex = null;

        return this.calcTop(true);
      }

      this.selectedIndex = selectedIndex;
      var actingIndex = selectedIndex;

      var offsetPadding = 1;
      // #708 Stop index should vary by tile length
      this.stopIndex = this.tiles.length > 4 ? this.tiles.length - 4 : this.tiles.length;

      if (selectedIndex > this.startIndex && selectedIndex < this.stopIndex) {
        actingIndex = 2;
        offsetPadding = 41;
      } else if (selectedIndex >= this.stopIndex) {
        offsetPadding = 9;
        actingIndex = selectedIndex - this.stopIndex;
      }

      return this.calcTop(true) + offsetPadding - actingIndex * 48;
    },
    calcLeft: function calcLeft() {
      if (this.auto) return this.calcLeftAuto();

      var a = this.dimensions.activator;
      var c = this.dimensions.content;
      var left = this.left ? a.right - c.width : a.left;

      if (this.offsetX) left += this.left ? -a.width : a.width;
      if (this.nudgeLeft) left += this.nudgeLeft;
      if (this.nudgeRight) left -= this.nudgeRight;

      return this.calcXOverflow(left);
    },
    calcTop: function calcTop(force) {
      if (this.auto && !force) return this.calcTopAuto();

      var a = this.dimensions.activator;
      var c = this.dimensions.content;
      var top = this.top ? a.bottom - c.height : a.top;

      if (this.offsetY) top += this.top ? -a.height : a.height;
      if (this.nudgeTop) top -= this.nudgeTop;
      if (this.nudgeBottom) top += this.nudgeBottom;

      var defined = typeof window !== 'undefined';
      var pageYOffset = defined ? window.pageYOffset : 0;

      return this.calcYOverflow(top) + pageYOffset;
    },
    calcXOverflow: function calcXOverflow(left) {
      var hasWindow = typeof window !== 'undefined';
      var innerWidth = hasWindow ? window.innerWidth : 0;
      var maxWidth = Math.max(this.dimensions.content.width, this.calculatedMinWidth, parseInt(this.maxWidth) || 0);
      var totalWidth = left + maxWidth;
      var availableWidth = totalWidth - innerWidth;

      if ((!this.left || this.right) && availableWidth > 0) {
        left = innerWidth - maxWidth - (innerWidth > 1024 ? 30 : 12) // Account for scrollbar
        ;
      } else if (this.left && left < 0) left = 12;

      return left;
    },
    calcYOverflow: function calcYOverflow(top) {
      var totalHeight = top + this.dimensions.content.height;
      var defined = typeof window !== 'undefined';
      var innerHeight = defined ? window.innerHeight : 0;

      if (this.top && top < 0) top = 12;else if ((!this.top || this.bottom) && innerHeight < totalHeight) {
        top = innerHeight - this.dimensions.content.height;
      }

      return top < 12 ? 12 : top;
    },
    sneakPeek: function sneakPeek(cb) {
      var _this = this;

      requestAnimationFrame(function () {
        var el = _this.$refs.content;
        var currentDisplay = el.style.display;

        el.style.display = 'inline-block';
        cb();
        el.style.display = currentDisplay;
      });
    },
    absolutePosition: function absolutePosition() {
      return {
        offsetTop: 0,
        scrollHeight: 0,
        top: this.positionY || this.absoluteY,
        bottom: this.positionY || this.absoluteY,
        left: this.positionX || this.absoluteX,
        right: this.positionX || this.absoluteX,
        height: 0,
        width: 0
      };
    },
    updateDimensions: function updateDimensions() {
      var _this2 = this;

      this.sneakPeek(function () {
        _this2.dimensions = {
          activator: !_this2.hasActivator || _this2.positionAbsolutely ? _this2.absolutePosition() : _this2.measure(_this2.getActivator()),
          content: _this2.measure(_this2.$refs.content)
        };
      });
    }
  }
});

/***/ }),
/* 86 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    measure: function measure(el, selector) {
      var getParent = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

      el = selector ? el.querySelector(selector) : el;

      if (!el) return null;

      var _el$getBoundingClient = el.getBoundingClientRect(),
          top = _el$getBoundingClient.top,
          bottom = _el$getBoundingClient.bottom,
          left = _el$getBoundingClient.left,
          right = _el$getBoundingClient.right,
          height = _el$getBoundingClient.height,
          width = _el$getBoundingClient.width;

      return {
        offsetTop: el.offsetTop,
        scrollHeight: el.scrollHeight,
        top: top, bottom: bottom, left: left, right: right, height: height, width: width
      };
    }
  }
});

/***/ }),
/* 87 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      listIndex: -1,
      isUsingKeys: false,
      tiles: []
    };
  },

  watch: {
    isActive: function isActive(val) {
      if (!val) this.listIndex = -1;
    },
    listIndex: function listIndex(next, prev) {
      // For infinite scroll and autocomplete, re-evaluate children
      this.getTiles();

      if (next in this.tiles) {
        this.tiles[next].classList.add('list__tile--highlighted');
        this.$refs.content.scrollTop = next * 48;
      }

      prev in this.tiles && this.tiles[prev].classList.remove('list__tile--highlighted');
    }
  },

  methods: {
    changeListIndex: function changeListIndex(e) {
      [40, 38, 13].includes(e.keyCode) && e.preventDefault();
      e.keyCode === 32 && !this.isActive && e.preventDefault();

      if (this.listIndex === -1) this.setActiveListIndex();
      if ([27, 9].includes(e.keyCode)) return this.isActive = false;else if (!this.isActive && [13, 32].includes(e.keyCode)) {
        return this.isActive = true;
      }

      if (e.keyCode === 40 && this.listIndex < this.tiles.length - 1) {
        this.listIndex++;
      } else if (e.keyCode === 38 && this.listIndex > 0) {
        this.listIndex--;
      } else if (e.keyCode === 13 && this.listIndex !== -1) {
        this.tiles[this.listIndex].click();
      }
    },
    getTiles: function getTiles() {
      this.tiles = this.$refs.content.querySelectorAll('.list__tile');
    },
    setActiveListIndex: function setActiveListIndex() {
      var _this = this;

      this.tiles.forEach(function (t, i) {
        if (t.classList.contains('list__tile--active')) {
          _this.listIndex = i;
          return;
        }
      });
    }
  }
});

/***/ }),
/* 88 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VNavigationDrawer__ = __webpack_require__(89);


/* harmony default export */ __webpack_exports__["a"] = ({
  VNavigationDrawer: __WEBPACK_IMPORTED_MODULE_0__VNavigationDrawer__["a" /* default */]
});

/***/ }),
/* 89 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_overlayable__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_themeable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__directives__ = __webpack_require__(4);




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-navigation-drawer',

  directives: {
    Resize: __WEBPACK_IMPORTED_MODULE_2__directives__["Resize"]
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_overlayable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_themeable__["a" /* default */]],

  data: function data() {
    return {
      isActive: this.value,
      isBooted: false,
      isMobile: false,
      touchArea: {
        left: 0,
        right: 0
      }
    };
  },


  props: {
    absolute: Boolean,
    clipped: Boolean,
    disableRouteWatcher: Boolean,
    enableResizeWatcher: Boolean,
    height: String,
    floating: Boolean,
    miniVariant: Boolean,
    mobileBreakPoint: {
      type: Number,
      default: 1024
    },
    permanent: Boolean,
    persistent: Boolean,
    right: Boolean,
    temporary: Boolean,
    touchless: Boolean,
    value: { required: false }
  },

  computed: {
    calculatedHeight: function calculatedHeight() {
      return this.height || '100%';
    },
    classes: function classes() {
      return {
        'navigation-drawer': true,
        'navigation-drawer--absolute': this.absolute,
        'navigation-drawer--clipped': this.clipped,
        'navigation-drawer--close': !this.isActive,
        'navigation-drawer--floating': this.floating,
        'navigation-drawer--is-booted': this.isBooted,
        'navigation-drawer--is-mobile': this.isMobile,
        'navigation-drawer--mini-variant': this.miniVariant,
        'navigation-drawer--open': this.isActive,
        'navigation-drawer--permanent': this.permanent,
        'navigation-drawer--persistent': this.persistent,
        'navigation-drawer--right': this.right,
        'navigation-drawer--temporary': this.temporary,
        'theme--dark': this.dark,
        'theme--light': this.light
      };
    },
    showOverlay: function showOverlay() {
      return !this.permanent && this.isActive && (this.temporary || this.isMobile);
    }
  },

  watch: {
    $route: function $route() {
      if (!this.disableRouteWatcher) {
        this.isActive = !this.closeConditional();
      }
    },
    isActive: function isActive(val) {
      this.$emit('input', val);
      this.showOverlay && val && this.genOverlay() || this.removeOverlay();
      this.$el.scrollTop = 0;
    },
    isMobile: function isMobile(val) {
      !val && this.removeOverlay();
    },
    permanent: function permanent(val) {
      this.$emit('input', val);
    },
    value: function value(val) {
      if (this.permanent) return;
      if (val !== this.isActive) this.isActive = val;
    }
  },

  mounted: function mounted() {
    this.$vuetify.load(this.init);
  },


  methods: {
    init: function init() {
      var _this = this;

      this.checkIfMobile();
      setTimeout(function () {
        return _this.isBooted = true;
      }, 0);

      if (this.permanent) this.isActive = true;else if (this.isMobile) this.isActive = false;else if (!this.value && (this.persistent || this.temporary)) this.isActive = false;
    },
    checkIfMobile: function checkIfMobile() {
      this.isMobile = window.innerWidth < parseInt(this.mobileBreakPoint);
    },
    closeConditional: function closeConditional() {
      return !this.permanent && (this.temporary || this.isMobile);
    },
    onResize: function onResize() {
      var _this2 = this;

      clearTimeout(this.resizeTimeout);

      if (!this.enableResizeWatcher || this.permanent || this.temporary) return;

      this.resizeTimeout = setTimeout(function () {
        _this2.checkIfMobile();
        _this2.isActive = !_this2.isMobile;
      }, 200);
    },
    swipeRight: function swipeRight(e) {
      if (this.isActive && !this.right) return;
      this.calculateTouchArea();

      if (Math.abs(e.touchendX - e.touchstartX) < 100) return;else if (!this.right && e.touchstartX <= this.touchArea.left) this.isActive = true;else if (this.right && this.isActive) this.isActive = false;
    },
    swipeLeft: function swipeLeft(e) {
      if (this.isActive && this.right) return;
      this.calculateTouchArea();

      if (Math.abs(e.touchendX - e.touchstartX) < 100) return;else if (this.right && e.touchstartX >= this.touchArea.right) this.isActive = true;else if (!this.right && this.isActive) this.isActive = false;
    },
    calculateTouchArea: function calculateTouchArea() {
      if (!this.$el.parentNode) return;
      var parentRect = this.$el.parentNode.getBoundingClientRect();

      this.touchArea = {
        left: parentRect.left + 50,
        right: parentRect.right - 50
      };
    },
    genDirectives: function genDirectives() {
      var directives = [{
        name: 'click-outside',
        value: this.closeConditional
      }, {
        name: 'resize',
        value: this.onResize
      }];

      !this.touchless && directives.push({
        name: 'touch',
        value: {
          parent: true,
          left: this.swipeLeft,
          right: this.swipeRight
        }
      });

      return directives;
    }
  },

  render: function render(h) {
    var _this3 = this;

    var data = {
      'class': this.classes,
      style: { height: this.calculatedHeight },
      directives: this.genDirectives(),
      on: Object.assign({}, {
        click: function click() {
          return _this3.$emit('update:miniVariant', false);
        }
      }, this.$listeners)
    };

    return h('aside', data, [this.$slots.default, h('div', { 'class': 'navigation-drawer__border' })]);
  }
});

/***/ }),
/* 90 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VSystemBar__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VToolbar__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__VToolbarSideIcon__ = __webpack_require__(93);






var VToolbarTitle = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('toolbar__title');
var VToolbarItems = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('toolbar__items');

/* harmony default export */ __webpack_exports__["a"] = ({
  VSystemBar: __WEBPACK_IMPORTED_MODULE_1__VSystemBar__["a" /* default */],
  VToolbar: __WEBPACK_IMPORTED_MODULE_2__VToolbar__["a" /* default */],
  VToolbarItems: VToolbarItems,
  VToolbarTitle: VToolbarTitle,
  VToolbarSideIcon: __WEBPACK_IMPORTED_MODULE_3__VToolbarSideIcon__["a" /* default */]
});

/***/ }),
/* 91 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);


/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */]],

  props: {
    lightsOut: Boolean,
    status: Boolean,
    window: Boolean
  },

  render: function render(h, _ref) {
    var data = _ref.data,
        props = _ref.props,
        children = _ref.children;

    data.staticClass = ('system-bar ' + (data.staticClass || '')).trim();

    if (props.dark) data.staticClass += ' theme--dark';
    if (props.light) data.staticClass += ' theme--light';
    if (props.status) data.staticClass += ' system-bar--status';
    if (props.window) data.staticClass += ' system-bar--window';
    if (props.lightsOut) data.staticClass += ' system-bar--lights-out';

    return h('div', data, children);
  }
});

/***/ }),
/* 92 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-toolbar',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */]],

  data: function data() {
    return {
      isExtended: false,
      isScrolling: false,
      marginTop: 0,
      previousScroll: null,
      target: null
    };
  },

  props: {
    absolute: Boolean,
    card: Boolean,
    dense: Boolean,
    extended: Boolean,
    fixed: Boolean,
    flat: Boolean,
    floating: Boolean,
    prominent: Boolean,
    scrollOffScreen: Boolean,
    scrollTarget: String,
    scrollThreshHold: {
      type: Number,
      default: 100
    }
  },

  computed: {
    classes: function classes() {
      return {
        'toolbar': true,
        'elevation-0': this.flat,
        'toolbar--absolute': this.absolute,
        'toolbar--card': this.card,
        'toolbar--dense': this.dense,
        'toolbar--fixed': this.fixed,
        'toolbar--floating': this.floating,
        'toolbar--prominent': this.prominent,
        'toolbar--extended': this.isExtended,
        'theme--dark': this.dark,
        'theme--light': this.light
      };
    },
    styles: function styles() {
      return {
        marginTop: this.marginTop
      };
    }
  },

  watch: {
    isScrolling: function isScrolling(val) {
      if (!val) this.marginTop = 0;else this.marginTop = -this.$refs.content.clientHeight - 6 + 'px';
    }
  },

  methods: {
    onScroll: function onScroll() {
      if (typeof window === 'undefined') return;

      if (!this.target) {
        this.target = this.scrollTarget ? document.querySelector(this.scrollTarget) : window;
      }

      var currentScroll = this.scrollTarget ? this.target.scrollTop : this.target.pageYOffset || document.documentElement.scrollTop;

      if (currentScroll < this.scrollThreshHold) return;

      if (this.previousScroll === null) {
        this.previousScroll = currentScroll;
      }

      this.isScrolling = this.previousScroll < currentScroll;

      this.previousScroll = currentScroll;
    }
  },

  render: function render(h) {
    this.isExtended = this.extended || !!this.$slots.extension;
    var children = [];
    var data = {
      'class': this.classes,
      style: this.styles,
      on: this.$listeners
    };

    if (this.scrollOffScreen) {
      data.directives = [{
        name: 'scroll',
        value: {
          callback: this.onScroll,
          target: this.scrollTarget
        }
      }];
    }

    children.push(h('div', {
      'class': 'toolbar__content',
      ref: 'content'
    }, this.$slots.default));

    if (this.isExtended) {
      children.push(h('div', {
        'class': 'toolbar__extension'
      }, this.$slots.extension));
    }

    return h('nav', data, children);
  }
});

/***/ }),
/* 93 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_buttons_VBtn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_icons_VIcon__ = __webpack_require__(3);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-toolbar-side-icon',

  functional: true,

  render: function render(h, _ref) {
    var slots = _ref.slots,
        listeners = _ref.listeners,
        props = _ref.props;

    var data = {
      staticClass: 'toolbar__side-icon',
      props: Object.assign(props, {
        icon: true
      }),
      on: listeners
    };

    var defaultSlot = slots().default;

    return h(__WEBPACK_IMPORTED_MODULE_0__components_buttons_VBtn__["a" /* default */], data, defaultSlot || [h(__WEBPACK_IMPORTED_MODULE_1__components_icons_VIcon__["a" /* default */], 'menu')]);
  }
});

/***/ }),
/* 94 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VPagination__ = __webpack_require__(95);


/* harmony default export */ __webpack_exports__["a"] = ({
  VPagination: __WEBPACK_IMPORTED_MODULE_0__VPagination__["a" /* default */]
});

/***/ }),
/* 95 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_icons_VIcon__ = __webpack_require__(3);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-pagination',

  props: {
    circle: Boolean,
    disabled: Boolean,
    length: {
      type: Number,
      default: 0,
      validator: function validator(val) {
        return val % 1 === 0;
      }
    },
    value: {
      type: Number,
      default: 0
    },
    prevIcon: {
      type: String,
      default: 'chevron_left'
    },
    nextIcon: {
      type: String,
      default: 'chevron_right'
    }
  },

  watch: {
    value: function value() {
      this.init();
    }
  },

  computed: {
    classes: function classes() {
      return {
        'pagination': true,
        'pagination--circle': this.circle,
        'pagination--disabled': this.disabled
      };
    },
    items: function items() {
      if (this.length <= 5) {
        return this.range(1, this.length);
      }

      var min = this.value - 3;
      min = min > 0 ? min : 1;

      var max = min + 6;
      max = max <= this.length ? max : this.length;

      if (max === this.length) {
        min = this.length - 6;
      }

      var range = this.range(min, max);

      if (this.value >= 4 && this.length > 6) {
        range.splice(0, 2, 1, '...');
      }

      if (this.value + 3 < this.length && this.length > 6) {
        range.splice(range.length - 2, 2, '...', this.length);
      }

      return range;
    }
  },

  mounted: function mounted() {
    this.$vuetify.load.call(this, this.init);
  },


  methods: {
    init: function init() {
      var _this = this;

      this.selected = null;

      // Change this
      setTimeout(function () {
        return _this.selected = _this.value;
      }, 100);
    },
    next: function next(e) {
      e.preventDefault();
      this.$emit('input', this.value + 1);
      this.$emit('next');
    },
    previous: function previous(e) {
      e.preventDefault();
      this.$emit('input', this.value - 1);
      this.$emit('previous');
    },
    range: function range(from, to) {
      var range = [];

      from = from > 0 ? from : 1;

      for (var i = from; i <= to; i++) {
        range.push(i);
      }

      return range;
    },
    genIcon: function genIcon(h, icon, disabled, fn) {
      return h('li', [h('a', {
        class: {
          'pagination__navigation': true,
          'pagination__navigation--disabled': disabled
        },
        attrs: { href: '#!' },
        on: { click: fn }
      }, [h(__WEBPACK_IMPORTED_MODULE_0__components_icons_VIcon__["a" /* default */], [icon])])]);
    },
    genItem: function genItem(h, i) {
      var _this2 = this;

      return h('a', {
        class: {
          'pagination__item': true,
          'pagination__item--active': i === this.value
        },
        attrs: { href: '#!' },
        on: {
          click: function click(e) {
            e.preventDefault();
            _this2.$emit('input', i);
          }
        }
      }, [i]);
    },
    genItems: function genItems(h) {
      var _this3 = this;

      return this.items.map(function (i) {
        return h('li', [isNaN(i) && h('span', { class: 'pagination__more' }, [i]) || _this3.genItem(h, i)]);
      });
    }
  },

  render: function render(h) {
    var children = [this.genIcon(h, this.prevIcon, this.value === 1, this.previous), this.genItems(h), this.genIcon(h, this.nextIcon, this.value === this.length, this.next)];

    return h('ul', { class: this.classes }, children);
  }
});

/***/ }),
/* 96 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VParallax__ = __webpack_require__(97);


/* harmony default export */ __webpack_exports__["a"] = ({
  VParallax: __WEBPACK_IMPORTED_MODULE_0__VParallax__["a" /* default */]
});

/***/ }),
/* 97 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_translatable__ = __webpack_require__(98);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-parallax',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_translatable__["a" /* default */]],

  props: {
    height: {
      type: [String, Number],
      default: 500
    },
    src: String
  },

  computed: {
    styles: function styles() {
      return {
        display: 'block',
        transform: 'translate3d(-50%, ' + this.parallax + 'px, 0)'
      };
    }
  },

  methods: {
    init: function init() {
      var _this = this;

      if (!this.$refs.img) return;

      if (this.$refs.img.complete) {
        this.translate();
        this.listeners();
      } else {
        this.$refs.img.addEventListener('load', function () {
          _this.translate();
          _this.listeners();
        }, false);
      }
    },
    objHeight: function objHeight() {
      return this.$refs.img.naturalHeight;
    },
    elOffsetTop: function elOffsetTop() {
      return this.$el.offsetTop;
    }
  },

  render: function render(h) {
    var container = h('div', {
      staticClass: 'parallax__image-container'
    }, [h('img', {
      staticClass: 'parallax__image',
      style: this.styles,
      attrs: {
        src: this.src
      },
      ref: 'img'
    })]);

    var content = h('div', {
      staticClass: 'parallax__content'
    }, this.$slots.default);

    return h('div', {
      staticClass: 'parallax',
      style: {
        height: parseInt(this.normalizedHeight) + 'px'
      },
      on: this.$listeners
    }, [container, content]);
  }
});

/***/ }),
/* 98 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      parallax: null,
      parallaxDist: null,
      percentScrolled: null,
      scrollTop: null,
      windowHeight: null,
      windowBottom: null
    };
  },


  computed: {
    normalizedHeight: function normalizedHeight() {
      return Number(this.height.toString().replace(/(^[0-9]*$)/, '$1'));
    },
    imgHeight: function imgHeight() {
      return this.objHeight();
    }
  },

  mounted: function mounted() {
    this.$vuetify.load(this.init);
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('scroll', this.translate, false);
    window.removeEventListener('resize', this.translate, false);
  },


  methods: {
    listeners: function listeners() {
      window.addEventListener('scroll', this.translate, false);
      window.addEventListener('resize', this.translate, false);
    },
    translate: function translate() {
      this.calcDimensions();

      this.percentScrolled = (this.windowBottom - this.elOffsetTop) / (this.normalizedHeight + this.windowHeight);

      this.parallax = Math.round(this.parallaxDist * this.percentScrolled);

      if (this.translated) {
        this.translated();
      }
    },
    calcDimensions: function calcDimensions() {
      var offset = this.$el.getBoundingClientRect();

      this.scrollTop = window.pageYOffset;
      this.parallaxDist = this.imgHeight - this.normalizedHeight;
      this.elOffsetTop = offset.top + this.scrollTop;
      this.windowHeight = window.innerHeight;
      this.windowBottom = this.scrollTop + this.windowHeight;
    }
  }
});

/***/ }),
/* 99 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VProgressLinear__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VProgressCircular__ = __webpack_require__(100);



/* harmony default export */ __webpack_exports__["a"] = ({
  VProgressLinear: __WEBPACK_IMPORTED_MODULE_0__VProgressLinear__["a" /* default */],
  VProgressCircular: __WEBPACK_IMPORTED_MODULE_1__VProgressCircular__["a" /* default */]
});

/***/ }),
/* 100 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var _this = this;

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-progress-circular',

  props: {
    button: Boolean,

    fill: {
      type: String,
      default: function _default() {
        return _this.indeterminate ? 'none' : 'transparent';
      }
    },

    indeterminate: Boolean,

    rotate: {
      type: Number,
      default: 0
    },

    size: {
      type: [Number, String],
      default: 32
    },

    width: {
      type: Number,
      default: 4
    },

    value: {
      type: Number,
      default: 0
    }
  },

  computed: {
    calculatedSize: function calculatedSize() {
      var size = Number(this.size);

      if (this.button) {
        size += 8;
      }

      return size;
    },
    circumference: function circumference() {
      return 2 * Math.PI * this.radius;
    },
    classes: function classes() {
      return {
        'progress-circular': true,
        'progress-circular--indeterminate': this.indeterminate,
        'progress-circular--button': this.button
      };
    },
    cxy: function cxy() {
      return this.indeterminate && !this.button ? 50 : this.calculatedSize / 2;
    },
    normalizedValue: function normalizedValue() {
      if (this.value < 0) {
        return 0;
      }

      if (this.value > 100) {
        return 100;
      }

      return this.value;
    },
    radius: function radius() {
      return this.indeterminate && !this.button ? 20 : (this.calculatedSize - this.width) / 2;
    },
    strokeDashArray: function strokeDashArray() {
      return Math.round(this.circumference * 1000) / 1000;
    },
    strokeDashOffset: function strokeDashOffset() {
      return (100 - this.normalizedValue) / 100 * this.circumference + 'px';
    },
    styles: function styles() {
      return {
        height: this.calculatedSize + 'px',
        width: this.calculatedSize + 'px'
      };
    },
    svgSize: function svgSize() {
      return this.indeterminate ? false : this.calculatedSize;
    },
    svgStyles: function svgStyles() {
      return {
        transform: 'rotate(' + this.rotate + 'deg)'
      };
    },
    viewBox: function viewBox() {
      return this.indeterminate ? '25 25 50 50' : false;
    }
  },

  methods: {
    genCircle: function genCircle(h, name, offset) {
      return h('circle', {
        class: 'progress-circular__' + name,
        attrs: {
          fill: 'transparent',
          cx: this.cxy,
          cy: this.cxy,
          r: this.radius,
          'stroke-width': this.width,
          'stroke-dasharray': this.strokeDashArray,
          'stroke-dashoffset': offset
        }
      });
    },
    genSvg: function genSvg(h) {
      var children = [!this.indeterminate && this.genCircle(h, 'underlay', 0), this.genCircle(h, 'overlay', this.strokeDashOffset)];

      return h('svg', {
        style: this.svgStyles,
        attrs: {
          xmlns: 'http://www.w3.org/2000/svg',
          height: this.svgSize,
          width: this.svgSize,
          viewBox: this.viewBox
        }
      }, children);
    }
  },

  render: function render(h) {
    var info = h('div', { class: 'progress-circular__info' }, [this.$slots.default]);
    var svg = this.genSvg(h);

    return h('div', {
      class: this.classes,
      style: this.styles,
      on: this.$listeners
    }, [svg, info]);
  }
});

/*
<template lang="pug">
  div(
    class="progress-circular"
    v-bind:class="classes"
    v-bind:style="styles"
    v-on="$listeners"
  )
    svg(
      xmlns="http://www.w3.org/2000/svg"
      v-bind:height="svgSize"
      v-bind:width="svgSize"
      v-bind:viewBox="viewBox"
      v-bind:style="svgStyles"
    )
      circle(
        class="progress-circular__underlay"
        fill="transparent"
        v-bind:cx="cxy"
        v-bind:cy="cxy"
        v-bind:r="radius"
        v-bind:stroke-width="width"
        v-bind:stroke-dasharray="strokeDashArray"
        v-bind:stroke-dashoffset="0"
        v-if="!indeterminate"
      )
      circle(
        class="progress-circular__overlay"
        v-bind:fill="fill"
        v-bind:cx="cxy"
        v-bind:cy="cxy"
        v-bind:r="radius"
        v-bind:stroke-width="width"
        v-bind:stroke-dasharray="strokeDashArray"
        v-bind:stroke-dashoffset="strokeDashOffset"
      )
    div(class="progress-circular__info")
      slot
</template>
*/

/***/ }),
/* 101 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VSelect__ = __webpack_require__(24);


/* harmony default export */ __webpack_exports__["a"] = ({
  VSelect: __WEBPACK_IMPORTED_MODULE_0__VSelect__["a" /* default */]
});

/***/ }),
/* 102 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    filterSearch: function filterSearch() {
      var _this = this;

      return this.items.filter(function (i) {
        var text = _this.getText(i);
        if (typeof text !== 'string') return false;

        return text.toLowerCase().indexOf(_this.searchValue.toLowerCase()) !== -1;
      });
    },
    onKeyDown: function onKeyDown(e) {
      this.$refs.menu.changeListIndex(e);
    }
  }
});

/***/ }),
/* 103 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);


/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    genMenu: function genMenu() {
      var _this = this;

      var offsetY = this.autocomplete || this.offset || this.isDropdown;
      var data = {
        ref: 'menu',
        props: {
          activator: this.$refs.activator,
          auto: this.auto,
          closeOnClick: false,
          closeOnContentClick: !this.multiple,
          contentClass: this.computedContentClass,
          disabled: this.disabled,
          maxHeight: this.maxHeight,
          nudgeTop: this.isDropdown ? 22 : offsetY ? 38 : 0,
          offsetY: offsetY,
          value: this.isActive
        },
        on: { input: function input(val) {
            return _this.isActive = val;
          } }
      };

      this.minWidth && (data.props.minWidth = this.minWidth);

      return this.$createElement('v-menu', data, [this.genList()]);
    },
    genSelectionsAndSearch: function genSelectionsAndSearch() {
      var _this2 = this;

      var input = void 0;

      if (this.autocomplete || this.editable) {
        input = this.$createElement('input', {
          'class': 'input-group--select__autocomplete',
          domProps: { value: this.searchValue },
          on: { input: function input(e) {
              return _this2.searchValue = e.target.value;
            } },
          attrs: { tabindex: -1 },
          ref: 'input',
          key: 'input'
        });
      }

      var selections = this.isDirty && (!this.editable || this.editable && !this.focused) ? this.genSelections() : [];
      input && selections.push(input);
      var group = this.$createElement('div', selections);

      return this.$createElement('div', {
        'class': 'input-group__selections',
        style: { 'overflow': 'hidden' },
        ref: 'activator'
      }, [group]);
    },
    genSelections: function genSelections() {
      var _this3 = this;

      var children = [];
      var chips = this.chips;
      var slots = this.$scopedSlots.selection;
      var length = this.selectedItems.length;

      this.selectedItems.forEach(function (item, i) {
        if (slots) {
          children.push(_this3.genSlotSelection(item));
        } else if (chips) {
          children.push(_this3.genChipSelection(item));
        } else {
          children.push(_this3.genCommaSelection(item, i < length - 1));
        }
      });

      return children;
    },
    genSlotSelection: function genSlotSelection(item) {
      return this.$scopedSlots.selection({ parent: this, item: item });
    },
    genChipSelection: function genChipSelection(item) {
      var _this4 = this;

      return this.$createElement('v-chip', {
        'class': 'chip--select-multi',
        props: { close: true },
        on: {
          input: function input() {
            return _this4.selectItem(item);
          },
          click: function click(e) {
            return e.stopPropagation();
          }
        },
        key: this.getValue(item)
      }, this.getText(item));
    },
    genCommaSelection: function genCommaSelection(item, comma) {
      return this.$createElement('div', {
        'class': 'input-group__selections__comma',
        key: JSON.stringify(this.getValue(item)) // Item may be an object
      }, '' + this.getText(item) + (comma ? ', ' : ''));
    },
    genList: function genList() {
      var _this5 = this;

      var children = this.filteredItems.map(function (o) {
        if (o.header) return _this5.genHeader(o);
        if (o.divider) return _this5.genDivider(o);else return _this5.genTile(o);
      });

      if (!children.length) {
        children.push(this.genTile(this.noDataText, true));
      }

      return this.$createElement('v-card', [this.$createElement('v-list', {
        ref: 'list'
      }, children)]);
    },
    genHeader: function genHeader(item) {
      return this.$createElement('v-subheader', {
        props: item
      }, item.header);
    },
    genDivider: function genDivider(item) {
      return this.$createElement('v-divider', {
        props: item
      });
    },
    genTile: function genTile(item, disabled) {
      var _this6 = this;

      var active = this.selectedItems.indexOf(item) !== -1;

      if (typeof disabled === 'undefined') {
        disabled = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["g" /* getObjectValueByPath */])(item, this.itemDisabled);
      }

      var data = {
        on: { click: function click(e) {
            return _this6.selectItem(item);
          } },
        props: {
          avatar: item === Object(item) && 'avatar' in item,
          ripple: true,
          value: active
        }
      };

      if (disabled) {
        data.props.disabled = disabled;
      }

      if (this.$scopedSlots.item) {
        return this.$createElement('v-list-tile', data, [this.$scopedSlots.item({ parent: this, item: item })]);
      }

      return this.$createElement('v-list-tile', data, [this.genAction(item, active), this.genContent(item)]);
    },
    genAction: function genAction(item, active) {
      var _this7 = this;

      if (!this.multiple) return null;

      var data = {
        'class': {
          'list__tile__action--select-multi': this.multiple
        },
        on: {
          click: function click(e) {
            e.stopPropagation();
            _this7.selectItem(item);
          }
        }
      };

      return this.$createElement('v-list-tile-action', data, [this.$createElement('v-checkbox', { props: { inputValue: active } })]);
    },
    genContent: function genContent(item) {
      return this.$createElement('v-list-tile-content', [this.$createElement('v-list-tile-title', this.getText(item))]);
    }
  }
});

/***/ }),
/* 104 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VCheckbox__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VRadio__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VSwitch__ = __webpack_require__(106);




/* harmony default export */ __webpack_exports__["a"] = ({
  VCheckbox: __WEBPACK_IMPORTED_MODULE_0__VCheckbox__["a" /* default */],
  VRadio: __WEBPACK_IMPORTED_MODULE_1__VRadio__["a" /* default */],
  VSwitch: __WEBPACK_IMPORTED_MODULE_2__VSwitch__["a" /* default */]
});

/***/ }),
/* 105 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_input__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_colorable__ = __webpack_require__(28);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'radio',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_input__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_colorable__["a" /* default */]],

  model: {
    prop: 'inputValue',
    event: 'change'
  },

  props: {
    inputValue: [String, Number]
  },

  computed: {
    isActive: function isActive() {
      return this.inputValue === this.value;
    },
    classes: function classes() {
      return this.addColorClassChecks({
        'radio': true,
        'input-group--selection-controls': true,
        'input-group--active': this.isActive
      });
    },
    icon: function icon() {
      return this.isActive ? 'radio_button_checked' : 'radio_button_unchecked';
    }
  },

  methods: {
    genLabel: function genLabel() {
      return this.$createElement('label', {
        on: { click: this.toggle }
      }, this.label);
    },
    toggle: function toggle() {
      if (!this.disabled) {
        this.$emit('change', this.value);
      }
    }
  },

  render: function render(h) {
    var transition = h('v-fade-transition', {}, [h('v-icon', {
      'class': {
        'icon--radio': this.isActive
      },
      key: this.icon
    }, this.icon)]);

    var ripple = h('div', {
      'class': 'input-group--selection-controls__ripple',
      on: Object.assign({}, {
        click: this.toggle
      }, this.$listeners),
      directives: [{
        name: 'ripple',
        value: { center: true }
      }]
    });

    return this.genInputGroup([transition, ripple]);
  }
});

/***/ }),
/* 106 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_selectable__ = __webpack_require__(27);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'switch',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_selectable__["a" /* default */]],

  computed: {
    classes: function classes() {
      return {
        'input-group--selection-controls switch': true
      };
    },
    rippleClasses: function rippleClasses() {
      return {
        'input-group--selection-controls__ripple': true,
        'input-group--selection-controls__ripple--active': this.isActive
      };
    },
    containerClasses: function containerClasses() {
      return this.addColorClassChecks({
        'input-group--selection-controls__container': true,
        'input-group--selection-controls__container--light': this.light,
        'input-group--selection-controls__container--disabled': this.disabled
      });
    },
    toggleClasses: function toggleClasses() {
      return {
        'input-group--selection-controls__toggle': true,
        'input-group--selection-controls__toggle--active': this.isActive
      };
    }
  },

  render: function render(h) {
    var ripple = h('div', {
      'class': this.rippleClasses,
      on: Object.assign({}, {
        click: this.toggle
      }, this.$listeners),
      directives: [{
        name: 'ripple',
        value: { center: true }
      }]
    });

    var container = h('div', {
      'class': this.containerClasses
    }, [h('div', { 'class': this.toggleClasses }), ripple]);

    return this.genInputGroup([container]);
  }
});

/***/ }),
/* 107 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VSlider__ = __webpack_require__(108);


/* harmony default export */ __webpack_exports__["a"] = ({
  VSlider: __WEBPACK_IMPORTED_MODULE_0__VSlider__["a" /* default */]
});

/***/ }),
/* 108 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_input__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_helpers__ = __webpack_require__(0);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-slider',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_input__["a" /* default */]],

  data: function data() {
    return {
      app: {},
      isActive: false,
      inputWidth: 0
    };
  },


  props: {
    inverted: Boolean,
    min: {
      type: [Number, String],
      default: 0
    },
    max: {
      type: [Number, String],
      default: 100
    },
    step: {
      type: [Number, String],
      default: null
    },
    thumbLabel: Boolean,
    value: [Number, String],
    vertical: Boolean,
    snap: Boolean
  },

  computed: {
    classes: function classes() {
      return {
        'input-group input-group--slider': true,
        'input-group--active': this.isActive,
        'input-group--dirty': this.inputWidth > 0,
        'input-group--disabled': this.disabled,
        'input-group--ticks': !this.disabled && this.step
      };
    },

    inputValue: {
      get: function get() {
        return this.value;
      },
      set: function set(val) {
        var min = this.min,
            max = this.max,
            step = this.step,
            snap = this.snap;

        val = val < min ? min : val > max ? max : val;
        if (Math.ceil(val) !== Math.ceil(this.lazyValue)) {
          this.inputWidth = this.calculateWidth(val);
        }

        var value = snap ? Math.round(val / step) * step : parseInt(val);
        this.lazyValue = value;

        if (value !== this.value) {
          this.$emit('input', value);
        }
      }
    },
    interval: function interval() {
      return 100 / (this.max - this.min) * this.step;
    },
    thumbContainerClasses: function thumbContainerClasses() {
      return {
        'slider__thumb-container': true,
        'slider__thumb-container--label': this.thumbLabel
      };
    },
    thumbStyles: function thumbStyles() {
      return {
        left: this.inputWidth + '%'
      };
    },
    tickContainerStyles: function tickContainerStyles() {
      return {
        transform: 'translate3d(0, -50%, 0)'
      };
    },
    trackStyles: function trackStyles() {
      var scaleX = this.calculateScale(1 - this.inputWidth / 100);
      var translateX = this.inputWidth < 1 && !this.isActive ? 8 + 'px' : 0;
      return {
        transform: 'scaleX(' + scaleX + ') translateX(' + translateX + ')'
      };
    },
    trackFillStyles: function trackFillStyles() {
      var inputWidth = this.inputWidth;
      var scaleX = this.calculateScale(inputWidth / 100);
      var translateX = inputWidth > 99 && !this.thumbLabel ? -8 + 'px' : 0;
      return {
        transform: 'scaleX(' + scaleX + ') translateX(' + translateX + ')'
      };
    },
    numTicks: function numTicks() {
      return parseInt((this.max - this.min) / this.step);
    }
  },

  watch: {
    value: function value() {
      this.inputValue = this.value;
    }
  },

  mounted: function mounted() {
    var _this = this;

    this.inputValue = this.value;
    this.$nextTick(function () {
      _this.inputWidth = _this.calculateWidth(_this.inputValue);
    });

    // Without a v-app, iOS does not work with body selectors
    this.app = document.querySelector('[data-app]') || console.warn('The v-slider component requires the present of v-app or a non-body wrapping element with the [data-app] attribute.');
  },


  methods: {
    calculateWidth: function calculateWidth(val) {
      if (this.snap) {
        val = Math.round(val / this.step) * this.step;
      }

      val = (val - this.min) / (this.max - this.min) * 100;

      return val < 0.15 ? 0 : val;
    },
    calculateScale: function calculateScale(scale) {
      if (scale < 0.02 && !this.thumbLabel) {
        return 0;
      }

      return this.disabled ? scale - 0.015 : scale;
    },
    onMouseDown: function onMouseDown(e) {
      var options = { passive: true };
      this.isActive = true;

      if ('touches' in e) {
        this.app.addEventListener('touchmove', this.onMouseMove, options);
        Object(__WEBPACK_IMPORTED_MODULE_1__util_helpers__["a" /* addOnceEventListener */])(this.app, 'touchend', this.onMouseUp);
      } else {
        this.app.addEventListener('mousemove', this.onMouseMove, options);
        Object(__WEBPACK_IMPORTED_MODULE_1__util_helpers__["a" /* addOnceEventListener */])(this.app, 'mouseup', this.onMouseUp);
      }
    },
    onMouseUp: function onMouseUp() {
      var options = { passive: true };
      this.isActive = false;
      this.app.removeEventListener('touchmove', this.onMouseMove, options);
      this.app.removeEventListener('mousemove', this.onMouseMove, options);
    },
    onMouseMove: function onMouseMove(e) {
      var _$refs$track$getBound = this.$refs.track.getBoundingClientRect(),
          offsetLeft = _$refs$track$getBound.left,
          trackWidth = _$refs$track$getBound.width;

      var clientX = 'touches' in e ? e.touches[0].clientX : e.clientX;
      var left = (clientX - offsetLeft) / trackWidth * 100;

      left = left < 0 ? 0 : left > 100 ? 100 : left;

      this.inputValue = this.min + left / 100 * (this.max - this.min);
    },
    onKeyDown: function onKeyDown(e) {
      if (!e.keyCode === 37 && !e.keyCode === 39) return;

      var direction = e.keyCode === 37 && -1 || e.keyCode === 39 && 1 || 0;
      var multiplier = e.shiftKey && 3 || e.ctrlKey && 2 || 1;
      var amount = this.snap && this.step || 1;

      this.inputValue = this.inputValue + direction * amount * multiplier;
    },
    sliderMove: function sliderMove(e) {
      if (!this.isActive) {
        this.onMouseMove(e);
      }
    },
    genThumbLabel: function genThumbLabel(h) {
      return h('v-scale-transition', {
        props: { origin: 'bottom center' }
      }, [h('div', {
        'class': 'slider__thumb--label__container',
        directives: [{
          name: 'show',
          value: this.isActive
        }]
      }, [h('div', { 'class': 'slider__thumb--label' }, [h('span', {}, parseInt(this.inputValue))])])]);
    },
    genThumbContainer: function genThumbContainer(h) {
      var children = [];
      children.push(h('div', { 'class': 'slider__thumb' }));

      this.thumbLabel && children.push(this.genThumbLabel(h));

      return h('div', {
        'class': this.thumbContainerClasses,
        style: this.thumbStyles,
        on: {
          touchstart: this.onMouseDown,
          mousedown: this.onMouseDown
        },
        ref: 'thumb'
      }, children);
    },
    genSteps: function genSteps(h) {
      var _this2 = this;

      var ticks = Object(__WEBPACK_IMPORTED_MODULE_1__util_helpers__["c" /* createRange */])(this.numTicks + 1).map(function (i) {
        var span = h('span', {
          class: 'slider__tick',
          style: {
            left: i * (100 / _this2.numTicks) + '%'
          }
        });

        return span;
      });

      return h('div', {
        'class': 'slider__ticks-container',
        style: this.tickContainerStyles
      }, ticks);
    },
    genTrackContainer: function genTrackContainer(h) {
      var children = [h('div', {
        'class': 'slider__track',
        style: this.trackStyles
      }), h('div', {
        'class': 'slider__track-fill',
        style: this.trackFillStyles
      })];

      return h('div', {
        'class': 'slider__track__container',
        ref: 'track'
      }, children);
    }
  },

  render: function render(h) {
    var children = [];

    children.push(this.genTrackContainer(h));
    this.step && children.push(this.genSteps(h));
    children.push(this.genThumbContainer(h));

    var slider = h('div', { 'class': 'slider' }, children);

    return this.genInputGroup([slider], {
      attrs: {
        role: 'slider',
        tabindex: this.tabindex
      },
      on: Object.assign({}, {
        mouseup: this.sliderMove,
        keydown: this.onKeyDown
      }, this.$listeners),
      directives: [{
        name: 'click-outside'
      }]
    });
  }
});

/***/ }),
/* 109 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VSubheader__ = __webpack_require__(110);


/* harmony default export */ __webpack_exports__["a"] = ({
  VSubheader: __WEBPACK_IMPORTED_MODULE_0__VSubheader__["a" /* default */]
});

/***/ }),
/* 110 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);


/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */]],

  props: {
    inset: Boolean
  },

  render: function render(h, _ref) {
    var data = _ref.data,
        children = _ref.children,
        props = _ref.props;

    data.staticClass = ('subheader ' + (data.staticClass || '')).trim();

    if (props.inset) data.staticClass += ' subheader--inset';
    if (props.light) data.staticClass += ' theme--light';
    if (props.dark) data.staticClass += ' theme--dark';

    return h('li', data, children);
  }
});

/***/ }),
/* 111 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VStepper__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VStepperStep__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__VStepperContent__ = __webpack_require__(114);





var VStepperHeader = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('stepper__header');

/* harmony default export */ __webpack_exports__["a"] = ({
  VStepper: __WEBPACK_IMPORTED_MODULE_1__VStepper__["a" /* default */],
  VStepperContent: __WEBPACK_IMPORTED_MODULE_3__VStepperContent__["a" /* default */],
  VStepperHeader: VStepperHeader,
  VStepperStep: __WEBPACK_IMPORTED_MODULE_2__VStepperStep__["a" /* default */]
});

/***/ }),
/* 112 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-stepper',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */]],

  provide: function provide() {
    return {
      stepClick: this.stepClick
    };
  },
  data: function data() {
    return {
      inputValue: null,
      isBooted: false,
      steps: [],
      content: [],
      isReverse: false
    };
  },


  props: {
    nonLinear: Boolean,
    altLabels: Boolean,
    vertical: Boolean,
    value: [Number, String]
  },

  computed: {
    classes: function classes() {
      return {
        'stepper': true,
        'stepper--is-booted': this.isBooted,
        'stepper--vertical': this.vertical,
        'stepper--alt-labels': this.altLabels,
        'stepper--non-linear': this.nonLinear,
        'theme--dark': this.dark,
        'theme--light': this.light
      };
    }
  },

  watch: {
    inputValue: function inputValue(val, prev) {
      var _this = this;

      this.isReverse = Number(val) < Number(prev);
      this.steps.forEach(function (i) {
        return i.toggle(_this.inputValue);
      });
      this.content.forEach(function (i) {
        return i.toggle(_this.inputValue, _this.isReverse);
      });

      this.$emit('input', this.inputValue);
      prev && (this.isBooted = true);
    },
    value: function value() {
      this.inputValue = this.value;
    }
  },

  mounted: function mounted() {
    this.$vuetify.load(this.init);
  },


  methods: {
    init: function init() {
      var _this2 = this;

      this.$children.forEach(function (i) {
        if (i.$options._componentTag === 'v-stepper-step') {
          _this2.steps.push(i);
        } else if (i.$options._componentTag === 'v-stepper-content') {
          i.isVertical = _this2.vertical;
          _this2.content.push(i);
        }
      });

      this.inputValue = this.value || this.steps[0].step || 1;
    },
    stepClick: function stepClick(step) {
      this.inputValue = step;
    }
  },

  render: function render(h) {
    return h('div', {
      'class': this.classes
    }, this.$slots.default);
  }
});

/***/ }),
/* 113 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-stepper-step',

  inject: ['stepClick'],

  data: function data() {
    return {
      isActive: false,
      isInactive: true
    };
  },


  props: {
    complete: Boolean,
    completeIcon: {
      type: String,
      default: 'check'
    },
    editIcon: {
      type: String,
      default: 'edit'
    },
    errorIcon: {
      type: String,
      default: 'warning'
    },
    editable: Boolean,
    rules: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    step: [Number, String]
  },

  computed: {
    classes: function classes() {
      return {
        'stepper__step': true,
        'stepper__step--active': this.isActive,
        'stepper__step--editable': this.editable,
        'stepper__step--inactive': this.isInactive,
        'stepper__step--error': this.hasError,
        'stepper__step--complete': this.complete
      };
    },
    hasError: function hasError() {
      return this.rules.some(function (i) {
        return i() !== true;
      });
    }
  },

  methods: {
    click: function click(e) {
      e.stopPropagation();

      if (this.editable) {
        this.stepClick(this.step);
      }
    },
    toggle: function toggle(step) {
      this.isActive = step.toString() === this.step.toString();
      this.isInactive = Number(step) < Number(this.step);
    }
  },

  render: function render(h) {
    var data = {
      'class': this.classes,
      directives: [{
        name: 'ripple',
        value: this.editable
      }],
      on: { click: this.click }
    };
    var stepContent = void 0;

    if (this.hasError) {
      stepContent = [h('v-icon', {}, this.errorIcon)];
    } else if (this.complete) {
      if (this.editable) {
        stepContent = [h('v-icon', {}, this.editIcon)];
      } else {
        stepContent = [h('v-icon', {}, this.completeIcon)];
      }
    } else {
      stepContent = this.step;
    }

    var step = h('span', { 'class': 'stepper__step__step' }, stepContent);
    var label = h('div', { 'class': 'stepper__label' }, this.$slots.default);

    return h('div', data, [step, label]);
  }
});

/***/ }),
/* 114 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-stepper-content',

  data: function data() {
    return {
      height: 0,
      isActive: false,
      isReverse: false,
      isVertical: false
    };
  },


  props: {
    step: {
      type: [Number, String],
      required: true
    }
  },

  computed: {
    classes: function classes() {
      return {
        'stepper__content': true
      };
    },
    computedTransition: function computedTransition() {
      return this.isReverse ? 'v-tab-reverse-transition' : 'v-tab-transition';
    },
    styles: function styles() {
      if (!this.isVertical) return {};

      return {
        height: !isNaN(this.height) ? this.height + 'px' : this.height
      };
    },
    wrapperClasses: function wrapperClasses() {
      return {
        'stepper__wrapper': true
      };
    }
  },

  watch: {
    isActive: function isActive() {
      if (!this.isVertical) {
        return;
      }

      if (this.isActive) {
        this.enter();
      } else {
        this.leave();
      }
    }
  },

  mounted: function mounted() {
    this.$refs.wrapper.addEventListener('transitionend', this.onTransition, false);
  },
  beforeDestroy: function beforeDestroy() {
    this.$refs.wrapper.removeEventListener('transitionend', this.onTransition, false);
  },


  methods: {
    onTransition: function onTransition() {
      if (!this.isActive) return;

      this.height = 'auto';
    },
    enter: function enter() {
      var _this = this;

      var scrollHeight = 0;

      // Render bug with height
      setTimeout(function () {
        scrollHeight = _this.$refs.wrapper.scrollHeight;
      }, 0);

      this.height = 0;

      // Give the collapsing element time to collapse
      setTimeout(function () {
        return _this.height = scrollHeight || 'auto';
      }, 450);
    },
    leave: function leave() {
      var _this2 = this;

      this.height = this.$refs.wrapper.clientHeight;
      setTimeout(function () {
        return _this2.height = 0;
      }, 0);
    },
    toggle: function toggle(step, reverse) {
      this.isActive = step.toString() === this.step.toString();
      this.isReverse = reverse;
    }
  },

  render: function render(h) {
    var contentData = {
      'class': this.classes
    };
    var wrapperData = {
      'class': this.wrapperClasses,
      style: this.styles,
      ref: 'wrapper'
    };

    if (!this.isVertical) {
      contentData.directives = [{
        name: 'show',
        value: this.isActive
      }];
    }

    var wrapper = h('div', wrapperData, [this.$slots.default]);
    var content = h('div', contentData, [wrapper]);

    return h(this.computedTransition, {
      on: this.$listeners
    }, [content]);
  }
});

/***/ }),
/* 115 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export VTableOverflow */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VDataTable__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VEditDialog__ = __webpack_require__(121);




var VTableOverflow = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('table__overflow');

/* harmony default export */ __webpack_exports__["a"] = ({
  VDataTable: __WEBPACK_IMPORTED_MODULE_1__VDataTable__["a" /* default */],
  VEditDialog: __WEBPACK_IMPORTED_MODULE_2__VEditDialog__["a" /* default */],
  VTableOverflow: VTableOverflow
});

/***/ }),
/* 116 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_head__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_body__ = __webpack_require__(118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_foot__ = __webpack_require__(119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_progress__ = __webpack_require__(120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_filterable__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mixins_themeable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_buttons_VBtn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_icons_VIcon__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_progress_VProgressLinear__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_selects_VSelect__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__util_helpers__ = __webpack_require__(0);
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };















/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-datatable',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_head__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_body__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__mixins_filterable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_foot__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_progress__["a" /* default */], __WEBPACK_IMPORTED_MODULE_5__mixins_themeable__["a" /* default */]],

  components: {
    VBtn: __WEBPACK_IMPORTED_MODULE_6__components_buttons_VBtn__["a" /* default */],
    VIcon: __WEBPACK_IMPORTED_MODULE_7__components_icons_VIcon__["a" /* default */],
    VProgressLinear: __WEBPACK_IMPORTED_MODULE_8__components_progress_VProgressLinear__["a" /* default */],
    VSelect: __WEBPACK_IMPORTED_MODULE_9__components_selects_VSelect__["a" /* default */],
    // Importing does not work properly
    'v-table-overflow': Object(__WEBPACK_IMPORTED_MODULE_10__util_helpers__["d" /* createSimpleFunctional */])('table__overflow')
  },

  data: function data() {
    return {
      all: false,
      searchLength: 0,
      defaultPagination: {
        page: 1,
        rowsPerPage: 5,
        descending: false,
        totalItems: 0
      }
    };
  },


  props: {
    headers: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    headerText: {
      type: String,
      default: 'text'
    },
    hideActions: Boolean,
    noResultsText: {
      type: String,
      default: 'No matching records found'
    },
    rowsPerPageItems: {
      type: Array,
      default: function _default() {
        return [5, 10, 25, { text: 'All', value: -1 }];
      }
    },
    rowsPerPageText: {
      type: String,
      default: 'Rows per page:'
    },
    selectAll: [Boolean, String],
    search: {
      required: false
    },
    filter: {
      type: Function,
      default: function _default(val, search) {
        return val !== null && ['undefined', 'boolean'].indexOf(typeof val === 'undefined' ? 'undefined' : _typeof(val)) === -1 && val.toString().toLowerCase().indexOf(search) !== -1;
      }
    },
    customFilter: {
      type: Function,
      default: function _default(items, search, filter) {
        search = search.toString().toLowerCase();
        return items.filter(function (i) {
          return Object.keys(i).some(function (j) {
            return filter(i[j], search);
          });
        });
      }
    },
    customSort: {
      type: Function,
      default: function _default(items, index, isDescending) {
        if (index === null) return items;

        return items.sort(function (a, b) {
          var sortA = Object(__WEBPACK_IMPORTED_MODULE_10__util_helpers__["g" /* getObjectValueByPath */])(a, index);
          var sortB = Object(__WEBPACK_IMPORTED_MODULE_10__util_helpers__["g" /* getObjectValueByPath */])(b, index);

          if (isDescending) {
            var _ref = [sortB, sortA];
            sortA = _ref[0];
            sortB = _ref[1];
          }

          // Check if both are numbers
          if (!isNaN(sortA) && !isNaN(sortB)) {
            return sortA - sortB;
          }

          // Check if both cannot be evaluated
          if (sortA === null && sortB === null) {
            return 0;
          }

          var _map = [sortA, sortB].map(function (s) {
            return (s || '').toString().toLocaleLowerCase();
          });

          var _map2 = _slicedToArray(_map, 2);

          sortA = _map2[0];
          sortB = _map2[1];


          if (sortA > sortB) return 1;
          if (sortA < sortB) return -1;

          return 0;
        });
      }
    },
    value: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    items: {
      type: Array,
      required: true,
      default: function _default() {
        return [];
      }
    },
    totalItems: {
      type: Number,
      default: null
    },
    loading: {
      type: [Boolean, String],
      default: false
    },
    selectedKey: {
      type: String,
      default: 'id'
    },
    pagination: {
      type: Object,
      default: null
    }
  },

  computed: {
    classes: function classes() {
      return {
        'datatable table': true,
        'datatable--select-all': this.selectAll !== false,
        'theme--dark': this.dark,
        'theme--light': this.light
      };
    },
    computedPagination: function computedPagination() {
      return this.pagination || this.defaultPagination;
    },
    hasSelectAll: function hasSelectAll() {
      return this.selectAll !== undefined && this.selectAll !== false;
    },
    itemsLength: function itemsLength() {
      if (this.search) return this.searchLength;
      return this.totalItems || this.items.length;
    },
    indeterminate: function indeterminate() {
      return this.hasSelectAll && this.someItems && !this.everyItem;
    },
    everyItem: function everyItem() {
      var _this = this;

      return this.filteredItems.length && this.filteredItems.every(function (i) {
        return _this.isSelected(i);
      });
    },
    someItems: function someItems() {
      var _this2 = this;

      return this.filteredItems.some(function (i) {
        return _this2.isSelected(i);
      });
    },
    getPage: function getPage() {
      var rowsPerPage = this.computedPagination.rowsPerPage;


      return rowsPerPage === Object(rowsPerPage) ? rowsPerPage.value : rowsPerPage;
    },
    pageStart: function pageStart() {
      return this.getPage === -1 ? 0 : (this.computedPagination.page - 1) * this.getPage;
    },
    pageStop: function pageStop() {
      return this.getPage === -1 ? this.itemsLength : this.computedPagination.page * this.getPage;
    },
    filteredItems: function filteredItems() {
      if (this.totalItems) return this.items;

      var items = this.items.slice();
      var hasSearch = typeof this.search !== 'undefined' && this.search !== null;

      if (hasSearch) {
        items = this.customFilter(items, this.search, this.filter);
        this.searchLength = items.length;
      }

      items = this.customSort(items, this.computedPagination.sortBy, this.computedPagination.descending);

      return this.hideActions && !this.pagination ? items : items.slice(this.pageStart, this.pageStop);
    },
    selected: function selected() {
      var _this3 = this;

      var selected = {};
      this.value.forEach(function (i) {
        return selected[i[_this3.selectedKey]] = true;
      });
      return selected;
    }
  },

  watch: {
    indeterminate: function indeterminate(val) {
      if (val) this.all = true;
    },
    someItems: function someItems(val) {
      if (!val) this.all = false;
    },
    search: function search() {
      this.updatePagination({ page: 1 });
    },
    everyItem: function everyItem(val) {
      if (val) this.all = true;
    }
  },

  methods: {
    updatePagination: function updatePagination(val) {
      var pagination = this.pagination || this.defaultPagination;
      var updatedPagination = Object.assign({}, pagination, val);

      if (this.pagination) {
        this.$emit('update:pagination', updatedPagination);
      } else {
        this.defaultPagination = updatedPagination;
      }
    },
    isSelected: function isSelected(item) {
      return this.selected[item[this.selectedKey]];
    },
    sort: function sort(index) {
      var _computedPagination = this.computedPagination,
          sortBy = _computedPagination.sortBy,
          descending = _computedPagination.descending;

      if (sortBy === null) {
        this.updatePagination({ sortBy: index, descending: false });
      } else if (sortBy === index && !descending) {
        this.updatePagination({ descending: true });
      } else if (sortBy !== index) {
        this.updatePagination({ sortBy: index, descending: false });
      } else {
        this.updatePagination({ sortBy: null, descending: null });
      }
    },
    needsTR: function needsTR(row) {
      return row.length && row.find(function (c) {
        return c.tag === 'td';
      });
    },
    genTR: function genTR(children) {
      var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      return this.$createElement('tr', data, children);
    },
    toggle: function toggle(value) {
      var _this4 = this;

      var selected = Object.assign({}, this.selected);
      this.filteredItems.forEach(function (i) {
        return selected[i[_this4.selectedKey]] = value;
      });

      this.$emit('input', this.items.filter(function (i) {
        return selected[i[_this4.selectedKey]];
      }));
    }
  },

  created: function created() {
    var firstSortable = this.headers.find(function (h) {
      return !('sortable' in h) || h.sortable;
    });

    this.defaultPagination.sortBy = firstSortable ? firstSortable.value : null;

    if (!this.rowsPerPageItems.length) {
      console.warn('The prop \'rows-per-page-items\' in v-data-table can not be empty.');
    } else {
      this.defaultPagination.rowsPerPage = this.rowsPerPageItems[0];
    }

    this.updatePagination(Object.assign({}, this.defaultPagination, this.pagination));
  },
  render: function render(h) {
    return h('v-table-overflow', {}, [h('table', {
      'class': this.classes
    }, [this.genTHead(), this.genTProgress(), this.genTBody(), this.genTFoot()])]);
  }
});

/***/ }),
/* 117 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    genTHead: function genTHead() {
      var _this = this;

      var children = [];

      if (this.$scopedSlots.headers) {
        var row = this.$scopedSlots.headers({
          headers: this.headers,
          indeterminate: this.indeterminate,
          all: this.all
        });

        children = this.needsTR(row) ? this.genTR(row) : row;
      } else {
        var _row = this.headers.map(function (o) {
          return _this.genHeader(o);
        });
        var checkbox = this.$createElement('v-checkbox', {
          props: {
            dark: this.dark,
            light: this.light,
            color: this.selectAll === true && '' || this.selectAll,
            hideDetails: true,
            inputValue: this.all,
            indeterminate: this.indeterminate
          },
          on: { change: this.toggle }
        });

        this.hasSelectAll && _row.unshift(this.$createElement('th', [checkbox]));

        children = this.genTR(_row);
      }

      return this.$createElement('thead', [children]);
    },
    genHeader: function genHeader(header) {
      var array = [this.$scopedSlots.headerCell ? this.$scopedSlots.headerCell({ header: header }) : header[this.headerText]];

      return this.$createElement.apply(this, ['th'].concat(_toConsumableArray(this.genHeaderData(header, array))));
    },
    genHeaderData: function genHeaderData(header, children) {
      var _this2 = this;

      var classes = ['column'];
      var data = {};
      var pagination = this.computedPagination;

      if ('sortable' in header && header.sortable || !('sortable' in header)) {
        data.on = { click: function click() {
            return _this2.sort(header.value);
          } };
        if (!('value' in header)) {
          console.warn('Data table headers must have a value property that corresponds to a value in the v-model array');
        }

        classes.push('sortable');
        var icon = this.$createElement('v-icon', 'arrow_upward');
        if (header.align && header.align === 'left') {
          children.push(icon);
        } else {
          children.unshift(icon);
        }

        var beingSorted = pagination.sortBy === header.value;
        if (beingSorted) {
          classes.push('active');
          classes.push(pagination.descending ? 'desc' : 'asc');
        }
      }

      classes.push('text-xs-' + (header.align || 'right'));
      data.class = classes;

      return [data, children];
    }
  }
});

/***/ }),
/* 118 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    genTBody: function genTBody() {
      var children = [];

      if (!this.itemsLength) {
        children.push(this.genEmptyBody(this.noDataText));
      } else if (!this.filteredItems.length) {
        children.push(this.genEmptyBody(this.noResultsText));
      } else {
        children.push(this.genFilteredItems());
      }

      return this.$createElement('tbody', children);
    },
    genFilteredItems: function genFilteredItems() {
      var _this = this;

      return this.filteredItems.map(function (item, index) {
        var props = { item: item, index: index };
        var key = _this.selectedKey;

        Object.defineProperty(props, 'selected', {
          get: function get() {
            return _this.selected[item[_this.selectedKey]];
          },
          set: function set(value) {
            var selected = _this.value.slice();
            if (value) selected.push(item);else selected = selected.filter(function (i) {
              return i[key] !== item[key];
            });

            _this.$emit('input', selected);
          }
        });

        var row = _this.$scopedSlots.items(props);

        return _this.needsTR(row) ? _this.genTR(row, {
          attrs: { active: _this.isSelected(item) }
        }) : row;
      });
    },
    genEmptyBody: function genEmptyBody(text) {
      return this.genTR([this.$createElement('td', {
        'class': 'text-xs-center',
        attrs: { colspan: '100%' }
      }, text)]);
    }
  }
});

/***/ }),
/* 119 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    genPrevIcon: function genPrevIcon() {
      var _this = this;

      return this.$createElement('v-btn', {
        props: {
          disabled: this.computedPagination.page === 1,
          icon: true,
          flat: true,
          dark: this.dark,
          light: this.light
        },
        on: {
          click: function click() {
            var page = _this.computedPagination.page;
            _this.updatePagination({ page: page - 1 });
          }
        }
      }, [this.$createElement('v-icon', 'chevron_left')]);
    },
    genNextIcon: function genNextIcon() {
      var _this2 = this;

      var pagination = this.computedPagination;
      var disabled = pagination.rowsPerPage < 0 || pagination.page * pagination.rowsPerPage >= this.itemsLength || this.pageStop < 0;

      return this.$createElement('v-btn', {
        props: {
          disabled: disabled,
          icon: true,
          flat: true,
          dark: this.dark,
          light: this.light
        },
        on: {
          click: function click() {
            var page = _this2.computedPagination.page;
            _this2.updatePagination({ page: page + 1 });
          }
        }
      }, [this.$createElement('v-icon', 'chevron_right')]);
    },
    genSelect: function genSelect() {
      var _this3 = this;

      return this.$createElement('div', {
        'class': 'datatable__actions__select'
      }, [this.rowsPerPageText, this.$createElement('v-select', {
        props: {
          items: this.rowsPerPageItems,
          value: this.computedPagination.rowsPerPage,
          hideDetails: true,
          auto: true,
          minWidth: '75px'
        },
        on: {
          input: function input(val) {
            _this3.updatePagination({
              page: 1,
              rowsPerPage: val
            });
          }
        }
      })]);
    },
    genPagination: function genPagination() {
      var pagination = '–';

      if (this.itemsLength) {
        var stop = this.itemsLength < this.pageStop || this.pageStop < 0 ? this.itemsLength : this.pageStop;

        pagination = this.$scopedSlots.pageText ? this.$scopedSlots.pageText({
          pageStart: this.pageStart + 1,
          pageStop: stop,
          itemsLength: this.itemsLength
        }) : this.pageStart + 1 + '-' + stop + ' of ' + this.itemsLength;
      }

      return this.$createElement('div', {
        'class': 'datatable__actions__pagination'
      }, [pagination]);
    },
    genActions: function genActions() {
      return [this.$createElement('div', {
        'class': 'datatable__actions'
      }, [this.genSelect(), this.genPagination(), this.genPrevIcon(), this.genNextIcon()])];
    },
    genTFoot: function genTFoot() {
      var children = [];

      if (this.$slots.footer) {
        var footer = this.$slots.footer;
        var row = this.needsTR(footer) ? this.genTR(footer) : footer;

        children.push(row);
      }

      if (!this.hideActions) {
        children.push(this.genTR([this.$createElement('td', {
          attrs: { colspan: '100%' }
        }, this.genActions())]));
      }

      if (!children.length) return null;
      return this.$createElement('tfoot', children);
    }
  }
});

/***/ }),
/* 120 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      color: ''
    };
  },


  watch: {
    loading: function loading(val) {
      if (val) this.color = val;
    }
  },

  methods: {
    genTProgress: function genTProgress() {
      var loader = this.$createElement('v-progress-linear', {
        props: {
          primary: this.color === 'primary',
          secondary: this.color === 'secondary',
          success: this.color === 'success',
          info: this.color === 'info',
          warning: this.color === 'warning',
          error: this.color === 'error',
          indeterminate: true,
          height: 3,
          active: !!this.loading
        }
      });

      var col = this.$createElement('th', {
        class: 'column',
        attrs: {
          colspan: '100%'
        }
      }, [loader]);

      return this.$createElement('thead', {
        class: 'datatable__progress'
      }, [this.genTR([col])]);
    }
  }
});

/***/ }),
/* 121 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-edit-dialog',

  data: function data() {
    return {
      isActive: false,
      isSaving: false
    };
  },


  props: {
    cancelText: {
      default: 'Cancel'
    },
    large: Boolean,
    lazy: Boolean,
    saveText: {
      default: 'Save'
    },
    transition: {
      type: String,
      default: 'slide-x-reverse-transition'
    }
  },

  watch: {
    isActive: function isActive(val) {
      val && this.$emit('open') && setTimeout(this.focus, 50); // Give DOM time to paint

      if (!val) {
        !this.isSaving && this.$emit('cancel');
        this.isSaving && this.$emit('close');
        this.isSaving = false;
      }
    }
  },

  methods: {
    cancel: function cancel() {
      this.isActive = false;
    },
    focus: function focus() {
      var input = this.$refs.content.querySelector('input');
      input && input.focus();
    },
    save: function save() {
      this.isSaving = true;
      this.isActive = false;
      this.$emit('save');
    },
    genButton: function genButton(fn, text) {
      return this.$createElement('v-btn', {
        props: {
          flat: true,
          primary: true,
          light: true
        },
        on: { click: fn }
      }, text);
    },
    genActions: function genActions() {
      return this.$createElement('div', {
        'class': 'small-dialog__actions',
        directives: [{
          name: 'show',
          value: this.large
        }]
      }, [this.genButton(this.cancel, this.cancelText), this.genButton(this.save, this.saveText)]);
    },
    genContent: function genContent() {
      var _this = this;

      return this.$createElement('div', {
        'class': 'small-dialog__content',
        on: {
          keydown: function keydown(e) {
            e.keyCode === 27 && _this.cancel();
            e.keyCode === 13 && _this.save();
          }
        },
        ref: 'content'
      }, [this.$slots.input]);
    }
  },

  render: function render(h) {
    var _this2 = this;

    return h('v-menu', {
      'class': 'small-dialog',
      props: {
        transition: this.transition,
        origin: 'top right',
        right: true,
        value: this.isActive,
        closeOnContentClick: false,
        lazy: this.lazy
      },
      on: {
        input: function input(val) {
          return _this2.isActive = val;
        }
      }
    }, [h('a', {
      domProps: { href: 'javascript:;' },
      slot: 'activator'
    }, this.$slots.default), this.genContent(), this.genActions()]);
  }
});

/***/ }),
/* 122 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VTabs__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VTabsItem__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__VTabsContent__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__VTabsBar__ = __webpack_require__(126);






var VTabsSlider = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('tabs__slider', 'li');

var VTabsItems = {
  name: 'v-tabs-items',

  render: function render(h) {
    return h('div', { 'class': { 'tabs__items': true } }, [this.$slots.default]);
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  VTabsItem: __WEBPACK_IMPORTED_MODULE_2__VTabsItem__["a" /* default */],
  VTabsItems: VTabsItems,
  VTabs: __WEBPACK_IMPORTED_MODULE_1__VTabs__["a" /* default */],
  VTabsContent: __WEBPACK_IMPORTED_MODULE_3__VTabsContent__["a" /* default */],
  VTabsBar: __WEBPACK_IMPORTED_MODULE_4__VTabsBar__["a" /* default */],
  VTabsSlider: VTabsSlider
});

/***/ }),
/* 123 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__directives__ = __webpack_require__(4);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-tabs',

  directives: {
    Resize: __WEBPACK_IMPORTED_MODULE_1__directives__["Resize"]
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */]],

  provide: function provide() {
    var _this = this;

    return {
      slider: this.slider,
      tabClick: this.tabClick,
      isScrollable: function isScrollable() {
        return _this.scrollable;
      },
      isMobile: function isMobile() {
        return _this.isMobile;
      }
    };
  },
  data: function data() {
    return {
      activators: [],
      activeIndex: null,
      isMobile: false,
      reverse: false,
      target: null,
      tabsSlider: null,
      targetEl: null,
      tabsContainer: null
    };
  },


  props: {
    centered: Boolean,
    fixed: Boolean,
    grow: Boolean,
    icons: Boolean,
    mobileBreakPoint: {
      type: [Number, String],
      default: 1024
    },
    value: String,
    scrollable: {
      type: Boolean,
      default: true
    }
  },

  computed: {
    classes: function classes() {
      return {
        'tabs': true,
        'tabs--centered': this.centered,
        'tabs--fixed': this.fixed,
        'tabs--grow': this.grow,
        'tabs--icons': this.icons,
        'tabs--mobile': this.isMobile,
        'tabs--scroll-bars': this.scrollable,
        'theme--dark': this.dark,
        'theme--light': this.light
      };
    }
  },

  watch: {
    value: function value() {
      this.tabClick(this.value);
    },
    activeIndex: function activeIndex() {
      this.updateTabs();
      this.$emit('input', this.target);
      this.isBooted = true;
    }
  },

  mounted: function mounted() {
    var _this2 = this;

    this.$vuetify.load(function () {
      var activators = _this2.$slots.activators;

      if (!activators || !activators.length || !activators[0].componentInstance) return;

      var bar = activators[0].componentInstance.$children;
      // // This is a workaround to detect if link is active
      // // when being used as a router or nuxt link
      var i = bar.findIndex(function (t) {
        return t.$el.firstChild.classList.contains('tabs__item--active');
      });

      var tab = _this2.value || (bar[i !== -1 ? i : 0] || {}).action;

      tab && _this2.tabClick(tab) && _this2.onResize();
    });
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('resize', this.resize, { passive: true });
  },


  methods: {
    onResize: function onResize() {
      this.isMobile = window.innerWidth < this.mobileBreakPoint;
      this.slider();
    },
    slider: function slider(el) {
      var _this3 = this;

      this.tabsSlider = this.tabsSlider || this.$el.querySelector('.tabs__slider');

      this.tabsContainer = this.tabsContainer || this.$el.querySelector('.tabs__container');

      if (!this.tabsSlider || !this.tabsContainer) return;

      this.targetEl = el || this.targetEl;

      if (!this.targetEl || !this.tabsContainer) return;

      // Gives DOM time to paint when
      // processing slider for
      // dynamic tabs
      this.$nextTick(function () {
        // #684 Calculate width as %
        var width = _this3.targetEl.scrollWidth / _this3.tabsContainer.clientWidth * 100;

        _this3.tabsSlider.style.width = width + '%';
        _this3.tabsSlider.style.left = _this3.targetEl.offsetLeft + 'px';
      });
    },
    tabClick: function tabClick(target) {
      var _this4 = this;

      var setActiveIndex = function setActiveIndex(index) {
        if (_this4.activeIndex === index) {
          // #762 update tabs display
          // In case tabs count got changed but activeIndex didn't
          _this4.updateTabs();
        } else {
          _this4.activeIndex = index;
        }
      };

      this.target = target;

      var content = this.$refs.content;
      if (!content) {
        setActiveIndex(target);
        return;
      }

      this.$nextTick(function () {
        var nextIndex = content.$children.findIndex(function (i) {
          return i.id === target;
        });
        _this4.reverse = nextIndex < _this4.activeIndex;
        setActiveIndex(nextIndex);
      });
    },
    updateTabs: function updateTabs() {
      var _this5 = this;

      var activators = this.$slots.activators;
      var content = this.$refs.content;

      if (!activators || !activators.length || activators.length && !activators[0].componentInstance) return;

      activators[0].componentInstance.$children.filter(function (i) {
        return i.$options._componentTag === 'v-tabs-item';
      }).forEach(function (i) {
        return i.toggle(_this5.target);
      });

      content && content.$children.forEach(function (i) {
        return i.toggle(_this5.target, _this5.reverse, _this5.isBooted);
      });
    }
  },

  render: function render(h) {
    var content = [];
    var slot = [];
    var iter = this.$slots.default || [];

    iter.forEach(function (c) {
      if (!c.componentOptions) slot.push(c);else if (c.componentOptions.tag === 'v-tabs-content') content.push(c);else slot.push(c);
    });

    var tabs = content.length ? h('v-tabs-items', {
      ref: 'content'
    }, content) : null;

    return h('div', {
      'class': this.classes,
      directives: [{
        name: 'resize',
        value: this.onResize
      }]
    }, [slot, this.$slots.activators, tabs]);
  }
});

/***/ }),
/* 124 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_route_link__ = __webpack_require__(9);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-tabs-item',

  inject: ['slider', 'tabClick'],

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_route_link__["a" /* default */]],

  data: function data() {
    return {
      isActive: false
    };
  },


  props: {
    activeClass: {
      type: String,
      default: 'tabs__item--active'
    }
  },

  computed: {
    classes: function classes() {
      var classes = {
        'tabs__item': true,
        'tabs__item--disabled': this.disabled
      };

      classes[this.activeClass] = !this.to && this.isActive;

      return classes;
    },
    action: function action() {
      var to = this.to || this.href;

      if (!to || to === Object(to)) return this._uid;

      return to.replace('#', '');
    }
  },

  watch: {
    $route: function $route() {
      this.to && this.callSlider();
    }
  },

  mounted: function mounted() {
    this.callSlider();
  },


  methods: {
    callSlider: function callSlider() {
      var _this = this;

      setTimeout(function () {
        _this.$el.firstChild.classList.contains('tabs__item--active') && _this.slider(_this.$el);
      }, 0);
    },
    click: function click(e) {
      e.preventDefault();

      if (!this.to && !this.href) return;

      if (!this.to) {
        this.tabClick(this.action);
      }

      this.callSlider();
    },
    toggle: function toggle(action) {
      var _this2 = this;

      this.isActive = this.action === action;

      this.$nextTick(function () {
        _this2.isActive && _this2.slider(_this2.$el);
      });
    }
  },

  render: function render(h) {
    var _generateRouteLink = this.generateRouteLink(),
        tag = _generateRouteLink.tag,
        data = _generateRouteLink.data;

    return h('li', {
      'class': 'tabs__li'
    }, [h(tag, data, this.$slots.default)]);
  }
});

/***/ }),
/* 125 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_bootable__ = __webpack_require__(10);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-tabs-content',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_bootable__["a" /* default */]],

  data: function data() {
    return {
      isActive: false,
      reverse: false
    };
  },


  props: {
    id: {
      type: String,
      required: true
    },
    lazy: Boolean,
    transition: {
      type: String,
      default: 'v-tab-transition'
    },
    reverseTransition: {
      type: String,
      default: 'v-tab-reverse-transition'
    }
  },

  computed: {
    computedTransition: function computedTransition() {
      return this.reverse ? this.reverseTransition : this.transition;
    }
  },

  methods: {
    toggle: function toggle(target, reverse, showTransition) {
      this.$el.style.transition = !showTransition ? 'none' : null;
      this.reverse = reverse;
      this.isActive = this.id === target;
    }
  },

  render: function render(h) {
    return h(this.computedTransition, {}, [h('div', {
      'class': 'tabs__content',
      domProps: { id: this.id },
      directives: [{
        name: 'show',
        value: this.isActive
      }],
      on: this.$listeners
    }, this.lazy && this.isBooted || !this.lazy ? this.$slots.default : null)]);
  }
});

/***/ }),
/* 126 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_icons_VIcon__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__directives__ = __webpack_require__(4);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-tabs-bar',

  directives: {
    Resize: __WEBPACK_IMPORTED_MODULE_1__directives__["Resize"]
  },

  inject: ['isScrollable', 'isMobile'],

  data: function data() {
    return {
      isOverflowing: false,
      scrollOffset: 0,
      itemOffset: 0,
      startX: 0
    };
  },


  computed: {
    classes: function classes() {
      return {
        'tabs__bar': true
      };
    },
    containerClasses: function containerClasses() {
      return {
        'tabs__container': true
      };
    },
    wrapperClasses: function wrapperClasses() {
      return {
        'tabs__wrapper': true,
        'tabs__wrapper--scrollable': this.isScrollable(),
        'tabs__wrapper--overflow': this.isOverflowing
      };
    },
    containerStyles: function containerStyles() {
      return {
        'transform': 'translateX(' + -this.scrollOffset + 'px)'
      };
    },
    leftIconVisible: function leftIconVisible() {
      return !this.isMobile() && this.isScrollable() && this.isOverflowing && this.scrollOffset > 0;
    },
    rightIconVisible: function rightIconVisible() {
      if (this.isMobile() || !this.isScrollable() || !this.isOverflowing) return;

      // Check one scroll ahead to know the width of right-most item
      var container = this.$refs.container;
      var item = this.newOffsetRight(this.scrollOffset, this.itemOffset);
      var itemWidth = item && container.children[item.index].clientWidth || 0;
      var scrollOffset = this.scrollOffset + container.clientWidth;

      return container.scrollWidth - scrollOffset > itemWidth * 0.30;
    }
  },

  methods: {
    genContainer: function genContainer() {
      return this.$createElement('ul', {
        'class': this.containerClasses,
        'style': this.containerStyles,
        ref: 'container'
      }, this.$slots.default);
    },
    genIcon: function genIcon(direction) {
      var capitalize = direction.charAt(0).toUpperCase() + direction.slice(1);
      return this.$createElement(__WEBPACK_IMPORTED_MODULE_0__components_icons_VIcon__["a" /* default */], {
        props: _defineProperty({}, '' + direction, true),
        style: { display: 'inline-flex' },
        on: {
          click: this['scroll' + capitalize]
        }
      }, 'chevron_' + direction);
    },
    genWrapper: function genWrapper() {
      return this.$createElement('div', {
        class: this.wrapperClasses,
        directives: [{
          name: 'touch',
          value: {
            start: this.start,
            move: this.move,
            end: this.end
          }
        }]
      }, [this.genContainer()]);
    },
    start: function start(e) {
      this.startX = this.scrollOffset + e.touchstartX;
      this.$refs.container.style.transition = 'none';
    },
    move: function move(e) {
      var offset = this.startX - e.touchmoveX;
      this.scrollOffset = offset;
    },
    end: function end(e) {
      this.onResize();
      var container = this.$refs.container;
      var scrollWidth = container.scrollWidth - this.$el.clientWidth / 2;
      container.style.transition = null;

      if (this.scrollOffset < 0 || !this.isOverflowing) {
        this.scrollOffset = 0;
      } else if (this.scrollOffset >= scrollWidth) {
        var lastItem = container.children[container.children.length - 1];
        this.scrollOffset = scrollWidth - lastItem.clientWidth;
      }
    },
    scrollLeft: function scrollLeft() {
      var _newOffset = this.newOffset('Left'),
          offset = _newOffset.offset,
          index = _newOffset.index;

      this.scrollOffset = offset;
      this.itemOffset = index;
    },
    scrollRight: function scrollRight() {
      var _newOffset2 = this.newOffset('Right'),
          offset = _newOffset2.offset,
          index = _newOffset2.index;

      this.scrollOffset = offset;
      this.itemOffset = index;
    },
    onResize: function onResize() {
      if (this._isDestroyed) return;

      var container = this.$refs.container;
      this.isOverflowing = container.clientWidth < container.scrollWidth;
    },
    newOffset: function newOffset(direction) {
      return this['newOffset' + direction](this.scrollOffset, this.itemOffset);
    },
    newOffsetLeft: function newOffsetLeft(currentOffset, currentIndex) {
      var container = this.$refs.container;
      var items = container.children;
      var offset = 0;

      for (var index = currentIndex - 1; index >= 0; index--) {
        if (!items[index].classList.contains('tabs__slider')) {
          var newOffset = offset + items[index].clientWidth;
          if (newOffset >= container.clientWidth) {
            return { offset: currentOffset - offset, index: index + 1 };
          }
          offset = newOffset;
        }
      }

      return { offset: 0, index: 0 };
    },
    newOffsetRight: function newOffsetRight(currentOffset, currentIndex) {
      var container = this.$refs.container;
      var items = container.children;
      var offset = currentOffset;

      for (var index = currentIndex; index < items.length; index++) {
        if (!items[index].classList.contains('tabs__slider')) {
          var newOffset = offset + items[index].clientWidth;
          if (newOffset > currentOffset + container.clientWidth) {
            return { offset: offset, index: index };
          }
          offset = newOffset;
        }
      }

      return null;
    }
  },

  render: function render(h) {
    return h('div', {
      'class': this.classes,
      directives: [{
        name: 'resize',
        value: this.onResize
      }]
    }, [this.genWrapper(), this.leftIconVisible ? this.genIcon('left') : null, this.rightIconVisible ? this.genIcon('right') : null]);
  }
});

/***/ }),
/* 127 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VTextField__ = __webpack_require__(128);


/* harmony default export */ __webpack_exports__["a"] = ({
  VTextField: __WEBPACK_IMPORTED_MODULE_0__VTextField__["a" /* default */]
});

/***/ }),
/* 128 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_input__ = __webpack_require__(7);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-text-field',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_input__["a" /* default */]],

  inheritAttrs: false,

  data: function data() {
    return {
      hasFocused: false,
      inputHeight: null
    };
  },


  props: {
    autofocus: Boolean,
    autoGrow: Boolean,
    counter: Boolean,
    fullWidth: Boolean,
    max: [Number, String],
    min: [Number, String],
    multiLine: Boolean,
    placeholder: String,
    prefix: String,
    rows: {
      default: 5
    },
    singleLine: Boolean,
    solo: Boolean,
    suffix: String,
    textarea: Boolean,
    type: {
      type: String,
      default: 'text'
    }
  },

  computed: {
    classes: function classes() {
      return {
        'input-group--text-field': true,
        'input-group--single-line': this.singleLine,
        'input-group--solo': this.solo,
        'input-group--multi-line': this.multiLine,
        'input-group--full-width': this.fullWidth,
        'input-group--prefix': this.prefix,
        'input-group--suffix': this.suffix,
        'input-group--textarea': this.textarea
      };
    },
    hasError: function hasError() {
      return this.validations.length || this.errorMessages.length > 0 || !this.counterIsValid() || !this.validateIsValid() || this.error;
    },
    count: function count() {
      var inputLength = void 0;
      if (this.inputValue) inputLength = this.inputValue.toString().length;else inputLength = 0;
      var min = inputLength;

      if (this.counterMin !== 0 && inputLength < this.counterMin) {
        min = this.counterMin;
      }

      return min + ' / ' + this.counterMax;
    },
    counterMin: function counterMin() {
      var parsedMin = parseInt(this.min, 10);
      return isNaN(parsedMin) ? 0 : parsedMin;
    },
    counterMax: function counterMax() {
      var parsedMax = parseInt(this.max, 10);
      return isNaN(parsedMax) ? 25 : parsedMax;
    },

    inputValue: {
      get: function get() {
        return this.value;
      },
      set: function set(val) {
        if (this.modifiers.trim) {
          val = val.trim();
        }

        if (this.modifiers.number) {
          val = Number(val);
        }

        if (!this.modifiers.lazy) {
          this.$emit('input', val);
        }

        this.lazyValue = val;
      }
    },
    isDirty: function isDirty() {
      return this.lazyValue !== null && typeof this.lazyValue !== 'undefined' && this.lazyValue.toString().length > 0 || this.placeholder;
    }
  },

  watch: {
    focused: function focused(val) {
      this.hasFocused = true;
    },
    value: function value() {
      this.lazyValue = this.value;
      this.validate();
      this.multiLine && this.autoGrow && this.calculateInputHeight();
    }
  },

  mounted: function mounted() {
    var _this = this;

    this.$vuetify.load(function () {
      _this.multiLine && _this.autoGrow && _this.calculateInputHeight();
      _this.autofocus && _this.focus();
    });
  },


  methods: {
    calculateInputHeight: function calculateInputHeight() {
      var _this2 = this;

      this.inputHeight = null;

      this.$nextTick(function () {
        var height = _this2.$refs.input.scrollHeight;
        var minHeight = _this2.rows * 24;
        var inputHeight = height < minHeight ? minHeight : height;
        _this2.inputHeight = inputHeight;
      });
    },
    onChange: function onChange(e) {
      this.lazyValue = e.target.value;
      this.$emit('change', this.lazyValue || null);
    },
    onInput: function onInput(e) {
      this.inputValue = e.target.value;
      this.multiLine && this.autoGrow && this.calculateInputHeight();
    },
    blur: function blur(e) {
      var _this3 = this;

      this.validate();
      this.$nextTick(function () {
        return _this3.focused = false;
      });
      this.$emit('blur', e);
    },
    focus: function focus(e) {
      this.focused = true;
      this.$refs.input.focus();
      this.$emit('focus', e);
    },
    genCounter: function genCounter() {
      return this.$createElement('div', {
        'class': {
          'input-group__counter': true,
          'input-group__counter--error': !this.counterIsValid()
        }
      }, this.count);
    },
    genInput: function genInput() {
      var tag = this.multiLine || this.textarea ? 'textarea' : 'input';

      var data = {
        style: {
          'height': this.inputHeight && this.inputHeight + 'px'
        },
        domProps: {
          autofocus: this.autofocus,
          disabled: this.disabled,
          required: this.required,
          value: this.lazyValue
        },
        attrs: _extends({}, this.$attrs, {
          tabindex: this.tabindex,
          'aria-label': !this.$attrs.id && this.label // Label `for` will be set if we have an id
        }),
        on: _extends({}, this.$listeners, {
          blur: this.blur,
          input: this.onInput,
          focus: this.focus
        }),
        ref: 'input'
      };

      if (this.placeholder) data.domProps.placeholder = this.placeholder;

      if (!this.counter) {
        if (![undefined, null].includes(this.max)) data.attrs.max = this.max;
        if (![undefined, null].includes(this.min)) data.attrs.min = this.min;
      }

      if (!this.textarea && !this.multiLine) {
        data.domProps.type = this.type;
      } else {
        data.domProps.rows = this.rows;
      }

      var children = [this.$createElement(tag, data)];

      this.prefix && children.unshift(this.genFix('prefix'));
      this.suffix && children.push(this.genFix('suffix'));

      return children;
    },
    genFix: function genFix(type) {
      return this.$createElement('span', {
        'class': 'input-group--text-field__' + type
      }, this[type]);
    },

    counterIsValid: function counterIsValid() {
      var val = this.inputValue && this.inputValue.toString() || '';

      return !this.counter || val.length >= this.counterMin && val.length <= this.counterMax;
    },
    validateIsValid: function validateIsValid() {
      return !this.required || this.required && this.isDirty || !this.hasFocused || this.hasFocused && this.focused;
    }
  },

  render: function render() {
    return this.genInputGroup(this.genInput(), { attrs: { tabindex: false } });
  }
});

/***/ }),
/* 129 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VSnackbar__ = __webpack_require__(130);


/* harmony default export */ __webpack_exports__["a"] = ({
  VSnackbar: __WEBPACK_IMPORTED_MODULE_0__VSnackbar__["a" /* default */]
});

/***/ }),
/* 130 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_contextualable__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__ = __webpack_require__(2);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-snackbar',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_contextualable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__["a" /* default */]],

  data: function data() {
    return {
      activeTimeout: {}
    };
  },


  props: {
    absolute: Boolean,
    bottom: Boolean,
    left: Boolean,
    multiLine: Boolean,
    right: Boolean,
    top: Boolean,
    timeout: {
      type: Number,
      default: 6000
    },
    vertical: Boolean
  },

  computed: {
    classes: function classes() {
      return {
        'snack': true,
        'snack--active': this.isActive,
        'snack--absolute': this.absolute,
        'snack--bottom': this.bottom || !this.top,
        'snack--left': this.left,
        'snack--multi-line': this.multiLine && !this.vertical,
        'snack--right': this.right,
        'snack--top': this.top,
        'snack--vertical': this.vertical,
        'primary': this.primary,
        'secondary': this.secondary,
        'success': this.success,
        'info': this.info,
        'warning': this.warning,
        'error': this.error
      };
    },
    computedTransition: function computedTransition() {
      return this.top ? 'v-slide-y-transition' : 'v-slide-y-reverse-transition';
    }
  },

  watch: {
    isActive: function isActive() {
      var _this = this;

      clearTimeout(this.activeTimeout);

      if (this.isActive && this.timeout) {
        this.activeTimeout = setTimeout(function () {
          _this.isActive = false;
        }, this.timeout);
      }
    }
  },

  render: function render(h) {
    var children = [];

    if (this.isActive) {
      children.push(h('div', {
        'class': 'snack__content'
      }, this.$slots.default));
    }

    return h('div', {
      'class': this.classes,
      on: this.$listeners
    }, [h(this.computedTransition, children)]);
  }
});

/***/ }),
/* 131 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function load(cb) {
  var i = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

  if (document.readyState === 'complete') {
    return setTimeout(cb, 0);
  }

  if (document.readyState === 'interactive' && i <= 10) {
    return setTimeout(function () {
      return load(cb, i + 1);
    }, 200);
  }

  window.addEventListener('load', cb);
}

/* harmony default export */ __webpack_exports__["a"] = (load);

/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process) {exports = module.exports = SemVer;

// The debug function is excluded entirely from the minified version.
/* nomin */ var debug;
/* nomin */ if (typeof process === 'object' &&
    /* nomin */ process.env &&
    /* nomin */ process.env.NODE_DEBUG &&
    /* nomin */ /\bsemver\b/i.test(process.env.NODE_DEBUG))
  /* nomin */ debug = function() {
    /* nomin */ var args = Array.prototype.slice.call(arguments, 0);
    /* nomin */ args.unshift('SEMVER');
    /* nomin */ console.log.apply(console, args);
    /* nomin */ };
/* nomin */ else
  /* nomin */ debug = function() {};

// Note: this is the semver.org version of the spec that it implements
// Not necessarily the package version of this code.
exports.SEMVER_SPEC_VERSION = '2.0.0';

var MAX_LENGTH = 256;
var MAX_SAFE_INTEGER = Number.MAX_SAFE_INTEGER || 9007199254740991;

// The actual regexps go on exports.re
var re = exports.re = [];
var src = exports.src = [];
var R = 0;

// The following Regular Expressions can be used for tokenizing,
// validating, and parsing SemVer version strings.

// ## Numeric Identifier
// A single `0`, or a non-zero digit followed by zero or more digits.

var NUMERICIDENTIFIER = R++;
src[NUMERICIDENTIFIER] = '0|[1-9]\\d*';
var NUMERICIDENTIFIERLOOSE = R++;
src[NUMERICIDENTIFIERLOOSE] = '[0-9]+';


// ## Non-numeric Identifier
// Zero or more digits, followed by a letter or hyphen, and then zero or
// more letters, digits, or hyphens.

var NONNUMERICIDENTIFIER = R++;
src[NONNUMERICIDENTIFIER] = '\\d*[a-zA-Z-][a-zA-Z0-9-]*';


// ## Main Version
// Three dot-separated numeric identifiers.

var MAINVERSION = R++;
src[MAINVERSION] = '(' + src[NUMERICIDENTIFIER] + ')\\.' +
                   '(' + src[NUMERICIDENTIFIER] + ')\\.' +
                   '(' + src[NUMERICIDENTIFIER] + ')';

var MAINVERSIONLOOSE = R++;
src[MAINVERSIONLOOSE] = '(' + src[NUMERICIDENTIFIERLOOSE] + ')\\.' +
                        '(' + src[NUMERICIDENTIFIERLOOSE] + ')\\.' +
                        '(' + src[NUMERICIDENTIFIERLOOSE] + ')';

// ## Pre-release Version Identifier
// A numeric identifier, or a non-numeric identifier.

var PRERELEASEIDENTIFIER = R++;
src[PRERELEASEIDENTIFIER] = '(?:' + src[NUMERICIDENTIFIER] +
                            '|' + src[NONNUMERICIDENTIFIER] + ')';

var PRERELEASEIDENTIFIERLOOSE = R++;
src[PRERELEASEIDENTIFIERLOOSE] = '(?:' + src[NUMERICIDENTIFIERLOOSE] +
                                 '|' + src[NONNUMERICIDENTIFIER] + ')';


// ## Pre-release Version
// Hyphen, followed by one or more dot-separated pre-release version
// identifiers.

var PRERELEASE = R++;
src[PRERELEASE] = '(?:-(' + src[PRERELEASEIDENTIFIER] +
                  '(?:\\.' + src[PRERELEASEIDENTIFIER] + ')*))';

var PRERELEASELOOSE = R++;
src[PRERELEASELOOSE] = '(?:-?(' + src[PRERELEASEIDENTIFIERLOOSE] +
                       '(?:\\.' + src[PRERELEASEIDENTIFIERLOOSE] + ')*))';

// ## Build Metadata Identifier
// Any combination of digits, letters, or hyphens.

var BUILDIDENTIFIER = R++;
src[BUILDIDENTIFIER] = '[0-9A-Za-z-]+';

// ## Build Metadata
// Plus sign, followed by one or more period-separated build metadata
// identifiers.

var BUILD = R++;
src[BUILD] = '(?:\\+(' + src[BUILDIDENTIFIER] +
             '(?:\\.' + src[BUILDIDENTIFIER] + ')*))';


// ## Full Version String
// A main version, followed optionally by a pre-release version and
// build metadata.

// Note that the only major, minor, patch, and pre-release sections of
// the version string are capturing groups.  The build metadata is not a
// capturing group, because it should not ever be used in version
// comparison.

var FULL = R++;
var FULLPLAIN = 'v?' + src[MAINVERSION] +
                src[PRERELEASE] + '?' +
                src[BUILD] + '?';

src[FULL] = '^' + FULLPLAIN + '$';

// like full, but allows v1.2.3 and =1.2.3, which people do sometimes.
// also, 1.0.0alpha1 (prerelease without the hyphen) which is pretty
// common in the npm registry.
var LOOSEPLAIN = '[v=\\s]*' + src[MAINVERSIONLOOSE] +
                 src[PRERELEASELOOSE] + '?' +
                 src[BUILD] + '?';

var LOOSE = R++;
src[LOOSE] = '^' + LOOSEPLAIN + '$';

var GTLT = R++;
src[GTLT] = '((?:<|>)?=?)';

// Something like "2.*" or "1.2.x".
// Note that "x.x" is a valid xRange identifer, meaning "any version"
// Only the first item is strictly required.
var XRANGEIDENTIFIERLOOSE = R++;
src[XRANGEIDENTIFIERLOOSE] = src[NUMERICIDENTIFIERLOOSE] + '|x|X|\\*';
var XRANGEIDENTIFIER = R++;
src[XRANGEIDENTIFIER] = src[NUMERICIDENTIFIER] + '|x|X|\\*';

var XRANGEPLAIN = R++;
src[XRANGEPLAIN] = '[v=\\s]*(' + src[XRANGEIDENTIFIER] + ')' +
                   '(?:\\.(' + src[XRANGEIDENTIFIER] + ')' +
                   '(?:\\.(' + src[XRANGEIDENTIFIER] + ')' +
                   '(?:' + src[PRERELEASE] + ')?' +
                   src[BUILD] + '?' +
                   ')?)?';

var XRANGEPLAINLOOSE = R++;
src[XRANGEPLAINLOOSE] = '[v=\\s]*(' + src[XRANGEIDENTIFIERLOOSE] + ')' +
                        '(?:\\.(' + src[XRANGEIDENTIFIERLOOSE] + ')' +
                        '(?:\\.(' + src[XRANGEIDENTIFIERLOOSE] + ')' +
                        '(?:' + src[PRERELEASELOOSE] + ')?' +
                        src[BUILD] + '?' +
                        ')?)?';

var XRANGE = R++;
src[XRANGE] = '^' + src[GTLT] + '\\s*' + src[XRANGEPLAIN] + '$';
var XRANGELOOSE = R++;
src[XRANGELOOSE] = '^' + src[GTLT] + '\\s*' + src[XRANGEPLAINLOOSE] + '$';

// Tilde ranges.
// Meaning is "reasonably at or greater than"
var LONETILDE = R++;
src[LONETILDE] = '(?:~>?)';

var TILDETRIM = R++;
src[TILDETRIM] = '(\\s*)' + src[LONETILDE] + '\\s+';
re[TILDETRIM] = new RegExp(src[TILDETRIM], 'g');
var tildeTrimReplace = '$1~';

var TILDE = R++;
src[TILDE] = '^' + src[LONETILDE] + src[XRANGEPLAIN] + '$';
var TILDELOOSE = R++;
src[TILDELOOSE] = '^' + src[LONETILDE] + src[XRANGEPLAINLOOSE] + '$';

// Caret ranges.
// Meaning is "at least and backwards compatible with"
var LONECARET = R++;
src[LONECARET] = '(?:\\^)';

var CARETTRIM = R++;
src[CARETTRIM] = '(\\s*)' + src[LONECARET] + '\\s+';
re[CARETTRIM] = new RegExp(src[CARETTRIM], 'g');
var caretTrimReplace = '$1^';

var CARET = R++;
src[CARET] = '^' + src[LONECARET] + src[XRANGEPLAIN] + '$';
var CARETLOOSE = R++;
src[CARETLOOSE] = '^' + src[LONECARET] + src[XRANGEPLAINLOOSE] + '$';

// A simple gt/lt/eq thing, or just "" to indicate "any version"
var COMPARATORLOOSE = R++;
src[COMPARATORLOOSE] = '^' + src[GTLT] + '\\s*(' + LOOSEPLAIN + ')$|^$';
var COMPARATOR = R++;
src[COMPARATOR] = '^' + src[GTLT] + '\\s*(' + FULLPLAIN + ')$|^$';


// An expression to strip any whitespace between the gtlt and the thing
// it modifies, so that `> 1.2.3` ==> `>1.2.3`
var COMPARATORTRIM = R++;
src[COMPARATORTRIM] = '(\\s*)' + src[GTLT] +
                      '\\s*(' + LOOSEPLAIN + '|' + src[XRANGEPLAIN] + ')';

// this one has to use the /g flag
re[COMPARATORTRIM] = new RegExp(src[COMPARATORTRIM], 'g');
var comparatorTrimReplace = '$1$2$3';


// Something like `1.2.3 - 1.2.4`
// Note that these all use the loose form, because they'll be
// checked against either the strict or loose comparator form
// later.
var HYPHENRANGE = R++;
src[HYPHENRANGE] = '^\\s*(' + src[XRANGEPLAIN] + ')' +
                   '\\s+-\\s+' +
                   '(' + src[XRANGEPLAIN] + ')' +
                   '\\s*$';

var HYPHENRANGELOOSE = R++;
src[HYPHENRANGELOOSE] = '^\\s*(' + src[XRANGEPLAINLOOSE] + ')' +
                        '\\s+-\\s+' +
                        '(' + src[XRANGEPLAINLOOSE] + ')' +
                        '\\s*$';

// Star ranges basically just allow anything at all.
var STAR = R++;
src[STAR] = '(<|>)?=?\\s*\\*';

// Compile to actual regexp objects.
// All are flag-free, unless they were created above with a flag.
for (var i = 0; i < R; i++) {
  debug(i, src[i]);
  if (!re[i])
    re[i] = new RegExp(src[i]);
}

exports.parse = parse;
function parse(version, loose) {
  if (version instanceof SemVer)
    return version;

  if (typeof version !== 'string')
    return null;

  if (version.length > MAX_LENGTH)
    return null;

  var r = loose ? re[LOOSE] : re[FULL];
  if (!r.test(version))
    return null;

  try {
    return new SemVer(version, loose);
  } catch (er) {
    return null;
  }
}

exports.valid = valid;
function valid(version, loose) {
  var v = parse(version, loose);
  return v ? v.version : null;
}


exports.clean = clean;
function clean(version, loose) {
  var s = parse(version.trim().replace(/^[=v]+/, ''), loose);
  return s ? s.version : null;
}

exports.SemVer = SemVer;

function SemVer(version, loose) {
  if (version instanceof SemVer) {
    if (version.loose === loose)
      return version;
    else
      version = version.version;
  } else if (typeof version !== 'string') {
    throw new TypeError('Invalid Version: ' + version);
  }

  if (version.length > MAX_LENGTH)
    throw new TypeError('version is longer than ' + MAX_LENGTH + ' characters')

  if (!(this instanceof SemVer))
    return new SemVer(version, loose);

  debug('SemVer', version, loose);
  this.loose = loose;
  var m = version.trim().match(loose ? re[LOOSE] : re[FULL]);

  if (!m)
    throw new TypeError('Invalid Version: ' + version);

  this.raw = version;

  // these are actually numbers
  this.major = +m[1];
  this.minor = +m[2];
  this.patch = +m[3];

  if (this.major > MAX_SAFE_INTEGER || this.major < 0)
    throw new TypeError('Invalid major version')

  if (this.minor > MAX_SAFE_INTEGER || this.minor < 0)
    throw new TypeError('Invalid minor version')

  if (this.patch > MAX_SAFE_INTEGER || this.patch < 0)
    throw new TypeError('Invalid patch version')

  // numberify any prerelease numeric ids
  if (!m[4])
    this.prerelease = [];
  else
    this.prerelease = m[4].split('.').map(function(id) {
      if (/^[0-9]+$/.test(id)) {
        var num = +id;
        if (num >= 0 && num < MAX_SAFE_INTEGER)
          return num;
      }
      return id;
    });

  this.build = m[5] ? m[5].split('.') : [];
  this.format();
}

SemVer.prototype.format = function() {
  this.version = this.major + '.' + this.minor + '.' + this.patch;
  if (this.prerelease.length)
    this.version += '-' + this.prerelease.join('.');
  return this.version;
};

SemVer.prototype.toString = function() {
  return this.version;
};

SemVer.prototype.compare = function(other) {
  debug('SemVer.compare', this.version, this.loose, other);
  if (!(other instanceof SemVer))
    other = new SemVer(other, this.loose);

  return this.compareMain(other) || this.comparePre(other);
};

SemVer.prototype.compareMain = function(other) {
  if (!(other instanceof SemVer))
    other = new SemVer(other, this.loose);

  return compareIdentifiers(this.major, other.major) ||
         compareIdentifiers(this.minor, other.minor) ||
         compareIdentifiers(this.patch, other.patch);
};

SemVer.prototype.comparePre = function(other) {
  if (!(other instanceof SemVer))
    other = new SemVer(other, this.loose);

  // NOT having a prerelease is > having one
  if (this.prerelease.length && !other.prerelease.length)
    return -1;
  else if (!this.prerelease.length && other.prerelease.length)
    return 1;
  else if (!this.prerelease.length && !other.prerelease.length)
    return 0;

  var i = 0;
  do {
    var a = this.prerelease[i];
    var b = other.prerelease[i];
    debug('prerelease compare', i, a, b);
    if (a === undefined && b === undefined)
      return 0;
    else if (b === undefined)
      return 1;
    else if (a === undefined)
      return -1;
    else if (a === b)
      continue;
    else
      return compareIdentifiers(a, b);
  } while (++i);
};

// preminor will bump the version up to the next minor release, and immediately
// down to pre-release. premajor and prepatch work the same way.
SemVer.prototype.inc = function(release, identifier) {
  switch (release) {
    case 'premajor':
      this.prerelease.length = 0;
      this.patch = 0;
      this.minor = 0;
      this.major++;
      this.inc('pre', identifier);
      break;
    case 'preminor':
      this.prerelease.length = 0;
      this.patch = 0;
      this.minor++;
      this.inc('pre', identifier);
      break;
    case 'prepatch':
      // If this is already a prerelease, it will bump to the next version
      // drop any prereleases that might already exist, since they are not
      // relevant at this point.
      this.prerelease.length = 0;
      this.inc('patch', identifier);
      this.inc('pre', identifier);
      break;
    // If the input is a non-prerelease version, this acts the same as
    // prepatch.
    case 'prerelease':
      if (this.prerelease.length === 0)
        this.inc('patch', identifier);
      this.inc('pre', identifier);
      break;

    case 'major':
      // If this is a pre-major version, bump up to the same major version.
      // Otherwise increment major.
      // 1.0.0-5 bumps to 1.0.0
      // 1.1.0 bumps to 2.0.0
      if (this.minor !== 0 || this.patch !== 0 || this.prerelease.length === 0)
        this.major++;
      this.minor = 0;
      this.patch = 0;
      this.prerelease = [];
      break;
    case 'minor':
      // If this is a pre-minor version, bump up to the same minor version.
      // Otherwise increment minor.
      // 1.2.0-5 bumps to 1.2.0
      // 1.2.1 bumps to 1.3.0
      if (this.patch !== 0 || this.prerelease.length === 0)
        this.minor++;
      this.patch = 0;
      this.prerelease = [];
      break;
    case 'patch':
      // If this is not a pre-release version, it will increment the patch.
      // If it is a pre-release it will bump up to the same patch version.
      // 1.2.0-5 patches to 1.2.0
      // 1.2.0 patches to 1.2.1
      if (this.prerelease.length === 0)
        this.patch++;
      this.prerelease = [];
      break;
    // This probably shouldn't be used publicly.
    // 1.0.0 "pre" would become 1.0.0-0 which is the wrong direction.
    case 'pre':
      if (this.prerelease.length === 0)
        this.prerelease = [0];
      else {
        var i = this.prerelease.length;
        while (--i >= 0) {
          if (typeof this.prerelease[i] === 'number') {
            this.prerelease[i]++;
            i = -2;
          }
        }
        if (i === -1) // didn't increment anything
          this.prerelease.push(0);
      }
      if (identifier) {
        // 1.2.0-beta.1 bumps to 1.2.0-beta.2,
        // 1.2.0-beta.fooblz or 1.2.0-beta bumps to 1.2.0-beta.0
        if (this.prerelease[0] === identifier) {
          if (isNaN(this.prerelease[1]))
            this.prerelease = [identifier, 0];
        } else
          this.prerelease = [identifier, 0];
      }
      break;

    default:
      throw new Error('invalid increment argument: ' + release);
  }
  this.format();
  this.raw = this.version;
  return this;
};

exports.inc = inc;
function inc(version, release, loose, identifier) {
  if (typeof(loose) === 'string') {
    identifier = loose;
    loose = undefined;
  }

  try {
    return new SemVer(version, loose).inc(release, identifier).version;
  } catch (er) {
    return null;
  }
}

exports.diff = diff;
function diff(version1, version2) {
  if (eq(version1, version2)) {
    return null;
  } else {
    var v1 = parse(version1);
    var v2 = parse(version2);
    if (v1.prerelease.length || v2.prerelease.length) {
      for (var key in v1) {
        if (key === 'major' || key === 'minor' || key === 'patch') {
          if (v1[key] !== v2[key]) {
            return 'pre'+key;
          }
        }
      }
      return 'prerelease';
    }
    for (var key in v1) {
      if (key === 'major' || key === 'minor' || key === 'patch') {
        if (v1[key] !== v2[key]) {
          return key;
        }
      }
    }
  }
}

exports.compareIdentifiers = compareIdentifiers;

var numeric = /^[0-9]+$/;
function compareIdentifiers(a, b) {
  var anum = numeric.test(a);
  var bnum = numeric.test(b);

  if (anum && bnum) {
    a = +a;
    b = +b;
  }

  return (anum && !bnum) ? -1 :
         (bnum && !anum) ? 1 :
         a < b ? -1 :
         a > b ? 1 :
         0;
}

exports.rcompareIdentifiers = rcompareIdentifiers;
function rcompareIdentifiers(a, b) {
  return compareIdentifiers(b, a);
}

exports.major = major;
function major(a, loose) {
  return new SemVer(a, loose).major;
}

exports.minor = minor;
function minor(a, loose) {
  return new SemVer(a, loose).minor;
}

exports.patch = patch;
function patch(a, loose) {
  return new SemVer(a, loose).patch;
}

exports.compare = compare;
function compare(a, b, loose) {
  return new SemVer(a, loose).compare(b);
}

exports.compareLoose = compareLoose;
function compareLoose(a, b) {
  return compare(a, b, true);
}

exports.rcompare = rcompare;
function rcompare(a, b, loose) {
  return compare(b, a, loose);
}

exports.sort = sort;
function sort(list, loose) {
  return list.sort(function(a, b) {
    return exports.compare(a, b, loose);
  });
}

exports.rsort = rsort;
function rsort(list, loose) {
  return list.sort(function(a, b) {
    return exports.rcompare(a, b, loose);
  });
}

exports.gt = gt;
function gt(a, b, loose) {
  return compare(a, b, loose) > 0;
}

exports.lt = lt;
function lt(a, b, loose) {
  return compare(a, b, loose) < 0;
}

exports.eq = eq;
function eq(a, b, loose) {
  return compare(a, b, loose) === 0;
}

exports.neq = neq;
function neq(a, b, loose) {
  return compare(a, b, loose) !== 0;
}

exports.gte = gte;
function gte(a, b, loose) {
  return compare(a, b, loose) >= 0;
}

exports.lte = lte;
function lte(a, b, loose) {
  return compare(a, b, loose) <= 0;
}

exports.cmp = cmp;
function cmp(a, op, b, loose) {
  var ret;
  switch (op) {
    case '===':
      if (typeof a === 'object') a = a.version;
      if (typeof b === 'object') b = b.version;
      ret = a === b;
      break;
    case '!==':
      if (typeof a === 'object') a = a.version;
      if (typeof b === 'object') b = b.version;
      ret = a !== b;
      break;
    case '': case '=': case '==': ret = eq(a, b, loose); break;
    case '!=': ret = neq(a, b, loose); break;
    case '>': ret = gt(a, b, loose); break;
    case '>=': ret = gte(a, b, loose); break;
    case '<': ret = lt(a, b, loose); break;
    case '<=': ret = lte(a, b, loose); break;
    default: throw new TypeError('Invalid operator: ' + op);
  }
  return ret;
}

exports.Comparator = Comparator;
function Comparator(comp, loose) {
  if (comp instanceof Comparator) {
    if (comp.loose === loose)
      return comp;
    else
      comp = comp.value;
  }

  if (!(this instanceof Comparator))
    return new Comparator(comp, loose);

  debug('comparator', comp, loose);
  this.loose = loose;
  this.parse(comp);

  if (this.semver === ANY)
    this.value = '';
  else
    this.value = this.operator + this.semver.version;

  debug('comp', this);
}

var ANY = {};
Comparator.prototype.parse = function(comp) {
  var r = this.loose ? re[COMPARATORLOOSE] : re[COMPARATOR];
  var m = comp.match(r);

  if (!m)
    throw new TypeError('Invalid comparator: ' + comp);

  this.operator = m[1];
  if (this.operator === '=')
    this.operator = '';

  // if it literally is just '>' or '' then allow anything.
  if (!m[2])
    this.semver = ANY;
  else
    this.semver = new SemVer(m[2], this.loose);
};

Comparator.prototype.toString = function() {
  return this.value;
};

Comparator.prototype.test = function(version) {
  debug('Comparator.test', version, this.loose);

  if (this.semver === ANY)
    return true;

  if (typeof version === 'string')
    version = new SemVer(version, this.loose);

  return cmp(version, this.operator, this.semver, this.loose);
};


exports.Range = Range;
function Range(range, loose) {
  if ((range instanceof Range) && range.loose === loose)
    return range;

  if (!(this instanceof Range))
    return new Range(range, loose);

  this.loose = loose;

  // First, split based on boolean or ||
  this.raw = range;
  this.set = range.split(/\s*\|\|\s*/).map(function(range) {
    return this.parseRange(range.trim());
  }, this).filter(function(c) {
    // throw out any that are not relevant for whatever reason
    return c.length;
  });

  if (!this.set.length) {
    throw new TypeError('Invalid SemVer Range: ' + range);
  }

  this.format();
}

Range.prototype.format = function() {
  this.range = this.set.map(function(comps) {
    return comps.join(' ').trim();
  }).join('||').trim();
  return this.range;
};

Range.prototype.toString = function() {
  return this.range;
};

Range.prototype.parseRange = function(range) {
  var loose = this.loose;
  range = range.trim();
  debug('range', range, loose);
  // `1.2.3 - 1.2.4` => `>=1.2.3 <=1.2.4`
  var hr = loose ? re[HYPHENRANGELOOSE] : re[HYPHENRANGE];
  range = range.replace(hr, hyphenReplace);
  debug('hyphen replace', range);
  // `> 1.2.3 < 1.2.5` => `>1.2.3 <1.2.5`
  range = range.replace(re[COMPARATORTRIM], comparatorTrimReplace);
  debug('comparator trim', range, re[COMPARATORTRIM]);

  // `~ 1.2.3` => `~1.2.3`
  range = range.replace(re[TILDETRIM], tildeTrimReplace);

  // `^ 1.2.3` => `^1.2.3`
  range = range.replace(re[CARETTRIM], caretTrimReplace);

  // normalize spaces
  range = range.split(/\s+/).join(' ');

  // At this point, the range is completely trimmed and
  // ready to be split into comparators.

  var compRe = loose ? re[COMPARATORLOOSE] : re[COMPARATOR];
  var set = range.split(' ').map(function(comp) {
    return parseComparator(comp, loose);
  }).join(' ').split(/\s+/);
  if (this.loose) {
    // in loose mode, throw out any that are not valid comparators
    set = set.filter(function(comp) {
      return !!comp.match(compRe);
    });
  }
  set = set.map(function(comp) {
    return new Comparator(comp, loose);
  });

  return set;
};

// Mostly just for testing and legacy API reasons
exports.toComparators = toComparators;
function toComparators(range, loose) {
  return new Range(range, loose).set.map(function(comp) {
    return comp.map(function(c) {
      return c.value;
    }).join(' ').trim().split(' ');
  });
}

// comprised of xranges, tildes, stars, and gtlt's at this point.
// already replaced the hyphen ranges
// turn into a set of JUST comparators.
function parseComparator(comp, loose) {
  debug('comp', comp);
  comp = replaceCarets(comp, loose);
  debug('caret', comp);
  comp = replaceTildes(comp, loose);
  debug('tildes', comp);
  comp = replaceXRanges(comp, loose);
  debug('xrange', comp);
  comp = replaceStars(comp, loose);
  debug('stars', comp);
  return comp;
}

function isX(id) {
  return !id || id.toLowerCase() === 'x' || id === '*';
}

// ~, ~> --> * (any, kinda silly)
// ~2, ~2.x, ~2.x.x, ~>2, ~>2.x ~>2.x.x --> >=2.0.0 <3.0.0
// ~2.0, ~2.0.x, ~>2.0, ~>2.0.x --> >=2.0.0 <2.1.0
// ~1.2, ~1.2.x, ~>1.2, ~>1.2.x --> >=1.2.0 <1.3.0
// ~1.2.3, ~>1.2.3 --> >=1.2.3 <1.3.0
// ~1.2.0, ~>1.2.0 --> >=1.2.0 <1.3.0
function replaceTildes(comp, loose) {
  return comp.trim().split(/\s+/).map(function(comp) {
    return replaceTilde(comp, loose);
  }).join(' ');
}

function replaceTilde(comp, loose) {
  var r = loose ? re[TILDELOOSE] : re[TILDE];
  return comp.replace(r, function(_, M, m, p, pr) {
    debug('tilde', comp, _, M, m, p, pr);
    var ret;

    if (isX(M))
      ret = '';
    else if (isX(m))
      ret = '>=' + M + '.0.0 <' + (+M + 1) + '.0.0';
    else if (isX(p))
      // ~1.2 == >=1.2.0 <1.3.0
      ret = '>=' + M + '.' + m + '.0 <' + M + '.' + (+m + 1) + '.0';
    else if (pr) {
      debug('replaceTilde pr', pr);
      if (pr.charAt(0) !== '-')
        pr = '-' + pr;
      ret = '>=' + M + '.' + m + '.' + p + pr +
            ' <' + M + '.' + (+m + 1) + '.0';
    } else
      // ~1.2.3 == >=1.2.3 <1.3.0
      ret = '>=' + M + '.' + m + '.' + p +
            ' <' + M + '.' + (+m + 1) + '.0';

    debug('tilde return', ret);
    return ret;
  });
}

// ^ --> * (any, kinda silly)
// ^2, ^2.x, ^2.x.x --> >=2.0.0 <3.0.0
// ^2.0, ^2.0.x --> >=2.0.0 <3.0.0
// ^1.2, ^1.2.x --> >=1.2.0 <2.0.0
// ^1.2.3 --> >=1.2.3 <2.0.0
// ^1.2.0 --> >=1.2.0 <2.0.0
function replaceCarets(comp, loose) {
  return comp.trim().split(/\s+/).map(function(comp) {
    return replaceCaret(comp, loose);
  }).join(' ');
}

function replaceCaret(comp, loose) {
  debug('caret', comp, loose);
  var r = loose ? re[CARETLOOSE] : re[CARET];
  return comp.replace(r, function(_, M, m, p, pr) {
    debug('caret', comp, _, M, m, p, pr);
    var ret;

    if (isX(M))
      ret = '';
    else if (isX(m))
      ret = '>=' + M + '.0.0 <' + (+M + 1) + '.0.0';
    else if (isX(p)) {
      if (M === '0')
        ret = '>=' + M + '.' + m + '.0 <' + M + '.' + (+m + 1) + '.0';
      else
        ret = '>=' + M + '.' + m + '.0 <' + (+M + 1) + '.0.0';
    } else if (pr) {
      debug('replaceCaret pr', pr);
      if (pr.charAt(0) !== '-')
        pr = '-' + pr;
      if (M === '0') {
        if (m === '0')
          ret = '>=' + M + '.' + m + '.' + p + pr +
                ' <' + M + '.' + m + '.' + (+p + 1);
        else
          ret = '>=' + M + '.' + m + '.' + p + pr +
                ' <' + M + '.' + (+m + 1) + '.0';
      } else
        ret = '>=' + M + '.' + m + '.' + p + pr +
              ' <' + (+M + 1) + '.0.0';
    } else {
      debug('no pr');
      if (M === '0') {
        if (m === '0')
          ret = '>=' + M + '.' + m + '.' + p +
                ' <' + M + '.' + m + '.' + (+p + 1);
        else
          ret = '>=' + M + '.' + m + '.' + p +
                ' <' + M + '.' + (+m + 1) + '.0';
      } else
        ret = '>=' + M + '.' + m + '.' + p +
              ' <' + (+M + 1) + '.0.0';
    }

    debug('caret return', ret);
    return ret;
  });
}

function replaceXRanges(comp, loose) {
  debug('replaceXRanges', comp, loose);
  return comp.split(/\s+/).map(function(comp) {
    return replaceXRange(comp, loose);
  }).join(' ');
}

function replaceXRange(comp, loose) {
  comp = comp.trim();
  var r = loose ? re[XRANGELOOSE] : re[XRANGE];
  return comp.replace(r, function(ret, gtlt, M, m, p, pr) {
    debug('xRange', comp, ret, gtlt, M, m, p, pr);
    var xM = isX(M);
    var xm = xM || isX(m);
    var xp = xm || isX(p);
    var anyX = xp;

    if (gtlt === '=' && anyX)
      gtlt = '';

    if (xM) {
      if (gtlt === '>' || gtlt === '<') {
        // nothing is allowed
        ret = '<0.0.0';
      } else {
        // nothing is forbidden
        ret = '*';
      }
    } else if (gtlt && anyX) {
      // replace X with 0
      if (xm)
        m = 0;
      if (xp)
        p = 0;

      if (gtlt === '>') {
        // >1 => >=2.0.0
        // >1.2 => >=1.3.0
        // >1.2.3 => >= 1.2.4
        gtlt = '>=';
        if (xm) {
          M = +M + 1;
          m = 0;
          p = 0;
        } else if (xp) {
          m = +m + 1;
          p = 0;
        }
      } else if (gtlt === '<=') {
        // <=0.7.x is actually <0.8.0, since any 0.7.x should
        // pass.  Similarly, <=7.x is actually <8.0.0, etc.
        gtlt = '<';
        if (xm)
          M = +M + 1;
        else
          m = +m + 1;
      }

      ret = gtlt + M + '.' + m + '.' + p;
    } else if (xm) {
      ret = '>=' + M + '.0.0 <' + (+M + 1) + '.0.0';
    } else if (xp) {
      ret = '>=' + M + '.' + m + '.0 <' + M + '.' + (+m + 1) + '.0';
    }

    debug('xRange return', ret);

    return ret;
  });
}

// Because * is AND-ed with everything else in the comparator,
// and '' means "any version", just remove the *s entirely.
function replaceStars(comp, loose) {
  debug('replaceStars', comp, loose);
  // Looseness is ignored here.  star is always as loose as it gets!
  return comp.trim().replace(re[STAR], '');
}

// This function is passed to string.replace(re[HYPHENRANGE])
// M, m, patch, prerelease, build
// 1.2 - 3.4.5 => >=1.2.0 <=3.4.5
// 1.2.3 - 3.4 => >=1.2.0 <3.5.0 Any 3.4.x will do
// 1.2 - 3.4 => >=1.2.0 <3.5.0
function hyphenReplace($0,
                       from, fM, fm, fp, fpr, fb,
                       to, tM, tm, tp, tpr, tb) {

  if (isX(fM))
    from = '';
  else if (isX(fm))
    from = '>=' + fM + '.0.0';
  else if (isX(fp))
    from = '>=' + fM + '.' + fm + '.0';
  else
    from = '>=' + from;

  if (isX(tM))
    to = '';
  else if (isX(tm))
    to = '<' + (+tM + 1) + '.0.0';
  else if (isX(tp))
    to = '<' + tM + '.' + (+tm + 1) + '.0';
  else if (tpr)
    to = '<=' + tM + '.' + tm + '.' + tp + '-' + tpr;
  else
    to = '<=' + to;

  return (from + ' ' + to).trim();
}


// if ANY of the sets match ALL of its comparators, then pass
Range.prototype.test = function(version) {
  if (!version)
    return false;

  if (typeof version === 'string')
    version = new SemVer(version, this.loose);

  for (var i = 0; i < this.set.length; i++) {
    if (testSet(this.set[i], version))
      return true;
  }
  return false;
};

function testSet(set, version) {
  for (var i = 0; i < set.length; i++) {
    if (!set[i].test(version))
      return false;
  }

  if (version.prerelease.length) {
    // Find the set of versions that are allowed to have prereleases
    // For example, ^1.2.3-pr.1 desugars to >=1.2.3-pr.1 <2.0.0
    // That should allow `1.2.3-pr.2` to pass.
    // However, `1.2.4-alpha.notready` should NOT be allowed,
    // even though it's within the range set by the comparators.
    for (var i = 0; i < set.length; i++) {
      debug(set[i].semver);
      if (set[i].semver === ANY)
        continue;

      if (set[i].semver.prerelease.length > 0) {
        var allowed = set[i].semver;
        if (allowed.major === version.major &&
            allowed.minor === version.minor &&
            allowed.patch === version.patch)
          return true;
      }
    }

    // Version has a -pre, but it's not one of the ones we like.
    return false;
  }

  return true;
}

exports.satisfies = satisfies;
function satisfies(version, range, loose) {
  try {
    range = new Range(range, loose);
  } catch (er) {
    return false;
  }
  return range.test(version);
}

exports.maxSatisfying = maxSatisfying;
function maxSatisfying(versions, range, loose) {
  return versions.filter(function(version) {
    return satisfies(version, range, loose);
  }).sort(function(a, b) {
    return rcompare(a, b, loose);
  })[0] || null;
}

exports.minSatisfying = minSatisfying;
function minSatisfying(versions, range, loose) {
  return versions.filter(function(version) {
    return satisfies(version, range, loose);
  }).sort(function(a, b) {
    return compare(a, b, loose);
  })[0] || null;
}

exports.validRange = validRange;
function validRange(range, loose) {
  try {
    // Return '*' instead of '' so that truthiness works.
    // This will throw if it's invalid anyway
    return new Range(range, loose).range || '*';
  } catch (er) {
    return null;
  }
}

// Determine if version is less than all the versions possible in the range
exports.ltr = ltr;
function ltr(version, range, loose) {
  return outside(version, range, '<', loose);
}

// Determine if version is greater than all the versions possible in the range.
exports.gtr = gtr;
function gtr(version, range, loose) {
  return outside(version, range, '>', loose);
}

exports.outside = outside;
function outside(version, range, hilo, loose) {
  version = new SemVer(version, loose);
  range = new Range(range, loose);

  var gtfn, ltefn, ltfn, comp, ecomp;
  switch (hilo) {
    case '>':
      gtfn = gt;
      ltefn = lte;
      ltfn = lt;
      comp = '>';
      ecomp = '>=';
      break;
    case '<':
      gtfn = lt;
      ltefn = gte;
      ltfn = gt;
      comp = '<';
      ecomp = '<=';
      break;
    default:
      throw new TypeError('Must provide a hilo val of "<" or ">"');
  }

  // If it satisifes the range it is not outside
  if (satisfies(version, range, loose)) {
    return false;
  }

  // From now on, variable terms are as if we're in "gtr" mode.
  // but note that everything is flipped for the "ltr" function.

  for (var i = 0; i < range.set.length; ++i) {
    var comparators = range.set[i];

    var high = null;
    var low = null;

    comparators.forEach(function(comparator) {
      if (comparator.semver === ANY) {
        comparator = new Comparator('>=0.0.0')
      }
      high = high || comparator;
      low = low || comparator;
      if (gtfn(comparator.semver, high.semver, loose)) {
        high = comparator;
      } else if (ltfn(comparator.semver, low.semver, loose)) {
        low = comparator;
      }
    });

    // If the edge version comparator has a operator then our version
    // isn't outside it
    if (high.operator === comp || high.operator === ecomp) {
      return false;
    }

    // If the lowest version comparator has an operator and our version
    // is less than it then it isn't higher than the range
    if ((!low.operator || low.operator === comp) &&
        ltefn(version, low.semver)) {
      return false;
    } else if (low.operator === ecomp && ltfn(version, low.semver)) {
      return false;
    }
  }
  return true;
}

exports.prerelease = prerelease;
function prerelease(version, loose) {
  var parsed = parse(version, loose);
  return (parsed && parsed.prerelease.length) ? parsed.prerelease : null;
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(133)))

/***/ }),
/* 133 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ })
/******/ ]);
});
//# sourceMappingURL=vuetify.js.map

/***/ }),
/* 527 */
/***/ (function(module, exports, __webpack_require__) {

!function(e,t){ true?module.exports=t():"function"==typeof define&&define.amd?define("VueShortkey",[],t):"object"==typeof exports?exports.VueShortkey=t():e.VueShortkey=t()}("undefined"!=typeof self?self:this,function(){return function(e){function t(r){if(n[r])return n[r].exports;var o=n[r]={i:r,l:!1,exports:{}};return e[r].call(o.exports,o,o.exports,t),o.l=!0,o.exports}var n={};return t.m=e,t.c=n,t.d=function(e,n,r){t.o(e,n)||Object.defineProperty(e,n,{configurable:!1,enumerable:!0,get:r})},t.n=function(e){var n=e&&e.__esModule?function(){return e.default}:function(){return e};return t.d(n,"a",n),n},t.o=function(e,t){return Object.prototype.hasOwnProperty.call(e,t)},t.p="../dist/",t(t.s=0)}([function(e,t,n){"use strict";(function(r){function o(e){if(Array.isArray(e)){for(var t=0,n=Array(e.length);t<e.length;t++)n[t]=e[t];return n}return Array.from(e)}var c;n(2),n(3);var u={},i={},a=[],l=[],s=!1,f=function(e){return e="string"==typeof e?JSON.parse(e.replace(/\'/gi,'"')):e,e instanceof Array?{"":e}:e},p=function(e,t,n,r){var o=!0===n.modifiers.push,c=!0===n.modifiers.avoid,u=!0==!n.modifiers.focus,i=!0===n.modifiers.once;c?(a=a.filter(function(e){return!e===t}),a.push(t)):v({b:e,push:o,once:i,focus:u,el:r.elm})},y=function(e,t){for(var n in e){var r=u.encodeKey(e[n]),o=i[r].el.indexOf(t);i[r].el.length>1&&o>-1?i[r].el.splice(o,1):delete i[r]}};u.install=function(e,t){l=[].concat(o(t&&t.prevent?t.prevent:[])),e.directive("shortkey",{bind:function(e,t,n){var r=f(t.value);p(r,e,t,n)},update:function(e,t,n){var r=f(t.oldValue);y(r,e);var o=f(t.value);p(o,e,t,n)},unbind:function(e,t){var n=f(t.value);y(n,e)}})},u.decodeKey=function(e){return d(e)},u.encodeKey=function(e){var t={};t.shiftKey=e.includes("shift"),t.ctrlKey=e.includes("ctrl"),t.metaKey=e.includes("meta"),t.altKey=e.includes("alt");var n=d(t);return n+=e.filter(function(e){return!["shift","ctrl","meta","alt"].includes(e)}).join("")};var d=function(e){var t="";return("Shift"===e.key||e.shiftKey)&&(t+="shift"),("Control"===e.key||e.ctrlKey)&&(t+="ctrl"),("Meta"===e.key||e.metaKey)&&(t+="meta"),("Alt"===e.key||e.altKey)&&(t+="alt"),"ArrowUp"===e.key&&(t+="arrowup"),"ArrowLeft"===e.key&&(t+="arrowleft"),"ArrowRight"===e.key&&(t+="arrowright"),"ArrowDown"===e.key&&(t+="arrowdown"),"AltGraph"===e.key&&(t+="altgraph"),"Escape"===e.key&&(t+="esc"),"Enter"===e.key&&(t+="enter"),"Tab"===e.key&&(t+="tab")," "===e.key&&(t+="space"),"PageUp"===e.key&&(t+="pageup"),"PageDown"===e.key&&(t+="pagedown"),"Home"===e.key&&(t+="home"),"End"===e.key&&(t+="end"),"Delete"===e.key&&(t+="del"),"Backspace"===e.key&&(t+="backspace"),"Insert"===e.key&&(t+="insert"),"NumLock"===e.key&&(t+="numlock"),"CapsLock"===e.key&&(t+="capslock"),"Pause"===e.key&&(t+="pause"),"ContextMenu"===e.key&&(t+="contextmenu"),"ScrollLock"===e.key&&(t+="scrolllock"),"BrowserHome"===e.key&&(t+="browserhome"),"MediaSelect"===e.key&&(t+="mediaselect"),(e.key&&" "!==e.key&&1===e.key.length||/F\d{1,2}|\//g.test(e.key))&&(t+=e.key.toLowerCase()),t},h=function(e){var t=new CustomEvent("shortkey",{bubbles:!1});i[e].key&&(t.srcKey=i[e].key);var n=i[e].el;n[n.length-1].dispatchEvent(t)};u.keyDown=function(e){(!i[e].once&&!i[e].push||i[e].push&&!s)&&h(e)},r&&Object({NODE_ENV:"production"})&&function(){document.addEventListener("keydown",function(e){var t=u.decodeKey(e);if(m(t))if(e.preventDefault(),e.stopPropagation(),i[t].focus)u.keyDown(t),s=!0;else if(!s){var n=i[t].el;n[n.length-1].focus(),s=!0}},!0),document.addEventListener("keyup",function(e){var t=u.decodeKey(e);m(t)&&(e.preventDefault(),e.stopPropagation(),(i[t].once||i[t].push)&&h(t)),s=!1},!0)}();var v=function(e){var t=e.b,n=e.push,r=e.once,o=e.focus,c=e.el;for(var a in t){var l=u.encodeKey(t[a]),s=i[l]&&i[l].el?i[l].el:[];s.push(c),i[l]={push:n,once:r,focus:o,key:a,el:s}}},m=function(e){var t=!!a.find(function(e){return e===document.activeElement}),n=!!l.find(function(e){return document.activeElement&&document.activeElement.matches(e)});return!!i[e]&&!(t||n)};void 0!==e&&e.exports?e.exports=u:void 0!==(c=function(){return u}.call(t,n,t,e))&&(e.exports=c)}).call(t,n(1))},function(e,t){function n(){throw new Error("setTimeout has not been defined")}function r(){throw new Error("clearTimeout has not been defined")}function o(e){if(s===setTimeout)return setTimeout(e,0);if((s===n||!s)&&setTimeout)return s=setTimeout,setTimeout(e,0);try{return s(e,0)}catch(t){try{return s.call(null,e,0)}catch(t){return s.call(this,e,0)}}}function c(e){if(f===clearTimeout)return clearTimeout(e);if((f===r||!f)&&clearTimeout)return f=clearTimeout,clearTimeout(e);try{return f(e)}catch(t){try{return f.call(null,e)}catch(t){return f.call(this,e)}}}function u(){h&&y&&(h=!1,y.length?d=y.concat(d):v=-1,d.length&&i())}function i(){if(!h){var e=o(u);h=!0;for(var t=d.length;t;){for(y=d,d=[];++v<t;)y&&y[v].run();v=-1,t=d.length}y=null,h=!1,c(e)}}function a(e,t){this.fun=e,this.array=t}function l(){}var s,f,p=e.exports={};!function(){try{s="function"==typeof setTimeout?setTimeout:n}catch(e){s=n}try{f="function"==typeof clearTimeout?clearTimeout:r}catch(e){f=r}}();var y,d=[],h=!1,v=-1;p.nextTick=function(e){var t=new Array(arguments.length-1);if(arguments.length>1)for(var n=1;n<arguments.length;n++)t[n-1]=arguments[n];d.push(new a(e,t)),1!==d.length||h||o(i)},a.prototype.run=function(){this.fun.apply(null,this.array)},p.title="browser",p.browser=!0,p.env={},p.argv=[],p.version="",p.versions={},p.on=l,p.addListener=l,p.once=l,p.off=l,p.removeListener=l,p.removeAllListeners=l,p.emit=l,p.prependListener=l,p.prependOnceListener=l,p.listeners=function(e){return[]},p.binding=function(e){throw new Error("process.binding is not supported")},p.cwd=function(){return"/"},p.chdir=function(e){throw new Error("process.chdir is not supported")},p.umask=function(){return 0}},function(e,t){Element.prototype.matches||(Element.prototype.matches=Element.prototype.matchesSelector||Element.prototype.msMatchesSelector||Element.prototype.webkitMatchesSelector)},function(e,t){!function(){if("undefined"!=typeof window)try{var e=new window.CustomEvent("test",{cancelable:!0});if(e.preventDefault(),!0!==e.defaultPrevented)throw new Error("Could not prevent default")}catch(e){var t=function(e,t){var n,r;return t=t||{},t.bubbles=!!t.bubbles,t.cancelable=!!t.cancelable,n=document.createEvent("CustomEvent"),n.initCustomEvent(e,t.bubbles,t.cancelable,t.detail),r=n.preventDefault,n.preventDefault=function(){r.call(this);try{Object.defineProperty(this,"defaultPrevented",{get:function(){return!0}})}catch(e){this.defaultPrevented=!0}},n};t.prototype=window.Event.prototype,window.CustomEvent=t}}()}])});
//# sourceMappingURL=index.js.map

/***/ }),
/* 528 */
/***/ (function(module, exports, __webpack_require__) {

(function (global, factory) {
   true ? factory(__webpack_require__(529)) :
  typeof define === 'function' && define.amd ? define(['hammerjs'], factory) :
  (factory(global.Hammer));
}(this, (function (Hammer) { 'use strict';

Hammer = 'default' in Hammer ? Hammer['default'] : Hammer;

function assign(target) {
  var sources = [], len = arguments.length - 1;
  while ( len-- > 0 ) sources[ len ] = arguments[ len + 1 ];
  for (var i = 0; i < sources.length; i++) {
    var source = sources[i];
    var keys = Object.keys(source);
    for (var i$1 = 0; i$1 < keys.length; i$1++) {
      var key = keys[i$1];
      target[key] = source[key];
    }
  }
  return target
}
function createProp() {
  return {
    type: Object,
    default: function() { return {} }
  }
}
function capitalize (str) {
  return str.charAt(0).toUpperCase() + str.slice(1)
}
var directions = ['up', 'down', 'left', 'right', 'horizontal', 'vertical', 'all'];
function guardDirections (options) {
  var dir = options.direction;
  if (typeof dir === 'string') {
    var hammerDirection = 'DIRECTION_' + dir.toUpperCase();
    if (directions.indexOf(dir) > -1 && Hammer.hasOwnProperty(hammerDirection)) {
      options.direction = Hammer[hammerDirection];
    } else {
      console.warn('[vue-touch] invalid direction: ' + dir);
    }
  }
  return options
}
var config = {
};
var customEvents = {
};
var gestures = [
  'pan','panstart','panmove','panend','pancancel','panleft','panright','panup','pandown',
  'pinch','pinchstart','pinchmove','pinchend','pinchcancel','pinchin','pinchout',
  'press','pressup',
  'rotate','rotatestart','rotatemove','rotateend','rotatecancel',
  'swipe','swipeleft','swiperight','swipeup','swipedown',
  'tap'
];
var gestureMap = {
  pan: 'pan',
  panstart: 'pan',
  panmove: 'pan',
  panend: 'pan',
  pancancel: 'pan',
  panleft: 'pan',
  panright: 'pan',
  panup: 'pan',
  pandown: 'pan',
  pinch: 'pinch',
  pinchstart: 'pinch',
  pinchmove: 'pinch',
  pinchend: 'pinch',
  pinchcancel: 'pinch',
  pinchin: 'pinch',
  pinchout: 'pinch',
  press: 'press',
  pressup: 'press',
  rotate: 'rotate',
  rotatestart: 'rotate',
  rotatemove: 'rotate',
  rotateend: 'rotate',
  rotatecancel: 'rotate',
  swipe: 'swipe',
  swipeleft: 'swipe',
  swiperight: 'swipe',
  swipeup: 'swipe',
  swipedown: 'swipe',
  tap: 'tap'
};

var Component = {
  props: {
    options: createProp(),
    tapOptions: createProp(),
    panOptions: createProp(),
    pinchOptions: createProp(),
    pressOptions: createProp(),
    rotateOptions: createProp(),
    swipeOptions: createProp(),
    tag: { type: String, default: 'div' },
    enabled: {
      default: true,
      type: [Boolean, Object],
    }
  },
  mounted: function mounted() {
    if (!this.$isServer) {
      this.hammer = new Hammer.Manager(this.$el, this.options);
      this.recognizers = {};
      this.setupBuiltinRecognizers();
      this.setupCustomRecognizers();
      this.updateEnabled(this.enabled);
    }
  },
  destroyed: function destroyed() {
    if (!this.$isServer) {
      this.hammer.destroy();
    }
  },
  watch: {
    enabled: {
      deep: true,
      handler: function handler() {
        var args = [], len = arguments.length;
        while ( len-- ) args[ len ] = arguments[ len ];
        (ref = this).updateEnabled.apply(ref, args);
        var ref;
      }
    }
  },
  methods: {
    setupBuiltinRecognizers: function setupBuiltinRecognizers()  {
      var this$1 = this;
      for (var i = 0; i < gestures.length; i++) {
        var gesture = gestures[i];
        if (this$1._events[gesture]) {
          var mainGesture = gestureMap[gesture];
          var options = assign({}, (config[mainGesture] || {}), this$1[(mainGesture + "Options")]);
          this$1.addRecognizer(mainGesture, options);
          this$1.addEvent(gesture);
        }
      }
    },
    setupCustomRecognizers: function setupCustomRecognizers() {
      var this$1 = this;
      var gestures$$1 = Object.keys(customEvents);
      for (var i = 0; i < gestures$$1.length; i++) {
        var gesture = gestures$$1[i];
        if (this$1._events[gesture]) {
          var opts = customEvents[gesture];
          var localCustomOpts = this$1[(gesture + "Options")] || {};
          var options = assign({}, opts, localCustomOpts);
          this$1.addRecognizer(gesture, options, {mainGesture: options.type});
          this$1.addEvent(gesture);
        }
      }
    },
    addRecognizer: function addRecognizer(gesture, options, ref) {
      if ( ref === void 0 ) ref = {};
      var mainGesture = ref.mainGesture;
      if (!this.recognizers[gesture]) {
        var recognizer = new Hammer[capitalize(mainGesture || gesture)](guardDirections(options));
        this.recognizers[gesture] = recognizer;
        this.hammer.add(recognizer);
        recognizer.recognizeWith(this.hammer.recognizers);
      }
    },
    addEvent: function addEvent(gesture) {
      var this$1 = this;
      this.hammer.on(gesture, function (e) { return this$1.$emit(gesture, e); });
    },
    updateEnabled: function updateEnabled(newVal, oldVal) {
      var this$1 = this;
      if (newVal === true) {
        this.enableAll();
      } else if (newVal === false) {
        this.disableAll();
      } else if (typeof newVal === 'object') {
        var keys = Object.keys(newVal);
        for (var i = 0; i < keys.length; i++) {
          var event = keys[i];
          if (this$1.recognizers[event]) {
            newVal[event]
              ? this$1.enable(event)
              : this$1.disable(event);
          }
        }
      }
    },
    enable: function enable(r) {
      var recognizer = this.recognizers[r];
      if (!recognizer.options.enable) {
        recognizer.set({ enable: true });
      }
    },
    disable: function disable(r) {
      var recognizer = this.recognizers[r];
      if (recognizer.options.enable) {
        recognizer.set({ enable: false });
      }
    },
    toggle: function toggle(r) {
      var recognizer = this.recognizers[r];
      if (recognizer) {
        recognizer.options.enable
          ? this.disable(r)
          : this.enable(r);
      }
    },
    enableAll: function enableAll(r) {
      this.toggleAll({ enable: true });
    },
    disableAll: function disableAll(r) {
      this.toggleAll({ enable: false });
    },
    toggleAll: function toggleAll(ref) {
      var this$1 = this;
      var enable = ref.enable;
      var keys = Object.keys(this.recognizers);
      for (var i = 0; i < keys.length; i++) {
        var r = this$1.recognizers[keys[i]];
        if (r.options.enable !== enable) {
          r.set({ enable: enable });
        }
      }
    },
    isEnabled: function isEnabled(r) {
      return this.recognizers[r] && this.recognizers[r].options.enable
    }
  },
  render: function render(h) {
    return h(this.tag, {}, this.$slots.default)
  }
};

var installed = false;
var vueTouch = { config: config, customEvents: customEvents };
vueTouch.install = function install(Vue, opts) {
  if ( opts === void 0 ) opts = {};
  var name = opts.name || 'v-touch';
  Vue.component(name, assign(Component, { name: name }));
  installed = true;
}.bind(vueTouch);
vueTouch.registerCustomEvent = function registerCustomEvent(event, options) {
  if ( options === void 0 ) options = {};
  if (installed) {
    console.warn(("\n      [vue-touch]: Custom Event '" + event + "' couldn't be added to vue-touch.\n      Custom Events have to be registered before installing the plugin.\n      "));
    return
  }
  options.event = event;
  customEvents[event] = options;
  Component.props[(event + "Options")] = {
    type: Object,
    default: function default$1() { return {} }
  };
}.bind(vueTouch);
vueTouch.component = Component;
if (true) {
  module.exports = vueTouch;
} else if (typeof define == "function" && define.amd) {
  define([], function(){ return vueTouch });
} else if (typeof window !== 'undefined' && window.Vue) {
  window.VueTouch = vueTouch;
  Vue.use(vueTouch);
}

})));
//# sourceMappingURL=vue-touch.js.map


/***/ }),
/* 529 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;/*! Hammer.JS - v2.0.7 - 2016-04-22
 * http://hammerjs.github.io/
 *
 * Copyright (c) 2016 Jorik Tangelder;
 * Licensed under the MIT license */
(function(window, document, exportName, undefined) {
  'use strict';

var VENDOR_PREFIXES = ['', 'webkit', 'Moz', 'MS', 'ms', 'o'];
var TEST_ELEMENT = document.createElement('div');

var TYPE_FUNCTION = 'function';

var round = Math.round;
var abs = Math.abs;
var now = Date.now;

/**
 * set a timeout with a given scope
 * @param {Function} fn
 * @param {Number} timeout
 * @param {Object} context
 * @returns {number}
 */
function setTimeoutContext(fn, timeout, context) {
    return setTimeout(bindFn(fn, context), timeout);
}

/**
 * if the argument is an array, we want to execute the fn on each entry
 * if it aint an array we don't want to do a thing.
 * this is used by all the methods that accept a single and array argument.
 * @param {*|Array} arg
 * @param {String} fn
 * @param {Object} [context]
 * @returns {Boolean}
 */
function invokeArrayArg(arg, fn, context) {
    if (Array.isArray(arg)) {
        each(arg, context[fn], context);
        return true;
    }
    return false;
}

/**
 * walk objects and arrays
 * @param {Object} obj
 * @param {Function} iterator
 * @param {Object} context
 */
function each(obj, iterator, context) {
    var i;

    if (!obj) {
        return;
    }

    if (obj.forEach) {
        obj.forEach(iterator, context);
    } else if (obj.length !== undefined) {
        i = 0;
        while (i < obj.length) {
            iterator.call(context, obj[i], i, obj);
            i++;
        }
    } else {
        for (i in obj) {
            obj.hasOwnProperty(i) && iterator.call(context, obj[i], i, obj);
        }
    }
}

/**
 * wrap a method with a deprecation warning and stack trace
 * @param {Function} method
 * @param {String} name
 * @param {String} message
 * @returns {Function} A new function wrapping the supplied method.
 */
function deprecate(method, name, message) {
    var deprecationMessage = 'DEPRECATED METHOD: ' + name + '\n' + message + ' AT \n';
    return function() {
        var e = new Error('get-stack-trace');
        var stack = e && e.stack ? e.stack.replace(/^[^\(]+?[\n$]/gm, '')
            .replace(/^\s+at\s+/gm, '')
            .replace(/^Object.<anonymous>\s*\(/gm, '{anonymous}()@') : 'Unknown Stack Trace';

        var log = window.console && (window.console.warn || window.console.log);
        if (log) {
            log.call(window.console, deprecationMessage, stack);
        }
        return method.apply(this, arguments);
    };
}

/**
 * extend object.
 * means that properties in dest will be overwritten by the ones in src.
 * @param {Object} target
 * @param {...Object} objects_to_assign
 * @returns {Object} target
 */
var assign;
if (typeof Object.assign !== 'function') {
    assign = function assign(target) {
        if (target === undefined || target === null) {
            throw new TypeError('Cannot convert undefined or null to object');
        }

        var output = Object(target);
        for (var index = 1; index < arguments.length; index++) {
            var source = arguments[index];
            if (source !== undefined && source !== null) {
                for (var nextKey in source) {
                    if (source.hasOwnProperty(nextKey)) {
                        output[nextKey] = source[nextKey];
                    }
                }
            }
        }
        return output;
    };
} else {
    assign = Object.assign;
}

/**
 * extend object.
 * means that properties in dest will be overwritten by the ones in src.
 * @param {Object} dest
 * @param {Object} src
 * @param {Boolean} [merge=false]
 * @returns {Object} dest
 */
var extend = deprecate(function extend(dest, src, merge) {
    var keys = Object.keys(src);
    var i = 0;
    while (i < keys.length) {
        if (!merge || (merge && dest[keys[i]] === undefined)) {
            dest[keys[i]] = src[keys[i]];
        }
        i++;
    }
    return dest;
}, 'extend', 'Use `assign`.');

/**
 * merge the values from src in the dest.
 * means that properties that exist in dest will not be overwritten by src
 * @param {Object} dest
 * @param {Object} src
 * @returns {Object} dest
 */
var merge = deprecate(function merge(dest, src) {
    return extend(dest, src, true);
}, 'merge', 'Use `assign`.');

/**
 * simple class inheritance
 * @param {Function} child
 * @param {Function} base
 * @param {Object} [properties]
 */
function inherit(child, base, properties) {
    var baseP = base.prototype,
        childP;

    childP = child.prototype = Object.create(baseP);
    childP.constructor = child;
    childP._super = baseP;

    if (properties) {
        assign(childP, properties);
    }
}

/**
 * simple function bind
 * @param {Function} fn
 * @param {Object} context
 * @returns {Function}
 */
function bindFn(fn, context) {
    return function boundFn() {
        return fn.apply(context, arguments);
    };
}

/**
 * let a boolean value also be a function that must return a boolean
 * this first item in args will be used as the context
 * @param {Boolean|Function} val
 * @param {Array} [args]
 * @returns {Boolean}
 */
function boolOrFn(val, args) {
    if (typeof val == TYPE_FUNCTION) {
        return val.apply(args ? args[0] || undefined : undefined, args);
    }
    return val;
}

/**
 * use the val2 when val1 is undefined
 * @param {*} val1
 * @param {*} val2
 * @returns {*}
 */
function ifUndefined(val1, val2) {
    return (val1 === undefined) ? val2 : val1;
}

/**
 * addEventListener with multiple events at once
 * @param {EventTarget} target
 * @param {String} types
 * @param {Function} handler
 */
function addEventListeners(target, types, handler) {
    each(splitStr(types), function(type) {
        target.addEventListener(type, handler, false);
    });
}

/**
 * removeEventListener with multiple events at once
 * @param {EventTarget} target
 * @param {String} types
 * @param {Function} handler
 */
function removeEventListeners(target, types, handler) {
    each(splitStr(types), function(type) {
        target.removeEventListener(type, handler, false);
    });
}

/**
 * find if a node is in the given parent
 * @method hasParent
 * @param {HTMLElement} node
 * @param {HTMLElement} parent
 * @return {Boolean} found
 */
function hasParent(node, parent) {
    while (node) {
        if (node == parent) {
            return true;
        }
        node = node.parentNode;
    }
    return false;
}

/**
 * small indexOf wrapper
 * @param {String} str
 * @param {String} find
 * @returns {Boolean} found
 */
function inStr(str, find) {
    return str.indexOf(find) > -1;
}

/**
 * split string on whitespace
 * @param {String} str
 * @returns {Array} words
 */
function splitStr(str) {
    return str.trim().split(/\s+/g);
}

/**
 * find if a array contains the object using indexOf or a simple polyFill
 * @param {Array} src
 * @param {String} find
 * @param {String} [findByKey]
 * @return {Boolean|Number} false when not found, or the index
 */
function inArray(src, find, findByKey) {
    if (src.indexOf && !findByKey) {
        return src.indexOf(find);
    } else {
        var i = 0;
        while (i < src.length) {
            if ((findByKey && src[i][findByKey] == find) || (!findByKey && src[i] === find)) {
                return i;
            }
            i++;
        }
        return -1;
    }
}

/**
 * convert array-like objects to real arrays
 * @param {Object} obj
 * @returns {Array}
 */
function toArray(obj) {
    return Array.prototype.slice.call(obj, 0);
}

/**
 * unique array with objects based on a key (like 'id') or just by the array's value
 * @param {Array} src [{id:1},{id:2},{id:1}]
 * @param {String} [key]
 * @param {Boolean} [sort=False]
 * @returns {Array} [{id:1},{id:2}]
 */
function uniqueArray(src, key, sort) {
    var results = [];
    var values = [];
    var i = 0;

    while (i < src.length) {
        var val = key ? src[i][key] : src[i];
        if (inArray(values, val) < 0) {
            results.push(src[i]);
        }
        values[i] = val;
        i++;
    }

    if (sort) {
        if (!key) {
            results = results.sort();
        } else {
            results = results.sort(function sortUniqueArray(a, b) {
                return a[key] > b[key];
            });
        }
    }

    return results;
}

/**
 * get the prefixed property
 * @param {Object} obj
 * @param {String} property
 * @returns {String|Undefined} prefixed
 */
function prefixed(obj, property) {
    var prefix, prop;
    var camelProp = property[0].toUpperCase() + property.slice(1);

    var i = 0;
    while (i < VENDOR_PREFIXES.length) {
        prefix = VENDOR_PREFIXES[i];
        prop = (prefix) ? prefix + camelProp : property;

        if (prop in obj) {
            return prop;
        }
        i++;
    }
    return undefined;
}

/**
 * get a unique id
 * @returns {number} uniqueId
 */
var _uniqueId = 1;
function uniqueId() {
    return _uniqueId++;
}

/**
 * get the window object of an element
 * @param {HTMLElement} element
 * @returns {DocumentView|Window}
 */
function getWindowForElement(element) {
    var doc = element.ownerDocument || element;
    return (doc.defaultView || doc.parentWindow || window);
}

var MOBILE_REGEX = /mobile|tablet|ip(ad|hone|od)|android/i;

var SUPPORT_TOUCH = ('ontouchstart' in window);
var SUPPORT_POINTER_EVENTS = prefixed(window, 'PointerEvent') !== undefined;
var SUPPORT_ONLY_TOUCH = SUPPORT_TOUCH && MOBILE_REGEX.test(navigator.userAgent);

var INPUT_TYPE_TOUCH = 'touch';
var INPUT_TYPE_PEN = 'pen';
var INPUT_TYPE_MOUSE = 'mouse';
var INPUT_TYPE_KINECT = 'kinect';

var COMPUTE_INTERVAL = 25;

var INPUT_START = 1;
var INPUT_MOVE = 2;
var INPUT_END = 4;
var INPUT_CANCEL = 8;

var DIRECTION_NONE = 1;
var DIRECTION_LEFT = 2;
var DIRECTION_RIGHT = 4;
var DIRECTION_UP = 8;
var DIRECTION_DOWN = 16;

var DIRECTION_HORIZONTAL = DIRECTION_LEFT | DIRECTION_RIGHT;
var DIRECTION_VERTICAL = DIRECTION_UP | DIRECTION_DOWN;
var DIRECTION_ALL = DIRECTION_HORIZONTAL | DIRECTION_VERTICAL;

var PROPS_XY = ['x', 'y'];
var PROPS_CLIENT_XY = ['clientX', 'clientY'];

/**
 * create new input type manager
 * @param {Manager} manager
 * @param {Function} callback
 * @returns {Input}
 * @constructor
 */
function Input(manager, callback) {
    var self = this;
    this.manager = manager;
    this.callback = callback;
    this.element = manager.element;
    this.target = manager.options.inputTarget;

    // smaller wrapper around the handler, for the scope and the enabled state of the manager,
    // so when disabled the input events are completely bypassed.
    this.domHandler = function(ev) {
        if (boolOrFn(manager.options.enable, [manager])) {
            self.handler(ev);
        }
    };

    this.init();

}

Input.prototype = {
    /**
     * should handle the inputEvent data and trigger the callback
     * @virtual
     */
    handler: function() { },

    /**
     * bind the events
     */
    init: function() {
        this.evEl && addEventListeners(this.element, this.evEl, this.domHandler);
        this.evTarget && addEventListeners(this.target, this.evTarget, this.domHandler);
        this.evWin && addEventListeners(getWindowForElement(this.element), this.evWin, this.domHandler);
    },

    /**
     * unbind the events
     */
    destroy: function() {
        this.evEl && removeEventListeners(this.element, this.evEl, this.domHandler);
        this.evTarget && removeEventListeners(this.target, this.evTarget, this.domHandler);
        this.evWin && removeEventListeners(getWindowForElement(this.element), this.evWin, this.domHandler);
    }
};

/**
 * create new input type manager
 * called by the Manager constructor
 * @param {Hammer} manager
 * @returns {Input}
 */
function createInputInstance(manager) {
    var Type;
    var inputClass = manager.options.inputClass;

    if (inputClass) {
        Type = inputClass;
    } else if (SUPPORT_POINTER_EVENTS) {
        Type = PointerEventInput;
    } else if (SUPPORT_ONLY_TOUCH) {
        Type = TouchInput;
    } else if (!SUPPORT_TOUCH) {
        Type = MouseInput;
    } else {
        Type = TouchMouseInput;
    }
    return new (Type)(manager, inputHandler);
}

/**
 * handle input events
 * @param {Manager} manager
 * @param {String} eventType
 * @param {Object} input
 */
function inputHandler(manager, eventType, input) {
    var pointersLen = input.pointers.length;
    var changedPointersLen = input.changedPointers.length;
    var isFirst = (eventType & INPUT_START && (pointersLen - changedPointersLen === 0));
    var isFinal = (eventType & (INPUT_END | INPUT_CANCEL) && (pointersLen - changedPointersLen === 0));

    input.isFirst = !!isFirst;
    input.isFinal = !!isFinal;

    if (isFirst) {
        manager.session = {};
    }

    // source event is the normalized value of the domEvents
    // like 'touchstart, mouseup, pointerdown'
    input.eventType = eventType;

    // compute scale, rotation etc
    computeInputData(manager, input);

    // emit secret event
    manager.emit('hammer.input', input);

    manager.recognize(input);
    manager.session.prevInput = input;
}

/**
 * extend the data with some usable properties like scale, rotate, velocity etc
 * @param {Object} manager
 * @param {Object} input
 */
function computeInputData(manager, input) {
    var session = manager.session;
    var pointers = input.pointers;
    var pointersLength = pointers.length;

    // store the first input to calculate the distance and direction
    if (!session.firstInput) {
        session.firstInput = simpleCloneInputData(input);
    }

    // to compute scale and rotation we need to store the multiple touches
    if (pointersLength > 1 && !session.firstMultiple) {
        session.firstMultiple = simpleCloneInputData(input);
    } else if (pointersLength === 1) {
        session.firstMultiple = false;
    }

    var firstInput = session.firstInput;
    var firstMultiple = session.firstMultiple;
    var offsetCenter = firstMultiple ? firstMultiple.center : firstInput.center;

    var center = input.center = getCenter(pointers);
    input.timeStamp = now();
    input.deltaTime = input.timeStamp - firstInput.timeStamp;

    input.angle = getAngle(offsetCenter, center);
    input.distance = getDistance(offsetCenter, center);

    computeDeltaXY(session, input);
    input.offsetDirection = getDirection(input.deltaX, input.deltaY);

    var overallVelocity = getVelocity(input.deltaTime, input.deltaX, input.deltaY);
    input.overallVelocityX = overallVelocity.x;
    input.overallVelocityY = overallVelocity.y;
    input.overallVelocity = (abs(overallVelocity.x) > abs(overallVelocity.y)) ? overallVelocity.x : overallVelocity.y;

    input.scale = firstMultiple ? getScale(firstMultiple.pointers, pointers) : 1;
    input.rotation = firstMultiple ? getRotation(firstMultiple.pointers, pointers) : 0;

    input.maxPointers = !session.prevInput ? input.pointers.length : ((input.pointers.length >
        session.prevInput.maxPointers) ? input.pointers.length : session.prevInput.maxPointers);

    computeIntervalInputData(session, input);

    // find the correct target
    var target = manager.element;
    if (hasParent(input.srcEvent.target, target)) {
        target = input.srcEvent.target;
    }
    input.target = target;
}

function computeDeltaXY(session, input) {
    var center = input.center;
    var offset = session.offsetDelta || {};
    var prevDelta = session.prevDelta || {};
    var prevInput = session.prevInput || {};

    if (input.eventType === INPUT_START || prevInput.eventType === INPUT_END) {
        prevDelta = session.prevDelta = {
            x: prevInput.deltaX || 0,
            y: prevInput.deltaY || 0
        };

        offset = session.offsetDelta = {
            x: center.x,
            y: center.y
        };
    }

    input.deltaX = prevDelta.x + (center.x - offset.x);
    input.deltaY = prevDelta.y + (center.y - offset.y);
}

/**
 * velocity is calculated every x ms
 * @param {Object} session
 * @param {Object} input
 */
function computeIntervalInputData(session, input) {
    var last = session.lastInterval || input,
        deltaTime = input.timeStamp - last.timeStamp,
        velocity, velocityX, velocityY, direction;

    if (input.eventType != INPUT_CANCEL && (deltaTime > COMPUTE_INTERVAL || last.velocity === undefined)) {
        var deltaX = input.deltaX - last.deltaX;
        var deltaY = input.deltaY - last.deltaY;

        var v = getVelocity(deltaTime, deltaX, deltaY);
        velocityX = v.x;
        velocityY = v.y;
        velocity = (abs(v.x) > abs(v.y)) ? v.x : v.y;
        direction = getDirection(deltaX, deltaY);

        session.lastInterval = input;
    } else {
        // use latest velocity info if it doesn't overtake a minimum period
        velocity = last.velocity;
        velocityX = last.velocityX;
        velocityY = last.velocityY;
        direction = last.direction;
    }

    input.velocity = velocity;
    input.velocityX = velocityX;
    input.velocityY = velocityY;
    input.direction = direction;
}

/**
 * create a simple clone from the input used for storage of firstInput and firstMultiple
 * @param {Object} input
 * @returns {Object} clonedInputData
 */
function simpleCloneInputData(input) {
    // make a simple copy of the pointers because we will get a reference if we don't
    // we only need clientXY for the calculations
    var pointers = [];
    var i = 0;
    while (i < input.pointers.length) {
        pointers[i] = {
            clientX: round(input.pointers[i].clientX),
            clientY: round(input.pointers[i].clientY)
        };
        i++;
    }

    return {
        timeStamp: now(),
        pointers: pointers,
        center: getCenter(pointers),
        deltaX: input.deltaX,
        deltaY: input.deltaY
    };
}

/**
 * get the center of all the pointers
 * @param {Array} pointers
 * @return {Object} center contains `x` and `y` properties
 */
function getCenter(pointers) {
    var pointersLength = pointers.length;

    // no need to loop when only one touch
    if (pointersLength === 1) {
        return {
            x: round(pointers[0].clientX),
            y: round(pointers[0].clientY)
        };
    }

    var x = 0, y = 0, i = 0;
    while (i < pointersLength) {
        x += pointers[i].clientX;
        y += pointers[i].clientY;
        i++;
    }

    return {
        x: round(x / pointersLength),
        y: round(y / pointersLength)
    };
}

/**
 * calculate the velocity between two points. unit is in px per ms.
 * @param {Number} deltaTime
 * @param {Number} x
 * @param {Number} y
 * @return {Object} velocity `x` and `y`
 */
function getVelocity(deltaTime, x, y) {
    return {
        x: x / deltaTime || 0,
        y: y / deltaTime || 0
    };
}

/**
 * get the direction between two points
 * @param {Number} x
 * @param {Number} y
 * @return {Number} direction
 */
function getDirection(x, y) {
    if (x === y) {
        return DIRECTION_NONE;
    }

    if (abs(x) >= abs(y)) {
        return x < 0 ? DIRECTION_LEFT : DIRECTION_RIGHT;
    }
    return y < 0 ? DIRECTION_UP : DIRECTION_DOWN;
}

/**
 * calculate the absolute distance between two points
 * @param {Object} p1 {x, y}
 * @param {Object} p2 {x, y}
 * @param {Array} [props] containing x and y keys
 * @return {Number} distance
 */
function getDistance(p1, p2, props) {
    if (!props) {
        props = PROPS_XY;
    }
    var x = p2[props[0]] - p1[props[0]],
        y = p2[props[1]] - p1[props[1]];

    return Math.sqrt((x * x) + (y * y));
}

/**
 * calculate the angle between two coordinates
 * @param {Object} p1
 * @param {Object} p2
 * @param {Array} [props] containing x and y keys
 * @return {Number} angle
 */
function getAngle(p1, p2, props) {
    if (!props) {
        props = PROPS_XY;
    }
    var x = p2[props[0]] - p1[props[0]],
        y = p2[props[1]] - p1[props[1]];
    return Math.atan2(y, x) * 180 / Math.PI;
}

/**
 * calculate the rotation degrees between two pointersets
 * @param {Array} start array of pointers
 * @param {Array} end array of pointers
 * @return {Number} rotation
 */
function getRotation(start, end) {
    return getAngle(end[1], end[0], PROPS_CLIENT_XY) + getAngle(start[1], start[0], PROPS_CLIENT_XY);
}

/**
 * calculate the scale factor between two pointersets
 * no scale is 1, and goes down to 0 when pinched together, and bigger when pinched out
 * @param {Array} start array of pointers
 * @param {Array} end array of pointers
 * @return {Number} scale
 */
function getScale(start, end) {
    return getDistance(end[0], end[1], PROPS_CLIENT_XY) / getDistance(start[0], start[1], PROPS_CLIENT_XY);
}

var MOUSE_INPUT_MAP = {
    mousedown: INPUT_START,
    mousemove: INPUT_MOVE,
    mouseup: INPUT_END
};

var MOUSE_ELEMENT_EVENTS = 'mousedown';
var MOUSE_WINDOW_EVENTS = 'mousemove mouseup';

/**
 * Mouse events input
 * @constructor
 * @extends Input
 */
function MouseInput() {
    this.evEl = MOUSE_ELEMENT_EVENTS;
    this.evWin = MOUSE_WINDOW_EVENTS;

    this.pressed = false; // mousedown state

    Input.apply(this, arguments);
}

inherit(MouseInput, Input, {
    /**
     * handle mouse events
     * @param {Object} ev
     */
    handler: function MEhandler(ev) {
        var eventType = MOUSE_INPUT_MAP[ev.type];

        // on start we want to have the left mouse button down
        if (eventType & INPUT_START && ev.button === 0) {
            this.pressed = true;
        }

        if (eventType & INPUT_MOVE && ev.which !== 1) {
            eventType = INPUT_END;
        }

        // mouse must be down
        if (!this.pressed) {
            return;
        }

        if (eventType & INPUT_END) {
            this.pressed = false;
        }

        this.callback(this.manager, eventType, {
            pointers: [ev],
            changedPointers: [ev],
            pointerType: INPUT_TYPE_MOUSE,
            srcEvent: ev
        });
    }
});

var POINTER_INPUT_MAP = {
    pointerdown: INPUT_START,
    pointermove: INPUT_MOVE,
    pointerup: INPUT_END,
    pointercancel: INPUT_CANCEL,
    pointerout: INPUT_CANCEL
};

// in IE10 the pointer types is defined as an enum
var IE10_POINTER_TYPE_ENUM = {
    2: INPUT_TYPE_TOUCH,
    3: INPUT_TYPE_PEN,
    4: INPUT_TYPE_MOUSE,
    5: INPUT_TYPE_KINECT // see https://twitter.com/jacobrossi/status/480596438489890816
};

var POINTER_ELEMENT_EVENTS = 'pointerdown';
var POINTER_WINDOW_EVENTS = 'pointermove pointerup pointercancel';

// IE10 has prefixed support, and case-sensitive
if (window.MSPointerEvent && !window.PointerEvent) {
    POINTER_ELEMENT_EVENTS = 'MSPointerDown';
    POINTER_WINDOW_EVENTS = 'MSPointerMove MSPointerUp MSPointerCancel';
}

/**
 * Pointer events input
 * @constructor
 * @extends Input
 */
function PointerEventInput() {
    this.evEl = POINTER_ELEMENT_EVENTS;
    this.evWin = POINTER_WINDOW_EVENTS;

    Input.apply(this, arguments);

    this.store = (this.manager.session.pointerEvents = []);
}

inherit(PointerEventInput, Input, {
    /**
     * handle mouse events
     * @param {Object} ev
     */
    handler: function PEhandler(ev) {
        var store = this.store;
        var removePointer = false;

        var eventTypeNormalized = ev.type.toLowerCase().replace('ms', '');
        var eventType = POINTER_INPUT_MAP[eventTypeNormalized];
        var pointerType = IE10_POINTER_TYPE_ENUM[ev.pointerType] || ev.pointerType;

        var isTouch = (pointerType == INPUT_TYPE_TOUCH);

        // get index of the event in the store
        var storeIndex = inArray(store, ev.pointerId, 'pointerId');

        // start and mouse must be down
        if (eventType & INPUT_START && (ev.button === 0 || isTouch)) {
            if (storeIndex < 0) {
                store.push(ev);
                storeIndex = store.length - 1;
            }
        } else if (eventType & (INPUT_END | INPUT_CANCEL)) {
            removePointer = true;
        }

        // it not found, so the pointer hasn't been down (so it's probably a hover)
        if (storeIndex < 0) {
            return;
        }

        // update the event in the store
        store[storeIndex] = ev;

        this.callback(this.manager, eventType, {
            pointers: store,
            changedPointers: [ev],
            pointerType: pointerType,
            srcEvent: ev
        });

        if (removePointer) {
            // remove from the store
            store.splice(storeIndex, 1);
        }
    }
});

var SINGLE_TOUCH_INPUT_MAP = {
    touchstart: INPUT_START,
    touchmove: INPUT_MOVE,
    touchend: INPUT_END,
    touchcancel: INPUT_CANCEL
};

var SINGLE_TOUCH_TARGET_EVENTS = 'touchstart';
var SINGLE_TOUCH_WINDOW_EVENTS = 'touchstart touchmove touchend touchcancel';

/**
 * Touch events input
 * @constructor
 * @extends Input
 */
function SingleTouchInput() {
    this.evTarget = SINGLE_TOUCH_TARGET_EVENTS;
    this.evWin = SINGLE_TOUCH_WINDOW_EVENTS;
    this.started = false;

    Input.apply(this, arguments);
}

inherit(SingleTouchInput, Input, {
    handler: function TEhandler(ev) {
        var type = SINGLE_TOUCH_INPUT_MAP[ev.type];

        // should we handle the touch events?
        if (type === INPUT_START) {
            this.started = true;
        }

        if (!this.started) {
            return;
        }

        var touches = normalizeSingleTouches.call(this, ev, type);

        // when done, reset the started state
        if (type & (INPUT_END | INPUT_CANCEL) && touches[0].length - touches[1].length === 0) {
            this.started = false;
        }

        this.callback(this.manager, type, {
            pointers: touches[0],
            changedPointers: touches[1],
            pointerType: INPUT_TYPE_TOUCH,
            srcEvent: ev
        });
    }
});

/**
 * @this {TouchInput}
 * @param {Object} ev
 * @param {Number} type flag
 * @returns {undefined|Array} [all, changed]
 */
function normalizeSingleTouches(ev, type) {
    var all = toArray(ev.touches);
    var changed = toArray(ev.changedTouches);

    if (type & (INPUT_END | INPUT_CANCEL)) {
        all = uniqueArray(all.concat(changed), 'identifier', true);
    }

    return [all, changed];
}

var TOUCH_INPUT_MAP = {
    touchstart: INPUT_START,
    touchmove: INPUT_MOVE,
    touchend: INPUT_END,
    touchcancel: INPUT_CANCEL
};

var TOUCH_TARGET_EVENTS = 'touchstart touchmove touchend touchcancel';

/**
 * Multi-user touch events input
 * @constructor
 * @extends Input
 */
function TouchInput() {
    this.evTarget = TOUCH_TARGET_EVENTS;
    this.targetIds = {};

    Input.apply(this, arguments);
}

inherit(TouchInput, Input, {
    handler: function MTEhandler(ev) {
        var type = TOUCH_INPUT_MAP[ev.type];
        var touches = getTouches.call(this, ev, type);
        if (!touches) {
            return;
        }

        this.callback(this.manager, type, {
            pointers: touches[0],
            changedPointers: touches[1],
            pointerType: INPUT_TYPE_TOUCH,
            srcEvent: ev
        });
    }
});

/**
 * @this {TouchInput}
 * @param {Object} ev
 * @param {Number} type flag
 * @returns {undefined|Array} [all, changed]
 */
function getTouches(ev, type) {
    var allTouches = toArray(ev.touches);
    var targetIds = this.targetIds;

    // when there is only one touch, the process can be simplified
    if (type & (INPUT_START | INPUT_MOVE) && allTouches.length === 1) {
        targetIds[allTouches[0].identifier] = true;
        return [allTouches, allTouches];
    }

    var i,
        targetTouches,
        changedTouches = toArray(ev.changedTouches),
        changedTargetTouches = [],
        target = this.target;

    // get target touches from touches
    targetTouches = allTouches.filter(function(touch) {
        return hasParent(touch.target, target);
    });

    // collect touches
    if (type === INPUT_START) {
        i = 0;
        while (i < targetTouches.length) {
            targetIds[targetTouches[i].identifier] = true;
            i++;
        }
    }

    // filter changed touches to only contain touches that exist in the collected target ids
    i = 0;
    while (i < changedTouches.length) {
        if (targetIds[changedTouches[i].identifier]) {
            changedTargetTouches.push(changedTouches[i]);
        }

        // cleanup removed touches
        if (type & (INPUT_END | INPUT_CANCEL)) {
            delete targetIds[changedTouches[i].identifier];
        }
        i++;
    }

    if (!changedTargetTouches.length) {
        return;
    }

    return [
        // merge targetTouches with changedTargetTouches so it contains ALL touches, including 'end' and 'cancel'
        uniqueArray(targetTouches.concat(changedTargetTouches), 'identifier', true),
        changedTargetTouches
    ];
}

/**
 * Combined touch and mouse input
 *
 * Touch has a higher priority then mouse, and while touching no mouse events are allowed.
 * This because touch devices also emit mouse events while doing a touch.
 *
 * @constructor
 * @extends Input
 */

var DEDUP_TIMEOUT = 2500;
var DEDUP_DISTANCE = 25;

function TouchMouseInput() {
    Input.apply(this, arguments);

    var handler = bindFn(this.handler, this);
    this.touch = new TouchInput(this.manager, handler);
    this.mouse = new MouseInput(this.manager, handler);

    this.primaryTouch = null;
    this.lastTouches = [];
}

inherit(TouchMouseInput, Input, {
    /**
     * handle mouse and touch events
     * @param {Hammer} manager
     * @param {String} inputEvent
     * @param {Object} inputData
     */
    handler: function TMEhandler(manager, inputEvent, inputData) {
        var isTouch = (inputData.pointerType == INPUT_TYPE_TOUCH),
            isMouse = (inputData.pointerType == INPUT_TYPE_MOUSE);

        if (isMouse && inputData.sourceCapabilities && inputData.sourceCapabilities.firesTouchEvents) {
            return;
        }

        // when we're in a touch event, record touches to  de-dupe synthetic mouse event
        if (isTouch) {
            recordTouches.call(this, inputEvent, inputData);
        } else if (isMouse && isSyntheticEvent.call(this, inputData)) {
            return;
        }

        this.callback(manager, inputEvent, inputData);
    },

    /**
     * remove the event listeners
     */
    destroy: function destroy() {
        this.touch.destroy();
        this.mouse.destroy();
    }
});

function recordTouches(eventType, eventData) {
    if (eventType & INPUT_START) {
        this.primaryTouch = eventData.changedPointers[0].identifier;
        setLastTouch.call(this, eventData);
    } else if (eventType & (INPUT_END | INPUT_CANCEL)) {
        setLastTouch.call(this, eventData);
    }
}

function setLastTouch(eventData) {
    var touch = eventData.changedPointers[0];

    if (touch.identifier === this.primaryTouch) {
        var lastTouch = {x: touch.clientX, y: touch.clientY};
        this.lastTouches.push(lastTouch);
        var lts = this.lastTouches;
        var removeLastTouch = function() {
            var i = lts.indexOf(lastTouch);
            if (i > -1) {
                lts.splice(i, 1);
            }
        };
        setTimeout(removeLastTouch, DEDUP_TIMEOUT);
    }
}

function isSyntheticEvent(eventData) {
    var x = eventData.srcEvent.clientX, y = eventData.srcEvent.clientY;
    for (var i = 0; i < this.lastTouches.length; i++) {
        var t = this.lastTouches[i];
        var dx = Math.abs(x - t.x), dy = Math.abs(y - t.y);
        if (dx <= DEDUP_DISTANCE && dy <= DEDUP_DISTANCE) {
            return true;
        }
    }
    return false;
}

var PREFIXED_TOUCH_ACTION = prefixed(TEST_ELEMENT.style, 'touchAction');
var NATIVE_TOUCH_ACTION = PREFIXED_TOUCH_ACTION !== undefined;

// magical touchAction value
var TOUCH_ACTION_COMPUTE = 'compute';
var TOUCH_ACTION_AUTO = 'auto';
var TOUCH_ACTION_MANIPULATION = 'manipulation'; // not implemented
var TOUCH_ACTION_NONE = 'none';
var TOUCH_ACTION_PAN_X = 'pan-x';
var TOUCH_ACTION_PAN_Y = 'pan-y';
var TOUCH_ACTION_MAP = getTouchActionProps();

/**
 * Touch Action
 * sets the touchAction property or uses the js alternative
 * @param {Manager} manager
 * @param {String} value
 * @constructor
 */
function TouchAction(manager, value) {
    this.manager = manager;
    this.set(value);
}

TouchAction.prototype = {
    /**
     * set the touchAction value on the element or enable the polyfill
     * @param {String} value
     */
    set: function(value) {
        // find out the touch-action by the event handlers
        if (value == TOUCH_ACTION_COMPUTE) {
            value = this.compute();
        }

        if (NATIVE_TOUCH_ACTION && this.manager.element.style && TOUCH_ACTION_MAP[value]) {
            this.manager.element.style[PREFIXED_TOUCH_ACTION] = value;
        }
        this.actions = value.toLowerCase().trim();
    },

    /**
     * just re-set the touchAction value
     */
    update: function() {
        this.set(this.manager.options.touchAction);
    },

    /**
     * compute the value for the touchAction property based on the recognizer's settings
     * @returns {String} value
     */
    compute: function() {
        var actions = [];
        each(this.manager.recognizers, function(recognizer) {
            if (boolOrFn(recognizer.options.enable, [recognizer])) {
                actions = actions.concat(recognizer.getTouchAction());
            }
        });
        return cleanTouchActions(actions.join(' '));
    },

    /**
     * this method is called on each input cycle and provides the preventing of the browser behavior
     * @param {Object} input
     */
    preventDefaults: function(input) {
        var srcEvent = input.srcEvent;
        var direction = input.offsetDirection;

        // if the touch action did prevented once this session
        if (this.manager.session.prevented) {
            srcEvent.preventDefault();
            return;
        }

        var actions = this.actions;
        var hasNone = inStr(actions, TOUCH_ACTION_NONE) && !TOUCH_ACTION_MAP[TOUCH_ACTION_NONE];
        var hasPanY = inStr(actions, TOUCH_ACTION_PAN_Y) && !TOUCH_ACTION_MAP[TOUCH_ACTION_PAN_Y];
        var hasPanX = inStr(actions, TOUCH_ACTION_PAN_X) && !TOUCH_ACTION_MAP[TOUCH_ACTION_PAN_X];

        if (hasNone) {
            //do not prevent defaults if this is a tap gesture

            var isTapPointer = input.pointers.length === 1;
            var isTapMovement = input.distance < 2;
            var isTapTouchTime = input.deltaTime < 250;

            if (isTapPointer && isTapMovement && isTapTouchTime) {
                return;
            }
        }

        if (hasPanX && hasPanY) {
            // `pan-x pan-y` means browser handles all scrolling/panning, do not prevent
            return;
        }

        if (hasNone ||
            (hasPanY && direction & DIRECTION_HORIZONTAL) ||
            (hasPanX && direction & DIRECTION_VERTICAL)) {
            return this.preventSrc(srcEvent);
        }
    },

    /**
     * call preventDefault to prevent the browser's default behavior (scrolling in most cases)
     * @param {Object} srcEvent
     */
    preventSrc: function(srcEvent) {
        this.manager.session.prevented = true;
        srcEvent.preventDefault();
    }
};

/**
 * when the touchActions are collected they are not a valid value, so we need to clean things up. *
 * @param {String} actions
 * @returns {*}
 */
function cleanTouchActions(actions) {
    // none
    if (inStr(actions, TOUCH_ACTION_NONE)) {
        return TOUCH_ACTION_NONE;
    }

    var hasPanX = inStr(actions, TOUCH_ACTION_PAN_X);
    var hasPanY = inStr(actions, TOUCH_ACTION_PAN_Y);

    // if both pan-x and pan-y are set (different recognizers
    // for different directions, e.g. horizontal pan but vertical swipe?)
    // we need none (as otherwise with pan-x pan-y combined none of these
    // recognizers will work, since the browser would handle all panning
    if (hasPanX && hasPanY) {
        return TOUCH_ACTION_NONE;
    }

    // pan-x OR pan-y
    if (hasPanX || hasPanY) {
        return hasPanX ? TOUCH_ACTION_PAN_X : TOUCH_ACTION_PAN_Y;
    }

    // manipulation
    if (inStr(actions, TOUCH_ACTION_MANIPULATION)) {
        return TOUCH_ACTION_MANIPULATION;
    }

    return TOUCH_ACTION_AUTO;
}

function getTouchActionProps() {
    if (!NATIVE_TOUCH_ACTION) {
        return false;
    }
    var touchMap = {};
    var cssSupports = window.CSS && window.CSS.supports;
    ['auto', 'manipulation', 'pan-y', 'pan-x', 'pan-x pan-y', 'none'].forEach(function(val) {

        // If css.supports is not supported but there is native touch-action assume it supports
        // all values. This is the case for IE 10 and 11.
        touchMap[val] = cssSupports ? window.CSS.supports('touch-action', val) : true;
    });
    return touchMap;
}

/**
 * Recognizer flow explained; *
 * All recognizers have the initial state of POSSIBLE when a input session starts.
 * The definition of a input session is from the first input until the last input, with all it's movement in it. *
 * Example session for mouse-input: mousedown -> mousemove -> mouseup
 *
 * On each recognizing cycle (see Manager.recognize) the .recognize() method is executed
 * which determines with state it should be.
 *
 * If the recognizer has the state FAILED, CANCELLED or RECOGNIZED (equals ENDED), it is reset to
 * POSSIBLE to give it another change on the next cycle.
 *
 *               Possible
 *                  |
 *            +-----+---------------+
 *            |                     |
 *      +-----+-----+               |
 *      |           |               |
 *   Failed      Cancelled          |
 *                          +-------+------+
 *                          |              |
 *                      Recognized       Began
 *                                         |
 *                                      Changed
 *                                         |
 *                                  Ended/Recognized
 */
var STATE_POSSIBLE = 1;
var STATE_BEGAN = 2;
var STATE_CHANGED = 4;
var STATE_ENDED = 8;
var STATE_RECOGNIZED = STATE_ENDED;
var STATE_CANCELLED = 16;
var STATE_FAILED = 32;

/**
 * Recognizer
 * Every recognizer needs to extend from this class.
 * @constructor
 * @param {Object} options
 */
function Recognizer(options) {
    this.options = assign({}, this.defaults, options || {});

    this.id = uniqueId();

    this.manager = null;

    // default is enable true
    this.options.enable = ifUndefined(this.options.enable, true);

    this.state = STATE_POSSIBLE;

    this.simultaneous = {};
    this.requireFail = [];
}

Recognizer.prototype = {
    /**
     * @virtual
     * @type {Object}
     */
    defaults: {},

    /**
     * set options
     * @param {Object} options
     * @return {Recognizer}
     */
    set: function(options) {
        assign(this.options, options);

        // also update the touchAction, in case something changed about the directions/enabled state
        this.manager && this.manager.touchAction.update();
        return this;
    },

    /**
     * recognize simultaneous with an other recognizer.
     * @param {Recognizer} otherRecognizer
     * @returns {Recognizer} this
     */
    recognizeWith: function(otherRecognizer) {
        if (invokeArrayArg(otherRecognizer, 'recognizeWith', this)) {
            return this;
        }

        var simultaneous = this.simultaneous;
        otherRecognizer = getRecognizerByNameIfManager(otherRecognizer, this);
        if (!simultaneous[otherRecognizer.id]) {
            simultaneous[otherRecognizer.id] = otherRecognizer;
            otherRecognizer.recognizeWith(this);
        }
        return this;
    },

    /**
     * drop the simultaneous link. it doesnt remove the link on the other recognizer.
     * @param {Recognizer} otherRecognizer
     * @returns {Recognizer} this
     */
    dropRecognizeWith: function(otherRecognizer) {
        if (invokeArrayArg(otherRecognizer, 'dropRecognizeWith', this)) {
            return this;
        }

        otherRecognizer = getRecognizerByNameIfManager(otherRecognizer, this);
        delete this.simultaneous[otherRecognizer.id];
        return this;
    },

    /**
     * recognizer can only run when an other is failing
     * @param {Recognizer} otherRecognizer
     * @returns {Recognizer} this
     */
    requireFailure: function(otherRecognizer) {
        if (invokeArrayArg(otherRecognizer, 'requireFailure', this)) {
            return this;
        }

        var requireFail = this.requireFail;
        otherRecognizer = getRecognizerByNameIfManager(otherRecognizer, this);
        if (inArray(requireFail, otherRecognizer) === -1) {
            requireFail.push(otherRecognizer);
            otherRecognizer.requireFailure(this);
        }
        return this;
    },

    /**
     * drop the requireFailure link. it does not remove the link on the other recognizer.
     * @param {Recognizer} otherRecognizer
     * @returns {Recognizer} this
     */
    dropRequireFailure: function(otherRecognizer) {
        if (invokeArrayArg(otherRecognizer, 'dropRequireFailure', this)) {
            return this;
        }

        otherRecognizer = getRecognizerByNameIfManager(otherRecognizer, this);
        var index = inArray(this.requireFail, otherRecognizer);
        if (index > -1) {
            this.requireFail.splice(index, 1);
        }
        return this;
    },

    /**
     * has require failures boolean
     * @returns {boolean}
     */
    hasRequireFailures: function() {
        return this.requireFail.length > 0;
    },

    /**
     * if the recognizer can recognize simultaneous with an other recognizer
     * @param {Recognizer} otherRecognizer
     * @returns {Boolean}
     */
    canRecognizeWith: function(otherRecognizer) {
        return !!this.simultaneous[otherRecognizer.id];
    },

    /**
     * You should use `tryEmit` instead of `emit` directly to check
     * that all the needed recognizers has failed before emitting.
     * @param {Object} input
     */
    emit: function(input) {
        var self = this;
        var state = this.state;

        function emit(event) {
            self.manager.emit(event, input);
        }

        // 'panstart' and 'panmove'
        if (state < STATE_ENDED) {
            emit(self.options.event + stateStr(state));
        }

        emit(self.options.event); // simple 'eventName' events

        if (input.additionalEvent) { // additional event(panleft, panright, pinchin, pinchout...)
            emit(input.additionalEvent);
        }

        // panend and pancancel
        if (state >= STATE_ENDED) {
            emit(self.options.event + stateStr(state));
        }
    },

    /**
     * Check that all the require failure recognizers has failed,
     * if true, it emits a gesture event,
     * otherwise, setup the state to FAILED.
     * @param {Object} input
     */
    tryEmit: function(input) {
        if (this.canEmit()) {
            return this.emit(input);
        }
        // it's failing anyway
        this.state = STATE_FAILED;
    },

    /**
     * can we emit?
     * @returns {boolean}
     */
    canEmit: function() {
        var i = 0;
        while (i < this.requireFail.length) {
            if (!(this.requireFail[i].state & (STATE_FAILED | STATE_POSSIBLE))) {
                return false;
            }
            i++;
        }
        return true;
    },

    /**
     * update the recognizer
     * @param {Object} inputData
     */
    recognize: function(inputData) {
        // make a new copy of the inputData
        // so we can change the inputData without messing up the other recognizers
        var inputDataClone = assign({}, inputData);

        // is is enabled and allow recognizing?
        if (!boolOrFn(this.options.enable, [this, inputDataClone])) {
            this.reset();
            this.state = STATE_FAILED;
            return;
        }

        // reset when we've reached the end
        if (this.state & (STATE_RECOGNIZED | STATE_CANCELLED | STATE_FAILED)) {
            this.state = STATE_POSSIBLE;
        }

        this.state = this.process(inputDataClone);

        // the recognizer has recognized a gesture
        // so trigger an event
        if (this.state & (STATE_BEGAN | STATE_CHANGED | STATE_ENDED | STATE_CANCELLED)) {
            this.tryEmit(inputDataClone);
        }
    },

    /**
     * return the state of the recognizer
     * the actual recognizing happens in this method
     * @virtual
     * @param {Object} inputData
     * @returns {Const} STATE
     */
    process: function(inputData) { }, // jshint ignore:line

    /**
     * return the preferred touch-action
     * @virtual
     * @returns {Array}
     */
    getTouchAction: function() { },

    /**
     * called when the gesture isn't allowed to recognize
     * like when another is being recognized or it is disabled
     * @virtual
     */
    reset: function() { }
};

/**
 * get a usable string, used as event postfix
 * @param {Const} state
 * @returns {String} state
 */
function stateStr(state) {
    if (state & STATE_CANCELLED) {
        return 'cancel';
    } else if (state & STATE_ENDED) {
        return 'end';
    } else if (state & STATE_CHANGED) {
        return 'move';
    } else if (state & STATE_BEGAN) {
        return 'start';
    }
    return '';
}

/**
 * direction cons to string
 * @param {Const} direction
 * @returns {String}
 */
function directionStr(direction) {
    if (direction == DIRECTION_DOWN) {
        return 'down';
    } else if (direction == DIRECTION_UP) {
        return 'up';
    } else if (direction == DIRECTION_LEFT) {
        return 'left';
    } else if (direction == DIRECTION_RIGHT) {
        return 'right';
    }
    return '';
}

/**
 * get a recognizer by name if it is bound to a manager
 * @param {Recognizer|String} otherRecognizer
 * @param {Recognizer} recognizer
 * @returns {Recognizer}
 */
function getRecognizerByNameIfManager(otherRecognizer, recognizer) {
    var manager = recognizer.manager;
    if (manager) {
        return manager.get(otherRecognizer);
    }
    return otherRecognizer;
}

/**
 * This recognizer is just used as a base for the simple attribute recognizers.
 * @constructor
 * @extends Recognizer
 */
function AttrRecognizer() {
    Recognizer.apply(this, arguments);
}

inherit(AttrRecognizer, Recognizer, {
    /**
     * @namespace
     * @memberof AttrRecognizer
     */
    defaults: {
        /**
         * @type {Number}
         * @default 1
         */
        pointers: 1
    },

    /**
     * Used to check if it the recognizer receives valid input, like input.distance > 10.
     * @memberof AttrRecognizer
     * @param {Object} input
     * @returns {Boolean} recognized
     */
    attrTest: function(input) {
        var optionPointers = this.options.pointers;
        return optionPointers === 0 || input.pointers.length === optionPointers;
    },

    /**
     * Process the input and return the state for the recognizer
     * @memberof AttrRecognizer
     * @param {Object} input
     * @returns {*} State
     */
    process: function(input) {
        var state = this.state;
        var eventType = input.eventType;

        var isRecognized = state & (STATE_BEGAN | STATE_CHANGED);
        var isValid = this.attrTest(input);

        // on cancel input and we've recognized before, return STATE_CANCELLED
        if (isRecognized && (eventType & INPUT_CANCEL || !isValid)) {
            return state | STATE_CANCELLED;
        } else if (isRecognized || isValid) {
            if (eventType & INPUT_END) {
                return state | STATE_ENDED;
            } else if (!(state & STATE_BEGAN)) {
                return STATE_BEGAN;
            }
            return state | STATE_CHANGED;
        }
        return STATE_FAILED;
    }
});

/**
 * Pan
 * Recognized when the pointer is down and moved in the allowed direction.
 * @constructor
 * @extends AttrRecognizer
 */
function PanRecognizer() {
    AttrRecognizer.apply(this, arguments);

    this.pX = null;
    this.pY = null;
}

inherit(PanRecognizer, AttrRecognizer, {
    /**
     * @namespace
     * @memberof PanRecognizer
     */
    defaults: {
        event: 'pan',
        threshold: 10,
        pointers: 1,
        direction: DIRECTION_ALL
    },

    getTouchAction: function() {
        var direction = this.options.direction;
        var actions = [];
        if (direction & DIRECTION_HORIZONTAL) {
            actions.push(TOUCH_ACTION_PAN_Y);
        }
        if (direction & DIRECTION_VERTICAL) {
            actions.push(TOUCH_ACTION_PAN_X);
        }
        return actions;
    },

    directionTest: function(input) {
        var options = this.options;
        var hasMoved = true;
        var distance = input.distance;
        var direction = input.direction;
        var x = input.deltaX;
        var y = input.deltaY;

        // lock to axis?
        if (!(direction & options.direction)) {
            if (options.direction & DIRECTION_HORIZONTAL) {
                direction = (x === 0) ? DIRECTION_NONE : (x < 0) ? DIRECTION_LEFT : DIRECTION_RIGHT;
                hasMoved = x != this.pX;
                distance = Math.abs(input.deltaX);
            } else {
                direction = (y === 0) ? DIRECTION_NONE : (y < 0) ? DIRECTION_UP : DIRECTION_DOWN;
                hasMoved = y != this.pY;
                distance = Math.abs(input.deltaY);
            }
        }
        input.direction = direction;
        return hasMoved && distance > options.threshold && direction & options.direction;
    },

    attrTest: function(input) {
        return AttrRecognizer.prototype.attrTest.call(this, input) &&
            (this.state & STATE_BEGAN || (!(this.state & STATE_BEGAN) && this.directionTest(input)));
    },

    emit: function(input) {

        this.pX = input.deltaX;
        this.pY = input.deltaY;

        var direction = directionStr(input.direction);

        if (direction) {
            input.additionalEvent = this.options.event + direction;
        }
        this._super.emit.call(this, input);
    }
});

/**
 * Pinch
 * Recognized when two or more pointers are moving toward (zoom-in) or away from each other (zoom-out).
 * @constructor
 * @extends AttrRecognizer
 */
function PinchRecognizer() {
    AttrRecognizer.apply(this, arguments);
}

inherit(PinchRecognizer, AttrRecognizer, {
    /**
     * @namespace
     * @memberof PinchRecognizer
     */
    defaults: {
        event: 'pinch',
        threshold: 0,
        pointers: 2
    },

    getTouchAction: function() {
        return [TOUCH_ACTION_NONE];
    },

    attrTest: function(input) {
        return this._super.attrTest.call(this, input) &&
            (Math.abs(input.scale - 1) > this.options.threshold || this.state & STATE_BEGAN);
    },

    emit: function(input) {
        if (input.scale !== 1) {
            var inOut = input.scale < 1 ? 'in' : 'out';
            input.additionalEvent = this.options.event + inOut;
        }
        this._super.emit.call(this, input);
    }
});

/**
 * Press
 * Recognized when the pointer is down for x ms without any movement.
 * @constructor
 * @extends Recognizer
 */
function PressRecognizer() {
    Recognizer.apply(this, arguments);

    this._timer = null;
    this._input = null;
}

inherit(PressRecognizer, Recognizer, {
    /**
     * @namespace
     * @memberof PressRecognizer
     */
    defaults: {
        event: 'press',
        pointers: 1,
        time: 251, // minimal time of the pointer to be pressed
        threshold: 9 // a minimal movement is ok, but keep it low
    },

    getTouchAction: function() {
        return [TOUCH_ACTION_AUTO];
    },

    process: function(input) {
        var options = this.options;
        var validPointers = input.pointers.length === options.pointers;
        var validMovement = input.distance < options.threshold;
        var validTime = input.deltaTime > options.time;

        this._input = input;

        // we only allow little movement
        // and we've reached an end event, so a tap is possible
        if (!validMovement || !validPointers || (input.eventType & (INPUT_END | INPUT_CANCEL) && !validTime)) {
            this.reset();
        } else if (input.eventType & INPUT_START) {
            this.reset();
            this._timer = setTimeoutContext(function() {
                this.state = STATE_RECOGNIZED;
                this.tryEmit();
            }, options.time, this);
        } else if (input.eventType & INPUT_END) {
            return STATE_RECOGNIZED;
        }
        return STATE_FAILED;
    },

    reset: function() {
        clearTimeout(this._timer);
    },

    emit: function(input) {
        if (this.state !== STATE_RECOGNIZED) {
            return;
        }

        if (input && (input.eventType & INPUT_END)) {
            this.manager.emit(this.options.event + 'up', input);
        } else {
            this._input.timeStamp = now();
            this.manager.emit(this.options.event, this._input);
        }
    }
});

/**
 * Rotate
 * Recognized when two or more pointer are moving in a circular motion.
 * @constructor
 * @extends AttrRecognizer
 */
function RotateRecognizer() {
    AttrRecognizer.apply(this, arguments);
}

inherit(RotateRecognizer, AttrRecognizer, {
    /**
     * @namespace
     * @memberof RotateRecognizer
     */
    defaults: {
        event: 'rotate',
        threshold: 0,
        pointers: 2
    },

    getTouchAction: function() {
        return [TOUCH_ACTION_NONE];
    },

    attrTest: function(input) {
        return this._super.attrTest.call(this, input) &&
            (Math.abs(input.rotation) > this.options.threshold || this.state & STATE_BEGAN);
    }
});

/**
 * Swipe
 * Recognized when the pointer is moving fast (velocity), with enough distance in the allowed direction.
 * @constructor
 * @extends AttrRecognizer
 */
function SwipeRecognizer() {
    AttrRecognizer.apply(this, arguments);
}

inherit(SwipeRecognizer, AttrRecognizer, {
    /**
     * @namespace
     * @memberof SwipeRecognizer
     */
    defaults: {
        event: 'swipe',
        threshold: 10,
        velocity: 0.3,
        direction: DIRECTION_HORIZONTAL | DIRECTION_VERTICAL,
        pointers: 1
    },

    getTouchAction: function() {
        return PanRecognizer.prototype.getTouchAction.call(this);
    },

    attrTest: function(input) {
        var direction = this.options.direction;
        var velocity;

        if (direction & (DIRECTION_HORIZONTAL | DIRECTION_VERTICAL)) {
            velocity = input.overallVelocity;
        } else if (direction & DIRECTION_HORIZONTAL) {
            velocity = input.overallVelocityX;
        } else if (direction & DIRECTION_VERTICAL) {
            velocity = input.overallVelocityY;
        }

        return this._super.attrTest.call(this, input) &&
            direction & input.offsetDirection &&
            input.distance > this.options.threshold &&
            input.maxPointers == this.options.pointers &&
            abs(velocity) > this.options.velocity && input.eventType & INPUT_END;
    },

    emit: function(input) {
        var direction = directionStr(input.offsetDirection);
        if (direction) {
            this.manager.emit(this.options.event + direction, input);
        }

        this.manager.emit(this.options.event, input);
    }
});

/**
 * A tap is ecognized when the pointer is doing a small tap/click. Multiple taps are recognized if they occur
 * between the given interval and position. The delay option can be used to recognize multi-taps without firing
 * a single tap.
 *
 * The eventData from the emitted event contains the property `tapCount`, which contains the amount of
 * multi-taps being recognized.
 * @constructor
 * @extends Recognizer
 */
function TapRecognizer() {
    Recognizer.apply(this, arguments);

    // previous time and center,
    // used for tap counting
    this.pTime = false;
    this.pCenter = false;

    this._timer = null;
    this._input = null;
    this.count = 0;
}

inherit(TapRecognizer, Recognizer, {
    /**
     * @namespace
     * @memberof PinchRecognizer
     */
    defaults: {
        event: 'tap',
        pointers: 1,
        taps: 1,
        interval: 300, // max time between the multi-tap taps
        time: 250, // max time of the pointer to be down (like finger on the screen)
        threshold: 9, // a minimal movement is ok, but keep it low
        posThreshold: 10 // a multi-tap can be a bit off the initial position
    },

    getTouchAction: function() {
        return [TOUCH_ACTION_MANIPULATION];
    },

    process: function(input) {
        var options = this.options;

        var validPointers = input.pointers.length === options.pointers;
        var validMovement = input.distance < options.threshold;
        var validTouchTime = input.deltaTime < options.time;

        this.reset();

        if ((input.eventType & INPUT_START) && (this.count === 0)) {
            return this.failTimeout();
        }

        // we only allow little movement
        // and we've reached an end event, so a tap is possible
        if (validMovement && validTouchTime && validPointers) {
            if (input.eventType != INPUT_END) {
                return this.failTimeout();
            }

            var validInterval = this.pTime ? (input.timeStamp - this.pTime < options.interval) : true;
            var validMultiTap = !this.pCenter || getDistance(this.pCenter, input.center) < options.posThreshold;

            this.pTime = input.timeStamp;
            this.pCenter = input.center;

            if (!validMultiTap || !validInterval) {
                this.count = 1;
            } else {
                this.count += 1;
            }

            this._input = input;

            // if tap count matches we have recognized it,
            // else it has began recognizing...
            var tapCount = this.count % options.taps;
            if (tapCount === 0) {
                // no failing requirements, immediately trigger the tap event
                // or wait as long as the multitap interval to trigger
                if (!this.hasRequireFailures()) {
                    return STATE_RECOGNIZED;
                } else {
                    this._timer = setTimeoutContext(function() {
                        this.state = STATE_RECOGNIZED;
                        this.tryEmit();
                    }, options.interval, this);
                    return STATE_BEGAN;
                }
            }
        }
        return STATE_FAILED;
    },

    failTimeout: function() {
        this._timer = setTimeoutContext(function() {
            this.state = STATE_FAILED;
        }, this.options.interval, this);
        return STATE_FAILED;
    },

    reset: function() {
        clearTimeout(this._timer);
    },

    emit: function() {
        if (this.state == STATE_RECOGNIZED) {
            this._input.tapCount = this.count;
            this.manager.emit(this.options.event, this._input);
        }
    }
});

/**
 * Simple way to create a manager with a default set of recognizers.
 * @param {HTMLElement} element
 * @param {Object} [options]
 * @constructor
 */
function Hammer(element, options) {
    options = options || {};
    options.recognizers = ifUndefined(options.recognizers, Hammer.defaults.preset);
    return new Manager(element, options);
}

/**
 * @const {string}
 */
Hammer.VERSION = '2.0.7';

/**
 * default settings
 * @namespace
 */
Hammer.defaults = {
    /**
     * set if DOM events are being triggered.
     * But this is slower and unused by simple implementations, so disabled by default.
     * @type {Boolean}
     * @default false
     */
    domEvents: false,

    /**
     * The value for the touchAction property/fallback.
     * When set to `compute` it will magically set the correct value based on the added recognizers.
     * @type {String}
     * @default compute
     */
    touchAction: TOUCH_ACTION_COMPUTE,

    /**
     * @type {Boolean}
     * @default true
     */
    enable: true,

    /**
     * EXPERIMENTAL FEATURE -- can be removed/changed
     * Change the parent input target element.
     * If Null, then it is being set the to main element.
     * @type {Null|EventTarget}
     * @default null
     */
    inputTarget: null,

    /**
     * force an input class
     * @type {Null|Function}
     * @default null
     */
    inputClass: null,

    /**
     * Default recognizer setup when calling `Hammer()`
     * When creating a new Manager these will be skipped.
     * @type {Array}
     */
    preset: [
        // RecognizerClass, options, [recognizeWith, ...], [requireFailure, ...]
        [RotateRecognizer, {enable: false}],
        [PinchRecognizer, {enable: false}, ['rotate']],
        [SwipeRecognizer, {direction: DIRECTION_HORIZONTAL}],
        [PanRecognizer, {direction: DIRECTION_HORIZONTAL}, ['swipe']],
        [TapRecognizer],
        [TapRecognizer, {event: 'doubletap', taps: 2}, ['tap']],
        [PressRecognizer]
    ],

    /**
     * Some CSS properties can be used to improve the working of Hammer.
     * Add them to this method and they will be set when creating a new Manager.
     * @namespace
     */
    cssProps: {
        /**
         * Disables text selection to improve the dragging gesture. Mainly for desktop browsers.
         * @type {String}
         * @default 'none'
         */
        userSelect: 'none',

        /**
         * Disable the Windows Phone grippers when pressing an element.
         * @type {String}
         * @default 'none'
         */
        touchSelect: 'none',

        /**
         * Disables the default callout shown when you touch and hold a touch target.
         * On iOS, when you touch and hold a touch target such as a link, Safari displays
         * a callout containing information about the link. This property allows you to disable that callout.
         * @type {String}
         * @default 'none'
         */
        touchCallout: 'none',

        /**
         * Specifies whether zooming is enabled. Used by IE10>
         * @type {String}
         * @default 'none'
         */
        contentZooming: 'none',

        /**
         * Specifies that an entire element should be draggable instead of its contents. Mainly for desktop browsers.
         * @type {String}
         * @default 'none'
         */
        userDrag: 'none',

        /**
         * Overrides the highlight color shown when the user taps a link or a JavaScript
         * clickable element in iOS. This property obeys the alpha value, if specified.
         * @type {String}
         * @default 'rgba(0,0,0,0)'
         */
        tapHighlightColor: 'rgba(0,0,0,0)'
    }
};

var STOP = 1;
var FORCED_STOP = 2;

/**
 * Manager
 * @param {HTMLElement} element
 * @param {Object} [options]
 * @constructor
 */
function Manager(element, options) {
    this.options = assign({}, Hammer.defaults, options || {});

    this.options.inputTarget = this.options.inputTarget || element;

    this.handlers = {};
    this.session = {};
    this.recognizers = [];
    this.oldCssProps = {};

    this.element = element;
    this.input = createInputInstance(this);
    this.touchAction = new TouchAction(this, this.options.touchAction);

    toggleCssProps(this, true);

    each(this.options.recognizers, function(item) {
        var recognizer = this.add(new (item[0])(item[1]));
        item[2] && recognizer.recognizeWith(item[2]);
        item[3] && recognizer.requireFailure(item[3]);
    }, this);
}

Manager.prototype = {
    /**
     * set options
     * @param {Object} options
     * @returns {Manager}
     */
    set: function(options) {
        assign(this.options, options);

        // Options that need a little more setup
        if (options.touchAction) {
            this.touchAction.update();
        }
        if (options.inputTarget) {
            // Clean up existing event listeners and reinitialize
            this.input.destroy();
            this.input.target = options.inputTarget;
            this.input.init();
        }
        return this;
    },

    /**
     * stop recognizing for this session.
     * This session will be discarded, when a new [input]start event is fired.
     * When forced, the recognizer cycle is stopped immediately.
     * @param {Boolean} [force]
     */
    stop: function(force) {
        this.session.stopped = force ? FORCED_STOP : STOP;
    },

    /**
     * run the recognizers!
     * called by the inputHandler function on every movement of the pointers (touches)
     * it walks through all the recognizers and tries to detect the gesture that is being made
     * @param {Object} inputData
     */
    recognize: function(inputData) {
        var session = this.session;
        if (session.stopped) {
            return;
        }

        // run the touch-action polyfill
        this.touchAction.preventDefaults(inputData);

        var recognizer;
        var recognizers = this.recognizers;

        // this holds the recognizer that is being recognized.
        // so the recognizer's state needs to be BEGAN, CHANGED, ENDED or RECOGNIZED
        // if no recognizer is detecting a thing, it is set to `null`
        var curRecognizer = session.curRecognizer;

        // reset when the last recognizer is recognized
        // or when we're in a new session
        if (!curRecognizer || (curRecognizer && curRecognizer.state & STATE_RECOGNIZED)) {
            curRecognizer = session.curRecognizer = null;
        }

        var i = 0;
        while (i < recognizers.length) {
            recognizer = recognizers[i];

            // find out if we are allowed try to recognize the input for this one.
            // 1.   allow if the session is NOT forced stopped (see the .stop() method)
            // 2.   allow if we still haven't recognized a gesture in this session, or the this recognizer is the one
            //      that is being recognized.
            // 3.   allow if the recognizer is allowed to run simultaneous with the current recognized recognizer.
            //      this can be setup with the `recognizeWith()` method on the recognizer.
            if (session.stopped !== FORCED_STOP && ( // 1
                    !curRecognizer || recognizer == curRecognizer || // 2
                    recognizer.canRecognizeWith(curRecognizer))) { // 3
                recognizer.recognize(inputData);
            } else {
                recognizer.reset();
            }

            // if the recognizer has been recognizing the input as a valid gesture, we want to store this one as the
            // current active recognizer. but only if we don't already have an active recognizer
            if (!curRecognizer && recognizer.state & (STATE_BEGAN | STATE_CHANGED | STATE_ENDED)) {
                curRecognizer = session.curRecognizer = recognizer;
            }
            i++;
        }
    },

    /**
     * get a recognizer by its event name.
     * @param {Recognizer|String} recognizer
     * @returns {Recognizer|Null}
     */
    get: function(recognizer) {
        if (recognizer instanceof Recognizer) {
            return recognizer;
        }

        var recognizers = this.recognizers;
        for (var i = 0; i < recognizers.length; i++) {
            if (recognizers[i].options.event == recognizer) {
                return recognizers[i];
            }
        }
        return null;
    },

    /**
     * add a recognizer to the manager
     * existing recognizers with the same event name will be removed
     * @param {Recognizer} recognizer
     * @returns {Recognizer|Manager}
     */
    add: function(recognizer) {
        if (invokeArrayArg(recognizer, 'add', this)) {
            return this;
        }

        // remove existing
        var existing = this.get(recognizer.options.event);
        if (existing) {
            this.remove(existing);
        }

        this.recognizers.push(recognizer);
        recognizer.manager = this;

        this.touchAction.update();
        return recognizer;
    },

    /**
     * remove a recognizer by name or instance
     * @param {Recognizer|String} recognizer
     * @returns {Manager}
     */
    remove: function(recognizer) {
        if (invokeArrayArg(recognizer, 'remove', this)) {
            return this;
        }

        recognizer = this.get(recognizer);

        // let's make sure this recognizer exists
        if (recognizer) {
            var recognizers = this.recognizers;
            var index = inArray(recognizers, recognizer);

            if (index !== -1) {
                recognizers.splice(index, 1);
                this.touchAction.update();
            }
        }

        return this;
    },

    /**
     * bind event
     * @param {String} events
     * @param {Function} handler
     * @returns {EventEmitter} this
     */
    on: function(events, handler) {
        if (events === undefined) {
            return;
        }
        if (handler === undefined) {
            return;
        }

        var handlers = this.handlers;
        each(splitStr(events), function(event) {
            handlers[event] = handlers[event] || [];
            handlers[event].push(handler);
        });
        return this;
    },

    /**
     * unbind event, leave emit blank to remove all handlers
     * @param {String} events
     * @param {Function} [handler]
     * @returns {EventEmitter} this
     */
    off: function(events, handler) {
        if (events === undefined) {
            return;
        }

        var handlers = this.handlers;
        each(splitStr(events), function(event) {
            if (!handler) {
                delete handlers[event];
            } else {
                handlers[event] && handlers[event].splice(inArray(handlers[event], handler), 1);
            }
        });
        return this;
    },

    /**
     * emit event to the listeners
     * @param {String} event
     * @param {Object} data
     */
    emit: function(event, data) {
        // we also want to trigger dom events
        if (this.options.domEvents) {
            triggerDomEvent(event, data);
        }

        // no handlers, so skip it all
        var handlers = this.handlers[event] && this.handlers[event].slice();
        if (!handlers || !handlers.length) {
            return;
        }

        data.type = event;
        data.preventDefault = function() {
            data.srcEvent.preventDefault();
        };

        var i = 0;
        while (i < handlers.length) {
            handlers[i](data);
            i++;
        }
    },

    /**
     * destroy the manager and unbinds all events
     * it doesn't unbind dom events, that is the user own responsibility
     */
    destroy: function() {
        this.element && toggleCssProps(this, false);

        this.handlers = {};
        this.session = {};
        this.input.destroy();
        this.element = null;
    }
};

/**
 * add/remove the css properties as defined in manager.options.cssProps
 * @param {Manager} manager
 * @param {Boolean} add
 */
function toggleCssProps(manager, add) {
    var element = manager.element;
    if (!element.style) {
        return;
    }
    var prop;
    each(manager.options.cssProps, function(value, name) {
        prop = prefixed(element.style, name);
        if (add) {
            manager.oldCssProps[prop] = element.style[prop];
            element.style[prop] = value;
        } else {
            element.style[prop] = manager.oldCssProps[prop] || '';
        }
    });
    if (!add) {
        manager.oldCssProps = {};
    }
}

/**
 * trigger dom event
 * @param {String} event
 * @param {Object} data
 */
function triggerDomEvent(event, data) {
    var gestureEvent = document.createEvent('Event');
    gestureEvent.initEvent(event, true, true);
    gestureEvent.gesture = data;
    data.target.dispatchEvent(gestureEvent);
}

assign(Hammer, {
    INPUT_START: INPUT_START,
    INPUT_MOVE: INPUT_MOVE,
    INPUT_END: INPUT_END,
    INPUT_CANCEL: INPUT_CANCEL,

    STATE_POSSIBLE: STATE_POSSIBLE,
    STATE_BEGAN: STATE_BEGAN,
    STATE_CHANGED: STATE_CHANGED,
    STATE_ENDED: STATE_ENDED,
    STATE_RECOGNIZED: STATE_RECOGNIZED,
    STATE_CANCELLED: STATE_CANCELLED,
    STATE_FAILED: STATE_FAILED,

    DIRECTION_NONE: DIRECTION_NONE,
    DIRECTION_LEFT: DIRECTION_LEFT,
    DIRECTION_RIGHT: DIRECTION_RIGHT,
    DIRECTION_UP: DIRECTION_UP,
    DIRECTION_DOWN: DIRECTION_DOWN,
    DIRECTION_HORIZONTAL: DIRECTION_HORIZONTAL,
    DIRECTION_VERTICAL: DIRECTION_VERTICAL,
    DIRECTION_ALL: DIRECTION_ALL,

    Manager: Manager,
    Input: Input,
    TouchAction: TouchAction,

    TouchInput: TouchInput,
    MouseInput: MouseInput,
    PointerEventInput: PointerEventInput,
    TouchMouseInput: TouchMouseInput,
    SingleTouchInput: SingleTouchInput,

    Recognizer: Recognizer,
    AttrRecognizer: AttrRecognizer,
    Tap: TapRecognizer,
    Pan: PanRecognizer,
    Swipe: SwipeRecognizer,
    Pinch: PinchRecognizer,
    Rotate: RotateRecognizer,
    Press: PressRecognizer,

    on: addEventListeners,
    off: removeEventListeners,
    each: each,
    merge: merge,
    extend: extend,
    assign: assign,
    inherit: inherit,
    bindFn: bindFn,
    prefixed: prefixed
});

// this prevents errors when Hammer is loaded in the presence of an AMD
//  style loader but by script tag, not by the loader.
var freeGlobal = (typeof window !== 'undefined' ? window : (typeof self !== 'undefined' ? self : {})); // jshint ignore:line
freeGlobal.Hammer = Hammer;

if (true) {
    !(__WEBPACK_AMD_DEFINE_RESULT__ = (function() {
        return Hammer;
    }).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
} else if (typeof module != 'undefined' && module.exports) {
    module.exports = Hammer;
} else {
    window[exportName] = Hammer;
}

})(window, document, 'Hammer');


/***/ }),
/* 530 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Url */
/* unused harmony export Http */
/* unused harmony export Resource */
/*!
 * vue-resource v1.5.1
 * https://github.com/pagekit/vue-resource
 * Released under the MIT License.
 */

/**
 * Promises/A+ polyfill v1.1.4 (https://github.com/bramstein/promis)
 */

var RESOLVED = 0;
var REJECTED = 1;
var PENDING = 2;

function Promise$1(executor) {

    this.state = PENDING;
    this.value = undefined;
    this.deferred = [];

    var promise = this;

    try {
        executor(function (x) {
            promise.resolve(x);
        }, function (r) {
            promise.reject(r);
        });
    } catch (e) {
        promise.reject(e);
    }
}

Promise$1.reject = function (r) {
    return new Promise$1(function (resolve, reject) {
        reject(r);
    });
};

Promise$1.resolve = function (x) {
    return new Promise$1(function (resolve, reject) {
        resolve(x);
    });
};

Promise$1.all = function all(iterable) {
    return new Promise$1(function (resolve, reject) {
        var count = 0, result = [];

        if (iterable.length === 0) {
            resolve(result);
        }

        function resolver(i) {
            return function (x) {
                result[i] = x;
                count += 1;

                if (count === iterable.length) {
                    resolve(result);
                }
            };
        }

        for (var i = 0; i < iterable.length; i += 1) {
            Promise$1.resolve(iterable[i]).then(resolver(i), reject);
        }
    });
};

Promise$1.race = function race(iterable) {
    return new Promise$1(function (resolve, reject) {
        for (var i = 0; i < iterable.length; i += 1) {
            Promise$1.resolve(iterable[i]).then(resolve, reject);
        }
    });
};

var p = Promise$1.prototype;

p.resolve = function resolve(x) {
    var promise = this;

    if (promise.state === PENDING) {
        if (x === promise) {
            throw new TypeError('Promise settled with itself.');
        }

        var called = false;

        try {
            var then = x && x['then'];

            if (x !== null && typeof x === 'object' && typeof then === 'function') {
                then.call(x, function (x) {
                    if (!called) {
                        promise.resolve(x);
                    }
                    called = true;

                }, function (r) {
                    if (!called) {
                        promise.reject(r);
                    }
                    called = true;
                });
                return;
            }
        } catch (e) {
            if (!called) {
                promise.reject(e);
            }
            return;
        }

        promise.state = RESOLVED;
        promise.value = x;
        promise.notify();
    }
};

p.reject = function reject(reason) {
    var promise = this;

    if (promise.state === PENDING) {
        if (reason === promise) {
            throw new TypeError('Promise settled with itself.');
        }

        promise.state = REJECTED;
        promise.value = reason;
        promise.notify();
    }
};

p.notify = function notify() {
    var promise = this;

    nextTick(function () {
        if (promise.state !== PENDING) {
            while (promise.deferred.length) {
                var deferred = promise.deferred.shift(),
                    onResolved = deferred[0],
                    onRejected = deferred[1],
                    resolve = deferred[2],
                    reject = deferred[3];

                try {
                    if (promise.state === RESOLVED) {
                        if (typeof onResolved === 'function') {
                            resolve(onResolved.call(undefined, promise.value));
                        } else {
                            resolve(promise.value);
                        }
                    } else if (promise.state === REJECTED) {
                        if (typeof onRejected === 'function') {
                            resolve(onRejected.call(undefined, promise.value));
                        } else {
                            reject(promise.value);
                        }
                    }
                } catch (e) {
                    reject(e);
                }
            }
        }
    });
};

p.then = function then(onResolved, onRejected) {
    var promise = this;

    return new Promise$1(function (resolve, reject) {
        promise.deferred.push([onResolved, onRejected, resolve, reject]);
        promise.notify();
    });
};

p.catch = function (onRejected) {
    return this.then(undefined, onRejected);
};

/**
 * Promise adapter.
 */

if (typeof Promise === 'undefined') {
    window.Promise = Promise$1;
}

function PromiseObj(executor, context) {

    if (executor instanceof Promise) {
        this.promise = executor;
    } else {
        this.promise = new Promise(executor.bind(context));
    }

    this.context = context;
}

PromiseObj.all = function (iterable, context) {
    return new PromiseObj(Promise.all(iterable), context);
};

PromiseObj.resolve = function (value, context) {
    return new PromiseObj(Promise.resolve(value), context);
};

PromiseObj.reject = function (reason, context) {
    return new PromiseObj(Promise.reject(reason), context);
};

PromiseObj.race = function (iterable, context) {
    return new PromiseObj(Promise.race(iterable), context);
};

var p$1 = PromiseObj.prototype;

p$1.bind = function (context) {
    this.context = context;
    return this;
};

p$1.then = function (fulfilled, rejected) {

    if (fulfilled && fulfilled.bind && this.context) {
        fulfilled = fulfilled.bind(this.context);
    }

    if (rejected && rejected.bind && this.context) {
        rejected = rejected.bind(this.context);
    }

    return new PromiseObj(this.promise.then(fulfilled, rejected), this.context);
};

p$1.catch = function (rejected) {

    if (rejected && rejected.bind && this.context) {
        rejected = rejected.bind(this.context);
    }

    return new PromiseObj(this.promise.catch(rejected), this.context);
};

p$1.finally = function (callback) {

    return this.then(function (value) {
        callback.call(this);
        return value;
    }, function (reason) {
        callback.call(this);
        return Promise.reject(reason);
    }
    );
};

/**
 * Utility functions.
 */

var ref = {};
var hasOwnProperty = ref.hasOwnProperty;
var ref$1 = [];
var slice = ref$1.slice;
var debug = false, ntick;

var inBrowser = typeof window !== 'undefined';

function Util (ref) {
    var config = ref.config;
    var nextTick = ref.nextTick;

    ntick = nextTick;
    debug = config.debug || !config.silent;
}

function warn(msg) {
    if (typeof console !== 'undefined' && debug) {
        console.warn('[VueResource warn]: ' + msg);
    }
}

function error(msg) {
    if (typeof console !== 'undefined') {
        console.error(msg);
    }
}

function nextTick(cb, ctx) {
    return ntick(cb, ctx);
}

function trim(str) {
    return str ? str.replace(/^\s*|\s*$/g, '') : '';
}

function trimEnd(str, chars) {

    if (str && chars === undefined) {
        return str.replace(/\s+$/, '');
    }

    if (!str || !chars) {
        return str;
    }

    return str.replace(new RegExp(("[" + chars + "]+$")), '');
}

function toLower(str) {
    return str ? str.toLowerCase() : '';
}

function toUpper(str) {
    return str ? str.toUpperCase() : '';
}

var isArray = Array.isArray;

function isString(val) {
    return typeof val === 'string';
}

function isFunction(val) {
    return typeof val === 'function';
}

function isObject(obj) {
    return obj !== null && typeof obj === 'object';
}

function isPlainObject(obj) {
    return isObject(obj) && Object.getPrototypeOf(obj) == Object.prototype;
}

function isBlob(obj) {
    return typeof Blob !== 'undefined' && obj instanceof Blob;
}

function isFormData(obj) {
    return typeof FormData !== 'undefined' && obj instanceof FormData;
}

function when(value, fulfilled, rejected) {

    var promise = PromiseObj.resolve(value);

    if (arguments.length < 2) {
        return promise;
    }

    return promise.then(fulfilled, rejected);
}

function options(fn, obj, opts) {

    opts = opts || {};

    if (isFunction(opts)) {
        opts = opts.call(obj);
    }

    return merge(fn.bind({$vm: obj, $options: opts}), fn, {$options: opts});
}

function each(obj, iterator) {

    var i, key;

    if (isArray(obj)) {
        for (i = 0; i < obj.length; i++) {
            iterator.call(obj[i], obj[i], i);
        }
    } else if (isObject(obj)) {
        for (key in obj) {
            if (hasOwnProperty.call(obj, key)) {
                iterator.call(obj[key], obj[key], key);
            }
        }
    }

    return obj;
}

var assign = Object.assign || _assign;

function merge(target) {

    var args = slice.call(arguments, 1);

    args.forEach(function (source) {
        _merge(target, source, true);
    });

    return target;
}

function defaults(target) {

    var args = slice.call(arguments, 1);

    args.forEach(function (source) {

        for (var key in source) {
            if (target[key] === undefined) {
                target[key] = source[key];
            }
        }

    });

    return target;
}

function _assign(target) {

    var args = slice.call(arguments, 1);

    args.forEach(function (source) {
        _merge(target, source);
    });

    return target;
}

function _merge(target, source, deep) {
    for (var key in source) {
        if (deep && (isPlainObject(source[key]) || isArray(source[key]))) {
            if (isPlainObject(source[key]) && !isPlainObject(target[key])) {
                target[key] = {};
            }
            if (isArray(source[key]) && !isArray(target[key])) {
                target[key] = [];
            }
            _merge(target[key], source[key], deep);
        } else if (source[key] !== undefined) {
            target[key] = source[key];
        }
    }
}

/**
 * Root Prefix Transform.
 */

function root (options$$1, next) {

    var url = next(options$$1);

    if (isString(options$$1.root) && !/^(https?:)?\//.test(url)) {
        url = trimEnd(options$$1.root, '/') + '/' + url;
    }

    return url;
}

/**
 * Query Parameter Transform.
 */

function query (options$$1, next) {

    var urlParams = Object.keys(Url.options.params), query = {}, url = next(options$$1);

    each(options$$1.params, function (value, key) {
        if (urlParams.indexOf(key) === -1) {
            query[key] = value;
        }
    });

    query = Url.params(query);

    if (query) {
        url += (url.indexOf('?') == -1 ? '?' : '&') + query;
    }

    return url;
}

/**
 * URL Template v2.0.6 (https://github.com/bramstein/url-template)
 */

function expand(url, params, variables) {

    var tmpl = parse(url), expanded = tmpl.expand(params);

    if (variables) {
        variables.push.apply(variables, tmpl.vars);
    }

    return expanded;
}

function parse(template) {

    var operators = ['+', '#', '.', '/', ';', '?', '&'], variables = [];

    return {
        vars: variables,
        expand: function expand(context) {
            return template.replace(/\{([^{}]+)\}|([^{}]+)/g, function (_, expression, literal) {
                if (expression) {

                    var operator = null, values = [];

                    if (operators.indexOf(expression.charAt(0)) !== -1) {
                        operator = expression.charAt(0);
                        expression = expression.substr(1);
                    }

                    expression.split(/,/g).forEach(function (variable) {
                        var tmp = /([^:*]*)(?::(\d+)|(\*))?/.exec(variable);
                        values.push.apply(values, getValues(context, operator, tmp[1], tmp[2] || tmp[3]));
                        variables.push(tmp[1]);
                    });

                    if (operator && operator !== '+') {

                        var separator = ',';

                        if (operator === '?') {
                            separator = '&';
                        } else if (operator !== '#') {
                            separator = operator;
                        }

                        return (values.length !== 0 ? operator : '') + values.join(separator);
                    } else {
                        return values.join(',');
                    }

                } else {
                    return encodeReserved(literal);
                }
            });
        }
    };
}

function getValues(context, operator, key, modifier) {

    var value = context[key], result = [];

    if (isDefined(value) && value !== '') {
        if (typeof value === 'string' || typeof value === 'number' || typeof value === 'boolean') {
            value = value.toString();

            if (modifier && modifier !== '*') {
                value = value.substring(0, parseInt(modifier, 10));
            }

            result.push(encodeValue(operator, value, isKeyOperator(operator) ? key : null));
        } else {
            if (modifier === '*') {
                if (Array.isArray(value)) {
                    value.filter(isDefined).forEach(function (value) {
                        result.push(encodeValue(operator, value, isKeyOperator(operator) ? key : null));
                    });
                } else {
                    Object.keys(value).forEach(function (k) {
                        if (isDefined(value[k])) {
                            result.push(encodeValue(operator, value[k], k));
                        }
                    });
                }
            } else {
                var tmp = [];

                if (Array.isArray(value)) {
                    value.filter(isDefined).forEach(function (value) {
                        tmp.push(encodeValue(operator, value));
                    });
                } else {
                    Object.keys(value).forEach(function (k) {
                        if (isDefined(value[k])) {
                            tmp.push(encodeURIComponent(k));
                            tmp.push(encodeValue(operator, value[k].toString()));
                        }
                    });
                }

                if (isKeyOperator(operator)) {
                    result.push(encodeURIComponent(key) + '=' + tmp.join(','));
                } else if (tmp.length !== 0) {
                    result.push(tmp.join(','));
                }
            }
        }
    } else {
        if (operator === ';') {
            result.push(encodeURIComponent(key));
        } else if (value === '' && (operator === '&' || operator === '?')) {
            result.push(encodeURIComponent(key) + '=');
        } else if (value === '') {
            result.push('');
        }
    }

    return result;
}

function isDefined(value) {
    return value !== undefined && value !== null;
}

function isKeyOperator(operator) {
    return operator === ';' || operator === '&' || operator === '?';
}

function encodeValue(operator, value, key) {

    value = (operator === '+' || operator === '#') ? encodeReserved(value) : encodeURIComponent(value);

    if (key) {
        return encodeURIComponent(key) + '=' + value;
    } else {
        return value;
    }
}

function encodeReserved(str) {
    return str.split(/(%[0-9A-Fa-f]{2})/g).map(function (part) {
        if (!/%[0-9A-Fa-f]/.test(part)) {
            part = encodeURI(part);
        }
        return part;
    }).join('');
}

/**
 * URL Template (RFC 6570) Transform.
 */

function template (options) {

    var variables = [], url = expand(options.url, options.params, variables);

    variables.forEach(function (key) {
        delete options.params[key];
    });

    return url;
}

/**
 * Service for URL templating.
 */

function Url(url, params) {

    var self = this || {}, options$$1 = url, transform;

    if (isString(url)) {
        options$$1 = {url: url, params: params};
    }

    options$$1 = merge({}, Url.options, self.$options, options$$1);

    Url.transforms.forEach(function (handler) {

        if (isString(handler)) {
            handler = Url.transform[handler];
        }

        if (isFunction(handler)) {
            transform = factory(handler, transform, self.$vm);
        }

    });

    return transform(options$$1);
}

/**
 * Url options.
 */

Url.options = {
    url: '',
    root: null,
    params: {}
};

/**
 * Url transforms.
 */

Url.transform = {template: template, query: query, root: root};
Url.transforms = ['template', 'query', 'root'];

/**
 * Encodes a Url parameter string.
 *
 * @param {Object} obj
 */

Url.params = function (obj) {

    var params = [], escape = encodeURIComponent;

    params.add = function (key, value) {

        if (isFunction(value)) {
            value = value();
        }

        if (value === null) {
            value = '';
        }

        this.push(escape(key) + '=' + escape(value));
    };

    serialize(params, obj);

    return params.join('&').replace(/%20/g, '+');
};

/**
 * Parse a URL and return its components.
 *
 * @param {String} url
 */

Url.parse = function (url) {

    var el = document.createElement('a');

    if (document.documentMode) {
        el.href = url;
        url = el.href;
    }

    el.href = url;

    return {
        href: el.href,
        protocol: el.protocol ? el.protocol.replace(/:$/, '') : '',
        port: el.port,
        host: el.host,
        hostname: el.hostname,
        pathname: el.pathname.charAt(0) === '/' ? el.pathname : '/' + el.pathname,
        search: el.search ? el.search.replace(/^\?/, '') : '',
        hash: el.hash ? el.hash.replace(/^#/, '') : ''
    };
};

function factory(handler, next, vm) {
    return function (options$$1) {
        return handler.call(vm, options$$1, next);
    };
}

function serialize(params, obj, scope) {

    var array = isArray(obj), plain = isPlainObject(obj), hash;

    each(obj, function (value, key) {

        hash = isObject(value) || isArray(value);

        if (scope) {
            key = scope + '[' + (plain || hash ? key : '') + ']';
        }

        if (!scope && array) {
            params.add(value.name, value.value);
        } else if (hash) {
            serialize(params, value, key);
        } else {
            params.add(key, value);
        }
    });
}

/**
 * XDomain client (Internet Explorer).
 */

function xdrClient (request) {
    return new PromiseObj(function (resolve) {

        var xdr = new XDomainRequest(), handler = function (ref) {
                var type = ref.type;


                var status = 0;

                if (type === 'load') {
                    status = 200;
                } else if (type === 'error') {
                    status = 500;
                }

                resolve(request.respondWith(xdr.responseText, {status: status}));
            };

        request.abort = function () { return xdr.abort(); };

        xdr.open(request.method, request.getUrl());

        if (request.timeout) {
            xdr.timeout = request.timeout;
        }

        xdr.onload = handler;
        xdr.onabort = handler;
        xdr.onerror = handler;
        xdr.ontimeout = handler;
        xdr.onprogress = function () {};
        xdr.send(request.getBody());
    });
}

/**
 * CORS Interceptor.
 */

var SUPPORTS_CORS = inBrowser && 'withCredentials' in new XMLHttpRequest();

function cors (request) {

    if (inBrowser) {

        var orgUrl = Url.parse(location.href);
        var reqUrl = Url.parse(request.getUrl());

        if (reqUrl.protocol !== orgUrl.protocol || reqUrl.host !== orgUrl.host) {

            request.crossOrigin = true;
            request.emulateHTTP = false;

            if (!SUPPORTS_CORS) {
                request.client = xdrClient;
            }
        }
    }

}

/**
 * Form data Interceptor.
 */

function form (request) {

    if (isFormData(request.body)) {
        request.headers.delete('Content-Type');
    } else if (isObject(request.body) && request.emulateJSON) {
        request.body = Url.params(request.body);
        request.headers.set('Content-Type', 'application/x-www-form-urlencoded');
    }

}

/**
 * JSON Interceptor.
 */

function json (request) {

    var type = request.headers.get('Content-Type') || '';

    if (isObject(request.body) && type.indexOf('application/json') === 0) {
        request.body = JSON.stringify(request.body);
    }

    return function (response) {

        return response.bodyText ? when(response.text(), function (text) {

            var type = response.headers.get('Content-Type') || '';

            if (type.indexOf('application/json') === 0 || isJson(text)) {

                try {
                    response.body = JSON.parse(text);
                } catch (e) {
                    response.body = null;
                }

            } else {
                response.body = text;
            }

            return response;

        }) : response;

    };
}

function isJson(str) {

    var start = str.match(/^\s*(\[|\{)/);
    var end = {'[': /]\s*$/, '{': /}\s*$/};

    return start && end[start[1]].test(str);
}

/**
 * JSONP client (Browser).
 */

function jsonpClient (request) {
    return new PromiseObj(function (resolve) {

        var name = request.jsonp || 'callback', callback = request.jsonpCallback || '_jsonp' + Math.random().toString(36).substr(2), body = null, handler, script;

        handler = function (ref) {
            var type = ref.type;


            var status = 0;

            if (type === 'load' && body !== null) {
                status = 200;
            } else if (type === 'error') {
                status = 500;
            }

            if (status && window[callback]) {
                delete window[callback];
                document.body.removeChild(script);
            }

            resolve(request.respondWith(body, {status: status}));
        };

        window[callback] = function (result) {
            body = JSON.stringify(result);
        };

        request.abort = function () {
            handler({type: 'abort'});
        };

        request.params[name] = callback;

        if (request.timeout) {
            setTimeout(request.abort, request.timeout);
        }

        script = document.createElement('script');
        script.src = request.getUrl();
        script.type = 'text/javascript';
        script.async = true;
        script.onload = handler;
        script.onerror = handler;

        document.body.appendChild(script);
    });
}

/**
 * JSONP Interceptor.
 */

function jsonp (request) {

    if (request.method == 'JSONP') {
        request.client = jsonpClient;
    }

}

/**
 * Before Interceptor.
 */

function before (request) {

    if (isFunction(request.before)) {
        request.before.call(this, request);
    }

}

/**
 * HTTP method override Interceptor.
 */

function method (request) {

    if (request.emulateHTTP && /^(PUT|PATCH|DELETE)$/i.test(request.method)) {
        request.headers.set('X-HTTP-Method-Override', request.method);
        request.method = 'POST';
    }

}

/**
 * Header Interceptor.
 */

function header (request) {

    var headers = assign({}, Http.headers.common,
        !request.crossOrigin ? Http.headers.custom : {},
        Http.headers[toLower(request.method)]
    );

    each(headers, function (value, name) {
        if (!request.headers.has(name)) {
            request.headers.set(name, value);
        }
    });

}

/**
 * XMLHttp client (Browser).
 */

function xhrClient (request) {
    return new PromiseObj(function (resolve) {

        var xhr = new XMLHttpRequest(), handler = function (event) {

                var response = request.respondWith(
                'response' in xhr ? xhr.response : xhr.responseText, {
                    status: xhr.status === 1223 ? 204 : xhr.status, // IE9 status bug
                    statusText: xhr.status === 1223 ? 'No Content' : trim(xhr.statusText)
                });

                each(trim(xhr.getAllResponseHeaders()).split('\n'), function (row) {
                    response.headers.append(row.slice(0, row.indexOf(':')), row.slice(row.indexOf(':') + 1));
                });

                resolve(response);
            };

        request.abort = function () { return xhr.abort(); };

        xhr.open(request.method, request.getUrl(), true);

        if (request.timeout) {
            xhr.timeout = request.timeout;
        }

        if (request.responseType && 'responseType' in xhr) {
            xhr.responseType = request.responseType;
        }

        if (request.withCredentials || request.credentials) {
            xhr.withCredentials = true;
        }

        if (!request.crossOrigin) {
            request.headers.set('X-Requested-With', 'XMLHttpRequest');
        }

        // deprecated use downloadProgress
        if (isFunction(request.progress) && request.method === 'GET') {
            xhr.addEventListener('progress', request.progress);
        }

        if (isFunction(request.downloadProgress)) {
            xhr.addEventListener('progress', request.downloadProgress);
        }

        // deprecated use uploadProgress
        if (isFunction(request.progress) && /^(POST|PUT)$/i.test(request.method)) {
            xhr.upload.addEventListener('progress', request.progress);
        }

        if (isFunction(request.uploadProgress) && xhr.upload) {
            xhr.upload.addEventListener('progress', request.uploadProgress);
        }

        request.headers.forEach(function (value, name) {
            xhr.setRequestHeader(name, value);
        });

        xhr.onload = handler;
        xhr.onabort = handler;
        xhr.onerror = handler;
        xhr.ontimeout = handler;
        xhr.send(request.getBody());
    });
}

/**
 * Http client (Node).
 */

function nodeClient (request) {

    var client = __webpack_require__(531);

    return new PromiseObj(function (resolve) {

        var url = request.getUrl();
        var body = request.getBody();
        var method = request.method;
        var headers = {}, handler;

        request.headers.forEach(function (value, name) {
            headers[name] = value;
        });

        client(url, {body: body, method: method, headers: headers}).then(handler = function (resp) {

            var response = request.respondWith(resp.body, {
                status: resp.statusCode,
                statusText: trim(resp.statusMessage)
            });

            each(resp.headers, function (value, name) {
                response.headers.set(name, value);
            });

            resolve(response);

        }, function (error$$1) { return handler(error$$1.response); });
    });
}

/**
 * Base client.
 */

function Client (context) {

    var reqHandlers = [sendRequest], resHandlers = [];

    if (!isObject(context)) {
        context = null;
    }

    function Client(request) {
        while (reqHandlers.length) {

            var handler = reqHandlers.pop();

            if (isFunction(handler)) {

                var response = (void 0), next = (void 0);

                response = handler.call(context, request, function (val) { return next = val; }) || next;

                if (isObject(response)) {
                    return new PromiseObj(function (resolve, reject) {

                        resHandlers.forEach(function (handler) {
                            response = when(response, function (response) {
                                return handler.call(context, response) || response;
                            }, reject);
                        });

                        when(response, resolve, reject);

                    }, context);
                }

                if (isFunction(response)) {
                    resHandlers.unshift(response);
                }

            } else {
                warn(("Invalid interceptor of type " + (typeof handler) + ", must be a function"));
            }
        }
    }

    Client.use = function (handler) {
        reqHandlers.push(handler);
    };

    return Client;
}

function sendRequest(request) {

    var client = request.client || (inBrowser ? xhrClient : nodeClient);

    return client(request);
}

/**
 * HTTP Headers.
 */

var Headers = function Headers(headers) {
    var this$1 = this;


    this.map = {};

    each(headers, function (value, name) { return this$1.append(name, value); });
};

Headers.prototype.has = function has (name) {
    return getName(this.map, name) !== null;
};

Headers.prototype.get = function get (name) {

    var list = this.map[getName(this.map, name)];

    return list ? list.join() : null;
};

Headers.prototype.getAll = function getAll (name) {
    return this.map[getName(this.map, name)] || [];
};

Headers.prototype.set = function set (name, value) {
    this.map[normalizeName(getName(this.map, name) || name)] = [trim(value)];
};

Headers.prototype.append = function append (name, value) {

    var list = this.map[getName(this.map, name)];

    if (list) {
        list.push(trim(value));
    } else {
        this.set(name, value);
    }
};

Headers.prototype.delete = function delete$1 (name) {
    delete this.map[getName(this.map, name)];
};

Headers.prototype.deleteAll = function deleteAll () {
    this.map = {};
};

Headers.prototype.forEach = function forEach (callback, thisArg) {
        var this$1 = this;

    each(this.map, function (list, name) {
        each(list, function (value) { return callback.call(thisArg, value, name, this$1); });
    });
};

function getName(map, name) {
    return Object.keys(map).reduce(function (prev, curr) {
        return toLower(name) === toLower(curr) ? curr : prev;
    }, null);
}

function normalizeName(name) {

    if (/[^a-z0-9\-#$%&'*+.^_`|~]/i.test(name)) {
        throw new TypeError('Invalid character in header field name');
    }

    return trim(name);
}

/**
 * HTTP Response.
 */

var Response = function Response(body, ref) {
    var url = ref.url;
    var headers = ref.headers;
    var status = ref.status;
    var statusText = ref.statusText;


    this.url = url;
    this.ok = status >= 200 && status < 300;
    this.status = status || 0;
    this.statusText = statusText || '';
    this.headers = new Headers(headers);
    this.body = body;

    if (isString(body)) {

        this.bodyText = body;

    } else if (isBlob(body)) {

        this.bodyBlob = body;

        if (isBlobText(body)) {
            this.bodyText = blobText(body);
        }
    }
};

Response.prototype.blob = function blob () {
    return when(this.bodyBlob);
};

Response.prototype.text = function text () {
    return when(this.bodyText);
};

Response.prototype.json = function json () {
    return when(this.text(), function (text) { return JSON.parse(text); });
};

Object.defineProperty(Response.prototype, 'data', {

    get: function get() {
        return this.body;
    },

    set: function set(body) {
        this.body = body;
    }

});

function blobText(body) {
    return new PromiseObj(function (resolve) {

        var reader = new FileReader();

        reader.readAsText(body);
        reader.onload = function () {
            resolve(reader.result);
        };

    });
}

function isBlobText(body) {
    return body.type.indexOf('text') === 0 || body.type.indexOf('json') !== -1;
}

/**
 * HTTP Request.
 */

var Request = function Request(options$$1) {

    this.body = null;
    this.params = {};

    assign(this, options$$1, {
        method: toUpper(options$$1.method || 'GET')
    });

    if (!(this.headers instanceof Headers)) {
        this.headers = new Headers(this.headers);
    }
};

Request.prototype.getUrl = function getUrl () {
    return Url(this);
};

Request.prototype.getBody = function getBody () {
    return this.body;
};

Request.prototype.respondWith = function respondWith (body, options$$1) {
    return new Response(body, assign(options$$1 || {}, {url: this.getUrl()}));
};

/**
 * Service for sending network requests.
 */

var COMMON_HEADERS = {'Accept': 'application/json, text/plain, */*'};
var JSON_CONTENT_TYPE = {'Content-Type': 'application/json;charset=utf-8'};

function Http(options$$1) {

    var self = this || {}, client = Client(self.$vm);

    defaults(options$$1 || {}, self.$options, Http.options);

    Http.interceptors.forEach(function (handler) {

        if (isString(handler)) {
            handler = Http.interceptor[handler];
        }

        if (isFunction(handler)) {
            client.use(handler);
        }

    });

    return client(new Request(options$$1)).then(function (response) {

        return response.ok ? response : PromiseObj.reject(response);

    }, function (response) {

        if (response instanceof Error) {
            error(response);
        }

        return PromiseObj.reject(response);
    });
}

Http.options = {};

Http.headers = {
    put: JSON_CONTENT_TYPE,
    post: JSON_CONTENT_TYPE,
    patch: JSON_CONTENT_TYPE,
    delete: JSON_CONTENT_TYPE,
    common: COMMON_HEADERS,
    custom: {}
};

Http.interceptor = {before: before, method: method, jsonp: jsonp, json: json, form: form, header: header, cors: cors};
Http.interceptors = ['before', 'method', 'jsonp', 'json', 'form', 'header', 'cors'];

['get', 'delete', 'head', 'jsonp'].forEach(function (method$$1) {

    Http[method$$1] = function (url, options$$1) {
        return this(assign(options$$1 || {}, {url: url, method: method$$1}));
    };

});

['post', 'put', 'patch'].forEach(function (method$$1) {

    Http[method$$1] = function (url, body, options$$1) {
        return this(assign(options$$1 || {}, {url: url, method: method$$1, body: body}));
    };

});

/**
 * Service for interacting with RESTful services.
 */

function Resource(url, params, actions, options$$1) {

    var self = this || {}, resource = {};

    actions = assign({},
        Resource.actions,
        actions
    );

    each(actions, function (action, name) {

        action = merge({url: url, params: assign({}, params)}, options$$1, action);

        resource[name] = function () {
            return (self.$http || Http)(opts(action, arguments));
        };
    });

    return resource;
}

function opts(action, args) {

    var options$$1 = assign({}, action), params = {}, body;

    switch (args.length) {

        case 2:

            params = args[0];
            body = args[1];

            break;

        case 1:

            if (/^(POST|PUT|PATCH)$/i.test(options$$1.method)) {
                body = args[0];
            } else {
                params = args[0];
            }

            break;

        case 0:

            break;

        default:

            throw 'Expected up to 2 arguments [params, body], got ' + args.length + ' arguments';
    }

    options$$1.body = body;
    options$$1.params = assign({}, options$$1.params, params);

    return options$$1;
}

Resource.actions = {

    get: {method: 'GET'},
    save: {method: 'POST'},
    query: {method: 'GET'},
    update: {method: 'PUT'},
    remove: {method: 'DELETE'},
    delete: {method: 'DELETE'}

};

/**
 * Install plugin.
 */

function plugin(Vue) {

    if (plugin.installed) {
        return;
    }

    Util(Vue);

    Vue.url = Url;
    Vue.http = Http;
    Vue.resource = Resource;
    Vue.Promise = PromiseObj;

    Object.defineProperties(Vue.prototype, {

        $url: {
            get: function get() {
                return options(Vue.url, this, this.$options.url);
            }
        },

        $http: {
            get: function get() {
                return options(Vue.http, this, this.$options.http);
            }
        },

        $resource: {
            get: function get() {
                return Vue.resource.bind(this);
            }
        },

        $promise: {
            get: function get() {
                var this$1 = this;

                return function (executor) { return new Vue.Promise(executor, this$1); };
            }
        }

    });
}

if (typeof window !== 'undefined' && window.Vue) {
    window.Vue.use(plugin);
}

/* harmony default export */ __webpack_exports__["a"] = (plugin);



/***/ }),
/* 531 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 532 */
/***/ (function(module, exports, __webpack_require__) {

!function(e,n){if(true)module.exports=n();else if("function"==typeof define&&define.amd)define([],n);else{var t=n();for(var r in t)("object"==typeof exports?exports:e)[r]=t[r]}}("undefined"!=typeof self?self:this,(function(){return function(e){var n={};function t(r){if(n[r])return n[r].exports;var o=n[r]={i:r,l:!1,exports:{}};return e[r].call(o.exports,o,o.exports,t),o.l=!0,o.exports}return t.m=e,t.c=n,t.d=function(e,n,r){t.o(e,n)||Object.defineProperty(e,n,{enumerable:!0,get:r})},t.r=function(e){"undefined"!=typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(e,Symbol.toStringTag,{value:"Module"}),Object.defineProperty(e,"__esModule",{value:!0})},t.t=function(e,n){if(1&n&&(e=t(e)),8&n)return e;if(4&n&&"object"==typeof e&&e&&e.__esModule)return e;var r=Object.create(null);if(t.r(r),Object.defineProperty(r,"default",{enumerable:!0,value:e}),2&n&&"string"!=typeof e)for(var o in e)t.d(r,o,function(n){return e[n]}.bind(null,o));return r},t.n=function(e){var n=e&&e.__esModule?function(){return e.default}:function(){return e};return t.d(n,"a",n),n},t.o=function(e,n){return Object.prototype.hasOwnProperty.call(e,n)},t.p="",t(t.s=0)}([function(e,n,t){"use strict";function r(e,n){var t=Object.keys(e);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(e);n&&(r=r.filter((function(n){return Object.getOwnPropertyDescriptor(e,n).enumerable}))),t.push.apply(t,r)}return t}function o(e){for(var n=1;n<arguments.length;n++){var t=null!=arguments[n]?arguments[n]:{};n%2?r(t,!0).forEach((function(n){i(e,n,t[n])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(t)):r(t).forEach((function(n){Object.defineProperty(e,n,Object.getOwnPropertyDescriptor(t,n))}))}return e}function i(e,n,t){return n in e?Object.defineProperty(e,n,{value:t,enumerable:!0,configurable:!0,writable:!0}):e[n]=t,e}t.r(n);var c={$vue:null,id:null,router:null,fields:{},customIdFields:{},ignoreRoutes:[],linkers:[],commands:{},disabled:!1,customResourceURL:null,set:[],require:[],ecommerce:{enabled:!1,options:null,enhanced:!1},autoTracking:{screenview:!1,shouldRouterUpdate:null,skipSamePath:!1,exception:!1,exceptionLogs:!0,page:!0,transformQueryString:!0,pageviewOnLoad:!0,pageviewTemplate:null,untracked:!0,prependBase:!0},debug:{enabled:!1,trace:!1,sendHitTask:!0},batch:{enabled:!1,delay:500,amount:2},checkDuplicatedScript:!1,disableScriptLoader:!1,beforeFirstHit:s,ready:s,untracked:[]},a=o({},c);function u(e){!function e(n,t){return Object.keys(t).forEach((function(r){var o=n[r]&&Object.prototype.toString.call(n[r]);"[object Object]"!==o&&"[object Array]"!==o?n[r]=t[r]:e(n[r],t[r])})),n}(a,e)}function f(){return a.id?[].concat(a.id):[]}var l=a;function s(){}var p=function(e){console.warn("[vue-analytics] ".concat(e))};function d(e,n){return new Promise((function(t,r){var o=document.head||document.getElementsByTagName("head")[0],i=document.createElement("script");if(i.async=!0,i.src=e,i.charset="utf-8",n){var c=document.createElement("link");c.href=n,c.rel="preconnect",o.appendChild(c)}o.appendChild(i),i.onload=t,i.onerror=r}))}function y(e){return e.name||e.replace(/-/gi,"")}function b(e,n){if(f().length>1){var t=y(n);return"".concat(t,".").concat(e)}return e}var m,v=function(e){if(e.then)return e;if("function"==typeof e){var n=e();return n.then?n:Promise.resolve(n)}return Promise.resolve(e)};function g(e){return function(e){if(Array.isArray(e)){for(var n=0,t=new Array(e.length);n<e.length;n++)t[n]=e[n];return t}}(e)||function(e){if(Symbol.iterator in Object(e)||"[object Arguments]"===Object.prototype.toString.call(e))return Array.from(e)}(e)||function(){throw new TypeError("Invalid attempt to spread non-iterable instance")}()}var h=[];function w(e){for(var n=arguments.length,t=new Array(n>1?n-1:0),r=1;r<n;r++)t[r-1]=arguments[r];"undefined"!=typeof window&&f().forEach((function(n){var r,o={m:b(e,n),a:t};window.ga?l.batch.enabled?(h.push(o),m||(m=setInterval((function(){h.length?h.splice(0,l.batch.amount).forEach((function(e){var n;(n=window).ga.apply(n,[e.m].concat(g(e.a)))})):(clearInterval(m),m=null)}),l.batch.delay))):(r=window).ga.apply(r,[b(e,n)].concat(t)):l.untracked.push(o)}))}function O(e){return(O="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e})(e)}function j(){for(var e=arguments.length,n=new Array(e),t=0;t<e;t++)n[t]=arguments[t];"object"!==O(n[0])||n[0].constructor!==Object?w("set",n[0],n[1]):w("set",n[0])}function P(e,n){var t=Object.keys(e);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(e);n&&(r=r.filter((function(n){return Object.getOwnPropertyDescriptor(e,n).enumerable}))),t.push.apply(t,r)}return t}function S(e,n,t){return n in e?Object.defineProperty(e,n,{value:t,enumerable:!0,configurable:!0,writable:!0}):e[n]=t,e}function k(){if(window.ga||!l.debug.enabled){if(window.ga){var e=f();l.debug.enabled&&(window.ga_debug={trace:l.debug.trace}),e.forEach((function(n){var t=y(n),r=l.customIdFields[n]||{},o=e.length>1?function(e){for(var n=1;n<arguments.length;n++){var t=null!=arguments[n]?arguments[n]:{};n%2?P(t,!0).forEach((function(n){S(e,n,t[n])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(t)):P(t).forEach((function(n){Object.defineProperty(e,n,Object.getOwnPropertyDescriptor(t,n))}))}return e}({},l.fields,{},r,{name:t}):l.fields;window.ga("create",n.id||n,"auto",o)})),l.beforeFirstHit();var n=l.ecommerce;if(n.enabled){var t=n.enhanced?"ec":"ecommerce";n.options?w("require",t,n.options):w("require",t)}l.linkers.length>0&&(w("require","linker"),w("linker:autoLink",l.linkers)),l.debug.sendHitTask||j("sendHitTask",null)}}else p("Google Analytics has probably been blocked.")}var E=function(){2!=arguments.length?w("require",arguments.length<=0?void 0:arguments[0]):w("require",arguments.length<=0?void 0:arguments[0],arguments.length<=1?void 0:arguments[1])};function A(e){return(A="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e})(e)}var x=function(){var e;l.set.forEach((function(e){var n=e.field,t=e.value;if(void 0===n||void 0===t)throw new Error('[vue-analytics] Wrong configuration in the plugin options.\nThe "set" array requires each item to have a "field" and a "value" property.');j(n,t)})),e=["ec","ecommerce"],l.require.forEach((function(n){if(-1!==e.indexOf(n)||-1!==e.indexOf(n.name))throw new Error("[vue-analytics] The ecommerce features are built-in in the plugin. \nFollow the ecommerce instructions available in the documentation.");if("string"!=typeof n&&"object"!==A(n))throw new Error('[vue-analytics] Wrong configuration in the plugin options. \nThe "require" array requires each item to be a string or to have a "name" and an "options" property.');var t=n.name||n;n.options?E(t,n.options):E(t)}))};function T(){for(var e=arguments.length,n=new Array(e),t=0;t<e;t++)n[t]=arguments[t];var r=n[0];if(1===n.length&&"string"==typeof r)return w("send","screenview",{screenName:r});w.apply(void 0,["send","screenview"].concat(n))}function D(e){return(D="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e})(e)}function q(){for(var e=arguments.length,n=new Array(e),t=0;t<e;t++)n[t]=arguments[t];var r;n.length&&!n[0]||(n.length&&n[0].currentRoute&&(r=n[0].currentRoute),n.length&&function(e){return e.query&&e.params}(n[0])&&(r=n[0]),r?R(r):(j("page","object"===D(n[0])?n[0].page:n[0]),w.apply(void 0,["send","pageview"].concat(n))))}function R(e){if(![(n=e).name,n.path].filter(Boolean).find((function(e){return-1!==l.ignoreRoutes.indexOf(e)}))){var n,t=l.autoTracking,r=e.meta.analytics,o=(void 0===r?{}:r).pageviewTemplate||t.pageviewTemplate;if(t.screenview&&!e.name)throw new Error("[vue-analytics] Route name is mandatory when using screenview.");if(t.screenview)T(e.name);else if(o)q(o(e));else{var i=l.router,c=l.autoTracking,a=c.transformQueryString,u=c.prependBase,f=function(e){var n=Object.keys(e).reduce((function(n,t,r,o){var i=r===o.length-1,c=e[t];return null==c?n:n+="".concat(t,"=").concat(c).concat(i?"":"&")}),"");return""!==n?"?".concat(n):""}(e.query),s=i&&i.options.base,p=u&&s,d=e.path+(a?f:"");q(d=p?function(e,n){var t=n.split("/"),r=e.split("/");return""===t[0]&&"/"===e[e.length-1]&&t.shift(),r.join("/")+t.join("/")}(s,d):d)}}}function I(e){return function(e){if(Array.isArray(e)){for(var n=0,t=new Array(e.length);n<e.length;n++)t[n]=e[n];return t}}(e)||function(e){if(Symbol.iterator in Object(e)||"[object Arguments]"===Object.prototype.toString.call(e))return Array.from(e)}(e)||function(){throw new TypeError("Invalid attempt to spread non-iterable instance")}()}var L=function(){var e=!(arguments.length>0&&void 0!==arguments[0])||arguments[0];"undefined"!=typeof window&&f().forEach((function(n){window["ga-disable-".concat(n)]=e}))},_=function(){if("undefined"!=typeof document&&"undefined"!=typeof window){if(l.id){var e,n,t=[v(l.id),v(l.disabled)];if(e=l.checkDuplicatedScript,n=l.disableScriptLoader,[Boolean(window&&window.ga),e&&!(Array.prototype.slice.call(document.getElementsByTagName("script")).filter((function(e){return-1!==e.src.indexOf("analytics")||-1!==e.src.indexOf("gtag")})).length>0),!n].some(Boolean)){var r="https://www.google-analytics.com",o=l.debug.enabled?"analytics_debug":"analytics",i=l.customResourceURL?d(l.customResourceURL):d("".concat(r,"/").concat(o,".js"),r);t.push(i.catch((function(){p("An error occured! Please check your connection or disable your AD blocker")})))}return Promise.all(t).then((function(e){var n,t,r;u({id:e[0],disabled:e[1]}),L(l.disabled),k(),x(),l.untracked.forEach((function(e){w.apply(void 0,[e.m].concat(I(e.a)))})),n=l.router,t=l.autoTracking,r=l.$vue,t.page&&n&&n.onReady((function(){t.pageviewOnLoad&&n.history.ready&&R(n.currentRoute),n.afterEach((function(e,o){var i=t.skipSamePath,c=t.shouldRouterUpdate;i&&e.path===o.path||("function"!=typeof c||c(e,o))&&r.nextTick().then((function(){R(n.currentRoute)}))}))})),l.ready()})).catch((function(e){l.debug.enabled&&p(e.message)}))}p('Missing the "id" parameter. Add at least one tracking domain ID')}};var B=function(e){var n=arguments.length>1&&void 0!==arguments[1]&&arguments[1];w("send","exception",{exDescription:e,exFatal:n})},H=function(e){if(l.autoTracking.exception){window.addEventListener("error",(function(e){B(e.message)}));var n=e.config.errorHandler;e.config.errorHandler=function(e,t,r){B(e.message),l.autoTracking.exceptionLogs&&console.error(e),"function"==typeof n&&n.call(void 0,e,t,r)}}},F=B;function M(e,n){var t=Object.keys(e);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(e);n&&(r=r.filter((function(n){return Object.getOwnPropertyDescriptor(e,n).enumerable}))),t.push.apply(t,r)}return t}function U(e,n,t){return n in e?Object.defineProperty(e,n,{value:t,enumerable:!0,configurable:!0,writable:!0}):e[n]=t,e}var $=function(e){return"".concat(l.ecommerce.enhanced?"ec":"ecommerce",":").concat(e)},C=["addItem","addTransaction","addProduct","addImpression","setAction","addPromo","send"].reduce((function(e,n){return function(e){for(var n=1;n<arguments.length;n++){var t=null!=arguments[n]?arguments[n]:{};n%2?M(t,!0).forEach((function(n){U(e,n,t[n])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(t)):M(t).forEach((function(n){Object.defineProperty(e,n,Object.getOwnPropertyDescriptor(t,n))}))}return e}({},e,U({},n,(function(){for(var e=arguments.length,t=new Array(e),r=0;r<e;r++)t[r]=arguments[r];w.apply(void 0,[$(n)].concat(t))})))}),{}),N={event:function(){for(var e=arguments.length,n=new Array(e),t=0;t<e;t++)n[t]=arguments[t];w.apply(void 0,["send","event"].concat(n))},exception:F,page:q,query:w,require:E,set:j,social:function(){for(var e=arguments.length,n=new Array(e),t=0;t<e;t++)n[t]=arguments[t];w.apply(void 0,["send","social"].concat(n))},time:function(){for(var e=arguments.length,n=new Array(e),t=0;t<e;t++)n[t]=arguments[t];w.apply(void 0,["send","timing"].concat(n))},screenview:T,ecommerce:C,disable:function(){return L(!0)},enable:function(){return L(!1)},commands:l.commands},Q={inserted:function(e,n,t){var r=Object.keys(n.modifiers);0===r.length&&r.push("click"),r.forEach((function(r){e.addEventListener(r,(function(){var e="string"==typeof n.value?l.commands[n.value]:n.value;if(!e)throw new Error("[vue-analytics] The value passed to v-ga is not defined in the commands list.");e.apply(t.context)}))}))}};function W(e){return function(e){if(Array.isArray(e)){for(var n=0,t=new Array(e.length);n<e.length;n++)t[n]=e[n];return t}}(e)||function(e){if(Symbol.iterator in Object(e)||"[object Arguments]"===Object.prototype.toString.call(e))return Array.from(e)}(e)||function(){throw new TypeError("Invalid attempt to spread non-iterable instance")}()}function G(e,n){return function(e){if(Array.isArray(e))return e}(e)||function(e,n){if(!(Symbol.iterator in Object(e)||"[object Arguments]"===Object.prototype.toString.call(e)))return;var t=[],r=!0,o=!1,i=void 0;try{for(var c,a=e[Symbol.iterator]();!(r=(c=a.next()).done)&&(t.push(c.value),!n||t.length!==n);r=!0);}catch(e){o=!0,i=e}finally{try{r||null==a.return||a.return()}finally{if(o)throw i}}return t}(e,n)||function(){throw new TypeError("Invalid attempt to destructure non-iterable instance")}()}function z(e,n){var t=Object.keys(e);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(e);n&&(r=r.filter((function(n){return Object.getOwnPropertyDescriptor(e,n).enumerable}))),t.push.apply(t,r)}return t}function J(e,n,t){return n in e?Object.defineProperty(e,n,{value:t,enumerable:!0,configurable:!0,writable:!0}):e[n]=t,e}function K(e){u(function(e){for(var n=1;n<arguments.length;n++){var t=null!=arguments[n]?arguments[n]:{};n%2?z(t,!0).forEach((function(n){J(e,n,t[n])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(t)):z(t).forEach((function(n){Object.defineProperty(e,n,Object.getOwnPropertyDescriptor(t,n))}))}return e}({},arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},{$vue:e})),e.directive("ga",Q),e.prototype.$ga=e.$ga=N,H(e),_()}t.d(n,"default",(function(){return K})),t.d(n,"analyticsMiddleware",(function(){return V})),t.d(n,"onAnalyticsReady",(function(){return X})),t.d(n,"event",(function(){return Y})),t.d(n,"ecommerce",(function(){return Z})),t.d(n,"set",(function(){return ee})),t.d(n,"page",(function(){return ne})),t.d(n,"query",(function(){return te})),t.d(n,"screenview",(function(){return re})),t.d(n,"time",(function(){return oe})),t.d(n,"require",(function(){return ie})),t.d(n,"exception",(function(){return ce})),t.d(n,"social",(function(){return ae}));var V=function(e){e.subscribe((function(e){var n=e.payload;if(n&&n.meta&&n.meta.analytics){var t=n.meta.analytics;if(!Array.isArray(t))throw new Error('The "analytics" property needs to be an array');t.forEach((function(e){var n,t,r=e.shift(),o=e;if(r.includes(":")){var i=G(r.split(":"),2);r=i[0],n=i[1]}if(!(r in N))throw new Error('[vue-analytics:vuex] The type "'.concat(r,"\" doesn't exist."));if(n&&!(n in N[r]))throw new Error('[vue-analytics:vuex] The type "'.concat(r,'" has not method "').concat(n,'".'));if("ecommerce"===r&&!n)throw new Error('[vue-analytics:vuex] The type "'.concat(r,'" needs to call a method. Check documentation.'));n?(t=N[r])[n].apply(t,W(o)):N[r].apply(N,W(o))}))}}))},X=function(){return new Promise((function(e,n){var t=setInterval((function(){"undefined"!=typeof window&&window.ga&&(e(),clearInterval(t))}),10)}))},Y=N.event,Z=N.ecommerce,ee=N.set,ne=N.page,te=N.query,re=N.screenview,oe=N.time,ie=N.require,ce=N.exception,ae=N.social}])}));

/***/ })
],[16]);


// WEBPACK FOOTER //
// js/app.2d48f58bc9483dae2a9e.js